(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[315],{

/***/ 62678:
/***/ (function(module) {

module.exports = {
  familyName: 'Barlow',
  capHeight: 700,
  ascent: 1000,
  descent: -200,
  lineGap: 0,
  unitsPerEm: 1000
};


/***/ }),

/***/ 23166:
/***/ (function(module) {

module.exports = {
  familyName: 'Cabin',
  capHeight: 1400,
  ascent: 1930,
  descent: -500,
  lineGap: 0,
  unitsPerEm: 2000
};


/***/ }),

/***/ 55167:
/***/ (function(module) {

module.exports = {
  familyName: 'Open Sans',
  capHeight: 1462,
  ascent: 2189,
  descent: -600,
  lineGap: 0,
  unitsPerEm: 2048
};


/***/ }),

/***/ 71400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ Alert; },
  "Z": function() { return /* binding */ Alert; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/typography/dist/typography.esm.js
var typography_esm = __webpack_require__(56158);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/color/dist/color.esm.js
var color_esm = __webpack_require__(62792);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spacing/dist/spacing.esm.js
var spacing_esm = __webpack_require__(84209);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/theme/dist/theme.esm.js + 16 modules
var theme_esm = __webpack_require__(97477);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/utils/dist/utils.esm.js
var utils_esm = __webpack_require__(27233);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/dist/Icon-e9280b89.esm.js
var Icon_e9280b89_esm = __webpack_require__(95087);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Info/dist/icon.esm.js






function SvgInfo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/CheckCircleOutline/dist/icon.esm.js






function SvgCheckCircleOutline(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
      })
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/ErrorOutline/dist/icon.esm.js






function SvgErrorOutline(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/alert/dist/alert.esm.js












function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-9k4a9t-0"
})(["", ";display:flex;align-items:flex-start;border-radius:", ";", " ", " ", ""], utils_esm/* normalise */.W$, (0,theme_esm/* select */.Ys)('borderRadius'), (0,spacing_esm.p)('sm'), _ref => {
  var {
    withHeading
  } = _ref;
  if (withHeading) {
    return (0,styled_components_browser_esm/* css */.iv)(["flex-direction:column;"]);
  }
  return (0,styled_components_browser_esm/* css */.iv)(["flex-direction:row;"]);
}, _ref2 => {
  var {
    variant
  } = _ref2;
  switch (variant) {
    case 'error':
      return (0,styled_components_browser_esm/* css */.iv)(["border:1px solid ", ";", " ", ";"], (0,color_esm/* color */.$)('error.500'), (0,color_esm.fg)('error.500'), (0,color_esm.bg)('error.25'));
    case 'info':
      return (0,styled_components_browser_esm/* css */.iv)(["border:1px solid ", ";", " ", ";"], (0,color_esm/* color */.$)('info.500'), (0,color_esm.fg)('info.500'), (0,color_esm.bg)('info.25'));
    case 'success':
      return (0,styled_components_browser_esm/* css */.iv)(["border:1px solid ", ";", " ", ";"], (0,color_esm/* color */.$)('success.500'), (0,color_esm.fg)('success.500'), (0,color_esm.bg)('success.25'));
    case 'warn':
      return (0,styled_components_browser_esm/* css */.iv)(["border:1px solid ", ";", " ", ";"], (0,color_esm/* color */.$)('warn.500'), (0,color_esm.fg)('warn.500'), (0,color_esm.bg)('warn.25'));
    default:
      return undefined;
  }
});
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__HeaderWrapper",
  componentId: "lui__sc-9k4a9t-1"
})(["display:flex;flex-direction:row;align-items:center;"]);
var IconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-9k4a9t-2"
})(["line-height:0;"]);
var HeadingWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "indexstyle__HeadingWrapper",
  componentId: "lui__sc-9k4a9t-3"
})(["", ";"], (0,spacing_esm.ml)('xs'));
var TextContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "indexstyle__TextContentWrapper",
  componentId: "lui__sc-9k4a9t-4"
})(["", ";"], _ref3 => {
  var {
    withHeading
  } = _ref3;
  return withHeading ? (0,spacing_esm.mt)('xxxs') : (0,spacing_esm.ml)('xs');
});
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__ContentWrapper",
  componentId: "lui__sc-9k4a9t-5"
})(["", ";", " ", " ", ";"], _ref4 => {
  var {
    withHeading
  } = _ref4;
  return withHeading ? (0,spacing_esm.mt)('xxxs') : (0,spacing_esm.ml)('xs');
}, (0,spacing_esm.my)('nil'), typography_esm/* body */.d1, spacing_esm/* margin */.e);

var _excluded = ["variant", "heading", "children"];
var Alert = _ref => {
  var {
      variant,
      heading,
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var alertIcon;
  var withHeading = !!heading;
  switch (variant) {
    case 'error':
      alertIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(SvgErrorOutline, {
        color: "error.500"
      });
      break;
    case 'info':
      alertIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(SvgInfo, {
        color: "info.500"
      });
      break;
    case 'success':
      alertIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(SvgCheckCircleOutline, {
        color: "success.500"
      });
      break;
    case 'warn':
      alertIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(SvgErrorOutline, {
        color: "warn.500"
      });
      break;
  }
  var alertBody = typeof children === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextContentWrapper, {
    withHeading: withHeading,
    size: "xs",
    children: children
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, {
    withHeading: withHeading,
    size: "xs",
    children: children
  });
  if (withHeading) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, _objectSpread2(_objectSpread2({
      variant: variant,
      withHeading: withHeading
    }, otherProps), {}, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
          children: alertIcon
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeadingWrapper, {
          size: "sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: heading
          })
        })]
      }), alertBody]
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, _objectSpread2(_objectSpread2({
    variant: variant,
    withHeading: withHeading
  }, otherProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
      children: alertIcon
    }), alertBody]
  }));
};




/***/ }),

/***/ 23783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gc": function() { return /* binding */ useBreakpoint; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "eg": function() { return /* binding */ gte; },
/* harmony export */   "vX": function() { return /* binding */ between; }
/* harmony export */ });
/* unused harmony exports Breakpoint, getBreakpoint, getTshirtBreakpoint, keys */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92891);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);




var DEBOUNCE_INTERVAL = 100;
var keys = Object.keys;
var Breakpoint;

(function (Breakpoint) {
  Breakpoint["mobile"] = "0";
  Breakpoint["tablet"] = "36rem";
  Breakpoint["desktop"] = "75rem";
  Breakpoint["xs"] = "0";
  Breakpoint["sm"] = "36rem";
  Breakpoint["md"] = "48rem";
  Breakpoint["lg"] = "62rem";
  Breakpoint["xl"] = "75rem";
})(Breakpoint || (Breakpoint = {}));

// FIXME: figure out what type this should be
function gte(breakpoint) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["@media (min-width:", "){", ";}"], Breakpoint[breakpoint], (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(strings, ...interpolations));
  };
}
function between(gte, lt) {
  return function (strings) {
    for (var _len2 = arguments.length, interpolations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    // TODO: lt needs to be lt - 1px
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["@media (min-width:", ") and (max-width:", "){", ";}"], Breakpoint[gte], Breakpoint[lt], (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(strings, ...interpolations));
  };
}

function throwErrorIfMixingBreakpoints(breakpoints) {
  if (breakpoints.includes('mobile') && breakpoints.includes('xs')) {
    throw new Error('Mobile and xs are synonyms for the same breakpoint, please use only one.');
  }

  if (breakpoints.includes('tablet') && breakpoints.includes('sm')) {
    throw new Error('Tablet and sm are synonyms for the same breakpoint, please use only one.');
  }

  if (breakpoints.includes('desktop') && breakpoints.includes('xl')) {
    throw new Error('Desktop and xl are synonyms for the same breakpoint, please use only one.');
  }
}

function map(values, mapValueToStyle) {
  if (typeof values !== 'object') {
    return mapValueToStyle(values);
  }

  var breakpoints = keys(values);
  throwErrorIfMixingBreakpoints(breakpoints); // sort the breakpoints(responsive-screens) in the order of Breakpoint values so that generated
  // css will always have the @media-queries in the order of mobile, tablet and desktop.

  breakpoints.sort((a, b) => parseFloat(Breakpoint[a]) - parseFloat(Breakpoint[b]));
  return breakpoints.reduce((accum, breakpoint) => {
    var template = gte(breakpoint);
    var value = values[breakpoint];
    var style = mapValueToStyle(value, breakpoint);
    return accum.concat(template([], style));
  }, [].concat(mapValueToStyle(undefined)));
}
var useBreakpoint = function useBreakpoint(callback, debounceInterval) {
  var useTshirt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof window === 'undefined') return;
    var getBreakpointFunction = useTshirt ? getTshirtBreakpoint : getBreakpoint;
    var handleResize = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.debounce)(() => callback(getBreakpointFunction()), debounceInterval || DEBOUNCE_INTERVAL);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
};
var getTshirtBreakpoint = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return 'xs';
  if (window.matchMedia("(min-width: ".concat(Breakpoint.xl, ")")).matches) return 'xl';else if (window.matchMedia("(min-width: ".concat(Breakpoint.lg, ")")).matches) return 'lg';else if (window.matchMedia("(min-width: ".concat(Breakpoint.md, ")")).matches) return 'md';else if (window.matchMedia("(min-width: ".concat(Breakpoint.sm, ")")).matches) return 'sm';
  return 'xs';
};
var getBreakpoint = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return 'mobile';
  if (window.matchMedia("(min-width: ".concat(Breakpoint.desktop, ")")).matches) return 'desktop';else if (window.matchMedia("(min-width: ".concat(Breakpoint.tablet, ")")).matches) return 'tablet';
  return 'mobile';
};




/***/ }),

/***/ 22294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hU": function() { return /* binding */ IconButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export ButtonGroup */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27233);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_depth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12987);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23783);
/* harmony import */ var _lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53075);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55354);
/* harmony import */ var _lendi_ui_spinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75910);












function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var commonStyleBySizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xs':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["border-radius:21px;padding:", " ", ";font-size:", ";letter-spacing:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.5), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.5625), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.625), _ref => {
        var {
          theme
        } = _ref;
        return theme.name === 'lendi' ? (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.0625) : 'normal';
      });
    case 'sm':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["height:", ";padding:0 ", ";font-size:", ";letter-spacing:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(2.5), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.75), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.75), _ref2 => {
        var {
          theme
        } = _ref2;
        return theme.name === 'lendi' ? (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.05) : 'normal';
      });
    case 'md':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["height:", ";padding:0 ", ";font-size:", ";letter-spacing:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(3), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.875), _ref3 => {
        var {
          theme
        } = _ref3;
        return theme.name === 'lendi' ? (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.0625) : 'normal';
      });
    case 'lg':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["height:", ";padding:0 ", ";font-size:", ";letter-spacing:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(4), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1.5), (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1), _ref4 => {
        var {
          theme
        } = _ref4;
        return theme.name === 'lendi' ? (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.075) : 'normal';
      });
    default:
      return undefined;
  }
});
var beforeBySizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xs':
    case 'sm':
      return "\n          margin-right: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.5), ";\n      ");
    case 'md':
    case 'lg':
      return "\n         margin-right: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1), ";\n      ");
    default:
      return undefined;
  }
});
var afterBySizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xs':
    case 'sm':
      return "\n          margin-left: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.5), ";\n      ");
    case 'md':
    case 'lg':
      return "\n         margin-left: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1), ";\n      ");
    default:
      return undefined;
  }
});
var commonStyle$1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";cursor:pointer;box-sizing:border-box;border:none;border-radius:", ";font-family:", ";font-weight:", ";line-height:1;text-align:center;transition:all 0.1s;text-transform:uppercase;", " ", " &:focus{outline:none;", ";}&:hover{", ";}&:active{transform:scale(0.98);}", ""], _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .normalise */ .W$, (0,_lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_4__/* .getRadius */ .H5)('button'), _ref5 => {
  var {
    theme
  } = _ref5;
  return theme.asset.font.body.family;
}, _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.asset.font.heading.weight;
}, _ref7 => {
  var {
    size
  } = _ref7;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";"], size && commonStyleBySizeMixin(size));
}, _ref8 => {
  var {
    isFullWidth = false
  } = _ref8;
  return isFullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["width:100%;"]);
}, (0,_lendi_ui_depth__WEBPACK_IMPORTED_MODULE_10__/* .depth */ .Y)(2), (0,_lendi_ui_depth__WEBPACK_IMPORTED_MODULE_10__/* .depth */ .Y)(4), _ref9 => {
  var {
    isDisabled,
    theme
  } = _ref9;
  return isDisabled ? (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";pointer-events:inherit;cursor:not-allowed;box-shadow:none;transform:scale(1);:hover,:active,:focus{pointer-events:inherit;cursor:not-allowed;box-shadow:none;transform:scale(1);}"], theme.name === 'lendi' && "opacity: 0.4;") : undefined;
});
var themeAble = colourPrefix => colourPrefix === 'primary' || colourPrefix === 'secondary';
var filledStyle = _ref10 => {
  var {
    colorPrefix
  } = _ref10;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";border-radius:", ";", " ", " &:focus{", "}&:hover{", ";box-shadow:inset 0 0 0 1px ", ";}&:active{", "}", ""], commonStyle$1, (0,_lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_4__/* .getRadius */ .H5)('button'), _ref11 => {
    var {
      theme
    } = _ref11;
    return themeAble(colorPrefix) ? "color: ".concat(theme.color.buttonForeground[colorPrefix].default, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)('shade.0');
  }, _ref12 => {
    var {
      theme
    } = _ref12;
    return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill[colorPrefix].default, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("".concat(colorPrefix, ".500"));
  }, _ref13 => {
    var {
      theme
    } = _ref13;
    return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill[colorPrefix].focus, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("".concat(colorPrefix, ".400"));
  }, _ref14 => {
    var {
      theme
    } = _ref14;
    return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill[colorPrefix].hover, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("".concat(colorPrefix, ".400"));
  }, _ref15 => {
    var {
      theme
    } = _ref15;
    return themeAble(colorPrefix) ? theme.color.buttonBorder[colorPrefix].disabled : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$)("".concat(colorPrefix, ".500"));
  }, _ref16 => {
    var {
      theme
    } = _ref16;
    return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill[colorPrefix].pressed, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("".concat(colorPrefix, ".600"));
  }, _ref17 => {
    var {
      isDisabled
    } = _ref17;
    return isDisabled ? (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";color:", ";box-shadow:inset 0 0 0 1px ", ";&:active,&:hover,&:focus{", "}"], _ref18 => {
      var {
        theme
      } = _ref18;
      return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill[colorPrefix].disabled, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("".concat(colorPrefix, ".500"));
    }, _ref19 => {
      var {
        theme
      } = _ref19;
      return theme.color.buttonForeground.primary.disabled;
    }, _ref20 => {
      var {
        theme
      } = _ref20;
      return theme.color.buttonBorder.primary.disabled;
    }, _ref21 => {
      var {
        theme
      } = _ref21;
      return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill[colorPrefix].disabled, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)("".concat(colorPrefix, ".500"));
    }) : undefined;
  });
};
var inversedFilledStyle = _ref22 => {
  var {
    colorPrefix
  } = _ref22;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";border-radius:", ";", ";", ";&:active{opacity:0.9;}"], commonStyle$1, (0,_lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_4__/* .getRadius */ .H5)('button'), _ref23 => {
    var {
      theme
    } = _ref23;
    return themeAble(colorPrefix) ? "color: ".concat(theme.color.buttonForeground.secondary.default, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)("".concat(colorPrefix, ".500"));
  }, _ref24 => {
    var {
      theme
    } = _ref24;
    return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill.secondary.default, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)('shade.0');
  });
};
var outlineStyle = _ref25 => {
  var {
    colorPrefix
  } = _ref25;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";border-radius:", ";", " ", ";border:1px solid ", ";&:active{opacity:0.9;}&:disabled{color:", ";border:1px solid ", ";}"], commonStyle$1, (0,_lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_4__/* .getRadius */ .H5)('button'), _ref26 => {
    var {
      theme
    } = _ref26;
    return themeAble(colorPrefix) ? "color: ".concat(theme.color.buttonForeground[colorPrefix].default, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)("".concat(colorPrefix, ".500"));
  }, _ref27 => {
    var {
      theme
    } = _ref27;
    return themeAble(colorPrefix) ? "background-color: ".concat(theme.color.buttonFill[colorPrefix].default, ";") : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.bg)('shade.0');
  }, _ref28 => {
    var {
      theme
    } = _ref28;
    return themeAble(colorPrefix) ? theme.color.buttonBorder[colorPrefix].default : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$)("".concat(colorPrefix, ".500"));
  }, _ref29 => {
    var {
      theme
    } = _ref29;
    return theme.color.buttonForeground.secondary.disabled;
  }, _ref30 => {
    var {
      theme
    } = _ref30;
    return themeAble(colorPrefix) ? theme.color.buttonBorder[colorPrefix].disabled : (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$)("".concat(colorPrefix, ".500"));
  });
};
var inversedOutlineStyle = () => {
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";border-radius:", ";", " background-color:transparent;border:1px solid ", ";&:active{opacity:0.9;}"], commonStyle$1, (0,_lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_4__/* .getRadius */ .H5)('button'), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__.fg)('shade.0'), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$)('shade.0'));
};
var buttonStyle = _ref31 => {
  var {
    variant,
    isInverse
  } = _ref31;
  switch (variant) {
    case 'primary':
      return !isInverse ? filledStyle({
        colorPrefix: 'primary'
      }) : inversedFilledStyle({
        colorPrefix: 'primary'
      });
    case 'secondary':
      return !isInverse ? outlineStyle({
        colorPrefix: 'secondary'
      }) : inversedOutlineStyle();
    case 'emphasis':
      return filledStyle({
        colorPrefix: 'tertiary'
      });
    case 'empty':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", " border-style:dashed;&:focus{border-width:1px;}"], !isInverse ? outlineStyle({
        colorPrefix: 'secondary'
      }) : inversedOutlineStyle());
  }
};
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "indexstyle__ButtonWrapper",
  componentId: "lui__sc-1m54lw8-0"
})(["", ";"], buttonStyle);
var LinkWrapper$1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(ButtonWrapper).attrs({
  as: 'a'
}).withConfig({
  displayName: "indexstyle__LinkWrapper",
  componentId: "lui__sc-1m54lw8-1"
})(["display:inline-block;text-decoration:none;"]);
var Layout = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "indexstyle__Layout",
  componentId: "lui__sc-1m54lw8-2"
})(["display:flex;height:100%;align-items:center;justify-content:space-between;"]);
var BeforeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "indexstyle__BeforeWrapper",
  componentId: "lui__sc-1m54lw8-3"
})(["", ";display:flex;"], _ref32 => {
  var {
    size
  } = _ref32;
  return beforeBySizeMixin(size);
});
var AfterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "indexstyle__AfterWrapper",
  componentId: "lui__sc-1m54lw8-4"
})(["", ";display:flex;"], _ref33 => {
  var {
    size
  } = _ref33;
  return afterBySizeMixin(size);
});

var _excluded$2 = ["href", "isDisabled", "type"];
class Button extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleLinkClick", event => {
      var {
        isDisabled,
        onClick
      } = this.props;
      if (isDisabled) {
        event.preventDefault();
      } else {
        if (onClick) {
          onClick(event);
        }
      }
    });
  }
  get commonProps() {
    var {
      variant,
      size = 'md',
      isInverse,
      isFullWidth,
      isDisabled,
      className,
      onClick
    } = this.props;
    return {
      variant,
      size,
      isInverse,
      isFullWidth,
      isDisabled,
      className,
      onClick
    };
  }
  get linkProps() {
    var {
      href
    } = this.props;
    return {
      href
    };
  }
  renderContent() {
    var {
      size = 'md',
      before,
      after,
      children
    } = this.props;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(Layout, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(BeforeWrapper, {
        size: size,
        children: before
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        children: children
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(AfterWrapper, {
        size: size,
        children: after
      })]
    });
  }
  render() {
    var _this$props = this.props,
      {
        href,
        isDisabled,
        type = 'button'
      } = _this$props,
      otherProps = _objectWithoutProperties(_this$props, _excluded$2);
    if (href) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(LinkWrapper$1, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, otherProps), this.commonProps), this.linkProps), {}, {
        onClick: this.handleLinkClick,
        children: this.renderContent()
      }));
    } else {
      var {
        ariaLabel = '',
        children
      } = this.props;
      var buttonLabel = ariaLabel;

      // infer the aria-label from children if possible
      if (!ariaLabel.length && typeof children === 'string') {
        buttonLabel = children;
      }
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ButtonWrapper, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        "aria-label": buttonLabel,
        disabled: isDisabled,
        type: type
      }, (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .getDataProps */ .Bl)(this.props)), this.commonProps), otherProps), {}, {
        children: this.renderContent()
      }));
    }
  }
}

var commonStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";cursor:pointer;border:none;border-radius:", ";text-align:center;transition:all 0.1s;background:inherit;:focus{background:none;}:hover{background:inherit;background:rgba(74,74,74,0.15);}:active{background:inherit;background:rgba(74,74,74,0.2);}", " ", ""], _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .normalise */ .W$, (0,_lendi_ui_Theme__WEBPACK_IMPORTED_MODULE_7__/* .select */ .Ys)('borderRadius'), _ref => {
  var {
    size
  } = _ref;
  switch (size) {
    case 'xs':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["padding:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.375));
    case 'sm':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["padding:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.625));
    case 'md':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["padding:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.75));
    case 'lg':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["padding:", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1));
    default:
      return undefined;
  }
}, _ref2 => {
  var {
    disabled
  } = _ref2;
  return disabled ? (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["border-color:", ";pointer-events:inherit;cursor:not-allowed;opacity:0.4;transform:scale(1);:hover,:active,:focus{background:inherit;pointer-events:inherit;cursor:not-allowed;opacity:0.4;box-shadow:none;transform:scale(1);}"], (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$)('error.500')) : undefined;
});
var IconButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "indexstyle__IconButtonWrapper",
  componentId: "lui__sc-xvll15-0"
})(["", ";background:inherit;"], commonStyle);
var LinkWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(IconButtonWrapper.withComponent('a')).withConfig({
  displayName: "indexstyle__LinkWrapper",
  componentId: "lui__sc-xvll15-1"
})(["", ";text-decoration:none;"], commonStyle);

var spacingTopBySizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xs':
    case 'sm':
    case 'md':
    case 'lg':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["margin-top:calc(-1 * ", ");"], _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__/* .Spacing */ .K[spacingBySize[val]]);
    default:
      return undefined;
  }
});
var spacingRightBySizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xs':
    case 'sm':
    case 'md':
    case 'lg':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["margin-right:calc(-1 * ", ");"], _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_6__/* .Spacing */ .K[spacingBySize[val]]);
    default:
      return undefined;
  }
});
var wrapperBySizeMixin = (size, isFullWidth) => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xs':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["margin-top:", ";", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.5), !isFullWidth && "margin-right: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.5)));
    case 'sm':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["margin-top:", ";", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.75), !isFullWidth && "margin-right: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.75)));
    case 'md':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["margin-top:", ";", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1), !isFullWidth && "margin-right: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1)));
    case 'lg':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["margin-top:", ";", ";"], (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1.5), !isFullWidth && "margin-right: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1.5)));
    default:
      return undefined;
  }
});
var spacingBySize = {
  lg: 'md',
  md: 'sm',
  sm: 'xs',
  xs: 'xxs'
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-obdqx3-0"
})(["", ";display:inline-flex;flex-wrap:wrap;", ";", " ", ",", "{", ";}"], _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .normalise */ .W$, _ref => {
  var {
    size
  } = _ref;
  return spacingTopBySizeMixin(size);
}, _ref2 => {
  var {
    size,
    isFullWidth
  } = _ref2;
  return isFullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["width:100%;", ";"], spacingRightBySizeMixin(size));
}, ButtonWrapper, IconButtonWrapper, _ref3 => {
  var {
    size,
    isFullWidth
  } = _ref3;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(["", ";"], wrapperBySizeMixin(size, isFullWidth));
});

var _excluded$1 = ["isLoading", "href", "color", "size", "isDisabled", "icon", "onClick", "type"];
class IconButton extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleLinkClick", event => {
      var {
        isDisabled,
        onClick
      } = this.props;
      if (isDisabled) {
        event.preventDefault();
      } else {
        if (onClick) {
          onClick(event);
        }
      }
    });
    _defineProperty(this, "getIconSize", size => {
      switch (size) {
        case 'xs':
          return (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1);
        case 'sm':
          return (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1.25);
        case 'md':
          return (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1.5);
        case 'lg':
          return (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(2);
        default:
          return undefined;
      }
    });
  }
  render() {
    var theme = this.context;
    var _this$props = this.props,
      {
        isLoading = false,
        href,
        color = theme.color.interaction.main,
        size = 'md',
        isDisabled,
        icon,
        onClick,
        type = 'button'
      } = _this$props,
      otherProps = _objectWithoutProperties(_this$props, _excluded$1);
    var Icon = isLoading ? _lendi_ui_spinner__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z : this.props.icon;
    var iconSize = this.getIconSize(size);
    if (href) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(LinkWrapper, _objectSpread2(_objectSpread2({
        onClick: this.handleLinkClick,
        size: size,
        disabled: isDisabled,
        href: href
      }, otherProps), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Icon, {
          color: color,
          height: iconSize,
          width: iconSize
        })
      }));
    } else {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(IconButtonWrapper, _objectSpread2(_objectSpread2(_objectSpread2({
        onClick: onClick,
        size: size,
        disabled: isDisabled || isLoading,
        type: type
      }, (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .getDataProps */ .Bl)(this.props)), otherProps), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Icon, {
          color: color,
          height: iconSize,
          width: iconSize
        })
      }));
    }
  }
}
_defineProperty(IconButton, "contextType", styled_components__WEBPACK_IMPORTED_MODULE_9__/* .ThemeContext */ .Ni);

var _excluded = ["size", "className", "isFullWidth", "children", "isInverse", "isLoading", "isDisabled"];
var ButtonGroupButton = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ButtonContext.Consumer, {
  children: state => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Button, _objectSpread2(_objectSpread2({}, props), state))
});
var ButtonGroupIconButton = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ButtonContext.Consumer, {
  children: state => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(IconButton, _objectSpread2(_objectSpread2({}, props), state))
});
var ButtonContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
class ButtonGroup extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  render() {
    var _this$props = this.props,
      {
        size = 'md',
        className,
        isFullWidth,
        children,
        isInverse,
        isLoading = false,
        isDisabled
      } = _this$props,
      btnProps = _objectWithoutProperties(_this$props, _excluded);
    var buttonGroupWrapperProps = {
      size,
      isFullWidth,
      isInverse,
      isDisabled,
      isLoading
    };
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ButtonContext.Provider, {
      value: buttonGroupWrapperProps,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Wrapper, _objectSpread2(_objectSpread2({
        className: className,
        size: size,
        isFullWidth: isFullWidth
      }, btnProps), {}, {
        children: children
      }))
    });
  }
}
_defineProperty(ButtonGroup, "Button", ButtonGroupButton);
_defineProperty(ButtonGroup, "IconButton", ButtonGroupIconButton);




/***/ }),

/***/ 62792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ color; },
/* harmony export */   "bg": function() { return /* binding */ bg; },
/* harmony export */   "fg": function() { return /* binding */ fg; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97477);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23783);




var removeHash = hex => {
  return hex[0] === '#' ? hex.slice(1) : hex;
};

var parseHex = nakedHex => {
  var isShort = nakedHex.length === 3;
  var twoDigitHexR = isShort ? nakedHex.slice(0, 1).concat(nakedHex.slice(0, 1)) : nakedHex.slice(0, 2);
  var twoDigitHexG = isShort ? nakedHex.slice(1, 2).concat(nakedHex.slice(1, 2)) : nakedHex.slice(2, 4);
  var twoDigitHexB = isShort ? nakedHex.slice(2, 3).concat(nakedHex.slice(2, 3)) : nakedHex.slice(4, 6);
  return {
    r: twoDigitHexR,
    g: twoDigitHexG,
    b: twoDigitHexB
  };
};

var hexToDecimal = hex => {
  return parseInt(hex, 16);
};

var hexesToDecimals = _ref => {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  return {
    r: hexToDecimal(r),
    g: hexToDecimal(g),
    b: hexToDecimal(b)
  };
};

var formatRgb = function formatRgb(decimalObject) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var r = decimalObject.r,
      g = decimalObject.g,
      b = decimalObject.b;
  return 'rgba('.concat(r.toString(), ',').concat(g.toString(), ',').concat(b.toString(), ',').concat(alpha.toString(), ')');
};

var hexToRgba = function hexToRgba(hex) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var hashlessHex = removeHash(hex);
  var hexObject = parseHex(hashlessHex);
  var decimalObject = hexesToDecimals(hexObject);
  return formatRgb(decimalObject, a);
};

function color(name, transparency) {
  return _ref => {
    var {
      theme
    } = _ref;

    if (!theme) {
      throw new Error('@lendi-ui/theme: Theme not found. Please ensure your components are wrapped in the Theme component e.g. <Theme><App/></Theme>');
    }

    var color = (0,_lendi_ui_theme__WEBPACK_IMPORTED_MODULE_0__/* .select */ .Ys)("colors.".concat(name))({
      theme
    });
    return hexToRgba(color, transparency);
  };
}
function fg(name, transparency) {
  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI)(name, n => n === undefined ? '' : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["color:", ";"], color(n, transparency)));
}
function bg(name, transparency) {
  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI)(name, n => n === undefined ? '' : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["background-color:", ";"], color(n, transparency)));
}




/***/ }),

/***/ 53075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H5": function() { return /* binding */ getRadius; },
/* harmony export */   "wK": function() { return /* binding */ getBorderRadius; },
/* harmony export */   "yb": function() { return /* binding */ getFocusRing; }
/* harmony export */ });
/* unused harmony exports getFocusOutline, getFocusOutlineOffset */
/* harmony import */ var _dist_getColour_41851c9a_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3286);
/* harmony import */ var _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7401);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32735);





var getFocusRing = opts => {
  var ringColour = (0,_dist_getColour_41851c9a_esm_js__WEBPACK_IMPORTED_MODULE_0__.g)('border', 'interaction', {
    state: 'focus'
  });
  if (opts !== null && opts !== void 0 && opts.background) {
    return "0 0 0 2px ".concat(opts.background, ", 0 0 0 2px ").concat(ringColour);
  }
  return "0 0 0 2px ".concat((0,_dist_getColour_41851c9a_esm_js__WEBPACK_IMPORTED_MODULE_0__.g)('fill', 'main'), ", 0 0 0 4px ").concat(ringColour);
};
var getFocusOutline = () => "".concat(getColour('border', 'interaction', {
  state: 'focus'
}), " solid 2px");
var getFocusOutlineOffset = () => "2px";

var semantics$3 = {
  default: '6px',
  decorative: '6px',
  button: '6px',
  checkbox: '3px'
};

var semantics$2 = {
  default: '6px',
  decorative: '6px',
  button: '50px',
  checkbox: '3px'
};

var semantics$1 = {
  default: '0',
  decorative: '16px',
  button: '50px',
  checkbox: '3px'
};

var semantics = {
  default: '2px',
  decorative: '2px',
  button: '3px',
  checkbox: '3px'
};

var getRadius = (category, themeName) => {
  var internalTheme = themeName !== null && themeName !== void 0 ? themeName : (0,_utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .getThemeName */ .Yo)();
  var brandMap = {
    lendi: semantics$3,
    'lendi-next': semantics$2,
    aussie: semantics$1,
    domain: semantics
  };
  return brandMap[internalTheme][category !== null && category !== void 0 ? category : 'default'];
};

// Temporary Backwards compatibility adapter
// TODO: remove when all components are migrated
var getBorderRadius = opts => {
  return getRadius('default', opts.theme);
};




/***/ }),

/***/ 56116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* reexport safe */ _dist_getColour_41851c9a_esm_js__WEBPACK_IMPORTED_MODULE_0__.g; },
/* harmony export */   "hs": function() { return /* reexport safe */ _dist_getColour_41851c9a_esm_js__WEBPACK_IMPORTED_MODULE_0__.g; }
/* harmony export */ });
/* unused harmony exports createOverrides, hexToRgba */
/* harmony import */ var _dist_getColour_41851c9a_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3286);
/* harmony import */ var _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7401);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32735);





// @ts-expect-error
function createOverrides(overrides) {
  var overrideMap = new Map();
  overrides === null || overrides === void 0 || overrides.forEach(item => overrideMap.set(item[0], item[1]));
  return overrideMap;
}

var removeHash = hex => hex.charAt(0) === '#' ? hex.slice(1) : hex;
var parseHex = nakedHex => {
  var isShort = nakedHex.length === 3 || nakedHex.length === 4;
  var twoDigitHexR = isShort ? "".concat(nakedHex.slice(0, 1)).concat(nakedHex.slice(0, 1)) : nakedHex.slice(0, 2);
  var twoDigitHexG = isShort ? "".concat(nakedHex.slice(1, 2)).concat(nakedHex.slice(1, 2)) : nakedHex.slice(2, 4);
  var twoDigitHexB = isShort ? "".concat(nakedHex.slice(2, 3)).concat(nakedHex.slice(2, 3)) : nakedHex.slice(4, 6);
  var twoDigitHexA = (isShort ? "".concat(nakedHex.slice(3, 4)).concat(nakedHex.slice(3, 4)) : nakedHex.slice(6, 8)) || 'ff';

  // const numericA = +((parseInt(a, 16) / 255).toFixed(2));

  return {
    r: twoDigitHexR,
    g: twoDigitHexG,
    b: twoDigitHexB,
    a: twoDigitHexA
  };
};
var hexToDecimal = hex => parseInt(hex, 16);
var hexesToDecimals = _ref => {
  var {
    r,
    g,
    b,
    a
  } = _ref;
  return {
    r: hexToDecimal(r),
    g: hexToDecimal(g),
    b: hexToDecimal(b),
    a: +(hexToDecimal(a) / 255).toFixed(2)
  };
};
var isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n); // eslint-disable-line no-restricted-globals, max-len

var formatRgb = (decimalObject, parameterA) => {
  var {
    r,
    g,
    b,
    a: parsedA
  } = decimalObject;
  var a = isNumeric(parameterA) ? parameterA : parsedA;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
};

/**
 * Turns an old-fashioned css hex colour value into a rgb colour value.
 *
 * If you specify an alpha value, you'll get a rgba() value instead.
 *
 * @param The hex value to convert. ('123456'. '#123456', ''123', '#123')
 * @param An alpha value to apply. (optional) ('0.5', '0.25')
 * @return An rgb or rgba value. ('rgb(11, 22, 33)'. 'rgba(11, 22, 33, 0.5)')
 */
var hexToRgba = (hex, a) => {
  var hashlessHex = removeHash(hex);
  var hexObject = parseHex(hashlessHex);
  var decimalObject = hexesToDecimals(hexObject);
  return formatRgb(decimalObject, a);
};




/***/ }),

/***/ 46706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDepth; }
/* harmony export */ });
var depth = {
  1: {
    default: "0 0 2px 0 rgba(0, 0, 0, 0.1), 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.14)"
  },
  2: {
    default: "0 3px 3px 0 rgba(0, 0, 0, 0.1), 0 3px 4px 0 rgba(0, 0, 0, 0.12), 0 1px 8px 0 rgba(0, 0, 0, 0.14)",
    focusRing: "0 3px 8px 0 rgba(0, 0, 0, 0.14), 0 5px 4px 0 rgba(0, 0, 0, 0.12), 0 5px 3px 0 rgba(0, 0, 0, 0.1)"
  },
  3: {
    default: "0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px 0 rgba(0, 0, 0, 0.14)"
  },
  4: {
    default: "0 12px 17px 2px rgba(0, 0, 0, 0.1), 0 5px 22px 4px rgba(0, 0, 0, 0.12), 0 7px 8px 0 rgba(0, 0, 0, 0.14)"
  }
};

// Determine if focusRing is present on a given Level

// Note: this is the same as @lendi-ui/depth but without the 'box-shadow: ' and semi-colon included in the string

function getDepth(level, type) {
  var _depth$level;
  var depthType = type !== null && type !== void 0 ? type : 'default';
  return depth === null || depth === void 0 || (_depth$level = depth[level]) === null || _depth$level === void 0 ? void 0 : _depth$level[depthType];
}




/***/ }),

/***/ 3286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getColour; }
/* harmony export */ });
/* unused harmony exports c, i */
/* harmony import */ var _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7401);


function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/**
 * Base Colours v3
 */
// Interactive
var ultramarine = {
  900: {
    value: '#171b3d'
  },
  800: {
    value: '#29337b'
  },
  700: {
    value: '#3645b8'
  },
  600: {
    value: '#3d53f5'
  },
  500: {
    value: '#5e72ff'
  },
  400: {
    value: '#8291ff'
  },
  300: {
    value: '#a9b3ff'
  },
  200: {
    value: '#d3d8ff'
  },
  100: {
    value: '#eaecff'
  },
  50: {
    value: '#f6f7ff'
  },
  25: {
    value: '#fbfbff'
  }
};

// Basic
var transparent = {
  0: {
    value: 'transparent'
  }
};
var white = {
  0: {
    value: '#ffffff'
  }
};
var black = {
  1000: {
    value: '#000000'
  }
};
var green = {
  900: {
    value: '#0d2210'
  },
  800: {
    value: '#18451f'
  },
  700: {
    value: '#21672d'
  },
  600: {
    value: '#288a38'
  },
  500: {
    value: '#2cac41'
  },
  400: {
    value: '#4cc460'
  },
  300: {
    value: '#73dc84'
  },
  200: {
    value: '#a0f4ae'
  },
  100: {
    value: '#c1fecb'
  },
  50: {
    value: '#d9ffdf'
  },
  25: {
    value: '#ecffef'
  }
};
var red = {
  900: {
    value: '#331314'
  },
  800: {
    value: '#662022'
  },
  700: {
    value: '#99282c'
  },
  600: {
    value: '#cc2b30'
  },
  500: {
    value: '#ff282f'
  },
  400: {
    value: '#ff5158'
  },
  300: {
    value: '#ff7f84'
  },
  200: {
    value: '#ffafb2'
  },
  100: {
    value: '#ffcfd1'
  },
  50: {
    value: '#ffe5e6'
  },
  25: {
    value: '#fff3f3'
  }
};
var orange = {
  900: {
    value: '#321e12'
  },
  800: {
    value: '#65391f'
  },
  700: {
    value: '#975027'
  },
  600: {
    value: '#ca6429'
  },
  500: {
    value: '#fc7426'
  },
  400: {
    value: '#ff904f'
  },
  300: {
    value: '#ffac7c'
  },
  200: {
    value: '#ffcbad'
  },
  100: {
    value: '#ffe0ce'
  },
  50: {
    value: '#ffeee4'
  },
  25: {
    value: '#fff7f2'
  }
};

// Feedback
var blue = {
  900: {
    value: '#112431'
  },
  800: {
    value: '#1d4562'
  },
  700: {
    value: '#216393'
  },
  600: {
    value: '#207fc4'
  },
  500: {
    value: '#1898f5'
  },
  400: {
    value: '#42b0ff'
  },
  300: {
    value: '#70c3ff'
  },
  200: {
    value: '#a2d8ff'
  },
  100: {
    value: '#c5e7ff'
  },
  50: {
    value: '#def1ff'
  },
  25: {
    value: '#f0f9ff'
  }
};

/**
 * Base Color v1 (LUI Now)
 */

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var info = _objectSpread2({
  950: {
    value: blue['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "blue" color. Will be removed in next major.'
  }
}, blue);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var error = _objectSpread2({
  950: {
    value: red['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "red" color. Will be removed in next major.'
  }
}, red);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var success = _objectSpread2({
  950: {
    value: green['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "green" color. Will be removed in next major.'
  }
}, green);

/**
 @deprecated LUI-863 To be removed in the next major
 */
var warn = _objectSpread2({
  950: {
    value: orange['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "orange" color. Will be removed in next major.'
  }
}, orange);
var base$4 = {
  info,
  error,
  success,
  warn,
  ultramarine,
  transparent,
  white,
  black,
  green,
  red,
  orange,
  blue
};

var color$5 = {
  base: base$4
};

/**
 * Base Colours v3
 */
var purple = {
  900: {
    value: '#1a0d23'
  },
  800: {
    value: '#331745'
  },
  700: {
    value: '#4b1f68'
  },
  600: {
    value: '#633482'
  },
  500: {
    value: '#7d4e9c'
  },
  400: {
    value: '#996db7'
  },
  300: {
    value: '#b791d1'
  },
  200: {
    value: '#d8bbeb'
  },
  100: {
    value: '#e9d5f7'
  },
  50: {
    value: '#f3e6fc'
  },
  25: {
    value: '#faf3fe'
  }
};
var yellow = {
  900: {
    value: '#2b2610'
  },
  800: {
    value: '#55491b'
  },
  700: {
    value: '#806d23'
  },
  600: {
    value: '#aa8f26'
  },
  500: {
    value: '#d4b024'
  },
  400: {
    value: '#ffd11f'
  },
  300: {
    value: '#ffdc51'
  },
  200: {
    value: '#ffe788'
  },
  100: {
    value: '#ffefb1'
  },
  50: {
    value: '#fff6d1'
  },
  25: {
    value: '#fffbe9'
  }
};
var teal = {
  900: {
    value: '#0f241f'
  },
  800: {
    value: '#1c483e'
  },
  700: {
    value: '#286d5e'
  },
  600: {
    value: '#33917d'
  },
  500: {
    value: '#3db59b'
  },
  400: {
    value: '#45d9ba'
  },
  300: {
    value: '#6eedd1'
  },
  200: {
    value: '#9dffea'
  },
  100: {
    value: '#bffff1'
  },
  50: {
    value: '#d8fff7'
  },
  25: {
    value: '#ecfffb'
  }
};
var peach = {
  900: {
    value: '#2b1a12'
  },
  800: {
    value: '#553223'
  },
  700: {
    value: '#804b34'
  },
  600: {
    value: '#aa6345'
  },
  500: {
    value: '#d47b56'
  },
  400: {
    value: '#ff9366'
  },
  300: {
    value: '#ffb18f'
  },
  200: {
    value: '#ffd0bc'
  },
  100: {
    value: '#ffe4d9'
  },
  50: {
    value: '#fff0ea'
  },
  25: {
    value: '#fff8f5'
  }
};
var grey$2 = {
  900: {
    value: '#1d1d1d'
  },
  800: {
    value: '#3a3a39'
  },
  700: {
    value: '#575756'
  },
  600: {
    value: '#737372'
  },
  500: {
    value: '#8f8f8e'
  },
  400: {
    value: '#ababa9'
  },
  300: {
    value: '#c7c7c5'
  },
  200: {
    value: '#e4e4e2'
  },
  100: {
    value: '#f2f2f0'
  },
  50: {
    value: '#f8f8f6'
  },
  25: {
    value: '#fcfcf9'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 * @deprecated use `grey` instead. LUI-863 To be removed in the next major
 */
var shade$3 = _objectSpread2(_objectSpread2({
  1000: {
    value: '#000000'
  },
  950: {
    value: '#0B0B0B'
  }
}, grey$2), {}, {
  0: {
    value: '#FFFFFF'
  }
});
var base$3 = {
  purple,
  yellow,
  teal,
  peach,
  grey: grey$2,
  shade: shade$3
};

/**
 * @todo evaulate how 'default' semantic value is being used and migrate away from it
 */
var text$3 = {
  main: base$3.grey[900],
  subtle: base$3.grey[700],
  contrast: base$3.purple[700],
  inverse: base$4.white[0],
  default: base$3.grey[900]
};
var interaction$3 = {
  main: base$3.purple[700],
  subtle: base$4.white[0],
  contrast: base$3.purple[700],
  emphasis: base$3.yellow[400],
  disabled: base$3.grey[400],
  success: base$4.green[600],
  error: base$4.red[600]
};
var fill$3 = {
  main: base$4.white[0],
  contrast: base$3.purple[700],
  accent: base$3.purple[700],
  selected: base$3.purple[50],
  disabled: base$3.grey[50]
};
var background$3 = {
  page: base$3.grey[25],
  container: base$4.white[0],
  surface: base$3.grey[100],
  emphasis: base$3.grey[50]
};
var border$3 = {
  container: base$3.grey[200],
  divider: base$3.grey[100],
  dividerEmphasis: base$3.grey[900],
  interaction: {
    default: base$3.grey[500],
    hover: base$3.grey[700],
    focus: base$4.ultramarine[500],
    selected: base$3.purple[700]
  }
};
var buttonFill$3 = {
  primary: {
    default: base$3.purple[700],
    hover: base$3.purple[600],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[800]
  },
  primaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[300],
    focus: base$3.yellow[400],
    disabled: base$3.grey[50],
    pressed: base$3.yellow[500]
  },
  secondary: {
    default: base$4.transparent[0],
    hover: base$3.purple[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base$3.purple[600],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[800]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$3.purple[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$3.purple[600],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[800]
  }
};

// foreground means button text
var buttonForeground$3 = {
  primary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  },
  primaryInverse: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  secondary: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  secondaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[400],
    focused: base$3.yellow[400],
    disabled: base$3.grey[400],
    pressed: base$3.yellow[400]
  },
  text: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  textInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[400],
    focused: base$3.yellow[400],
    disabled: base$3.grey[400],
    pressed: base$3.yellow[400]
  }
};
var buttonBorder$3 = {
  primary: {
    default: base$3.purple[700],
    hover: base$3.purple[600],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[800]
  },
  primaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[300],
    focus: base$3.yellow[400],
    disabled: base$3.grey[50],
    pressed: base$3.yellow[500]
  },
  secondary: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  secondaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[400],
    focus: base$3.yellow[400],
    disabled: base$3.grey[400],
    pressed: base$3.yellow[400]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$3.purple[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$3.purple[600],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[800]
  }
};
var semantic$3 = {
  text: text$3,
  interaction: interaction$3,
  fill: fill$3,
  background: background$3,
  border: border$3,
  buttonFill: buttonFill$3,
  buttonForeground: buttonForeground$3,
  buttonBorder: buttonBorder$3
};

var color$4 = {
  base: base$3,
  semantic: semantic$3
};

/**
 * Base Colours v3
 */
var lime = {
  900: {
    value: '#0d220b'
  },
  800: {
    value: '#154311'
  },
  700: {
    value: '#186511'
  },
  600: {
    value: '#16860b'
  },
  500: {
    value: '#0ea800'
  },
  400: {
    value: '#2ec121'
  },
  300: {
    value: '#56d94a'
  },
  200: {
    value: '#85f27c'
  },
  100: {
    value: '#abfca4'
  },
  50: {
    value: '#caffc5'
  },
  25: {
    value: '#e4ffe2'
  }
};
var navy = {
  900: {
    value: '#0e182a'
  },
  800: {
    value: '#142c54'
  },
  700: {
    value: '#25406e'
  },
  600: {
    value: '#3a5687'
  },
  500: {
    value: '#5470a1'
  },
  400: {
    value: '#748eba'
  },
  300: {
    value: '#98aed4'
  },
  200: {
    value: '#c1d2ee'
  },
  100: {
    value: '#dae5f9'
  },
  50: {
    value: '#eaf1fd'
  },
  25: {
    value: '#f4f8fe'
  }
};
var ocean = {
  900: {
    value: '#161331'
  },
  800: {
    value: '#292363'
  },
  700: {
    value: '#3b3194'
  },
  600: {
    value: '#483bc5'
  },
  500: {
    value: '#6458d7'
  },
  400: {
    value: '#857ae9'
  },
  300: {
    value: '#a89ffb'
  },
  200: {
    value: '#cdc8ff'
  },
  100: {
    value: '#e4e1ff'
  },
  50: {
    value: '#f1efff'
  },
  25: {
    value: '#f8f7ff'
  }
};
var vermillion = {
  900: {
    value: '#361712'
  },
  800: {
    value: '#6d281c'
  },
  700: {
    value: '#a3301c'
  },
  600: {
    value: '#d93013'
  },
  500: {
    value: '#e84f34'
  },
  400: {
    value: '#f8715a'
  },
  300: {
    value: '#ff9684'
  },
  200: {
    value: '#ffbeb2'
  },
  100: {
    value: '#ffd8d1'
  },
  50: {
    value: '#ffe9e5'
  },
  25: {
    value: '#fff5f3'
  }
};
var grey$1 = {
  900: {
    value: '#0f141e'
  },
  800: {
    value: '#232c3d'
  },
  700: {
    value: '#3c475b'
  },
  600: {
    value: '#556177'
  },
  500: {
    value: '#727d92'
  },
  400: {
    value: '#929cae'
  },
  300: {
    value: '#b5bcca'
  },
  200: {
    value: '#dbdee5'
  },
  100: {
    value: '#eff0f3'
  },
  50: {
    value: '#f8f8f9'
  },
  25: {
    value: '#fbfbfc'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 */

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var shade$2 = _objectSpread2(_objectSpread2({
  1000: {
    value: '#000000',
    deprecated: true,
    deprecated_comment: 'Replace with the "black" color. Will be removed in next major.'
  },
  950: {
    value: '#0B0B0B',
    deprecated: true,
    deprecated_comment: 'Replace with the "grey" color. Will be removed in next major.'
  }
}, grey$1), {}, {
  0: {
    value: '#FFFFFF',
    deprecated: true,
    deprecated_comment: 'Replace with the "white" color. Will be removed in next major.'
  }
});

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var primary$1 = _objectSpread2({
  950: {
    value: lime['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "lime" color. Will be removed in next major.'
  }
}, lime);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var secondary$1 = _objectSpread2({
  950: {
    value: navy['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "navy" color. Will be removed in next major.'
  }
}, navy);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var tertiary$1 = _objectSpread2({
  950: {
    value: ocean['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "ocean" color. Will be removed in next major.'
  }
}, ocean);
var base$2 = {
  primary: primary$1,
  secondary: secondary$1,
  tertiary: tertiary$1,
  lime,
  navy,
  ocean,
  vermillion,
  grey: grey$1,
  shade: shade$2
};

var text$2 = {
  main: base$2.grey[900],
  subtle: base$2.grey[700],
  contrast: base$2.navy[800],
  inverse: base$4.white[0],
  default: base$2.grey[900]
};
var interaction$2 = {
  main: base$2.lime[500],
  subtle: base$4.white[0],
  contrast: base$2.lime[500],
  emphasis: base$2.vermillion[600],
  disabled: base$2.grey[400],
  success: base$4.green[600],
  error: base$4.red[600]
};
var fill$2 = {
  main: base$4.white[0],
  contrast: base$2.navy[800],
  accent: base$2.lime[500],
  selected: base$2.navy[50],
  disabled: base$2.grey[50]
};
var background$2 = {
  page: base$2.grey[25],
  container: base$4.white[0],
  surface: base$2.grey[100],
  emphasis: base$2.grey[50]
};
var border$2 = {
  container: base$2.grey[200],
  divider: base$2.grey[100],
  dividerEmphasis: base$2.grey[900],
  interaction: {
    default: base$2.grey[500],
    hover: base$2.grey[700],
    focus: base$4.ultramarine[500],
    selected: base$2.navy[800]
  }
};
var buttonFill$2 = {
  primary: {
    default: base$2.lime[500],
    hover: base$2.lime[400],
    focus: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[600]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base$2.lime[25],
    focus: base$4.white[0],
    disabled: base$2.grey[50],
    pressed: base$2.lime[50]
  },
  secondary: {
    default: base$4.transparent[0],
    hover: base$2.lime[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.lime[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base$2.navy[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.navy[900]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$2.lime[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.lime[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$2.navy[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.navy[900]
  }
};
var buttonForeground$2 = {
  primary: {
    default: base$4.white[0],
    // todo: white
    hover: base$4.white[0],
    // todo: white
    focus: base$4.white[0],
    // todo: white
    disabled: base$4.white[0],
    pressed: base$4.white[0] // todo: white
  },
  primaryInverse: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focused: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  secondary: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focused: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focused: base$4.white[0],
    disabled: base$2.grey[400],
    pressed: base$4.white[0]
  },
  text: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focused: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  textInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focused: base$4.white[0],
    disabled: base$2.grey[400],
    pressed: base$4.white[0]
  }
};
var buttonBorder$2 = {
  primary: {
    default: base$2.lime[500],
    hover: base$2.lime[400],
    focus: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[600]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base$2.lime[25],
    focus: base$4.white[0],
    disabled: base$2.grey[50],
    pressed: base$2.lime[50]
  },
  secondary: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focus: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  secondaryInverse: {
    default: base$4.white[0],
    focus: base$4.white[0],
    hover: base$4.white[0],
    pressed: base$4.white[0],
    disabled: base$2.grey[400]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$2.lime[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.lime[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$2.navy[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.navy[900]
  }
};
var semantic$2 = {
  text: text$2,
  interaction: interaction$2,
  fill: fill$2,
  background: background$2,
  border: border$2,
  buttonFill: buttonFill$2,
  buttonForeground: buttonForeground$2,
  buttonBorder: buttonBorder$2
};

var color$3 = {
  base: base$2,
  semantic: semantic$2
};

/**
 * Base Colours v1 (LUI Now)
 *
 * @see https://www.figma.com/file/tgquIt0gPjaosYSGkjm5IQ/Colours---Base-%26-Semantic?node-id=207%3A20457
 */

/**
 * @deprecated Use `turquoise` instead. LUI-863 To be removed in the next major
 */
var primary = {
  950: {
    value: '#001310'
  },
  900: {
    value: '#002621'
  },
  800: {
    value: '#004C42'
  },
  700: {
    value: '#007363'
  },
  600: {
    value: '#329984'
  },
  500: {
    value: '#00C0A5'
  },
  400: {
    value: '#32CCB7'
  },
  300: {
    value: '#66D9C9'
  },
  200: {
    value: '#99E5DB'
  },
  100: {
    value: '#CCF2ED'
  },
  50: {
    value: '#E5F8F6'
  },
  25: {
    value: '#F2FBFA'
  }
};

/**
 @deprecated Use `turquoise` instead. LUI-863 To be removed in the next major
 */
var secondary = {
  950: {
    value: '#01080A'
  },
  900: {
    value: '#021215'
  },
  800: {
    value: '#05242B'
  },
  700: {
    value: '#073641'
  },
  600: {
    value: '#0A4857'
  },
  500: {
    value: '#0D5A6D'
  },
  400: {
    value: '#3D7A8A'
  },
  300: {
    value: '#6D9CA7'
  },
  200: {
    value: '#9EBDC4'
  },
  100: {
    value: '#CEDEE1'
  },
  50: {
    value: '#E6EEF0'
  },
  25: {
    value: '#F2F6F7'
  }
};

/**
 @deprecated Use `turquoise` instead. LUI-863 To be removed in the next major
 */
var tertiary = {
  950: {
    value: '#190B09'
  },
  900: {
    value: '#331613'
  },
  800: {
    value: '#662C27'
  },
  700: {
    value: '#99433B'
  },
  600: {
    value: '#CC594F'
  },
  500: {
    value: '#FF7063'
  },
  400: {
    value: '#FF8C82'
  },
  300: {
    value: '#FFA9A1'
  },
  200: {
    value: '#FFC5C0'
  },
  100: {
    value: '#FFE2DF'
  },
  50: {
    value: '#FFF0EF'
  },
  25: {
    value: '#FFF7F7'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 * @deprecated LUI-863 To be removed in the next major
 */
var shade$1 = {
  1000: {
    value: '#000000'
  },
  950: {
    value: '#0B0B0B'
  },
  900: {
    value: '#171717'
  },
  800: {
    value: '#2F2F2F'
  },
  700: {
    value: '#474747'
  },
  600: {
    value: '#5F5F5F'
  },
  500: {
    value: '#777777'
  },
  400: {
    value: '#929292'
  },
  300: {
    value: '#ADADAD'
  },
  200: {
    value: '#C8C8C8'
  },
  100: {
    value: '#E3E3E3'
  },
  50: {
    value: '#F1F1F1'
  },
  25: {
    value: '#F8F8F8'
  },
  0: {
    value: '#FFFFFF'
  }
};
var base$1 = {
  primary,
  secondary,
  tertiary,
  shade: shade$1
};

var interaction$1 = {
  main: base$1.primary[500],
  subtle: base$4.white[0],
  contrast: base$1.primary[500],
  emphasis: base$1.tertiary[500],
  disabled: base$1.shade[700],
  success: base$4.success[500],
  error: base$4.error[500]
};
var background$1 = {
  page: base$1.shade[25],
  container: base$4.white[0],
  surface: base$1.shade[100],
  emphasis: base$1.shade[50]
};
var text$1 = {
  main: base$1.shade[700],
  subtle: base$1.shade[600],
  inverse: base$4.white[0],
  contrast: base$1.secondary[500]
};
var fill$1 = {
  main: base$4.white[0],
  selected: base$1.primary[50],
  disabled: base$1.shade[25],
  accent: base$1.primary[500],
  contrast: base$1.secondary[500]
};
var border$1 = {
  container: base$1.shade[100],
  divider: base$1.shade[300],
  dividerEmphasis: base$1.shade[800],
  interaction: {
    default: base$1.shade[200],
    hover: base$1.secondary[500],
    selected: interaction$1.contrast,
    focus: {
      value: '#3F86F7'
    }
  }
};
var buttonFill$1 = {
  primary: {
    default: base$1.primary[500],
    hover: base$1.primary[400],
    focus: base$1.primary[600],
    disabled: base$1.primary[500],
    pressed: base$1.primary[600]
  },
  primaryInverse: {
    default: interaction$1.emphasis,
    hover: base$4.white[0],
    focus: interaction$1.emphasis,
    disabled: fill$1.disabled,
    pressed: interaction$1.emphasis
  },
  secondary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$1.primary[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base$4.white[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$1.primary[50]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  }
};
var buttonForeground$1 = {
  primary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: interaction$1.emphasis,
    focused: base$4.white[0],
    disabled: interaction$1.disabled,
    pressed: base$4.white[0]
  },
  secondary: {
    default: interaction$1.main,
    hover: interaction$1.main,
    focus: interaction$1.main,
    disabled: interaction$1.main,
    pressed: base$1.primary[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: interaction$1.main,
    focused: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$1.primary[600]
  },
  text: {
    default: interaction$1.main,
    hover: interaction$1.main,
    focus: interaction$1.main,
    disabled: interaction$1.main,
    pressed: base$1.primary[600]
  },
  textInverse: {
    default: base$4.white[0],
    hover: interaction$1.main,
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  }
};
var buttonBorder$1 = {
  primary: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  },
  primaryInverse: {
    pressed: interaction$1.emphasis,
    default: interaction$1.emphasis,
    hover: base$4.white[0],
    focus: interaction$1.emphasis,
    disabled: base$1.shade[700]
  },
  secondary: {
    default: interaction$1.main,
    hover: base$1.primary[400],
    focus: interaction$1.main,
    disabled: interaction$1.main,
    pressed: base$1.primary[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: interaction$1.main,
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$1.primary[600]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  }
};
var semantic$1 = {
  text: text$1,
  interaction: interaction$1,
  fill: fill$1,
  background: background$1,
  border: border$1,
  buttonFill: buttonFill$1,
  buttonForeground: buttonForeground$1,
  buttonBorder: buttonBorder$1
};

var color$2 = {
  base: base$1,
  semantic: semantic$1
};

/**
 * Base Colours v3
 */
var tiber = {
  900: {
    value: '#091d21'
  },
  800: {
    value: '#083742'
  },
  700: {
    value: '#15505d'
  },
  600: {
    value: '#296a79'
  },
  500: {
    value: '#428594'
  },
  400: {
    value: '#61a1b0'
  },
  300: {
    value: '#85becb'
  },
  200: {
    value: '#b0dce6'
  },
  100: {
    value: '#cdedf4'
  },
  50: {
    value: '#e0f5fa'
  },
  25: {
    value: '#f0fafc'
  }
};
var turquoise = {
  900: {
    value: '#0b201d'
  },
  800: {
    value: '#12403a'
  },
  700: {
    value: '#146056'
  },
  600: {
    value: '#128071'
  },
  500: {
    value: '#0ba08b'
  },
  400: {
    value: '#00c0a5'
  },
  300: {
    value: '#2bd9c2'
  },
  200: {
    value: '#60f1dd'
  },
  100: {
    value: '#8efced'
  },
  50: {
    value: '#b7fff5'
  },
  25: {
    value: '#dbfffa'
  }
};
var lagoon = {
  900: {
    value: '#0b1e23'
  },
  800: {
    value: '#0f3a46'
  },
  700: {
    value: '#0b5569'
  },
  600: {
    value: '#006e8c'
  },
  500: {
    value: '#1987a5'
  },
  400: {
    value: '#39a1be'
  },
  300: {
    value: '#60bdd7'
  },
  200: {
    value: '#8fdbf0'
  },
  100: {
    value: '#b3ebfb'
  },
  50: {
    value: '#cff5ff'
  },
  25: {
    value: '#e7faff'
  }
};
var coral = {
  900: {
    value: '#2b1412'
  },
  800: {
    value: '#552723'
  },
  700: {
    value: '#803a34'
  },
  600: {
    value: '#aa4c44'
  },
  500: {
    value: '#d45e54'
  },
  400: {
    value: '#ff7063'
  },
  300: {
    value: '#ff978d'
  },
  200: {
    value: '#ffc0ba'
  },
  100: {
    value: '#ffdad7'
  },
  50: {
    value: '#ffebe9'
  },
  25: {
    value: '#fff6f5'
  }
};
var grey = {
  900: {
    value: '#181818'
  },
  800: {
    value: '#2f2f2f'
  },
  700: {
    value: '#474747'
  },
  600: {
    value: '#656565'
  },
  500: {
    value: '#838383'
  },
  400: {
    value: '#a1a1a1'
  },
  300: {
    value: '#bfbfbf'
  },
  200: {
    value: '#dcdcdc'
  },
  100: {
    value: '#ececec'
  },
  50: {
    value: '#f5f5f5'
  },
  25: {
    value: '#fafafa'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 * @deprecated use `grey` instead. LUI-863 To be removed in the next major
 */
var shade = _objectSpread2(_objectSpread2({
  1000: {
    value: '#000000'
  },
  950: {
    value: '#0B0B0B'
  }
}, grey), {}, {
  0: {
    value: '#FFFFFF'
  }
});
var base = {
  tiber,
  turquoise,
  lagoon,
  coral,
  grey,
  shade
};

var text = {
  main: base.grey[900],
  subtle: base.grey[700],
  contrast: base.tiber[800],
  inverse: base$4.white[0]
};
var interaction = {
  main: base.lagoon[600],
  subtle: base$4.white[0],
  contrast: base.turquoise[500],
  emphasis: base.coral[400],
  disabled: base.grey[400],
  success: base$4.green[600],
  error: base$4.red[600]
};
var fill = {
  main: base$4.white[0],
  contrast: base.lagoon[600],
  accent: base.turquoise[400],
  selected: base.lagoon[50],
  disabled: base.grey[50]
};
var background = {
  page: base.grey[25],
  container: base$4.white[0],
  surface: base.grey[100],
  emphasis: base.grey[50]
};
var border = {
  container: base.grey[200],
  divider: base.grey[100],
  dividerEmphasis: base.grey[900],
  interaction: {
    default: base.grey[500],
    hover: base.grey[700],
    focus: base$4.ultramarine[500],
    selected: base.lagoon[600]
  }
};
var buttonFill = {
  primary: {
    default: base.lagoon[600],
    hover: base.lagoon[700],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[800]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base.lagoon[25],
    focus: base$4.white[0],
    disabled: base.grey[50],
    pressed: base.lagoon[50]
  },
  secondary: {
    default: base$4.transparent[0],
    hover: base.lagoon[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.lagoon[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base.tiber[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.tiber[900]
  },
  text: {
    default: base$4.transparent[0],
    hover: base.lagoon[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.lagoon[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base.tiber[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.tiber[900]
  }
};
var buttonForeground = {
  primary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  },
  primaryInverse: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  secondary: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base.grey[400],
    pressed: base$4.white[0]
  },
  text: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  textInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base.grey[400],
    pressed: base$4.white[0]
  }
};
var buttonBorder = {
  primary: {
    default: base.lagoon[600],
    hover: base.lagoon[700],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[800]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base.lagoon[25],
    focus: base$4.white[0],
    disabled: base.grey[50],
    pressed: base.lagoon[50]
  },
  secondary: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    focus: base$4.white[0],
    hover: base$4.white[0],
    pressed: base$4.white[0],
    disabled: base.grey[400]
  },
  text: {
    default: base$4.transparent[0],
    hover: base.lagoon[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.lagoon[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base.tiber[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.tiber[900]
  }
};
var semantic = {
  text,
  interaction,
  fill,
  background,
  border,
  buttonFill,
  buttonForeground,
  buttonBorder
};

var color$1 = {
  base,
  semantic
};

var color = {
  common: color$5,
  lendi: color$2,
  lendiNext: color$1,
  domain: color$3,
  aussie: color$4
};

function select(path) {
  return _ref => {
    var {
      colors
    } = _ref;
    if (!colors) {
      throw new Error('@lendi-ui/theme: Theme not found. Please ensure your components are wrapped in the Theme component e.g. <Theme><App/></Theme>');
    }
    var pathWithDesignToken = "".concat(path, ".value");
    var obj = colors;
    var startIndex = -1;
    var finishIndex = -1;
    do {
      // check if there is a key that matches the remainder of the path
      var restOfPath = pathWithDesignToken.substr(startIndex + 1);
      if (Object.prototype.hasOwnProperty.call(obj, restOfPath)) {
        return obj[restOfPath];
      }

      // check if there is a key that matches the next part of the path
      finishIndex = pathWithDesignToken.indexOf('.', startIndex + 1);
      var nextPartOfPath = pathWithDesignToken.substr(startIndex + 1, finishIndex - startIndex - 1);
      if (finishIndex === -1 || !Object.prototype.hasOwnProperty.call(obj, nextPartOfPath)) {
        // console.warn(`@lendi-ui/commons: getColour(${path}) Could not find a matching color.`);
        return undefined;
      }
      obj = obj[nextPartOfPath];
      startIndex = finishIndex;
    } while (true); // eslint-disable-line no-constant-condition
  };
}

var isHex = str => str.match(/^#(?:[0-9a-fA-F]{3}){1,2}$/);
var createErrorString = (category, key, theme, state) => {
  var message = "The colour ".concat(category, ", ").concat(key, ",");
  if (state) {
    message = "".concat(message, ", ").concat(state, ",");
  }
  message = "".concat(message, " does not exist");
  if (theme) {
    message = "".concat(message, " for theme: ").concat(theme);
  }
  return message;
};
function getColour(category, key, options) {
  var _options$theme;
  var hex;
  var state = options === null || options === void 0 ? void 0 : options.state;
  var themeName = (_options$theme = options === null || options === void 0 ? void 0 : options.theme) !== null && _options$theme !== void 0 ? _options$theme : (0,_utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__/* .getThemeName */ .Yo)();
  var themePalette = _objectSpread2(_objectSpread2({}, color.lendi.base), color.lendi.semantic);
  switch (themeName) {
    case _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__/* .ThemeNames.Lendi */ .hN.Lendi:
      themePalette = _objectSpread2(_objectSpread2({}, color.lendi.base), color.lendi.semantic);
      break;
    case _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__/* .ThemeNames.LendiNext */ .hN.LendiNext:
      themePalette = _objectSpread2(_objectSpread2({}, color.lendiNext.base), color.lendiNext.semantic);
      break;
    case _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__/* .ThemeNames.Domain */ .hN.Domain:
      themePalette = _objectSpread2(_objectSpread2({}, color.domain.base), color.domain.semantic);
      break;
    case _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__/* .ThemeNames.Aussie */ .hN.Aussie:
      themePalette = _objectSpread2(_objectSpread2({}, color.aussie.base), color.aussie.semantic);
      break;
  }
  var merged = _objectSpread2(_objectSpread2({}, color.common.base), themePalette);
  if (category === 'border' || category === 'buttonFill' || category === 'buttonForeground' || category === 'buttonBorder') {
    // Border is a special semantic where we had nested semantic before.
    if (state) {
      hex = select("".concat(category, ".").concat(key, ".").concat(state))({
        colors: merged
      });
    } else {
      var _select;
      hex = (_select = select("".concat(category, ".").concat(key))({
        colors: merged
      })) !== null && _select !== void 0 ? _select : select("".concat(category, ".").concat(key, ".default"))({
        colors: merged
      });
    }
  } else {
    hex = select("".concat(category, ".").concat(key))({
      colors: merged
    });
  }
  if (!hex) {
    console.warn(createErrorString(category, key, themeName, options === null || options === void 0 ? void 0 : options.state));
  }
  return hex;
}




/***/ }),

/***/ 70757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTypography; }
/* harmony export */ });
/* unused harmony export textVariants */
/* harmony import */ var _utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7401);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _capsizecss_metrics_barlow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62678);
/* harmony import */ var _capsizecss_metrics_barlow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_capsizecss_metrics_barlow__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _capsizecss_metrics_cabin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23166);
/* harmony import */ var _capsizecss_metrics_cabin__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_capsizecss_metrics_cabin__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _capsizecss_metrics_openSans__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55167);
/* harmony import */ var _capsizecss_metrics_openSans__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_capsizecss_metrics_openSans__WEBPACK_IMPORTED_MODULE_4__);







var typography$3 = {
  subtitle1: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  subtitle2: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  overline: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 400
  }
};

var typography$2 = {
  display: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  display1: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  display2: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title1: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title2: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title3: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title4: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  lead1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  lead2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  subtitle1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  },
  subtitle2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  },
  body1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  body2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  button1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700
  },
  button2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700
  },
  detail1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  },
  detail2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  overline: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  }
};

var typography$1 = {
  display: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  display1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  display2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title3: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title4: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  lead1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  lead2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  subtitle1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  subtitle2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  body1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  body2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  button1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  button2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  detail1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  detail2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  overline: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 600
  }
};

var typography = {
  display: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  display1: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  display2: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title1: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title2: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title3: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title4: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  lead1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  lead2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  subtitle1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  },
  subtitle2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  },
  body1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  body2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  button1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 700
  },
  button2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 700
  },
  detail1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  },
  detail2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  overline: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  }
};

var metrics$1 = {
  capHeight: 717,
  ascent: 714,
  descent: -286,
  lineGap: 250,
  unitsPerEm: 1000
};

var metrics = {
  capHeight: 700,
  ascent: 1000,
  descent: -200,
  lineGap: 0,
  unitsPerEm: 1000
};

var fonts = {
  barlow: {
    fontFamily: "'Barlow'",
    capsizeSettings: (_capsizecss_metrics_barlow__WEBPACK_IMPORTED_MODULE_2___default())
  },
  cabin: {
    fontFamily: "'Cabin'",
    capsizeSettings: (_capsizecss_metrics_cabin__WEBPACK_IMPORTED_MODULE_3___default())
  },
  f37Bolton: {
    fontFamily: "'F37 Bolton'",
    capsizeSettings: metrics$1
  },
  openSans: {
    fontFamily: "'Open Sans'",
    capsizeSettings: (_capsizecss_metrics_openSans__WEBPACK_IMPORTED_MODULE_4___default())
  },
  ttCommons: {
    fontFamily: "'tt-commons-pro'",
    capsizeSettings: metrics
  }
};
var getFontMetrics = fontDeclaration => {
  var fontName = fontDeclaration.split(',')[0];
  // find the enum key if the fontName is one of our fonts
  var fontKey = Object.keys(fonts).find(key => fonts[key].fontFamily === fontName);
  if (fontKey) return fonts[fontKey].capsizeSettings;
  return (_capsizecss_metrics_openSans__WEBPACK_IMPORTED_MODULE_4___default());
};

var textVariants = (/* unused pure expression or super */ null && ([
/*
 * @deprecated use 'display1' instead
 */
'display', 'display1', 'display2', 'title1', 'title2', 'title3', 'title4', 'lead1', 'lead2', 'subtitle1', 'subtitle2', 'body1', 'body2', 'button1', 'button2', 'detail1', 'detail2', 'overline']));
function getTypography(variant, property) {
  var themeName = (0,_utils_dist_commons_esm_js__WEBPACK_IMPORTED_MODULE_0__/* .getThemeName */ .Yo)();
  var baseTypography = typography$2;
  var themeTypography = {
    // This is a bit confusing, but because Lendi Next is the foundation for all themes, on order to
    // create the "legacy" set of typography, we need to merge them together here to form
    // the default.
    lendi: Object.assign({}, baseTypography, typography$3),
    'lendi-next': baseTypography,
    domain: Object.assign({}, baseTypography, typography$1),
    aussie: Object.assign({}, baseTypography, typography)
  };
  if (property === 'fontMetrics') {
    return getFontMetrics(themeTypography[themeName][variant].fontFamily);
  }
  return themeTypography[themeName][variant][property];
}




/***/ }),

/***/ 58905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; },
/* harmony export */   "n": function() { return /* binding */ container; }
/* harmony export */ });
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23783);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84209);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90471);




function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var marginX = "1rem";
var xlMaxWidth = '71.25rem';
var responsiveMaxWidth = {
  sm: '33.75rem',
  md: '45rem',
  lg: '60rem',
  xl: xlMaxWidth
};

var _templateObject;
var container = () => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["box-sizing:border-box;margin:auto ", ";", ";width:calc(100% - ", " * 2);", ";"], marginX, (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(responsiveMaxWidth, value => value === undefined ? '' : "width: ".concat(value)), marginX, (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .gte */ .eg)('tablet')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_1__.mx)('auto')));
var Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "src__Container",
  componentId: "lui__sc-ifo7jj-0"
})(["", ";"], container);




/***/ }),

/***/ 12987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ depth; }
/* harmony export */ });
function depth(level) {
  switch (level) {
    case 1:
      return "box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1),\n        0 2px 2px 0 rgba(0, 0, 0, 0.12),\n        0 1px 3px 0 rgba(0, 0, 0, 0.14);";

    case 2:
      return "box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1),\n        0 3px 4px 0 rgba(0, 0, 0, 0.12),\n        0 1px 8px 0 rgba(0, 0, 0, 0.14);";

    case 3:
      return "box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1),\n        0 1px 18px 0 rgba(0, 0, 0, 0.12),\n        0 3px 5px 0 rgba(0, 0, 0, 0.14);";

    case 4:
      return "box-shadow: 0 12px 17px 2px rgba(0, 0, 0, 0.1),\n        0 5px 22px 4px rgba(0, 0, 0, 0.12),\n        0 7px 8px 0 rgba(0, 0, 0, 0.14);";
  }
}




/***/ }),

/***/ 136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Field; }
});

// UNUSED EXPORTS: Field

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/typography/dist/typography.esm.js
var typography_esm = __webpack_require__(56158);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/breakpoint/dist/breakpoint.esm.js
var breakpoint_esm = __webpack_require__(23783);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/utils/dist/utils.esm.js
var utils_esm = __webpack_require__(27233);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spacing/dist/spacing.esm.js
var spacing_esm = __webpack_require__(84209);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/dist/Icon-e9280b89.esm.js
var Icon_e9280b89_esm = __webpack_require__(95087);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/color/dist/color.esm.js
var color_esm = __webpack_require__(62792);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/HighlightOff/dist/icon.esm.js






function SvgHighlightOff(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/QuestionOutline/dist/icon.esm.js






function SvgQuestionOutline(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
      })
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/cuid/index.js
var cuid = __webpack_require__(56219);
var cuid_default = /*#__PURE__*/__webpack_require__.n(cuid);
;// CONCATENATED MODULE: ../../../node_modules/chromatic/isChromatic.mjs
/* eslint-env browser */

function isChromatic(windowArg) {
  const windowToCheck = windowArg || (typeof window !== 'undefined' && window);
  return !!(
    windowToCheck &&
    (windowToCheck.navigator.userAgent.match(/Chromatic/) ||
      windowToCheck.location.href.match(/chromatic=true/))
  );
}

// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/depth/dist/depth.esm.js
var depth_esm = __webpack_require__(12987);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/colours/dist/commons.esm.js
var commons_esm = __webpack_require__(56116);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/borders/dist/commons.esm.js
var dist_commons_esm = __webpack_require__(53075);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/typography/dist/commons.esm.js
var typography_dist_commons_esm = __webpack_require__(70757);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/tooltip/dist/tooltip.esm.js











function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var TooltipWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "indexstyle__TooltipWrapper",
  componentId: "lui__sc-16ro6qx-0"
})(["position:relative;"]);
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__ContentWrapper",
  componentId: "lui__sc-16ro6qx-1"
})(["font-family:", ";font-weight:", ";color:", ";background-color:", ";border-radius:", ";", ";", ";max-width:", ";min-width:", ";width:max-content;z-index:3;text-align:left;", ";overflow:hidden;position:absolute;transition:opacity 0.35s ease 0s;", ";", ";"], (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'), (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontWeight'), (0,commons_esm/* default */.ZP)('text', 'main'), (0,commons_esm/* default */.ZP)('background', 'container'), (0,dist_commons_esm/* getRadius */.H5)(), (0,spacing_esm.py)('sm'), (0,spacing_esm.px)('xxs'), (0,utils_esm/* deriveSize */.MS)(16.25), (0,utils_esm/* deriveSize */.MS)(3.75), (0,depth_esm/* depth */.Y)(3), _ref => {
  var {
    isOpen
  } = _ref;
  if (isOpen) {
    return (0,styled_components_browser_esm/* css */.iv)(["visibility:visible;"]);
  } else {
    return (0,styled_components_browser_esm/* css */.iv)(["visibility:hidden;position:absolute;z-index:1;opacity:0;transition:opacity 0.6s;"]);
  }
}, _ref2 => {
  var {
    position
  } = _ref2;
  switch (position) {
    case 'top':
      return (0,styled_components_browser_esm/* css */.iv)(["bottom:calc(100% + ", ");left:50%;transform:translateX(-50%);"], (0,utils_esm/* deriveSize */.MS)(0.5));
    case 'bottom':
      return (0,styled_components_browser_esm/* css */.iv)(["top:calc(100% + ", ");left:50%;transform:translateX(-50%);"], (0,utils_esm/* deriveSize */.MS)(0.5));
    case 'left':
      return (0,styled_components_browser_esm/* css */.iv)(["right:calc(100% + ", ");top:50%;transform:translateY(-50%);"], (0,utils_esm/* deriveSize */.MS)(0.5));
    case 'right':
      return (0,styled_components_browser_esm/* css */.iv)(["left:calc(100% + ", ");top:50%;transform:translateY(-50%);"], (0,utils_esm/* deriveSize */.MS)(0.5));
  }
});

class Tooltip extends react.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isOpen: false
    });
    _defineProperty(this, "hammer", undefined);
    _defineProperty(this, "_isMounted", false);
    _defineProperty(this, "myRef", /*#__PURE__*/react.createRef());
    _defineProperty(this, "changeOpenStatus", bool => {
      if (this._isMounted) {
        if (bool) {
          var _this$props$onOpen, _this$props;
          (_this$props$onOpen = (_this$props = this.props).onOpen) === null || _this$props$onOpen === void 0 ? void 0 : _this$props$onOpen.call(_this$props);
        }
        this.setState({
          isOpen: bool
        });
      }
    });
  }
  componentDidMount() {
    this._isMounted = true;
    if (typeof window !== "undefined") {
      var Hammer = __webpack_require__(11539);
      var hammer;
      var manager = new Hammer.Manager(this.myRef.current);
      var Press = new Hammer.Press({
        time: 300
      });
      manager.add(Press);
      manager.on('press', () => {
        var _this$props$onOpen2, _this$props2;
        (_this$props$onOpen2 = (_this$props2 = this.props).onOpen) === null || _this$props$onOpen2 === void 0 ? void 0 : _this$props$onOpen2.call(_this$props2);
        this.setState({
          isOpen: true
        });
      });
      hammer = new Hammer(document.body, {
        cssProps: {
          userSelect: 'auto'
        }
      });
      hammer.on('tap', e => {
        if (e.target !== this.myRef.current) {
          this.setState({
            isOpen: false
          });
        }
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (typeof this.hammer !== 'undefined') {
      this.hammer.destroy();
    }
  }
  render() {
    var {
      content,
      position = 'right',
      children,
      className,
      onClick: _onClick
    } = this.props;
    var {
      isOpen
    } = this.state;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipWrapper, {
      ref: this.myRef,
      onMouseEnter: () => this.changeOpenStatus(true),
      onMouseLeave: () => this.changeOpenStatus(false),
      className: className,
      onClick: () => {
        this.changeOpenStatus(true);
        _onClick === null || _onClick === void 0 ? void 0 : _onClick();
      },
      children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, {
        isOpen,
        position,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_esm/* Body */.uT, {
          size: "sm",
          color: 'shade.700',
          children: content
        })
      })]
    });
  }
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/field/dist/field.esm.js













function field_esm_toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function field_esm_toPropertyKey(arg) {
  var key = field_esm_toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function field_esm_defineProperty(obj, key, value) {
  key = field_esm_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      field_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var bodyStyleBySizeMixin = size => (0,breakpoint_esm/* map */.UI)(size, val => {
  switch (val) {
    case 'sm':
      return "\n          font-size: ".concat((0,utils_esm/* deriveSize */.MS)(0.75), ";\n      ");
    case 'lg':
      return "\n          font-size: ".concat((0,utils_esm/* deriveSize */.MS)(1), ";\n      ");
    default:
      return undefined;
  }
});
var headingStyleBySizeMixin = size => (0,breakpoint_esm/* map */.UI)(size, val => {
  switch (val) {
    case 'sm':
      return "\n          font-size: ".concat((0,utils_esm/* deriveSize */.MS)(1), ";\n          margin-right: ").concat((0,utils_esm/* deriveSize */.MS)(0.5), ";\n      ");
    case 'lg':
      return "\n          font-size: ".concat((0,utils_esm/* deriveSize */.MS)(1.75), ";\n          margin-right: ").concat((0,utils_esm/* deriveSize */.MS)(1), ";\n      ");
    default:
      return undefined;
  }
});
var LabelHeading = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Heading */.X6).withConfig({
  displayName: "indexstyle__LabelHeading",
  componentId: "lui__sc-1djucs9-0"
})(["", " display:inline-block;"], _ref => {
  var {
    size
  } = _ref;
  return headingStyleBySizeMixin(size);
});
var AssistiveBody = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "indexstyle__AssistiveBody",
  componentId: "lui__sc-1djucs9-1"
})(["", ";"], _ref2 => {
  var {
    size
  } = _ref2;
  return bodyStyleBySizeMixin(size);
});

var Label = _ref => {
  var {
    size,
    label,
    assistiveText,
    link,
    isRequired
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelHeading, {
      size: size,
      children: [label, !isRequired && ' (Optional)']
    }), link, /*#__PURE__*/(0,jsx_runtime.jsx)(AssistiveBody, {
      color: "shade.400",
      size: size,
      children: assistiveText
    })]
  });
};

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-1ij5id7-0"
})(["width:100%;display:flex;flex-direction:row;justify-content:flex-start;align-items:base-line;", ";color:", ";"], (0,spacing_esm.pt)('xxxs'), _ref => {
  var {
    theme
  } = _ref;
  return theme.color.interaction.error;
});
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "indexstyle__StyledError",
  componentId: "lui__sc-1ij5id7-1"
})(["color:", ";"], _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.interaction.error;
});

var ErrorMessage = _ref => {
  var {
    error
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgHighlightOff, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledError, {
      size: "xs",
      ml: "xxxs",
      children: error
    })]
  });
};

var FieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__FieldWrapper",
  componentId: "lui__sc-1pu8jrh-0"
})(["", ";display:flex;flex-direction:column;width:100%;"], utils_esm/* normalise */.W$);
var LabelField = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "indexstyle__LabelField",
  componentId: "lui__sc-1pu8jrh-1"
})(["width:100%;display:flex;align-items:center;", ";"], (0,spacing_esm.mb)('xxxs'));
var QuestionIcon = (0,styled_components_browser_esm/* default */.ZP)(SvgQuestionOutline).withConfig({
  displayName: "indexstyle__QuestionIcon",
  componentId: "lui__sc-1pu8jrh-2"
})(["display:flex;color:", ";"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.contrast;
});

var _excluded = ["size", "label", "isRequired", "assistiveText", "link", "tooltip", "children", "error", "touched", "htmlFor"];
var Field = _ref => {
  var {
      size = 'sm',
      label,
      isRequired = true,
      assistiveText,
      link,
      tooltip,
      children,
      error,
      touched,
      htmlFor
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var hasCustomLabelProps = label || !isRequired || assistiveText || link || tooltip;
  if (!htmlFor || htmlFor === '') {
    htmlFor = isChromatic() ? '123' : cuid_default()();
  }
  var childrenWithCustomId = /*#__PURE__*/react.isValidElement(children) ? /*#__PURE__*/react.cloneElement(children, {
    id: htmlFor
  }) : '';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [hasCustomLabelProps && /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelField, {
        htmlFor: htmlFor,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          size: size,
          label: label,
          isRequired: isRequired,
          assistiveText: assistiveText,
          link: link
        }), tooltip && /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip, {
          content: tooltip,
          position: "right",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionIcon, {})
        })]
      }), childrenWithCustomId, touched && error && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
        error: error
      })]
    })
  }));
};




/***/ }),

/***/ 63518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Grid; },
/* harmony export */   "bf": function() { return /* binding */ unit; },
/* harmony export */   "eC": function() { return /* binding */ grid; }
/* harmony export */ });
/* unused harmony exports Grid, Unit */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23783);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84209);




var gutter = {
  xs: '0.875rem',
  sm: '1rem',
  md: '1.25rem',
  lg: '1.5rem'
};

function halignMixin(_ref) {
  var {
    halign,
    reverse
  } = _ref;

  // if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
  if (halign === undefined) {
    return '';
  }

  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(halign, function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'left';
    var rule = '';

    switch (value) {
      case 'left':
        if (reverse) {
          rule = 'flex-end';
        } else {
          rule = 'flex-start';
        }

        break;

      case 'right':
        if (reverse) {
          rule = 'flex-start';
        } else {
          rule = 'flex-end';
        }

        break;

      case 'center':
        rule = 'center';
        break;

      case 'justify-center':
        rule = 'space-around';
        break;

      case 'justify':
        rule = 'space-between';
        break;

      default:
        throw new Error("styled-components-grid: halign must be one of \"left\", \"right\", \"center\", \"justify-center\" or \"justify\". Got \"".concat(String(value), "\""));
    }

    return "justify-content: ".concat(rule, ";");
  });
}

function valignMixin(_ref2) {
  var {
    valign
  } = _ref2;

  // if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
  if (valign === undefined) {
    return '';
  }

  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(valign, function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stretch';
    var rule = '';

    switch (value) {
      case 'top':
        rule = 'flex-start';
        break;

      case 'bottom':
        rule = 'flex-end';
        break;

      case 'center':
        rule = 'center';
        break;

      case 'stretch':
        rule = 'stretch';
        break;

      default:
        throw new Error("styled-components-grid: valign must be one of \"top\", \"bottom\", \"center\" or \"stretch\". Got \"".concat(String(value), "\"."));
    }

    return "align-items: ".concat(rule, ";");
  });
}

function reverseMixin(_ref3) {
  var {
    reverse
  } = _ref3;

  // if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
  if (reverse === undefined) {
    return '';
  }

  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(reverse, function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return "flex-direction: ".concat(value && 'row-reverse' || 'row', ";");
  });
}

function wrapMixin(_ref4) {
  var {
    wrap,
    reverse
  } = _ref4;

  if (wrap === undefined) {
    return 'flex-wrap: wrap;';
  }

  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(wrap, function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var breakpoint = arguments.length > 1 ? arguments[1] : undefined;
    var reverseVal = typeof reverse === 'object' && breakpoint ? reverse[breakpoint] : reverse;

    if (value && reverseVal) {
      return 'flex-wrap: wrap-reverse;';
    } else if (value === false) {
      return 'flex-wrap: nowrap;';
    } else {
      return 'flex-wrap: wrap;';
    }
  });
}

function isSpacingName(gutter) {
  return _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_1__/* .Spacing */ .K[gutter] !== undefined;
}

function gutterMixin(_ref5) {
  var {
    gutter: gutter$1 = gutter
  } = _ref5;
  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(gutter$1, value => {
    if (value === undefined) return;
    var val = isSpacingName(value) ? _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_1__/* .Spacing */ .K[value] : value;
    return "\n        width: calc(100% + ".concat(val, ");\n        margin-left: calc(").concat(val, " / 2 * -1);\n        margin-right: calc(").concat(val, " / 2 * -1);\n\n        & > * {\n          padding-left: calc(").concat(val, " / 2);\n          padding-right: calc(").concat(val, " / 2);\n        }\n      ");
  });
}

function grid() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["display:flex;", ";", ";", ";", ";", ";"], halignMixin(props), valignMixin(props), reverseMixin(props), wrapMixin(props), gutterMixin(props));
}

function offsetMixin(_ref) {
  var {
    offset
  } = _ref;

  if (offset === undefined) {
    return undefined;
  }

  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(offset, value => {
    if (value !== undefined) {
      var pct = Math.round(value * 100 * 10000) / 10000; // round to 4 decimal places

      return "margin-left: ".concat(pct, "%;");
    }

    return undefined;
  });
}

function sizeMixin(_ref2) {
  var {
    size = 1
  } = _ref2;
  return (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(size, function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    switch (value) {
      case 'min':
        return "\n          flex-grow: 0;\n          flex-basis: auto;\n          width: auto;\n          max-width: none;\n        ";

      case 'max':
        return "\n          flex-grow: 1;\n          flex-basis: auto;\n          width: auto;\n          max-width: none;\n          max-width: 100%; /* TODO: does this always work as expected? */\n        ";

      default:
        {
          var pct = Math.round(value * 100 * 10000) / 10000; // round to 4 decimal places

          return "\n          flex-basis: ".concat(pct, "%;\n          max-width: ").concat(pct, "%;\n        ");
        }
    }
  });
}

function unit() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["box-sizing:border-box;", ";", ";"], offsetMixin(props), sizeMixin(props));
}

var Unit = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "src__Unit",
  componentId: "lui__sc-1606zaz-0"
})(["", ";"], unit);
var Grid = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "src__Grid",
  componentId: "lui__sc-1606zaz-1"
})(["", ";"], grid);

/*
Styled components asserts that its components have no other properties on it,
however we have broken that promise in how we created this component.

We are ignoring the illegal assignment below, and casting the type of the export
so we do not make a breaking change for consumers.
*/
// @ts-expect-error
Grid.Unit = Unit;




/***/ }),

/***/ 82447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgClose; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgClose(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}




/***/ }),

/***/ 79007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgEmail; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgEmail(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}




/***/ }),

/***/ 5924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgMessage; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgMessage(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}




/***/ }),

/***/ 81114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgPerson; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgPerson(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}




/***/ }),

/***/ 33540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgSmartphone; }
/* harmony export */ });
/* harmony import */ var _dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62792);






function SvgSmartphone(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__.I, (0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_dist_Icon_e9280b89_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
      })]
    })
  }));
}




/***/ }),

/***/ 95087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ IconWrapper; },
/* harmony export */   "_": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62792);



function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

var isHex = str => str.match(/^#(?:[0-9a-fA-F]{3}){1,2}$/);
var getColorStr = function getColorStr(color$1) {
  // If we have a hex code
  if (isHex(color$1)) return color$1;
  return (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$)(color$1);
};
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "lui__sc-1jznn6y-0"
})(["width:", ";height:", ";vertical-align:middle;display:inline-block;& > svg{fill:", ";width:inherit;height:inherit;}[class$='fillPath']{fill:", ";}"], _ref => {
  var {
    width
  } = _ref;
  return width !== null && width !== void 0 ? width : '1em';
}, _ref2 => {
  var {
    height
  } = _ref2;
  return height !== null && height !== void 0 ? height : '1em';
}, _ref3 => {
  var {
    color
  } = _ref3;
  return color ? getColorStr(color) : 'currentColor';
}, _ref4 => {
  var {
    color
  } = _ref4;
  return color ? getColorStr(color) : 'currentColor';
});




/***/ }),

/***/ 50191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* unused harmony export Overlay */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _lendi_ui_transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4459);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90471);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74512);





function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-1p9iizv-0"
})(["position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;background-color:#000000;opacity:0.4;"], props => {
  var _props$zIndex;

  return (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 2;
});

class Overlay extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "handleClick", () => {
      var {
        onClickHide = true,
        onHide
      } = this.props;

      if (onClickHide && onHide) {
        onHide();
      }
    });

    _defineProperty(this, "handleKeyPress", event => {
      if (event.key !== 'Escape') {
        return;
      }

      var {
        onClickEscape = true,
        onHide
      } = this.props;

      if (onClickEscape && onHide) {
        onHide();
      }
    });
  }

  activate() {
    window.addEventListener('keydown', this.handleKeyPress);
  }

  deactivate() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }

  componentDidMount() {
    var {
      isVisible
    } = this.props;

    if (isVisible) {
      this.activate();
    }
  }

  componentDidUpdate(prevProps) {
    var {
      isVisible: prevShow
    } = prevProps;
    var {
      isVisible: currShow
    } = this.props;

    if (currShow !== prevShow) {
      if (currShow) {
        this.activate();
      } else {
        this.deactivate();
      }
    }
  }

  componentWillUnmount() {
    var {
      isVisible
    } = this.props;

    if (isVisible) {
      this.deactivate();
    }
  }

  render() {
    var {
      isVisible,
      children,
      zIndex
    } = this.props;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_lendi_ui_transition__WEBPACK_IMPORTED_MODULE_1__/* .Fade */ .pT, {
        isActive: isVisible,
        isVisible: isVisible,
        shouldMountOnEnter: true,
        shouldUnmountOnExit: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
          onClick: this.handleClick,
          zIndex: zIndex,
          children: children
        })
      })
    });
  }

}




/***/ }),

/***/ 84209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Spacing; },
/* harmony export */   "e": function() { return /* binding */ margin; },
/* harmony export */   "m": function() { return /* binding */ m; },
/* harmony export */   "mb": function() { return /* binding */ mb; },
/* harmony export */   "ml": function() { return /* binding */ ml; },
/* harmony export */   "mr": function() { return /* binding */ mr; },
/* harmony export */   "mt": function() { return /* binding */ mt; },
/* harmony export */   "mx": function() { return /* binding */ mx; },
/* harmony export */   "my": function() { return /* binding */ my; },
/* harmony export */   "p": function() { return /* binding */ p; },
/* harmony export */   "pb": function() { return /* binding */ pb; },
/* harmony export */   "pl": function() { return /* binding */ pl; },
/* harmony export */   "pr": function() { return /* binding */ pr; },
/* harmony export */   "pt": function() { return /* binding */ pt; },
/* harmony export */   "px": function() { return /* binding */ px; },
/* harmony export */   "py": function() { return /* binding */ py; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23783);
/* harmony import */ var _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27233);




var Spacing = {
  auto: 'auto',
  nil: '0',
  xxxs: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.25),
  xxs: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.5),
  xs: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(0.75),
  sm: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1),
  md: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(1.5),
  lg: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(2),
  xl: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(2.5),
  xxl: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(4),
  xxxl: (0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .deriveSize */ .MS)(5)
};

function createSpacingMixin(mapValueToStyle) {
  return size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)(size, s => s === undefined ? '' : mapValueToStyle(Spacing[s]));
}

var m = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["margin:", ";"], size));
var mx = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["margin-left:", ";margin-right:", ";"], size, size));
var my = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["margin-top:", ";margin-bottom:", ";"], size, size));
var mt = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["margin-top:", ";"], size));
var mr = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["margin-right:", ";"], size));
var mb = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["margin-bottom:", ";"], size));
var ml = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["margin-left:", ";"], size));
var p = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["padding:", ";"], size));
var px = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["padding-left:", ";padding-right:", ";"], size, size));
var py = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["padding-top:", ";padding-bottom:", ";"], size, size));
var pt = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["padding-top:", ";"], size));
var pr = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["padding-right:", ";"], size));
var pb = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["padding-bottom:", ";"], size));
var pl = createSpacingMixin(size => (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["padding-left:", ";"], size));
var margin = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["", " ", " ", " ", " ", " ", " ", ""], props => props.m && m(props.m), props => props.mx && mx(props.mx), props => props.my && my(props.my), props => props.mt && mt(props.mt), props => props.mr && mr(props.mr), props => props.mb && mb(props.mb), props => props.ml && ml(props.ml));




/***/ }),

/***/ 75910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Spinner; }
});

// UNUSED EXPORTS: Spinner

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/dist/Icon-e9280b89.esm.js
var Icon_e9280b89_esm = __webpack_require__(95087);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/color/dist/color.esm.js
var color_esm = __webpack_require__(62792);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Spinner/dist/icon.esm.js






function SvgSpinner(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.088.584v3c2.96 0 5.062 1.734 6.006 4.014.944 2.28.682 4.99-1.41 7.082-2.093 2.092-4.803 2.354-7.082 1.41-2.28-.944-4.014-3.047-4.014-6.006h-3c0 4.168 2.576 7.415 5.865 8.777 3.289 1.362 7.406.889 10.354-2.058 2.947-2.947 3.42-7.065 2.058-10.354C17.503 3.16 14.256.584 10.088.584z"
      })
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/colours/dist/commons.esm.js
var commons_esm = __webpack_require__(56116);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/spinner/dist/spinner.esm.js






function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var spin = (0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerIconWrapper = (0,styled_components_browser_esm/* default */.ZP)(SvgSpinner).withConfig({
  displayName: "indexstyle__SpinnerIconWrapper",
  componentId: "lui__sc-x7rvh5-0"
})(["animation:", " 1.2s linear infinite;display:inline-block;line-height:0;"], spin);

var _excluded = ["variant"];
var Spinner = _ref => {
  var {
    variant = 'dark'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var color = variant === 'dark' ? (0,commons_esm/* default */.ZP)('buttonForeground', 'secondary') : (0,commons_esm/* default */.ZP)('shade', 0);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerIconWrapper, _objectSpread2({
    color: color
  }, props));
};




/***/ }),

/***/ 97477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ys": function() { return /* reexport */ Theme_e539ec04_esm_select; }
});

// UNUSED EXPORTS: default, domainTheme, theme

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/utils/dist/commons.esm.js
var commons_esm = __webpack_require__(7401);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/index-03130070.esm.js
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function index_03130070_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

// Spacing in LUI now is all based in px values, we could redefine these in LUI now (in a more sensible reusable place)
// Needs to be compatable with Figma so can we even use rems here
/**
 * @property {string}  xxxs = 4px
 * @property {string}  xxs = 8px
 * @property {string}  xs = 12px
 * @property {string}  sm = 16px
 * @property {string}  md = 24px
 * @property {string}  lg = 32px
 * @property {string}  xl = 40px
 * @property {string}  xxl = 64px
 * @property {string}  xxxl = 80px
 */
var Spacing = {
  xxxs: '0.25rem',
  xxs: '0.5rem',
  xs: '0.75rem',
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
  xl: '2.5rem',
  xxl: '4rem',
  xxxl: '5rem'
};
var Breakpoint = {
  xs: '35.9375rem',
  sm: '36rem',
  md: '48rem',
  lg: '62rem',
  xl: '75rem'
};
var BreakpointMedia = {
  xs: "@media (max-width: ".concat(Breakpoint.xs, ")"),
  sm: "@media (min-width: ".concat(Breakpoint.sm, ")"),
  md: "@media (min-width: ".concat(Breakpoint.md, ")"),
  lg: "@media (min-width: ".concat(Breakpoint.lg, ")"),
  xl: "@media (min-width: ".concat(Breakpoint.xl, ")")
};
var Gutters = {
  md: Spacing.md,
  sm: Spacing.sm
};
var LineHeight = {
  nospace: 1,
  heading: 1.2,
  body: 1.5
};
var baseFontSize = 16;

// Font size is kept in pixels but converted to rem when used
var fontSize = {
  '1': 12,
  '2': 14,
  '3': 16,
  '4': 18,
  '5': 20,
  '6': 24,
  '7': 28,
  '8': 32,
  '9': 40,
  '10': 48
};



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/objectWithoutProperties-7e1dfdab.esm.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/index-9102c435.esm.js







// remove this once safari support ships
function checkFlexGap() {
  var _flex$parentNode;
  // create flex container with row-gap set
  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex === null || flex === void 0 ? void 0 : (_flex$parentNode = flex.parentNode) === null || _flex$parentNode === void 0 ? void 0 : _flex$parentNode.removeChild(flex);
  return isSupported;
}
function useFlexGap() {
  var [isFlexGapSupported, setIsFlexGapSupported] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (document.documentElement.classList.contains('flexbox-gap')) {
      setIsFlexGapSupported(true);
    } else if (document.documentElement.classList.contains('no-flexbox-gap')) {
      setIsFlexGapSupported(false);
    }
  }, []);
  return isFlexGapSupported;
}
function useFlexGapPolyfill() {
  (0,react.useLayoutEffect)(() => {
    // first check if it's already been run
    if (!document.documentElement.classList.contains('flexbox-gap') && !document.documentElement.classList.contains('no-flexbox-gap')) {
      if (checkFlexGap()) {
        document.documentElement.classList.add('flexbox-gap');
      } else {
        document.documentElement.classList.add('no-flexbox-gap');
      }
    }
  }, []);
}

// reset margin between direct children
// add extra space before headings
var VerticalRhythmWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "VerticalRhythm__VerticalRhythmWrapper",
  componentId: "lui__sc-z5vadw-0"
})(["display:flex;flex-direction:column;gap:var(--gap);align-items:", ";& > *{margin-top:0;margin-bottom:0;}& > .lui-title1:not(:first-child),& > .lui-title2:not(:first-child),& > .lui-subtitle1:not(:first-child),& > .lui-subtitle2:not(:first-child){margin-top:", "px;}.no-flexbox-gap &{gap:initial;margin-top:calc(var(--gap) / -2);margin-bottom:calc(var(--gap) / -2);> *{margin-top:calc(var(--gap) / 2);margin-bottom:calc(var(--gap) / 2);}& > .lui-title1:not(:first-child),& > .lui-title2:not(:first-child),& > .lui-subtitle1:not(:first-child),& > .lui-subtitle2:not(:first-child){margin-top:calc(calc(var(--gap) / 2) + ", "px);}}"], props => props.align === "start" ? "flex-start" : props.align, commons_esm/* spacing.xs */.W0.xs, commons_esm/* spacing.xs */.W0.xs);

// Direct children have margin removed and are spaced out xs
var VerticalRhythm = _ref => {
  var {
    density = 'md',
    align = 'stretch',
    children
  } = _ref;
  useFlexGapPolyfill();
  var isFlexGapSupported = useFlexGap();
  var gap = "".concat(spacing.md, "px");
  if (density === 'sm') {
    gap = "".concat(spacing.sm, "px");
  } else if (density === 'lg') {
    gap = "".concat(spacing.lg, "px");
  }
  var Markup = /*#__PURE__*/jsx(VerticalRhythmWrapper, {
    className: "vertical-rhythm",
    align: align,
    style: {
      '--gap': gap
    },
    children: children
  });
  return !isFlexGapSupported ? /*#__PURE__*/jsx("div", {
    className: "flex-gap-polyfill-wrapper",
    children: Markup
  }) : Markup;
};

var _excluded$4 = ["width", "xgap", "ygap", "gap", "className", "minWidth", "maxWidth"];
var getYSpacing = props => {
  if (props.ygap) {
    return commons_esm/* spacing */.W0[props.ygap];
  }
  if (props.gap) {
    return commons_esm/* spacing */.W0[props.gap];
  }
  return '0';
};
var getXSpacing = props => {
  if (props.xgap) {
    return commons_esm/* spacing */.W0[props.xgap];
  }
  if (props.gap) {
    return commons_esm/* spacing */.W0[props.gap];
  }
  return '0';
};
var getMarginTop = function getMarginTop(direction, start) {
  var isFlexGapSupported = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!isFlexGapSupported) {
    if (start) {
      return (0,styled_components_browser_esm/* css */.iv)(["margin-top:calc(calc(var(--row-gap) / -2) + ", "px);"], commons_esm/* spacing */.W0[start]);
    }
    return "margin-top: calc(var(--row-gap) / -2);";
  }
  return start && direction === 'column' ? (0,styled_components_browser_esm/* css */.iv)(["margin-top:", "px;"], commons_esm/* spacing */.W0[start]) : null;
};
var getMarginBottom = function getMarginBottom(direction, end) {
  var isFlexGapSupported = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!isFlexGapSupported) {
    if (end) {
      return (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:calc(calc(var(--row-gap) / -2) + ", "px);"], commons_esm/* spacing */.W0[end]);
    }
    return "margin-bottom: calc(var(--row-gap) / -2);";
  }
  return end && direction === 'column' ? (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:", "px;"], commons_esm/* spacing */.W0[end]) : null;
};
var getMarginLeft = (direction, start) => {
  return start && direction === 'row' ? (0,styled_components_browser_esm/* css */.iv)(["margin-left:", "px;"], commons_esm/* spacing */.W0[start]) : null;
};
var getMarginRight = (direction, end) => {
  return end && direction === 'row' ? (0,styled_components_browser_esm/* css */.iv)(["margin-right:", "px;"], commons_esm/* spacing */.W0[end]) : null;
};
var getAlign = align => {
  switch (align) {
    case 'center':
      return "center";
    case 'start':
      return 'flex-start';
    case 'end':
      return 'flex-end';
    case 'stretch':
      return 'stretch';
    default:
      return 'flex-start';
  }
};
var getAlignment = props => {
  if (props.align) {
    return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";align-items:", ";"], getAlign(props.align), getAlign(props.align));
  }

  // horizontal spacer
  if (props.direction === 'row') {
    if (props.xalign && props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";align-items:", ";"], getAlign(props.yalign), getAlign(props.xalign));
    }
    if (props.xalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["align-items:", ";justify-content:flex-start;"], getAlign(props.xalign));
    }
    if (props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";"], getAlign(props.yalign));
    } else {
      return "\n        justify-content: flex-start;\n        align-items: flex-start;\n      ";
    }
  } else {
    // vertical spacer
    if (props.xalign && props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";align-items:", ";"], getAlign(props.xalign), getAlign(props.yalign));
    }
    if (props.xalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["justify-content:", ";"], getAlign(props.xalign));
    }
    if (props.yalign) {
      return (0,styled_components_browser_esm/* css */.iv)(["align-items:", ";"], getAlign(props.yalign));
    } else {
      return "\n        justify-content: flex-start;\n        align-items: flex-start;\n      ";
    }
  }
};
var Wrapper$1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Spacer__Wrapper",
  componentId: "lui__sc-n3gfm-0"
})(["display:flex;flex-direction:", ";column-gap:var(--column-gap);row-gap:var(--row-gap);flex-wrap:", ";width:", ";", " ", " ", " ", " ", " ", " ", " .no-flexbox-gap &{gap:initial;margin-left:calc(var(--column-gap) / -2);margin-right:calc(var(--column-gap) / -2);", " ", " > *{margin-top:calc(var(--row-gap) / 2);margin-bottom:calc(var(--row-gap) / 2);margin-left:calc(var(--column-gap) / 2);margin-right:calc(var(--column-gap) / 2);}}"], props => props.$direction, props => props.shouldWrap ? "wrap" : "nowrap", props => props.$width, props => props.minWidth && "min-width: ".concat(props.minWidth, ";"), props => props.maxWidth && "max-width: ".concat(props.maxWidth, ";"), props => getMarginLeft(props.$direction, props.start), props => getMarginRight(props.$direction, props.$end), props => getMarginTop(props.$direction, props.start), props => getMarginBottom(props.$direction, props.$end), props => getAlignment(props.align ? {
  align: props.align,
  direction: props.$direction
} : {
  xalign: props.xalign,
  yalign: props.yalign,
  direction: props.$direction
}), props => getMarginTop(props.$direction, props.start, false), props => getMarginBottom(props.$direction, props.$end, false));
var FlexGapWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Spacer__FlexGapWrapper",
  componentId: "lui__sc-n3gfm-1"
})(["width:", ";"], props => props.$width);
var index_9102c435_esm_Spacer = _ref => {
  var {
      width = '100%',
      xgap,
      ygap,
      gap,
      className,
      minWidth,
      maxWidth
    } = _ref,
    props = objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(_ref, _excluded$4);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  useFlexGapPolyfill();
  var isFlexGapSupported = useFlexGap();
  var direction = 'row';
  var shouldWrap = false;
  if (props !== null && props !== void 0 && props.shouldWrap) {
    shouldWrap = props.shouldWrap;
  } else if (gap) {
    // if we have a gap or both xgap and ygap
    shouldWrap = true;
  } else if (xgap && ygap) {
    shouldWrap = true;
  }

  // if we only have ygap
  if (ygap && !xgap) {
    direction = 'column';
  }

  // or if we have no gap
  if (!xgap && !ygap && !gap) {
    // default to 16
    gap = '16';
  }
  var Markup = /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper$1, index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
    className: className ? "lui-spacer ".concat(className) : "lui-spacer",
    style: {
      '--row-gap': "".concat(getYSpacing(gap ? {
        gap
      } : {
        xgap,
        ygap
      }), "px"),
      '--column-gap': "".concat(getXSpacing(gap ? {
        gap
      } : {
        xgap,
        ygap
      }), "px")
    },
    $direction: direction,
    align: props.align,
    xalign: props.xalign,
    yalign: props.yalign,
    shouldWrap: shouldWrap,
    $end: props.end,
    $width: width && isFlexGapSupported ? width : 'auto',
    minWidth: minWidth,
    maxWidth: maxWidth,
    start: props.start
  }, isFlexGapSupported && globalProps), {}, {
    children: props.children
  }));
  return !isFlexGapSupported ? /*#__PURE__*/(0,jsx_runtime.jsx)(FlexGapWrapper, index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
    className: "flex-gap-polyfill-wrapper",
    $width: width
  }, globalProps), {}, {
    children: Markup
  })) : Markup;
};

var _excluded$3 = (/* unused pure expression or super */ null && (["children"]));
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "lui__sc-1jtonxt-0"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";margin-top:-", ";", "{margin-left:-", ";margin-top:-", ";}> *{padding-left:", ";padding-top:", ";", "{padding-left:", ";padding-top:", ";}}"], Gutters.sm, Gutters.sm, BreakpointMedia.sm, Gutters.md, Gutters.md, Gutters.sm, Gutters.sm, BreakpointMedia.sm, Gutters.md, Gutters.md);
var Grid = _ref => {
  var {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/jsx(StyledGrid, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded$2 = (/* unused pure expression or super */ null && (["children"]));
var SmallScreenGrid = '4';
var LargeScreenGrid = '12';
var calculatePercentage = (partial, total) => "".concat(Number(partial) / Number(total) * 100, "%");
var getWidth = (size, totalColumns) => {
  if (!size) return;
  if (size === 'auto') {
    return 'auto';
  } else {
    return calculatePercentage(size, totalColumns);
  }
};
var StyledGridItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "GridItem__StyledGridItem",
  componentId: "lui__sc-y5ttjj-0"
})(["max-width:100%;width:", ";", " ", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}"], _ref => {
  var {
    xs
  } = _ref;
  return xs ? getWidth(xs, SmallScreenGrid) : '100%';
}, _ref2 => {
  var {
    xs
  } = _ref2;
  return xs ? (0,styled_components_browser_esm/* css */.iv)(["flex:0 0 auto;"]) : (0,styled_components_browser_esm/* css */.iv)(["flex-shrink:0;"]);
}, BreakpointMedia.sm, _ref3 => {
  var {
    sm
  } = _ref3;
  return getWidth(sm, LargeScreenGrid);
}, BreakpointMedia.md, _ref4 => {
  var {
    md
  } = _ref4;
  return getWidth(md, LargeScreenGrid);
}, BreakpointMedia.lg, _ref5 => {
  var {
    lg
  } = _ref5;
  return getWidth(lg, LargeScreenGrid);
}, BreakpointMedia.xl, _ref6 => {
  var {
    xl
  } = _ref6;
  return getWidth(xl, LargeScreenGrid);
});
var GridItem = _ref7 => {
  var {
      children
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded$2);
  return /*#__PURE__*/jsx(StyledGridItem, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded$1 = (/* unused pure expression or super */ null && (["children"]));
var MaxWidths = {
  xxl: '82.5rem',
  // 1320px
  xl: '71.25rem' // 1140px
};

var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Wrapper__StyledWrapper",
  componentId: "lui__sc-5zleyr-0"
})(["max-width:", ";margin-left:auto;margin-right:auto;padding-left:", ";padding-right:", ";@media (min-width:", "){padding-left:", ";padding-right:", ";}"], _ref => {
  var {
    maxWidth
  } = _ref;
  return maxWidth ? MaxWidths[maxWidth] : MaxWidths.xxl;
}, Gutters.sm, Gutters.sm, Breakpoint.sm, Gutters.md, Gutters.md);
var Wrapper = _ref2 => {
  var {
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded$1);
  return /*#__PURE__*/jsx(StyledWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded = (/* unused pure expression or super */ null && (["children"]));
var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Section__StyledSection",
  componentId: "lui__sc-1pbxoat-0"
})(["padding-top:3rem;padding-bottom:3rem;", "{padding-top:4rem;padding-bottom:4rem;}", "{padding-top:6rem;padding-bottom:6rem;}"], BreakpointMedia.sm, BreakpointMedia.lg);
var Section = _ref => {
  var {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(StyledSection, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/typography/dist/commons.esm.js
var dist_commons_esm = __webpack_require__(70757);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/RichText-50b4a7f5.esm.js








var getFontSize = variant => {
  var styles = styleData[variant];
  return styles.fontSize;
};
var getLineHeight = variant => {
  var styles = styleData[variant];
  return styles.lineHeight;
};
var getTextColor = (theme, appearance) => {
  if (appearance) {
    if (appearance === 'error') {
      return theme.color.interaction.error;
    }
    if (appearance === 'subtle') {
      return theme.color.text.subtle;
    }
  }
  return theme.color.text.main;
};
var linkStyle = theme => {
  return {
    textDecoration: 'underline',
    color: theme.color.interaction.main,
    fontFamily: theme.asset.font.body.family,
    '&:hover': {
      textDecoration: 'none'
    }
  };
};
var styleData = {
  display: {
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(36),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[10])
    },
    lineHeight: 1.31
  },
  display1: {
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[9]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[10])
    },
    lineHeight: LineHeight.heading
  },
  display2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[8]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[9])
    },
    lineHeight: LineHeight.heading
  },
  title1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[7]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[8])
    },
    lineHeight: LineHeight.heading
  },
  title2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[6])
    },
    lineHeight: LineHeight.heading
  },
  title3: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[5])
    },
    lineHeight: LineHeight.heading
  },
  title4: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[4])
    },
    lineHeight: LineHeight.heading
  },
  lead1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[5]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[6])
    },
    lineHeight: LineHeight.body
  },
  lead2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[5])
    },
    lineHeight: LineHeight.body
  },
  subtitle1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3])
    },
    lineHeight: LineHeight.body
  },
  subtitle2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.body
  },
  body1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3])
    },
    lineHeight: LineHeight.body
  },
  body2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.body
  },
  detail1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[1])
    },
    lineHeight: LineHeight.body
  },
  detail2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[1])
    },
    lineHeight: LineHeight.body
  },
  overline: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.heading
  },
  button1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3])
    },
    lineHeight: LineHeight.body
  },
  button2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.body
  }
};

var RichText_50b4a7f5_esm_excluded$1 = ["children", "variant", "className"];
var getThemeTextAlignment = themeName => {
  if (themeName === commons_esm/* ThemeNames.Lendi */.hN.Lendi) {
    return 'center';
  }
  return 'left';
};
var checkIsHeading = variant => {
  var headingsVariants = ['display', 'display1', 'display2', 'title1', 'title2', 'title3', 'title4'];
  return headingsVariants.includes(variant);
};
var Component = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Text__Component",
  componentId: "lui__sc-xe5utb-0"
})(_ref => {
  var _theme$name;
  var {
    variant,
    theme,
    align,
    isMobile,
    styleTarget,
    $display,
    appearance,
    isInverse
  } = _ref;
  var fontSizeValue = getFontSize(variant);
  var isHeading = checkIsHeading(variant);
  var hasDesktopFontSize = Object.prototype.hasOwnProperty.call(fontSizeValue, 'desktop');
  var themeName = (_theme$name = theme === null || theme === void 0 ? void 0 : theme.name) !== null && _theme$name !== void 0 ? _theme$name : (0,commons_esm/* getThemeName */.Yo)(); // fallback to old getTheme function when latest Theme not being used. To be removed in next major

  var styleObj = {
    margin: 0,
    display: $display !== null && $display !== void 0 ? $display : 'block',
    fontFamily: isHeading ? theme.asset.font.heading.family : theme.asset.font.body.family,
    fontWeight: (0,dist_commons_esm/* default */.Z)(variant, 'fontWeight'),
    textAlign: align !== null && align !== void 0 ? align : getThemeTextAlignment(themeName),
    color: isInverse ? theme.color.text.inverse : getTextColor(theme, appearance),
    fontSize: fontSizeValue.mobile,
    lineHeight: getLineHeight(variant),
    a: linkStyle(theme)
  };
  if (variant === 'overline') {
    styleObj = Object.assign({
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }, styleObj);
  }
  if (hasDesktopFontSize && !isMobile) {
    styleObj = Object.assign({
      [BreakpointMedia.sm]: {
        fontSize: fontSizeValue.desktop
      }
    }, styleObj);
  }
  if (styleTarget) {
    return {
      [styleTarget]: styleObj
    };
  }
  return styleObj;
});
var RichText_50b4a7f5_esm_Text = _ref2 => {
  var {
      children,
      variant = 'body1',
      className
    } = _ref2,
    props = objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(_ref2, RichText_50b4a7f5_esm_excluded$1);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var textVariantClass;
  switch (variant) {
    case 'display':
      textVariantClass = 'lui-display';
      break;
    case 'display1':
      textVariantClass = 'lui-display1';
      break;
    case 'display2':
      textVariantClass = 'lui-display2';
      break;
    case 'title1':
      textVariantClass = 'lui-title1';
      break;
    case 'title2':
      textVariantClass = 'lui-title2';
      break;
    case 'title3':
      textVariantClass = 'lui-title3';
      break;
    case 'title4':
      textVariantClass = 'lui-title4';
      break;
    case 'lead1':
      textVariantClass = 'lui-lead1';
      break;
    case 'lead2':
      textVariantClass = 'lui-lead2';
      break;
    case 'subtitle1':
      textVariantClass = 'lui-subtitle1';
      break;
    case 'subtitle2':
      textVariantClass = 'lui-subtitle2';
      break;
    case 'body1':
      textVariantClass = 'lui-body1';
      break;
    case 'body2':
      textVariantClass = 'lui-body2';
      break;
    case 'button1':
      textVariantClass = 'lui-button1';
      break;
    case 'button2':
      textVariantClass = 'lui-button2';
      break;
    case 'detail1':
      textVariantClass = 'lui-detail1';
      break;
    case 'detail2':
      textVariantClass = 'lui-detail2';
      break;
    case 'overline':
      textVariantClass = 'lui-overline';
      break;
    default:
      textVariantClass = 'lui-body1';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
    id: props.id,
    className: className ? "".concat(className, " ").concat(textVariantClass) : textVariantClass,
    as: props.tag,
    variant: variant,
    align: props.align,
    appearance: props.appearance,
    isMobile: props.isMobile,
    htmlFor: props.for,
    $display: props.display,
    role: props.role,
    isInverse: props.isInverse
  }, globalProps), {}, {
    children: children
  }));
};

var Paragraph = (0,styled_components_browser_esm/* default */.ZP)(RichText_50b4a7f5_esm_Text).withConfig({
  displayName: "Paragraph",
  componentId: "lui__sc-iqzapc-0"
})(_ref => {
  var {
    theme
  } = _ref;
  return {
    a: linkStyle(theme)
  };
});
var P = _ref2 => {
  var {
    appearance,
    variant,
    children
  } = _ref2;
  return /*#__PURE__*/jsx(Paragraph, {
    variant: variant !== null && variant !== void 0 ? variant : 'body1',
    tag: "p",
    appearance: appearance,
    children: children
  });
};

var A = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Link__A",
  componentId: "lui__sc-1u7drzy-0"
})(["", ""], _ref => {
  var {
    theme
  } = _ref;
  return linkStyle(theme);
});

var RichText_50b4a7f5_esm_excluded = (/* unused pure expression or super */ null && (["children", "textSize"]));
var StyledRichText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RichText__StyledRichText",
  componentId: "lui__sc-nganh6-0"
})(["font-size:", ";line-height:", ";color:", ";", "{font-size:", ";}> *{font-family:", ";font-weight:", ";font-size:1em;margin-bottom:0;margin-top:0;}> * + *{margin-top:", ";", "{margin-top:", ";}}> * li{margin-top:0.5em;}> * + h1,> * + h2,> * + div,> div + *{margin-top:", ";}> h1 + *,> h2 + *{margin-top:", ";}> h3 + *,> h4 + *{margin-top:", ";}> * + h3,> * + h4{margin-top:", ";}> h1,> h2,> h3,> h4{font-family:", ";line-height:", ";font-weight:", ";color:", ";}> h1{font-size:", ";", ";}> h2{font-size:", ";", ";}> h3{font-size:", ";}> h4{font-size:", ";}> a,li > a,p > a{", ";}"], (0,commons_esm/* pxToRem */.Q1)(baseFontSize), styleData.body1.lineHeight, _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.subtle;
}, BreakpointMedia.sm, _ref2 => {
  var {
    textSize
  } = _ref2;
  return textSize === 'lg' && (0,commons_esm/* pxToRem */.Q1)(fontSize[5]);
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.asset.font.body.family;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.asset.font.body.weight;
}, (0,commons_esm/* pxToRem */.Q1)(fontSize[3]), BreakpointMedia.sm, _ref5 => {
  var {
    textSize
  } = _ref5;
  return textSize === 'lg' && (0,commons_esm/* pxToRem */.Q1)(fontSize[5]);
}, (0,commons_esm/* pxToRem */.Q1)(fontSize[10]), (0,commons_esm/* pxToRem */.Q1)(fontSize[6]), (0,commons_esm/* pxToRem */.Q1)(fontSize[5]), (0,commons_esm/* pxToRem */.Q1)(fontSize[9]), _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.asset.font.body.family;
}, LineHeight.heading, _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.asset.font.heading.weight;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.color.text.main;
}, styleData.display2.fontSize.mobile, 'desktop' in styleData.display2.fontSize && (0,styled_components_browser_esm/* css */.iv)(["", "{font-size:", ";}"], BreakpointMedia.sm, styleData.display2.fontSize.desktop), styleData.title1.fontSize.mobile, 'desktop' in styleData.title1.fontSize && (0,styled_components_browser_esm/* css */.iv)(["", "{font-size:", ";}"], BreakpointMedia.sm, styleData.title1.fontSize.desktop), styleData.title2.fontSize.mobile, styleData.title3.fontSize.mobile, _ref9 => {
  var {
    theme
  } = _ref9;
  return linkStyle(theme);
});

// Direct children have margin removed and are spaced out xs
var RichText = _ref10 => {
  var {
      children,
      textSize = 'md'
    } = _ref10,
    props = _objectWithoutProperties(_ref10, RichText_50b4a7f5_esm_excluded);
  return /*#__PURE__*/jsx(StyledRichText, _objectSpread2(_objectSpread2({
    textSize: textSize
  }, props), {}, {
    children: children
  }));
};



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/index-83c6f867.esm.js





var colorPrefixes = ['primary', 'secondary', 'tertiary', 'shade', 'info', 'warn', 'error', 'success']; // All available prefix

var capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Custom setThemeName function
 *
 * At runtime, it sets the correct theme to the `document`
 *
 * It replys on `document` `data-attributes` as primary mechanism,
 * ans `sessionStoryage` as a backup mechanism.
 *
 * It works in conjunction with Custom getThemeName from `@lendi-ui/commons`
 *
 * @deprecated Deprecated since 0.2.3. Use SC's Theme instead.
 */
var index_83c6f867_esm_setThemeName = themeName => {
  // Check browser for runtime
  if (isBrowser) {
    var _window;
    // Get `theme` from DOM `data-attributes` if it's already available.
    var dataTheme = (_window = window) === null || _window === void 0 ? void 0 : _window.document.documentElement.getAttribute(themeAttribute);

    // Check `domTheme` against provided runtime `themeName`
    if (dataTheme !== themeName) {
      var _window2;
      // If different, set runtime `themeName` to data-attributes
      (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.document.documentElement.setAttribute(themeAttribute, themeName);

      // If different, set runtime `themeName` to sessionStorage
      try {
        var themeValue = JSON.stringify({
          label: capitalizeFirstLetter(themeName),
          value: themeName
        });
        window.sessionStorage.setItem('theme', themeValue);
      } catch (error) {
        // TODO: Report Error
      }
    }
  }
};
var mapToColorsLegacyFormat = colorToken => {
  var colors = {};
  var categories = Object.keys(colorToken);
  var shouldInclude = category => colorPrefixes.includes(category);
  categories.filter(shouldInclude).map(category => {
    var transparencies = Object.keys(colorToken[category]);
    transparencies.map(transparency => {
      colors = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, colors), {}, {
        ["".concat(category, ".").concat(transparency)]: colorToken[category][transparency]
      });
    });
  });
  return colors;
};

var tokens$3 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'Cabin', sans-serif",
				metrics: {
					familyName: "Cabin",
					capHeight: 1400,
					ascent: 1930,
					descent: -500,
					lineGap: 0,
					unitsPerEm: 2000
				}
			},
			body: {
				weight: 400,
				family: "'Open Sans', sans-serif",
				metrics: {
					familyName: "Open Sans",
					capHeight: 1462,
					ascent: 2189,
					descent: -600,
					lineGap: 0,
					unitsPerEm: 2048
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		primary: {
			"25": "#f2fbfa",
			"50": "#e5f8f6",
			"100": "#ccf2ed",
			"200": "#99e5db",
			"300": "#66d9c9",
			"400": "#32ccb7",
			"500": "#00c0a5",
			"600": "#329984",
			"700": "#007363",
			"800": "#004c42",
			"900": "#002621",
			"950": "#001310"
		},
		secondary: {
			"25": "#f2f6f7",
			"50": "#e6eef0",
			"100": "#cedee1",
			"200": "#9ebdc4",
			"300": "#6d9ca7",
			"400": "#3d7a8a",
			"500": "#0d5a6d",
			"600": "#0a4857",
			"700": "#073641",
			"800": "#05242b",
			"900": "#021215",
			"950": "#01080a"
		},
		tertiary: {
			"25": "#fff7f7",
			"50": "#fff0ef",
			"100": "#ffe2df",
			"200": "#ffc5c0",
			"300": "#ffa9a1",
			"400": "#ff8c82",
			"500": "#ff7063",
			"600": "#cc594f",
			"700": "#99433b",
			"800": "#662c27",
			"900": "#331613",
			"950": "#190b09"
		},
		shade: {
			"0": "#ffffff",
			"25": "#f8f8f8",
			"50": "#f1f1f1",
			"100": "#e3e3e3",
			"200": "#c8c8c8",
			"300": "#adadad",
			"400": "#929292",
			"500": "#777777",
			"600": "#5f5f5f",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#171717",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#474747",
			subtle: "#5f5f5f",
			inverse: "#ffffff",
			contrast: "#0d5a6d"
		},
		interaction: {
			main: "#00c0a5",
			subtle: "#ffffff",
			contrast: "#00c0a5",
			emphasis: "#ff7063",
			disabled: "#474747",
			success: "#2cac41",
			error: "#ff282f"
		},
		fill: {
			main: "#ffffff",
			selected: "#e5f8f6",
			disabled: "#f8f8f8",
			accent: "#00c0a5",
			contrast: "#0d5a6d"
		},
		background: {
			page: "#f8f8f8",
			container: "#ffffff",
			surface: "#e3e3e3",
			emphasis: "#f1f1f1"
		},
		border: {
			container: "#e3e3e3",
			divider: "#adadad",
			dividerEmphasis: "#2f2f2f",
			interaction: {
				"default": "#c8c8c8",
				hover: "#0d5a6d",
				selected: "#00c0a5",
				focus: "#3f86f7"
			}
		},
		buttonFill: {
			primary: {
				"default": "#00c0a5",
				hover: "#32ccb7",
				focus: "#329984",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			primaryInverse: {
				"default": "#ff7063",
				hover: "#ffffff",
				focus: "#ff7063",
				disabled: "#f8f8f8",
				pressed: "#ff7063"
			},
			secondary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#e5f8f6"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#ffffff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#e5f8f6"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#ff7063",
				focused: "#ffffff",
				disabled: "#474747",
				pressed: "#ffffff"
			},
			secondary: {
				"default": "#00c0a5",
				hover: "#00c0a5",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focused: "#ffffff",
				disabled: "#ffffff",
				pressed: "#329984"
			},
			text: {
				"default": "#00c0a5",
				hover: "#00c0a5",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			primaryInverse: {
				pressed: "#ff7063",
				"default": "#ff7063",
				hover: "#ffffff",
				focus: "#ff7063",
				disabled: "#474747"
			},
			secondary: {
				"default": "#00c0a5",
				hover: "#32ccb7",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#329984"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$3 = 'lendi';

/**
 * @deprecated Use tokens instead
 */
var typography$2 = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens$3.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens$3.asset.font.body.family
  }
};

/**
 * @deprecated Use `theme.name` instead
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * const themeName = theme.name;
 */
var logo$1 = {
  logoName: 'LendiLogo'
};
var borderRadius$1 = '6px';

/**
 * @deprecated Use `theme.color.xxx.yyy` instead. Will be removed in future major release.
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * theme.color.interaction.main;
 */
// @ts-expect-error
var colors$1 = mapToColorsLegacyFormat(tokens$3.color);
var index_83c6f867_esm_theme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
  typography: typography$2,
  colors: colors$1,
  logo: logo$1,
  borderRadius: borderRadius$1
}, tokens$3), {}, {
  name: themeName$3
});

var tokens$2 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'F37 Bolton', Helvetica, Arial, sans-serif",
				metrics: {
					fontFamily: "F37 Bolton",
					capHeight: 717,
					ascent: 714,
					descent: -286,
					lineGap: 250,
					unitsPerEm: 1000
				}
			},
			body: {
				weight: 400,
				family: "'F37 Bolton', Helvetica, Arial, sans-serif",
				metrics: {
					fontFamily: "F37 Bolton",
					capHeight: 717,
					ascent: 714,
					descent: -286,
					lineGap: 250,
					unitsPerEm: 1000
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		primary: {
			"25": "#e4ffe2",
			"50": "#caffc5",
			"100": "#abfca4",
			"200": "#85f27c",
			"300": "#56d94a",
			"400": "#2ec121",
			"500": "#0ea800",
			"600": "#16860b",
			"700": "#186511",
			"800": "#154311",
			"900": "#0d220b",
			"950": "#0d220b"
		},
		secondary: {
			"25": "#f4f8fe",
			"50": "#eaf1fd",
			"100": "#dae5f9",
			"200": "#c1d2ee",
			"300": "#98aed4",
			"400": "#748eba",
			"500": "#5470a1",
			"600": "#3a5687",
			"700": "#25406e",
			"800": "#142c54",
			"900": "#0e182a",
			"950": "#0e182a"
		},
		tertiary: {
			"25": "#f8f7ff",
			"50": "#f1efff",
			"100": "#e4e1ff",
			"200": "#cdc8ff",
			"300": "#a89ffb",
			"400": "#857ae9",
			"500": "#6458d7",
			"600": "#483bc5",
			"700": "#3b3194",
			"800": "#292363",
			"900": "#161331",
			"950": "#161331"
		},
		lime: {
			"25": "#e4ffe2",
			"50": "#caffc5",
			"100": "#abfca4",
			"200": "#85f27c",
			"300": "#56d94a",
			"400": "#2ec121",
			"500": "#0ea800",
			"600": "#16860b",
			"700": "#186511",
			"800": "#154311",
			"900": "#0d220b"
		},
		navy: {
			"25": "#f4f8fe",
			"50": "#eaf1fd",
			"100": "#dae5f9",
			"200": "#c1d2ee",
			"300": "#98aed4",
			"400": "#748eba",
			"500": "#5470a1",
			"600": "#3a5687",
			"700": "#25406e",
			"800": "#142c54",
			"900": "#0e182a"
		},
		ocean: {
			"25": "#f8f7ff",
			"50": "#f1efff",
			"100": "#e4e1ff",
			"200": "#cdc8ff",
			"300": "#a89ffb",
			"400": "#857ae9",
			"500": "#6458d7",
			"600": "#483bc5",
			"700": "#3b3194",
			"800": "#292363",
			"900": "#161331"
		},
		vermillion: {
			"25": "#fff5f3",
			"50": "#ffe9e5",
			"100": "#ffd8d1",
			"200": "#ffbeb2",
			"300": "#ff9684",
			"400": "#f8715a",
			"500": "#e84f34",
			"600": "#d93013",
			"700": "#a3301c",
			"800": "#6d281c",
			"900": "#361712"
		},
		grey: {
			"25": "#fbfbfc",
			"50": "#f8f8f9",
			"100": "#eff0f3",
			"200": "#dbdee5",
			"300": "#b5bcca",
			"400": "#929cae",
			"500": "#727d92",
			"600": "#556177",
			"700": "#3c475b",
			"800": "#232c3d",
			"900": "#0f141e"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fbfbfc",
			"50": "#f8f8f9",
			"100": "#eff0f3",
			"200": "#dbdee5",
			"300": "#b5bcca",
			"400": "#929cae",
			"500": "#727d92",
			"600": "#556177",
			"700": "#3c475b",
			"800": "#232c3d",
			"900": "#0f141e",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#0f141e",
			subtle: "#3c475b",
			contrast: "#142c54",
			inverse: "#ffffff",
			"default": "#0f141e"
		},
		interaction: {
			main: "#0ea800",
			subtle: "#ffffff",
			contrast: "#0ea800",
			emphasis: "#d93013",
			disabled: "#929cae",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#142c54",
			accent: "#0ea800",
			selected: "#eaf1fd",
			disabled: "#f8f8f9"
		},
		background: {
			page: "#fbfbfc",
			container: "#ffffff",
			surface: "#eff0f3",
			emphasis: "#f8f8f9"
		},
		border: {
			container: "#dbdee5",
			divider: "#eff0f3",
			dividerEmphasis: "#0f141e",
			interaction: {
				"default": "#727d92",
				hover: "#3c475b",
				focus: "#5e72ff",
				selected: "#142c54"
			}
		},
		buttonFill: {
			primary: {
				"default": "#0ea800",
				hover: "#2ec121",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#16860b"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e4ffe2",
				focus: "#ffffff",
				disabled: "#f8f8f9",
				pressed: "#caffc5"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondary: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focused: "#ffffff",
				disabled: "#929cae",
				pressed: "#ffffff"
			},
			text: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focused: "#ffffff",
				disabled: "#929cae",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#0ea800",
				hover: "#2ec121",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#16860b"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e4ffe2",
				focus: "#ffffff",
				disabled: "#f8f8f9",
				pressed: "#caffc5"
			},
			secondary: {
				"default": "#0ea800",
				hover: "#0ea800",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondaryInverse: {
				"default": "#ffffff",
				focus: "#ffffff",
				hover: "#ffffff",
				pressed: "#ffffff",
				disabled: "#929cae"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$2 = 'domain';

/**
 * @deprecated Use tokens instead
 */
var typography$1 = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens$2.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens$2.asset.font.body.family
  }
};

/**
 * @deprecated Use `theme.name` instead
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * const themeName = theme.name;
 */
var logo = {
  logoName: 'DomainLogo'
};
var borderRadius = '3px';

/**
 * @deprecated Use `theme.color.xxx.yyy` instead. Will be removed in future major release.
 * @example
 * const theme = useTheme();
 * theme.color.interaction.main;
 */
// @ts-expect-error
var colors = mapToColorsLegacyFormat(tokens$2.color);

/**
 * @since 9.2.3
 */

var index_83c6f867_esm_domainTheme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
  typography: typography$1,
  colors,
  logo,
  borderRadius
}, tokens$2), {}, {
  name: themeName$2
});

var tokens$1 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'Cabin', sans-serif",
				metrics: {
					familyName: "Cabin",
					capHeight: 1400,
					ascent: 1930,
					descent: -500,
					lineGap: 0,
					unitsPerEm: 2000
				}
			},
			body: {
				weight: 400,
				family: "'Open Sans', sans-serif",
				metrics: {
					familyName: "Open Sans",
					capHeight: 1462,
					ascent: 2189,
					descent: -600,
					lineGap: 0,
					unitsPerEm: 2048
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		tiber: {
			"25": "#f0fafc",
			"50": "#e0f5fa",
			"100": "#cdedf4",
			"200": "#b0dce6",
			"300": "#85becb",
			"400": "#61a1b0",
			"500": "#428594",
			"600": "#296a79",
			"700": "#15505d",
			"800": "#083742",
			"900": "#091d21"
		},
		turquoise: {
			"25": "#dbfffa",
			"50": "#b7fff5",
			"100": "#8efced",
			"200": "#60f1dd",
			"300": "#2bd9c2",
			"400": "#00c0a5",
			"500": "#0ba08b",
			"600": "#128071",
			"700": "#146056",
			"800": "#12403a",
			"900": "#0b201d"
		},
		lagoon: {
			"25": "#e7faff",
			"50": "#cff5ff",
			"100": "#b3ebfb",
			"200": "#8fdbf0",
			"300": "#60bdd7",
			"400": "#39a1be",
			"500": "#1987a5",
			"600": "#006e8c",
			"700": "#0b5569",
			"800": "#0f3a46",
			"900": "#0b1e23"
		},
		coral: {
			"25": "#fff6f5",
			"50": "#ffebe9",
			"100": "#ffdad7",
			"200": "#ffc0ba",
			"300": "#ff978d",
			"400": "#ff7063",
			"500": "#d45e54",
			"600": "#aa4c44",
			"700": "#803a34",
			"800": "#552723",
			"900": "#2b1412"
		},
		grey: {
			"25": "#fafafa",
			"50": "#f5f5f5",
			"100": "#ececec",
			"200": "#dcdcdc",
			"300": "#bfbfbf",
			"400": "#a1a1a1",
			"500": "#838383",
			"600": "#656565",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#181818"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fafafa",
			"50": "#f5f5f5",
			"100": "#ececec",
			"200": "#dcdcdc",
			"300": "#bfbfbf",
			"400": "#a1a1a1",
			"500": "#838383",
			"600": "#656565",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#181818",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#181818",
			subtle: "#474747",
			contrast: "#083742",
			inverse: "#ffffff"
		},
		interaction: {
			main: "#006e8c",
			subtle: "#ffffff",
			contrast: "#0ba08b",
			emphasis: "#ff7063",
			disabled: "#a1a1a1",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#006e8c",
			accent: "#00c0a5",
			selected: "#cff5ff",
			disabled: "#f5f5f5"
		},
		background: {
			page: "#fafafa",
			container: "#ffffff",
			surface: "#ececec",
			emphasis: "#f5f5f5"
		},
		border: {
			container: "#dcdcdc",
			divider: "#ececec",
			dividerEmphasis: "#181818",
			interaction: {
				"default": "#838383",
				hover: "#474747",
				focus: "#5e72ff",
				selected: "#006e8c"
			}
		},
		buttonFill: {
			primary: {
				"default": "#006e8c",
				hover: "#0b5569",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#0f3a46"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e7faff",
				focus: "#ffffff",
				disabled: "#f5f5f5",
				pressed: "#cff5ff"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondary: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#a1a1a1",
				pressed: "#ffffff"
			},
			text: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#a1a1a1",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#006e8c",
				hover: "#0b5569",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#0f3a46"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e7faff",
				focus: "#ffffff",
				disabled: "#f5f5f5",
				pressed: "#cff5ff"
			},
			secondary: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondaryInverse: {
				"default": "#ffffff",
				focus: "#ffffff",
				hover: "#ffffff",
				pressed: "#ffffff",
				disabled: "#a1a1a1"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$1 = 'lendi-next';
var index_83c6f867_esm_lendiNextTheme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, index_83c6f867_esm_theme), tokens$1), {}, {
  name: themeName$1
});

var tokens = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'TT Commons Pro', sans-serif",
				metrics: {
					familyName: "TT Commons Pro",
					capHeight: 700,
					ascent: 1000,
					descent: -200,
					lineGap: 0,
					unitsPerEm: 1000
				}
			},
			body: {
				weight: 400,
				family: "'Barlow', sans-serif",
				metrics: {
					familyName: "Barlow",
					capHeight: 700,
					ascent: 1000,
					descent: -200,
					lineGap: 0,
					unitsPerEm: 1000
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		purple: {
			"25": "#faf3fe",
			"50": "#f3e6fc",
			"100": "#e9d5f7",
			"200": "#d8bbeb",
			"300": "#b791d1",
			"400": "#996db7",
			"500": "#7d4e9c",
			"600": "#633482",
			"700": "#4b1f68",
			"800": "#331745",
			"900": "#1a0d23"
		},
		yellow: {
			"25": "#fffbe9",
			"50": "#fff6d1",
			"100": "#ffefb1",
			"200": "#ffe788",
			"300": "#ffdc51",
			"400": "#ffd11f",
			"500": "#d4b024",
			"600": "#aa8f26",
			"700": "#806d23",
			"800": "#55491b",
			"900": "#2b2610"
		},
		teal: {
			"25": "#ecfffb",
			"50": "#d8fff7",
			"100": "#bffff1",
			"200": "#9dffea",
			"300": "#6eedd1",
			"400": "#45d9ba",
			"500": "#3db59b",
			"600": "#33917d",
			"700": "#286d5e",
			"800": "#1c483e",
			"900": "#0f241f"
		},
		peach: {
			"25": "#fff8f5",
			"50": "#fff0ea",
			"100": "#ffe4d9",
			"200": "#ffd0bc",
			"300": "#ffb18f",
			"400": "#ff9366",
			"500": "#d47b56",
			"600": "#aa6345",
			"700": "#804b34",
			"800": "#553223",
			"900": "#2b1a12"
		},
		grey: {
			"25": "#fcfcf9",
			"50": "#f8f8f6",
			"100": "#f2f2f0",
			"200": "#e4e4e2",
			"300": "#c7c7c5",
			"400": "#ababa9",
			"500": "#8f8f8e",
			"600": "#737372",
			"700": "#575756",
			"800": "#3a3a39",
			"900": "#1d1d1d"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fcfcf9",
			"50": "#f8f8f6",
			"100": "#f2f2f0",
			"200": "#e4e4e2",
			"300": "#c7c7c5",
			"400": "#ababa9",
			"500": "#8f8f8e",
			"600": "#737372",
			"700": "#575756",
			"800": "#3a3a39",
			"900": "#1d1d1d",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#1d1d1d",
			subtle: "#575756",
			contrast: "#4b1f68",
			inverse: "#ffffff",
			"default": "#1d1d1d"
		},
		interaction: {
			main: "#4b1f68",
			subtle: "#ffffff",
			contrast: "#4b1f68",
			emphasis: "#ffd11f",
			disabled: "#ababa9",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#4b1f68",
			accent: "#4b1f68",
			selected: "#f3e6fc",
			disabled: "#f8f8f6"
		},
		background: {
			page: "#fcfcf9",
			container: "#ffffff",
			surface: "#f2f2f0",
			emphasis: "#f8f8f6"
		},
		border: {
			container: "#e4e4e2",
			divider: "#f2f2f0",
			dividerEmphasis: "#1d1d1d",
			interaction: {
				"default": "#8f8f8e",
				hover: "#575756",
				focus: "#5e72ff",
				selected: "#4b1f68"
			}
		},
		buttonFill: {
			primary: {
				"default": "#4b1f68",
				hover: "#633482",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#331745"
			},
			primaryInverse: {
				"default": "#ffd11f",
				hover: "#ffdc51",
				focus: "#ffd11f",
				disabled: "#f8f8f6",
				pressed: "#d4b024"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondary: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondaryInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focused: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			},
			text: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			textInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focused: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#4b1f68",
				hover: "#633482",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#331745"
			},
			primaryInverse: {
				"default": "#ffd11f",
				hover: "#ffdc51",
				focus: "#ffd11f",
				disabled: "#f8f8f6",
				pressed: "#d4b024"
			},
			secondary: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondaryInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focus: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName = 'aussie';

/**
 * @deprecated Use tokens instead
 */
var typography = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens.asset.font.body.family
  }
};
var index_83c6f867_esm_aussieTheme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, index_83c6f867_esm_theme), {}, {
  typography
}, tokens), {}, {
  name: themeName
});

// Any cross browser resets should occur here
var index_83c6f867_esm_GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(["html{box-sizing:border-box;font-size:100%;}*,*:before,*:after{box-sizing:inherit;}html,body{margin:0;padding:0;}body{color:", ";font-family:", ";}h1,h2,h3,h4,h5,h6{font-family:", ";font-weight:", ";}input::-ms-clear{display:none;}:root{--lendi-ui-size:14px;}@media (min-width:", "){:root{--lendi-ui-size:16px;}}.sr-only{border:0 !important;clip:rect(1px,1px,1px,1px) !important;clip-path:inset(50%) !important;height:1px !important;overflow:hidden !important;padding:0 !important;position:absolute !important;width:1px !important;white-space:nowrap !important;}.sr-only-focusable:focus,.sr-only-focusable:active{clip:auto !important;clip-path:none !important;height:auto !important;overflow:visible !important;width:auto !important;white-space:normal !important;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.asset.font.body.family;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.asset.font.heading.family;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.asset.font.heading.weight;
}, Breakpoint.sm);

/**
 * useTheme is a custom hook to return theme object.
 *
 * It is natively available in Style Component v5. However since Lendi's using v4, this custom hook is necessary.
 */
var index_83c6f867_esm_useTheme = () => {
  return useContext(ThemeContext);
};



// EXTERNAL MODULE: ../../../node_modules/react-helmet/es/Helmet.js
var es_Helmet = __webpack_require__(74758);
// EXTERNAL MODULE: ../../../node_modules/react-element-to-jsx-string/dist/cjs/index.js
var cjs = __webpack_require__(44782);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/Theme-e539ec04.esm.js










var fallback$2 = "\n  body, p  {\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.6px;\n    word-spacing: -0.25px;\n    visibility: visible;\n    font-weight: 300;\n    font-family: verdana;\n    height: auto;\n  }\n\n  h1, h2, .lui-title2, h3, h4, h5, h6 {\n    line-height: 1.4;\n    letter-spacing: 0px;\n    word-spacing: -1px;\n    visibility: visible;\n    font-weight: 700;\n    height: auto;\n    font-family: Arial;\n  }\n\n  h1, .lui-display {\n    font-size: 30px;\n  }\n\n  h2, .lui-title1 {\n    font-size: 22px;\n  }\n";

var fallback$1 = "\n  body,\n  h4,\n  h5,\n  h6,\n  p,\n  .lui-subtitle1,\n  .lui-subtitle2,\n  .lui-body1,\n  .lui-body2 {\n    font-family: Arial;\n    visibility: visible;\n    letter-spacing: -0.4px;\n    font-weight: 400;\n    word-spacing: 0.4px;\n  }\n\n  h1,\n  .lui-display {\n    font-family: Arial;\n    font-size: 48px;\n    line-height: 1.3;\n    visibility: visible;\n    letter-spacing: -0.85px;\n    word-spacing: -1.65px;\n    font-weight: 700;\n  }\n\n  h2,\n  .lui-title1 {\n    font-family: Arial;\n    font-size: 32px;\n    line-height: 1.2;\n    visibility: visible;\n    letter-spacing: -0.75px;\n    word-spacing: 0.2px;\n    font-weight: 700;\n  }\n\n  h3,\n  .lui-title2 {\n    font-family: Arial;\n    font-size: 24px;\n    line-height: 1.3;\n    visibility: visible;\n    letter-spacing: -0.55px;\n    word-spacing: -0.15px;\n    font-weight: 700;\n  }\n";

var fallback = "\n  body,\n  h4,\n  h5,\n  h6,\n  p,\n  .lui-subtitle1,\n  .lui-subtitle2,\n  .lui-body1,\n  .lui-body2 {\n    font-family: Arial;\n    font-size: 16px;\n    line-height: 1.5;\n    font-weight: 300;\n    letter-spacing: -0.15px;\n    word-spacing: 0.65px;\n    visibility: visible;\n  }\n\n  h1,\n  .lui-display {\n    font-family: Arial;\n    font-size: 46px;\n    line-height: 1.5;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    word-spacing: -1.05px;\n    visibility: visible;\n  }\n\n  h2,\n  .lui-title1 {\n    font-family: Arial;\n    font-size: 31px;\n    line-height: 1.5;\n    font-weight: 700;\n    letter-spacing: -0.3px;\n    word-spacing: -0.9px;\n    visibility: visible;\n  }\n\n  .lui-title2 {\n    font-family: Arial;\n    font-size: 22px;\n    line-height: 1.4;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n    word-spacing: 0.2px;\n    visibility: visible;\n  }\n";

// All CDN assets can be found in the /public folder in this repo
var config = {
  lendi: {
    fontFamilies: ['Open Sans', 'Cabin'],
    fallback: fallback$2,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap",
      rel: "stylesheet"
    }, "lendi")]
  },
  'lendi-next': {
    // ^^ duplicate of lendi above ^^, but ts complains if we don't redeclare it here
    fontFamilies: ['Open Sans', 'Cabin'],
    fallback: fallback$2,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap",
      rel: "stylesheet"
    }, "lendi")]
  },
  domain: {
    fontFamilies: ['F37 Bolton'],
    fallback: fallback,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://lendi.style/font-face/domain.css",
      rel: "stylesheet"
    }, "domain")]
  },
  aussie: {
    fontFamilies: ['Barlow', 'TT Commons Pro'],
    fallback: fallback$1,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap",
      rel: "stylesheet"
    }, "aussie-google"), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://lendi.style/font-face/aussie.css",
      rel: "stylesheet"
    }, "aussie")]
  }
};
var FontComponent = _ref => {
  var {
    children,
    disableFallbackFonts = false,
    themeName
  } = _ref;
  var currentThemeConfig = config[themeName];
  var [brandFontLoaded, setBrandFontLoaded] = useState(false);
  useEffect(() => {
    if (!brandFontLoaded && 'fonts' in document) {
      document.fonts.onloadingdone = fontFaceSetEvent => {
        var _fontFaceSetEvent$ret;
        setBrandFontLoaded((_fontFaceSetEvent$ret = fontFaceSetEvent === null || fontFaceSetEvent === void 0 ? void 0 : fontFaceSetEvent.returnValue) !== null && _fontFaceSetEvent$ret !== void 0 ? _fontFaceSetEvent$ret : true);
      };
      return;
    }
    setBrandFontLoaded(true);
  }, [brandFontLoaded]);
  var FontDetector = () => {
    var fontFamilies = currentThemeConfig.fontFamilies;
    if (brandFontLoaded) {
      return null;
    }
    return /*#__PURE__*/jsx(VisuallyHidden, {
      "aria-hidden": "true",
      children: fontFamilies.map((fontFamily, index) => /*#__PURE__*/jsx("span", {
        style: {
          fontFamily
        },
        children: "\xA0"
      }, index))
    });
  };
  var fontLinks = currentThemeConfig.brandFontFace.map(fontFace => reactElementToJSXString(fontFace)).join();
  var useFallbackFonts = !brandFontLoaded && !disableFallbackFonts;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Helmet, {
      children: [/*#__PURE__*/jsx("link", {
        rel: "preconnect",
        href: "https://lendi.style/",
        crossOrigin: "true"
      }), /*#__PURE__*/jsx("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
      }), /*#__PURE__*/jsx("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "true"
      }), currentThemeConfig.brandFontFace.map(fontFace => fontFace), useFallbackFonts && /*#__PURE__*/jsx("style", {
        children: currentThemeConfig === null || currentThemeConfig === void 0 ? void 0 : currentThemeConfig.fallback
      }), /*#__PURE__*/jsx("noscript", {
        children: fontLinks
      })]
    }), children, /*#__PURE__*/jsx(FontDetector, {})]
  });
};
var Font = (/* unused pure expression or super */ null && (FontComponent));

var FaviconComponent = _ref => {
  var _favicons$themeName;
  var {
    themeName
  } = _ref;
  var cdnLink = getCDNLink();
  var favicons = {
    lendi: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon.ico?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: ''
    }, {
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon-32x32.png?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: 'image/png'
    }],
    'lendi-next': [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon.ico?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: ''
    }, {
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon-32x32.png?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: 'image/png'
    }],
    domain: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/domain/favicon.icon"),
      type: ''
    }, {
      rel: 'shortcut icon',
      href: "".concat(cdnLink, "/favicons/domain/favicon.icon"),
      type: ''
    }, {
      rel: 'icon',
      sizes: '16x16',
      href: "".concat(cdnLink, "/favicons/domain/16x16.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '32x32',
      href: "".concat(cdnLink, "/favicons/domain/32x32.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '192x192',
      href: "".concat(cdnLink, "/favicons/domain/192x192.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '512x512',
      href: "".concat(cdnLink, "/favicons/domain/512x512.png"),
      type: 'image/png'
    }, {
      rel: 'apple-touch-icon-precomposed',
      href: "".concat(cdnLink, "/favicons/domain/apple-touch-icon.png"),
      type: ''
    }],
    aussie: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/aussie/favicon.ico"),
      type: ''
    }, {
      rel: 'shortcut icon',
      href: "".concat(cdnLink, "/favicons/aussie/favicon.ico"),
      type: ''
    }]
  };
  return /*#__PURE__*/jsx(Helmet, {
    children: (_favicons$themeName = favicons[themeName]) === null || _favicons$themeName === void 0 ? void 0 : _favicons$themeName.map((props, index) => /*#__PURE__*/jsx("link", _objectSpread2({}, props), index))
  });
};
var Favicon = (/* unused pure expression or super */ null && (FaviconComponent));

var LUIProvider = _ref => {
  var {
    children,
    themeName,
    disableFallbackFonts = false
  } = _ref;
  // Run runtime setThemeName to apply theming data attribute
  setThemeName(themeName);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Favicon, {
      themeName: themeName
    }), /*#__PURE__*/jsx(Font, {
      themeName: themeName,
      disableFallbackFonts: disableFallbackFonts,
      children: children
    })]
  });
};

function Theme_e539ec04_esm_select(path, defaultValue) {
  return _ref => {
    var {
      theme
    } = _ref;
    if (!theme) {
      throw new Error('@lendi-ui/theme: Theme not found. Please ensure your components are wrapped in the Theme component e.g. <Theme><App/></Theme>');
    }
    var obj = theme;
    var startIndex = -1;
    var finishIndex = -1;
    do {
      // check if there is a key that matches the remainder of the path
      var restOfPath = path.substr(startIndex + 1);
      if (Object.prototype.hasOwnProperty.call(obj, restOfPath)) {
        return obj[restOfPath];
      }

      // check if there is a key that matches the next part of the path
      finishIndex = path.indexOf('.', startIndex + 1);
      var nextPartOfPath = path.substr(startIndex + 1, finishIndex - startIndex - 1);
      if (finishIndex === -1 || !Object.prototype.hasOwnProperty.call(obj, nextPartOfPath)) {
        if (defaultValue !== undefined) {
          return defaultValue;
        } else {
          throw new Error("@lendi-ui/theme: Could not find a property named \"".concat(path, "\" on the theme."));
        }
      }
      obj = obj[nextPartOfPath];
      startIndex = finishIndex;
    } while (true); // eslint-disable-line no-constant-condition
  };
}

/**
 * To provide the best transition experience, and avoid breaking changes, we’re going to keep the `name` as optional.
 *
 * Meanwhile, `mapThemeNameToLegacyKind` will ensure to correct mapping.
 *
 * We will make `name` mandatory in the next breaking change.
 *
 * @since 0.2.3
 * @param {string} themeName the new ThemeName
 * @return {ThemeMap | undefined} kind the legacy ThemeMap
 *
 * @todo LUI-785 Remove backwards compatibility in next major.
 * @see https://creditandfinance.atlassian.net/browse/LUI-785
 */
var mapThemeNameToLegacyKind = themeName => {
  switch (themeName) {
    case 'lendi':
      return theme;
    case 'domain':
      return domainTheme;
    case 'lendi-next':
      return lendiNextTheme;
    case 'aussie':
      return aussieTheme;
    default:
      return undefined;
  }
};

/**
 * @param {ThemeProps} props
 * @param {string} props.name `lendi`, `domain`, `aussie`, `lendi-next`
 * @param {ThemeMap} props.kind Deprecated. Use `name` instead.
 * @param {boolean} props.disableFallbackFonts Whether you wish to disable fallback fonts.
 * @param {ReactNode} props.children React children
 *
 * @since 0.2.3
 */
var Theme = _ref => {
  var _mapThemeNameToLegacy, _innerKind$name;
  var {
    kind = theme,
    name,
    disableFallbackFonts = false,
    children
  } = _ref;
  var innerKind = (_mapThemeNameToLegacy = mapThemeNameToLegacyKind(name)) !== null && _mapThemeNameToLegacy !== void 0 ? _mapThemeNameToLegacy : kind;
  /**
   * Determine appropriate themeName based on to backwards compatibility
   *
   * If `kind` is provided, use that first, because that's the backwards supported API.
   * Else, if `name` is provided, use that next, because that's the new API.
   *
   * @todo LUI-785 Remove backwards compatibility in next major.
   */
  var themeName = (_innerKind$name = innerKind === null || innerKind === void 0 ? void 0 : innerKind.name) !== null && _innerKind$name !== void 0 ? _innerKind$name : name;
  if (!themeName) return null;

  // Run runtime setThemeName to apply theming data attribute
  setThemeName(themeName);

  /**
   * As part of ThemeV2 & Navbar constraint (use of `window`), the following `isBrowser` check enforces Client Side Rendering.
   * This is a temporary measure, and will be removed in the future once SSR is fully supported.
   * @see [LUI-854](https://creditandfinance.atlassian.net/browse/LUI-854)
   */
  return /*#__PURE__*/jsxs(ThemeProvider, {
    theme: innerKind,
    children: [/*#__PURE__*/jsx(GlobalStyle, {}), /*#__PURE__*/jsx(Favicon, {
      themeName: themeName
    }), /*#__PURE__*/jsx(Font, {
      themeName: themeName,
      disableFallbackFonts: disableFallbackFonts,
      children: isBrowser ? children : ''
    })]
  });
};



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/index.style-741fda20.esm.js


/**
 * This is a 100% duplicate of `@lendi-ui/icon/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
var index_style_741fda20_esm_IconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-1vln477-0"
})(["width:", ";height:", ";vertical-align:middle;display:inline-block;& > svg{fill:", ";width:inherit;height:inherit;}[class$='fillPath']{fill:", ";}"], _ref => {
  var {
    width
  } = _ref;
  return width !== null && width !== void 0 ? width : '1em';
}, _ref2 => {
  var {
    height
  } = _ref2;
  return height !== null && height !== void 0 ? height : '1em';
}, _ref3 => {
  var {
    color
  } = _ref3;
  return color;
}, _ref4 => {
  var {
    color
  } = _ref4;
  return color;
});



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/borders/dist/commons.esm.js
var borders_dist_commons_esm = __webpack_require__(53075);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/depth/dist/commons.esm.js
var depth_dist_commons_esm = __webpack_require__(46706);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/AnchorButton-2afadd26.esm.js














var getIconMargin = props => {
  var marginSize;
  switch (props.size) {
    case 'lg':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(20));
      break;
    case 'sm':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(8));
      break;
    case 'xs':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(6));
      break;
    default:
    case 'md':
      marginSize = "".concat((0,commons_esm/* pxToRem */.Q1)(12));
  }
  return (0,styled_components_browser_esm/* css */.iv)(["", ""], props.position === 'start' ? "margin-right: ".concat(marginSize, ";") : props.position === 'end' ? "margin-left: ".concat(marginSize, ";") : '');
};
var AnchorButton_2afadd26_esm_IconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "lui__sc-1c5jz0y-0"
})(["display:inline-flex;", " ", ""], _ref => {
  var {
    position,
    size
  } = _ref;
  return getIconMargin({
    size,
    position
  });
}, props => props.isLoading && (0,styled_components_browser_esm/* css */.iv)(["visibility:hidden;"]));
var Icon = _ref2 => {
  var {
    isLoading,
    icon,
    position,
    size
  } = _ref2;
  var IconComponent = icon === null || icon === void 0 ? void 0 : icon.component;
  var isSmall = size === 'xs';
  return /*#__PURE__*/jsx(AnchorButton_2afadd26_esm_IconWrapper, {
    size: size,
    position: position,
    isLoading: isLoading,
    "aria-hidden": true,
    children: IconComponent && /*#__PURE__*/jsx(IconComponent, {
      height: isSmall ? '1.43em' : '1.5em',
      width: "auto"
    })
  });
};

var ButtonContent = _ref => {
  var {
    isLoading,
    icon,
    children,
    size
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [icon && icon.position !== 'end' && /*#__PURE__*/jsx(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    }), children && /*#__PURE__*/jsx("span", {
      style: isLoading ? {
        visibility: 'hidden'
      } : undefined,
      children: children
    }), icon && icon.position === 'end' && /*#__PURE__*/jsx(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    })]
  });
};

/**
 * This is a 100% duplicate of `@lendi-ui/icon/spinner`.
 *
 * It is used in LUI Next Button
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SpinnerIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm_IconWrapper, index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.088.584v3c2.96 0 5.062 1.734 6.006 4.014.944 2.28.682 4.99-1.41 7.082-2.093 2.092-4.803 2.354-7.082 1.41-2.28-.944-4.014-3.047-4.014-6.006h-3c0 4.168 2.576 7.415 5.865 8.777 3.289 1.362 7.406.889 10.354-2.058 2.947-2.947 3.42-7.065 2.058-10.354C17.503 3.16 14.256.584 10.088.584z"
      })
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var spin = (0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerIconWrapper = (0,styled_components_browser_esm/* default */.ZP)(SpinnerIcon).withConfig({
  displayName: "indexstyle__SpinnerIconWrapper",
  componentId: "lui__sc-ilwsxi-0"
})(["animation:", " 1.2s linear infinite;display:flex;line-height:0;width:100%;height:100%;svg{fill:currentColor;}"], spin);

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var Spinner = _ref => {
  var {
    variant = 'dark'
  } = _ref;
  var theme = useTheme();
  var color = variant === 'dark' ? theme.color.buttonForeground.default : 'white';
  return /*#__PURE__*/jsx(SpinnerIconWrapper, {
    color: color
  });
};

var BaseButtonStyles = (0,styled_components_browser_esm/* css */.iv)(["display:inline-block;text-align:center;position:relative;transition:background-color 0.2s ease-out,color 0.2s ease-out,box-shadow 0.2s ease-out;cursor:pointer;font-family:", ";font-weight:700;border:solid 2px transparent;:focus-visible{outline:solid 2px ", ";outline-offset:2px;}:disabled{cursor:default;pointer-events:none;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.asset.font.body.family;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.border.interaction.focus;
});
var getButtonSize = props => {
  var _props$minWidth;
  var minWidth;
  var padding;

  /**
   * @todo Tokens: font-size
   */
  var fontSizeValue = props.size === 'xs' ? 14 : 16;
  var lineHeightValue = props.size === 'xs' ? 1.43 : 1.5;
  switch (props.size) {
    case 'lg':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(18), " ").concat((0,commons_esm/* pxToRem */.Q1)(40));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(144);
      break;
    case 'sm':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(6), " ").concat((0,commons_esm/* pxToRem */.Q1)(14));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(90);
      break;
    case 'xs':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(4), " ").concat((0,commons_esm/* pxToRem */.Q1)(10));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(72);
      break;
    default:
    case 'md':
      padding = "".concat((0,commons_esm/* pxToRem */.Q1)(10), " ").concat((0,commons_esm/* pxToRem */.Q1)(22));
      minWidth = (0,commons_esm/* pxToRem */.Q1)(108);
  }
  return (0,styled_components_browser_esm/* css */.iv)(["", ";", ";min-width:", ";padding:", ";border-radius:", ";font-size:", ";line-height:", ";"], props.width ? "width: ".concat(props.width) : '', props.maxWidth ? "max-width: ".concat(props.maxWidth) : '', (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : minWidth, padding, (0,borders_dist_commons_esm/* getRadius */.H5)('button'), (0,commons_esm/* pxToRem */.Q1)(fontSizeValue), lineHeightValue);
};
var getColorStyle = (variant, state) => {
  return (0,styled_components_browser_esm/* css */.iv)(["background-color:", ";color:", ";border-color:", ";"], _ref3 => {
    var {
      theme
    } = _ref3;
    return theme.color.buttonFill[variant][state];
  }, _ref4 => {
    var {
      theme
    } = _ref4;
    return theme.color.buttonForeground[variant][state];
  }, _ref5 => {
    var {
      theme
    } = _ref5;
    return theme.color.buttonBorder[variant][state];
  });
};

//
// OLD LENDI BUTTON STYLES
// This will be removed, this code is here to bridge the gap untill lendi theme is turned off
//
var getOldLendiStyles = (variantName, isInverse) => (0,styled_components_browser_esm/* css */.iv)(["text-transform:uppercase;letter-spacing:1.2px;border-width:1px;", ";&:disabled{opacity:0.4;}&:hover{box-shadow:", ";", ";}&:active{box-shadow:none;}:focus-visible{outline:0;box-shadow:", ",", ";}"], variantName.includes('text') ? "text-decoration: none; " : '', (0,depth_dist_commons_esm/* default */.Z)(4), variantName.includes('text') && !isInverse ? "box-shadow: ".concat((0,depth_dist_commons_esm/* default */.Z)(3)) : '', (0,borders_dist_commons_esm/* getFocusRing */.yb)(), (0,depth_dist_commons_esm/* default */.Z)(2, 'focusRing'));
var StyledButtonBase = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "buttonstyles__StyledButtonBase",
  componentId: "lui__sc-1juyc07-0"
})(["", ";", ";", ""], BaseButtonStyles, props => getButtonSize(props), _ref6 => {
  var {
    isInverse,
    variant
  } = _ref6;
  var variantName = isInverse ? "".concat(variant, "Inverse") : variant;
  return (0,styled_components_browser_esm/* css */.iv)(["", ";", " &:disabled{", ";pointer-events:none;}&:hover{", ";", "}&:focus-visible{", ";", "}&:active{", ";transform:translateY(1px);", "}", ";"], getColorStyle(variantName, 'default'), variantName.includes('text') && "text-decoration: underline;", getColorStyle(variantName, 'disabled'), getColorStyle(variantName, 'hover'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'focus'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'pressed'), variantName.includes('text') && "text-decoration: none;", _ref7 => {
    var {
      theme
    } = _ref7;
    return theme.name === 'lendi' && getOldLendiStyles(variantName, isInverse);
  });
});

var AnchorButton_2afadd26_esm_excluded$1 = (/* unused pure expression or super */ null && (["variant", "width", "size", "ariaExpanded", "ariaLabel", "className", "isInverse", "minWidth", "maxWidth", "isLoading", "isDisabled", "icon", "children", "onPress", "onClick", "type"]));
var Loader = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Button__Loader",
  componentId: "lui__sc-12k3xs9-0"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:flex;width:", ";height:", ";"], _ref => {
  var {
    size
  } = _ref;
  return size === 'xs' ? '1.43em' : '1.5em';
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === 'xs' ? '1.43em' : '1.5em';
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(StyledButtonBase).withConfig({
  displayName: "Button__StyledButton",
  componentId: "lui__sc-12k3xs9-1"
})(["", ";"], _ref3 => {
  var {
    icon
  } = _ref3;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var Button = _ref4 => {
  var {
      variant = 'primary',
      width = 'auto',
      size = 'md',
      ariaExpanded,
      ariaLabel,
      className,
      isInverse,
      minWidth,
      maxWidth,
      isLoading,
      isDisabled,
      icon,
      children,
      onPress,
      onClick,
      type = 'button'
    } = _ref4,
    props = _objectWithoutProperties(_ref4, AnchorButton_2afadd26_esm_excluded$1);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsxs(StyledButton, _objectSpread2(_objectSpread2({
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    className: className,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress,
    variant: variant,
    type: type,
    isLoading: isLoading,
    disabled: isDisabled,
    icon: icon
  }, globalProps), {}, {
    children: [isLoading && /*#__PURE__*/jsxs(Loader, {
      size: size,
      children: [/*#__PURE__*/jsx(Spinner, {
        variant: variant === 'primary' ? 'light' : 'dark'
      }), /*#__PURE__*/jsx("span", {
        className: "sr-only",
        children: "Loading"
      })]
    }), /*#__PURE__*/jsx(ButtonContent, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      children: children
    })]
  }));
};

var AnchorButton_2afadd26_esm_excluded = (/* unused pure expression or super */ null && (["href", "target", "variant", "width", "isInverse", "ariaLabel", "minWidth", "maxWidth", "onPress", "onClick", "children", "className", "icon", "size"]));
var StyledAnchorButton = (0,styled_components_browser_esm/* default */.ZP)(StyledButtonBase).withConfig({
  displayName: "AnchorButton__StyledAnchorButton",
  componentId: "lui__sc-6oc08b-0"
})(["", ";text-decoration:none;"], _ref => {
  var {
    icon
  } = _ref;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var AnchorButton = _ref2 => {
  var {
      href,
      target,
      variant = 'primary',
      width,
      isInverse,
      ariaLabel,
      minWidth,
      maxWidth,
      onPress,
      onClick,
      children,
      className,
      icon,
      size = 'md'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, AnchorButton_2afadd26_esm_excluded);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsx(StyledAnchorButton, _objectSpread2(_objectSpread2({
    as: "a",
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    className: className,
    variant: variant,
    href: href,
    target: target,
    icon: icon,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress
  }, globalProps), {}, {
    children: /*#__PURE__*/jsx(ButtonContent, {
      size: size,
      icon: icon,
      children: children
    })
  }));
};



// EXTERNAL MODULE: ../../../node_modules/cuid/index.js
var node_modules_cuid = __webpack_require__(56219);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/TextField-18fb9ee7.esm.js

















/**
 * This is a 100% duplicate of `@lendi-ui/icon/email`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgEmail(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var InputBaseComponent = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "InputBase__InputBaseComponent",
  componentId: "lui__sc-ncc05m-0"
})(["font-family:", ";font-size:", ";color:", ";background-color:", ";border:", ";border-radius:", ";padding:", ";height:", ";width:100%;&:hover{", ";}&::placeholder{color:", ";}&:focus-visible{outline:0;box-shadow:", ";}&:disabled{background-color:", ";border:1px solid ", ";&::placeholder{color:", ";}}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.asset.font.body.family;
}, (0,commons_esm/* pxToRem */.Q1)(16), _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.main;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.background.container;
}, _ref4 => {
  var {
    validationState,
    theme
  } = _ref4;
  return validationState === 'invalid' ? "2px solid ".concat(theme.color.interaction.error) : "1px solid ".concat(theme.color.border.interaction.default);
}, () => (0,borders_dist_commons_esm/* getRadius */.H5)(), (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(48), _ref5 => {
  var {
    validationState,
    theme
  } = _ref5;
  return validationState !== 'invalid' && "border: 1px solid ".concat(theme.color.border.interaction.hover);
}, _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.color.text.main;
}, (0,borders_dist_commons_esm/* getFocusRing */.yb)(), _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.color.fill.disabled;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.color.interaction.disabled;
}, _ref9 => {
  var {
    theme
  } = _ref9;
  return theme.color.interaction.disabled;
});

/**
 * This is a 100% duplicate of `@lendi-ui/icon/clear`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgClear(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

function TextField_18fb9ee7_esm_useClearAction(onChange, ref, value) {
  var [isCleared, setIsCleared] = useState(false);
  useEffect(() => {
    var inputRef = ref;

    // When the component first renders, check if value is empty
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && inputRef.current.value === '') {
      setIsCleared(true);
    } else if (value === '') {
      setIsCleared(true);
    }

    // When we have cleared, set value for uncontrolled inputs
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && isCleared) {
      inputRef.current.value = '';
    }
  }, [isCleared, ref, value]);
  var clearValue = () => {
    setIsCleared(true);
  };
  var handleChange = e => {
    if (e.target.value === '') {
      setIsCleared(true);
    } else {
      // once a value has been typed, we are no longer clearing
      setIsCleared(false);
    }
    // call the consumer's onChange
    if (onChange) {
      onChange(e);
    }
  };
  return {
    clearValue,
    handleChange,
    isCleared
  };
}

// TODO: this should be our button component
// ^^^ Until Button allows className we can't do that
var ActionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ClearAction__ActionButton",
  componentId: "lui__sc-1cpgla3-0"
})(["position:absolute;right:", ";top:", ";border:0;border-radius:", ";background:none;padding:", ";cursor:pointer;&:focus-visible{outline:0;box-shadow:", ";}"], (0,commons_esm/* pxToRem */.Q1)(6), (0,commons_esm/* pxToRem */.Q1)(7), (0,commons_esm/* pxToRem */.Q1)(4), (0,commons_esm/* pxToRem */.Q1)(5), (0,borders_dist_commons_esm/* getFocusRing */.yb)());
var TextField_18fb9ee7_esm_ClearActionButton = _ref => {
  var {
    isCleared,
    clearValue
  } = _ref;
  var theme = useTheme();
  if (isCleared) {
    return null;
  } else {
    return /*#__PURE__*/jsx(ActionButton, {
      "aria-label": "Clear",
      type: "button",
      onClick: clearValue,
      children: /*#__PURE__*/jsx(SvgClear, {
        color: theme.color.interaction.contrast,
        width: "24px",
        height: "24px"
      })
    });
  }
};

/**
 * This is a 100% duplicate of `@lendi-ui/icon/error`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgError(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm_IconWrapper, index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      })]
    })
  }));
}

var ErrorIcon = (0,styled_components_browser_esm/* default */.ZP)(SvgError).withConfig({
  displayName: "ErrorText__ErrorIcon",
  componentId: "lui__sc-1xismmk-0"
})(["display:inline;"]);
var TextField_18fb9ee7_esm_ErrorText = _ref => {
  var {
    id,
    text
  } = _ref;
  var theme = useTheme();
  return /*#__PURE__*/jsxs(Spacer, {
    xgap: "xxs",
    children: [/*#__PURE__*/jsx(ErrorIcon, {
      color: theme.color.interaction.error
    }), /*#__PURE__*/jsx(Text, {
      id: id,
      tag: "p",
      variant: "detail1",
      appearance: "error",
      display: "flex",
      children: text
    })]
  });
};

var TextField_18fb9ee7_esm_HelpText = _ref => {
  var {
    id,
    text
  } = _ref;
  return /*#__PURE__*/jsx(Text, {
    id: id,
    tag: "p",
    variant: "detail2",
    appearance: "subtle",
    children: text
  });
};

var TextField_18fb9ee7_esm_FieldLabel = _ref => {
  var {
    tag = 'label',
    label,
    labelSuffix,
    forId
  } = _ref;
  var LabelComponent = label;
  var props = {};
  if (tag === 'label') {
    props = {
      for: forId
    };
  }
  return /*#__PURE__*/jsxs(Text, _objectSpread2(_objectSpread2({
    variant: "subtitle2",
    tag: tag
  }, props), {}, {
    children: [typeof label === 'string' ? label : /*#__PURE__*/jsx(LabelComponent, {}), labelSuffix && " ".concat(labelSuffix)]
  }));
};

var TextField_18fb9ee7_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "value", "defaultValue", "onChange", "validationState", "label", "ariaLabel", "ariaLabelledBy", "labelSuffix", "inlineAction", "autoComplete", "placeholder", "helpText", "errorText", "isDisabled", "isRequired", "maxCharCount", "minCharCount", "width", "minWidth", "maxWidth"]));
var Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "TextField__Input",
  componentId: "lui__sc-1h9z42q-0"
})(["padding-left:", ";padding-right:", ";"], props => props.hasLeftItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16), props => props.hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16));
var TextField_18fb9ee7_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextField__Wrapper",
  componentId: "lui__sc-1h9z42q-1"
})(["position:relative;width:100%;"]);
var LeftIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TextField__LeftIcon",
  componentId: "lui__sc-1h9z42q-2"
})(["position:absolute;top:12px;left:12px;"]);
function TextFieldComponent(_ref, ref) {
  var {
      inputId,
      name,
      variant = 'text',
      value,
      defaultValue,
      onChange,
      validationState,
      label,
      ariaLabel,
      ariaLabelledBy,
      labelSuffix,
      inlineAction,
      autoComplete,
      placeholder,
      helpText,
      errorText,
      isDisabled,
      isRequired,
      maxCharCount,
      minCharCount,
      width = '100%',
      minWidth,
      maxWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, TextField_18fb9ee7_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var {
    isCleared,
    handleChange,
    clearValue
  } = TextField_18fb9ee7_esm_useClearAction(onChange, ref, value);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(TextField_18fb9ee7_esm_FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(TextField_18fb9ee7_esm_Wrapper, {
        children: [variant === 'email' && /*#__PURE__*/jsx(LeftIcon, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgEmail, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(Input, {
          id: inputElId,
          name: name,
          type: variant,
          placeholder: placeholder,
          validationState: validationState,
          value: value && isCleared ? '' : value,
          defaultValue: defaultValue,
          onChange: handleChange,
          ref: ref,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          autoComplete: variant === 'email' ? 'email' : autoComplete,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          hasLeftItem: variant === 'email',
          hasRightItem: !!inlineAction
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(TextField_18fb9ee7_esm_ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(TextField_18fb9ee7_esm_HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(TextField_18fb9ee7_esm_ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var TextField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(TextFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/NumericField-3fdcfbf4.esm.js











/**
 * Remove invalid characters
 */
var removeInvalidChars = function removeInvalidChars(value) {
  if (value) {
    var reg = new RegExp("[^\\d.]", 'gi');
    return value.replace(reg, '');
  }
  return '';
};

/**
 * Remove group separator from value eg. 1,000 > 1000
 */
var removeSeparators = function removeSeparators(value) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var reg = new RegExp(escapeRegExp(separator), 'g');
  return value.replace(reg, '');
};

var NumericField_3fdcfbf4_esm_cleanNumericValue = _ref => {
  var {
    value,
    allowDecimal = false
  } = _ref;
  var groupSeparator = ',';
  var decimalSeparator = '.';
  var decimalsLimit = 2;
  var withoutSeparators = removeSeparators(value, groupSeparator);
  var withoutInvalidChars = removeInvalidChars(withoutSeparators);
  var valueOnly = withoutInvalidChars;

  // This is the part that takes care of trimming the decimals
  if (valueOnly.includes(decimalSeparator)) {
    var [int, decimals] = withoutInvalidChars.split(decimalSeparator);
    var trimmedDecimals = decimals ? decimals.slice(0, decimalsLimit) : decimals;
    var includeDecimals = allowDecimal ? "".concat(decimalSeparator).concat(trimmedDecimals) : '';
    return "".concat(int).concat(includeDecimals);
  }
  return valueOnly;
};

var NumericField_3fdcfbf4_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var NumericField_3fdcfbf4_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "NumericField__Input",
  componentId: "lui__sc-1xofghe-0"
})(["padding-left:", ";padding-right:", ";"], _ref => {
  var {
    variant
  } = _ref;
  return variant && variant === 'dollar' ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
}, _ref2 => {
  var {
    hasRightItem
  } = _ref2;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var NumericField_3fdcfbf4_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NumericField__Wrapper",
  componentId: "lui__sc-1xofghe-1"
})(["position:relative;width:100%;"]);
function NumericFieldComponent(_ref3, ref) {
  var {
      inputId,
      name,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      onValueChange,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref3,
    props = _objectWithoutProperties(_ref3, NumericField_3fdcfbf4_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var handleOnChange = event => {
    var valueOnly = NumericField_3fdcfbf4_esm_cleanNumericValue({
      value: event.target.value
    });
    event.target.value = valueOnly;
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      return;
    }
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(Number(valueOnly), name);
  };
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleOnChange, ref, value === null || value === void 0 ? void 0 : value.toString());
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(NumericField_3fdcfbf4_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(NumericField_3fdcfbf4_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: "[0-9]*",
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value && isCleared ? '' : value,
          defaultValue: defaultValue,
          onChange: handleChange,
          ref: ref,
          hasRightItem: !!inlineAction,
          inputMode: "numeric"
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var NumericField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(NumericFieldComponent)));



// EXTERNAL MODULE: ../../../node_modules/leading-zeroes/dist/index.js
var dist = __webpack_require__(41699);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/DateField-3ef2b542.esm.js






















var DateField_3ef2b542_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "isRequired", "isDisabled", "defaultValue", "value", "onChange", "width", "minWidth", "maxWidth", "minDate", "maxDate"]));
var DateField_3ef2b542_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "DateField__Input",
  componentId: "lui__sc-uzb5tf-0"
})(["--border-radius:", ";border-radius:0;&:first-of-type{border-radius:var(--border-radius) 0 0 var(--border-radius);}&:nth-of-type(2){border-left:none;}&:last-of-type{border-left:none;border-radius:0 var(--border-radius) var(--border-radius) 0;}&:focus-visible{box-shadow:none;}"], _ref => {
  var {
    theme
  } = _ref;
  return (0,borders_dist_commons_esm/* getBorderRadius */.wK)({
    theme: theme.name
  });
});
var DateField_3ef2b542_esm_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(index_9102c435_esm_Spacer).withConfig({
  displayName: "DateField__Wrapper",
  componentId: "lui__sc-uzb5tf-1"
})(["position:relative;"]);
var DateFieldsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DateField__DateFieldsWrapper",
  componentId: "lui__sc-uzb5tf-2"
})(["display:flex;border-radius:", ";box-shadow:", ";&:hover{", "{border-color:", ";}}"], _ref2 => {
  var {
    theme
  } = _ref2;
  return (0,borders_dist_commons_esm/* getBorderRadius */.wK)({
    theme: theme.name
  });
}, props => props.isFocused && (0,borders_dist_commons_esm/* getFocusRing */.yb)(), DateField_3ef2b542_esm_Input, _ref3 => {
  var {
    isDisabled,
    validationState,
    theme
  } = _ref3;
  if (isDisabled) {
    return theme.color.border.container;
  }
  if (validationState === 'invalid') {
    return theme.color.interaction.error;
  } else {
    return theme.color.border.interaction.hover;
  }
});

// Worth moving this when something else needs a fieldset/legend
// but for now its only one :)
var Fieldset = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
  displayName: "DateField__Fieldset",
  componentId: "lui__sc-uzb5tf-3"
})(["margin:0;padding:0;border:none;legend{margin-bottom:", ";}"], (0,commons_esm/* pxToRem */.Q1)(8));
var filterAlphabet = value => value.replace(/\D*/g, '');
function DateFieldComponent(_ref4, ref) {
  var {
      inputId,
      name,
      variant = 'daymonthyear',
      helpText,
      errorText,
      validationState,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      isRequired,
      isDisabled,
      defaultValue,
      value,
      onChange,
      width = '100%',
      minWidth,
      maxWidth,
      minDate,
      maxDate
    } = _ref4,
    props = _objectWithoutProperties(_ref4, DateField_3ef2b542_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var [isFocused, setIsFocused] = useState(false);
  var [day, setDay] = useState('');
  var [month, setMonth] = useState('');
  var [year, setYear] = useState('');
  var [fullDate, setFullDate] = useState('');
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var hasFullDate = fullDate.length > 0;
  var inputRef = ref;
  var yearRef = useRef(null);
  var getRealMonth = dateObject => getMonth(dateObject) + 1;
  var applyDateToState = date => {
    var dateObject = toDate(date);
    if (dateIsValid(dateObject)) {
      setDay(leadingZeroes(getDate(dateObject).toString(), 2));
      setMonth(leadingZeroes(getRealMonth(dateObject).toString(), 2));
      setYear(getYear(dateObject).toString());
    }
  };
  // Used only to initialise the fields with default values
  useEffect(() => {
    var defaultDate = value !== null && value !== void 0 ? value : defaultValue;
    if (defaultDate) {
      applyDateToState(defaultDate);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Manage when to update the full date
  useEffect(() => {
    if (day && month && year) {
      setFullDate("".concat(year, "-").concat(month, "-").concat(day));
    }
  }, [day, month, year]);

  // Manage reporting the full date string & other details back to the consumer:
  // This effectively is a fake onChange handler in place of the lack of a real onChange given the management of 3 different input fields.
  useEffect(() => {
    if (onChange && hasFullDate) {
      // Because I'm doing this outside of a real change event, I have created a fakeEvent to send back to consumer
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      var fakeEvent = {
        target: {
          value: fullDate,
          validity: getValidity(fullDate)
        }
        // using `as` here to bypass typescript's requirements to add missing values in the real event object
      };

      onChange(fakeEvent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFullDate, fullDate]);
  var getValidity = fullDate => {
    var validity = {
      patternMismatch: false,
      rangeOverflow: false,
      rangeUnderflow: false
    };
    if (day.length !== 2 && month.length !== 2 && year.length !== 4) {
      validity.patternMismatch = true;
      return validity;
    }
    var dateInput = toDate(new Date(fullDate));

    // dateIsValid handles dates which exceed days in a month etc.
    if (dateIsValid(dateInput)) {
      var minDateObject = minDate && toDate(minDate);
      var maxDateObject = maxDate && toDate(maxDate);
      var dateIsBeforeIsBeforeMinDate = minDateObject && isBefore(dateInput, minDateObject);
      var dateIsAfterMaxDate = maxDateObject && isAfter(dateInput, maxDateObject);
      if (dateIsBeforeIsBeforeMinDate) {
        validity.rangeUnderflow = true;
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.setCustomValidity('You have entered a date before the accepted minimum date');
      }
      if (dateIsAfterMaxDate) {
        validity.rangeOverflow = true;
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.setCustomValidity('You have exceeded the number of days in this month');
      }
    } else {
      validity.patternMismatch = true;
    }
    return validity;
  };
  var handleChange = type => e => {
    // Ensures there's no alphabet in the inputs
    if (e.target.value !== '') {
      e.target.value = filterAlphabet(e.target.value);
    }
    if (type === 'day') setDay(e.target.value);
    if (type === 'month') setMonth(e.target.value);
    if (type === 'year') setYear(e.target.value);
  };
  var handleOnPaste = e => {
    e.clipboardData.items[0].getAsString(text => {
      // Only really supporting the Queen's date format here
      var parsedDate = text && dateParse(text, 'dd/MM/yyyy', new Date());
      if (parsedDate && dateIsValid(parsedDate)) {
        var _yearRef$current;
        applyDateToState(parsedDate);
        // Once we apply the date to the state, we shift the user to the year input
        // to create the affect of having entered the date manually, and to provide
        // a better flow
        yearRef === null || yearRef === void 0 ? void 0 : (_yearRef$current = yearRef.current) === null || _yearRef$current === void 0 ? void 0 : _yearRef$current.focus();
      }
    });
  };
  var onFocusHandler = () => !isFocused && setIsFocused(true);
  var onBlurHandler = () => isFocused && setIsFocused(false);
  var showDayField = variant === 'daymonthyear';
  var showMonthField = variant === 'daymonthyear' || variant === 'monthyear';
  var showYearField = variant === 'daymonthyear' || variant === 'monthyear';
  return /*#__PURE__*/jsx(Spacer, _objectSpread2(_objectSpread2({
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: /*#__PURE__*/jsxs(Fieldset, {
      disabled: isDisabled,
      children: [label && /*#__PURE__*/jsxs("legend", {
        children: [/*#__PURE__*/jsx(FieldLabel, {
          forId: "",
          tag: "span",
          label: label,
          labelSuffix: labelSuffix
        }), helpText && /*#__PURE__*/jsx("span", {
          className: "sr-only",
          children: helpText
        }), hasError && errorText && /*#__PURE__*/jsx("span", {
          className: "sr-only",
          children: errorText
        })]
      }), /*#__PURE__*/jsxs(DateField_3ef2b542_esm_Wrapper, {
        ygap: "xxs",
        children: [/*#__PURE__*/jsx("input", {
          type: "text",
          value: fullDate,
          ref: inputRef,
          "aria-disabled": true,
          "aria-hidden": true,
          hidden: true,
          disabled: true,
          readOnly: true
        }), /*#__PURE__*/jsxs(DateFieldsWrapper, {
          isFocused: isFocused,
          isDisabled: isDisabled,
          validationState: validationState,
          children: [showDayField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-day"),
                label: "Day"
              })
            }), /*#__PURE__*/jsx(DateField_3ef2b542_esm_Input, {
              id: "".concat(inputElId, "-day"),
              placeholder: "DD",
              inputMode: "numeric",
              pattern: "[0-9]{2}",
              minLength: 2,
              maxLength: 2,
              validationState: validationState,
              value: day,
              required: isRequired,
              onChange: handleChange('day'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-day"
            })]
          }), showMonthField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-month"),
                label: "Month"
              })
            }), /*#__PURE__*/jsx(DateField_3ef2b542_esm_Input, {
              id: "".concat(inputElId, "-month"),
              placeholder: "MM",
              inputMode: "numeric",
              pattern: "[0-9]{2}",
              minLength: 2,
              maxLength: 2,
              validationState: validationState,
              value: month,
              required: isRequired,
              onChange: handleChange('month'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-month"
            })]
          }), showYearField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-year"),
                label: "Year"
              })
            }), /*#__PURE__*/jsx(DateField_3ef2b542_esm_Input, {
              id: "".concat(inputElId, "-year"),
              placeholder: "YYYY",
              inputMode: "numeric",
              pattern: "[0-9]{4}",
              minLength: 4,
              maxLength: 4,
              validationState: validationState,
              value: year,
              required: isRequired,
              onChange: handleChange('year'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-year",
              ref: yearRef
            })]
          })]
        }), helpText && /*#__PURE__*/jsx("div", {
          "aria-hidden": "true",
          children: /*#__PURE__*/jsx(HelpText, {
            id: helpTextId,
            text: helpText
          })
        }), hasError && errorText && /*#__PURE__*/jsx("div", {
          "aria-hidden": "true",
          children: /*#__PURE__*/jsx(ErrorText, {
            id: errorTextId,
            text: errorText
          })
        })]
      })]
    })
  }));
}
var DateField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(DateFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/helpers-183b14df.esm.js

















/**
 * This is a 100% duplicate of `@lendi-ui/icon/Call`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgAttachMoney(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var formatToCurrency = _value => {
  var _value$match;
  var decimalSeparator = '.';
  if (_value === '' || _value === undefined) {
    return '';
  }
  var value = _value;

  // This is somewhat of an overkill way to do currency formatting,
  // but it covers some interesting edge cases like if there's a decimal number (123.10)
  // and you delete the 123, it will magically replace it with a 0 to ensure proper format (0.10)
  var numberFormatter = new Intl.NumberFormat('en-AU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20
  });
  var formatted = numberFormatter.format(Number(value));

  // Include decimal separator if user input ends with decimal separator
  var includeDecimalSeparator = _value.slice(-1) === decimalSeparator ? decimalSeparator : '';
  var [, decimals] = (_value$match = value.match(RegExp('\\d+\\.(\\d+)'))) !== null && _value$match !== void 0 ? _value$match : [];

  // Keep original decimal padding if no decimalScale
  if (decimals && decimalSeparator) {
    if (formatted.includes(decimalSeparator)) {
      formatted = formatted.replace(RegExp("(\\d+)(".concat(escapeRegExp(decimalSeparator), ")(\\d+)"), 'g'), "$1$2".concat(decimals));
    } else {
      formatted = "".concat(formatted).concat(decimalSeparator).concat(decimals);
    }
  }
  return [formatted, includeDecimalSeparator].join('');
};

var padTrimValue = function padTrimValue(value) {
  var decimalSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var decimalScale = 2;
  if (value === '' || value === undefined || !value.includes(decimalSeparator)) {
    return value;
  }
  if (!value.match(/\d/g)) {
    return '';
  }
  var [int, decimals] = value.split(decimalSeparator);
  var newValue = decimals || '';
  if (newValue.length < decimalScale) {
    while (newValue.length < decimalScale) {
      newValue += '0';
    }
  } else {
    newValue = newValue.slice(0, decimalScale);
  }
  return "".concat(int).concat(decimalSeparator).concat(newValue);
};

var helpers_183b14df_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "onBlur", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var helpers_183b14df_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "DollarField__Input",
  componentId: "lui__sc-1g3sog3-0"
})(["padding-left:", ";padding-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(46), _ref => {
  var {
    hasRightItem
  } = _ref;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var helpers_183b14df_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DollarField__Wrapper",
  componentId: "lui__sc-1g3sog3-1"
})(["position:relative;width:100%;"]);
var LeftInputFieldIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DollarField__LeftInputFieldIconWrapper",
  componentId: "lui__sc-1g3sog3-2"
})(["position:absolute;top:12px;left:12px;"]);
function DollarFieldComponent(_ref2, ref) {
  var {
      inputId,
      name,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value: userValue,
      defaultValue,
      onChange,
      onValueChange,
      onBlur,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref2,
    props = _objectWithoutProperties(_ref2, helpers_183b14df_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();

  // This is of course against hook rules, but in order for cursor tracking to work,
  // we must always have a valid ref to the input available
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var inputRef = ref !== null && ref !== void 0 ? ref : useRef(null);
  var initialStateValue = defaultValue !== undefined ? formatToCurrency(String(defaultValue)) : userValue !== undefined ? formatToCurrency(String(userValue)) : '';
  var [stateValue, setStateValue] = useState(initialStateValue);
  var [dirty, setDirty] = useState(false);
  var [cursor, setCursor] = useState(0);
  var processValue = (value, selectionStart, name) => {
    setDirty(true);
    var valueOnly = cleanNumericValue({
      value,
      allowDecimal: true
    });
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      setStateValue('');
      return;
    }
    if (maxCharCount && valueOnly.length > maxCharCount) {
      return;
    }
    if (valueOnly === '.') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      setStateValue(valueOnly);
      return;
    }
    var formatted = formatToCurrency(valueOnly);
    if (selectionStart !== undefined && selectionStart !== null) {
      // Prevent cursor jumping
      var newCursor = selectionStart + (formatted.length - value.length) || 0;
      var isNegative = Math.sign(newCursor) < 0;
      setCursor(isNegative ? 0 : newCursor);
    }
    setStateValue(formatted);
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(valueOnly, name);
  };
  var handleOnChange = event => {
    event.persist();
    var {
      target: {
        value,
        selectionStart
      }
    } = event;
    processValue(value, selectionStart);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };
  var handleOnKeyUp = event => {
    var {
      key,
      currentTarget: {
        selectionStart
      }
    } = event;
    if (key !== 'ArrowUp' && key !== 'ArrowDown') {
      if (selectionStart && selectionStart > stateValue.length) {
        if (inputRef && typeof inputRef === 'object' && inputRef.current) {
          var newCursor = stateValue.length;
          inputRef.current.setSelectionRange(newCursor, newCursor);
        }
      }
    }
  };
  var handleOnFocus = event => {
    return stateValue ? stateValue.length : 0;
  };
  var handleOnBlur = event => {
    event.persist();
    var {
      target: {
        value
      }
    } = event;
    if (value) {
      var valueOnly = cleanNumericValue({
        value,
        allowDecimal: true
      });
      if (!valueOnly) {
        setStateValue('');
        return;
      }
      var paddedDecimalsValue = padTrimValue(valueOnly);
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(paddedDecimalsValue, name);
      var formattedValue = formatToCurrency(paddedDecimalsValue);
      setStateValue(formattedValue);
    }
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };
  useEffect(() => {
    // prevent cursor jumping if editing value
    if (dirty && inputRef && typeof inputRef === 'object' && inputRef.current) {
      inputRef.current.setSelectionRange(cursor, cursor);
    }
  }, [stateValue, cursor, inputRef, dirty]);
  var formattedPropsValue = userValue !== undefined ? formatToCurrency(String(userValue)) : undefined;
  var inputValue = formattedPropsValue !== undefined && stateValue !== '.' ? formattedPropsValue : stateValue;
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleOnChange, inputRef, inputValue);
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: validationState === 'invalid' ? 'xxs' : 'xs',
      children: [/*#__PURE__*/jsxs(helpers_183b14df_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(LeftInputFieldIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgAttachMoney, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(helpers_183b14df_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: "[0-9,.]*",
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          onBlur: handleOnBlur,
          onKeyUp: handleOnKeyUp,
          onFocus: handleOnFocus,
          value: inputValue && isCleared ? '' : inputValue,
          onChange: handleChange,
          hasRightItem: !!inlineAction,
          inputMode: "decimal",
          ref: inputRef
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var DollarField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(DollarFieldComponent)));

var dollarToNumber = dollar => parseFloat(dollar === null || dollar === void 0 ? void 0 : dollar.replace(',', ''));



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/PhoneField-4041b0ff.esm.js

















/**
 * This is a 100% duplicate of `@lendi-ui/icon/Call`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgCall(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      })]
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/icon/PhoneAndroid`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgPhoneAndroid(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var PhoneField_4041b0ff_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PhoneFieldstyle__Wrapper",
  componentId: "lui__sc-c2e1lq-0"
})(["position:relative;width:100%;"]);
var PhoneField_4041b0ff_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "PhoneFieldstyle__Input",
  componentId: "lui__sc-c2e1lq-1"
})(["padding-left:", ";padding-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(46), _ref => {
  var {
    hasRightItem
  } = _ref;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var PhoneIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "PhoneFieldstyle__PhoneIconWrapper",
  componentId: "lui__sc-c2e1lq-2"
})(["position:absolute;top:", ";left:", ";"], (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(12));
var MobileIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "PhoneFieldstyle__MobileIconWrapper",
  componentId: "lui__sc-c2e1lq-3"
})(["position:absolute;top:", ";left:", ";"], (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(12));

var getPattern = variant => {
  switch (variant) {
    case 'mobile':
      return "^04{1}[0-9]{2}[0-9]{3}[0-9]{3}$";
    default:
      return "^0{1}[2378]{1}[0-9]{4}[0-9]{4}$";
  }
};

var PhoneField_4041b0ff_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "width", "maxCharCount", "minCharCount", "minWidth", "maxWidth"]));
var PhoneField_4041b0ff_esm_filterAlphabet = value => value.replace(/\D*/g, '');
var handleFormatting = value => {
  // because we handle uncontrolled, this function could receive undefined.
  if (value) {
    return PhoneField_4041b0ff_esm_filterAlphabet(value);
  }
  return value;
};
var PhoneFieldComponent = (_ref, ref) => {
  var {
      inputId,
      name,
      variant,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      width = '100%',
      maxCharCount,
      minCharCount,
      minWidth,
      maxWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, PhoneField_4041b0ff_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();
  var handleValueChange = e => {
    if (e.target.value !== '') {
      var _handleFormatting;
      e.target.value = (_handleFormatting = handleFormatting(e.target.value)) !== null && _handleFormatting !== void 0 ? _handleFormatting : '';
    }
    if (onChange) {
      onChange(e);
    }
  };
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleValueChange, ref, value);
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(PhoneField_4041b0ff_esm_Wrapper, {
        children: [variant === 'mobile' ? /*#__PURE__*/jsx(MobileIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgPhoneAndroid, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }) : /*#__PURE__*/jsx(PhoneIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgCall, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(PhoneField_4041b0ff_esm_Input, {
          id: inputElId,
          name: name,
          type: "tel",
          autoComplete: "tel",
          inputMode: "tel",
          pattern: getPattern(variant),
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value && isCleared ? '' : handleFormatting(value),
          defaultValue: handleFormatting(defaultValue),
          onChange: handleChange,
          ref: ref,
          hasRightItem: !!inlineAction,
          variant: variant
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
};
var PhoneField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(PhoneFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/UnitField-dbabc0ab.esm.js














var UnitField_dbabc0ab_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var getPaddingRight = variant => {
  switch (variant) {
    case 'age':
      return 98;
    case 'years':
      return 70;
    case 'months':
      return 86;
    case 'days':
      return 62;
    case 'percent':
      return 42;
  }
};
var UnitField_dbabc0ab_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "UnitField__Input",
  componentId: "lui__sc-1ywqqq4-0"
})(["padding-right:", ";"], props => "".concat(getPaddingRight(props.variant), "px"));
var UnitLabelWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "UnitField__UnitLabelWrapper",
  componentId: "lui__sc-1ywqqq4-1"
})(["position:absolute;right:1rem;top:50%;transform:translateY(-50%);"]);
var UnitField_dbabc0ab_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "UnitField__Wrapper",
  componentId: "lui__sc-1ywqqq4-2"
})(["position:relative;width:100%;"]);
var getVariantLabel = variant => {
  switch (variant) {
    case 'age':
      return 'years old';
    case 'percent':
      return '%';
    default:
      return variant;
  }
};
var UnitLabel = _ref => {
  var {
    variant
  } = _ref;
  return /*#__PURE__*/jsx(UnitLabelWrapper, {
    "aria-hidden": "true",
    children: /*#__PURE__*/jsx(Text, {
      variant: "subtitle1",
      tag: "span",
      appearance: "subtle",
      children: getVariantLabel(variant)
    })
  });
};
function UnitFieldComponent(_ref2, ref) {
  var {
      inputId,
      name,
      variant,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label: _label,
      labelSuffix,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      onValueChange,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref2,
    props = _objectWithoutProperties(_ref2, UnitField_dbabc0ab_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  var handleOnChange = event => {
    var valueOnly = cleanNumericValue({
      value: event.target.value,
      allowDecimal: variant === 'percent'
    });
    var [, hasDecimals] = valueOnly.split('.');
    event.target.value = valueOnly;
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      return;
    }
    if (valueOnly === '.') {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(undefined, name);
      return;
    }
    if (hasDecimals) {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(parseFloat(valueOnly), name);
      return;
    }
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(Number(valueOnly), name);
  };
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [_label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: () => /*#__PURE__*/jsxs(Fragment, {
        children: [_label, /*#__PURE__*/jsx(VisuallyHidden, {
          children: "(".concat(getVariantLabel(variant), ")")
        })]
      }),
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(UnitField_dbabc0ab_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(UnitField_dbabc0ab_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: variant === 'percent' ? '[0-9.]*' : '[0-9]*',
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value,
          defaultValue: defaultValue,
          onChange: handleOnChange,
          ref: ref,
          inputMode: variant === 'percent' ? 'decimal' : 'numeric',
          variant: variant
        }), /*#__PURE__*/jsx(UnitLabel, {
          variant: variant
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var UnitField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(UnitFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/SelectField-b63d9ad7.esm.js
















/**
 * This is a 100% duplicate of `@lendi-ui/icon/KeyboardArrowDown`.
 *
 * It is used in LUI Next SelectField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgKeyboardArrowDown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm_IconWrapper, index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0-.75h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var SelectField_b63d9ad7_esm_excluded = (/* unused pure expression or super */ null && (["name", "inputId", "validationState", "helpText", "errorText", "placeholder", "label", "ariaLabel", "ariaLabelledBy", "labelSuffix", "isRequired", "isDisabled", "width", "minWidth", "maxWidth", "options", "onChange", "defaultValue", "value"]));
// TODO: if placeholder is active, color should be 600
// prettier-ignore
var Select = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).attrs({
  as: 'select'
}).withConfig({
  displayName: "SelectField__Select",
  componentId: "lui__sc-bl1fdz-0"
})(["appearance:none;display:flex;align-items:center;padding-top:0;padding-bottom:0;padding-right:40px;color:", ";&:disabled{color:", ";}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.subtle;
});
var Arrow = (0,styled_components_browser_esm/* default */.ZP)(SvgKeyboardArrowDown).withConfig({
  displayName: "SelectField__Arrow",
  componentId: "lui__sc-bl1fdz-1"
})(["position:absolute;right:0.75em;top:50%;margin-top:calc(-0.75em + 1px);width:1.5em;height:1.5em;pointer-events:none;"]);
var SelectField_b63d9ad7_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectField__Wrapper",
  componentId: "lui__sc-bl1fdz-2"
})(["position:relative;width:100%;"]);
function SelectFieldComponent(_ref3, ref) {
  var {
      name,
      inputId,
      validationState,
      helpText,
      errorText,
      placeholder,
      label,
      ariaLabel,
      ariaLabelledBy,
      labelSuffix,
      isRequired,
      isDisabled,
      width = '100%',
      minWidth,
      maxWidth,
      options,
      onChange,
      defaultValue,
      value
    } = _ref3,
    props = _objectWithoutProperties(_ref3, SelectField_b63d9ad7_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var selectElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var hasNoValue = defaultValue === undefined && value === undefined;
  var theme = useTheme();
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: selectElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(SelectField_b63d9ad7_esm_Wrapper, {
        children: [/*#__PURE__*/jsxs(Select, {
          name: name,
          id: selectElId,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          onChange: onChange,
          value: onChange && hasNoValue && placeholder ? '' : value,
          defaultValue: !onChange && hasNoValue && placeholder ? '' : defaultValue,
          ref: ref,
          placeholder: placeholder,
          children: [placeholder && /*#__PURE__*/jsx("option", {
            value: "",
            disabled: true,
            hidden: true,
            children: placeholder
          }), options.length > 0 && options.map(option => {
            if ('value' in option) {
              if (option.value === '') {
                throw new Error('value cannot be an empty string');
              }
              return /*#__PURE__*/jsx("option", {
                value: option.value,
                children: option.label
              }, option.value);
            } else if ('header' in option) {
              return /*#__PURE__*/jsx("optgroup", {
                label: option.header,
                children: option.options.map(option => /*#__PURE__*/jsx("option", {
                  value: option.value,
                  children: option.label
                }, option.value))
              }, option.header);
            }
            return null;
          })]
        }), /*#__PURE__*/jsx(Arrow, {
          "aria-hidden": "true",
          color: isDisabled ? theme.color.interaction.disabled : theme.color.interaction.contrast
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var SelectField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SelectFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/node_modules/@lendi/ui/dist/ui.esm.js





































;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/theme/dist/theme.esm.js



/***/ }),

/***/ 4459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Transition; },
/* harmony export */   "jB": function() { return /* binding */ mixin; },
/* harmony export */   "pT": function() { return /* binding */ Fade; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74512);



function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

class Transition extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      mounted: false
    });
    _defineProperty(this, "timeout", null);
    _defineProperty(this, "raf", null);
  }
  static getDerivedStateFromProps(props, state) {
    if (state.mounted === false) {
      if (props.isVisible && props.isActive) {
        return {
          mounted: true,
          state: 'enter'
        };
      }
      if (props.isVisible && !props.isActive) {
        return {
          mounted: true,
          state: 'exit'
        };
      }
      if (!props.isVisible && !props.isActive) {
        return {
          mounted: true,
          state: 'exited' // Skip the exit transition all together
        };
      }

      return {
        mounted: true
      };
    } else {
      if (!props.isActive && (state.state === undefined || state.state === 'enter' || state.state === 'entering' || state.state === 'entered')) {
        return {
          state: 'exit'
        };
      }
      if (props.isActive && (state.state === undefined || state.state === 'exit' || state.state === 'exiting' || state.state === 'exited')) {
        return {
          state: 'enter'
        };
      }
    }
    return null;
  }
  notifyStateChange() {
    var {
      onChangeState
    } = this.props;
    var {
      state
    } = this.state;
    if (onChangeState) {
      onChangeState(state);
    }
  }
  enter() {
    this.notifyStateChange();
    cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => {
      var {
        timeout
      } = this.props;
      clearTimeout(this.timeout);
      this.setState({
        state: 'entering'
      }, () => {
        this.notifyStateChange();
        this.timeout = setTimeout(() => this.setState({
          state: 'entered'
        }, () => this.notifyStateChange()), timeout);
      });
    });
  }
  exit() {
    this.notifyStateChange();
    cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => {
      var {
        timeout
      } = this.props;
      clearTimeout(this.timeout);
      this.setState({
        state: 'exiting'
      }, () => {
        this.notifyStateChange();
        this.timeout = setTimeout(() => this.setState({
          state: 'exited'
        }, () => this.notifyStateChange()), timeout);
      });
    });
  }
  componentDidMount() {
    if (this.state.state === 'enter') {
      setTimeout(() => this.enter(), 0);
    }
    if (this.state.state === 'exit') {
      this.exit();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.state !== 'enter' && this.state.state === 'enter') {
      setTimeout(() => this.enter(), 0);
    }
    if (prevState.state !== 'exit' && this.state.state === 'exit') {
      this.exit();
    }
  }
  componentWillUnmount() {
    cancelAnimationFrame(this.raf);
    clearTimeout(this.timeout);
  }
  render() {
    var {
      shouldMountOnEnter,
      shouldUnmountOnExit,
      children
    } = this.props;
    var {
      state
    } = this.state;
    if (shouldMountOnEnter && state === undefined) {
      return null;
    }
    if (shouldUnmountOnExit && state === 'exited') {
      return null;
    }
    return children(state);
  }
}
var mixin = (state, options) => {
  switch (state) {
    case 'enter':
    case 'entering':
    case 'entered':
    case 'exit':
    case 'exiting':
    case 'exited':
      return options[state];
    default:
      return undefined;
  }
};
var style = (state, options) => {
  switch (state) {
    case 'enter':
    case 'entering':
    case 'entered':
    case 'exit':
    case 'exiting':
    case 'exited':
      return options[state];
    default:
      return undefined;
  }
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded = ["timeout", "children"];
var TIMEOUT = 250;
var STYLES = {
  enter: {
    opacity: '0'
  },
  entering: {
    opacity: '1'
  },
  entered: {
    opacity: '1'
  },
  exit: {
    opacity: '1'
  },
  exiting: {
    opacity: '0'
  }
};
var Fade = props => {
  var {
      timeout: customTimeout,
      children: _children
    } = props,
    transitionProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Transition, _objectSpread2(_objectSpread2({
    timeout: customTimeout !== null && customTimeout !== void 0 ? customTimeout : TIMEOUT
  }, transitionProps), {}, {
    children: state => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      style: _objectSpread2({
        opacity: 0,
        transition: "opacity ".concat(TIMEOUT / 1000, "s")
      }, style(state, STYLES)),
      children: _children
    })
  }));
};




/***/ }),

/***/ 56158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "d1": function() { return /* binding */ body; },
/* harmony export */   "nP": function() { return /* binding */ heading; },
/* harmony export */   "rU": function() { return /* binding */ Link; },
/* harmony export */   "uT": function() { return /* binding */ Body; }
/* harmony export */ });
/* unused harmony exports A, Overline, P, Text, align, default, ellipsis, link, overline, overlineLink */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _lendi_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97049);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74512);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23783);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62792);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84209);
/* harmony import */ var _lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27233);
/* harmony import */ var _lendi_ui_commons_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70757);










function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

var align = alignment => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(alignment, val => val && "text-align: ".concat(val, ";"));
var ellipsis = () => "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";

/**
 * Body Options
 * Note: we recommend using the <Text> component instead
 */

var bodySizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xxs':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.625), ";\n        line-height: calc(14 / 10);\n      ");
    case 'xs':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.75), ";\n        line-height: calc(16 / 12);\n      ");
    case 'sm':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.875), ";\n        line-height: calc(20 / 14);\n      ");
    case 'md':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1), ";\n        line-height: calc(24 / 16);\n      ");
    case 'lg':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1.125), ";\n        line-height: calc(24 / 18);\n      ");
    case 'xl':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1.5), ";\n        line-height: calc(30 / 24);\n      ");
    default:
      return undefined;
  }
});

/**
 * Body mixin
 */
var body = function body() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    color,
    align: align$1,
    size
  } = options;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["", " ", " ", " font-family:", ";"], color && (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_4__.fg)(color), align$1 && align(align$1), size && bodySizeMixin(size), (0,_lendi_ui_commons_typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('body1', 'fontFamily'));
};

/**
 * Body component
 */
var Body = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "Body",
  componentId: "lui__sc-1yhxwuv-0"
})(["", " ", " ", ";"], (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.my)('nil'), body, _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__/* .margin */ .e);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded$2 = ["as", "size"];
var headingSizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xxs':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.875), ";\n        font-weight: 400;\n        line-height: calc(20 / 14);\n      ");
    case 'xs':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1.125), ";\n        font-weight: 400;\n        line-height: calc(24 / 18);\n      ");
    case 'sm':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1.375), ";\n        font-weight: 400;\n        line-height: calc(28 / 22);\n      ");
    case 'md':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1.75), ";\n        font-weight: 400;\n        line-height: calc(32 / 28);\n      ");
    case 'lg':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(2.3125), ";\n        font-weight: 400;\n        line-height: calc(40 / 37);\n      ");
    case 'xl':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(2.875), ";\n        font-weight: 600;\n        line-height: calc(50 / 46);\n      ");
    default:
      return undefined;
  }
});
var heading = options => {
  var {
    color,
    align: align$1,
    size
  } = options;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["", " ", " ", " font-family:", ";"], color && (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_4__.fg)(color), align$1 && align(align$1), headingSizeMixin(size), (0,_lendi_ui_commons_typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('title1', 'fontFamily'));
};
var componentBySize = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xxs':
      return 'h6';
    case 'xs':
      return 'h5';
    case 'sm':
      return 'h4';
    case 'md':
      return 'h3';
    case 'lg':
      return 'h2';
    case 'xl':
      return 'h1';
    default:
      return 'h1';
  }
});

/**
 * Heading Props
 * Note: we recommend using the <Text> component instead
 */

var HeadingTag = _ref => {
  var {
      as,
      size
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$2);
  var Component = as !== null && as !== void 0 ? as : typeof size !== 'object' ? componentBySize(size) : 'h1';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, _objectSpread2({
    size: size
  }, otherProps));
};

/**
 * Heading Component
 * Not recommended: Use <Text> or <P> component instead
 */
var Heading = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(HeadingTag).withConfig({
  displayName: "Heading",
  componentId: "lui__sc-37fddq-0"
})(["", " ", " ", ";"], (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__.my)('nil'), heading, _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__/* .margin */ .e);

var _excluded$1 = ["href", "children", "target", "type"];
/**
 * Link mixin
 */

var link = function link() {
  var {
    color: color$1,
    size
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["", " font-weight:bold;cursor:pointer;text-decoration:underline;color:", ";&:hover,&:focus,&:active{text-decoration:underline;}"], body({
    size
  }), color$1 ? (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_4__/* .color */ .$)(color$1) : 'currentColor');
};

/**
 * Link component
 */
var LinkWrapper$1 = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "Link__LinkWrapper",
  componentId: "lui__sc-7ivhe6-0"
})(["", ";", ";"], link, _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__/* .margin */ .e);
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Link__ButtonWrapper",
  componentId: "lui__sc-7ivhe6-1"
})(["font-size:1em;border:none;padding:0;", ";", ";background-color:inherit;"], link, _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__/* .margin */ .e);
var Link = props => {
  var {
      href,
      children,
      target = '_self',
      type
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded$1);
  if (href) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkWrapper$1, _objectSpread2(_objectSpread2({
      href: href,
      target: target
    }, otherProps), {}, {
      children: children
    }));
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ButtonWrapper, _objectSpread2(_objectSpread2({}, otherProps), {}, {
      type: type,
      children: children
    }));
  }
};

var _excluded = (/* unused pure expression or super */ null && (["href", "children"]));
var overlineSizeMixin = size => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(size, val => {
  switch (val) {
    case 'xxs':
    case 'xs':
    case 'sm':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.625), ";\n        line-height: ").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.625), ";\n        letter-spacing: calc(").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.625), "/10);\n      ");
    case 'md':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.75), ";\n        line-height: ").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.75), ";\n        letter-spacing: calc(").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.75), "/10);\n      ");
    case 'lg':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.875), ";\n        line-height: ").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.875), ";\n        letter-spacing: calc(").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(0.875), "/10);\n      ");
    case 'xl':
      return "\n        font-size: ".concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1), ";\n        line-height: ").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1), ";\n        letter-spacing: calc(").concat((0,_lendi_ui_utils__WEBPACK_IMPORTED_MODULE_6__/* .deriveSize */ .MS)(1), "/10);\n      ");
    default:
      return undefined;
  }
});
/**
 * Overline mixin
 */
var overline = options => {
  var {
    colorScheme,
    size,
    align: align$1
  } = options;
  var color;
  if (colorScheme === 'dark') {
    color = 'shade.0';
  } else {
    color = 'shade.400';
  }
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["display:block;font-family:", ";text-transform:uppercase;font-weight:", ";", " ", " ", " text-decoration:none;"], (0,_lendi_ui_commons_typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('overline', 'fontFamily'), (0,_lendi_ui_commons_typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('overline', 'fontWeight'), overlineSizeMixin(size), align$1 && align(align$1), color && (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_4__.fg)(color));
};

/**
 * Overline Link Mixin
 */
var overlineLink = options => {
  var {
    colorScheme
  } = options;
  var linkColor;
  var stateColor;
  if (colorScheme === 'dark') {
    linkColor = 'primary.200';
    stateColor = 'primary.200';
  } else {
    linkColor = 'primary.500';
    stateColor = 'primary.700';
  }
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["cursor:pointer;", ";text-decoration:none;&:hover{text-decoration:underline;}&:hover,&:focus,&:active{", ";}"], (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_4__.fg)(linkColor), (0,_lendi_ui_color__WEBPACK_IMPORTED_MODULE_4__.fg)(stateColor));
};

/**
 * Overline component
 */
var LinkWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "Overline__LinkWrapper",
  componentId: "lui__sc-1i5xmqs-0"
})(["", " ", " ", ";"], overline, overlineLink, _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__/* .margin */ .e);
var TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Overline__TextWrapper",
  componentId: "lui__sc-1i5xmqs-1"
})(["", ";", ";"], overline, _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_5__/* .margin */ .e);
var Overline = props => {
  var {
      href,
      children
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (href) {
    return /*#__PURE__*/jsx(LinkWrapper, _objectSpread2(_objectSpread2({
      href: href
    }, otherProps), {}, {
      children: children
    }));
  } else {
    return /*#__PURE__*/jsx(TextWrapper, _objectSpread2(_objectSpread2({}, otherProps), {}, {
      children: children
    }));
  }
};

/**
 * @deprecated Importing from '@lendi-ui/typography' is deprecated, import directly from '@lendi/ui' instead.
 * @example import { Text } from '@lendi/ui';
 * @see https://lendi.styls/
 */
var Text = props => {
  return /*#__PURE__*/jsx(Text$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: props.children
  }));
};

/**
 * @deprecated Importing from '@lendi-ui/typography' is deprecated, import directly from '@lendi/ui' instead.
 * @example import { P } from '@lendi/ui';
 * @see https://lendi.styls/
 */
var P = props => {
  return /*#__PURE__*/jsx(P$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: "props.children"
  }));
};

/**
 * @deprecated Importing from '@lendi-ui/typography' is deprecated, import directly from '@lendi/ui' instead.
 * @example import { A } from '@lendi/ui';
 * @see https://lendi.styls/
 */
var A = props => {
  return /*#__PURE__*/jsx(A$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: "props.children"
  }));
};




/***/ }),

/***/ 27233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bl": function() { return /* binding */ getDataProps; },
/* harmony export */   "MS": function() { return /* binding */ deriveSize; },
/* harmony export */   "N1": function() { return /* binding */ NORMALISE_LINE_HEIGHT; },
/* harmony export */   "W$": function() { return /* binding */ normalise; },
/* harmony export */   "jf": function() { return /* binding */ display; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92891);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23783);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90471);




var display = val => (0,_lendi_ui_breakpoint__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI)(val, v => v && "display: ".concat(v, ";"));
/**
 * Derive size from root CSS variable
 * @param multiplier
 */

var deriveSize = multiplier => {
  if (multiplier === 1) {
    return "var(--lendi-ui-size)";
  }

  return "calc(".concat(multiplier, " * var(--lendi-ui-size))");
};
var normalise = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["box-sizing:border-box;line-height:1.333;white-space:normal;border-spacing:2px;text-align:left;word-spacing:normal;letter-spacing:normal;"]);
var NORMALISE_LINE_HEIGHT = 1.333;

/**
 * return all the props of an object where the key begins with 'data-'
 * @param props The props object of a given component
 */
var getDataProps = props => {
  var dataProps = {};

  for (var _key in props) {
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)(_key, 'data-')) {
      dataProps[_key] = props[_key];
    }
  }

  return dataProps;
};




/***/ }),

/***/ 91539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(70245);

/***/ }),

/***/ 8477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);
var settle = __webpack_require__(93927);
var cookies = __webpack_require__(12953);
var buildURL = __webpack_require__(58759);
var buildFullPath = __webpack_require__(27074);
var parseHeaders = __webpack_require__(52462);
var isURLSameOrigin = __webpack_require__(18374);
var transitionalDefaults = __webpack_require__(60143);
var AxiosError = __webpack_require__(4710);
var CanceledError = __webpack_require__(82765);
var parseProtocol = __webpack_require__(6804);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 70245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);
var bind = __webpack_require__(29729);
var Axios = __webpack_require__(77099);
var mergeConfig = __webpack_require__(68908);
var defaults = __webpack_require__(54645);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(82765);
axios.CancelToken = __webpack_require__(82851);
axios.isCancel = __webpack_require__(59788);
axios.VERSION = (__webpack_require__(57159).version);
axios.toFormData = __webpack_require__(47022);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(4710);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(52863);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(39880);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 82851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(82765);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 82765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(4710);
var utils = __webpack_require__(14434);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 59788:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 77099:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);
var buildURL = __webpack_require__(58759);
var InterceptorManager = __webpack_require__(67011);
var dispatchRequest = __webpack_require__(81583);
var mergeConfig = __webpack_require__(68908);
var buildFullPath = __webpack_require__(27074);
var validator = __webpack_require__(97930);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 4710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 67011:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 27074:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(33326);
var combineURLs = __webpack_require__(30140);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 81583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);
var transformData = __webpack_require__(3625);
var isCancel = __webpack_require__(59788);
var defaults = __webpack_require__(54645);
var CanceledError = __webpack_require__(82765);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 68908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 93927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(4710);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 3625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);
var defaults = __webpack_require__(54645);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 54645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(13158);


var utils = __webpack_require__(14434);
var normalizeHeaderName = __webpack_require__(30380);
var AxiosError = __webpack_require__(4710);
var transitionalDefaults = __webpack_require__(60143);
var toFormData = __webpack_require__(47022);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(8477);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(8477);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(33264)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 60143:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 57159:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 29729:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 58759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 30140:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 12953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 33326:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 39880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 18374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 30380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 33264:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 52462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14434);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 6804:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 52863:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(75291)["lW"];


var utils = __webpack_require__(14434);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 97930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(57159).version);
var AxiosError = __webpack_require__(4710);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 14434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(29729);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 80623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HE": function() { return /* binding */ SimpleNavbar; }
});

// UNUSED EXPORTS: ApplicationStage, CommPanelProvider, GuestNavbar, Header, MultiNavbar, useCommPanel

// NAMESPACE OBJECT: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/utils/dist/utils.esm.js
var utils_esm = __webpack_require__(27233);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/color/dist/color.esm.js
var color_esm = __webpack_require__(62792);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/depth/dist/depth.esm.js
var depth_esm = __webpack_require__(12987);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react-stickynode/index.js
var react_stickynode = __webpack_require__(75690);
var react_stickynode_default = /*#__PURE__*/__webpack_require__.n(react_stickynode);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/navbar-base/dist/navbar-base.esm.js









var ChildrenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__ChildrenWrapper",
  componentId: "lui__sc-48r6gj-0"
})(["", ";padding:0;display:flex;flex-direction:row;align-items:center;width:100%;", ""], utils_esm/* normalise */.W$, _ref => {
  var {
    isTransparent
  } = _ref;
  return (0,styled_components_browser_esm/* css */.iv)(["", ";"], isTransparent ? "background-color: transparent;" : (0,styled_components_browser_esm/* css */.iv)(["", " ", ";"], (0,depth_esm/* depth */.Y)(2), (0,color_esm.bg)('shade.0')));
});
var NavbarLeftWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__NavbarLeftWrapper",
  componentId: "lui__sc-48r6gj-1"
})(["margin-right:auto;"]);
var NavbarRightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__NavbarRightWrapper",
  componentId: "lui__sc-48r6gj-2"
})(["margin-left:auto;"]);

var NavbarLeft = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavbarLeftWrapper, {
    children: children
  });
};

var NavbarRight = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavbarRightWrapper, {
    children: children
  });
};

var NavbarBaseContext = /*#__PURE__*/(0,react.createContext)(undefined);
var useNavbarBaseContext = () => {
  var context = (0,react.useContext)(NavbarBaseContext);

  if (!context) {
    throw new Error("NavbarBase compound components cannot be rendered outside the NavbarBase component");
  }

  return context;
};

var NavbarBase = _ref => {
  var {
    children,
    isTransparent: useTransparent = false,
    className
  } = _ref;
  var [isTransparent, setIsTransparent] = react.useState(useTransparent);
  react.useEffect(() => {
    setIsTransparent(useTransparent);
  }, [useTransparent]);

  var handleStickyState = _ref2 => {
    var {
      status
    } = _ref2;

    if (useTransparent) {
      if (status === (react_stickynode_default()).STATUS_FIXED) {
        setIsTransparent(false);
      } else {
        setIsTransparent(true);
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    "aria-label": "Main navigation",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavbarBaseContext.Provider, {
      value: {
        isTransparent
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((react_stickynode_default()), {
        innerZ: 3,
        onStateChange: handleStickyState,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ChildrenWrapper, {
          isTransparent: isTransparent,
          className: className,
          children: children
        })
      })
    })
  });
};

NavbarBase.Left = NavbarLeft;
NavbarBase.Right = NavbarRight;



// EXTERNAL MODULE: ../../../node_modules/@analytics/segment/lib/analytics-plugin-segment.browser.es.js
var analytics_plugin_segment_browser_es = __webpack_require__(15068);
// EXTERNAL MODULE: ../../../node_modules/analytics/lib/analytics.browser.es.js + 8 modules
var analytics_browser_es = __webpack_require__(70303);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/analytics/lib/esm/ClientLendiAnalytics.js
/* provided dependency */ var process = __webpack_require__(13158);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


let analyticsInstance;
var ClientLendiAnalytics_Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(ClientLendiAnalytics_Brand || (ClientLendiAnalytics_Brand = {}));
const getAnalyticsInstance = (callback) => {
    if (analyticsInstance) {
        return analyticsInstance;
    }
    if (typeof window !== 'undefined') {
        const writeKey = getWriteKey();
        if (!writeKey) {
            const error = new Error(`@lendi/analytics: segment write id is not given, so we can't track your events.`);
            // eslint-disable-next-line no-console
            callback ? callback(error) : console.error(error);
        }
        const config = {
            flushAt: +(process.env.LENDI_ANALYTICS_FLUSH_AT || 0),
            flushInterval: +(process.env.LENDI_ANALYTICS_FLUSH_INTERVAL || 0),
            enable: process.env.LENDI_ANALYTICS_ENABLE !== 'true',
            debug: process.env.LENDI_ANALYTICS_DEBUG === 'true',
        };
        analyticsInstance = (0,analytics_browser_es/* default */.ZP)({
            debug: config.debug,
            plugins: [
                (0,analytics_plugin_segment_browser_es/* default */.Z)(Object.assign({ writeKey }, config)),
            ],
        });
        return analyticsInstance;
    }
};
const identify = (userId, traits, options, callback) => {
    return getAnalyticsInstance(callback).identify(userId, traits, options);
};
const trackPage = (category, name, callback) => {
    return getAnalyticsInstance(callback).page({
        category,
        name,
    });
};
const trackEvent = (trackingEvent, options, callback) => {
    const { event_name } = trackingEvent, payload = __rest(trackingEvent, ["event_name"]);
    if (typeof window !== 'undefined') {
        payload.path = location.href.replace(location.origin, '');
    }
    return getAnalyticsInstance(callback).track(event_name, payload, options);
};
const getWriteKey = () => {
    const hostname = window.location.hostname;
    if (hostname.indexOf('aussie') !== -1) {
        return process.env.REACT_APP_AUSSIE_SEGMENT_ID || process.env.NEXT_PUBLIC_AUSSIE_SEGMENT_ID;
    }
    else if (hostname.indexOf('domain') !== -1 || hostname.indexOf('dlf') !== -1) {
        return process.env.REACT_APP_DLF_SEGMENT_ID;
    }
    else {
        return (process.env.REACT_APP_SEGMENT_ID || process.env.NEXT_PUBLIC_SEGMENT_ID || process.env.GATSBY_SEGMENT_ID);
    }
};
//# sourceMappingURL=ClientLendiAnalytics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/analytics/lib/esm/events/common.js
var CustomerType;
(function (CustomerType) {
    CustomerType["CUSTOMER"] = "Customer";
    CustomerType["TEAM"] = "Team";
})(CustomerType || (CustomerType = {}));
var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus["AUTHENTICATED"] = "Authenticated";
    AuthenticationStatus["UNAUTHENTICATED"] = "Unauthenticated";
})(AuthenticationStatus || (AuthenticationStatus = {}));
var EventCategory;
(function (EventCategory) {
    EventCategory["APPLICATION_SUMMARY"] = "Application Summary";
    EventCategory["APPLICATION"] = "Application";
    EventCategory["AUTH"] = "Auth";
    EventCategory["BOOK_APPOINTMENT"] = "Book Appointment";
    EventCategory["CASH_OUT"] = "Cash Out";
    EventCategory["CHAT"] = "Chat";
    EventCategory["CHOOSE_YOUR_LOAN"] = "Choose Your Loan";
    EventCategory["COMMSPANEL"] = "CommsPanel";
    EventCategory["CREDIT_GUIDE"] = "Credit Guide";
    EventCategory["CREDIT_PROPOSAL"] = "Credit Proposal";
    EventCategory["DASHBOARD"] = "Dashboard";
    EventCategory["ERROR_PAGES"] = "Error Pages";
    EventCategory["FOOTER"] = "Footer";
    EventCategory["FUNDING_POSITION"] = "Funding Position";
    EventCategory["FREE_FORM_FUNDING_POSITION"] = "Free Form Funding Position";
    EventCategory["FUNNELS"] = "Funnels";
    EventCategory["INSPIRE_BLOG"] = "Inspire Blog";
    EventCategory["JAM_LANDING_PAGES"] = "Jam Landing Pages";
    EventCategory["NAVBAR"] = "Navbar";
    EventCategory["NOTES"] = "Notes";
    EventCategory["NOTIFICATION"] = "Notification";
    EventCategory["PACKAGE_COMPARISON"] = "Package Comparison";
    EventCategory["PRODUCT_SEARCH"] = "Product Search";
    EventCategory["PROPERTY_REPORT"] = "Property Report";
    EventCategory["REQUIRED_ACTIONS"] = "Required Actions";
    EventCategory["REQUIRED_DOCUMENTS"] = "Required Documents";
    EventCategory["SAFETYNET_CTP"] = "Safetynet CTP";
    EventCategory["SAVINGS_CALCULATOR"] = "Savings Calculator";
    EventCategory["FREE_FORM_SAVINGS_CALCULATOR"] = "Free Form Savings Calculator";
    EventCategory["STAMP_DUTY_CALCULATOR"] = "Stamp Duty Calculator";
    EventCategory["CMS"] = "CMS";
    EventCategory["POSTCODE"] = "Customer Suburb";
    EventCategory["EMAIL_VERIFICATION"] = "email-verification";
    EventCategory["ACCOUNT_LINKING"] = "account-linking";
    EventCategory["SMS_SENDER"] = "SMS Sender";
    EventCategory["FIXED_RATE_EXPIRY_CALCULATOR"] = "Fixed Rate Expiry Calculator";
})(EventCategory || (EventCategory = {}));
//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/analytics/lib/esm/events/objects/button/index.js
var ButtonType;
(function (ButtonType) {
    ButtonType["PRIMARY"] = "Primary";
    ButtonType["SECONDARY"] = "Secondary";
    ButtonType["EMPHASIS"] = "Emphasis";
    ButtonType["EMPTY"] = "Empty";
    ButtonType["LINK"] = "Link";
    ButtonType["ICON"] = "Icon";
})(ButtonType || (ButtonType = {}));
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/breakpoint/dist/breakpoint.esm.js
var breakpoint_esm = __webpack_require__(23783);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/utils/dist/commons.esm.js
var commons_esm = __webpack_require__(7401);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/logo/dist/logo.esm.js





function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function logo_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function logo_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var LogoWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LogoWrapper",
  componentId: "lui__sc-2m77v6-0"
})(["width:", ";height:", ";vertical-align:middle;display:inline-block;& > svg{fill:", ";width:inherit;height:inherit;}[class$='fillPath']{fill:", ";}"], _ref => {
  var {
    width
  } = _ref;
  return width !== null && width !== void 0 ? width : '1em';
}, _ref2 => {
  var {
    height
  } = _ref2;
  return height !== null && height !== void 0 ? height : '1em';
}, _ref3 => {
  var {
    color
  } = _ref3;
  return color !== null && color !== void 0 ? color : 'currentColor';
}, _ref4 => {
  var {
    color
  } = _ref4;
  return color !== null && color !== void 0 ? color : 'currentColor';
});

var Lendi = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    viewBox: "0 0 800 201",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M761.535 8.832h19.787c5.178 0 9.617 1.85 13.13 5.548 3.699 3.698 5.548 8.137 5.548 13.13v11.465h-38.465V8.832z",
      fill: "#00C0A5"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M265.002 8.832h-19.787v188.997h38.465V26.955c0-5.178-1.849-9.431-5.548-12.945-3.699-3.514-8.137-5.178-13.13-5.178zM366.898 48.407c-20.897 0-37.171 6.842-49.006 20.342-11.281 13.13-17.014 31.438-17.014 54.924 0 24.595 5.918 43.458 17.569 56.588 11.65 13.499 28.109 20.342 49.006 20.342 17.198 0 31.437-4.254 42.903-12.575 11.281-8.137 19.048-19.788 23.116-35.137h-27.554c-4.439 0-7.767.925-10.171 2.774-2.404 1.849-3.699 3.329-4.069 4.438l-2.959 2.959c-.924.925-1.849 1.48-2.958 1.85-4.439 2.589-9.802 3.883-15.904 3.883-9.617 0-16.644-2.959-21.452-8.877-5.178-5.547-7.952-13.869-8.322-25.335h95.053c.37-.739.555-2.034.555-3.883v-2.219-3.884c0-24.225-5.918-43.088-17.568-56.588-12.205-12.945-29.219-19.602-51.225-19.602zm-26.815 61.581c.37-9.616 3.144-16.829 8.322-22.007 5.178-5.178 11.65-7.767 19.787-7.767 8.877 0 15.534 2.59 20.342 7.767 4.439 4.809 7.028 12.021 7.767 22.007h-56.218zM562.922 60.982c-13.5-8.507-28.479-12.575-44.568-12.575-15.719.74-30.143 5.363-43.088 13.684-12.945 8.507-19.602 25.15-19.602 49.931v85.807h38.465V104.44c0-8.876 2.589-15.164 7.767-19.233 5.178-4.068 10.91-6.102 17.568-6.102 6.657 0 12.575 2.034 17.938 6.102 5.363 4.069 7.952 10.357 7.952 19.233v74.711c0 5.548 1.664 9.986 5.178 13.5 3.513 3.514 7.952 5.178 13.499 5.178h19.233v-85.622c0-25.705-6.842-42.718-20.342-51.225zM718.816 8.277h-18.677v62.691c-4.439-7.027-10.172-12.575-17.569-17.013-7.027-3.699-14.979-5.548-24.225-5.548-17.199 0-31.253 7.212-42.349 21.452-10.541 13.87-15.904 32.362-15.904 55.478 0 23.486 5.363 41.979 15.904 55.478 5.548 7.028 12.76 12.021 22.007 15.165 9.246 3.143 18.492 4.623 28.109 4.623 17.568 0 33.842-4.623 49.006-13.685 14.979-9.246 22.561-26.815 22.561-52.705V26.955c0-4.808-1.849-9.061-5.548-12.945-3.883-3.883-8.137-5.733-13.315-5.733zm-26.444 148.868c-5.548 7.767-13.13 11.465-23.117 11.465-10.171 0-18.122-3.883-23.67-11.465-5.548-7.767-8.322-18.863-8.322-33.472 0-13.13 2.774-23.486 8.322-30.698 5.548-7.767 12.945-11.466 22.561-11.466 9.801 0 17.753 3.698 23.671 10.91 5.548 7.768 8.322 18.124 8.322 31.254 0 14.609-2.589 25.89-7.767 33.472zM794.452 57.283c-3.698-3.698-8.137-5.548-13.13-5.548h-19.787V197.83H800v-127.6c0-4.994-1.849-9.432-5.548-12.946z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M196.579 58.763L113.361 3.099c-5.918-4.068-13.5-4.068-19.417-.37L7.952 58.578C2.959 61.906 0 67.454 0 73.372v109.662c0 9.802 7.952 17.569 17.568 17.569h169.21c9.801 0 17.568-7.952 17.568-17.569V73.372c0-5.918-2.959-11.466-7.767-14.61zm-27.37 106.703h-49.375v-51.225H84.697v51.225h-49.56V82.803l68.238-44.198 65.834 44.013v82.848z",
      fill: "#00C0A5"
    })]
  })
}));
var LendiLogoMark = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    viewBox: "0 0 609.271 609.271",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M513.617 502.385H363.694V346.877H256.8v155.508H106.886v-250.65l207.028-134.282 199.7 133.772v251.16zm83.189-324.092L344.129 9.041a53.445 53.445 0 00-58.829-.433L24.359 177.86A53.443 53.443 0 000 222.7v333.125a53.443 53.443 0 0053.44 53.446h513.622a53.444 53.444 0 0053.446-53.446V222.7a53.437 53.437 0 00-23.7-44.407z",
      fill: "#00c0a5"
    })
  })
}));

var DomainHomeLoans = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    viewBox: "0 0 590 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M190.207 47.955V29.679c0-11.257-6.942-14.62-15.82-14.62-9.5 0-15.711 4.935-15.784 13.122h7.307c0-4.094 2.594-6.36 8.659-6.36 6.065 0 8.404 2.814 8.404 5.483 0 2.668-.293 3.399-4.312 4.13l-8.732 1.645c-7.636 1.425-13.189 4.897-13.189 12.902a11.997 11.997 0 003.957 8.653 11.984 11.984 0 009.013 3.043 16.215 16.215 0 0013.811-6.177v.84c0 2.815 1.644 4.314 4.64 4.314h5.736v-5.958h-.95c-2.046 0-2.74-.768-2.74-2.741zm-7.015-7.055a10.97 10.97 0 01-7.532 9.764 10.957 10.957 0 01-4.306.507c-4.348 0-6.686-2.193-6.686-5.812 0-3.618 2.521-5.336 8.148-6.505l7.014-1.499a11.214 11.214 0 003.362-1.206V40.9zM18.268.33H0v56.323h17.61c17.355 0 28.827-11.842 28.827-28.216 0-18.385-13.19-28.108-28.169-28.108zm-.694 49.342H7.709V7.31h9.098c12.897 0 21.921 6.981 21.921 21.09A19.89 19.89 0 0125.94 48.427a19.867 19.867 0 01-8.33 1.245h-.036zM205.442 16.119h-7.015v40.534h7.015V16.118zM201.935 0a4.75 4.75 0 00-4.75 4.752 4.751 4.751 0 004.75 4.751 4.75 4.75 0 004.749-4.751A4.751 4.751 0 00201.935 0zM136.864 14.364l-12.532 8.553-12.605-8.553-9.024 6.14v-4.349h-7.052v40.498h7.052V29.021l9.024-6.14 9.025 6.14v27.632h7.015V29.021l9.097-6.14 9.061 6.14v27.632h7.052V25.22l-16.113-10.856zM70.697 15.059a20.78 20.78 0 00-15.214 6.188 20.8 20.8 0 00-5.977 15.304 20.77 20.77 0 006.02 15.219 20.754 20.754 0 0015.171 6.126 20.784 20.784 0 0019.766-13.115 20.807 20.807 0 001.462-8.23A20.877 20.877 0 0078.94 16.597a20.857 20.857 0 00-8.243-1.538zm0 35.527a14.172 14.172 0 01-13.11-8.789 14.187 14.187 0 013.139-15.472A14.174 14.174 0 0184.873 36.55a14.184 14.184 0 01-4.203 9.933 14.173 14.173 0 01-9.973 4.102zM230.469 15.095a14.608 14.608 0 00-11.582 5.19V16.12h-6.978v40.534h7.052V31.068a9.791 9.791 0 019.791-9.796 9.72 9.72 0 019.755 9.796v25.585h7.052V31.068c-.073-9.394-5.663-15.973-15.09-15.973z",
      fill: "#0EA800"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 70.543h7.71V94.52h27.657V70.543h7.855v56.36h-7.855v-25.329H7.709v25.293H0V70.542zM49.872 106.618c0-11.696 7.307-21.309 18.925-21.309 11.619 0 18.89 9.21 18.89 21.309 0 12.098-7.308 21.309-18.89 21.309-11.581 0-18.925-9.138-18.925-21.309zm30.873 0c0-8.662-4.713-14.62-11.948-14.62-7.234 0-11.874 6.03-11.874 14.62 0 8.589 4.64 14.62 11.874 14.62 7.235 0 11.948-5.884 11.948-14.62zM93.167 86.259h6.832v4.093a12.791 12.791 0 0110.705-5.044 11.651 11.651 0 0111.326 6.36 14.034 14.034 0 0112.386-6.36c8.805 0 14.615 6.068 14.615 16.119v25.586h-7.235v-24.051c0-6.615-3.069-10.782-8.732-10.782-5.663 0-8.549 4.715-8.549 10.965v23.831h-6.979v-24.123c0-6.616-3.032-10.783-8.622-10.783s-8.659 4.496-8.659 10.271v24.452h-7.088V86.259zM172.998 121.165a9.06 9.06 0 009.902-6.542h7.088a16.303 16.303 0 01-6.048 9.931 16.29 16.29 0 01-11.124 3.373c-10.669 0-18.78-7.31-18.78-21.309 0-12.72 8.038-21.309 18.78-21.309 11.326 0 18.012 8.26 18.012 20.286v3.472h-29.631a11.739 11.739 0 003.329 8.56 11.727 11.727 0 008.472 3.538zm-11.618-18.494h22.141a10.567 10.567 0 00-6.637-9.846 10.553 10.553 0 00-4.105-.754 10.955 10.955 0 00-10.42 6.413 10.977 10.977 0 00-.979 4.187zM203.725 70.543h7.673v49.05h28.059v7.31h-35.732v-56.36zM240.334 106.618c0-11.696 7.307-21.309 18.926-21.309 11.618 0 18.999 9.21 18.999 21.309 0 12.098-7.381 21.309-18.853 21.309-11.472 0-19.072-9.138-19.072-21.309zm30.873 0c0-8.662-4.713-14.62-11.947-14.62-7.234 0-11.874 6.03-11.874 14.62 0 8.589 4.64 14.62 11.874 14.62 7.234 0 11.947-5.958 11.947-14.62zM280.743 116.194c0-8.004 5.59-11.477 13.189-12.866l8.732-1.681c3.654-.694 4.312-1.864 4.312-4.057 0-2.193-1.864-5.52-8.404-5.52-6.539 0-8.732 2.267-8.659 6.36h-7.307c0-8.15 6.284-13.12 15.784-13.12 8.878 0 15.783 3.215 15.783 14.62v18.274c0 1.974.695 2.742 2.741 2.742h.949v5.994h-5.699c-2.996 0-4.64-1.499-4.64-4.313v-.914a16.155 16.155 0 01-13.811 6.214 12.005 12.005 0 01-9.014-3.068 12.036 12.036 0 01-2.873-3.924 12.037 12.037 0 01-1.083-4.741zm26.488-5.08v-4.825a10.935 10.935 0 01-3.397 1.206l-6.979 1.499c-5.663 1.169-8.184 2.741-8.184 6.506 0 3.764 2.375 5.811 6.686 5.811a10.957 10.957 0 0011.874-10.197zM322.467 86.332h6.832v4.167a15.097 15.097 0 0111.802-5.19c9.426 0 14.979 6.14 14.979 16.593v25.001h-7.051v-23.831c0-7.054-3.654-10.965-8.732-10.965a10.956 10.956 0 00-10.404 7.401 10.96 10.96 0 00-.557 4.478v22.954h-6.869V86.332zM360.83 114.221h7.307c.402 4.97 3.398 7.31 9.134 7.31 5.736 0 8.732-1.718 8.732-5.337 0-2.924-1.9-3.874-6.759-5.592l-5.261-1.791c-6.54-2.193-11.947-4.386-11.947-11.477 0-7.931 6.649-11.952 14.979-11.952 8.331 0 15.273 3.472 15.346 13.158h-7.308c-.255-4.715-3.653-6.688-8.184-6.688-5.407 0-7.599 1.864-7.599 4.86 0 2.998 1.717 3.656 6.576 5.264l7.308 2.668c5.736 2.047 9.609 4.642 9.609 10.783 0 9.283-7.637 12.573-15.711 12.573-8.805-.073-16.222-3.728-16.222-13.779z",
      fill: "#005837"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M581.727 86.332h4.275a3.98 3.98 0 013.982 4.021v2.486h-8.257v-6.507z",
      fill: "#00C0A5"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M475.261 86.332h-4.238v40.572h8.257v-36.55a3.658 3.658 0 00-1.206-2.779 3.982 3.982 0 00-2.813-1.243zM497.146 95.031a13.112 13.112 0 00-10.486 4.35 17.44 17.44 0 00-3.654 11.805 17.623 17.623 0 003.654 12.135 13.15 13.15 0 0010.522 4.386c3.27.117 6.488-.832 9.171-2.704a13.052 13.052 0 005.152-7.749h-5.919a3.648 3.648 0 00-2.192.585 2.735 2.735 0 00-.877.95l-.621.658a1.537 1.537 0 01-.658.402 6.649 6.649 0 01-3.434.841 5.487 5.487 0 01-4.567-1.864 8.044 8.044 0 01-1.791-5.446h20.387a1.642 1.642 0 000-.841v-1.279c.3-4.367-.998-8.693-3.653-12.172a14.17 14.17 0 00-11.034-4.057zm-5.773 13.195a6.727 6.727 0 011.754-4.715 6.465 6.465 0 018.622 0 8.008 8.008 0 011.645 4.715h-12.021zM539.163 97.553a17.61 17.61 0 00-9.39-2.522 18.26 18.26 0 00-9.28 2.924c-2.777 1.828-4.165 5.41-4.165 10.746v18.275h8.22v-20.102a4.91 4.91 0 01.343-2.268 4.914 4.914 0 011.338-1.863 5.915 5.915 0 013.653-1.315 6.093 6.093 0 013.654 1.315 4.832 4.832 0 011.717 4.131v16.009a3.848 3.848 0 002.199 3.659c.456.215.951.338 1.455.361h4.457v-18.275c.146-5.629-1.279-9.284-4.201-11.075zM572.593 86.223h-4.019v13.45a10.966 10.966 0 00-3.654-3.655 11.14 11.14 0 00-5.188-1.206 10.96 10.96 0 00-9.097 4.605 19.3 19.3 0 00-3.398 11.916 18.931 18.931 0 003.398 11.915 10.3 10.3 0 004.713 3.253c1.942.656 3.978.989 6.028.987a19.397 19.397 0 0010.486-2.961c3.215-1.937 4.823-5.738 4.823-11.294v-22.99a3.916 3.916 0 00-1.169-2.778 3.662 3.662 0 00-2.923-1.242zm-5.663 31.945a5.634 5.634 0 01-4.933 2.485 5.882 5.882 0 01-5.078-2.485 12.4 12.4 0 01-1.754-7.31 10.97 10.97 0 011.754-6.58 5.629 5.629 0 014.859-2.485 6.101 6.101 0 015.042 2.376 11.337 11.337 0 011.754 6.689 12.955 12.955 0 01-1.644 7.31zM588.815 96.713a3.657 3.657 0 00-2.813-1.17h-4.275v31.36h8.257v-27.34a3.662 3.662 0 00-1.169-2.85z",
      fill: "#083742"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M460.61 97.041L442.744 85.09a3.655 3.655 0 00-4.129 0l-18.268 11.952a3.656 3.656 0 00-1.717 3.18v23.539a3.655 3.655 0 003.653 3.655h36.281a3.654 3.654 0 003.653-3.655v-23.576a3.824 3.824 0 00-.421-1.767 3.828 3.828 0 00-1.186-1.376zm-5.919 22.881h-10.559v-10.965h-7.563v10.965h-10.595v-17.581l14.614-9.503 14.139 9.503-.036 17.581z",
      fill: "#00C0A5"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M419.068 51.573h7.308c4.238 0 6.138 2.23 6.138 5.373a5.13 5.13 0 01-1.419 4.003 5.113 5.113 0 01-3.952 1.553h-5.334v8.04h-2.595l-.146-18.969zm7.308 8.443a2.848 2.848 0 003.041-1.818c.151-.399.21-.827.174-1.252 0-1.864-1.352-2.924-3.654-2.924h-4.494v5.994h4.933zM434.523 63.708a6.473 6.473 0 013.744-6.734 6.468 6.468 0 019.08 6.734 6.585 6.585 0 01-1.598 5.078 6.583 6.583 0 01-4.832 2.232 6.505 6.505 0 01-6.394-7.31zm10.45 0c0-2.924-1.608-4.971-4.056-4.971s-4.019 2.047-4.019 4.97c0 2.925 1.571 4.935 4.019 4.935 2.448 0 4.056-2.01 4.056-4.934zM449.722 56.836h2.485l2.484 10.965 2.996-10.965h2.667l2.85 10.965 2.594-10.965h2.448l-3.654 13.707h-2.63l-1.681-6.104-1.169-4.386-1.169 4.422-1.754 6.068h-2.594l-3.873-13.707zM476.832 68.605a3.07 3.07 0 003.361-2.193h2.339a5.482 5.482 0 01-5.737 4.46 6.358 6.358 0 01-6.357-7.31 6.544 6.544 0 016.357-7.31 6.059 6.059 0 014.585 2.038 6.069 6.069 0 011.48 4.796v1.17h-9.974a3.98 3.98 0 001.017 3.043 3.983 3.983 0 002.929 1.306zm-3.909-6.214h7.49a3.653 3.653 0 00-3.654-3.654 3.65 3.65 0 00-3.542 2.212 3.648 3.648 0 00-.294 1.443zM486.551 56.836h2.301v1.645a4.607 4.607 0 013.873-1.938h1.023v2.34h-1.279a3.65 3.65 0 00-3.563 2.66 3.646 3.646 0 00-.09 1.58v7.31h-2.375l.11-13.597zM502.005 68.605a2.994 2.994 0 003.325-2.193h2.521a5.482 5.482 0 01-5.736 4.46 6.322 6.322 0 01-6.321-7.31 6.538 6.538 0 011.548-5.05 6.549 6.549 0 014.773-2.26 6.062 6.062 0 015.877 4.267c.258.83.334 1.705.224 2.567v1.17h-9.974a3.984 3.984 0 003.763 4.35zm-3.946-6.213h7.49a3.656 3.656 0 00-3.654-3.655 3.652 3.652 0 00-3.836 3.655zM523.196 51.5v19.043h-2.265v-1.426a4.713 4.713 0 01-3.946 1.791c-3.653 0-6.028-2.778-6.028-7.31a6.317 6.317 0 011.379-5.028 6.323 6.323 0 014.686-2.282 4.93 4.93 0 013.836 1.681V51.5h2.338zm-2.338 12.135c0-3.07-1.535-4.935-3.654-4.935-2.119 0-3.653 2.12-3.653 4.935 0 2.814 1.498 5.007 3.653 5.007 2.156 0 3.654-1.79 3.654-4.97v-.037zM547.383 63.635c0 4.276-2.448 7.31-5.955 7.31a4.822 4.822 0 01-4.056-1.864v1.498h-2.265V51.5h2.375v6.726a5.002 5.002 0 014.019-1.718c3.544-.036 5.882 2.924 5.882 7.128zm-2.411 0c0-2.815-1.389-4.935-3.654-4.935-2.265 0-3.983 1.864-3.946 4.935.037 3.07 1.608 5.007 3.909 5.007 2.302 0 3.654-2.12 3.654-5.044l.037.037zM550.817 73.942h1.937a2.665 2.665 0 001.571-.402 1.393 1.393 0 00.511-1.133 5.93 5.93 0 00-.438-1.974l-4.896-13.597h2.777l2.265 7.09 1.717 5.118 1.462-5.117 1.9-7.09h2.594l-5.006 16.045c-.804 2.522-1.827 3.326-3.873 3.326h-2.521v-2.266z",
      fill: "#8E8E8E"
    })]
  })
}));
var DomainHomeLoansNegative = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    viewBox: "0 0 148 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_601_1214)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M47.6257 11.9887V7.41994C47.6257 4.60554 45.8902 3.76489 43.6707 3.76489C41.2957 3.76489 39.743 4.99847 39.7247 7.04529H41.5515C41.5515 6.02189 42.2 5.45534 43.7162 5.45534C45.2325 5.45534 45.8172 6.15894 45.8172 6.82599C45.8172 7.49304 45.744 7.67579 44.7392 7.85854L42.5562 8.26974C40.6472 8.62609 39.259 9.49417 39.259 11.4953C39.2675 11.9044 39.3597 12.3073 39.5297 12.6794C39.7 13.0514 39.9445 13.3847 40.2482 13.6586C40.552 13.9326 40.9087 14.1414 41.2962 14.2722C41.6837 14.403 42.094 14.4531 42.5015 14.4193C43.159 14.4619 43.8172 14.3436 44.4187 14.0745C45.0205 13.8054 45.5472 13.3937 45.9542 12.8751V13.0853C45.9542 13.7889 46.3652 14.1635 47.1142 14.1635H48.5482V12.6741H48.3107C47.7992 12.6741 47.6257 12.4822 47.6257 11.9887ZM45.872 10.2252C45.85 10.5896 45.7557 10.9459 45.5942 11.2733C45.4327 11.6007 45.2077 11.8925 44.932 12.1317C44.6565 12.3709 44.3357 12.5525 43.989 12.6661C43.6422 12.7796 43.2762 12.8227 42.9125 12.7929C41.8255 12.7929 41.241 12.2446 41.241 11.34C41.241 10.4353 41.8712 10.0059 43.278 9.71349L45.0315 9.33884C45.326 9.28387 45.6097 9.18207 45.872 9.03729V10.2252Z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M4.64097 0.0822754H0.0739746V14.1633H4.47657C8.81522 14.1633 11.6833 11.2027 11.6833 7.10909C11.6833 2.51287 8.38592 0.0822754 4.64097 0.0822754ZM4.46742 12.418H2.00125V1.82756H4.27562C7.49992 1.82756 9.75602 3.57284 9.75602 7.09997C9.80712 7.80832 9.7059 8.51942 9.45915 9.18534C9.21242 9.85129 8.8259 10.4566 8.32565 10.9605C7.8254 11.4644 7.223 11.8553 6.55905 12.1067C5.8951 12.3581 5.185 12.4643 4.47657 12.418H4.46742Z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M51.4345 4.02954H49.6807V14.1632H51.4345V4.02954Z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M50.5577 0C50.2427 0 49.9407 0.125152 49.718 0.347925C49.4952 0.570697 49.3702 0.872843 49.3702 1.18789C49.3702 1.50294 49.4952 1.80508 49.718 2.02785C49.9407 2.25063 50.2427 2.37578 50.5577 2.37578C50.8725 2.37578 51.1745 2.25063 51.3972 2.02785C51.62 1.80508 51.745 1.50294 51.745 1.18789C51.745 0.872843 51.62 0.570697 51.3972 0.347925C51.1745 0.125152 50.8725 0 50.5577 0Z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M34.29 3.59106L31.157 5.72926L28.0057 3.59106L25.7497 5.12619V4.03881H23.9868V14.1633H25.7497V7.25526L28.0057 5.72014L30.262 7.25526V14.1633H32.0157V7.25526L34.29 5.72014L36.5552 7.25526V14.1633H38.3182V6.30494L34.29 3.59106Z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M17.7483 3.7647C17.0425 3.75065 16.3413 3.88058 15.6873 4.14658C15.0334 4.41255 14.4405 4.80903 13.9448 5.31178C13.449 5.81455 13.0609 6.41308 12.804 7.07083C12.5471 7.7286 12.4268 8.43183 12.4505 9.13763C12.4306 9.84073 12.5537 10.5406 12.8124 11.1946C13.0711 11.8487 13.46 12.4433 13.9554 12.9424C14.4509 13.4415 15.0426 13.8346 15.6946 14.0979C16.3466 14.3612 17.0453 14.4891 17.7483 14.474C18.4516 14.4891 19.1507 14.3612 19.8032 14.098C20.4557 13.8348 21.048 13.4418 21.5442 12.9429C22.0404 12.4439 22.4301 11.8494 22.6899 11.1953C22.9496 10.5412 23.0738 9.84118 23.0551 9.13763C23.0763 8.43173 22.9539 7.72888 22.6955 7.07168C22.4371 6.41445 22.0481 5.81658 21.5519 5.31423C21.0557 4.81188 20.4628 4.4155 19.809 4.14915C19.1552 3.88283 18.4541 3.75203 17.7483 3.7647ZM17.7483 12.6465C17.0458 12.6464 16.3592 12.4376 15.7756 12.0463C15.192 11.6551 14.7378 11.0992 14.4707 10.4493C14.2036 9.7993 14.1356 9.08458 14.2753 8.39585C14.415 7.70713 14.7562 7.0755 15.2555 6.58115C15.7548 6.0868 16.3897 5.75205 17.0795 5.6194C17.7694 5.48675 18.4831 5.5622 19.13 5.83618C19.7769 6.11013 20.3279 6.57023 20.7128 7.15805C21.0978 7.74588 21.2995 8.4349 21.2923 9.13763C21.2826 10.0716 20.905 10.964 20.2414 11.621C19.5778 12.278 18.6819 12.6465 17.7483 12.6465Z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M57.6912 3.77389C57.1422 3.75852 56.5967 3.86719 56.0955 4.09184C55.5942 4.31649 55.15 4.65132 54.7957 5.07144V4.02974H53.0512V14.1634H54.8142V7.76704C54.8142 7.11754 55.072 6.49467 55.531 6.03542C55.9902 5.57617 56.6127 5.31817 57.262 5.31817C57.5835 5.31694 57.9017 5.37952 58.199 5.50227C58.496 5.62502 58.7657 5.80549 58.9925 6.03327C59.2192 6.26102 59.3987 6.53154 59.5202 6.82914C59.642 7.12677 59.7032 7.44554 59.7007 7.76704V14.1634H61.4637V7.76704C61.4455 5.41867 60.048 3.77389 57.6912 3.77389Z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0.0739746 17.6357H2.00125V23.63H8.9157V17.6357H10.8795V31.7259H8.9157V25.3936H2.00125V31.7169H0.0739746V17.6357Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.5419 26.6546C12.5419 23.7306 14.3687 21.3274 17.2733 21.3274C20.178 21.3274 21.9956 23.6301 21.9956 26.6546C21.9956 29.6791 20.1688 31.9819 17.2733 31.9819C14.3779 31.9819 12.5419 29.6974 12.5419 26.6546ZM20.2602 26.6546C20.2602 24.489 19.0819 22.9996 17.2733 22.9996C15.4648 22.9996 14.3048 24.5073 14.3048 26.6546C14.3048 28.8019 15.4648 30.3096 17.2733 30.3096C19.0819 30.3096 20.2602 28.8386 20.2602 26.6546Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M23.3657 21.5647H25.0738V22.5881C25.3852 22.1778 25.7915 21.8488 26.2572 21.6293C26.7232 21.4097 27.2355 21.306 27.75 21.3271C28.3265 21.2811 28.9035 21.4078 29.4077 21.6909C29.912 21.974 30.3205 22.4008 30.5815 22.917C30.9147 22.4054 31.3757 21.9896 31.9187 21.7107C32.4617 21.4319 33.0682 21.2996 33.678 21.3271C35.8792 21.3271 37.3317 22.8439 37.3317 25.3567V31.7532H35.523V25.7405C35.523 24.0866 34.7557 23.045 33.34 23.045C31.9242 23.045 31.2027 24.2237 31.2027 25.7862V31.744H29.458V25.7132C29.458 24.0592 28.7 23.0175 27.3025 23.0175C25.905 23.0175 25.1377 24.1415 25.1377 25.5852V31.6982H23.3657V21.5647Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M43.3235 30.2914C43.8637 30.3621 44.4115 30.2356 44.866 29.9354C45.3207 29.6349 45.652 29.1806 45.799 28.6559H47.571C47.3892 29.6411 46.851 30.5251 46.059 31.1386C45.2672 31.7521 44.277 32.0524 43.278 31.9819C40.6107 31.9819 38.583 30.1544 38.583 26.6546C38.583 23.4747 40.5925 21.3274 43.278 21.3274C46.1095 21.3274 47.781 23.3925 47.781 26.3989C47.781 26.6729 47.781 27.0109 47.781 27.2669H40.3732C40.361 27.6611 40.4282 28.0539 40.5712 28.4216C40.7142 28.7894 40.93 29.1244 41.2055 29.4069C41.4807 29.6891 41.8105 29.9131 42.1745 30.0651C42.5382 30.2171 42.9292 30.2941 43.3235 30.2914ZM40.419 25.6679H45.9542C45.9555 25.3164 45.8865 24.9682 45.7515 24.6437C45.6167 24.3192 45.4182 24.025 45.1682 23.7782C44.918 23.5314 44.6212 23.337 44.295 23.2064C43.969 23.0759 43.62 23.0118 43.2687 23.0178C42.9072 23.0032 42.5467 23.0602 42.2075 23.1857C41.8682 23.3112 41.557 23.5027 41.2922 23.749C41.0272 23.9953 40.8137 24.2917 40.6637 24.621C40.514 24.9504 40.4307 25.3061 40.419 25.6679Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M51.0052 17.6357H52.9235V29.8984H59.9382V31.7259H51.0052V17.6357Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M60.1575 26.6546C60.1575 23.7306 61.9842 21.3274 64.889 21.3274C67.7935 21.3274 69.6387 23.6301 69.6387 26.6546C69.6387 29.6791 67.7935 31.9819 64.9255 31.9819C62.0575 31.9819 60.1575 29.6974 60.1575 26.6546ZM67.8757 26.6546C67.8757 24.489 66.6975 22.9996 64.889 22.9996C63.0805 22.9996 61.9205 24.5073 61.9205 26.6546C61.9205 28.8019 63.0805 30.3096 64.889 30.3096C66.6975 30.3096 67.8757 28.8201 67.8757 26.6546Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M70.2597 29.0486C70.2597 27.0476 71.6572 26.1794 73.557 25.8321L75.74 25.4119C76.6535 25.2384 76.818 24.9459 76.818 24.3976C76.818 23.8494 76.352 23.0178 74.717 23.0178C73.0822 23.0178 72.534 23.5844 72.5522 24.6078H70.7255C70.7255 22.5701 72.2965 21.3274 74.6715 21.3274C76.891 21.3274 78.6172 22.1315 78.6172 24.9824V29.5511C78.6172 30.0446 78.791 30.2366 79.3025 30.2366H79.5397V31.7351H78.115C77.366 31.7351 76.955 31.3604 76.955 30.6569V30.4284C76.5502 30.9499 76.0237 31.3644 75.422 31.6351C74.82 31.9059 74.161 32.0249 73.5022 31.9819C73.0942 32.0144 72.6837 31.9631 72.2962 31.8311C71.9087 31.6991 71.5522 31.4896 71.2487 31.2149C70.945 30.9401 70.7007 30.6064 70.5305 30.2339C70.3605 29.8614 70.2685 29.4581 70.2597 29.0486ZM76.8817 27.7786V26.5724C76.6172 26.7191 76.3302 26.8211 76.0325 26.8739L74.2877 27.2486C72.872 27.5409 72.2417 27.9339 72.2417 28.8751C72.2417 29.8161 72.8355 30.3279 73.9132 30.3279C74.2762 30.3591 74.6417 30.3176 74.9885 30.2059C75.3352 30.0939 75.6562 29.9141 75.9325 29.6766C76.209 29.4394 76.4352 29.1491 76.5982 28.8234C76.7612 28.4974 76.8577 28.1421 76.8817 27.7786Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M80.6907 21.5829H82.3987V22.6246C82.7642 22.2038 83.2185 21.8691 83.7285 21.6448C84.2385 21.4204 84.792 21.3119 85.3492 21.3271C87.7057 21.3271 89.094 22.8622 89.094 25.4754V31.7257H87.3312V25.7679C87.3312 24.0044 86.4177 23.0267 85.1482 23.0267C84.7682 23.0253 84.3922 23.1031 84.044 23.2549C83.6957 23.4067 83.3827 23.6293 83.1252 23.9086C82.8675 24.1878 82.6707 24.5177 82.5472 24.8771C82.4237 25.2364 82.3762 25.6177 82.408 25.9964V31.735H80.6907V21.5829Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M90.2815 28.5552H92.1082C92.2087 29.7977 92.9577 30.3827 94.3917 30.3827C95.8257 30.3827 96.5747 29.9532 96.5747 29.0484C96.5747 28.3174 96.0997 28.0799 94.885 27.6504L93.5697 27.2027C91.9347 26.6544 90.583 26.1062 90.583 24.3335C90.583 22.3506 92.2452 21.3455 94.3277 21.3455C96.4105 21.3455 98.146 22.2135 98.1642 24.635H96.3372C96.2735 23.4563 95.424 22.9628 94.2912 22.9628C92.9395 22.9628 92.3915 23.4288 92.3915 24.1781C92.3915 24.9274 92.8207 25.0919 94.0355 25.4939L95.8625 26.1609C97.2965 26.6727 98.2647 27.3214 98.2647 28.8567C98.2647 31.1774 96.3555 31.9999 94.337 31.9999C92.1357 31.9817 90.2815 31.0679 90.2815 28.5552Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M145.506 21.583H146.575C146.706 21.583 146.836 21.6091 146.958 21.6597C147.079 21.7103 147.189 21.7845 147.282 21.878C147.374 21.9714 147.447 22.0823 147.497 22.2042C147.546 22.3261 147.571 22.4566 147.57 22.5882V23.2095H145.506V21.583Z",
        fill: "#00C0A5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M118.889 21.583H117.83V31.7259H119.894V22.5882C119.896 22.4576 119.871 22.328 119.819 22.2082C119.767 22.0884 119.69 21.9812 119.593 21.8937C119.502 21.7979 119.393 21.721 119.272 21.6677C119.151 21.6144 119.021 21.5856 118.889 21.583Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M124.36 23.7579C123.87 23.7311 123.38 23.8149 122.926 24.0032C122.472 24.1914 122.067 24.4791 121.739 24.8452C121.084 25.6846 120.759 26.7343 120.825 27.7966C120.743 28.8863 121.069 29.9676 121.739 30.8303C122.067 31.1988 122.474 31.4888 122.929 31.6786C123.385 31.8683 123.877 31.9533 124.369 31.9268C125.187 31.9561 125.991 31.7188 126.662 31.2508C127.315 30.7853 127.773 30.0956 127.95 29.3136H126.47C126.277 29.3028 126.085 29.3541 125.922 29.4598C125.831 29.5203 125.756 29.6018 125.703 29.6973L125.548 29.8618C125.502 29.9088 125.446 29.9433 125.383 29.9623C125.121 30.1086 124.825 30.1813 124.525 30.1726C124.311 30.1896 124.097 30.1561 123.899 30.0753C123.7 29.9943 123.524 29.8681 123.383 29.7066C123.072 29.3231 122.912 28.8383 122.935 28.3451H128.032C128.05 28.2761 128.05 28.2036 128.032 28.1348V27.8151C128.107 26.7233 127.783 25.6418 127.119 24.7721C126.758 24.4155 126.326 24.1404 125.85 23.9655C125.374 23.7905 124.866 23.7197 124.36 23.7579ZM122.917 27.0566C122.905 26.6216 123.063 26.1991 123.356 25.8778C123.652 25.6126 124.036 25.4658 124.433 25.4658C124.831 25.4658 125.215 25.6126 125.511 25.8778C125.77 26.2168 125.914 26.6298 125.922 27.0566H122.917Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M134.865 24.3882C134.157 23.9619 133.343 23.7434 132.517 23.7577C131.692 23.7871 130.89 24.0398 130.197 24.4888C129.503 24.9456 129.156 25.8412 129.156 27.1752V31.7439H131.211V26.7184C131.194 26.5252 131.224 26.3309 131.297 26.1514C131.37 25.9719 131.485 25.8124 131.631 25.6857C131.89 25.4764 132.212 25.3607 132.545 25.3569C132.877 25.3639 133.198 25.4794 133.458 25.6857C133.608 25.8104 133.725 25.9694 133.8 26.1492C133.874 26.3292 133.905 26.5244 133.887 26.7184V30.7207C133.881 30.8467 133.9 30.9727 133.943 31.0914C133.985 31.2102 134.051 31.3194 134.135 31.4127C134.22 31.5062 134.323 31.5817 134.437 31.6354C134.551 31.6892 134.675 31.7199 134.801 31.7257H135.915V27.1569C135.952 25.7497 135.595 24.836 134.865 24.3882Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M143.222 21.5557H142.217V24.9184C141.99 24.5453 141.677 24.232 141.304 24.0046C140.902 23.8007 140.457 23.6972 140.007 23.7031C139.563 23.6963 139.124 23.7975 138.728 23.9981C138.332 24.1986 137.99 24.4925 137.733 24.8544C137.13 25.7268 136.831 26.7738 136.883 27.8333C136.824 28.8933 137.123 29.9426 137.733 30.8121C138.041 31.1891 138.449 31.4711 138.911 31.6253C139.396 31.7893 139.905 31.8726 140.418 31.8721C141.344 31.8808 142.254 31.6241 143.039 31.1318C143.843 30.6476 144.245 29.6973 144.245 28.3083V22.5609C144.245 22.4315 144.219 22.3035 144.168 22.1843C144.118 22.0651 144.045 21.9571 143.953 21.8664C143.862 21.7629 143.749 21.6813 143.623 21.6275C143.496 21.5737 143.359 21.5492 143.222 21.5557ZM141.806 29.5421C141.671 29.7428 141.487 29.9056 141.271 30.0143C141.055 30.1233 140.815 30.1746 140.573 30.1633C140.326 30.1748 140.081 30.1238 139.859 30.0153C139.637 29.9066 139.446 29.7438 139.304 29.5421C138.972 28.9928 138.819 28.3543 138.865 27.7146C138.833 27.1336 138.987 26.5576 139.304 26.0696C139.437 25.8716 139.618 25.7106 139.831 25.6018C140.043 25.4931 140.28 25.4403 140.518 25.4483C140.761 25.4401 141.001 25.4896 141.22 25.5928C141.44 25.6963 141.631 25.8503 141.779 26.0423C142.096 26.5403 142.249 27.1251 142.217 27.7146C142.263 28.3508 142.12 28.9868 141.806 29.5421Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M147.278 24.1783C147.189 24.0818 147.079 24.0057 146.958 23.9552C146.837 23.9048 146.706 23.8811 146.575 23.8859H145.506V31.7259H147.57V24.891C147.576 24.7581 147.553 24.6254 147.503 24.5023C147.452 24.3792 147.375 24.2686 147.278 24.1783Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M115.226 24.2604L110.76 21.2724C110.608 21.1683 110.428 21.1125 110.244 21.1125C110.06 21.1125 109.88 21.1683 109.728 21.2724L105.161 24.2604C105.026 24.3443 104.916 24.4617 104.841 24.6011C104.766 24.7404 104.728 24.897 104.731 25.0553V30.9401C104.731 31.1824 104.828 31.4148 104.999 31.5861C105.17 31.7573 105.402 31.8538 105.645 31.8538H114.715C114.957 31.8538 115.189 31.7573 115.361 31.5861C115.532 31.4148 115.628 31.1824 115.628 30.9401V25.0461C115.629 24.8926 115.593 24.7411 115.523 24.6043C115.453 24.4676 115.351 24.3496 115.226 24.2604ZM113.747 29.9806H111.107V27.2393H109.216V29.9806H106.567V25.5854L110.221 23.2095L113.756 25.5854L113.747 29.9806Z",
        fill: "#00C0A5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M104.841 12.8933H106.668C107.727 12.8933 108.202 13.4507 108.202 14.2365C108.218 14.419 108.195 14.6028 108.134 14.7755C108.072 14.9482 107.975 15.1057 107.848 15.2374C107.72 15.3691 107.566 15.4719 107.396 15.5388C107.225 15.6058 107.042 15.6353 106.86 15.6255H105.526V17.6357H104.877L104.841 12.8933ZM106.668 15.0041C106.773 15.0182 106.881 15.0083 106.982 14.9753C107.084 14.9422 107.177 14.8868 107.254 14.8132C107.331 14.7395 107.39 14.6494 107.428 14.5496C107.466 14.4498 107.481 14.3428 107.472 14.2365C107.472 13.7705 107.134 13.5055 106.558 13.5055H105.435V15.0041H106.668Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M108.705 15.9268C108.675 15.6987 108.694 15.4667 108.761 15.2465C108.828 15.0263 108.941 14.8229 109.093 14.65C109.244 14.477 109.431 14.3384 109.641 14.2434C109.851 14.1485 110.078 14.0994 110.308 14.0994C110.538 14.0994 110.765 14.1485 110.975 14.2434C111.185 14.3384 111.371 14.477 111.523 14.65C111.675 14.8229 111.788 15.0263 111.855 15.2465C111.922 15.4667 111.941 15.6987 111.911 15.9268C111.936 16.1546 111.914 16.3852 111.845 16.6039C111.776 16.8225 111.663 17.0243 111.511 17.1964C111.36 17.3685 111.174 17.507 110.966 17.6031C110.758 17.6992 110.532 17.7507 110.303 17.7544C110.074 17.7523 109.848 17.7017 109.639 17.606C109.431 17.5103 109.245 17.3716 109.094 17.199C108.944 17.0264 108.831 16.8239 108.764 16.6046C108.696 16.3854 108.676 16.1544 108.705 15.9268ZM111.317 15.9268C111.317 15.1958 110.915 14.6841 110.303 14.6841C109.691 14.6841 109.298 15.1958 109.298 15.9268C109.298 16.6579 109.691 17.1604 110.303 17.1604C110.915 17.1604 111.317 16.6579 111.317 15.9268Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M112.504 14.209H113.126L113.747 16.9503L114.496 14.209H115.162L115.875 16.9503L116.523 14.209H117.135L116.222 17.6356H115.564L115.144 16.1096L114.852 15.0131L114.56 16.1187L114.121 17.6356H113.473L112.504 14.209Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M119.282 17.1513C119.464 17.176 119.65 17.1343 119.804 17.0336C119.958 16.9329 120.071 16.7801 120.122 16.603H120.707C120.645 16.932 120.465 17.2269 120.201 17.4323C119.937 17.6376 119.607 17.7392 119.273 17.7178C119.042 17.7204 118.814 17.6729 118.604 17.5786C118.394 17.4843 118.207 17.3454 118.056 17.1716C117.905 16.9977 117.793 16.7931 117.729 16.5719C117.664 16.3507 117.649 16.1181 117.683 15.8903C117.657 15.6638 117.677 15.4341 117.745 15.2161C117.812 14.9981 117.924 14.7966 118.074 14.6245C118.223 14.4524 118.407 14.3135 118.614 14.2167C118.82 14.12 119.045 14.0676 119.273 14.0628C119.489 14.061 119.703 14.1056 119.901 14.1936C120.099 14.2815 120.275 14.4107 120.419 14.5726C120.562 14.7344 120.67 14.9252 120.734 15.132C120.797 15.3388 120.816 15.5568 120.789 15.7715C120.789 15.8629 120.789 15.9817 120.789 16.0639H118.295C118.283 16.2014 118.299 16.3401 118.343 16.471C118.386 16.602 118.457 16.7224 118.55 16.8247C118.642 16.9269 118.755 17.0088 118.881 17.065C119.007 17.1212 119.144 17.1506 119.282 17.1513ZM118.305 15.5979H120.177C120.177 15.3555 120.081 15.1231 119.909 14.9518C119.738 14.7804 119.506 14.6841 119.264 14.6841C119.14 14.6779 119.016 14.697 118.9 14.7401C118.784 14.7833 118.678 14.8496 118.588 14.9351C118.498 15.0205 118.427 15.1234 118.378 15.2373C118.329 15.3513 118.304 15.474 118.305 15.5979Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M121.712 14.209H122.287V14.6202C122.396 14.4662 122.542 14.3415 122.711 14.257C122.879 14.1726 123.066 14.131 123.255 14.1359H123.511V14.7207H123.191C123.058 14.719 122.926 14.7465 122.804 14.8012C122.683 14.856 122.575 14.9367 122.488 15.0377C122.401 15.1388 122.337 15.2576 122.3 15.386C122.264 15.5143 122.256 15.649 122.278 15.7807V17.6082H121.684L121.712 14.209Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M125.575 17.1514C125.757 17.1778 125.942 17.1365 126.095 17.0354C126.248 16.9344 126.359 16.7805 126.406 16.6032H127.037C126.975 16.9321 126.795 17.227 126.531 17.4324C126.267 17.6377 125.936 17.7393 125.603 17.7179C125.373 17.7208 125.145 17.6733 124.935 17.5789C124.725 17.4845 124.539 17.3455 124.388 17.1714C124.238 16.9974 124.127 16.7926 124.064 16.5713C124.001 16.3501 123.986 16.1177 124.022 15.8904C123.996 15.6646 124.016 15.4357 124.083 15.2183C124.15 15.001 124.261 14.7999 124.409 14.6279C124.558 14.4559 124.741 14.3169 124.946 14.2196C125.152 14.1223 125.375 14.0689 125.603 14.0629C125.82 14.0598 126.035 14.1035 126.234 14.1908C126.432 14.2782 126.61 14.4072 126.755 14.5692C126.899 14.7312 127.008 14.9224 127.072 15.1299C127.136 15.3373 127.155 15.5562 127.128 15.7716C127.128 15.863 127.128 15.9818 127.128 16.064H124.634C124.622 16.1978 124.637 16.3327 124.678 16.4607C124.719 16.5886 124.785 16.7069 124.873 16.8085C124.961 16.9101 125.068 16.9929 125.189 17.0518C125.31 17.1107 125.441 17.1446 125.575 17.1514ZM124.589 15.598H126.461C126.461 15.3557 126.365 15.1233 126.194 14.9519C126.022 14.7805 125.79 14.6843 125.548 14.6843C125.424 14.6781 125.3 14.6971 125.184 14.7402C125.068 14.7834 124.962 14.8497 124.872 14.9352C124.782 15.0207 124.711 15.1235 124.662 15.2374C124.614 15.3514 124.589 15.4741 124.589 15.598Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M130.873 12.875V17.6357H130.307V17.2793C130.19 17.4275 130.04 17.5454 129.868 17.6233C129.696 17.7012 129.509 17.7368 129.32 17.7271C128.407 17.7271 127.813 17.0326 127.813 15.8996C127.778 15.6776 127.791 15.4506 127.85 15.2339C127.91 15.0171 128.015 14.8156 128.158 14.6426C128.302 14.4697 128.48 14.3293 128.682 14.2309C128.884 14.1325 129.105 14.0783 129.329 14.072C129.51 14.0674 129.69 14.1026 129.856 14.1753C130.022 14.2479 130.169 14.3562 130.288 14.4923V12.875H130.873ZM130.288 15.9087C130.288 15.1411 129.905 14.6751 129.375 14.6751C128.845 14.6751 128.462 15.2051 128.462 15.9087C128.462 16.6123 128.836 17.1605 129.375 17.1605C129.914 17.1605 130.288 16.7128 130.288 15.9178V15.9087Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M136.92 15.9087C136.92 16.9778 136.308 17.7362 135.431 17.7362C135.237 17.746 135.043 17.7087 134.867 17.6276C134.69 17.5465 134.536 17.4238 134.417 17.2702V17.6448H133.851V12.875H134.444V14.5563C134.568 14.4134 134.723 14.3005 134.897 14.2261C135.071 14.1517 135.26 14.1178 135.449 14.1269C136.335 14.1177 136.92 14.8579 136.92 15.9087ZM136.317 15.9087C136.317 15.2051 135.97 14.6751 135.403 14.6751C134.837 14.6751 134.408 15.1411 134.417 15.9087C134.426 16.6763 134.819 17.1605 135.394 17.1605C135.97 17.1605 136.308 16.6306 136.308 15.8996L136.317 15.9087Z",
        fill: "#8E8E8E"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M137.778 18.4854H138.262C138.401 18.4935 138.538 18.4583 138.655 18.3849C138.697 18.3508 138.73 18.3075 138.753 18.2583C138.775 18.2092 138.785 18.1555 138.783 18.1016C138.775 17.9321 138.738 17.7652 138.673 17.6082L137.449 14.209H138.144L138.71 15.9817L139.139 17.2609L139.505 15.9817L139.98 14.209H140.628L139.377 18.2204C139.176 18.8509 138.92 19.0519 138.408 19.0519H137.778V18.4854Z",
        fill: "#8E8E8E"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_601_1214",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "147.5",
          height: "32",
          fill: "white",
          transform: "translate(0.0739746)"
        })
      })
    })]
  })
}));
var DomainTeamView = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    viewBox: "0 0 393 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#domain-home-loans-team-view-logo_svg__clip0)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M190.207 47.955V29.679c0-11.257-6.942-14.62-15.82-14.62-9.5 0-15.711 4.935-15.784 13.122h7.307c0-4.094 2.594-6.36 8.659-6.36 6.065 0 8.404 2.814 8.404 5.483 0 2.668-.293 3.399-4.312 4.13l-8.732 1.645c-7.636 1.425-13.189 4.897-13.189 12.902a11.997 11.997 0 003.957 8.653 11.984 11.984 0 009.013 3.043 16.217 16.217 0 0013.811-6.177v.84c0 2.815 1.644 4.314 4.64 4.314h5.736v-5.958h-.95c-2.046 0-2.74-.768-2.74-2.741zm-7.015-7.055a10.97 10.97 0 01-7.532 9.764 10.955 10.955 0 01-4.306.507c-4.348 0-6.686-2.193-6.686-5.812 0-3.618 2.521-5.336 8.148-6.506l7.014-1.498a11.214 11.214 0 003.362-1.206V40.9zM18.268.33H0v56.323h17.61c17.355 0 28.827-11.842 28.827-28.216 0-18.385-13.19-28.108-28.169-28.108zm-.694 49.342H7.709V7.31h9.098c12.897 0 21.921 6.981 21.921 21.09A19.89 19.89 0 0125.94 48.427a19.867 19.867 0 01-8.33 1.245h-.036zM205.442 16.119h-7.015v40.534h7.015V16.118zM201.935 0a4.75 4.75 0 00-4.75 4.752 4.751 4.751 0 004.75 4.751 4.75 4.75 0 004.749-4.751A4.751 4.751 0 00201.935 0zM136.864 14.364l-12.532 8.553-12.605-8.553-9.024 6.14v-4.349h-7.052v40.498h7.052V29.021l9.024-6.14 9.025 6.14v27.632h7.015V29.021l9.097-6.14 9.061 6.14v27.632h7.052V25.22l-16.113-10.856zM70.697 15.059a20.78 20.78 0 00-15.214 6.188 20.8 20.8 0 00-5.977 15.304 20.77 20.77 0 006.02 15.219 20.754 20.754 0 0015.171 6.126 20.784 20.784 0 0019.766-13.115 20.805 20.805 0 001.462-8.23A20.877 20.877 0 0078.94 16.597a20.857 20.857 0 00-8.243-1.538zm0 35.527a14.172 14.172 0 01-13.11-8.789 14.187 14.187 0 013.139-15.472A14.174 14.174 0 0184.873 36.55a14.184 14.184 0 01-4.203 9.933 14.173 14.173 0 01-9.973 4.102zM230.469 15.095a14.608 14.608 0 00-11.582 5.19V16.12h-6.978v40.534h7.051V31.068a9.791 9.791 0 019.792-9.796 9.71 9.71 0 016.922 2.86 9.72 9.72 0 012.833 6.936v25.585h7.052V31.068c-.073-9.394-5.663-15.973-15.09-15.973z",
        fill: "#0EA800"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 70.543h7.71V94.52h27.657V70.543h7.855v56.36h-7.855v-25.329H7.709v25.293H0V70.542zM49.872 106.618c0-11.696 7.307-21.309 18.925-21.309 11.619 0 18.89 9.21 18.89 21.309 0 12.098-7.308 21.309-18.89 21.309-11.581 0-18.925-9.138-18.925-21.309zm30.873 0c0-8.662-4.713-14.62-11.948-14.62-7.234 0-11.874 6.03-11.874 14.62 0 8.589 4.64 14.62 11.874 14.62 7.235 0 11.948-5.884 11.948-14.62zM93.167 86.259h6.832v4.093a12.784 12.784 0 0110.705-5.044 11.651 11.651 0 0111.326 6.36 14.034 14.034 0 0112.386-6.36c8.805 0 14.614 6.068 14.614 16.119v25.586h-7.234v-24.051c0-6.615-3.069-10.782-8.732-10.782-5.663 0-8.549 4.715-8.549 10.965v23.831h-6.979v-24.123c0-6.616-3.032-10.783-8.622-10.783s-8.659 4.496-8.659 10.271v24.452h-7.088V86.259zM172.998 121.165a9.06 9.06 0 009.901-6.542h7.088a16.297 16.297 0 01-17.171 13.304c-10.669 0-18.78-7.31-18.78-21.309 0-12.72 8.038-21.309 18.78-21.309 11.326 0 18.012 8.26 18.012 20.286v3.472h-29.631a11.739 11.739 0 007.204 11.193 11.72 11.72 0 004.597.905zm-11.618-18.494h22.141a10.567 10.567 0 00-6.637-9.846 10.553 10.553 0 00-4.105-.754 10.96 10.96 0 00-11.399 10.6zM203.725 70.543h7.673v49.05h28.059v7.31h-35.732v-56.36zM240.334 106.618c0-11.696 7.307-21.309 18.926-21.309 11.618 0 18.999 9.21 18.999 21.309 0 12.098-7.381 21.309-18.853 21.309-11.472 0-19.072-9.138-19.072-21.309zm30.873 0c0-8.662-4.713-14.62-11.947-14.62-7.234 0-11.874 6.03-11.874 14.62 0 8.589 4.64 14.62 11.874 14.62 7.234 0 11.947-5.958 11.947-14.62zM280.743 116.194c0-8.004 5.59-11.477 13.189-12.866l8.732-1.681c3.654-.694 4.312-1.864 4.312-4.057 0-2.193-1.864-5.52-8.404-5.52s-8.732 2.267-8.659 6.36h-7.307c0-8.15 6.284-13.12 15.784-13.12 8.878 0 15.783 3.215 15.783 14.62v18.274c0 1.974.694 2.742 2.74 2.742h.95v5.994h-5.699c-2.996 0-4.64-1.499-4.64-4.313v-.914a16.155 16.155 0 01-13.811 6.214 12.005 12.005 0 01-9.015-3.068 12.02 12.02 0 01-3.955-8.665zm26.488-5.08v-4.825a10.935 10.935 0 01-3.397 1.206l-6.979 1.499c-5.663 1.169-8.184 2.741-8.184 6.506 0 3.764 2.375 5.811 6.686 5.811a10.957 10.957 0 0011.874-10.197zM322.467 86.332h6.832v4.167a15.088 15.088 0 0111.801-5.19c9.427 0 14.98 6.14 14.98 16.593v25.001h-7.051v-23.831c0-7.054-3.654-10.965-8.732-10.965a10.956 10.956 0 00-10.404 7.401 10.96 10.96 0 00-.557 4.478v22.954h-6.869V86.332zM360.83 114.22h7.307c.402 4.971 3.398 7.311 9.134 7.311 5.736 0 8.732-1.718 8.732-5.337 0-2.924-1.9-3.874-6.759-5.592l-5.261-1.791c-6.54-2.193-11.947-4.386-11.947-11.477 0-7.931 6.649-11.952 14.979-11.952 8.331 0 15.272 3.472 15.346 13.158h-7.308c-.255-4.715-3.653-6.688-8.184-6.688-5.407 0-7.599 1.864-7.599 4.86 0 2.998 1.717 3.656 6.576 5.264l7.307 2.668c5.737 2.047 9.609 4.642 9.609 10.783 0 9.283-7.636 12.573-15.71 12.573-8.805-.073-16.222-3.728-16.222-13.78z",
        fill: "#fff"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "domain-home-loans-team-view-logo_svg__clip0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          d: "M0 0h392.762v128H0z"
        })
      })
    })]
  })
}));
var DomainLogoMark = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#29AB54",
      d: "M16.042 2.023 5 9.297v.86V9.5 30h12.92l1.29-1.968-1.29-1.969H8.926V11.39l7.104-4.684V2l.012.023Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#fff",
      d: "M23.146 30V11.413l-7.105-4.684V2.034h.012l11.019 7.263V30h-3.926Z"
    })]
  })
}));

var AussieLogoWide = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    viewBox: "0 0 131 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_702_410)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M113.053 6.54504C113.053 6.31457 112.863 6.12314 112.632 6.12314H109.303C109.07 6.12314 108.88 6.31457 108.88 6.54504V23.206C108.88 23.443 109.07 23.6289 109.303 23.6289H112.632C112.863 23.6289 113.053 23.443 113.053 23.206V6.54504Z",
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M87.805 15.3026L83.4449 12.3982C82.4359 11.698 81.9816 11.1153 82.0854 10.4712C82.3444 8.98622 84.4237 9.28348 84.4237 9.28348C86.2847 9.35328 88.1819 9.64888 90.0179 10.0123C90.208 10.048 90.3582 9.93435 90.3552 9.75603C90.3433 8.90331 90.3297 8.05285 90.3114 7.19996C90.3071 7.02296 90.1536 6.84651 89.9677 6.80912C87.8557 6.3914 85.7156 6.17139 83.5742 6.14761C83.5742 6.14761 78.2301 6.16641 78.2301 10.5179C78.2301 11.8414 78.7283 13.3688 80.4617 14.6198L80.4574 14.6237L85.0358 17.6686C86.1248 18.4092 86.6123 19.0064 86.5012 19.6734C86.243 21.1584 84.1633 20.8612 84.1633 20.8612C82.3006 20.7944 80.4064 20.4969 78.5692 20.1329C78.3803 20.0966 78.228 20.2116 78.2301 20.3886C78.2467 21.2402 78.2595 22.0918 78.2735 22.9447C78.2769 23.1217 78.4326 23.2994 78.6189 23.3355C80.7326 23.7508 82.874 23.9732 85.0116 24C85.0116 24 90.3552 23.9812 90.3552 19.6267C90.3552 18.2246 89.7988 16.5907 87.805 15.3026Z",
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M102.688 15.3026L98.3243 12.3982C97.3187 11.698 96.8601 11.1153 96.9699 10.4712C97.2281 8.98622 99.3022 9.28348 99.3022 9.28348C101.166 9.35328 103.063 9.64888 104.9 10.0123C105.09 10.048 105.241 9.93435 105.238 9.75603C105.221 8.90331 105.209 8.05285 105.193 7.19996C105.189 7.02296 105.034 6.84651 104.849 6.80912C102.738 6.3914 100.597 6.17139 98.4544 6.14761C98.4544 6.14761 93.1117 6.16641 93.1117 10.5179C93.1117 11.8414 93.6077 13.3688 95.3424 14.6198L95.3368 14.6237L99.9161 17.6686C101.005 18.4092 101.494 19.0064 101.381 19.6734C101.122 21.1584 99.0466 20.8612 99.0466 20.8612C97.1826 20.7944 95.2888 20.4969 93.4511 20.1329C93.2601 20.0966 93.1087 20.2116 93.1117 20.3886C93.1261 21.2402 93.141 22.0918 93.1584 22.9447C93.1597 23.1217 93.3133 23.2994 93.5009 23.3355C95.6138 23.7508 97.7521 23.9732 99.8973 24C99.8973 24 105.238 23.9812 105.238 19.6267C105.238 18.2246 104.679 16.5907 102.688 15.3026Z",
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M113.053 0.422871C113.053 0.189762 112.863 0.000807762 112.632 0.000807762H109.303C109.07 0.000807762 108.88 0.189762 108.88 0.422871V3.5775C108.88 3.80797 109.07 3.99939 109.303 3.99939H112.632C112.863 3.99939 113.053 3.80797 113.053 3.5775V0.422871Z",
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M74.4328 6.12466H71.1029C70.8732 6.12466 70.6843 6.31477 70.6843 6.54788V18.6036C70.683 18.6036 70.6809 18.6036 70.6796 18.6061C70.6796 18.9167 70.6541 19.0333 70.6388 19.072C69.6519 19.9747 68.5382 20.6616 66.6398 20.6616C64.4346 20.6616 64.5107 18.5177 64.5107 18.5177V16.6899H64.5035V6.54788C64.5035 6.31477 64.3172 6.12466 64.0837 6.12466H60.7529C60.5211 6.12466 60.3309 6.31477 60.3309 6.54788V16.7838C60.2944 17.7346 60.2459 23.9609 65.7469 23.9609C67.5399 23.9609 69.3933 23.0425 70.4542 22.2938C70.5567 22.2376 70.6694 22.2096 70.6843 22.353V23.2071C70.6843 23.4415 70.8732 23.6291 71.1029 23.6291H74.4328C74.6654 23.6291 74.8547 23.4415 74.8547 23.2071V6.54788C74.8547 6.31477 74.6654 6.12466 74.4328 6.12466Z",
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M130.498 16.4837C130.498 16.4837 130.712 16.4944 130.802 16.4071C130.886 16.3217 130.855 16.1677 130.855 16.1677V15.2412C130.858 11.9657 130.052 9.58743 128.591 8.02215C127.135 6.45671 125.197 5.94242 123.584 5.95603C120.804 5.90486 118.589 7.31925 117.502 9.22466C116.387 11.113 116.098 13.3019 116.089 15.3671C116.061 18.8683 117.309 21.3271 119.095 22.6543C120.763 23.9036 122.109 23.9759 123.328 23.9879L123.323 23.9972C123.409 23.9972 123.496 23.9892 123.586 23.9892C123.856 23.9854 124.133 23.9759 124.409 23.9623C126.187 23.8832 127.96 23.6855 129.716 23.3397C129.905 23.3021 130.057 23.127 130.061 22.95C130.076 22.1064 130.092 21.2586 130.104 20.4125C130.107 20.2374 129.956 20.1246 129.768 20.1619C127.972 20.5104 126.154 20.6887 124.332 20.758C124.26 20.758 124.187 20.7593 124.118 20.7593C123.246 20.7635 122.046 20.4968 121.233 19.8634C120.389 19.1939 119.871 18.2044 119.742 16.4837H129.093H130.498ZM119.739 13.4894C119.884 12.5132 120.15 11.6429 120.533 11.0231C121.18 10.0427 121.828 9.51133 123.584 9.46028C124.543 9.4696 125.358 9.71585 126.009 10.4111C126.506 10.9385 127.009 11.8692 127.22 13.4894H119.739Z",
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M58.1147 23.2205L52.9867 2.7236C52.9727 2.67924 52.9519 2.6407 52.931 2.60016C52.5767 1.62144 51.5349 0.850098 50.508 0.850098H47.5542C46.4499 0.850098 45.3295 1.7311 45.0568 2.80787L43.9402 7.27633C43.9334 7.2976 43.9334 7.3164 43.93 7.33635L39.9607 23.2205C39.9007 23.4724 40.0403 23.6813 40.2716 23.6813H43.599C43.8291 23.6813 44.0656 23.4724 44.1222 23.2205L45.4941 17.1078H52.5848L53.9541 23.2205C54.0132 23.4724 54.2446 23.6813 54.4785 23.6813H57.8059C58.0373 23.6813 58.1768 23.4724 58.1147 23.2205ZM46.1938 13.9771L48.0953 5.50339C48.2076 5.07332 48.5117 4.16126 49.0583 4.16126C49.7696 4.16126 49.8053 4.76029 50.0793 5.95982C50.0805 5.95982 50.0805 5.95982 50.0839 5.95867L51.8829 13.9771H46.1938Z",
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.8007 23.4532C32.8007 23.7548 32.5556 23.9998 32.2545 23.9998H0.546683C0.243265 23.9998 0 23.7548 0 23.4532V22.086C0 21.7823 0.243265 21.5369 0.546683 21.5369H32.2545C32.5556 21.5369 32.8007 21.7823 32.8007 22.086V23.4532Z",
        fill: "#FFD11F"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.8007 18.8121C32.8007 19.1124 32.5556 19.3591 32.2545 19.3591H0.546683C0.243265 19.3591 0 19.1124 0 18.8121V17.4411C0 17.1398 0.243265 16.8944 0.546683 16.8944H32.2545C32.5556 16.8944 32.8007 17.1398 32.8007 17.4411V18.8121Z",
        fill: "#FFD11F"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.3854 12.7569L32.3901 12.7505L17.7668 0.61229C17.7668 0.61229 17.1101 0.000974655 16.4538 0.000974655C15.831 0.000974655 15.1185 0.624925 15.1185 0.624925L0.42239 12.7569H0.429201C0.174805 12.9675 0.00681305 13.2784 0.00681305 13.6281C0.00681305 14.2546 0.53339 14.7668 1.17777 14.7668H1.18509H1.18675H31.6143L31.6176 14.7647C31.6214 14.7647 31.6292 14.7668 31.6364 14.7668C32.2834 14.7668 32.81 14.2546 32.81 13.6281C32.81 13.2784 32.6407 12.9675 32.3854 12.7569ZM28.1504 12.3046C28.1504 12.4072 28.0645 12.4919 27.9607 12.4919V12.4927H4.87959C4.87959 12.4927 4.88456 12.4911 4.89022 12.4911C4.8824 12.4911 4.87278 12.4919 4.86598 12.4919C4.76427 12.4919 4.68004 12.4072 4.68004 12.3046C4.68004 12.2391 4.7179 12.1805 4.77405 12.1478L15.9807 2.89408C15.9807 2.89408 16.2572 2.65365 16.4652 2.65365C16.6562 2.65365 16.9293 2.90854 16.9293 2.90854L28.0777 12.1634C28.1207 12.1958 28.1504 12.2481 28.1504 12.3046Z",
        fill: "#4B1F68"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_702_410",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "130.86",
          height: "24",
          fill: "white"
        })
      })
    })]
  })
}));
var AussieLogoWideNegative = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    viewBox: "0 0 131 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_702_214)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M113.053 6.54504C113.053 6.31457 112.863 6.12314 112.632 6.12314H109.303C109.07 6.12314 108.88 6.31457 108.88 6.54504V23.206C108.88 23.443 109.07 23.6289 109.303 23.6289H112.632C112.863 23.6289 113.053 23.443 113.053 23.206V6.54504Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M87.805 15.3026L83.4449 12.3982C82.4359 11.698 81.9816 11.1153 82.0849 10.4712C82.344 8.98622 84.4237 9.28348 84.4237 9.28348C86.2847 9.35328 88.1819 9.64888 90.0178 10.0123C90.208 10.048 90.3577 9.93435 90.3552 9.75603C90.3433 8.90331 90.3297 8.05285 90.3109 7.19996C90.3067 7.02296 90.1535 6.84651 89.9677 6.80912C87.8561 6.3914 85.7151 6.17139 83.5738 6.14761C83.5738 6.14761 78.2297 6.16641 78.2297 10.5179C78.2297 11.8414 78.7282 13.3688 80.4617 14.6198L80.4574 14.6237L85.0358 17.6686C86.1248 18.4092 86.6123 19.0064 86.5012 19.6734C86.2434 21.1584 84.1633 20.8612 84.1633 20.8612C82.3006 20.7944 80.4064 20.4969 78.5687 20.1329C78.3803 20.0966 78.2276 20.2116 78.2297 20.3886C78.2463 21.2402 78.2595 22.0918 78.2731 22.9447C78.2765 23.1217 78.4326 23.2994 78.6185 23.3355C80.7322 23.7508 82.8736 23.9732 85.0115 24C85.0115 24 90.3552 23.9812 90.3552 19.6267C90.3552 18.2246 89.7992 16.5907 87.805 15.3026Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M102.688 15.3026L98.3243 12.3982C97.3187 11.698 96.8601 11.1153 96.9699 10.4712C97.2281 8.98622 99.3022 9.28348 99.3022 9.28348C101.166 9.35328 103.063 9.64888 104.9 10.0123C105.09 10.048 105.241 9.93435 105.238 9.75603C105.221 8.90331 105.209 8.05285 105.193 7.19996C105.189 7.02296 105.034 6.84651 104.849 6.80912C102.738 6.3914 100.597 6.17139 98.454 6.14761C98.454 6.14761 93.1116 6.16641 93.1116 10.5179C93.1116 11.8414 93.6076 13.3688 95.3424 14.6198L95.3368 14.6237L99.9161 17.6686C101.005 18.4092 101.494 19.0064 101.381 19.6734C101.122 21.1584 99.0466 20.8612 99.0466 20.8612C97.1825 20.7944 95.2887 20.4969 93.4511 20.1329C93.2601 20.0966 93.1087 20.2116 93.1116 20.3886C93.1261 21.2402 93.141 22.0918 93.1584 22.9447C93.1597 23.1217 93.3133 23.2994 93.5005 23.3355C95.6137 23.7508 97.7521 23.9732 99.8973 24C99.8973 24 105.238 23.9812 105.238 19.6267C105.238 18.2246 104.679 16.5907 102.688 15.3026Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M113.053 0.422871C113.053 0.189762 112.863 0.000807762 112.632 0.000807762H109.303C109.07 0.000807762 108.88 0.189762 108.88 0.422871V3.5775C108.88 3.80797 109.07 3.99939 109.303 3.99939H112.632C112.863 3.99939 113.053 3.80797 113.053 3.5775V0.422871Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M74.4332 6.12466H71.1033C70.8731 6.12466 70.6847 6.31477 70.6847 6.54788V18.6036C70.6834 18.6036 70.6813 18.6036 70.6796 18.6061C70.6796 18.9167 70.6541 19.0333 70.6392 19.072C69.6523 19.9747 68.5382 20.6616 66.6393 20.6616C64.4346 20.6616 64.5103 18.5177 64.5103 18.5177V16.6899H64.5035V6.54788C64.5035 6.31477 64.3172 6.12466 64.0836 6.12466H60.7529C60.5211 6.12466 60.3314 6.31477 60.3314 6.54788V16.7838C60.2948 17.7346 60.2454 23.9609 65.7473 23.9609C67.5407 23.9609 69.3932 23.0425 70.4541 22.2938C70.5567 22.2376 70.6694 22.2096 70.6847 22.353V23.2071C70.6847 23.4415 70.8731 23.6291 71.1033 23.6291H74.4332C74.6658 23.6291 74.8547 23.4415 74.8547 23.2071V6.54788C74.8547 6.31477 74.6658 6.12466 74.4332 6.12466Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M130.498 16.4837C130.498 16.4837 130.712 16.4944 130.802 16.4071C130.886 16.3217 130.855 16.1677 130.855 16.1677V15.2412C130.858 11.9657 130.052 9.58743 128.591 8.02215C127.135 6.45671 125.197 5.94242 123.584 5.95603C120.804 5.90486 118.589 7.31925 117.502 9.22466C116.387 11.113 116.098 13.3019 116.089 15.3671C116.061 18.8683 117.309 21.3271 119.095 22.6543C120.763 23.9036 122.109 23.9759 123.328 23.9879L123.323 23.9972C123.409 23.9972 123.496 23.9892 123.586 23.9892C123.856 23.9854 124.133 23.9759 124.409 23.9623C126.187 23.8832 127.96 23.6855 129.716 23.3397C129.905 23.3021 130.057 23.127 130.061 22.95C130.076 22.1064 130.092 21.2586 130.104 20.4125C130.107 20.2374 129.956 20.1246 129.768 20.1619C127.972 20.5104 126.154 20.6887 124.332 20.758C124.26 20.758 124.187 20.7593 124.118 20.7593C123.246 20.7635 122.046 20.4968 121.233 19.8634C120.389 19.1939 119.871 18.2044 119.742 16.4837H129.093H130.498ZM119.74 13.4894C119.884 12.5132 120.15 11.6429 120.533 11.0231C121.18 10.0427 121.828 9.51133 123.584 9.46028C124.543 9.4696 125.358 9.71585 126.009 10.4111C126.506 10.9385 127.009 11.8692 127.22 13.4894H119.74Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M58.1147 23.2205L52.9867 2.7236C52.9727 2.67924 52.9519 2.6407 52.931 2.60016C52.5767 1.62144 51.5349 0.850098 50.508 0.850098H47.5542C46.4499 0.850098 45.3295 1.7311 45.0568 2.80787L43.9402 7.27633C43.9334 7.2976 43.9334 7.3164 43.9299 7.33635L39.9607 23.2205C39.9007 23.4724 40.0403 23.6813 40.2716 23.6813H43.599C43.8291 23.6813 44.0661 23.4724 44.1222 23.2205L45.4941 17.1078H52.5848L53.9541 23.2205C54.0132 23.4724 54.2446 23.6813 54.4785 23.6813H57.8059C58.0373 23.6813 58.1768 23.4724 58.1147 23.2205ZM46.1938 13.9771L48.0953 5.50339C48.2076 5.07332 48.5117 4.16126 49.0583 4.16126C49.7696 4.16126 49.8053 4.76029 50.0793 5.95982C50.0805 5.95982 50.0805 5.95982 50.0839 5.95867L51.8829 13.9771H46.1938Z",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.8007 23.4532C32.8007 23.7548 32.5556 23.9998 32.2545 23.9998H0.546683C0.243265 23.9998 0 23.7548 0 23.4532V22.086C0 21.7823 0.243265 21.5369 0.546683 21.5369H32.2545C32.5556 21.5369 32.8007 21.7823 32.8007 22.086V23.4532Z",
        fill: "#FFD11F"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.8007 18.8121C32.8007 19.1124 32.5556 19.3591 32.2545 19.3591H0.546683C0.243265 19.3591 0 19.1124 0 18.8121V17.4411C0 17.1398 0.243265 16.8944 0.546683 16.8944H32.2545C32.5556 16.8944 32.8007 17.1398 32.8007 17.4411V18.8121Z",
        fill: "#FFD11F"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.3854 12.7569L32.3902 12.7505L17.767 0.61229C17.767 0.61229 17.1101 0.000974655 16.4538 0.000974655C15.831 0.000974655 15.1185 0.624925 15.1185 0.624925L0.422383 12.7569H0.429194C0.174798 12.9675 0.00680542 13.2784 0.00680542 13.6281C0.00680542 14.2546 0.533382 14.7668 1.17793 14.7668H1.18475H1.18674H31.6139L31.6178 14.7647C31.6216 14.7647 31.6292 14.7668 31.6364 14.7668C32.2834 14.7668 32.81 14.2546 32.81 13.6281C32.81 13.2784 32.6407 12.9675 32.3854 12.7569ZM28.1504 12.3046C28.1504 12.4072 28.0645 12.4919 27.9607 12.4919V12.4927H4.87958C4.87958 12.4927 4.88456 12.4911 4.89021 12.4911C4.88256 12.4911 4.87277 12.4919 4.86597 12.4919C4.76426 12.4919 4.68003 12.4072 4.68003 12.3046C4.68003 12.2391 4.71789 12.1805 4.77404 12.1478L15.9807 2.89408C15.9807 2.89408 16.2572 2.65365 16.4652 2.65365C16.6562 2.65365 16.9293 2.90854 16.9293 2.90854L28.0776 12.1634C28.1207 12.1958 28.1504 12.2481 28.1504 12.3046Z",
        fill: "white"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_702_214",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "130.86",
          height: "24",
          fill: "white"
        })
      })
    })]
  })
}));
var AussieLogoIconNegative = props => /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, logo_esm_objectSpread2(logo_esm_objectSpread2({}, props), {}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#FFC800",
      d: "M22.39 20.06a.35.35 0 0 1-.35.35H1.745a.35.35 0 0 1-.35-.35v-.873a.35.35 0 0 1 .35-.352H22.04a.35.35 0 0 1 .35.351v.875ZM22.39 17.093a.35.35 0 0 1-.35.35H1.745a.35.35 0 0 1-.35-.35v-.876a.35.35 0 0 1 .35-.35H22.04a.35.35 0 0 1 .35.35v.876Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#fff",
      d: "m22.123 13.222.003-.005-9.36-7.76s-.42-.392-.84-.392c-.398 0-.854.4-.854.4l-9.407 7.757h.005a.724.724 0 0 0-.27.556c0 .401.336.729.749.729H21.63l.002-.002.012.002a.741.741 0 0 0 .751-.729.724.724 0 0 0-.272-.556Zm-2.71-.29c0 .066-.055.12-.122.12H4.518h.007-.016a.12.12 0 0 1-.119-.12c0-.041.025-.08.06-.1l7.173-5.917s.177-.153.31-.153c.123 0 .298.162.298.162l7.135 5.918c.027.02.047.054.047.09Z"
    })]
  })
}));

var _excluded = ["variant", "width", "height", "className", "isExpanded", "isTeamView", "brand"];
var Logo = _ref => {
  var {
    variant = 'dark',
    width = '160px',
    height = '100px',
    className,
    isExpanded = true,
    isTeamView = false,
    brand
  } = _ref,
      otherProps = logo_esm_objectWithoutProperties(_ref, _excluded);

  var themeName = brand !== null && brand !== void 0 ? brand : (0,commons_esm/* getThemeName */.Yo)();
  var isLight = variant === 'light';
  var color = variant === 'dark' ? '#083742' : '#fff';

  if (themeName === 'lendi' || themeName === 'lendi-next') {
    if (!isExpanded) return /*#__PURE__*/(0,jsx_runtime.jsx)(LendiLogoMark, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
    if (isTeamView) return /*#__PURE__*/(0,jsx_runtime.jsx)(Lendi, logo_esm_objectSpread2({
      color: "#fff",
      width: width,
      height: height,
      className: className
    }, otherProps));
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Lendi, logo_esm_objectSpread2({
      color: color,
      width: width,
      height: height,
      className: className
    }, otherProps));
  }

  if (themeName === 'domain') {
    if (!isExpanded) return /*#__PURE__*/(0,jsx_runtime.jsx)(DomainLogoMark, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
    if (isTeamView) return /*#__PURE__*/(0,jsx_runtime.jsx)(DomainTeamView, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
    if (isLight) return /*#__PURE__*/(0,jsx_runtime.jsx)(DomainHomeLoansNegative, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DomainHomeLoans, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
  }

  if (themeName === 'aussie') {
    if (!isExpanded) return /*#__PURE__*/(0,jsx_runtime.jsx)(AussieLogoIconNegative, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
    if (isTeamView || isLight) return /*#__PURE__*/(0,jsx_runtime.jsx)(AussieLogoWideNegative, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
    return /*#__PURE__*/(0,jsx_runtime.jsx)(AussieLogoWide, logo_esm_objectSpread2({
      width: width,
      height: height,
      className: className
    }, otherProps));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Lendi, logo_esm_objectSpread2({
    color: color,
    width: width,
    height: height,
    className: className
  }, otherProps));
};



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spacing/dist/spacing.esm.js
var spacing_esm = __webpack_require__(84209);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/Theme/dist/ui.esm.js
var ui_esm = __webpack_require__(55354);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/alert/dist/alert.esm.js + 3 modules
var alert_esm = __webpack_require__(71400);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/button/dist/button.esm.js
var button_esm = __webpack_require__(22294);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/dist/Icon-e9280b89.esm.js
var Icon_e9280b89_esm = __webpack_require__(95087);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/UnreadMessage/dist/icon.esm.js






function SvgUnreadMessage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      viewBox: "0 0 26 27",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "translate(-2)",
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          className: "unread-message_svg__fillPath",
          d: "M20 7H4c-1.1 0-1.99.9-1.99 2L2 27l4-4h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6v-2h12v2zm0-3H6v-2h12v2z",
          fill: "#90ee90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          fill: "#E02020",
          cx: 23,
          cy: 5,
          r: 5
        })]
      })
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/MoreVert/dist/icon.esm.js






function SvgMoreVert(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/Brand.js
var Brand_Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(Brand_Brand || (Brand_Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/Type.js
var Type_Type;
(function (Type) {
    Type["Customer"] = "customer";
    Type["Team"] = "team";
})(Type_Type || (Type_Type = {}));
//# sourceMappingURL=Type.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/Environment.js
var Environment_Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Preproduction"] = "preproduction";
    Environment["Production"] = "production";
})(Environment_Environment || (Environment_Environment = {}));
var getEnv = function (environment) {
    var env = environment || "production" || 0;
    switch (env) {
        case Environment_Environment.Development:
        case Environment_Environment.Staging:
        case Environment_Environment.Preproduction:
        case Environment_Environment.Production:
            return env;
        default:
            throw new Error("Invalid environment ".concat(env));
    }
};
var getAPIBaseURL = function (env) {
    switch (env) {
        case Environment_Environment.Development:
        default:
            return 'https://api.lendi-dev.net';
        case Environment_Environment.Production:
            return 'https://api.lendi.com.au';
        case Environment_Environment.Preproduction:
            return 'https://api.lendi-preprod.net';
        case Environment_Environment.Staging:
            return 'https://api.lendi-stg.net';
    }
};
//# sourceMappingURL=Environment.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getTenant.js



function getTenant_getTenant(brand, type, environment) {
    if (type === Type.Team) {
        // lendi-team cause we were too pushed for time to delete the old tenants and create new
        // tenants when we found that team members aren't split by brand
        return "lendi-team-".concat(environment, ".au.auth0.com");
    }
    if (brand === Brand.Domain) {
        return "dlf-".concat(type, "-").concat(environment, ".au.auth0.com");
    }
    if (type === Type.Customer && brand === Brand.Lendi) {
        switch (environment) {
            case Environment.Development:
                return "lala.lendi-dev.net";
            case Environment.Staging:
                return "lala.lendi-stg.net";
            case Environment.Preproduction:
                return "lala.lendi-preprod.net";
            case Environment.Production:
                return "lala.lendi.com.au";
        }
    }
    if (type === Type.Customer && brand === Brand.Aussie) {
        switch (environment) {
            case Environment.Development:
                return "lala.aussie-dev.com.au";
            case Environment.Staging:
                return "lala.aussie-stg.com.au";
            case Environment.Preproduction:
                return "lala.aussie-preprod.com.au";
            case Environment.Production:
                return "lala.aussie.com.au";
        }
    }
    return "".concat(brand, "-").concat(type, "-").concat(environment, ".au.auth0.com");
}
//# sourceMappingURL=getTenant.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getDomain.js

function getDomain(brand, type, environment) {
    return getTenant(brand, type, environment);
}
//# sourceMappingURL=getDomain.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getClientID.js



function getClientID(brand, type, environment) {
    if (type === Type.Team) {
        switch (environment) {
            // FIXME: reduce to one team tenant per environment instead of two
            // using `lendi-team-*` for now
            case Environment.Development:
                return 'IdtM2Iu7uhHWQNRMVB6vuaeSo0tRmkXe';
            case Environment.Staging:
                return '7VfZtkRmcNwkL5hLrr2JOz6ID09aQx5S';
            case Environment.Preproduction:
                return 'Q1kDu5GAx4xslZa9yCNg09Iu8KjbTqTb';
            case Environment.Production:
                return 'oVRWqJ9V6BjAKExYQEYHbmbHD9ey4BA7';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return '02HMKpY3DBWow93s4Liv4hOo7LBy5E0v';
            case Environment.Staging:
                return 'KX2f6VfN8m46kAmo2aeVJ6rp3ZSn8G6V';
            case Environment.Preproduction:
                return 'Wo0q6I3JX2gpgCW2ACNvi1z2Ua3YeLoW';
            case Environment.Production:
                return 'HRuDIzIv8Y0X5XNcCzN6xu0E84VkGS0z';
        }
    }
    if (brand === Brand.Domain && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'sI2IAYsp5Wq7clzrwXf6CJfo5j8MWi2n';
            case Environment.Staging:
                return 'qf5mv1u4KfXJh9lqskxpN3wQAiy137US';
            case Environment.Preproduction:
                return 'ZgMxT6WN70VwXv5FEWdiyK4WvI1iQ14Z';
            case Environment.Production:
                return 'cwbIAhyZQvTube2aIg6A7NkIJonxtMaW';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'BmMQl2jaxrMHr8S814STOl46RH75Bb5V';
            case Environment.Staging:
                return '8hO4kNgj4ejLlnh5PRooHQt6g0x88Cqe';
            case Environment.Preproduction:
                return 'YA3q6iku85NDdWOfUQXCOeuB0kD3q5qb';
            case Environment.Production:
                return '3Kb8uy7nsTawMVTviFmuBjSCkajs24GE';
        }
    }
    throw new Error("Unable to determine client ID for ".concat(brand, " ").concat(type, " ").concat(environment, "."));
}
//# sourceMappingURL=getClientID.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getURLs.js

function getBaseURL(brand, type, environment, lendiGroupTeamView) {
    if (typeof window !== 'undefined') {
        switch (window.location.hostname) {
            case 'www.lendi.com.au.local':
            case 'team.lendi.com.au.local':
            case 'dlf.lendi-paas.net.local':
            case 'team.aussie.com.au.local':
                return location.origin;
        }
        if (window.location.hostname && window.location.hostname.indexOf('test.lendi-dev.net') >= 0) {
            return location.origin;
        }
    }
    if (brand === Brand_Brand.Lendi && type === Type_Type.Team) {
        switch (environment) {
            case Environment_Environment.Development:
                return !lendiGroupTeamView ? 'https://team.lendi-dev.net' : 'https://lendi-team-dev.lendigroup.com.au';
            case Environment_Environment.Staging:
                return !lendiGroupTeamView ? 'https://team.lendi-stg.net' : 'https://lendi-team-stg.lendigroup.com.au';
            case Environment_Environment.Preproduction:
                return !lendiGroupTeamView ? 'https://team.lendi-preprod.net' : 'https://lendi-team-preprod.lendigroup.com.au';
            case Environment_Environment.Production:
                return !lendiGroupTeamView ? 'https://team.lendi.com.au' : 'https://lendi-team.lendigroup.com.au';
        }
    }
    if (brand === Brand_Brand.Domain && type === Type_Type.Team) {
        switch (environment) {
            case Environment_Environment.Development:
                return 'https://team-dlf.lendi-dev.net';
            case Environment_Environment.Staging:
                return 'https://team-dlf.lendi-stg.net';
            case Environment_Environment.Preproduction:
                return 'https://team-dlf.lendi-preprod.net';
            case Environment_Environment.Production:
                return 'https://team-dlf.lendi.com.au';
        }
    }
    if (brand === Brand_Brand.Aussie && type === Type_Type.Team) {
        switch (environment) {
            case Environment_Environment.Development:
                return !lendiGroupTeamView ? 'https://team.aussie-dev.com.au' : 'https://aussie-team-dev.lendigroup.com.au';
            case Environment_Environment.Staging:
                return !lendiGroupTeamView ? 'https://team.aussie-stg.com.au' : 'https://aussie-team-stg.lendigroup.com.au';
            case Environment_Environment.Preproduction:
                return !lendiGroupTeamView
                    ? 'https://team.aussie-preprod.com.au'
                    : 'https://aussie-team-preprod.lendigroup.com.au';
            case Environment_Environment.Production:
                return !lendiGroupTeamView ? 'https://team.aussie.com.au' : 'https://aussie-team.lendigroup.com.au';
        }
    }
    if (brand === Brand_Brand.Lendi && type === Type_Type.Customer) {
        switch (environment) {
            case Environment_Environment.Development:
                return 'https://www.lendi-dev.net';
            case Environment_Environment.Staging:
                return 'https://www.lendi-stg.net';
            case Environment_Environment.Preproduction:
                return 'https://www.lendi-preprod.net';
            case Environment_Environment.Production:
                return 'https://www.lendi.com.au';
        }
    }
    if (brand === Brand_Brand.Domain && type === Type_Type.Customer) {
        switch (environment) {
            case Environment_Environment.Development:
                return 'https://dlf.lendi-paas-dev.net';
            case Environment_Environment.Staging:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment_Environment.Preproduction:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment_Environment.Production:
                return 'https://www.domain.com.au/loanfinder';
        }
    }
    if (brand === Brand_Brand.Aussie && type === Type_Type.Customer) {
        switch (environment) {
            case Environment_Environment.Development:
                return 'https://www.aussie-dev.com.au';
            case Environment_Environment.Staging:
                return 'https://www.aussie-stg.com.au';
            case Environment_Environment.Preproduction:
                return 'https://www.aussie-preprod.com.au';
            case Environment_Environment.Production:
                return 'https://www.aussie.com.au';
        }
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
function getDomainUnauthUrl(environment) {
    switch (environment) {
        case Environment_Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment_Environment.Staging:
        case Environment_Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment_Environment.Production:
            return 'https://www.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
function getDomainAuthUrl(environment) {
    switch (environment) {
        case Environment_Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/login';
        case Environment_Environment.Staging:
        case Environment_Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/login';
        case Environment_Environment.Production:
            return 'https://www.domain.com.au/authentications/login';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
function getURLs_getURLs(brand, type, environment, lendiGroupTeamView) {
    if (lendiGroupTeamView === void 0) { lendiGroupTeamView = false; }
    var baseURL = getBaseURL(brand, type, environment, lendiGroupTeamView);
    var unauthBaseURL = brand === Brand_Brand.Domain ? getDomainUnauthUrl(environment) : baseURL;
    var authBaseURL = brand === Brand_Brand.Domain ? getDomainAuthUrl(environment) : baseURL;
    if (type === Type_Type.Team) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: '',
            authenticated: brand === Brand_Brand.Domain ? "".concat(baseURL, "/loanfinder/dashboard/applications") : "".concat(baseURL, "/dashboard/applications"),
            unauthenticated: "".concat(baseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    if (type === Type_Type.Customer) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: brand === Brand_Brand.Domain ? "".concat(baseURL, "/sign-in/") : "".concat(baseURL, "/sign-in/sign-up/"),
            authenticated: "".concat(authBaseURL),
            unauthenticated: "".concat(unauthBaseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
//# sourceMappingURL=getURLs.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/AuthError.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AuthError_ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["ACCESS_DENIED"] = "access_denied";
    ErrorCodes["TOO_MANY_ATTEMPTS"] = "too_many_attempts";
    ErrorCodes["BLOCKED_USER"] = "blocked_user";
    ErrorCodes["SMS_PROVIDER_ERROR"] = "sms_provider_error";
    ErrorCodes["GENERIC"] = "invalid";
    ErrorCodes["PARSE_STATE"] = "parse";
    ErrorCodes["POPUP_CLOSED"] = "popup_closed";
    ErrorCodes["NUMBER_NOT_WORKING"] = "number_not_working";
    ErrorCodes["SSO_VERIFY_GENERIC"] = "sso_verify_generic";
    ErrorCodes["SSO_ACCOUNT_MERGE"] = "sso_account_merge";
    ErrorCodes["UNAUTHORIZED"] = "unauthorized";
    ErrorCodes["INVALID_COUNTRY"] = "invalid_country";
})(AuthError_ErrorCodes || (AuthError_ErrorCodes = {}));
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["WRONG_CODE"] = "One-time passcode incorrect, please try again.";
    ErrorMessages["TOO_MANY_ATTEMPTS"] = "Sorry, your account has been locked following multiple failed login attempts.";
    ErrorMessages["SUSPICIOUS_LOGIN"] = "Sorry, you have been blocked from logging in because we detected suspicious login behaviour.";
    ErrorMessages["GENERIC"] = "Please try again, something went wrong.";
    ErrorMessages["BLOCKED_USER"] = "Sorry, you may be blocked from logging in.";
    ErrorMessages["NO_ACCESS_TOKEN"] = "An access token was not received from the identity provider.";
    ErrorMessages["NO_EXPIRY"] = "The access token did not have an expiry date.";
    ErrorMessages["NO_IDENTITY_TOKEN"] = "An identity token was not received from the identity provider.";
    ErrorMessages["PARSE_STATE"] = "An error occured while parsing the authentication state.";
    ErrorMessages["NUMBER_NOT_WORKING"] = "The provided number is not working, please check again.";
    ErrorMessages["SMS_GATEWAY_ERROR"] = "Unexpected response while calling the SMS gateway, try after sometime.";
    ErrorMessages["POPUP_CLOSED"] = "The popup window has been closed.";
    ErrorMessages["SSO_VERIFY_GENERIC"] = "Something went wrong with the social sign in verification";
    ErrorMessages["SSO_ACCOUNT_MERGE"] = "Something went wrong while merging accounts";
    ErrorMessages["INVALID_COUNTRY"] = "Non-AU customer self-sign-up is not allowed!";
})(ErrorMessages || (ErrorMessages = {}));
var AuthError_AuthError = /** @class */ (function () {
    function AuthError(code, description, contactUs) {
        this._code = code || AuthError_ErrorCodes.GENERIC;
        this._description = description || ErrorMessages.GENERIC;
        this._contactUs = typeof contactUs === 'undefined' ? false : contactUs;
    }
    Object.defineProperty(AuthError.prototype, "code", {
        get: function () {
            return this._code;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "contactUs", {
        get: function () {
            return this._contactUs;
        },
        enumerable: false,
        configurable: true
    });
    return AuthError;
}());

var AuthError_WrongCode = /** @class */ (function (_super) {
    __extends(WrongCode, _super);
    function WrongCode() {
        return _super.call(this, AuthError_ErrorCodes.ACCESS_DENIED, ErrorMessages.WRONG_CODE) || this;
    }
    return WrongCode;
}(AuthError_AuthError));

var AuthError_TooManyAttempts = /** @class */ (function (_super) {
    __extends(TooManyAttempts, _super);
    function TooManyAttempts() {
        return _super.call(this, AuthError_ErrorCodes.TOO_MANY_ATTEMPTS, ErrorMessages.TOO_MANY_ATTEMPTS) || this;
    }
    return TooManyAttempts;
}(AuthError_AuthError));

var AuthError_BlockedUser = /** @class */ (function (_super) {
    __extends(BlockedUser, _super);
    function BlockedUser() {
        return _super.call(this, AuthError_ErrorCodes.BLOCKED_USER, ErrorMessages.BLOCKED_USER, true) || this;
    }
    return BlockedUser;
}(AuthError_AuthError));

var AuthError_NumberNotWorking = /** @class */ (function (_super) {
    __extends(NumberNotWorking, _super);
    function NumberNotWorking() {
        return _super.call(this, AuthError_ErrorCodes.NUMBER_NOT_WORKING, ErrorMessages.NUMBER_NOT_WORKING) || this;
    }
    return NumberNotWorking;
}(AuthError_AuthError));

var AuthError_SMSGatewayError = /** @class */ (function (_super) {
    __extends(SMSGatewayError, _super);
    function SMSGatewayError() {
        return _super.call(this, AuthError_ErrorCodes.SMS_PROVIDER_ERROR, ErrorMessages.SMS_GATEWAY_ERROR) || this;
    }
    return SMSGatewayError;
}(AuthError_AuthError));

var AuthError_NoAccessToken = /** @class */ (function (_super) {
    __extends(NoAccessToken, _super);
    function NoAccessToken() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.NO_ACCESS_TOKEN) || this;
    }
    return NoAccessToken;
}(AuthError_AuthError));

var AuthError_NoExpiry = /** @class */ (function (_super) {
    __extends(NoExpiry, _super);
    function NoExpiry() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.NO_EXPIRY) || this;
    }
    return NoExpiry;
}(AuthError_AuthError));

var AuthError_NoIdentityToken = /** @class */ (function (_super) {
    __extends(NoIdentityToken, _super);
    function NoIdentityToken() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.NO_IDENTITY_TOKEN) || this;
    }
    return NoIdentityToken;
}(AuthError_AuthError));

var AuthError_GenericError = /** @class */ (function (_super) {
    __extends(GenericError, _super);
    function GenericError() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.GENERIC, true) || this;
    }
    return GenericError;
}(AuthError_AuthError));

var AuthError_ParseStateError = /** @class */ (function (_super) {
    __extends(ParseStateError, _super);
    function ParseStateError() {
        return _super.call(this, AuthError_ErrorCodes.PARSE_STATE, ErrorMessages.PARSE_STATE) || this;
    }
    return ParseStateError;
}(AuthError_AuthError));

var AuthError_PopupClosedError = /** @class */ (function (_super) {
    __extends(PopupClosedError, _super);
    function PopupClosedError() {
        return _super.call(this, AuthError_ErrorCodes.POPUP_CLOSED, ErrorMessages.POPUP_CLOSED) || this;
    }
    return PopupClosedError;
}(AuthError_AuthError));

var SsoVerifyGeneric = /** @class */ (function (_super) {
    __extends(SsoVerifyGeneric, _super);
    function SsoVerifyGeneric() {
        return _super.call(this, AuthError_ErrorCodes.SSO_VERIFY_GENERIC, ErrorMessages.SSO_VERIFY_GENERIC) || this;
    }
    return SsoVerifyGeneric;
}(AuthError_AuthError));

var SSOAccountMerge = /** @class */ (function (_super) {
    __extends(SSOAccountMerge, _super);
    function SSOAccountMerge() {
        return _super.call(this, AuthError_ErrorCodes.SSO_ACCOUNT_MERGE, ErrorMessages.SSO_ACCOUNT_MERGE) || this;
    }
    return SSOAccountMerge;
}(AuthError_AuthError));

var AuthError_InvalidCountry = /** @class */ (function (_super) {
    __extends(InvalidCountry, _super);
    function InvalidCountry() {
        return _super.call(this, AuthError_ErrorCodes.INVALID_COUNTRY, ErrorMessages.INVALID_COUNTRY) || this;
    }
    return InvalidCountry;
}(AuthError_AuthError));

//# sourceMappingURL=AuthError.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 108 modules
var main = __webpack_require__(66715);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-logs/esm/index.js + 24 modules
var esm = __webpack_require__(45142);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/Sentry.js
var Sentry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var rumOptions = {
    applicationId: "a64100b3-87a7-479c-962a-bf16197efb0f" || 0,
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    sampleRate: 100,
    resourceSampleRate: 100,
    env: "production",
    version: "LALA-7432",
    trackInteractions: true,
};
var logsOptions = {
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: "LALA-7432",
    env: "production",
    defaultPrivacyLevel: main.DefaultPrivacyLevel.MASK,
};
var LegacyAuthMeError = /** @class */ (function (_super) {
    Sentry_extends(LegacyAuthMeError, _super);
    function LegacyAuthMeError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LegacyAuthMeError;
}(Error));

var logger;
var Sentry_LalaSentry = {
    configureUserContext: function (userCxt) {
        main.datadogRum.setUser({ username: userCxt.phoneNumber });
        main.datadogRum.addAction('Updated User Context');
    },
    init: function () {
        if (!logger) {
            main.datadogRum.init(rumOptions);
            main.datadogRum.addAction('Initialized Rum client');
            esm.datadogLogs.init(logsOptions);
            logger = esm.datadogLogs.createLogger('lalaSentryLogger');
        }
    },
    captureException: function (error, errorTag, errorInfo) {
        main.datadogRum.addError(error, __assign(__assign({}, errorInfo), { errorTag: errorTag }));
    },
    logToSentry: function (message, event) {
        console.log(message, { event: event, loggerInitialized: !!logger, level: 'Info', oldLog: true }); // tslint:disable-line no-console
        if (logger)
            logger.info(message, { event: event });
    },
    logInfo: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'Info' })); // tslint:disable-line no-console
        if (logger)
            logger.info(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logWarn: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'warn' })); // tslint:disable-line no-console
        if (logger)
            logger.warn(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logError: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'error' })); // tslint:disable-line no-console
        if (logger)
            logger.error(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
};
//# sourceMappingURL=Sentry.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/AuthErrorUtils.js


var matchPatterns;
(function (matchPatterns) {
    matchPatterns["WRONG_CODE"] = "verification code";
    matchPatterns["TOO_MANY_ATTEMPTS"] = "attempts";
    matchPatterns["BLOCKED_USER"] = "blocked";
    matchPatterns["NUMBER_NOT_WORKING"] = "not a valid phone";
    matchPatterns["SMS_GATEWAY_NOT_WORKING"] = "unexpected response";
    matchPatterns["POPUP_CLOSED"] = "User closed the popup window";
    matchPatterns["INVALID_COUNTRY"] = "non-allowed country";
})(matchPatterns || (matchPatterns = {}));
var matchAuth0ErrorToLALAAuthError = function (code, description) {
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(matchPatterns.WRONG_CODE)) {
        return new WrongCode();
    }
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(matchPatterns.TOO_MANY_ATTEMPTS)) {
        return new TooManyAttempts();
    }
    if (code === ErrorCodes.BLOCKED_USER && description.toLowerCase().includes(matchPatterns.BLOCKED_USER)) {
        return new BlockedUser();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR && description.toLowerCase().includes(matchPatterns.NUMBER_NOT_WORKING)) {
        return new NumberNotWorking();
    }
    if (code === ErrorCodes.UNAUTHORIZED && description.toLowerCase().includes(matchPatterns.INVALID_COUNTRY)) {
        return new InvalidCountry();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR &&
        description.toLowerCase().includes(matchPatterns.SMS_GATEWAY_NOT_WORKING)) {
        return new SMSGatewayError();
    }
    return new GenericError();
};
var AuthErrorUtils_parseAuthError = function (auth0Error) {
    var code = auth0Error.code, description = auth0Error.description, original = auth0Error.original;
    LalaSentry.logError('Auth failed', { auth0Error: auth0Error });
    if (original === matchPatterns.POPUP_CLOSED) {
        return { error: new PopupClosedError() };
    }
    var errCode = code ? code : ErrorCodes.GENERIC;
    var error = description ? matchAuth0ErrorToLALAAuthError(errCode, description) : new GenericError();
    return {
        error: error,
    };
};
var AuthErrorUtils_parseStorageError = function (_a) {
    var _code = _a._code, _description = _a._description, _contactUs = _a._contactUs;
    return new AuthError(_code, _description, _contactUs);
};
//# sourceMappingURL=AuthErrorUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/consts.js
var NAMESPACE = "https://lendi";
var consts_IDENTITY_TOKEN_USER_ID_KEY = "".concat(NAMESPACE, "/userId");
var consts_IDENTITY_TOKEN_ROLE_KEY = "".concat(NAMESPACE, "/userRole");
var consts_IDENTITY_TOKEN_PROFILE_KEY = "".concat(NAMESPACE, "/userProfile");
var consts_IDENTITY_TOKEN_EXISTING_KEY = "".concat(NAMESPACE, "/existingUser");
var consts_IDENTITY_TOKEN_AUTH_ID_KEY = "".concat(NAMESPACE, "/authId");
var consts_IDENTITY_TOKEN_CONNECTION_KEY = "".concat(NAMESPACE, "/connection");
var consts_RETURNURL_STORAGE_KEY = 'lendi_auth:return_url';
var SAFETY_NET_COOKIE_NAME = 'safetynet';
var LG_APP_AUTH_SESSION_COOKIE_NAME = 'authsession';
var BYPASS_POSTCODE = 'bypass_postcode';
var PRL_STORE_ID = 'prl_storeid';
var PRL_BROKER_ID = 'prl_brokerid';
var CUSTOMER_REFERRAL_CODE = 'customer_refcode';
var LOCAL_STORAGE_KEYS = {
    COTR_PROMPT_DATA: 'cotr_prompt_data',
};
var SESSION_STORAGE_KEYS = {
    CTOR_TARGET_STORE_ID: 'target-storeid',
    CTOR_TARGET_BROKER_ID: 'target-brokerid',
    CTOR_REQUESTED_STORE_ID: 'requested-storeid',
    CTOR_REQUESTED_BROKER_ID: 'requested-brokerid',
};
//# sourceMappingURL=consts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getStateFromAuthResult.js



function getStateFromAuthResult(error, result) {
    if (result) {
        if (!result.accessToken) {
            return {
                error: new NoAccessToken(),
            };
        }
        var accessToken = result.accessToken;
        if (!result.expiresIn) {
            return {
                error: new NoExpiry(),
            };
        }
        var expiry = Date.now() + result.expiresIn * 1000;
        if (!result.idTokenPayload) {
            return {
                error: new NoIdentityToken(),
            };
        }
        var userID = result.idTokenPayload[IDENTITY_TOKEN_USER_ID_KEY];
        var role = result.idTokenPayload[IDENTITY_TOKEN_ROLE_KEY];
        var profile = result.idTokenPayload[IDENTITY_TOKEN_PROFILE_KEY];
        var authId = result.idTokenPayload[IDENTITY_TOKEN_AUTH_ID_KEY];
        var existingUser = result.idTokenPayload[IDENTITY_TOKEN_EXISTING_KEY];
        var connection = result.idTokenPayload[IDENTITY_TOKEN_CONNECTION_KEY];
        return {
            token: accessToken,
            expiry: expiry,
            identity: {
                id: userID,
                role: role,
                profile: profile,
                existingUser: existingUser,
                authId: authId,
                connection: connection,
            },
        };
    }
    else if (error) {
        return parseAuthError(error);
    }
    else {
        throw new Error('Please call getStateFromAuthResult() with either an error or a result.');
    }
}
//# sourceMappingURL=getStateFromAuthResult.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getStateFromStorage.js



function getStateFromStorage() {
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    var value = sessionStorage.getItem(STATE_STORAGE_KEY);
    if (!value) {
        return undefined;
    }
    try {
        var json = JSON.parse(value);
        // if we don't have an object then wtf do we have
        if (typeof json !== 'object') {
            return { error: new ParseStateError() };
        }
        // make sure the object is compatible with this version of the parser
        if (!json.v || json.v !== STATE_STORAGE_VERSION) {
            return undefined;
        }
        delete json.v;
        // parse the authError from storage
        if (json.error) {
            json.error = parseStorageError(json.error);
        }
        return json;
    }
    catch (error) {
        return { error: new ParseStateError() };
    }
}
//# sourceMappingURL=getStateFromStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/setStateInStorage.js
var setStateInStorage_assign = (undefined && undefined.__assign) || function () {
    setStateInStorage_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return setStateInStorage_assign.apply(this, arguments);
};



function isAuthenticatedState(state) {
    return state.token !== undefined;
}
function isUnauthenticatedState(state) {
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return state === undefined;
}
function setStateInStorage(state, broadcast) {
    var _a, _b, _c;
    if (broadcast === void 0) { broadcast = true; }
    LalaSentry.logInfo('setStateInStorage...', { userId: (_a = state === null || state === void 0 ? void 0 : state.identity) === null || _a === void 0 ? void 0 : _a.id });
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    /**
     * If the environment is test then we use simulate type so that our tests do not break
     * as referenced here: https://github.com/pubkey/broadcast-channel/issues/8
     * using simulate is documented here: https://github.com/pubkey/broadcast-channel#methods
     */
    var lalaChannel = new BroadcastChannel('lala', setStateInStorage_assign({}, ( false && 0)));
    var setStorage = function (session) {
        return sessionStorage.setItem(STATE_STORAGE_KEY, JSON.stringify(setStateInStorage_assign({ v: STATE_STORAGE_VERSION }, session)));
    };
    if (isUnauthenticatedState(state)) {
        LalaSentry.logInfo('Removing state from sessionStorage...', { userId: (_b = state === null || state === void 0 ? void 0 : state.identity) === null || _b === void 0 ? void 0 : _b.id });
        sessionStorage.removeItem(STATE_STORAGE_KEY);
    }
    else {
        if (isAuthenticatedState(state)) {
            // this if block is temporary measure to cater for removal of legacy token
            // as soon as all consumers of lala-react upgraded to v12+
            // , this could be removed
            localStorage.setItem('token', 'random-value');
        }
        LalaSentry.logInfo('Setting state to sessionStorage...', { userId: (_c = state === null || state === void 0 ? void 0 : state.identity) === null || _c === void 0 ? void 0 : _c.id });
        setStorage(state);
    }
    if (broadcast) {
        lalaChannel.postMessage(state).catch(function (error) { return LalaSentry.captureException(error, 'setStateInStorageBroadcast'); });
    }
    // tslint:disable-next-line: no-floating-promises
    lalaChannel.close();
}
//# sourceMappingURL=setStateInStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getAudience.js

function getAudience(environment) {
    switch (environment) {
        case Environment.Staging: {
            return 'https://api.lendi-stg.net/';
        }
        case Environment.Preproduction: {
            return 'https://api.lendi-preprod.net/';
        }
        case Environment.Production: {
            return 'https://api.lendi.com.au/';
        }
        case Environment.Development:
        default: {
            return 'https://api.lendi-dev.net/';
        }
    }
}
//# sourceMappingURL=getAudience.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getReturnURLFromStorage.js

var EMPTY_RETURNURL = '{ "queries": {} }';
function getReturnURLFromStorage() {
    return JSON.parse(sessionStorage.getItem(RETURNURL_STORAGE_KEY) || EMPTY_RETURNURL);
}
//# sourceMappingURL=getReturnURLFromStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/setReturnURLInStorage.js

function setReturnURLInStorage(url) {
    if (url) {
        sessionStorage.setItem(RETURNURL_STORAGE_KEY, JSON.stringify(url));
    }
    else {
        sessionStorage.removeItem(RETURNURL_STORAGE_KEY);
    }
}
//# sourceMappingURL=setReturnURLInStorage.js.map
// EXTERNAL MODULE: ../../../node_modules/querystring/index.js
var node_modules_querystring = __webpack_require__(67526);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getReturnURLQueryString.js
var getReturnURLQueryString_assign = (undefined && undefined.__assign) || function () {
    getReturnURLQueryString_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return getReturnURLQueryString_assign.apply(this, arguments);
};


var getOtherQueryStrings = function (queries) {
    return Object.keys(queries)
        .filter(function (queryKey) { return queryKey !== 'returnURL'; })
        .reduce(function (obj, key) {
        var _a;
        var newObj = getReturnURLQueryString_assign(getReturnURLQueryString_assign({}, obj), (_a = {}, _a[key] = queries[key], _a));
        return newObj;
    }, {});
};
var generateReturnURL = function (redirectLinks) {
    if (!redirectLinks.length) {
        return '';
    }
    var returnURL = redirectLinks.pop();
    redirectLinks.reverse();
    redirectLinks.forEach(function (link, i) {
        if (returnURL.includes('?')) {
            returnURL = "".concat(link, "&returnURL=").concat(encodeURIComponent(returnURL));
        }
        else {
            returnURL = "".concat(link, "?returnURL=").concat(encodeURIComponent(returnURL));
        }
    });
    returnURL = "".concat(decodeURI(returnURL));
    return returnURL;
};
var shorternReturnURL = function (returnURL) {
    // IM-422 redirect to the homepage
    if (returnURL.length > 1000) {
        if (returnURL.includes('applicationidplaceholder')) {
            return '/home-loans/basics/landing/?returnURL=/home-loans/basics/application/applicationidplaceholder/ctp/';
        }
        return '/dashboard';
    }
    return returnURL;
};
var getReturnURLFromQuery = function () {
    if (typeof window === 'undefined') {
        return { returnURL: undefined, queries: {} };
    }
    var searchQueries = window.location.search.replace(/\?/, '');
    var parsedQueries = querystring.parse(searchQueries);
    if (parsedQueries) {
        var otherQueries = getOtherQueryStrings(parsedQueries);
        if (parsedQueries.returnURL) {
            var returnURLInQuery = parsedQueries.returnURL;
            if (Array.isArray(returnURLInQuery)) {
                var returnURLArrayString = generateReturnURL(returnURLInQuery);
                LalaSentry.logToSentry('Multiple Return Urls found', returnURLArrayString);
                return { returnURL: shorternReturnURL(returnURLArrayString), queries: otherQueries };
            }
            else {
                return { returnURL: shorternReturnURL(returnURLInQuery), queries: otherQueries };
            }
        }
        return { returnURL: undefined, queries: otherQueries };
    }
    return { returnURL: undefined, queries: {} };
};
//# sourceMappingURL=getReturnURLQueryString.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/validateReturnURL.js

var validateReturnURL = function (brand, type, env, returnURL) {
    var returnURLs = getURLs(brand, type, env);
    return validateReturnURL_validateReturnURLByMap(returnURLs, returnURL);
};
var validateReturnURL_validateReturnURLByMap = function (returnURLs, returnURL) {
    return ((returnURL.startsWith(returnURLs.origin) || returnURL.startsWith('/')) &&
        !returnURL.startsWith(returnURLs.origin + '/') &&
        !returnURL.startsWith('//'));
};
//# sourceMappingURL=validateReturnURL.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/executeReturnURL.js
/// <reference types="node"/>




var generateReturnURLHOF = function (returnURLs) { return function (urlQueries) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnUrlParam = urlQueries.returnURL || '';
    var returnURL = validateReturnURLByMap(returnURLs, returnUrlParam) ? returnUrlParam : returnURLs.authenticated;
    if (stringQueries === '')
        return returnURL;
    if (returnURL.includes('?'))
        return "".concat(returnURL, "&").concat(stringQueries);
    return "".concat(returnURL, "?").concat(stringQueries);
}; };
var getReturnURLFromLALAURLQueries = function (brand, type, env, returnURL) {
    var returnURLs = getURLs(brand, type, env);
    if (brand === Brand.Domain && type === Type.Customer) {
        return generateDomainReturnURL(returnURL, returnURLs);
    }
    else {
        var generateReturnURL = generateReturnURLHOF(returnURLs);
        return generateReturnURL(returnURL);
    }
};
// https://creditandfinance.atlassian.net/browse/SUB-2202
var generateDomainReturnURL = function (urlQueries, returnURLs) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnURLObject = urlQueries.returnURL || '';
    if (returnURLObject) {
        if (stringQueries === '') {
            // with no query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL);
        }
        else {
            // with query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL, "&").concat(stringQueries);
        }
    }
    else {
        // when there is no return url given
        return "".concat(returnURLs.authenticated);
    }
};
var executeReturnURL = function (brand, type, env, returnURL) {
    var returnUrl = getReturnURLFromLALAURLQueries(brand, type, env, returnURL);
    LalaSentry.logInfo('redirect by executeReturnURL', { returnUrl: returnUrl });
    window.location.assign(returnUrl);
};
//# sourceMappingURL=executeReturnURL.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getBrandFromHostname.js

function getBrandFromHostname() {
    if (typeof window === 'undefined')
        return Brand_Brand.Lendi;
    var hostname = window.location.hostname;
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-preprod.net' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net') {
        return Brand_Brand.Lendi;
    }
    // domain customer
    if (hostname === 'www.domain.com.au' || hostname === 'stage.domain.com.au' || hostname === 'dlf.lendi-paas-dev.net') {
        return Brand_Brand.Domain;
    }
    // domain team
    if (hostname === 'team-dlf.lendi.com.au' ||
        hostname === 'team-dlf.lendi-paas-preprod.net' ||
        hostname === 'team-dlf.lendi-paas-stg.net' ||
        hostname === 'team-dlf.lendi-paas-dev.net' ||
        hostname === 'team-dlf.lendi-dev.net' ||
        hostname === 'team-dlf.lendi-stg.net' ||
        hostname === 'team-dlf.lendi.com.au.local') {
        return Brand_Brand.Domain;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-preprod.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au.local') {
        return Brand_Brand.Aussie;
    }
    // aussie team
    if (hostname === 'team.aussie.com.au' ||
        hostname === 'team.aussie-preprod.com.au' ||
        hostname === 'team.aussie-dev.com.au' ||
        hostname === 'team.aussie-stg.com.au' ||
        hostname === 'team.aussie-dev.com.au.local' ||
        hostname === 'aussie-team-dev.lendigroup.com.au' ||
        hostname === 'aussie-team-stg.lendigroup.com.au' ||
        hostname === 'aussie-team-preprod.lendigroup.com.au' ||
        hostname === 'aussie-team.lendigroup.com.au' ||
        hostname === 'tools.aussie-dev.com.au' ||
        hostname === 'tools.aussie-stg.com.au' ||
        hostname === 'tools.aussie-preprod.com.au' ||
        hostname === 'tools.aussie.com.au') {
        return Brand_Brand.Aussie;
    }
    // default to customer
    return Brand_Brand.Lendi;
}
//# sourceMappingURL=getBrandFromHostname.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/getTypeFromHostname.js

function getTypeFromHostname() {
    var hostname = window.location.hostname;
    var hostNameRegex = new RegExp('team');
    /*
      hostname === 'team.lendi.com.au' ||
      hostname === 'team.lendi-stg.net' ||
      hostname === 'team.lendi-preprod.net' ||
      hostname === 'team.lendi-dev.net' ||
      hostname === 'team.aussie.com.au' ||
      hostname === 'team.aussie-stg.com.au' ||
      hostname === 'team.aussie-preprod.com.au' ||
      hostname === 'team.aussie-dev.com.au' ||
      hostname === 'team-dlf.lendi-dev.net' ||
      hostname === 'team-dlf.lendi-stg.net' ||
      hostname === 'team-dlf.lendi.com.au'
    */
    // team
    if (hostNameRegex.test(hostname) || hostname.startsWith('tools.')) {
        return Type.Team;
    }
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net' ||
        hostname === 'www.lendi-preprod.net') {
        return Type.Customer;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-preprod.com.au') {
        return Type.Customer;
    }
    // domain customer
    if (hostname === 'www.domain.com.au' || hostname === 'stage.domain.com.au' || hostname === 'dlf.lendi-paas-dev.net') {
        return Type.Customer;
    }
    // default to customer
    return Type.Customer;
}
//# sourceMappingURL=getTypeFromHostname.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/@lendi/lala-utils/dist/esm/index.js






















//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/launchdarkly-react-client-sdk/lib/index.js
var lib = __webpack_require__(52850);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 27 modules
var dist_esm = __webpack_require__(71384);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/Brand.js
var esm_Brand_Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(esm_Brand_Brand || (esm_Brand_Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/Type.js
var esm_Type_Type;
(function (Type) {
    Type["Customer"] = "customer";
    Type["Team"] = "team";
})(esm_Type_Type || (esm_Type_Type = {}));
//# sourceMappingURL=Type.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/Environment.js
var esm_Environment_Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Preproduction"] = "preproduction";
    Environment["Production"] = "production";
})(esm_Environment_Environment || (esm_Environment_Environment = {}));
var Environment_getEnv = function () {
    var env = "production" || 0;
    switch (env) {
        case esm_Environment_Environment.Development:
        case esm_Environment_Environment.Staging:
        case esm_Environment_Environment.Preproduction:
        case esm_Environment_Environment.Production:
            return env;
        default:
            throw new Error("Invalid environment ".concat(env));
    }
};
var Environment_getAPIBaseURL = function (env) {
    switch (env) {
        case esm_Environment_Environment.Development:
        default:
            return 'https://api.lendi-dev.net';
        case esm_Environment_Environment.Production:
            return 'https://api.lendi.com.au';
        case esm_Environment_Environment.Preproduction:
            return 'https://api.lendi-preprod.net';
        case esm_Environment_Environment.Staging:
            return 'https://api.lendi-stg.net';
    }
};
//# sourceMappingURL=Environment.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getTenant.js



function esm_getTenant_getTenant(brand, type, environment) {
    if (type === Type.Team) {
        // lendi-team cause we were too pushed for time to delete the old tenants and create new
        // tenants when we found that team members aren't split by brand
        return "lendi-team-".concat(environment, ".au.auth0.com");
    }
    if (brand === Brand.Domain) {
        return "dlf-".concat(type, "-").concat(environment, ".au.auth0.com");
    }
    if (type === Type.Customer && brand === Brand.Lendi) {
        switch (environment) {
            case Environment.Development:
                return "lala.lendi-dev.net";
            case Environment.Staging:
                return "lala.lendi-stg.net";
            case Environment.Preproduction:
                return "lala.lendi-preprod.net";
            case Environment.Production:
                return "lala.lendi.com.au";
        }
    }
    if (type === Type.Customer && brand === Brand.Aussie) {
        switch (environment) {
            case Environment.Development:
                return "lala.aussie-dev.com.au";
            case Environment.Staging:
                return "lala.aussie-stg.com.au";
            case Environment.Preproduction:
                return "lala.aussie-preprod.com.au";
            case Environment.Production:
                return "lala.aussie.com.au";
        }
    }
    return "".concat(brand, "-").concat(type, "-").concat(environment, ".au.auth0.com");
}
//# sourceMappingURL=getTenant.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getDomain.js

function getDomain_getDomain(brand, type, environment) {
    return getTenant(brand, type, environment);
}
//# sourceMappingURL=getDomain.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getClientID.js



function getClientID_getClientID(brand, type, environment) {
    if (type === Type.Team) {
        switch (environment) {
            // FIXME: reduce to one team tenant per environment instead of two
            // using `lendi-team-*` for now
            case Environment.Development:
                return 'IdtM2Iu7uhHWQNRMVB6vuaeSo0tRmkXe';
            case Environment.Staging:
                return '7VfZtkRmcNwkL5hLrr2JOz6ID09aQx5S';
            case Environment.Preproduction:
                return 'Q1kDu5GAx4xslZa9yCNg09Iu8KjbTqTb';
            case Environment.Production:
                return 'oVRWqJ9V6BjAKExYQEYHbmbHD9ey4BA7';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return '02HMKpY3DBWow93s4Liv4hOo7LBy5E0v';
            case Environment.Staging:
                return 'KX2f6VfN8m46kAmo2aeVJ6rp3ZSn8G6V';
            case Environment.Preproduction:
                return 'Wo0q6I3JX2gpgCW2ACNvi1z2Ua3YeLoW';
            case Environment.Production:
                return 'HRuDIzIv8Y0X5XNcCzN6xu0E84VkGS0z';
        }
    }
    if (brand === Brand.Domain && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'sI2IAYsp5Wq7clzrwXf6CJfo5j8MWi2n';
            case Environment.Staging:
                return 'qf5mv1u4KfXJh9lqskxpN3wQAiy137US';
            case Environment.Preproduction:
                return 'ZgMxT6WN70VwXv5FEWdiyK4WvI1iQ14Z';
            case Environment.Production:
                return 'cwbIAhyZQvTube2aIg6A7NkIJonxtMaW';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'BmMQl2jaxrMHr8S814STOl46RH75Bb5V';
            case Environment.Staging:
                return '8hO4kNgj4ejLlnh5PRooHQt6g0x88Cqe';
            case Environment.Preproduction:
                return 'YA3q6iku85NDdWOfUQXCOeuB0kD3q5qb';
            case Environment.Production:
                return '3Kb8uy7nsTawMVTviFmuBjSCkajs24GE';
        }
    }
    throw new Error("Unable to determine client ID for ".concat(brand, " ").concat(type, " ").concat(environment, "."));
}
//# sourceMappingURL=getClientID.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getURLs.js

function getURLs_getBaseURL(brand, type, environment) {
    if (typeof window !== 'undefined') {
        switch (window.location.hostname) {
            case 'www.lendi.com.au.local':
            case 'team.lendi.com.au.local':
            case 'dlf.lendi-paas.net.local':
            case 'team.aussie.com.au.local':
                return location.origin;
        }
        if (window.location.hostname && window.location.hostname.indexOf('test.lendi-dev.net') >= 0) {
            return location.origin;
        }
    }
    if (brand === Brand.Lendi && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return 'https://team.lendi-dev.net';
            case Environment.Staging:
                return 'https://team.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://team.lendi-preprod.net';
            case Environment.Production:
                return 'https://team.lendi.com.au';
        }
    }
    if (brand === Brand.Domain && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return 'https://team-dlf.lendi-dev.net';
            case Environment.Staging:
                return 'https://team-dlf.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://team-dlf.lendi-preprod.net';
            case Environment.Production:
                return 'https://team-dlf.lendi.com.au';
        }
    }
    if (brand === Brand.Aussie && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return 'https://team.aussie-dev.com.au';
            case Environment.Staging:
                return 'https://team.aussie-stg.com.au';
            case Environment.Preproduction:
                return 'https://team.aussie-preprod.com.au';
            case Environment.Production:
                return 'https://team.aussie.com.au';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.lendi-dev.net';
            case Environment.Staging:
                return 'https://www.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://www.lendi-preprod.net';
            case Environment.Production:
                return 'https://www.lendi.com.au';
        }
    }
    if (brand === Brand.Domain && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://dlf.lendi-paas-dev.net';
            case Environment.Staging:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment.Preproduction:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment.Production:
                return 'https://www.domain.com.au/loanfinder';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.aussie-dev.com.au';
            case Environment.Staging:
                return 'https://www.aussie-stg.com.au';
            case Environment.Preproduction:
                return 'https://www.aussie-preprod.com.au';
            case Environment.Production:
                return 'https://www.aussie.com.au';
        }
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
function getURLs_getDomainUnauthUrl(environment) {
    switch (environment) {
        case Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment.Staging:
        case Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment.Production:
            return 'https://www.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
function getURLs_getDomainAuthUrl(environment) {
    switch (environment) {
        case Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/login';
        case Environment.Staging:
        case Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/login';
        case Environment.Production:
            return 'https://www.domain.com.au/authentications/login';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
function esm_getURLs_getURLs(brand, type, environment) {
    var baseURL = getURLs_getBaseURL(brand, type, environment);
    var unauthBaseURL = brand === Brand.Domain ? getURLs_getDomainUnauthUrl(environment) : baseURL;
    var authBaseURL = brand === Brand.Domain ? getURLs_getDomainAuthUrl(environment) : baseURL;
    if (type === Type.Team) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: '',
            authenticated: brand === Brand.Domain ? "".concat(baseURL, "/loanfinder/dashboard/applications") : "".concat(baseURL, "/dashboard/applications"),
            unauthenticated: "".concat(baseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    if (type === Type.Customer) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: brand === Brand.Domain ? "".concat(baseURL, "/sign-in/") : "".concat(baseURL, "/sign-in/sign-up/"),
            authenticated: "".concat(authBaseURL),
            unauthenticated: "".concat(unauthBaseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
//# sourceMappingURL=getURLs.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/AuthError.js
var AuthError_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var esm_AuthError_ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["ACCESS_DENIED"] = "access_denied";
    ErrorCodes["TOO_MANY_ATTEMPTS"] = "too_many_attempts";
    ErrorCodes["BLOCKED_USER"] = "blocked_user";
    ErrorCodes["SMS_PROVIDER_ERROR"] = "sms_provider_error";
    ErrorCodes["GENERIC"] = "invalid";
    ErrorCodes["PARSE_STATE"] = "parse";
    ErrorCodes["POPUP_CLOSED"] = "popup_closed";
    ErrorCodes["NUMBER_NOT_WORKING"] = "number_not_working";
    ErrorCodes["SSO_VERIFY_GENERIC"] = "sso_verify_generic";
    ErrorCodes["SSO_ACCOUNT_MERGE"] = "sso_account_merge";
})(esm_AuthError_ErrorCodes || (esm_AuthError_ErrorCodes = {}));
var AuthError_ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["WRONG_CODE"] = "One-time passcode incorrect, please try again.";
    ErrorMessages["TOO_MANY_ATTEMPTS"] = "Sorry, your account has been locked following multiple failed login attempts.";
    ErrorMessages["SUSPICIOUS_LOGIN"] = "Sorry, you have been blocked from logging in because we detected suspicious login behaviour.";
    ErrorMessages["GENERIC"] = "Please try again, something went wrong.";
    ErrorMessages["BLOCKED_USER"] = "Sorry, you may be blocked from logging in.";
    ErrorMessages["NO_ACCESS_TOKEN"] = "An access token was not received from the identity provider.";
    ErrorMessages["NO_EXPIRY"] = "The access token did not have an expiry date.";
    ErrorMessages["NO_IDENTITY_TOKEN"] = "An identity token was not received from the identity provider.";
    ErrorMessages["PARSE_STATE"] = "An error occured while parsing the authentication state.";
    ErrorMessages["NUMBER_NOT_WORKING"] = "The provided number is not working, please check again.";
    ErrorMessages["SMS_GATEWAY_ERROR"] = "Unexpected response while calling the SMS gateway, try after sometime.";
    ErrorMessages["POPUP_CLOSED"] = "The popup window has been closed.";
    ErrorMessages["SSO_VERIFY_GENERIC"] = "Something went wrong with the social sign in verification";
    ErrorMessages["SSO_ACCOUNT_MERGE"] = "Something went wrong while merging accounts";
})(AuthError_ErrorMessages || (AuthError_ErrorMessages = {}));
var esm_AuthError_AuthError = /** @class */ (function () {
    function AuthError(code, description, contactUs) {
        this._code = code || esm_AuthError_ErrorCodes.GENERIC;
        this._description = description || AuthError_ErrorMessages.GENERIC;
        this._contactUs = typeof contactUs === 'undefined' ? false : contactUs;
    }
    Object.defineProperty(AuthError.prototype, "code", {
        get: function () {
            return this._code;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "contactUs", {
        get: function () {
            return this._contactUs;
        },
        enumerable: false,
        configurable: true
    });
    return AuthError;
}());

var esm_AuthError_WrongCode = /** @class */ (function (_super) {
    AuthError_extends(WrongCode, _super);
    function WrongCode() {
        return _super.call(this, esm_AuthError_ErrorCodes.ACCESS_DENIED, AuthError_ErrorMessages.WRONG_CODE) || this;
    }
    return WrongCode;
}(esm_AuthError_AuthError));

var esm_AuthError_TooManyAttempts = /** @class */ (function (_super) {
    AuthError_extends(TooManyAttempts, _super);
    function TooManyAttempts() {
        return _super.call(this, esm_AuthError_ErrorCodes.TOO_MANY_ATTEMPTS, AuthError_ErrorMessages.TOO_MANY_ATTEMPTS) || this;
    }
    return TooManyAttempts;
}(esm_AuthError_AuthError));

var esm_AuthError_BlockedUser = /** @class */ (function (_super) {
    AuthError_extends(BlockedUser, _super);
    function BlockedUser() {
        return _super.call(this, esm_AuthError_ErrorCodes.BLOCKED_USER, AuthError_ErrorMessages.BLOCKED_USER, true) || this;
    }
    return BlockedUser;
}(esm_AuthError_AuthError));

var esm_AuthError_NumberNotWorking = /** @class */ (function (_super) {
    AuthError_extends(NumberNotWorking, _super);
    function NumberNotWorking() {
        return _super.call(this, esm_AuthError_ErrorCodes.NUMBER_NOT_WORKING, AuthError_ErrorMessages.NUMBER_NOT_WORKING) || this;
    }
    return NumberNotWorking;
}(esm_AuthError_AuthError));

var esm_AuthError_SMSGatewayError = /** @class */ (function (_super) {
    AuthError_extends(SMSGatewayError, _super);
    function SMSGatewayError() {
        return _super.call(this, esm_AuthError_ErrorCodes.SMS_PROVIDER_ERROR, AuthError_ErrorMessages.SMS_GATEWAY_ERROR) || this;
    }
    return SMSGatewayError;
}(esm_AuthError_AuthError));

var esm_AuthError_NoAccessToken = /** @class */ (function (_super) {
    AuthError_extends(NoAccessToken, _super);
    function NoAccessToken() {
        return _super.call(this, esm_AuthError_ErrorCodes.GENERIC, AuthError_ErrorMessages.NO_ACCESS_TOKEN) || this;
    }
    return NoAccessToken;
}(esm_AuthError_AuthError));

var esm_AuthError_NoExpiry = /** @class */ (function (_super) {
    AuthError_extends(NoExpiry, _super);
    function NoExpiry() {
        return _super.call(this, esm_AuthError_ErrorCodes.GENERIC, AuthError_ErrorMessages.NO_EXPIRY) || this;
    }
    return NoExpiry;
}(esm_AuthError_AuthError));

var esm_AuthError_NoIdentityToken = /** @class */ (function (_super) {
    AuthError_extends(NoIdentityToken, _super);
    function NoIdentityToken() {
        return _super.call(this, esm_AuthError_ErrorCodes.GENERIC, AuthError_ErrorMessages.NO_IDENTITY_TOKEN) || this;
    }
    return NoIdentityToken;
}(esm_AuthError_AuthError));

var esm_AuthError_GenericError = /** @class */ (function (_super) {
    AuthError_extends(GenericError, _super);
    function GenericError() {
        return _super.call(this, esm_AuthError_ErrorCodes.GENERIC, AuthError_ErrorMessages.GENERIC, true) || this;
    }
    return GenericError;
}(esm_AuthError_AuthError));

var esm_AuthError_ParseStateError = /** @class */ (function (_super) {
    AuthError_extends(ParseStateError, _super);
    function ParseStateError() {
        return _super.call(this, esm_AuthError_ErrorCodes.PARSE_STATE, AuthError_ErrorMessages.PARSE_STATE) || this;
    }
    return ParseStateError;
}(esm_AuthError_AuthError));

var esm_AuthError_PopupClosedError = /** @class */ (function (_super) {
    AuthError_extends(PopupClosedError, _super);
    function PopupClosedError() {
        return _super.call(this, esm_AuthError_ErrorCodes.POPUP_CLOSED, AuthError_ErrorMessages.POPUP_CLOSED) || this;
    }
    return PopupClosedError;
}(esm_AuthError_AuthError));

var AuthError_SsoVerifyGeneric = /** @class */ (function (_super) {
    AuthError_extends(SsoVerifyGeneric, _super);
    function SsoVerifyGeneric() {
        return _super.call(this, esm_AuthError_ErrorCodes.SSO_VERIFY_GENERIC, AuthError_ErrorMessages.SSO_VERIFY_GENERIC) || this;
    }
    return SsoVerifyGeneric;
}(esm_AuthError_AuthError));

var AuthError_SSOAccountMerge = /** @class */ (function (_super) {
    AuthError_extends(SSOAccountMerge, _super);
    function SSOAccountMerge() {
        return _super.call(this, esm_AuthError_ErrorCodes.SSO_ACCOUNT_MERGE, AuthError_ErrorMessages.SSO_ACCOUNT_MERGE) || this;
    }
    return SSOAccountMerge;
}(esm_AuthError_AuthError));

//# sourceMappingURL=AuthError.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/AuthErrorUtils.js

var AuthErrorUtils_matchPatterns;
(function (matchPatterns) {
    matchPatterns["WRONG_CODE"] = "verification code";
    matchPatterns["TOO_MANY_ATTEMPTS"] = "attempts";
    matchPatterns["BLOCKED_USER"] = "blocked";
    matchPatterns["NUMBER_NOT_WORKING"] = "not a valid phone";
    matchPatterns["SMS_GATEWAY_NOT_WORKING"] = "unexpected response";
    matchPatterns["POPUP_CLOSED"] = "User closed the popup window";
})(AuthErrorUtils_matchPatterns || (AuthErrorUtils_matchPatterns = {}));
var AuthErrorUtils_matchAuth0ErrorToLALAAuthError = function (code, description) {
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(AuthErrorUtils_matchPatterns.WRONG_CODE)) {
        return new WrongCode();
    }
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(AuthErrorUtils_matchPatterns.TOO_MANY_ATTEMPTS)) {
        return new TooManyAttempts();
    }
    if (code === ErrorCodes.BLOCKED_USER && description.toLowerCase().includes(AuthErrorUtils_matchPatterns.BLOCKED_USER)) {
        return new BlockedUser();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR && description.toLowerCase().includes(AuthErrorUtils_matchPatterns.NUMBER_NOT_WORKING)) {
        return new NumberNotWorking();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR &&
        description.toLowerCase().includes(AuthErrorUtils_matchPatterns.SMS_GATEWAY_NOT_WORKING)) {
        return new SMSGatewayError();
    }
    return new GenericError();
};
var esm_AuthErrorUtils_parseAuthError = function (_a) {
    var code = _a.code, description = _a.description, original = _a.original;
    if (original === AuthErrorUtils_matchPatterns.POPUP_CLOSED) {
        return { error: new PopupClosedError() };
    }
    var errCode = code ? code : ErrorCodes.GENERIC;
    var error = description ? AuthErrorUtils_matchAuth0ErrorToLALAAuthError(errCode, description) : new GenericError();
    return {
        error: error,
    };
};
var esm_AuthErrorUtils_parseStorageError = function (_a) {
    var _code = _a._code, _description = _a._description, _contactUs = _a._contactUs;
    return new AuthError(_code, _description, _contactUs);
};
//# sourceMappingURL=AuthErrorUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/consts.js
var consts_NAMESPACE = "https://lendi";
var esm_consts_IDENTITY_TOKEN_USER_ID_KEY = "".concat(consts_NAMESPACE, "/userId");
var esm_consts_IDENTITY_TOKEN_ROLE_KEY = "".concat(consts_NAMESPACE, "/userRole");
var esm_consts_IDENTITY_TOKEN_PROFILE_KEY = "".concat(consts_NAMESPACE, "/userProfile");
var esm_consts_IDENTITY_TOKEN_EXISTING_KEY = "".concat(consts_NAMESPACE, "/existingUser");
var esm_consts_IDENTITY_TOKEN_AUTH_ID_KEY = "".concat(consts_NAMESPACE, "/authId");
var esm_consts_IDENTITY_TOKEN_CONNECTION_KEY = "".concat(consts_NAMESPACE, "/connection");
var esm_consts_RETURNURL_STORAGE_KEY = 'lendi_auth:return_url';
var consts_SAFETY_NET_COOKIE_NAME = 'safetynet';
var consts_LG_APP_AUTH_SESSION_COOKIE_NAME = 'authsession';
//# sourceMappingURL=consts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getStateFromAuthResult.js



function getStateFromAuthResult_getStateFromAuthResult(error, result) {
    if (result) {
        if (!result.accessToken) {
            return {
                error: new NoAccessToken(),
            };
        }
        var accessToken = result.accessToken;
        if (!result.expiresIn) {
            return {
                error: new NoExpiry(),
            };
        }
        var expiry = Date.now() + result.expiresIn * 1000;
        if (!result.idTokenPayload) {
            return {
                error: new NoIdentityToken(),
            };
        }
        var userID = result.idTokenPayload[IDENTITY_TOKEN_USER_ID_KEY];
        var role = result.idTokenPayload[IDENTITY_TOKEN_ROLE_KEY];
        var profile = result.idTokenPayload[IDENTITY_TOKEN_PROFILE_KEY];
        var authId = result.idTokenPayload[IDENTITY_TOKEN_AUTH_ID_KEY];
        var existingUser = result.idTokenPayload[IDENTITY_TOKEN_EXISTING_KEY];
        var connection = result.idTokenPayload[IDENTITY_TOKEN_CONNECTION_KEY];
        return {
            token: accessToken,
            expiry: expiry,
            identity: {
                id: userID,
                role: role,
                profile: profile,
                existingUser: existingUser,
                authId: authId,
                connection: connection,
            },
        };
    }
    else if (error) {
        return parseAuthError(error);
    }
    else {
        throw new Error('Please call getStateFromAuthResult() with either an error or a result.');
    }
}
//# sourceMappingURL=getStateFromAuthResult.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getStateFromStorage.js



function getStateFromStorage_getStateFromStorage() {
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    var value = sessionStorage.getItem(STATE_STORAGE_KEY);
    if (!value) {
        return undefined;
    }
    try {
        var json = JSON.parse(value);
        // if we don't have an object then wtf do we have
        if (typeof json !== 'object') {
            return { error: new ParseStateError() };
        }
        // make sure the object is compatible with this version of the parser
        if (!json.v || json.v !== STATE_STORAGE_VERSION) {
            return undefined;
        }
        delete json.v;
        // parse the authError from storage
        if (json.error) {
            json.error = parseStorageError(json.error);
        }
        return json;
    }
    catch (error) {
        return { error: new ParseStateError() };
    }
}
//# sourceMappingURL=getStateFromStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/Sentry.js
var esm_Sentry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Sentry_assign = (undefined && undefined.__assign) || function () {
    Sentry_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Sentry_assign.apply(this, arguments);
};


var Sentry_rumOptions = {
    applicationId: "a64100b3-87a7-479c-962a-bf16197efb0f" || 0,
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    sampleRate: 100,
    resourceSampleRate: 100,
    env: "production",
    version: "LALA-7432",
    trackInteractions: true,
};
var Sentry_logsOptions = {
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: "LALA-7432",
    env: "production",
    defaultPrivacyLevel: main.DefaultPrivacyLevel.MASK,
};
var Sentry_LegacyAuthMeError = /** @class */ (function (_super) {
    esm_Sentry_extends(LegacyAuthMeError, _super);
    function LegacyAuthMeError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LegacyAuthMeError;
}(Error));

var Sentry_logger;
var esm_Sentry_LalaSentry = {
    configureUserContext: function (userCxt) {
        main.datadogRum.setUser({ username: userCxt.phoneNumber });
        main.datadogRum.addAction('Updated User Context');
    },
    init: function () {
        if (!Sentry_logger) {
            main.datadogRum.init(Sentry_rumOptions);
            main.datadogRum.addAction('Initialized Rum client');
            esm.datadogLogs.init(Sentry_logsOptions);
            Sentry_logger = esm.datadogLogs.createLogger('lalaSentryLogger');
        }
    },
    captureException: function (error, errorTag, errorInfo) {
        main.datadogRum.addError(error, Sentry_assign(Sentry_assign({}, errorInfo), { errorTag: errorTag }));
    },
    logToSentry: function (message, event) {
        console.log(message, { event: event, loggerInitialized: !!Sentry_logger, level: 'Info', oldLog: true }); // tslint:disable-line no-console
        if (Sentry_logger)
            Sentry_logger.info(message, { event: event });
    },
    logInfo: function (message, tags) {
        console.log(message, Sentry_assign(Sentry_assign({}, tags), { loggerInitialized: !!Sentry_logger, level: 'Info' })); // tslint:disable-line no-console
        if (Sentry_logger)
            Sentry_logger.info(message, Sentry_assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logWarn: function (message, tags) {
        console.log(message, Sentry_assign(Sentry_assign({}, tags), { loggerInitialized: !!Sentry_logger, level: 'warn' })); // tslint:disable-line no-console
        if (Sentry_logger)
            Sentry_logger.warn(message, Sentry_assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logError: function (message, tags) {
        console.log(message, Sentry_assign(Sentry_assign({}, tags), { loggerInitialized: !!Sentry_logger, level: 'error' })); // tslint:disable-line no-console
        if (Sentry_logger)
            Sentry_logger.error(message, Sentry_assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
};
//# sourceMappingURL=Sentry.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/setStateInStorage.js
var esm_setStateInStorage_assign = (undefined && undefined.__assign) || function () {
    esm_setStateInStorage_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return esm_setStateInStorage_assign.apply(this, arguments);
};



function setStateInStorage_isAuthenticatedState(state) {
    return state.token !== undefined;
}
function setStateInStorage_isUnauthenticatedState(state) {
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return state === undefined;
}
function setStateInStorage_setStateInStorage(state, broadcast) {
    var _a, _b, _c;
    if (broadcast === void 0) { broadcast = true; }
    LalaSentry.logInfo('setStateInStorage...', { userId: (_a = state === null || state === void 0 ? void 0 : state.identity) === null || _a === void 0 ? void 0 : _a.id });
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    /**
     * If the environment is test then we use simulate type so that our tests do not break
     * as referenced here: https://github.com/pubkey/broadcast-channel/issues/8
     * using simulate is documented here: https://github.com/pubkey/broadcast-channel#methods
     */
    var lalaChannel = new BroadcastChannel('lala', esm_setStateInStorage_assign({}, ( false && 0)));
    var setStorage = function (session) {
        return sessionStorage.setItem(STATE_STORAGE_KEY, JSON.stringify(esm_setStateInStorage_assign({ v: STATE_STORAGE_VERSION }, session)));
    };
    if (setStateInStorage_isUnauthenticatedState(state)) {
        LalaSentry.logInfo('Removing state from sessionStorage...', { userId: (_b = state === null || state === void 0 ? void 0 : state.identity) === null || _b === void 0 ? void 0 : _b.id });
        sessionStorage.removeItem(STATE_STORAGE_KEY);
    }
    else {
        if (setStateInStorage_isAuthenticatedState(state)) {
            // this if block is temporary measure to cater for removal of legacy token
            // as soon as all consumers of lala-react upgraded to v12+
            // , this could be removed
            localStorage.setItem('token', 'random-value');
        }
        LalaSentry.logInfo('Setting state to sessionStorage...', { userId: (_c = state === null || state === void 0 ? void 0 : state.identity) === null || _c === void 0 ? void 0 : _c.id });
        setStorage(state);
    }
    if (broadcast) {
        lalaChannel.postMessage(state).catch(function (error) { return LalaSentry.captureException(error, 'setStateInStorageBroadcast'); });
    }
    // tslint:disable-next-line: no-floating-promises
    lalaChannel.close();
}
//# sourceMappingURL=setStateInStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getAudience.js

function getAudience_getAudience(environment) {
    switch (environment) {
        case Environment.Staging: {
            return 'https://api.lendi-stg.net/';
        }
        case Environment.Preproduction: {
            return 'https://api.lendi-preprod.net/';
        }
        case Environment.Production: {
            return 'https://api.lendi.com.au/';
        }
        case Environment.Development:
        default: {
            return 'https://api.lendi-dev.net/';
        }
    }
}
//# sourceMappingURL=getAudience.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getReturnURLFromStorage.js

var getReturnURLFromStorage_EMPTY_RETURNURL = '{ "queries": {} }';
function getReturnURLFromStorage_getReturnURLFromStorage() {
    return JSON.parse(sessionStorage.getItem(RETURNURL_STORAGE_KEY) || getReturnURLFromStorage_EMPTY_RETURNURL);
}
//# sourceMappingURL=getReturnURLFromStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/setReturnURLInStorage.js

function setReturnURLInStorage_setReturnURLInStorage(url) {
    if (url) {
        sessionStorage.setItem(RETURNURL_STORAGE_KEY, JSON.stringify(url));
    }
    else {
        sessionStorage.removeItem(RETURNURL_STORAGE_KEY);
    }
}
//# sourceMappingURL=setReturnURLInStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getReturnURLQueryString.js
var esm_getReturnURLQueryString_assign = (undefined && undefined.__assign) || function () {
    esm_getReturnURLQueryString_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return esm_getReturnURLQueryString_assign.apply(this, arguments);
};


var getReturnURLQueryString_getOtherQueryStrings = function (queries) {
    return Object.keys(queries)
        .filter(function (queryKey) { return queryKey !== 'returnURL'; })
        .reduce(function (obj, key) {
        var _a;
        var newObj = esm_getReturnURLQueryString_assign(esm_getReturnURLQueryString_assign({}, obj), (_a = {}, _a[key] = queries[key], _a));
        return newObj;
    }, {});
};
var getReturnURLQueryString_generateReturnURL = function (redirectLinks) {
    if (!redirectLinks.length) {
        return '';
    }
    var returnURL = redirectLinks.pop();
    redirectLinks.reverse();
    redirectLinks.forEach(function (link, i) {
        if (returnURL.includes('?')) {
            returnURL = "".concat(link, "&returnURL=").concat(encodeURIComponent(returnURL));
        }
        else {
            returnURL = "".concat(link, "?returnURL=").concat(encodeURIComponent(returnURL));
        }
    });
    returnURL = "".concat(decodeURI(returnURL));
    return returnURL;
};
var getReturnURLQueryString_getReturnURLFromQuery = function () {
    if (typeof window === 'undefined') {
        return { returnURL: undefined, queries: {} };
    }
    var searchQueries = window.location.search.replace(/\?/, '');
    var parsedQueries = querystring.parse(searchQueries);
    if (parsedQueries) {
        var otherQueries = getReturnURLQueryString_getOtherQueryStrings(parsedQueries);
        if (parsedQueries.returnURL) {
            var returnURLInQuery = parsedQueries.returnURL;
            if (Array.isArray(returnURLInQuery)) {
                var returnURLArrayString = getReturnURLQueryString_generateReturnURL(returnURLInQuery);
                LalaSentry.logToSentry('Multiple Return Urls found', returnURLArrayString);
                return { returnURL: returnURLArrayString, queries: otherQueries };
            }
            else {
                return { returnURL: returnURLInQuery, queries: otherQueries };
            }
        }
        return { returnURL: undefined, queries: otherQueries };
    }
    return { returnURL: undefined, queries: {} };
};
//# sourceMappingURL=getReturnURLQueryString.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/executeReturnURL.js
/// <reference types="node"/>



var isValidReturnURLLHOF = function (returnURLs) { return function (returnURL) {
    return returnURL.startsWith(returnURLs.origin) || returnURL.startsWith('/');
}; };
var executeReturnURL_generateReturnURLHOF = function (returnURLs) { return function (urlQueries) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnURL = urlQueries.returnURL || '';
    var isValidReturnURL = isValidReturnURLLHOF(returnURLs);
    if (isValidReturnURL(returnURL)) {
        if (stringQueries === '')
            return returnURL;
        if (returnURL.includes('?'))
            return "".concat(returnURL, "&").concat(stringQueries);
        return "".concat(returnURL, "?").concat(stringQueries);
    }
    if (stringQueries === '')
        return returnURLs.authenticated;
    return "".concat(returnURLs.authenticated, "?").concat(stringQueries);
}; };
var executeReturnURL_getReturnURLFromLALAURLQueries = function (brand, type, env, returnURL) {
    var returnURLs = getURLs(brand, type, env);
    if (brand === Brand.Domain && type === Type.Customer) {
        return executeReturnURL_generateDomainReturnURL(returnURL, returnURLs);
    }
    else {
        var generateReturnURL = executeReturnURL_generateReturnURLHOF(returnURLs);
        return generateReturnURL(returnURL);
    }
};
// https://creditandfinance.atlassian.net/browse/SUB-2202
var executeReturnURL_generateDomainReturnURL = function (urlQueries, returnURLs) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnURLObject = urlQueries.returnURL || '';
    if (returnURLObject) {
        if (stringQueries === '') {
            // with no query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL);
        }
        else {
            // with query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL, "&").concat(stringQueries);
        }
    }
    else {
        // when there is no return url given
        return "".concat(returnURLs.authenticated);
    }
};
var executeReturnURL_executeReturnURL = function (brand, type, env, returnURL) {
    var returnUrl = executeReturnURL_getReturnURLFromLALAURLQueries(brand, type, env, returnURL);
    LalaSentry.logToSentry('executeReturnURL', JSON.stringify(returnUrl));
    window.location.assign(returnUrl);
};
//# sourceMappingURL=executeReturnURL.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getBrandFromHostname.js

function getBrandFromHostname_getBrandFromHostname() {
    if (typeof window === 'undefined')
        return esm_Brand_Brand.Lendi;
    var hostname = window.location.hostname;
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-preprod.net' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net') {
        return esm_Brand_Brand.Lendi;
    }
    // domain customer
    if (hostname === 'www.domain.com.au' || hostname === 'stage.domain.com.au' || hostname === 'dlf.lendi-paas-dev.net') {
        return esm_Brand_Brand.Domain;
    }
    // domain team
    if (hostname === 'team-dlf.lendi.com.au' ||
        hostname === 'team-dlf.lendi-paas-preprod.net' ||
        hostname === 'team-dlf.lendi-paas-stg.net' ||
        hostname === 'team-dlf.lendi-paas-dev.net' ||
        hostname === 'team-dlf.lendi-dev.net' ||
        hostname === 'team-dlf.lendi-stg.net' ||
        hostname === 'team-dlf.lendi.com.au.local') {
        return esm_Brand_Brand.Domain;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-preprod.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au.local') {
        return esm_Brand_Brand.Aussie;
    }
    // aussie team
    if (hostname === 'team.aussie.com.au' ||
        hostname === 'team.aussie-preprod.com.au' ||
        hostname === 'team.aussie-dev.com.au' ||
        hostname === 'team.aussie-stg.com.au' ||
        hostname === 'team.aussie-dev.com.au.local') {
        return esm_Brand_Brand.Aussie;
    }
    // default to customer
    return esm_Brand_Brand.Lendi;
}
//# sourceMappingURL=getBrandFromHostname.js.map
// EXTERNAL MODULE: ../../../node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(22512);
// EXTERNAL MODULE: ../../../node_modules/@lendi/customer-client/node_modules/axios/index.js
var node_modules_axios = __webpack_require__(91539);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/customer-client/dist/esm/base.js
// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Customer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var base_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BASE_PATH = 'http://localhost'.replace(/\/+$/, '');
/**
 *
 * @export
 */
var COLLECTION_FORMATS = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, axios) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (axios === void 0) { axios = (axios_default()); }
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    base_extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = 'RequiredError';
        return _this;
    }
    return RequiredError;
}(Error));

//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/customer-client/dist/esm/api.js
// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Customer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var api_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var api_assign = (undefined && undefined.__assign) || function () {
    api_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return api_assign.apply(this, arguments);
};



/**
 * @export
 * @enum {string}
 */
var AuthCustomerCreateRequestGenderEnum;
(function (AuthCustomerCreateRequestGenderEnum) {
    AuthCustomerCreateRequestGenderEnum["FEMALE"] = "FEMALE";
    AuthCustomerCreateRequestGenderEnum["MALE"] = "MALE";
    AuthCustomerCreateRequestGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(AuthCustomerCreateRequestGenderEnum || (AuthCustomerCreateRequestGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
var AuthCustomerCreateRequestTitleEnum;
(function (AuthCustomerCreateRequestTitleEnum) {
    AuthCustomerCreateRequestTitleEnum["MR"] = "MR";
    AuthCustomerCreateRequestTitleEnum["MRS"] = "MRS";
    AuthCustomerCreateRequestTitleEnum["MISS"] = "MISS";
    AuthCustomerCreateRequestTitleEnum["MS"] = "MS";
    AuthCustomerCreateRequestTitleEnum["DR"] = "DR";
})(AuthCustomerCreateRequestTitleEnum || (AuthCustomerCreateRequestTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
var AuthCustomerCreateRequestBrandEnum;
(function (AuthCustomerCreateRequestBrandEnum) {
    AuthCustomerCreateRequestBrandEnum["Lendi"] = "lendi";
    AuthCustomerCreateRequestBrandEnum["Domain"] = "domain";
})(AuthCustomerCreateRequestBrandEnum || (AuthCustomerCreateRequestBrandEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var api_Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
})(api_Brand || (api_Brand = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerBaseDetailsGenderEnum;
(function (CustomerBaseDetailsGenderEnum) {
    CustomerBaseDetailsGenderEnum["FEMALE"] = "FEMALE";
    CustomerBaseDetailsGenderEnum["MALE"] = "MALE";
    CustomerBaseDetailsGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerBaseDetailsGenderEnum || (CustomerBaseDetailsGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerBaseDetailsTitleEnum;
(function (CustomerBaseDetailsTitleEnum) {
    CustomerBaseDetailsTitleEnum["MR"] = "MR";
    CustomerBaseDetailsTitleEnum["MRS"] = "MRS";
    CustomerBaseDetailsTitleEnum["MISS"] = "MISS";
    CustomerBaseDetailsTitleEnum["MS"] = "MS";
    CustomerBaseDetailsTitleEnum["DR"] = "DR";
})(CustomerBaseDetailsTitleEnum || (CustomerBaseDetailsTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerBaseDetailsBrandEnum;
(function (CustomerBaseDetailsBrandEnum) {
    CustomerBaseDetailsBrandEnum["Lendi"] = "lendi";
    CustomerBaseDetailsBrandEnum["Domain"] = "domain";
})(CustomerBaseDetailsBrandEnum || (CustomerBaseDetailsBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerCreateRequestGenderEnum;
(function (CustomerCreateRequestGenderEnum) {
    CustomerCreateRequestGenderEnum["FEMALE"] = "FEMALE";
    CustomerCreateRequestGenderEnum["MALE"] = "MALE";
    CustomerCreateRequestGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerCreateRequestGenderEnum || (CustomerCreateRequestGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerCreateRequestTitleEnum;
(function (CustomerCreateRequestTitleEnum) {
    CustomerCreateRequestTitleEnum["MR"] = "MR";
    CustomerCreateRequestTitleEnum["MRS"] = "MRS";
    CustomerCreateRequestTitleEnum["MISS"] = "MISS";
    CustomerCreateRequestTitleEnum["MS"] = "MS";
    CustomerCreateRequestTitleEnum["DR"] = "DR";
})(CustomerCreateRequestTitleEnum || (CustomerCreateRequestTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerCreateRequestBrandEnum;
(function (CustomerCreateRequestBrandEnum) {
    CustomerCreateRequestBrandEnum["Lendi"] = "lendi";
    CustomerCreateRequestBrandEnum["Domain"] = "domain";
})(CustomerCreateRequestBrandEnum || (CustomerCreateRequestBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerDetailsGenderEnum;
(function (CustomerDetailsGenderEnum) {
    CustomerDetailsGenderEnum["FEMALE"] = "FEMALE";
    CustomerDetailsGenderEnum["MALE"] = "MALE";
    CustomerDetailsGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerDetailsGenderEnum || (CustomerDetailsGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerDetailsTitleEnum;
(function (CustomerDetailsTitleEnum) {
    CustomerDetailsTitleEnum["MR"] = "MR";
    CustomerDetailsTitleEnum["MRS"] = "MRS";
    CustomerDetailsTitleEnum["MISS"] = "MISS";
    CustomerDetailsTitleEnum["MS"] = "MS";
    CustomerDetailsTitleEnum["DR"] = "DR";
})(CustomerDetailsTitleEnum || (CustomerDetailsTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerDetailsBrandEnum;
(function (CustomerDetailsBrandEnum) {
    CustomerDetailsBrandEnum["Lendi"] = "lendi";
    CustomerDetailsBrandEnum["Domain"] = "domain";
})(CustomerDetailsBrandEnum || (CustomerDetailsBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerDetailsAllOfGenderEnum;
(function (CustomerDetailsAllOfGenderEnum) {
    CustomerDetailsAllOfGenderEnum["FEMALE"] = "FEMALE";
    CustomerDetailsAllOfGenderEnum["MALE"] = "MALE";
    CustomerDetailsAllOfGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerDetailsAllOfGenderEnum || (CustomerDetailsAllOfGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerDetailsAllOfTitleEnum;
(function (CustomerDetailsAllOfTitleEnum) {
    CustomerDetailsAllOfTitleEnum["MR"] = "MR";
    CustomerDetailsAllOfTitleEnum["MRS"] = "MRS";
    CustomerDetailsAllOfTitleEnum["MISS"] = "MISS";
    CustomerDetailsAllOfTitleEnum["MS"] = "MS";
    CustomerDetailsAllOfTitleEnum["DR"] = "DR";
})(CustomerDetailsAllOfTitleEnum || (CustomerDetailsAllOfTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerDetailsAllOfBrandEnum;
(function (CustomerDetailsAllOfBrandEnum) {
    CustomerDetailsAllOfBrandEnum["Lendi"] = "lendi";
    CustomerDetailsAllOfBrandEnum["Domain"] = "domain";
})(CustomerDetailsAllOfBrandEnum || (CustomerDetailsAllOfBrandEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerUpdateRequestGenderEnum;
(function (CustomerUpdateRequestGenderEnum) {
    CustomerUpdateRequestGenderEnum["FEMALE"] = "FEMALE";
    CustomerUpdateRequestGenderEnum["MALE"] = "MALE";
    CustomerUpdateRequestGenderEnum["UNDISCLOSED"] = "UNDISCLOSED";
})(CustomerUpdateRequestGenderEnum || (CustomerUpdateRequestGenderEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerUpdateRequestTitleEnum;
(function (CustomerUpdateRequestTitleEnum) {
    CustomerUpdateRequestTitleEnum["MR"] = "MR";
    CustomerUpdateRequestTitleEnum["MRS"] = "MRS";
    CustomerUpdateRequestTitleEnum["MISS"] = "MISS";
    CustomerUpdateRequestTitleEnum["MS"] = "MS";
    CustomerUpdateRequestTitleEnum["DR"] = "DR";
})(CustomerUpdateRequestTitleEnum || (CustomerUpdateRequestTitleEnum = {}));
/**
 * @export
 * @enum {string}
 */
var CustomerUpdateRequestBrandEnum;
(function (CustomerUpdateRequestBrandEnum) {
    CustomerUpdateRequestBrandEnum["Lendi"] = "lendi";
    CustomerUpdateRequestBrandEnum["Domain"] = "domain";
})(CustomerUpdateRequestBrandEnum || (CustomerUpdateRequestBrandEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var Gender;
(function (Gender) {
    Gender["FEMALE"] = "FEMALE";
    Gender["MALE"] = "MALE";
    Gender["UNDISCLOSED"] = "UNDISCLOSED";
})(Gender || (Gender = {}));
/**
 *
 * @export
 * @enum {string}
 */
var Title;
(function (Title) {
    Title["MR"] = "MR";
    Title["MRS"] = "MRS";
    Title["MISS"] = "MISS";
    Title["MS"] = "MS";
    Title["DR"] = "DR";
})(Title || (Title = {}));
/**
 * CustomerApi - axios parameter creator
 * @export
 */
var CustomerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get customer profile
         * @param {string} id Customer profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1Auth0CustomersIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling v1Auth0CustomersIdGet.');
            }
            var localVarPath = "/v1/auth0/customers/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = (0,native_url.parse)(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = api_assign(api_assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = api_assign(api_assign(api_assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = api_assign(api_assign({}, localVarHeaderParameter), options.headers);
            return {
                url: (0,native_url.format)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves information for the customer that calls it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CustomersMeGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/v1/customers/me";
            var localVarUrlObj = (0,native_url.parse)(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = api_assign(api_assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = api_assign(api_assign(api_assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = api_assign(api_assign({}, localVarHeaderParameter), options.headers);
            return {
                url: (0,native_url.format)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CustomerApi - functional programming interface
 * @export
 */
var CustomerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get customer profile
         * @param {string} id Customer profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1Auth0CustomersIdGet: function (id, options) {
            var localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).v1Auth0CustomersIdGet(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = (axios_default()); }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = api_assign(api_assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retrieves information for the customer that calls it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CustomersMeGet: function (options) {
            var localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).v1CustomersMeGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = (axios_default()); }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = api_assign(api_assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CustomerApi - factory interface
 * @export
 */
var CustomerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get customer profile
         * @param {string} id Customer profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1Auth0CustomersIdGet: function (id, options) {
            return CustomerApiFp(configuration).v1Auth0CustomersIdGet(id, options)(axios, basePath);
        },
        /**
         *
         * @summary Retrieves information for the customer that calls it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CustomersMeGet: function (options) {
            return CustomerApiFp(configuration).v1CustomersMeGet(options)(axios, basePath);
        },
    };
};
/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
var CustomerApi = /** @class */ (function (_super) {
    api_extends(CustomerApi, _super);
    function CustomerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get customer profile
     * @param {string} id Customer profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.v1Auth0CustomersIdGet = function (id, options) {
        return CustomerApiFp(this.configuration).v1Auth0CustomersIdGet(id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retrieves information for the customer that calls it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.v1CustomersMeGet = function (options) {
        return CustomerApiFp(this.configuration).v1CustomersMeGet(options)(this.axios, this.basePath);
    };
    return CustomerApi;
}(BaseAPI));

/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Documents health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/healthcheck";
            var localVarUrlObj = (0,native_url.parse)(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = api_assign(api_assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = api_assign(api_assign(api_assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = api_assign(api_assign({}, localVarHeaderParameter), options.headers);
            return {
                url: (0,native_url.format)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Documents health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckGet: function (options) {
            var localVarAxiosArgs = HealthCheckApiAxiosParamCreator(configuration).healthcheckGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = (axios_default()); }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = api_assign(api_assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Documents health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckGet: function (options) {
            return HealthCheckApiFp(configuration).healthcheckGet(options)(axios, basePath);
        },
    };
};
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    api_extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Documents health check endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.healthcheckGet = function (options) {
        return HealthCheckApiFp(this.configuration).healthcheckGet(options)(this.axios, this.basePath);
    };
    return HealthCheckApi;
}(BaseAPI));

//# sourceMappingURL=api.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/customer-client/dist/esm/configuration.js
// tslint:disable
/**
 * Customer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
    return Configuration;
}());

//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/customer-client/dist/esm/index.js
// tslint:disable
/**
 * Customer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/customerService.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var customerAPI = new CustomerApi({}, Environment_getAPIBaseURL(Environment_getEnv()));
var getCustomer = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, customerAPI.v1CustomersMeGet({
                    headers: { Authorization: "Bearer ".concat(token), 'Content-Type': 'application/json' },
                })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result.data && result.data.data];
        }
    });
}); };
//# sourceMappingURL=customerService.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/getTypeFromHostname.js

function getTypeFromHostname_getTypeFromHostname() {
    var hostname = window.location.hostname;
    var hostNameRegex = new RegExp('^team.');
    /*
      hostname === 'team.lendi.com.au' ||
      hostname === 'team.lendi-stg.net' ||
      hostname === 'team.lendi-preprod.net' ||
      hostname === 'team.lendi-dev.net' ||
      hostname === 'team.aussie.com.au' ||
      hostname === 'team.aussie-stg.com.au' ||
      hostname === 'team.aussie-preprod.com.au' ||
      hostname === 'team.aussie-dev.com.au' ||
      hostname === 'team-dlf.lendi-dev.net' ||
      hostname === 'team-dlf.lendi-stg.net' ||
      hostname === 'team-dlf.lendi.com.au'
    */
    // team
    if (hostNameRegex.test(hostname)) {
        return Type.Team;
    }
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net' ||
        hostname === 'www.lendi-preprod.net') {
        return Type.Customer;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-preprod.com.au') {
        return Type.Customer;
    }
    // domain customer
    if (hostname === 'www.domain.com.au' || hostname === 'stage.domain.com.au' || hostname === 'dlf.lendi-paas-dev.net') {
        return Type.Customer;
    }
    // default to customer
    return Type.Customer;
}
//# sourceMappingURL=getTypeFromHostname.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/node_modules/@lendi/lala-utils/dist/esm/index.js






















//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/dist/esm/constants.js
// Those are the clientId from cross-functional team (Funnels). For more info, see: https://creditandfinance.atlassian.net/wiki/spaces/engineering/pages/1074692778/LaunchDarkly+implementation+guideline#Environment-%26-project
var LAUNCH_DARKLY_XF_PRODUCTION_CLIENT_SIDE_ID = '5e5486f5f434d50824ef46b0';
var LAUNCH_DARKLY_XF_PREPRODUCTION_CLIENT_SIDE_ID = '61d4cd637fe8d014e78814fa';
var LAUNCH_DARKLY_XF_STAGING_CLIENT_SIDE_ID = '5e5486f5f434d50824ef46af';
var LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID = '5e54875ff434d50824ef46b6';
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/dist/esm/utils/getClientId/index.js


var getClientId_getClientId = function (environment) {
    switch (environment) {
        case esm_Environment_Environment.Development:
            return LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID;
        case esm_Environment_Environment.Staging:
            return LAUNCH_DARKLY_XF_STAGING_CLIENT_SIDE_ID;
        case esm_Environment_Environment.Preproduction:
            return LAUNCH_DARKLY_XF_PREPRODUCTION_CLIENT_SIDE_ID;
        case esm_Environment_Environment.Production:
            return LAUNCH_DARKLY_XF_PRODUCTION_CLIENT_SIDE_ID;
        default:
            return LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID;
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/launchdarkly/dist/esm/LDProvider/index.js
var LDProvider_assign = (undefined && undefined.__assign) || function () {
    LDProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return LDProvider_assign.apply(this, arguments);
};
var LDProvider_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var LendiLDConsumer = function (_a) {
    // const environment = getEnvironment(); // TODO: A better way to get `type` is to use the `getEnvironment()` method from Acquire team. But they've kept it to themselves in `@lendi/lala-callback-app/src/getEnvironment.ts`. We'll use session's environment for now, but in the futurue ideally we should get it from `getEnvironment()`;
    // const type = getTypeFromHostname(); // TODO: A better way to get `type` is to use the `getTypeFromHostname()` method from Acquire team. But they've kept it to themselves in `@lendi/lala-callback-app/src/getTypeFromHostname.ts`. We'll use session's type for now, but in the futurue ideally we should get it from `getTypeFromHostname()`;
    var children = _a.children, clientId = _a.clientId;
    var _b = (0,dist_esm/* useSession */.kP)(), identity = _b.identity, type = _b.type, _c = _b.brand, brand = _c === void 0 ? getBrandFromHostname_getBrandFromHostname() : _c;
    var isTeamView = type === dist_esm/* Type.Team */.Dy.Team;
    var custom = { isTeamView: isTeamView, brand: brand };
    var ldClient = (0,lib.useLDClient)();
    react.useEffect(function () {
        if (ldClient) {
            if (identity) {
                ldClient.identify({ key: identity.id, custom: custom });
            }
            else {
                ldClient.identify({ anonymous: true, custom: custom }); // TODO: Funnels 1 uses a magic method to track anonymous user. Consider implementing it here. Docs: https://docs.launchdarkly.com/sdk/client-side/javascript#anonymous-users
            }
        }
        else {
            // Do nothing
        }
    }, [ldClient, identity]);
    return react.createElement(react.Fragment, null, children);
};
/**
 * LendiLDProvider
 *
 * This Provider utilzes the session from `@lendi/lala-react` to identify user to LaunchDarkly platform. It'll work for app behind authentication. (Qualis, Submissions)
 *
 * @param clientId In case application wish to provide a custom clientId
 * @param children
 * @constructor
 */
function LendiLDProvider(_a) {
    var children = _a.children, clientId = _a.clientId;
    var _b = useSession().environment /* Use `environment` from `session` if available, otherwise default to Development */, environment = _b === void 0 ? Environment.Development : _b /* Use `environment` from `session` if available, otherwise default to Development */;
    var launchdarklyClientId = clientId || getClientId(environment);
    var options = {}; // TODO: Set Options
    var reactOptions = {}; // TODO: Set React Options
    return (React.createElement(LDProvider, { clientSideID: launchdarklyClientId, options: options, reactOptions: reactOptions },
        React.createElement(LendiLDConsumer, null, children)));
}
var withLendiLDProvider = function (Component) {
    return function (_a) {
        var clientId = _a.clientId, props = LDProvider_rest(_a, ["clientId"]);
        var environment = (0,dist_esm/* useSession */.kP)().environment;
        if (!environment) {
            return null;
        }
        return (react.createElement(lib.LDProvider, { clientSideID: clientId || getClientId_getClientId(environment) },
            react.createElement(LendiLDConsumer, null,
                react.createElement(Component, LDProvider_assign({}, props)))));
    };
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/borders/dist/commons.esm.js
var dist_commons_esm = __webpack_require__(53075);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/colours/dist/commons.esm.js
var colours_dist_commons_esm = __webpack_require__(56116);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Launch/dist/icon.esm.js






function SvgLaunch(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
      })]
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/typography/dist/typography.esm.js
var typography_esm = __webpack_require__(56158);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatBootstrapperProvider/context.js
var context = __webpack_require__(71771);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/index.js + 22 modules
var lala_utils_dist_esm = __webpack_require__(34795);
// EXTERNAL MODULE: ../../../node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(76598);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/customerService/index.js
var customerService_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var customerService_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var customerService_getCustomer = function (token, environment) { return customerService_awaiter(void 0, void 0, void 0, function () {
    var axiosConfig, result;
    return customerService_generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                axiosConfig = {
                    baseURL: (0,lala_utils_dist_esm/* getAPIBaseURL */.K0)(environment),
                    headers: {
                        Authorization: "Bearer ".concat(token),
                        'Content-Type': 'application/json',
                    },
                };
                return [4 /*yield*/, axios/* default.get */.Z.get('/v1/customers/me', axiosConfig)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result.data && result.data.data];
        }
    });
}); };
var pollGetCustomer = function (token, environment, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.timeout, timeout = _c === void 0 ? 10000 : _c, _d = _b.interval, interval = _d === void 0 ? 1000 : _d;
    var endTime = Number(Date.now()) + timeout;
    var callbackPromise = function (resolve, reject) {
        // dive into the ajax promise
        customerService_getCustomer(token, environment)
            .then(function (obj) {
            // If the condition is met, we're done!
            resolve(obj);
        })
            .catch(function () {
            // Request failed, call again if time not spaned!
            if (Number(Date.now()) < endTime) {
                setTimeout(function () {
                    callbackPromise(resolve, reject);
                }, interval);
            }
            else {
                reject(new Error('Timed out, please try again.'));
            }
        });
    };
    return new Promise(callbackPromise);
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/analytics/lib/esm/ClientLendiAnalytics.js
var ClientLendiAnalytics = __webpack_require__(99036);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/analytics.js
var analytics_assign = (undefined && undefined.__assign) || function () {
    analytics_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return analytics_assign.apply(this, arguments);
};

var analytics = function (event) {
    (0,ClientLendiAnalytics/* trackEvent */.L9)(analytics_assign({}, event));
};

//# sourceMappingURL=analytics.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/types.js
var types = __webpack_require__(72239);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/analytics/lib/esm/events/common.js
var common = __webpack_require__(32126);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ErrorProvider/context.js

var ErrorContext = react.createContext(undefined);
var useError = function () {
    var errorState = react.useContext(ErrorContext);
    if (!errorState) {
        throw new Error('Please setup <ErrorProvider /> as a parent component, before using useError().');
    }
    return errorState;
};
//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/hooks/useChatAuthenticationTracking/index.js
var useChatAuthenticationTracking_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useChatAuthenticationTracking_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






// tracks when user is authenticated on chat and capture customer existence
var useChatAuthenticationTracking = function (customerExistenceStatus, hasAuthedViaChat) {
    var _a = (0,dist_esm/* useSession */.kP)(), status = _a.status, token = _a.token, environment = _a.environment;
    var onException = useError().onException;
    function trackingHandler() {
        return useChatAuthenticationTracking_awaiter(this, void 0, void 0, function () {
            var isNewCustomer, customer, err_1;
            return useChatAuthenticationTracking_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isNewCustomer = customerExistenceStatus !== CustomerExistenceEnum.REGISTERED;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, pollGetCustomer(token, environment)];
                    case 2:
                        customer = _a.sent();
                        // track event when user completes the authentication via SmartChat
                        analytics({
                            event_name: types/* ChatEventName.USER_AUTHENTICATED */.Y.USER_AUTHENTICATED,
                            userId: customer.id,
                            isNewCustomer: isNewCustomer,
                            category: common/* EventCategory.CHAT */.Jk.CHAT,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        onException(new Error("@lendi/chat: useChatAuthenticationTracking: Could not get the customer: ".concat(err_1)));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    (0,react.useEffect)(function () {
        // track only when user is authenticated
        if (hasAuthedViaChat &&
            status === dist_esm/* Status.Authenticated */.qb.Authenticated &&
            customerExistenceStatus !== CustomerExistenceEnum.UNKNOWN) {
            trackingHandler();
        }
    }, [status, hasAuthedViaChat, customerExistenceStatus]);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatAnalyicsProvider/index.js
var ChatAnalyicsProvider_assign = (undefined && undefined.__assign) || function () {
    ChatAnalyicsProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ChatAnalyicsProvider_assign.apply(this, arguments);
};


var ChatAnalyticsContext = react.createContext({
    setIsExistingCustomer: function () { return false; },
    setAuthViaSmartChat: function () { return false; },
    authViaSmartChat: false,
});
var CustomerExistenceEnum;
(function (CustomerExistenceEnum) {
    CustomerExistenceEnum["REGISTERED"] = "REGISTERED";
    CustomerExistenceEnum["NEW"] = "NEW";
    CustomerExistenceEnum["UNKNOWN"] = "UNKNOWN";
})(CustomerExistenceEnum || (CustomerExistenceEnum = {}));
var ChatAnalyticsProvider = function (_a) {
    var children = _a.children;
    var _b = react.useState(CustomerExistenceEnum.UNKNOWN), customerExistenceStatus = _b[0], setCustomerExistenceStatus = _b[1];
    var _c = react.useState(false), hasAuthedViaChat = _c[0], setChatAuthed = _c[1];
    // tracks when user is authenticated on chat
    useChatAuthenticationTracking(customerExistenceStatus, hasAuthedViaChat);
    return (react.createElement(ChatAnalyticsContext.Provider, { value: {
            setIsExistingCustomer: function (isExist) {
                return setCustomerExistenceStatus(isExist ? CustomerExistenceEnum.REGISTERED : CustomerExistenceEnum.NEW);
            },
            setAuthViaSmartChat: function (isAuth) { return setChatAuthed(isAuth); },
            authViaSmartChat: hasAuthedViaChat,
        } }, children));
};
var useChatAuthAnalytics = function () {
    var analyticsState = react.useContext(ChatAnalyticsContext);
    if (!analyticsState) {
        throw new Error('Please setup <ChatAnalyticsContext /> as a parent component, before using useAnalytics().');
    }
    return analyticsState;
};
var withChatAnalytics = function (Component) {
    return function (props) {
        return (react.createElement(ChatAnalyticsProvider, null,
            react.createElement(Component, ChatAnalyicsProvider_assign({}, props))));
    };
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ErrorProvider/provider.js


var ErrorProvider = function (_a) {
    var children = _a.children, onException = _a.onException;
    return (react.createElement(ErrorContext.Provider, { value: {
            onException: onException,
        } }, children));
};
//# sourceMappingURL=provider.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ErrorProvider/withErrorProvider.js
var withErrorProvider_assign = (undefined && undefined.__assign) || function () {
    withErrorProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return withErrorProvider_assign.apply(this, arguments);
};


var withErrorProvider = function (Component) {
    return function (props) {
        return (react.createElement(ErrorProvider, { onException: props.onException },
            react.createElement(Component, withErrorProvider_assign({}, props))));
    };
};
//# sourceMappingURL=withErrorProvider.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/SafetyNetProvider/index.js
var SafetyNetProvider_assign = (undefined && undefined.__assign) || function () {
    SafetyNetProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return SafetyNetProvider_assign.apply(this, arguments);
};


var SafetyNetProviderContext = react.createContext({});
var SafetyNetProvider_SAFETY_NET_COOKIE_NAME = 'safetynet';
var SafetyNetProvider = function (_a) {
    var children = _a.children, openChat = _a.openChat;
    // chat window not open
    if (!openChat)
        return react.createElement(react.Fragment, null);
    if (api.get(SafetyNetProvider_SAFETY_NET_COOKIE_NAME) === 'true') {
        var pathname = window.location.pathname;
        var returnURL = "".concat(pathname, "?openChatWindow=1");
        var encodeURI_1 = encodeURIComponent(returnURL);
        window.location.assign("/safety-net?returnURL=".concat(encodeURI_1));
        return null;
    }
    return react.createElement(SafetyNetProviderContext.Provider, { value: {} }, children);
};
var withSafetyNetProvider = function (Component) {
    return function (props) {
        return (react.createElement(SafetyNetProvider, { openChat: props.openChat },
            react.createElement(Component, SafetyNetProvider_assign({}, props))));
    };
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/hooks/useChatOpenTracking/index.js



// track events when user clicks the chat on comm panel
var useChatOpenTracking = function (isAParticipant, hasAuthedViaChat) {
    if (isAParticipant === void 0) { isAParticipant = true; }
    if (hasAuthedViaChat === void 0) { hasAuthedViaChat = false; }
    var status = (0,dist_esm/* useSession */.kP)().status;
    (0,react.useEffect)(function () {
        var trackEventOnChatOpen = function () {
            if (status === dist_esm/* Status.Authenticated */.qb.Authenticated) {
                // this track when user is authenticated but not via SmartChat.
                if (!hasAuthedViaChat) {
                    var event_1 = {
                        event_name: types/* ChatEventName.OPENED */.Y.OPENED,
                        category: common/* EventCategory.CHAT */.Jk.CHAT,
                        authenticationStatus: common/* AuthenticationStatus.AUTHENTICATED */.y_.AUTHENTICATED,
                        isAParticipant: isAParticipant,
                    };
                    analytics(event_1);
                }
            }
            else {
                // this track when user is not authenticated - which could be unauthenticated, errored, expired.
                var event_2 = {
                    event_name: types/* ChatEventName.OPENED */.Y.OPENED,
                    category: common/* EventCategory.CHAT */.Jk.CHAT,
                    authenticationStatus: common/* AuthenticationStatus.UNAUTHENTICATED */.y_.UNAUTHENTICATED,
                };
                analytics(event_2);
            }
        };
        trackEventOnChatOpen();
    }, [status, hasAuthedViaChat]);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/hooks/useSmartChatTracking/index.js


// tracks event getting fired on user input on chat
var useSmartChatTracking = function (phoneNumber, email, firstName) {
    (0,react.useEffect)(function () {
        if (phoneNumber) {
            // track when a phone number has entered
            analytics({
                event_name: types/* ChatEventName.PHONE_NUMBER_ENTERED */.Y.PHONE_NUMBER_ENTERED,
                category: common/* EventCategory.CHAT */.Jk.CHAT,
            });
        }
    }, [phoneNumber]);
    (0,react.useEffect)(function () {
        if (email) {
            // track when a email has entered
            analytics({
                event_name: types/* ChatEventName.EMAIL_ENTERED */.Y.EMAIL_ENTERED,
                category: common/* EventCategory.CHAT */.Jk.CHAT,
            });
        }
    }, [email]);
    (0,react.useEffect)(function () {
        if (firstName) {
            // track when a firstName has entered
            analytics({
                event_name: types/* ChatEventName.FIRST_NAME_ENTERED */.Y.FIRST_NAME_ENTERED,
                category: common/* EventCategory.CHAT */.Jk.CHAT,
            });
        }
    }, [firstName]);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/types.js
var ChatPanels;
(function (ChatPanels) {
    ChatPanels["CurrentThread"] = "CurrentThread";
    ChatPanels["Threads"] = "Threads";
    ChatPanels["Default"] = "Default";
})(ChatPanels || (ChatPanels = {}));
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/KeyboardArrowLeft/dist/icon.esm.js






function SvgKeyboardArrowLeft(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0-.5h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/spinner/dist/spinner.esm.js + 1 modules
var spinner_esm = __webpack_require__(75910);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/analytics/lib/esm/events/objects/button/index.js
var button_ButtonType;
(function (ButtonType) {
    ButtonType["PRIMARY"] = "Primary";
    ButtonType["SECONDARY"] = "Secondary";
    ButtonType["EMPHASIS"] = "Emphasis";
    ButtonType["EMPTY"] = "Empty";
    ButtonType["LINK"] = "Link";
    ButtonType["ICON"] = "Icon";
})(button_ButtonType || (button_ButtonType = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/state/types/index.js

var LENDI_BOT_IDENTITY = 'lendi_bot';
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/state/types/LendiMember.js
var LendiMemberType;
(function (LendiMemberType) {
    LendiMemberType["CUSTOMER"] = "customer";
    LendiMemberType["TEAM"] = "team";
    LendiMemberType["BOT"] = "bot";
})(LendiMemberType || (LendiMemberType = {}));
//# sourceMappingURL=LendiMember.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/state/index.js

var lendiBot = {
    identity: LENDI_BOT_IDENTITY,
    isOnline: false,
    isTyping: false,
    firstName: 'Lendi',
    lastName: 'Bot',
    type: LendiMemberType.BOT,
    lastConsumedMessageIndex: 0,
};
var initialState = {
    accessToken: undefined,
    channelId: '',
    identity: undefined,
    recipientIdentity: undefined,
    client: undefined,
    messages: [],
    members: [lendiBot],
    channel: undefined,
    loading: false,
    hasNew: false,
    retryFetch: undefined,
    retryingFetch: false,
    sendMessage: undefined,
    setMessagesRead: undefined,
    error: undefined,
    fetchMore: undefined,
    fetchingMore: false,
    hasMore: true,
    hasCustomerAddedNewMessage: false,
    lendiBotTyping: false,
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/ChatContext.js
/* istanbul ignore file */


var ChatContext = react.createContext(initialState);
//# sourceMappingURL=ChatContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/index.js


var useChat = function () {
    var chatState = react.useContext(ChatContext);
    if (!chatState) {
        throw new Error('Please setup <ChatProvider /> as a parent component, before using usechat().');
    }
    return chatState;
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/Close/dist/icon.esm.js
var icon_esm = __webpack_require__(82447);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatHeader/CloseButton/index.js
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var CloseButton = function (_a) {
    var onClose = _a.onClose;
    return react.createElement(IconButtonStyled, { icon: icon_esm/* default */.Z, color: (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'disabled'), onClick: onClose });
};
var IconButtonStyled = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* IconButton */.hU)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/depth/dist/commons.esm.js
var depth_dist_commons_esm = __webpack_require__(46706);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/typography/dist/commons.esm.js
var typography_dist_commons_esm = __webpack_require__(70757);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/menu-dropdown/dist/menu-dropdown.esm.js










function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function menu_dropdown_esm_defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function menu_dropdown_esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function menu_dropdown_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? menu_dropdown_esm_ownKeys(Object(source), !0).forEach(function (key) {
      menu_dropdown_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : menu_dropdown_esm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function menu_dropdown_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function menu_dropdown_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = menu_dropdown_esm_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var ItemWrapperBySizeMixin = size => {
  switch (size) {
    case 'sm':
      return "height: 32px;   ".concat((0,spacing_esm.p)('sm'), ";");
    case 'md':
      return "height: 40px;   ".concat((0,spacing_esm.p)('md'), ";");
    case 'lg':
      return "height: 56px;   ".concat((0,spacing_esm.p)('lg'), ";");
    default:
      return undefined;
  }
};
var ItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__ItemWrapper",
  componentId: "lui__sc-18bcxte-0"
})(["background-color:white;", ";width:250px;cursor:pointer;box-sizing:border-box;display:flex;justify-content:flex-start;align-items:center;&:hover{color:", ";background-color:", ";}span{pointer-events:none;}"], props => props.size && ItemWrapperBySizeMixin(props.size), _ref => {
  var {
    theme
  } = _ref;
  return theme.name === 'lendi' ? theme.color.text.inverse : theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.name === 'lendi' ? '#0d5a6d' : theme.color.background.emphasis;
});
var IconWrapper$1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-18bcxte-1"
})(["", ";", ";line-height:1em;"], (0,spacing_esm.pl)('sm'), (0,spacing_esm.pr)('sm'));
var ChildWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__ChildWrapper",
  componentId: "lui__sc-18bcxte-2"
})(["", ";line-height:1em;"], (0,spacing_esm.pl)('sm'));

var _excluded$3 = ["size", "icon", "onClick", "children"];
var MenuDropdownItem = _ref => {
  var {
      size = 'md',
      icon,
      onClick = () => {},
      children
    } = _ref,
    otherProps = menu_dropdown_esm_objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ItemWrapper, menu_dropdown_esm_objectSpread2(menu_dropdown_esm_objectSpread2({
    size: size,
    onClick: onClick
  }, otherProps), {}, {
    children: [icon && /*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper$1, {
      children: icon
    }), children && /*#__PURE__*/(0,jsx_runtime.jsx)(ChildWrapper, {
      children: children
    })]
  }));
};

var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__ContentWrapper",
  componentId: "lui__sc-1yqzyyx-0"
})(["position:absolute;display:block;z-index:1;width:250px;overflow:hidden;border-radius:6px;box-shadow:", ";"], (0,depth_dist_commons_esm/* default */.Z)(1));

var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__Divider",
  componentId: "lui__sc-s5micb-0"
})(["width:250px;height:1px;background-color:", ";"], (0,colours_dist_commons_esm/* default */.ZP)('shade', 100));

var MenuDropdownDivider = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Divider, menu_dropdown_esm_objectSpread2({}, props));
};

var MenuDropdownContext = /*#__PURE__*/(0,react.createContext)({
  showDropdown: false
});
var useMenuDropdownContext = () => {
  var context = useContext(MenuDropdownContext);
  if (!context) {
    throw new Error("Menu Dropdown context cannot be rendered outside the Menu Dropdown component");
  }
  return context;
};

var _excluded$2 = ["children"];
class MenuDropdownContent extends react.Component {
  constructor() {
    super(...arguments);
    menu_dropdown_esm_defineProperty(this, "renderItem", child => {
      if ( /*#__PURE__*/react.isValidElement(child)) {
        return child;
      }
      return undefined;
    });
  }
  render() {
    var _this$props = this.props,
      {
        children: _children
      } = _this$props,
      otherProps = menu_dropdown_esm_objectWithoutProperties(_this$props, _excluded$2);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuDropdownContext.Consumer, {
      children: _ref => {
        var {
          showDropdown
        } = _ref;
        return showDropdown && /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, menu_dropdown_esm_objectSpread2(menu_dropdown_esm_objectSpread2({}, otherProps), {}, {
          children: react.Children.map(_children, this.renderItem)
        }));
      }
    });
  }
}
menu_dropdown_esm_defineProperty(MenuDropdownContent, "Item", MenuDropdownItem);
menu_dropdown_esm_defineProperty(MenuDropdownContent, "Divider", MenuDropdownDivider);

var TriggerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__TriggerWrapper",
  componentId: "lui__sc-1mezgx7-0"
})(["height:100%;display:flex;justify-content:space-between;align-items:center;cursor:pointer;:hover{color:", ";background-color:", ";}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.name === 'lendi' ? theme.color.text.inverse : theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.name === 'lendi' ? theme.color.fill.contrast : theme.color.background.emphasis;
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-1mezgx7-1"
})(["", ";", ";line-height:1em;"], (0,spacing_esm.pl)('sm'), (0,spacing_esm.pr)('sm'));

var _excluded$1 = ["iconBefore", "iconAfter", "children"];
var MenuDropdownTrigger = _ref => {
  var {
      iconBefore,
      iconAfter,
      children
    } = _ref,
    otherProps = menu_dropdown_esm_objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TriggerWrapper, menu_dropdown_esm_objectSpread2(menu_dropdown_esm_objectSpread2({}, otherProps), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [iconBefore && /*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
        children: iconBefore
      }), children, iconAfter && /*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
        children: iconAfter
      })]
    })
  }));
};

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-10omiv5-0"
})(["", ";min-width:45px;min-height:45px;line-height:45px;position:relative;display:inline-block;font-family:", ";"], utils_esm/* normalise */.W$, (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'));

var menu_dropdown_esm_excluded = ["children"];
class MenuDropdown extends react.Component {
  constructor() {
    super(...arguments);
    menu_dropdown_esm_defineProperty(this, "node", /*#__PURE__*/react.createRef());
    menu_dropdown_esm_defineProperty(this, "state", {
      showDropdown: false
    });
    menu_dropdown_esm_defineProperty(this, "handleWindowClick", e => {
      var _this$node$current;
      if ((_this$node$current = this.node.current) !== null && _this$node$current !== void 0 && _this$node$current.contains(e.target)) {
        // on dropdown.
        if (e.target instanceof HTMLDivElement) {
          e.target.click();
        }
        this.handleClick();
      } else {
        // outside
        this.setState({
          showDropdown: false
        });
      }
    });
    menu_dropdown_esm_defineProperty(this, "handleClick", () => {
      this.setState({
        showDropdown: !this.state.showDropdown
      });
    });
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleWindowClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleWindowClick, false);
  }
  render() {
    var _this$props = this.props,
      {
        children
      } = _this$props,
      otherProps = menu_dropdown_esm_objectWithoutProperties(_this$props, menu_dropdown_esm_excluded);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, menu_dropdown_esm_objectSpread2(menu_dropdown_esm_objectSpread2({
      ref: this.node
    }, otherProps), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuDropdownContext.Provider, {
        value: this.state,
        children: children
      })
    }));
  }
}
menu_dropdown_esm_defineProperty(MenuDropdown, "Content", MenuDropdownContent);
menu_dropdown_esm_defineProperty(MenuDropdown, "Trigger", MenuDropdownTrigger);



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatHeader/Menu/style.js
var style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledMenu = (0,styled_components_browser_esm/* default */.ZP)(MenuDropdown)(style_templateObject_1 || (style_templateObject_1 = style_makeTemplateObject(["\n  .menu-trigger:hover {\n    background-color: ", ";\n  }\n  min-height: auto;\n  min-width: auto;\n"], ["\n  .menu-trigger:hover {\n    background-color: ", ";\n  }\n  min-height: auto;\n  min-width: auto;\n"])), (0,color_esm/* color */.$)('shade.100'));
var ContentItem = (0,styled_components_browser_esm/* default */.ZP)(MenuDropdown.Content.Item)(templateObject_2 || (templateObject_2 = style_makeTemplateObject([""], [""])));
var Content = (0,styled_components_browser_esm/* default */.ZP)(MenuDropdown.Content)(templateObject_3 || (templateObject_3 = style_makeTemplateObject(["\n  left: -100px;\n  width: 150px;\n"], ["\n  left: -100px;\n  width: 150px;\n"])));
var style_templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatHeader/Menu/index.js






var Menu = function (_a) {
    var onShowHistory = _a.onShowHistory;
    return (react.createElement(StyledMenu, null,
        react.createElement(MenuDropdown.Trigger, { className: "menu-trigger", iconAfter: react.createElement(SvgMoreVert, { color: (0,colours_dist_commons_esm/* default */.ZP)('primary', '500'), width: "24px", height: "24px" }), onClick: function () {
                analytics({
                    event_name: 'Menu Clicked',
                    menuName: 'Kebab Menu',
                    path: window.location.href,
                    category: common/* EventCategory.CHAT */.Jk.CHAT,
                });
            } }),
        react.createElement(Content, null,
            react.createElement(ContentItem, { size: "lg", onClick: onShowHistory }, "History"))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatHeader/style.js
var ChatHeader_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var HeaderWrapper = styled_components_browser_esm/* default.div */.ZP.div(ChatHeader_style_templateObject_1 || (ChatHeader_style_templateObject_1 = ChatHeader_style_makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-bottom: 1px solid ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-bottom: 1px solid ", ";\n"])), (0,color_esm/* color */.$)('shade.300'));
var TitleWrapper = styled_components_browser_esm/* default.span */.ZP.span(style_templateObject_2 || (style_templateObject_2 = ChatHeader_style_makeTemplateObject(["\n  font-weight: 700;\n  font-size: 14px;\n"], ["\n  font-weight: 700;\n  font-size: 14px;\n"])));
var style_IconWrapper = styled_components_browser_esm/* default.span */.ZP.span(style_templateObject_3 || (style_templateObject_3 = ChatHeader_style_makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var HeaderRight = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = ChatHeader_style_makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: end;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: end;\n"])));
var ChatHeader_style_templateObject_1, style_templateObject_2, style_templateObject_3, templateObject_4;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatHeader/index.js











var ChatHeader = function (_a) {
    var activePanel = _a.activePanel, onShowHistory = _a.onShowHistory, showBackArrow = _a.showBackArrow, teamRestrictedViewProps = _a.teamRestrictedViewProps, onClose = _a.onClose;
    var _b = useChat(), members = _b.members, client = _b.client;
    var closeChat = (0,context/* useBootstrappedChatState */.D)().closeChat;
    var _c = (0,react.useState)(undefined), participantCount = _c[0], setParticipantsCount = _c[1];
    (0,react.useEffect)(function () {
        if (client && client.connectionState === 'connected' && members) {
            // Don't count Lendi Bot as participant.
            setParticipantsCount(members.length - 1);
        }
    }, [client, members]);
    var getTitle = function (activePanel, participantCount, teamRestrictedViewProps) {
        var isLoading = participantCount === undefined;
        // this is active channel participants count retrieved from twilio live connection
        var titleText = "".concat(participantCount, " ").concat(participantCount <= 1 ? 'Participant' : 'Participants');
        // this title is specific to team view where team member is not a member of the channel
        var restrictedTeamViewTitleText = "".concat(teamRestrictedViewProps === null || teamRestrictedViewProps === void 0 ? void 0 : teamRestrictedViewProps.teamRestrictedViewParticipantsCount, " ").concat((teamRestrictedViewProps === null || teamRestrictedViewProps === void 0 ? void 0 : teamRestrictedViewProps.teamRestrictedViewParticipantsCount) <= 1 ? 'Participant' : 'Participants');
        var title;
        switch (activePanel) {
            case ChatPanels.CurrentThread:
                if (teamRestrictedViewProps === null || teamRestrictedViewProps === void 0 ? void 0 : teamRestrictedViewProps.teamRestrictedView) {
                    title = restrictedTeamViewTitleText;
                }
                else {
                    title = isLoading ? (react.createElement(react.Fragment, null,
                        react.createElement(spinner_esm/* default */.Z, { variant: "dark" }),
                        " Loading...")) : (titleText);
                }
                break;
            case ChatPanels.Threads:
                title = react.createElement(react.Fragment, null, "Chat threads");
                break;
            case ChatPanels.Default:
            default:
                title = react.createElement(react.Fragment, null, "Chat");
        }
        return title;
    };
    return (react.createElement(HeaderWrapper, null,
        react.createElement("div", null,
            showBackArrow && (react.createElement(style_IconWrapper, { onClick: function () {
                    closeChat();
                    analytics({
                        event_name: 'Button Clicked',
                        category: common/* EventCategory.CHAT */.Jk.CHAT,
                        buttonType: button_ButtonType.ICON,
                        text: 'BackArrow',
                    });
                } },
                react.createElement(SvgKeyboardArrowLeft, { color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'secondary'), height: "24px", width: "24px" }))),
            react.createElement(TitleWrapper, null, getTitle(activePanel, participantCount, teamRestrictedViewProps))),
        react.createElement(HeaderRight, null,
            onShowHistory && react.createElement(Menu, { onShowHistory: onShowHistory }),
            onClose && react.createElement(CloseButton, { onClose: onClose }))));
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@seznam/compose-react-refs/composeRefs.js
var composeRefs = __webpack_require__(1596);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/text-area/dist/text-area.esm.js










function text_area_esm_toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function text_area_esm_toPropertyKey(arg) {
  var key = text_area_esm_toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function text_area_esm_defineProperty(obj, key, value) {
  key = text_area_esm_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function text_area_esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function text_area_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? text_area_esm_ownKeys(Object(source), !0).forEach(function (key) {
      text_area_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : text_area_esm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function text_area_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function text_area_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = text_area_esm_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var styleBySizeMixin = (size, rows) => (0,breakpoint_esm/* map */.UI)(size, val => {
  switch (val) {
    case 'xs':
      return (0,styled_components_browser_esm/* css */.iv)(["padding:", " ", ";font-size:", ";height:calc(", " * ", " * ", " + 2 * ", ");"], (0,utils_esm/* deriveSize */.MS)(0.5), (0,utils_esm/* deriveSize */.MS)(0.75), (0,utils_esm/* deriveSize */.MS)(0.875), utils_esm/* NORMALISE_LINE_HEIGHT */.N1, rows, (0,utils_esm/* deriveSize */.MS)(0.875), (0,utils_esm/* deriveSize */.MS)(0.5));
    case 'sm':
      return (0,styled_components_browser_esm/* css */.iv)(["padding:", " ", ";font-size:", ";height:calc(", " * ", " * ", " + 2 * ", ");"], (0,utils_esm/* deriveSize */.MS)(0.5), (0,utils_esm/* deriveSize */.MS)(0.75), (0,utils_esm/* deriveSize */.MS)(1), utils_esm/* NORMALISE_LINE_HEIGHT */.N1, rows, (0,utils_esm/* deriveSize */.MS)(1), (0,utils_esm/* deriveSize */.MS)(0.5));
    case 'md':
      return (0,styled_components_browser_esm/* css */.iv)(["padding:", " ", ";font-size:", ";height:calc(", " * ", " * ", " + 2 * ", ");"], (0,utils_esm/* deriveSize */.MS)(0.75), (0,utils_esm/* deriveSize */.MS)(1), (0,utils_esm/* deriveSize */.MS)(1.125), utils_esm/* NORMALISE_LINE_HEIGHT */.N1, rows, (0,utils_esm/* deriveSize */.MS)(1.125), (0,utils_esm/* deriveSize */.MS)(0.75));
    case 'lg':
      return (0,styled_components_browser_esm/* css */.iv)(["padding:", " ", ";font-size:", ";height:calc(", " * ", " * ", " + 2 * ", ");"], (0,utils_esm/* deriveSize */.MS)(1), (0,utils_esm/* deriveSize */.MS)(1.5), (0,utils_esm/* deriveSize */.MS)(1.375), utils_esm/* NORMALISE_LINE_HEIGHT */.N1, rows, (0,utils_esm/* deriveSize */.MS)(1.375), (0,utils_esm/* deriveSize */.MS)(1));
    default:
      return (0,styled_components_browser_esm/* css */.iv)(["padding:", " ", ";font-size:", ";height:calc(", " * ", " * ", " + 2 * ", ");"], (0,utils_esm/* deriveSize */.MS)(0.75), (0,utils_esm/* deriveSize */.MS)(1), (0,utils_esm/* deriveSize */.MS)(1.125), utils_esm/* NORMALISE_LINE_HEIGHT */.N1, rows, (0,utils_esm/* deriveSize */.MS)(1.125), (0,utils_esm/* deriveSize */.MS)(0.75));
  }
});
var InputBorderWidth = _ref => {
  var {
    isError
  } = _ref;
  return isError ? '2px' : '1px';
};
var InputBorderColor = _ref2 => {
  var {
    isInverse,
    isError
  } = _ref2;
  if (isError) return (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'error');
  if (isInverse) return (0,colours_dist_commons_esm/* default */.ZP)('shade', 25);
  return (0,colours_dist_commons_esm/* default */.ZP)('border', 'interaction');
};
var InputBorderHoverColor = _ref3 => {
  var {
    isInverse,
    isError
  } = _ref3;
  if (isError) return (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'error');
  if (isInverse) return (0,colours_dist_commons_esm/* default */.ZP)('shade', 0);

  // this used to be shade.400 even though colour handover says Now doesn't have a border hover colour
  return (0,colours_dist_commons_esm/* default */.ZP)('border', 'interaction', {
    state: 'hover'
  });
};
var TextAreaWrapper = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "indexstyle__TextAreaWrapper",
  componentId: "lui__sc-o0l6w5-0"
})(["", ";resize:none;overflow:auto;border-radius:", ";box-sizing:border-box;font-family:", ";", ";", ";::placeholder{color:", ";}:hover:not(:focus){", "}"], utils_esm/* normalise */.W$, (0,dist_commons_esm/* getRadius */.H5)(), (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'), _ref4 => {
  var {
    size,
    isInverse,
    isFullWidth,
    rows
  } = _ref4;
  return (0,styled_components_browser_esm/* css */.iv)(["color:", ";", ";", ";"], isInverse ? (0,colours_dist_commons_esm/* default */.ZP)('shade', 0) : (0,colours_dist_commons_esm/* default */.ZP)('text', 'main'), isFullWidth ? (0,styled_components_browser_esm/* css */.iv)(["width:100%;"]) : (0,styled_components_browser_esm/* css */.iv)(["width:auto;"]), styleBySizeMixin(size, rows));
}, _ref5 => {
  var {
    isInverse,
    isDisabled
  } = _ref5;
  if (isDisabled) {
    return (0,styled_components_browser_esm/* css */.iv)(["cursor:not-allowed;background-color:", ";border:1px solid ", ";"], (0,colours_dist_commons_esm/* default */.ZP)('fill', 'disabled'), isInverse ? (0,colours_dist_commons_esm/* default */.ZP)('shade', 0) : (0,colours_dist_commons_esm/* default */.ZP)('border', 'interaction'));
  } else {
    return (0,styled_components_browser_esm/* css */.iv)(["border:", " solid ", ";background-color:", ";"], InputBorderWidth, InputBorderColor, isInverse ? 'transparent' : (0,colours_dist_commons_esm/* default */.ZP)('fill', 'main'));
  }
}, (0,colours_dist_commons_esm/* default */.ZP)('text', 'subtle'), _ref6 => {
  var {
    isDisabled
  } = _ref6;
  return isDisabled ? undefined : (0,styled_components_browser_esm/* css */.iv)(["border:", " solid ", ";"], InputBorderWidth, InputBorderHoverColor);
});

var text_area_esm_excluded = ["size", "isError", "isInverse", "isFullWidth", "isDisabled", "maxRows", "onChange", "rows", "className"];
var TextArea = /*#__PURE__*/react.forwardRef((_ref, parentRef) => {
  var {
      size = 'md',
      isError = false,
      isInverse = false,
      isFullWidth = false,
      isDisabled = false,
      maxRows,
      onChange,
      rows: initialRows = 3,
      className = ''
    } = _ref,
    otherProps = text_area_esm_objectWithoutProperties(_ref, text_area_esm_excluded);
  var [rows, setRows] = react.useState(maxRows && initialRows > maxRows ? maxRows : initialRows);
  // we can use this to tell us what the new row value needs to be
  var [scrollHeightRatio, setScrollHeightRatio] = react.useState(0);
  var [scrollHeight, setScrollHeight] = react.useState(0);

  // remove padding from scrollheight calculation
  var getScrollHeightMinusPadding = node => {
    if (typeof window !== 'undefined') {
      var paddingY = parseFloat(window.getComputedStyle(node, null).getPropertyValue('padding-top')) * 2;
      // scrollHeight minus vertical padding is the value of (rows * lineHeight)
      return node.scrollHeight - paddingY;
    }
    return node.scrollHeight;
  };
  var scrollHeightRef = react.useCallback(node => {
    if (node !== null) {
      var currentScrollHeight = getScrollHeightMinusPadding(node);
      // get ratio of each line
      setScrollHeightRatio(currentScrollHeight / rows);
      // get scrollheight
      setScrollHeight(currentScrollHeight);
    }
    return node;
  }, []);

  // if rows if greater than maxRows by mistake then set rows to the maxRows
  var setRowsWithMax = rows => {
    if (maxRows && rows > maxRows) {
      setRows(maxRows);
    } else {
      setRows(rows);
    }
  };
  var handleChange = event => {
    if (maxRows) {
      // set rows to initial rows every time and allow us to change height
      event.target.rows = initialRows;
      event.target.style.height = 'auto';

      // get the current scrollHeight without vertical paddings
      var newScrollHeight = getScrollHeightMinusPadding(event.target);

      // when the incoming change affect scrollHeight then we change the scrollHeight and rows
      if (scrollHeight !== newScrollHeight) {
        setScrollHeight(newScrollHeight);
        setRowsWithMax(Math.round(newScrollHeight / scrollHeightRatio));
      }

      // once the incoming change rows is greater than maxRows then we make it scrollable
      if (Math.round(newScrollHeight / scrollHeightRatio) > maxRows) {
        event.target.scrollTop = event.target.scrollHeight;
      }
      // finally change rows and height back
      event.target.rows = rows;
      event.target.style.height = '';
    }
    if (onChange) {
      onChange(event);
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextAreaWrapper, text_area_esm_objectSpread2({
    size: size,
    "data-testid": "lui-textarea",
    id: "lui-textarea",
    rows: rows,
    ref: (0,composeRefs/* default */.Z)(parentRef, scrollHeightRef),
    isError: isError,
    isInverse: isInverse,
    isFullWidth: isFullWidth,
    disabled: isDisabled,
    isDisabled: isDisabled,
    className: className,
    onChange: handleChange
  }, otherProps));
});



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/fullstory/constants.js
var FULLSTORY_EXCLUDE_CLASS = 'fs-exclude';
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/text-input/dist/text-input.esm.js










function text_input_esm_toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function text_input_esm_toPropertyKey(arg) {
  var key = text_input_esm_toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function text_input_esm_defineProperty(obj, key, value) {
  key = text_input_esm_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function text_input_esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function text_input_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? text_input_esm_ownKeys(Object(source), !0).forEach(function (key) {
      text_input_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : text_input_esm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function text_input_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function text_input_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = text_input_esm_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var InputWithButton = props => {
  var InputWithButton = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
    displayName: "InputButton__InputWithButton",
    componentId: "lui__sc-1t83oga-0"
  })(["", ";"], props => {
    if (props.variant === 'secondary') {
      return (0,styled_components_browser_esm/* css */.iv)(["border:1px solid ", ";"], (0,colours_dist_commons_esm/* default */.ZP)('border', 'interaction'));
    }
    return undefined;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InputWithButton, text_input_esm_objectSpread2({}, props));
};
var InputButton = (0,styled_components_browser_esm/* default */.ZP)(InputWithButton).withConfig({
  displayName: "InputButton",
  componentId: "lui__sc-1t83oga-1"
})([":focus{outline:5px auto -webkit-focus-ring-color;opacity:1;box-shadow:none;transform:scale(1);}:active{transform:scale(1);}"]);

var _templateObject, _templateObject2;
var heightBySizeMixin = size => (0,breakpoint_esm/* map */.UI)(size, val => {
  switch (val) {
    case 'xs':
      return (0,styled_components_browser_esm/* css */.iv)(["height:", ";", ""], (0,utils_esm/* deriveSize */.MS)(1.57), (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            height: ", ";\n          "])), (0,utils_esm/* deriveSize */.MS)(1.625)));
    case 'sm':
      return (0,styled_components_browser_esm/* css */.iv)(["height:", ";"], (0,utils_esm/* deriveSize */.MS)(2.5));
    case 'md':
      return (0,styled_components_browser_esm/* css */.iv)(["height:", ";"], (0,utils_esm/* deriveSize */.MS)(3));
    case 'lg':
      return (0,styled_components_browser_esm/* css */.iv)(["height:", ";"], (0,utils_esm/* deriveSize */.MS)(4));
    default:
      return undefined;
  }
});
var fontBySizeMixin = size => (0,breakpoint_esm/* map */.UI)(size, val => {
  switch (val) {
    case 'xs':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";", ""], (0,utils_esm/* deriveSize */.MS)(0.7857), (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["font-size: ", ";"])), (0,utils_esm/* deriveSize */.MS)(0.75)));
    case 'sm':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";"], (0,utils_esm/* deriveSize */.MS)(0.875));
    case 'md':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";"], (0,utils_esm/* deriveSize */.MS)(1));
    case 'lg':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";"], (0,utils_esm/* deriveSize */.MS)(1.125));
    default:
      return undefined;
  }
});
var text_input_esm_InputBorderColor = _ref => {
  var {
    isInverse,
    isError
  } = _ref;
  var color;
  if (!isError) {
    if (!isInverse) {
      color = (0,colours_dist_commons_esm/* default */.ZP)('border', 'interaction');
    } else {
      color = (0,colours_dist_commons_esm/* default */.ZP)('background', 'page');
    }
  } else {
    color = (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'error');
  }
  return color;
};
var text_input_esm_InputBorderWidth = _ref2 => {
  var {
    isError
  } = _ref2;
  return isError ? '2px' : '1px';
};
var text_input_esm_InputBorderHoverColor = _ref3 => {
  var {
    isInverse,
    isError
  } = _ref3;
  var color;
  if (!isError) {
    if (!isInverse) {
      color = (0,colours_dist_commons_esm/* default */.ZP)('border', 'interaction', {
        state: 'hover'
      });
    } else {
      color = (0,colours_dist_commons_esm/* default */.ZP)('shade', 0);
    }
  } else {
    color = (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'error');
  }
  return color;
};
var Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__Layout",
  componentId: "lui__sc-lnm15l-0"
})(["", " display:inline-flex;flex-direction:row;align-items:center;justify-content:center;box-sizing:border-box;", ""], utils_esm/* normalise */.W$, _ref4 => {
  var {
    isFullWidth,
    size,
    isInverse,
    isDisabled
  } = _ref4;
  return isDisabled ? (0,styled_components_browser_esm/* css */.iv)(["border-radius:", ";cursor:not-allowed;width:", ";background-color:", ";border:1px solid ", ";:hover:not(:focus){border:1px solid ", ";}", " ", ""], size === 'xs' ? '12px' : (0,dist_commons_esm/* getRadius */.H5)(), isFullWidth ? '100%' : 'auto', isInverse ? 'transparent' : (0,colours_dist_commons_esm/* default */.ZP)('background', 'page'), isInverse ? (0,colours_dist_commons_esm/* default */.ZP)('fill', 'main') : (0,colours_dist_commons_esm/* default */.ZP)('border', 'container'), text_input_esm_InputBorderHoverColor, heightBySizeMixin(size), isFullWidth ? (0,styled_components_browser_esm/* css */.iv)(["width:100%;"]) : widthBySizeMixin(size)) : (0,styled_components_browser_esm/* css */.iv)(["border-radius:", ";border:", " solid ", ";width:", ";background-color:", ";", " ", ""], size === 'xs' ? '21px' : (0,dist_commons_esm/* getRadius */.H5)(), text_input_esm_InputBorderWidth, text_input_esm_InputBorderColor, isFullWidth ? '100%' : 'auto', isInverse ? 'transparent' : (0,colours_dist_commons_esm/* default */.ZP)('fill', 'main'), heightBySizeMixin(size), isFullWidth ? (0,styled_components_browser_esm/* css */.iv)(["width:100%;"]) : widthBySizeMixin(size));
});
var widthBySizeMixin = size => (0,breakpoint_esm/* map */.UI)(size, val => {
  switch (val) {
    case 'xs':
      return (0,styled_components_browser_esm/* css */.iv)(["width:", ";"], (0,utils_esm/* deriveSize */.MS)(12.5));
    case 'sm':
      return (0,styled_components_browser_esm/* css */.iv)(["width:", ";"], (0,utils_esm/* deriveSize */.MS)(14.5));
    case 'md':
      return (0,styled_components_browser_esm/* css */.iv)(["width:", ";"], (0,utils_esm/* deriveSize */.MS)(21.5));
    case 'lg':
      return (0,styled_components_browser_esm/* css */.iv)(["width:", ";"], (0,utils_esm/* deriveSize */.MS)(24));
    default:
      return (0,styled_components_browser_esm/* css */.iv)(["width:", ";"], (0,utils_esm/* deriveSize */.MS)(21.5));
  }
});
var InputWrapper = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "indexstyle__InputWrapper",
  componentId: "lui__sc-lnm15l-1"
})(["flex:1 1 auto;height:100%;min-width:0;width:100%;border:0px;&::placeholder{color:", ";}&:disabled{cursor:not-allowed;", ";}", ""], (0,colours_dist_commons_esm/* default */.ZP)('text', 'subtle'), _ref5 => {
  var {
    isInverse
  } = _ref5;
  return (0,styled_components_browser_esm/* css */.iv)(["background-color:", ";"], isInverse ? 'transparent' : (0,colours_dist_commons_esm/* default */.ZP)('fill', 'disabled'));
}, _ref6 => {
  var {
    fontSize,
    isInverse
  } = _ref6;
  return (0,styled_components_browser_esm/* css */.iv)(["", " border-radius:", ";color:", ";background-color:", ";font-family:", ";padding:", ";"], fontBySizeMixin(fontSize), fontSize === 'xs' ? '21px' : (0,dist_commons_esm/* getRadius */.H5)(), isInverse ? (0,colours_dist_commons_esm/* default */.ZP)('fill', 'main') : (0,colours_dist_commons_esm/* default */.ZP)('text', 'main'), isInverse ? 'transparent' : (0,colours_dist_commons_esm/* default */.ZP)('fill', 'main'), (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'), fontSize === 'xs' ? "0 ".concat((0,utils_esm/* deriveSize */.MS)(0.25)) : "0 ".concat((0,utils_esm/* deriveSize */.MS)(1)));
});
var BeforeWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "indexstyle__BeforeWrapper",
  componentId: "lui__sc-lnm15l-2"
})(["", "{border-top-right-radius:0;border-bottom-right-radius:0;margin:0 0 0 -1px;}box-sizing:content-box;padding-right:1px;flex:1 0 auto;line-height:1px;", ""], InputButton, _ref7 => {
  var {
    isDisabled
  } = _ref7;
  return isDisabled && (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;"]);
});
var AfterWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "indexstyle__AfterWrapper",
  componentId: "lui__sc-lnm15l-3"
})(["", "{border-top-left-radius:0;border-bottom-left-radius:0;margin:0 -1px 0 0;}box-sizing:content-box;padding-left:1px;flex:1 0 auto;line-height:1px;", ";"], InputButton, _ref8 => {
  var {
    isDisabled
  } = _ref8;
  if (isDisabled) {
    return (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;"]);
  }
  return undefined;
});

var text_input_esm_excluded = ["size", "before", "after", "isError", "isInverse", "isFullWidth", "isDisabled", "isReadOnly", "isAutoFocus", "isRequired", "inputSize", "type"];
var supportedTypes = ['text', 'email', 'number', 'tel'];
var Input = /*#__PURE__*/react.forwardRef((_ref, parentRef) => {
  var {
      size = 'md',
      before,
      after,
      isError = false,
      isInverse = false,
      isFullWidth = false,
      isDisabled = false,
      isReadOnly = false,
      isAutoFocus = false,
      isRequired = false,
      inputSize,
      type = 'text'
    } = _ref,
    otherProps = text_input_esm_objectWithoutProperties(_ref, text_input_esm_excluded);
  var disabledVal = isDisabled || !!otherProps.disabled;
  var refInput = react.useRef(null);
  react.useEffect(() => {
    if (refInput.current && (isAutoFocus || otherProps.autoFocus)) {
      refInput.current.focus();
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout, {
    size: size,
    isFullWidth: isFullWidth,
    isInverse: isInverse,
    isError: isError,
    isDisabled: disabledVal,
    children: [before && /*#__PURE__*/(0,jsx_runtime.jsx)(BeforeWrapper, {
      isDisabled: disabledVal,
      children: before
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputWrapper, text_input_esm_objectSpread2(text_input_esm_objectSpread2({}, otherProps), {}, {
      ref: parentRef !== null && parentRef !== void 0 ? parentRef : refInput,
      type: supportedTypes.includes("".concat(type)) ? "".concat(type) : 'text',
      isError: isError,
      isInverse: isInverse,
      fontSize: size,
      size: inputSize,
      readOnly: isReadOnly || otherProps.readOnly // in order to keep a backward compatibility, and giving preferences to provided InputProps, otherwise fall to HTML defaults.
      ,
      disabled: disabledVal,
      required: isRequired || otherProps.required
    })), after && /*#__PURE__*/(0,jsx_runtime.jsx)(AfterWrapper, {
      isDisabled: isDisabled,
      children: after
    })]
  });
});
Input.displayName = 'TextInput';



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/ChatInput/index.style.js
var index_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};







var ChatInputWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: FULLSTORY_EXCLUDE_CLASS,
})(index_style_templateObject_1 || (index_style_templateObject_1 = index_style_makeTemplateObject(["\n  display: block;\n  ", "\n  ", "\n    ", "\n    ", "\n"], ["\n  display: block;\n  ", "\n  ", "\n    ", "\n    ", "\n"])), (0,spacing_esm.py)('xs'), (0,spacing_esm.pl)('xs'), (0,spacing_esm.mt)('xxxs'), (0,color_esm.bg)('shade.50'));
var IconsWrapper = styled_components_browser_esm/* default.div */.ZP.div(index_style_templateObject_2 || (index_style_templateObject_2 = index_style_makeTemplateObject(["\n  display: inline-block;\n  width: 14%;\n  float: right;\n"], ["\n  display: inline-block;\n  width: 14%;\n  float: right;\n"])));
var StyledTextArea = (0,styled_components_browser_esm/* default */.ZP)(TextArea)(index_style_templateObject_3 || (index_style_templateObject_3 = index_style_makeTemplateObject(["\n  width: 85%;\n"], ["\n  width: 85%;\n"])));
var ChatInputWrapperV2 = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: FULLSTORY_EXCLUDE_CLASS,
})(index_style_templateObject_4 || (index_style_templateObject_4 = index_style_makeTemplateObject(["\n  padding: 12px 0px 12px 12px;\n  background-color: ", ";\n  display: flex;\n"], ["\n  padding: 12px 0px 12px 12px;\n  background-color: ", ";\n  display: flex;\n"])), (0,color_esm/* color */.$)('shade.50'));
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Input)(templateObject_5 || (templateObject_5 = index_style_makeTemplateObject([""], [""])));
var index_style_IconWrapper = styled_components_browser_esm/* default.button */.ZP.button(templateObject_6 || (templateObject_6 = index_style_makeTemplateObject(["\n  margin: 0 16px;\n  border: none;\n  cursor: pointer;\n  color: ", ";\n  background-color: transparent;\n  padding: 0px;\n"], ["\n  margin: 0 16px;\n  border: none;\n  cursor: pointer;\n  color: ", ";\n  background-color: transparent;\n  padding: 0px;\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? (0,color_esm/* color */.$)('shade.200') : (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'main'));
});
var index_style_templateObject_1, index_style_templateObject_2, index_style_templateObject_3, index_style_templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/KeyboardArrowUp/dist/icon.esm.js






function SvgKeyboardArrowUp(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/KeyboardArrowDown/dist/icon.esm.js






function SvgKeyboardArrowDown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0-.75h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Send/dist/icon.esm.js






function SvgSend(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/ChatInput/index.js








var ChatInput = function (_a) {
    var value = _a.value, disabledSend = _a.disabledSend, onChange = _a.onChange, _b = _a.send, send = _b === void 0 ? function () { } : _b, onKeyDown = _a.onKeyDown, _c = _a.disabledTextArea, disabledTextArea = _c === void 0 ? false : _c, userType = _a.userType;
    var chatBubble = (0,lib.useFlags)().chatBubble;
    var _d = react.useState(false), expandTextArea = _d[0], setExpandTextArea = _d[1];
    return chatBubble && userType === 'customer' ? (react.createElement(ChatInputWrapperV2, null,
        react.createElement(StyledText, { disabled: disabledTextArea, value: value, "data-testid": "auto-expand-message-input-textarea", isFullWidth: true, size: "sm", onChange: onChange, onKeyDown: onKeyDown, placeholder: "Write a message\u2026" }),
        react.createElement(index_style_IconWrapper, { onClick: send, disabled: disabledSend },
            react.createElement(SvgSend, { width: "24px", height: "24px", "data-testid": "message-send-button", "aria-label": "Send message" })))) : (react.createElement(ChatInputWrapper, null,
        expandTextArea ? (react.createElement(react.Fragment, null,
            react.createElement(StyledTextArea, { isDisabled: disabledTextArea, value: value, "data-testid": "maxRows-message-input-textarea", rows: 10, cols: 50, onChange: onChange, onKeyDown: onKeyDown, size: "xs", placeholder: "Write a message\u2026" }))) : (react.createElement(StyledTextArea, { disabled: disabledTextArea, value: value, "data-testid": "auto-expand-message-input-textarea", rows: 4, cols: 50, maxRows: 10, onChange: onChange, onKeyDown: onKeyDown, size: "xs", placeholder: "Write a message\u2026" })),
        react.createElement(IconsWrapper, null,
            react.createElement(button_esm/* IconButton */.hU, { onClick: function () { return setExpandTextArea(!expandTextArea); }, color: "shade.500", "data-testid": "textarea-expand-button", size: "sm", icon: expandTextArea ? SvgKeyboardArrowDown : SvgKeyboardArrowUp }),
            react.createElement(button_esm/* IconButton */.hU, { onClick: send, color: disabledSend ? 'shade.200' : (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'), isDisabled: disabledSend, size: "md", "aria-label": "Send message", icon: SvgSend, "data-testid": "message-send-button" }))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/ui/dist/index-03130070.esm.js
function index_03130070_esm_toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function index_03130070_esm_toPropertyKey(arg) {
  var key = index_03130070_esm_toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function index_03130070_esm_defineProperty(obj, key, value) {
  key = index_03130070_esm_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function index_03130070_esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function index_03130070_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? index_03130070_esm_ownKeys(Object(source), !0).forEach(function (key) {
      index_03130070_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : index_03130070_esm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

// Spacing in LUI now is all based in px values, we could redefine these in LUI now (in a more sensible reusable place)
// Needs to be compatable with Figma so can we even use rems here
/**
 * @property {string}  xxxs = 4px
 * @property {string}  xxs = 8px
 * @property {string}  xs = 12px
 * @property {string}  sm = 16px
 * @property {string}  md = 24px
 * @property {string}  lg = 32px
 * @property {string}  xl = 40px
 * @property {string}  xxl = 64px
 * @property {string}  xxxl = 80px
 */
var Spacing = {
  xxxs: '0.25rem',
  xxs: '0.5rem',
  xs: '0.75rem',
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
  xl: '2.5rem',
  xxl: '4rem',
  xxxl: '5rem'
};
var Breakpoint = {
  xs: '35.9375rem',
  sm: '36rem',
  md: '48rem',
  lg: '62rem',
  xl: '75rem'
};
var BreakpointMedia = {
  xs: "@media (max-width: ".concat(Breakpoint.xs, ")"),
  sm: "@media (min-width: ".concat(Breakpoint.sm, ")"),
  md: "@media (min-width: ".concat(Breakpoint.md, ")"),
  lg: "@media (min-width: ".concat(Breakpoint.lg, ")"),
  xl: "@media (min-width: ".concat(Breakpoint.xl, ")")
};
var Gutters = {
  md: Spacing.md,
  sm: Spacing.sm
};
var LineHeight = {
  nospace: 1,
  heading: 1.2,
  body: 1.5
};
var baseFontSize = 16;

// Font size is kept in pixels but converted to rem when used
var fontSize = {
  '1': 12,
  '2': 14,
  '3': 16,
  '4': 18,
  '5': 20,
  '6': 24,
  '7': 28,
  '8': 32,
  '9': 40,
  '10': 48
};



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/ui/dist/index-83c6f867.esm.js





var colorPrefixes = ['primary', 'secondary', 'tertiary', 'shade', 'info', 'warn', 'error', 'success']; // All available prefix

var capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Custom setThemeName function
 *
 * At runtime, it sets the correct theme to the `document`
 *
 * It replys on `document` `data-attributes` as primary mechanism,
 * ans `sessionStoryage` as a backup mechanism.
 *
 * It works in conjunction with Custom getThemeName from `@lendi-ui/commons`
 *
 * @deprecated Deprecated since 0.2.3. Use SC's Theme instead.
 */
var index_83c6f867_esm_setThemeName = themeName => {
  // Check browser for runtime
  if (isBrowser) {
    var _window;
    // Get `theme` from DOM `data-attributes` if it's already available.
    var dataTheme = (_window = window) === null || _window === void 0 ? void 0 : _window.document.documentElement.getAttribute(themeAttribute);

    // Check `domTheme` against provided runtime `themeName`
    if (dataTheme !== themeName) {
      var _window2;
      // If different, set runtime `themeName` to data-attributes
      (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.document.documentElement.setAttribute(themeAttribute, themeName);

      // If different, set runtime `themeName` to sessionStorage
      try {
        var themeValue = JSON.stringify({
          label: capitalizeFirstLetter(themeName),
          value: themeName
        });
        window.sessionStorage.setItem('theme', themeValue);
      } catch (error) {
        // TODO: Report Error
      }
    }
  }
};
var mapToColorsLegacyFormat = colorToken => {
  var colors = {};
  var categories = Object.keys(colorToken);
  var shouldInclude = category => colorPrefixes.includes(category);
  categories.filter(shouldInclude).map(category => {
    var transparencies = Object.keys(colorToken[category]);
    transparencies.map(transparency => {
      colors = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, colors), {}, {
        ["".concat(category, ".").concat(transparency)]: colorToken[category][transparency]
      });
    });
  });
  return colors;
};

var tokens$3 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'Cabin', sans-serif",
				metrics: {
					familyName: "Cabin",
					capHeight: 1400,
					ascent: 1930,
					descent: -500,
					lineGap: 0,
					unitsPerEm: 2000
				}
			},
			body: {
				weight: 400,
				family: "'Open Sans', sans-serif",
				metrics: {
					familyName: "Open Sans",
					capHeight: 1462,
					ascent: 2189,
					descent: -600,
					lineGap: 0,
					unitsPerEm: 2048
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		primary: {
			"25": "#f2fbfa",
			"50": "#e5f8f6",
			"100": "#ccf2ed",
			"200": "#99e5db",
			"300": "#66d9c9",
			"400": "#32ccb7",
			"500": "#00c0a5",
			"600": "#329984",
			"700": "#007363",
			"800": "#004c42",
			"900": "#002621",
			"950": "#001310"
		},
		secondary: {
			"25": "#f2f6f7",
			"50": "#e6eef0",
			"100": "#cedee1",
			"200": "#9ebdc4",
			"300": "#6d9ca7",
			"400": "#3d7a8a",
			"500": "#0d5a6d",
			"600": "#0a4857",
			"700": "#073641",
			"800": "#05242b",
			"900": "#021215",
			"950": "#01080a"
		},
		tertiary: {
			"25": "#fff7f7",
			"50": "#fff0ef",
			"100": "#ffe2df",
			"200": "#ffc5c0",
			"300": "#ffa9a1",
			"400": "#ff8c82",
			"500": "#ff7063",
			"600": "#cc594f",
			"700": "#99433b",
			"800": "#662c27",
			"900": "#331613",
			"950": "#190b09"
		},
		shade: {
			"0": "#ffffff",
			"25": "#f8f8f8",
			"50": "#f1f1f1",
			"100": "#e3e3e3",
			"200": "#c8c8c8",
			"300": "#adadad",
			"400": "#929292",
			"500": "#777777",
			"600": "#5f5f5f",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#171717",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#474747",
			subtle: "#5f5f5f",
			inverse: "#ffffff",
			contrast: "#0d5a6d"
		},
		interaction: {
			main: "#00c0a5",
			subtle: "#ffffff",
			contrast: "#00c0a5",
			emphasis: "#ff7063",
			disabled: "#474747",
			success: "#2cac41",
			error: "#ff282f"
		},
		fill: {
			main: "#ffffff",
			selected: "#e5f8f6",
			disabled: "#f8f8f8",
			accent: "#00c0a5",
			contrast: "#0d5a6d"
		},
		background: {
			page: "#f8f8f8",
			container: "#ffffff",
			surface: "#e3e3e3",
			emphasis: "#f1f1f1"
		},
		border: {
			container: "#e3e3e3",
			divider: "#adadad",
			dividerEmphasis: "#2f2f2f",
			interaction: {
				"default": "#c8c8c8",
				hover: "#0d5a6d",
				selected: "#00c0a5",
				focus: "#3f86f7"
			}
		},
		buttonFill: {
			primary: {
				"default": "#00c0a5",
				hover: "#32ccb7",
				focus: "#329984",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			primaryInverse: {
				"default": "#ff7063",
				hover: "#ffffff",
				focus: "#ff7063",
				disabled: "#f8f8f8",
				pressed: "#ff7063"
			},
			secondary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#e5f8f6"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#ffffff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#e5f8f6"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#ff7063",
				focused: "#ffffff",
				disabled: "#474747",
				pressed: "#ffffff"
			},
			secondary: {
				"default": "#00c0a5",
				hover: "#00c0a5",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focused: "#ffffff",
				disabled: "#ffffff",
				pressed: "#329984"
			},
			text: {
				"default": "#00c0a5",
				hover: "#00c0a5",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			primaryInverse: {
				pressed: "#ff7063",
				"default": "#ff7063",
				hover: "#ffffff",
				focus: "#ff7063",
				disabled: "#474747"
			},
			secondary: {
				"default": "#00c0a5",
				hover: "#32ccb7",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#329984"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$3 = 'lendi';

/**
 * @deprecated Use tokens instead
 */
var typography$2 = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens$3.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens$3.asset.font.body.family
  }
};

/**
 * @deprecated Use `theme.name` instead
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * const themeName = theme.name;
 */
var logo$1 = {
  logoName: 'LendiLogo'
};
var borderRadius$1 = '6px';

/**
 * @deprecated Use `theme.color.xxx.yyy` instead. Will be removed in future major release.
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * theme.color.interaction.main;
 */
// @ts-expect-error
var colors$1 = mapToColorsLegacyFormat(tokens$3.color);
var index_83c6f867_esm_theme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
  typography: typography$2,
  colors: colors$1,
  logo: logo$1,
  borderRadius: borderRadius$1
}, tokens$3), {}, {
  name: themeName$3
});

var tokens$2 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'F37 Bolton', Helvetica, Arial, sans-serif",
				metrics: {
					fontFamily: "F37 Bolton",
					capHeight: 717,
					ascent: 714,
					descent: -286,
					lineGap: 250,
					unitsPerEm: 1000
				}
			},
			body: {
				weight: 400,
				family: "'F37 Bolton', Helvetica, Arial, sans-serif",
				metrics: {
					fontFamily: "F37 Bolton",
					capHeight: 717,
					ascent: 714,
					descent: -286,
					lineGap: 250,
					unitsPerEm: 1000
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		primary: {
			"25": "#e4ffe2",
			"50": "#caffc5",
			"100": "#abfca4",
			"200": "#85f27c",
			"300": "#56d94a",
			"400": "#2ec121",
			"500": "#0ea800",
			"600": "#16860b",
			"700": "#186511",
			"800": "#154311",
			"900": "#0d220b",
			"950": "#0d220b"
		},
		secondary: {
			"25": "#f4f8fe",
			"50": "#eaf1fd",
			"100": "#dae5f9",
			"200": "#c1d2ee",
			"300": "#98aed4",
			"400": "#748eba",
			"500": "#5470a1",
			"600": "#3a5687",
			"700": "#25406e",
			"800": "#142c54",
			"900": "#0e182a",
			"950": "#0e182a"
		},
		tertiary: {
			"25": "#f8f7ff",
			"50": "#f1efff",
			"100": "#e4e1ff",
			"200": "#cdc8ff",
			"300": "#a89ffb",
			"400": "#857ae9",
			"500": "#6458d7",
			"600": "#483bc5",
			"700": "#3b3194",
			"800": "#292363",
			"900": "#161331",
			"950": "#161331"
		},
		lime: {
			"25": "#e4ffe2",
			"50": "#caffc5",
			"100": "#abfca4",
			"200": "#85f27c",
			"300": "#56d94a",
			"400": "#2ec121",
			"500": "#0ea800",
			"600": "#16860b",
			"700": "#186511",
			"800": "#154311",
			"900": "#0d220b"
		},
		navy: {
			"25": "#f4f8fe",
			"50": "#eaf1fd",
			"100": "#dae5f9",
			"200": "#c1d2ee",
			"300": "#98aed4",
			"400": "#748eba",
			"500": "#5470a1",
			"600": "#3a5687",
			"700": "#25406e",
			"800": "#142c54",
			"900": "#0e182a"
		},
		ocean: {
			"25": "#f8f7ff",
			"50": "#f1efff",
			"100": "#e4e1ff",
			"200": "#cdc8ff",
			"300": "#a89ffb",
			"400": "#857ae9",
			"500": "#6458d7",
			"600": "#483bc5",
			"700": "#3b3194",
			"800": "#292363",
			"900": "#161331"
		},
		vermillion: {
			"25": "#fff5f3",
			"50": "#ffe9e5",
			"100": "#ffd8d1",
			"200": "#ffbeb2",
			"300": "#ff9684",
			"400": "#f8715a",
			"500": "#e84f34",
			"600": "#d93013",
			"700": "#a3301c",
			"800": "#6d281c",
			"900": "#361712"
		},
		grey: {
			"25": "#fbfbfc",
			"50": "#f8f8f9",
			"100": "#eff0f3",
			"200": "#dbdee5",
			"300": "#b5bcca",
			"400": "#929cae",
			"500": "#727d92",
			"600": "#556177",
			"700": "#3c475b",
			"800": "#232c3d",
			"900": "#0f141e"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fbfbfc",
			"50": "#f8f8f9",
			"100": "#eff0f3",
			"200": "#dbdee5",
			"300": "#b5bcca",
			"400": "#929cae",
			"500": "#727d92",
			"600": "#556177",
			"700": "#3c475b",
			"800": "#232c3d",
			"900": "#0f141e",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#0f141e",
			subtle: "#3c475b",
			contrast: "#142c54",
			inverse: "#ffffff",
			"default": "#0f141e"
		},
		interaction: {
			main: "#0ea800",
			subtle: "#ffffff",
			contrast: "#0ea800",
			emphasis: "#d93013",
			disabled: "#929cae",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#142c54",
			accent: "#0ea800",
			selected: "#eaf1fd",
			disabled: "#f8f8f9"
		},
		background: {
			page: "#fbfbfc",
			container: "#ffffff",
			surface: "#eff0f3",
			emphasis: "#f8f8f9"
		},
		border: {
			container: "#dbdee5",
			divider: "#eff0f3",
			dividerEmphasis: "#0f141e",
			interaction: {
				"default": "#727d92",
				hover: "#3c475b",
				focus: "#5e72ff",
				selected: "#142c54"
			}
		},
		buttonFill: {
			primary: {
				"default": "#0ea800",
				hover: "#2ec121",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#16860b"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e4ffe2",
				focus: "#ffffff",
				disabled: "#f8f8f9",
				pressed: "#caffc5"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondary: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focused: "#ffffff",
				disabled: "#929cae",
				pressed: "#ffffff"
			},
			text: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focused: "#ffffff",
				disabled: "#929cae",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#0ea800",
				hover: "#2ec121",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#16860b"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e4ffe2",
				focus: "#ffffff",
				disabled: "#f8f8f9",
				pressed: "#caffc5"
			},
			secondary: {
				"default": "#0ea800",
				hover: "#0ea800",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondaryInverse: {
				"default": "#ffffff",
				focus: "#ffffff",
				hover: "#ffffff",
				pressed: "#ffffff",
				disabled: "#929cae"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$2 = 'domain';

/**
 * @deprecated Use tokens instead
 */
var typography$1 = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens$2.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens$2.asset.font.body.family
  }
};

/**
 * @deprecated Use `theme.name` instead
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * const themeName = theme.name;
 */
var logo = {
  logoName: 'DomainLogo'
};
var borderRadius = '3px';

/**
 * @deprecated Use `theme.color.xxx.yyy` instead. Will be removed in future major release.
 * @example
 * const theme = useTheme();
 * theme.color.interaction.main;
 */
// @ts-expect-error
var colors = mapToColorsLegacyFormat(tokens$2.color);

/**
 * @since 9.2.3
 */

var index_83c6f867_esm_domainTheme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
  typography: typography$1,
  colors,
  logo,
  borderRadius
}, tokens$2), {}, {
  name: themeName$2
});

var tokens$1 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'Cabin', sans-serif",
				metrics: {
					familyName: "Cabin",
					capHeight: 1400,
					ascent: 1930,
					descent: -500,
					lineGap: 0,
					unitsPerEm: 2000
				}
			},
			body: {
				weight: 400,
				family: "'Open Sans', sans-serif",
				metrics: {
					familyName: "Open Sans",
					capHeight: 1462,
					ascent: 2189,
					descent: -600,
					lineGap: 0,
					unitsPerEm: 2048
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		tiber: {
			"25": "#f0fafc",
			"50": "#e0f5fa",
			"100": "#cdedf4",
			"200": "#b0dce6",
			"300": "#85becb",
			"400": "#61a1b0",
			"500": "#428594",
			"600": "#296a79",
			"700": "#15505d",
			"800": "#083742",
			"900": "#091d21"
		},
		turquoise: {
			"25": "#dbfffa",
			"50": "#b7fff5",
			"100": "#8efced",
			"200": "#60f1dd",
			"300": "#2bd9c2",
			"400": "#00c0a5",
			"500": "#0ba08b",
			"600": "#128071",
			"700": "#146056",
			"800": "#12403a",
			"900": "#0b201d"
		},
		lagoon: {
			"25": "#e7faff",
			"50": "#cff5ff",
			"100": "#b3ebfb",
			"200": "#8fdbf0",
			"300": "#60bdd7",
			"400": "#39a1be",
			"500": "#1987a5",
			"600": "#006e8c",
			"700": "#0b5569",
			"800": "#0f3a46",
			"900": "#0b1e23"
		},
		coral: {
			"25": "#fff6f5",
			"50": "#ffebe9",
			"100": "#ffdad7",
			"200": "#ffc0ba",
			"300": "#ff978d",
			"400": "#ff7063",
			"500": "#d45e54",
			"600": "#aa4c44",
			"700": "#803a34",
			"800": "#552723",
			"900": "#2b1412"
		},
		grey: {
			"25": "#fafafa",
			"50": "#f5f5f5",
			"100": "#ececec",
			"200": "#dcdcdc",
			"300": "#bfbfbf",
			"400": "#a1a1a1",
			"500": "#838383",
			"600": "#656565",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#181818"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fafafa",
			"50": "#f5f5f5",
			"100": "#ececec",
			"200": "#dcdcdc",
			"300": "#bfbfbf",
			"400": "#a1a1a1",
			"500": "#838383",
			"600": "#656565",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#181818",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#181818",
			subtle: "#474747",
			contrast: "#083742",
			inverse: "#ffffff"
		},
		interaction: {
			main: "#006e8c",
			subtle: "#ffffff",
			contrast: "#0ba08b",
			emphasis: "#ff7063",
			disabled: "#a1a1a1",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#006e8c",
			accent: "#00c0a5",
			selected: "#cff5ff",
			disabled: "#f5f5f5"
		},
		background: {
			page: "#fafafa",
			container: "#ffffff",
			surface: "#ececec",
			emphasis: "#f5f5f5"
		},
		border: {
			container: "#dcdcdc",
			divider: "#ececec",
			dividerEmphasis: "#181818",
			interaction: {
				"default": "#838383",
				hover: "#474747",
				focus: "#5e72ff",
				selected: "#006e8c"
			}
		},
		buttonFill: {
			primary: {
				"default": "#006e8c",
				hover: "#0b5569",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#0f3a46"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e7faff",
				focus: "#ffffff",
				disabled: "#f5f5f5",
				pressed: "#cff5ff"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondary: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#a1a1a1",
				pressed: "#ffffff"
			},
			text: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#a1a1a1",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#006e8c",
				hover: "#0b5569",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#0f3a46"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e7faff",
				focus: "#ffffff",
				disabled: "#f5f5f5",
				pressed: "#cff5ff"
			},
			secondary: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondaryInverse: {
				"default": "#ffffff",
				focus: "#ffffff",
				hover: "#ffffff",
				pressed: "#ffffff",
				disabled: "#a1a1a1"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$1 = 'lendi-next';
var index_83c6f867_esm_lendiNextTheme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, index_83c6f867_esm_theme), tokens$1), {}, {
  name: themeName$1
});

var tokens = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'TT Commons Pro', sans-serif",
				metrics: {
					familyName: "TT Commons Pro",
					capHeight: 700,
					ascent: 1000,
					descent: -200,
					lineGap: 0,
					unitsPerEm: 1000
				}
			},
			body: {
				weight: 400,
				family: "'Barlow', sans-serif",
				metrics: {
					familyName: "Barlow",
					capHeight: 700,
					ascent: 1000,
					descent: -200,
					lineGap: 0,
					unitsPerEm: 1000
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		purple: {
			"25": "#faf3fe",
			"50": "#f3e6fc",
			"100": "#e9d5f7",
			"200": "#d8bbeb",
			"300": "#b791d1",
			"400": "#996db7",
			"500": "#7d4e9c",
			"600": "#633482",
			"700": "#4b1f68",
			"800": "#331745",
			"900": "#1a0d23"
		},
		yellow: {
			"25": "#fffbe9",
			"50": "#fff6d1",
			"100": "#ffefb1",
			"200": "#ffe788",
			"300": "#ffdc51",
			"400": "#ffd11f",
			"500": "#d4b024",
			"600": "#aa8f26",
			"700": "#806d23",
			"800": "#55491b",
			"900": "#2b2610"
		},
		teal: {
			"25": "#ecfffb",
			"50": "#d8fff7",
			"100": "#bffff1",
			"200": "#9dffea",
			"300": "#6eedd1",
			"400": "#45d9ba",
			"500": "#3db59b",
			"600": "#33917d",
			"700": "#286d5e",
			"800": "#1c483e",
			"900": "#0f241f"
		},
		peach: {
			"25": "#fff8f5",
			"50": "#fff0ea",
			"100": "#ffe4d9",
			"200": "#ffd0bc",
			"300": "#ffb18f",
			"400": "#ff9366",
			"500": "#d47b56",
			"600": "#aa6345",
			"700": "#804b34",
			"800": "#553223",
			"900": "#2b1a12"
		},
		grey: {
			"25": "#fcfcf9",
			"50": "#f8f8f6",
			"100": "#f2f2f0",
			"200": "#e4e4e2",
			"300": "#c7c7c5",
			"400": "#ababa9",
			"500": "#8f8f8e",
			"600": "#737372",
			"700": "#575756",
			"800": "#3a3a39",
			"900": "#1d1d1d"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fcfcf9",
			"50": "#f8f8f6",
			"100": "#f2f2f0",
			"200": "#e4e4e2",
			"300": "#c7c7c5",
			"400": "#ababa9",
			"500": "#8f8f8e",
			"600": "#737372",
			"700": "#575756",
			"800": "#3a3a39",
			"900": "#1d1d1d",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#1d1d1d",
			subtle: "#575756",
			contrast: "#4b1f68",
			inverse: "#ffffff",
			"default": "#1d1d1d"
		},
		interaction: {
			main: "#4b1f68",
			subtle: "#ffffff",
			contrast: "#4b1f68",
			emphasis: "#ffd11f",
			disabled: "#ababa9",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#4b1f68",
			accent: "#4b1f68",
			selected: "#f3e6fc",
			disabled: "#f8f8f6"
		},
		background: {
			page: "#fcfcf9",
			container: "#ffffff",
			surface: "#f2f2f0",
			emphasis: "#f8f8f6"
		},
		border: {
			container: "#e4e4e2",
			divider: "#f2f2f0",
			dividerEmphasis: "#1d1d1d",
			interaction: {
				"default": "#8f8f8e",
				hover: "#575756",
				focus: "#5e72ff",
				selected: "#4b1f68"
			}
		},
		buttonFill: {
			primary: {
				"default": "#4b1f68",
				hover: "#633482",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#331745"
			},
			primaryInverse: {
				"default": "#ffd11f",
				hover: "#ffdc51",
				focus: "#ffd11f",
				disabled: "#f8f8f6",
				pressed: "#d4b024"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondary: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondaryInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focused: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			},
			text: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			textInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focused: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#4b1f68",
				hover: "#633482",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#331745"
			},
			primaryInverse: {
				"default": "#ffd11f",
				hover: "#ffdc51",
				focus: "#ffd11f",
				disabled: "#f8f8f6",
				pressed: "#d4b024"
			},
			secondary: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondaryInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focus: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName = 'aussie';

/**
 * @deprecated Use tokens instead
 */
var typography = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens.asset.font.body.family
  }
};
var index_83c6f867_esm_aussieTheme = index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({}, index_83c6f867_esm_theme), {}, {
  typography
}, tokens), {}, {
  name: themeName
});

// Any cross browser resets should occur here
var index_83c6f867_esm_GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(["html{box-sizing:border-box;font-size:100%;}*,*:before,*:after{box-sizing:inherit;}html,body{margin:0;padding:0;}body{color:", ";font-family:", ";}h1,h2,h3,h4,h5,h6{font-family:", ";font-weight:", ";}input::-ms-clear{display:none;}:root{--lendi-ui-size:14px;}@media (min-width:", "){:root{--lendi-ui-size:16px;}}.sr-only{border:0 !important;clip:rect(1px,1px,1px,1px) !important;clip-path:inset(50%) !important;height:1px !important;overflow:hidden !important;padding:0 !important;position:absolute !important;width:1px !important;white-space:nowrap !important;}.sr-only-focusable:focus,.sr-only-focusable:active{clip:auto !important;clip-path:none !important;height:auto !important;overflow:visible !important;width:auto !important;white-space:normal !important;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.asset.font.body.family;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.asset.font.heading.family;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.asset.font.heading.weight;
}, Breakpoint.sm);

/**
 * useTheme is a custom hook to return theme object.
 *
 * It is natively available in Style Component v5. However since Lendi's using v4, this custom hook is necessary.
 */
var useTheme = () => {
  return useContext(ThemeContext);
};



;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(72975);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../../node_modules/next/node_modules/react-dom/index.js
var react_dom = __webpack_require__(88872);
// EXTERNAL MODULE: ../../../node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js + 8 modules
var dom_esm = __webpack_require__(82390);
// EXTERNAL MODULE: ../../../node_modules/react-dom/test-utils.js
var test_utils = __webpack_require__(30740);
;// CONCATENATED MODULE: ../../../node_modules/@testing-library/react/dist/@testing-library/react.esm.js
/* provided dependency */ var react_esm_process = __webpack_require__(13158);









var reactAct = test_utils.act;
var actSupported = reactAct !== undefined; // act is supported react-dom@16.8.0
// so for versions that don't have act from test utils
// we do this little polyfill. No warnings, but it's
// better than nothing.

function actPolyfill(cb) {
  react_dom.unstable_batchedUpdates(cb);
  react_dom.render( /*#__PURE__*/react.createElement("div", null), document.createElement('div'));
}

var act = reactAct || actPolyfill;
var youHaveBeenWarned = false;
var isAsyncActSupported = null;

function asyncAct(cb) {
  if (actSupported === true) {
    if (isAsyncActSupported === null) {
      return new Promise(function (resolve, reject) {
        // patch console.error here
        var originalConsoleError = console.error;

        console.error = function error() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          /* if console.error fired *with that specific message* */

          /* istanbul ignore next */
          var firstArgIsString = typeof args[0] === 'string';

          if (firstArgIsString && args[0].indexOf('Warning: Do not await the result of calling ReactTestUtils.act') === 0) {
            // v16.8.6
            isAsyncActSupported = false;
          } else if (firstArgIsString && args[0].indexOf('Warning: The callback passed to ReactTestUtils.act(...) function must not return anything') === 0) ; else {
            originalConsoleError.apply(console, args);
          }
        };

        var cbReturn, result;

        try {
          result = reactAct(function () {
            cbReturn = cb();
            return cbReturn;
          });
        } catch (err) {
          console.error = originalConsoleError;
          reject(err);
          return;
        }

        result.then(function () {
          console.error = originalConsoleError; // if it got here, it means async act is supported

          isAsyncActSupported = true;
          resolve();
        }, function (err) {
          console.error = originalConsoleError;
          isAsyncActSupported = true;
          reject(err);
        }); // 16.8.6's act().then() doesn't call a resolve handler, so we need to manually flush here, sigh

        if (isAsyncActSupported === false) {
          console.error = originalConsoleError;
          /* istanbul ignore next */

          if (!youHaveBeenWarned) {
            // if act is supported and async act isn't and they're trying to use async
            // act, then they need to upgrade from 16.8 to 16.9.
            // This is a seamless upgrade, so we'll add a warning
            console.error("It looks like you're using a version of react-dom that supports the \"act\" function, but not an awaitable version of \"act\" which you will need. Please upgrade to at least react-dom@16.9.0 to remove this warning.");
            youHaveBeenWarned = true;
          }

          cbReturn.then(function () {
            // a faux-version.
            // todo - copy https://github.com/facebook/react/blob/master/packages/shared/enqueueTask.js
            Promise.resolve().then(function () {
              // use sync act to flush effects
              act(function () {});
              resolve();
            });
          }, reject);
        }
      });
    } else if (isAsyncActSupported === false) {
      // use the polyfill directly
      var _result;

      act(function () {
        _result = cb();
      });
      return _result.then(function () {
        return Promise.resolve().then(function () {
          // use sync act to flush effects
          act(function () {});
        });
      });
    } // all good! regular act


    return act(cb);
  } // use the polyfill


  var result;
  act(function () {
    result = cb();
  });
  return result.then(function () {
    return Promise.resolve().then(function () {
      // use sync act to flush effects
      act(function () {});
    });
  });
}
/* eslint no-console:0 */

// dom-testing-library's version of fireEvent. The reason
// we make this distinction however is because we have
// a few extra events that work a bit differently

var fireEvent = function fireEvent() {
  return dom_esm/* fireEvent.apply */.BX.apply(void 0, arguments);
};

Object.keys(dom_esm/* fireEvent */.BX).forEach(function (key) {
  fireEvent[key] = function () {
    return dom_esm/* fireEvent */.BX[key].apply(dom_esm/* fireEvent */.BX, arguments);
  };
}); // React event system tracks native mouseOver/mouseOut events for
// running onMouseEnter/onMouseLeave handlers
// @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/EnterLeaveEventPlugin.js#L24-L31

var mouseEnter = fireEvent.mouseEnter;
var mouseLeave = fireEvent.mouseLeave;

fireEvent.mouseEnter = function () {
  mouseEnter.apply(void 0, arguments);
  return fireEvent.mouseOver.apply(fireEvent, arguments);
};

fireEvent.mouseLeave = function () {
  mouseLeave.apply(void 0, arguments);
  return fireEvent.mouseOut.apply(fireEvent, arguments);
};

var pointerEnter = fireEvent.pointerEnter;
var pointerLeave = fireEvent.pointerLeave;

fireEvent.pointerEnter = function () {
  pointerEnter.apply(void 0, arguments);
  return fireEvent.pointerOver.apply(fireEvent, arguments);
};

fireEvent.pointerLeave = function () {
  pointerLeave.apply(void 0, arguments);
  return fireEvent.pointerOut.apply(fireEvent, arguments);
};

var react_esm_select = fireEvent.select;

fireEvent.select = function (node, init) {
  react_esm_select(node, init); // React tracks this event only on focused inputs

  node.focus(); // React creates this event when one of the following native events happens
  // - contextMenu
  // - mouseUp
  // - dragEnd
  // - keyUp
  // - keyDown
  // so we can use any here
  // @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/SelectEventPlugin.js#L203-L224

  fireEvent.keyUp(node, init);
}; // React event system tracks native focusout/focusin events for
// running blur/focus handlers
// @link https://github.com/facebook/react/pull/19186


var react_esm_blur = fireEvent.blur;
var react_esm_focus = fireEvent.focus;

fireEvent.blur = function () {
  fireEvent.focusOut.apply(fireEvent, arguments);
  return react_esm_blur.apply(void 0, arguments);
};

fireEvent.focus = function () {
  fireEvent.focusIn.apply(fireEvent, arguments);
  return react_esm_focus.apply(void 0, arguments);
};

(0,dom_esm/* configure */.jQ)({
  asyncWrapper: function () {
    var _asyncWrapper = _asyncToGenerator( /*#__PURE__*/regenerator_default().mark(function _callee2(cb) {
      var result;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return asyncAct( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator_default().mark(function _callee() {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return cb();

                      case 2:
                        result = _context.sent;

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 2:
              return _context2.abrupt("return", result);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function asyncWrapper(_x) {
      return _asyncWrapper.apply(this, arguments);
    }

    return asyncWrapper;
  }(),
  eventWrapper: function eventWrapper(cb) {
    var result;
    act(function () {
      result = cb();
    });
    return result;
  }
});
var mountedContainers = new Set();

function react_esm_render(ui, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      container = _ref2.container,
      _ref2$baseElement = _ref2.baseElement,
      baseElement = _ref2$baseElement === void 0 ? container : _ref2$baseElement,
      queries = _ref2.queries,
      _ref2$hydrate = _ref2.hydrate,
      hydrate = _ref2$hydrate === void 0 ? false : _ref2$hydrate,
      WrapperComponent = _ref2.wrapper;

  if (!baseElement) {
    // default to document.body instead of documentElement to avoid output of potentially-large
    // head elements (such as JSS style blocks) in debug output
    baseElement = document.body;
  }

  if (!container) {
    container = baseElement.appendChild(document.createElement('div'));
  } // we'll add it to the mounted containers regardless of whether it's actually
  // added to document.body so the cleanup method works regardless of whether
  // they're passing us a custom container or not.


  mountedContainers.add(container);

  var wrapUiIfNeeded = function wrapUiIfNeeded(innerElement) {
    return WrapperComponent ? /*#__PURE__*/React.createElement(WrapperComponent, null, innerElement) : innerElement;
  };

  act(function () {
    if (hydrate) {
      ReactDOM.hydrate(wrapUiIfNeeded(ui), container);
    } else {
      ReactDOM.render(wrapUiIfNeeded(ui), container);
    }
  });
  return _extends({
    container: container,
    baseElement: baseElement,
    debug: function debug(el, maxLength, options) {
      if (el === void 0) {
        el = baseElement;
      }

      return Array.isArray(el) ? // eslint-disable-next-line no-console
      el.forEach(function (e) {
        return console.log(prettyDOM(e, maxLength, options));
      }) : // eslint-disable-next-line no-console,
      console.log(prettyDOM(el, maxLength, options));
    },
    unmount: function unmount() {
      act(function () {
        ReactDOM.unmountComponentAtNode(container);
      });
    },
    rerender: function rerender(rerenderUi) {
      react_esm_render(wrapUiIfNeeded(rerenderUi), {
        container: container,
        baseElement: baseElement
      }); // Intentionally do not return anything to avoid unnecessarily complicating the API.
      // folks can use all the same utilities we return in the first place that are bound to the container
    },
    asFragment: function asFragment() {
      /* istanbul ignore else (old jsdom limitation) */
      if (typeof document.createRange === 'function') {
        return document.createRange().createContextualFragment(container.innerHTML);
      } else {
        var template = document.createElement('template');
        template.innerHTML = container.innerHTML;
        return template.content;
      }
    }
  }, getQueriesForElement(baseElement, queries));
}

function cleanup() {
  mountedContainers.forEach(cleanupAtContainer);
} // maybe one day we'll expose this (perhaps even as a utility returned by render).
// but let's wait until someone asks for it.


function cleanupAtContainer(container) {
  act(function () {
    react_dom.unmountComponentAtNode(container);
  });

  if (container.parentNode === document.body) {
    document.body.removeChild(container);
  }

  mountedContainers.delete(container);
} // just re-export everything from dom-testing-library
// thing for people using react-dom@16.8.0. Anyone else doesn't need it and
// people should just upgrade anyway.

/* eslint func-name-matching:0 */

var _process$env;
// or teardown then we'll automatically run cleanup afterEach test
// this ensures that tests run in isolation from each other
// if you don't like this then either import the `pure` module
// or set the RTL_SKIP_AUTO_CLEANUP env variable to 'true'.

if (typeof react_esm_process === 'undefined' || !((_process$env = react_esm_process.env) != null && _process$env.RTL_SKIP_AUTO_CLEANUP)) {
  // ignore teardown() in code coverage because Jest does not support it

  /* istanbul ignore else */
  if (typeof afterEach === 'function') {
    afterEach(function () {
      cleanup();
    });
  } else if (typeof teardown === 'function') {
    // Block is guarded by `typeof` check.
    // eslint does not support `typeof` guards.
    // eslint-disable-next-line no-undef
    teardown(function () {
      cleanup();
    });
  }
}



// EXTERNAL MODULE: ../../../node_modules/react-helmet/es/Helmet.js
var es_Helmet = __webpack_require__(74758);
// EXTERNAL MODULE: ../../../node_modules/react-element-to-jsx-string/dist/cjs/index.js
var cjs = __webpack_require__(44782);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/ui/dist/select-73d530a0.esm.js











var fallback$2 = "\n  body, p  {\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.6px;\n    word-spacing: -0.25px;\n    visibility: visible;\n    font-weight: 300;\n    font-family: verdana;\n    height: auto;\n  }\n\n  h1, h2, .lui-title2, h3, h4, h5, h6 {\n    line-height: 1.4;\n    letter-spacing: 0px;\n    word-spacing: -1px;\n    visibility: visible;\n    font-weight: 700;\n    height: auto;\n    font-family: Arial;\n  }\n\n  h1, .lui-display {\n    font-size: 30px;\n  }\n\n  h2, .lui-title1 {\n    font-size: 22px;\n  }\n";

var fallback$1 = "\n  body,\n  h4,\n  h5,\n  h6,\n  p,\n  .lui-subtitle1,\n  .lui-subtitle2,\n  .lui-body1,\n  .lui-body2 {\n    font-family: Arial;\n    visibility: visible;\n    letter-spacing: -0.4px;\n    font-weight: 400;\n    word-spacing: 0.4px;\n  }\n\n  h1,\n  .lui-display {\n    font-family: Arial;\n    font-size: 48px;\n    line-height: 1.3;\n    visibility: visible;\n    letter-spacing: -0.85px;\n    word-spacing: -1.65px;\n    font-weight: 700;\n  }\n\n  h2,\n  .lui-title1 {\n    font-family: Arial;\n    font-size: 32px;\n    line-height: 1.2;\n    visibility: visible;\n    letter-spacing: -0.75px;\n    word-spacing: 0.2px;\n    font-weight: 700;\n  }\n\n  h3,\n  .lui-title2 {\n    font-family: Arial;\n    font-size: 24px;\n    line-height: 1.3;\n    visibility: visible;\n    letter-spacing: -0.55px;\n    word-spacing: -0.15px;\n    font-weight: 700;\n  }\n";

var fallback = "\n  body,\n  h4,\n  h5,\n  h6,\n  p,\n  .lui-subtitle1,\n  .lui-subtitle2,\n  .lui-body1,\n  .lui-body2 {\n    font-family: Arial;\n    font-size: 16px;\n    line-height: 1.5;\n    font-weight: 300;\n    letter-spacing: -0.15px;\n    word-spacing: 0.65px;\n    visibility: visible;\n  }\n\n  h1,\n  .lui-display {\n    font-family: Arial;\n    font-size: 46px;\n    line-height: 1.5;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    word-spacing: -1.05px;\n    visibility: visible;\n  }\n\n  h2,\n  .lui-title1 {\n    font-family: Arial;\n    font-size: 31px;\n    line-height: 1.5;\n    font-weight: 700;\n    letter-spacing: -0.3px;\n    word-spacing: -0.9px;\n    visibility: visible;\n  }\n\n  .lui-title2 {\n    font-family: Arial;\n    font-size: 22px;\n    line-height: 1.4;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n    word-spacing: 0.2px;\n    visibility: visible;\n  }\n";

// All CDN assets can be found in the /public folder in this repo
var config = {
  lendi: {
    fontFamilies: ['Open Sans', 'Cabin'],
    fallback: fallback$2,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap",
      rel: "stylesheet"
    }, "lendi")]
  },
  'lendi-next': {
    // ^^ duplicate of lendi above ^^, but ts complains if we don't redeclare it here
    fontFamilies: ['Open Sans', 'Cabin'],
    fallback: fallback$2,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap",
      rel: "stylesheet"
    }, "lendi")]
  },
  domain: {
    fontFamilies: ['F37 Bolton'],
    fallback: fallback,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://lendi.style/font-face/domain.css",
      rel: "stylesheet"
    }, "domain")]
  },
  aussie: {
    fontFamilies: ['Barlow', 'TT Commons Pro'],
    fallback: fallback$1,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap",
      rel: "stylesheet"
    }, "aussie-google"), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://lendi.style/font-face/aussie.css",
      rel: "stylesheet"
    }, "aussie")]
  }
};
var FontComponent = _ref => {
  var {
    children,
    disableFallbackFonts = false,
    themeName
  } = _ref;
  var currentThemeConfig = config[themeName];
  var [brandFontLoaded, setBrandFontLoaded] = useState(false);
  useEffect(() => {
    if (!brandFontLoaded && 'fonts' in document) {
      document.fonts.onloadingdone = fontFaceSetEvent => {
        var _fontFaceSetEvent$ret;
        setBrandFontLoaded((_fontFaceSetEvent$ret = fontFaceSetEvent === null || fontFaceSetEvent === void 0 ? void 0 : fontFaceSetEvent.returnValue) !== null && _fontFaceSetEvent$ret !== void 0 ? _fontFaceSetEvent$ret : true);
      };
      return;
    }
    setBrandFontLoaded(true);
  }, [brandFontLoaded]);
  var FontDetector = () => {
    var fontFamilies = currentThemeConfig.fontFamilies;
    if (brandFontLoaded) {
      return null;
    }
    return /*#__PURE__*/jsx(VisuallyHidden, {
      "aria-hidden": "true",
      children: fontFamilies.map((fontFamily, index) => /*#__PURE__*/jsx("span", {
        style: {
          fontFamily
        },
        children: "\xA0"
      }, index))
    });
  };
  var fontLinks = currentThemeConfig.brandFontFace.map(fontFace => reactElementToJSXString(fontFace)).join();
  var useFallbackFonts = !brandFontLoaded && !disableFallbackFonts;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Helmet, {
      children: [/*#__PURE__*/jsx("link", {
        rel: "preconnect",
        href: "https://lendi.style/",
        crossOrigin: "true"
      }), /*#__PURE__*/jsx("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
      }), /*#__PURE__*/jsx("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "true"
      }), currentThemeConfig.brandFontFace.map(fontFace => fontFace), useFallbackFonts && /*#__PURE__*/jsx("style", {
        children: currentThemeConfig === null || currentThemeConfig === void 0 ? void 0 : currentThemeConfig.fallback
      }), /*#__PURE__*/jsx("noscript", {
        children: fontLinks
      })]
    }), children, /*#__PURE__*/jsx(FontDetector, {})]
  });
};
var Font = (/* unused pure expression or super */ null && (FontComponent));

var FaviconComponent = _ref => {
  var _favicons$themeName;
  var {
    themeName
  } = _ref;
  var cdnLink = getCDNLink();
  var favicons = {
    lendi: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon.ico?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: ''
    }, {
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon-32x32.png?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: 'image/png'
    }],
    'lendi-next': [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon.ico?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: ''
    }, {
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon-32x32.png?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: 'image/png'
    }],
    domain: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/domain/favicon.icon"),
      type: ''
    }, {
      rel: 'shortcut icon',
      href: "".concat(cdnLink, "/favicons/domain/favicon.icon"),
      type: ''
    }, {
      rel: 'icon',
      sizes: '16x16',
      href: "".concat(cdnLink, "/favicons/domain/16x16.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '32x32',
      href: "".concat(cdnLink, "/favicons/domain/32x32.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '192x192',
      href: "".concat(cdnLink, "/favicons/domain/192x192.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '512x512',
      href: "".concat(cdnLink, "/favicons/domain/512x512.png"),
      type: 'image/png'
    }, {
      rel: 'apple-touch-icon-precomposed',
      href: "".concat(cdnLink, "/favicons/domain/apple-touch-icon.png"),
      type: ''
    }],
    aussie: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/aussie/favicon.ico"),
      type: ''
    }, {
      rel: 'shortcut icon',
      href: "".concat(cdnLink, "/favicons/aussie/favicon.ico"),
      type: ''
    }]
  };
  return /*#__PURE__*/jsx(Helmet, {
    children: (_favicons$themeName = favicons[themeName]) === null || _favicons$themeName === void 0 ? void 0 : _favicons$themeName.map((props, index) => /*#__PURE__*/jsx("link", _objectSpread2({}, props), index))
  });
};
var Favicon = (/* unused pure expression or super */ null && (FaviconComponent));

var LUIProvider = _ref => {
  var {
    children,
    themeName,
    disableFallbackFonts = false
  } = _ref;
  // Run runtime setThemeName to apply theming data attribute
  setThemeName(themeName);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Favicon, {
      themeName: themeName
    }), /*#__PURE__*/jsx(Font, {
      themeName: themeName,
      disableFallbackFonts: disableFallbackFonts,
      children: children
    })]
  });
};

/**
 * To provide the best transition experience, and avoid breaking changes, we’re going to keep the `name` as optional.
 *
 * Meanwhile, `mapThemeNameToLegacyKind` will ensure to correct mapping.
 *
 * We will make `name` mandatory in the next breaking change.
 *
 * @since 0.2.3
 * @param {string} themeName the new ThemeName
 * @return {ThemeMap | undefined} kind the legacy ThemeMap
 *
 * @todo LUI-785 Remove backwards compatibility in next major.
 * @see https://creditandfinance.atlassian.net/browse/LUI-785
 */
var mapThemeNameToLegacyKind = themeName => {
  switch (themeName) {
    case 'lendi':
      return theme;
    case 'domain':
      return domainTheme;
    case 'lendi-next':
      return lendiNextTheme;
    case 'aussie':
      return aussieTheme;
    default:
      return undefined;
  }
};

/**
 * @param {ThemeProps} props
 * @param {string} props.name `lendi`, `domain`, `aussie`, `lendi-next`
 * @param {ThemeMap} props.kind Deprecated. Use `name` instead.
 * @param {boolean} props.disableFallbackFonts Whether you wish to disable fallback fonts.
 * @param {ReactNode} props.children React children
 *
 * @since 0.2.3
 */
var Theme = _ref => {
  var _mapThemeNameToLegacy, _innerKind$name;
  var {
    kind = theme,
    name,
    disableFallbackFonts = false,
    children
  } = _ref;
  var innerKind = (_mapThemeNameToLegacy = mapThemeNameToLegacyKind(name)) !== null && _mapThemeNameToLegacy !== void 0 ? _mapThemeNameToLegacy : kind;
  /**
   * Determine appropriate themeName based on to backwards compatibility
   *
   * If `kind` is provided, use that first, because that's the backwards supported API.
   * Else, if `name` is provided, use that next, because that's the new API.
   *
   * @todo LUI-785 Remove backwards compatibility in next major.
   */
  var themeName = (_innerKind$name = innerKind === null || innerKind === void 0 ? void 0 : innerKind.name) !== null && _innerKind$name !== void 0 ? _innerKind$name : name;
  if (!themeName) return null;

  // Run runtime setThemeName to apply theming data attribute
  setThemeName(themeName);

  /**
   * As part of ThemeV2 & Navbar constraint (use of `window`), the following `isBrowser` check enforces Client Side Rendering.
   * This is a temporary measure, and will be removed in the future once SSR is fully supported.
   * @see [LUI-854](https://creditandfinance.atlassian.net/browse/LUI-854)
   */
  return /*#__PURE__*/jsxs(ThemeProvider$1, {
    theme: innerKind,
    children: [/*#__PURE__*/jsx(GlobalStyle, {}), /*#__PURE__*/jsx(Favicon, {
      themeName: themeName
    }), /*#__PURE__*/jsx(Font, {
      themeName: themeName,
      disableFallbackFonts: disableFallbackFonts,
      children: isBrowser ? children : ''
    })]
  });
};

var ThemeProvider = _ref => {
  var {
    children,
    name
  } = _ref;
  return /*#__PURE__*/jsx(Theme, {
    name: name,
    children: children
  });
};
var renderWithTheme = (ui, options) => render(ui, _objectSpread2({
  wrapper: props => {
    var _options$name;
    return /*#__PURE__*/jsx(ThemeProvider, _objectSpread2(_objectSpread2({}, props), {}, {
      name: (_options$name = options === null || options === void 0 ? void 0 : options.name) !== null && _options$name !== void 0 ? _options$name : 'lendi'
    }));
  }
}, options));

function select_73d530a0_esm_select(path, defaultValue) {
  return _ref => {
    var {
      theme
    } = _ref;
    if (!theme) {
      throw new Error('@lendi-ui/theme: Theme not found. Please ensure your components are wrapped in the Theme component e.g. <Theme><App/></Theme>');
    }
    var obj = theme;
    var startIndex = -1;
    var finishIndex = -1;
    do {
      // check if there is a key that matches the remainder of the path
      var restOfPath = path.substr(startIndex + 1);
      if (Object.prototype.hasOwnProperty.call(obj, restOfPath)) {
        return obj[restOfPath];
      }

      // check if there is a key that matches the next part of the path
      finishIndex = path.indexOf('.', startIndex + 1);
      var nextPartOfPath = path.substr(startIndex + 1, finishIndex - startIndex - 1);
      if (finishIndex === -1 || !Object.prototype.hasOwnProperty.call(obj, nextPartOfPath)) {
        if (defaultValue !== undefined) {
          return defaultValue;
        } else {
          throw new Error("@lendi-ui/theme: Could not find a property named \"".concat(path, "\" on the theme."));
        }
      }
      obj = obj[nextPartOfPath];
      startIndex = finishIndex;
    } while (true); // eslint-disable-line no-constant-condition
  };
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/ui/Theme/dist/ui.esm.js












;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/style.js
var MessageList_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var MessageListWrapper = styled_components_browser_esm/* default.div */.ZP.div(MessageList_style_templateObject_1 || (MessageList_style_templateObject_1 = MessageList_style_makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
    return props.isExperiment
        ? "\n      padding-left: 20px;\n    "
        : "\n      height: 100%;\n      ".concat((0,spacing_esm.mt)('sm'), ";\n    ");
});
var StyleWelcome = styled_components_browser_esm/* default.div */.ZP.div(MessageList_style_templateObject_2 || (MessageList_style_templateObject_2 = MessageList_style_makeTemplateObject(["\n  ", ";\n  text-align: center;\n  ", ";\n  ", ";\n  font-size: ", ";\n  font-family: ", ";\n"], ["\n  ", ";\n  text-align: center;\n  ", ";\n  ", ";\n  font-size: ", ";\n  font-family: ", ";\n"])), (0,typography_esm/* body */.d1)({ size: 'sm', color: 'shade.700' }), (0,spacing_esm.pt)('md'), (0,spacing_esm.pb)('xxs'), (0,utils_esm/* deriveSize */.MS)(0.875), select_73d530a0_esm_select('typography.body.fontFamily'));
var MessageList_style_templateObject_1, MessageList_style_templateObject_2;
//# sourceMappingURL=style.js.map
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(36655);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || (0,esm_typeof/* default */.Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/toDate/index.js


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,esm_typeof/* default */.Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/isToday/index.js


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/DateDivider/style.js
var DateDivider_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var DateDividerWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(DateDivider_style_templateObject_1 || (DateDivider_style_templateObject_1 = DateDivider_style_makeTemplateObject(["\n  text-align: center;\n  ", ";\n  ", ";\n  font-weight: 600;\n  font-size: ", ";\n"], ["\n  text-align: center;\n  ", ";\n  ", ";\n  font-weight: 600;\n  font-size: ", ";\n"])), (0,spacing_esm.pt)('xs'), (0,spacing_esm.pb)('xxs'), (0,utils_esm/* deriveSize */.MS)(0.875));
var DateDivider_style_templateObject_1;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/DateDivider/index.js



var DateDivider = react.memo(function (_a) {
    var message = _a.message, previousMessage = _a.previousMessage;
    var date = message.dateCreated;
    var formattedDate = format(date, 'ccc, d MMM');
    var isSentToday = isToday(date);
    var previousTimestamp = previousMessage === null || previousMessage === void 0 ? void 0 : previousMessage.dateCreated;
    var isPreviousMessageTheSameDate = previousTimestamp && isSameDay(date, previousTimestamp);
    return previousMessage ? (react.createElement(react.Fragment, null, isPreviousMessageTheSameDate ? ('') : isSentToday ? (react.createElement(DateDividerWrapper, null, "Today")) : (react.createElement(DateDividerWrapper, null, formattedDate)))) : (react.createElement(DateDividerWrapper, null, isSentToday ? 'Today' : formattedDate));
});
/* harmony default export */ var MessageList_DateDivider = (DateDivider);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatBubble/index.style.js
var ChatBubble_index_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var index_style_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(ChatBubble_index_style_templateObject_1 || (ChatBubble_index_style_templateObject_1 = ChatBubble_index_style_makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n"])), function (_a) {
    var direction = _a.direction;
    if (direction === 'left')
        return 'align-items: flex-start;';
    return 'align-items: flex-end;';
});
var AlignmentDiv = styled_components_browser_esm/* default.div */.ZP.div(ChatBubble_index_style_templateObject_2 || (ChatBubble_index_style_templateObject_2 = ChatBubble_index_style_makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n"])), function (_a) {
    var direction = _a.direction;
    if (direction === 'left')
        return 'align-items: flex-start;';
    return 'align-items: flex-end;';
});
var BeforeCommonStyle = function () { return (0,styled_components_browser_esm/* css */.iv)(ChatBubble_index_style_templateObject_3 || (ChatBubble_index_style_templateObject_3 = ChatBubble_index_style_makeTemplateObject(["\n  content: '';\n  width: 16px;\n  height: 16px;\n  top: 0px;\n  position: absolute;\n  background: inherit;\n"], ["\n  content: '';\n  width: 16px;\n  height: 16px;\n  top: 0px;\n  position: absolute;\n  background: inherit;\n"]))); };
var AfterCommonStyle = function () { return (0,styled_components_browser_esm/* css */.iv)(ChatBubble_index_style_templateObject_4 || (ChatBubble_index_style_templateObject_4 = ChatBubble_index_style_makeTemplateObject(["\n  content: '';\n  width: 16px;\n  height: 32px;\n  top: 0px;\n  position: absolute;\n  ", "\n"], ["\n  content: '';\n  width: 16px;\n  height: 32px;\n  top: 0px;\n  position: absolute;\n  ", "\n"])), (0,color_esm.bg)('shade.0')); };
var LeftSideWrapper = function () { return (0,styled_components_browser_esm/* css */.iv)(index_style_templateObject_5 || (index_style_templateObject_5 = ChatBubble_index_style_makeTemplateObject(["\n  position: relative;\n  border-radius: 0 5px 5px 5px;\n\n  display: flex;\n\n  :before {\n    ", ";\n    right: 100%;\n  }\n\n  :after {\n    ", ";\n    border-radius: 0 20px 20px 0;\n    right: 100%;\n  }\n"], ["\n  position: relative;\n  border-radius: 0 5px 5px 5px;\n\n  display: flex;\n\n  :before {\n    ", ";\n    right: 100%;\n  }\n\n  :after {\n    ", ";\n    border-radius: 0 20px 20px 0;\n    right: 100%;\n  }\n"])), BeforeCommonStyle, AfterCommonStyle); };
var RightSideWrapper = function () { return (0,styled_components_browser_esm/* css */.iv)(index_style_templateObject_6 || (index_style_templateObject_6 = ChatBubble_index_style_makeTemplateObject(["\n  position: relative;\n  border-radius: 5px 0 5px 5px;\n\n  :before {\n    ", ";\n    left: 100%;\n  }\n\n  :after {\n    ", ";\n    border-radius: 20px 0 0 20px;\n    left: 100%;\n  }\n"], ["\n  position: relative;\n  border-radius: 5px 0 5px 5px;\n\n  :before {\n    ", ";\n    left: 100%;\n  }\n\n  :after {\n    ", ";\n    border-radius: 20px 0 0 20px;\n    left: 100%;\n  }\n"])), BeforeCommonStyle, AfterCommonStyle); };
var ChatBubbleContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = ChatBubble_index_style_makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var direction = _a.direction, hasTail = _a.hasTail;
    if (hasTail) {
        if (direction === 'left')
            return LeftSideWrapper();
        return RightSideWrapper();
    }
    else {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = ChatBubble_index_style_makeTemplateObject(["\n        border-radius: 5px;\n      "], ["\n        border-radius: 5px;\n      "])));
    }
});
var ChatBubble_index_style_templateObject_1, ChatBubble_index_style_templateObject_2, ChatBubble_index_style_templateObject_3, ChatBubble_index_style_templateObject_4, index_style_templateObject_5, index_style_templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=index.style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatBubble/index.js
var ChatBubble_assign = (undefined && undefined.__assign) || function () {
    ChatBubble_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ChatBubble_assign.apply(this, arguments);
};
var ChatBubble_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var ChatBubble_ChatContext = react.createContext({ direction: 'left', hasTail: false });
var ChatBubble = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'left' : _b, _c = _a.hasTail, hasTail = _c === void 0 ? true : _c, children = _a.children, props = ChatBubble_rest(_a, ["direction", "hasTail", "children"]);
    return (react.createElement(ChatBubble_ChatContext.Provider, { value: { direction: direction, hasTail: hasTail } },
        react.createElement(index_style_Wrapper, ChatBubble_assign({ direction: direction }, props, { "data-testid": "chat-bubble" }),
            react.createElement(AlignmentDiv, { direction: direction }, children))));
};
var ChatBubble_Content = function (_a) {
    var children = _a.children, props = ChatBubble_rest(_a, ["children"]);
    var _b = react.useContext(ChatBubble_ChatContext), direction = _b.direction, hasTail = _b.hasTail;
    return (react.createElement(ChatBubbleContentWrapper, ChatBubble_assign({ direction: direction, hasTail: hasTail, "data-testid": "chat-bubble-content" }, props), children));
};
ChatBubble.Content = ChatBubble_Content;
var Footer = function (_a) {
    var children = _a.children, props = ChatBubble_rest(_a, ["children"]);
    return (react.createElement("span", ChatBubble_assign({}, props), children));
};
ChatBubble.Footer = Footer;
/* harmony default export */ var components_ChatBubble = (ChatBubble);

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/style.js
var Message_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var ChatBubbleWrapper = (0,styled_components_browser_esm/* default */.ZP)(components_ChatBubble)(Message_style_templateObject_1 || (Message_style_templateObject_1 = Message_style_makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), (0,spacing_esm.mb)('xxs'), function (_a) {
    var direction = _a.direction;
    return (direction === 'right' ? (0,spacing_esm.ml)('xl') : (0,spacing_esm.mr)('lg'));
});
var BubbleContent = (0,styled_components_browser_esm/* default */.ZP)(components_ChatBubble.Content)(Message_style_templateObject_2 || (Message_style_templateObject_2 = Message_style_makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), (0,color_esm.fg)('shade.0'));
var MessageBodyWrapper = styled_components_browser_esm/* default.pre */.ZP.pre(style_templateObject_4 || (style_templateObject_4 = Message_style_makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n  font-family: ", ";\n  margin: 0;\n  ", ";\n  white-space: pre-wrap;\n\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n\n  ", ";\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n  font-family: ", ";\n  margin: 0;\n  ", ";\n  white-space: pre-wrap;\n\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n\n  ", ";\n"])), select_73d530a0_esm_select('typography.body.fontFamily'), (0,spacing_esm.p)('xs'), function (_a) {
    var isExperiment = _a.isExperiment;
    return isExperiment && (0,styled_components_browser_esm/* css */.iv)(Message_style_templateObject_3 || (Message_style_templateObject_3 = Message_style_makeTemplateObject(["\n      min-width: 300px;\n    "], ["\n      min-width: 300px;\n    "])));
});
var Message_style_templateObject_1, Message_style_templateObject_2, Message_style_templateObject_3, style_templateObject_4;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Avatar/style.js
var Avatar_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var DisplayWrapper = styled_components_browser_esm/* default.div */.ZP.div(Avatar_style_templateObject_1 || (Avatar_style_templateObject_1 = Avatar_style_makeTemplateObject(["\n  float: left;\n  z-index: 1;\n  align-self: flex-end;\n"], ["\n  float: left;\n  z-index: 1;\n  align-self: flex-end;\n"])));
var FooterAvatarWrapper = styled_components_browser_esm/* default.div */.ZP.div(Avatar_style_templateObject_2 || (Avatar_style_templateObject_2 = Avatar_style_makeTemplateObject(["\n  float: right;\n  z-index: 1;\n\n  ", ";\n"], ["\n  float: right;\n  z-index: 1;\n\n  ", ";\n"])), (0,spacing_esm.mt)('xxxs'));
var BaseAvatar = styled_components_browser_esm/* default.div */.ZP.div(Avatar_style_templateObject_3 || (Avatar_style_templateObject_3 = Avatar_style_makeTemplateObject(["\n  border-radius: 50%;\n  overflow: hidden;\n  font-weight: bold;\n\n  ", ";\n"], ["\n  border-radius: 50%;\n  overflow: hidden;\n  font-weight: bold;\n\n  ", ";\n"])), function (_a) {
    var isFooter = _a.isFooter;
    return isFooter
        ? "\n    min-width: 16px;\n    max-width: 16px;\n    height: 15px;\n    ".concat((0,spacing_esm.ml)('xxxs'), ";\n  ")
        : "\n    min-width: 24px;\n    max-width: 24px;\n    height: 24px;\n  ";
});
var BaseAvatarSm = styled_components_browser_esm/* default.div */.ZP.div(Avatar_style_templateObject_4 || (Avatar_style_templateObject_4 = Avatar_style_makeTemplateObject(["\n  border-radius: 50%;\n  overflow: hidden;\n  font-weight: bold;\n"], ["\n  border-radius: 50%;\n  overflow: hidden;\n  font-weight: bold;\n"])));
var FooterAvatarText = styled_components_browser_esm/* default.span */.ZP.span(style_templateObject_5 || (style_templateObject_5 = Avatar_style_makeTemplateObject(["\n  line-height: 1.4;\n  ", ";\n"], ["\n  line-height: 1.4;\n  ", ";\n"])), function (_a) {
    var isFooter = _a.isFooter;
    return isFooter
        ? "\n    font-size: 7.5px;\n  "
        : "\n    font-size: 10px;\n  ";
});
var BotWrapper = (0,styled_components_browser_esm/* default */.ZP)(BaseAvatar)(style_templateObject_6 || (style_templateObject_6 = Avatar_style_makeTemplateObject(["\n  ", ";\n\n  ", " {\n    ", ";\n  }\n"], ["\n  ", ";\n\n  ", " {\n    ", ";\n  }\n"])), (0,color_esm.bg)('secondary.400'), typography_esm/* Body */.uT, (0,spacing_esm.pt)('xxs'));
var Avatar_style_templateObject_1, Avatar_style_templateObject_2, Avatar_style_templateObject_3, Avatar_style_templateObject_4, style_templateObject_5, style_templateObject_6;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/LendiBot/dist/icon.esm.js






function SvgLendiBot(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#00C0A5",
          d: "M0 0h20v20H0z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          className: "lendi-bot_svg__fillPath",
          d: "M10.655 4.173l4.887 3.241c.286.19.458.509.458.85v6.38c0 .565-.463 1.023-1.034 1.023H5.034c-.571 0-1.034-.458-1.034-1.024V8.264c0-.346.177-.67.471-.858l5.047-3.241c.346-.223.794-.22 1.137.008zm3.278 9.447V8.81L10.07 6.25 6.067 8.82v4.8h2.9v-2.978h2.067v2.978h2.899z",
          fill: "#FFF"
        })]
      })
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/DomainBot/dist/icon.esm.js






function SvgDomainBot(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      viewBox: "0 0 40 40",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#0EA800",
          d: "M0 0h40v40H0z"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          fill: "#FFF",
          fillRule: "nonzero",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M19.394 8L10 14.191v.735-.554 17.45H20.999l1.094-1.672-1.094-1.67h-7.656V15.99h.001l6.05-3.987V8"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M28.788 14.372v-.18L19.394 8v4.004l6.05 3.987v15.821h3.344v-17.44"
          })]
        })]
      })
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/AussieBot/dist/icon.esm.js






function SvgAussieBot(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "#4B1F68"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        clipPath: "url(#aussie-bot_svg__clip0_539_34309)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M18.819 12.183l.002-.002-6.241-4.933S12.3 7 12.02 7c-.266 0-.57.254-.57.254l-6.273 4.93h.003a.453.453 0 00-.18.353c0 .255.225.463.5.463H18.499c.276 0 .501-.208.501-.463a.453.453 0 00-.181-.354zM17.01 12c0 .042-.036.077-.08.077H7.08h.004-.01a.078.078 0 01-.08-.077c0-.026.017-.05.04-.063l4.784-3.76s.117-.098.206-.098c.082 0 .198.103.198.103l4.758 3.761a.072.072 0 01.031.057",
          fill: "#fff"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M19 14.778a.228.228 0 01-.233.222H5.233c-.13 0-.233-.1-.233-.222v-.556c0-.122.104-.222.233-.222h13.534c.128 0 .233.1.233.222v.556zM19 16.778a.228.228 0 01-.233.222H5.233c-.13 0-.233-.1-.233-.222v-.555c0-.123.104-.223.233-.223h13.534c.128 0 .233.1.233.223v.555z",
          fill: "#FFD11F"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
          id: "aussie-bot_svg__clip0_539_34309",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: "#fff",
            transform: "translate(5 7)",
            d: "M0 0h14v10H0z"
          })
        })
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Avatar/ThemedBotIcon/index.js





var BotIcon = function () {
    var brand = (0,lala_utils_dist_esm/* getBrandFromHostname */.Y6)();
    switch (brand) {
        case lala_utils_dist_esm/* Brand.Aussie */.H2.Aussie:
            return react.createElement(SvgAussieBot, { color: "shade.0", height: "1.5em", width: "1.5em" });
        case lala_utils_dist_esm/* Brand.Domain */.H2.Domain:
            return react.createElement(SvgDomainBot, { height: "1.5em", width: "1.5em" });
        case lala_utils_dist_esm/* Brand.Lendi */.H2.Lendi:
        default:
            return react.createElement(SvgLendiBot, { color: "shade.0", height: "1.5em", width: "1.5em" });
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Avatar/CustomerAvatar/style.js
var CustomerAvatar_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var CustomerWrapper = (0,styled_components_browser_esm/* default */.ZP)(BaseAvatar)(CustomerAvatar_style_templateObject_1 || (CustomerAvatar_style_templateObject_1 = CustomerAvatar_style_makeTemplateObject(["\n  ", ";\n\n  ", " {\n    ", ";\n  }\n\n  ", ";\n"], ["\n  ", ";\n\n  ", " {\n    ", ";\n  }\n\n  ", ";\n"])), (0,color_esm.bg)('secondary.400'), typography_esm/* Body */.uT, (0,spacing_esm.pt)('xxs'), function (_a) {
    var isFooter = _a.isFooter;
    return isFooter &&
        "\n    margin-left: 2px;\n  ";
});
var CustomerBody = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(CustomerAvatar_style_templateObject_2 || (CustomerAvatar_style_templateObject_2 = CustomerAvatar_style_makeTemplateObject(["\n  padding-top: 0 !important; // Override LUI's body padding attribute to fix the tiny avator circle\n  ", ";\n"], ["\n  padding-top: 0 !important; // Override LUI's body padding attribute to fix the tiny avator circle\n  ", ";\n"])), function (_a) {
    var isFooter = _a.isFooter;
    return (isFooter ? 'margin-top: -6px;' : 'margin-top: -2px;');
});
var CustomerAvatar_style_templateObject_1, CustomerAvatar_style_templateObject_2;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Avatar/CustomerAvatar/index.js



var CustomerAvatar = function (_a) {
    var initials = _a.initials, isFooter = _a.isFooter;
    return (react.createElement(CustomerWrapper, { isFooter: isFooter },
        react.createElement(CustomerBody, { align: "center", color: "shade.0", isFooter: isFooter },
            react.createElement(FooterAvatarText, { isFooter: isFooter }, initials))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Avatar/BrokerAvatar/style.js
var BrokerAvatar_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var BrokerWrapper = (0,styled_components_browser_esm/* default */.ZP)(BaseAvatar)(BrokerAvatar_style_templateObject_1 || (BrokerAvatar_style_templateObject_1 = BrokerAvatar_style_makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), (0,color_esm.bg)('shade.300'));
var AvatarImage = styled_components_browser_esm/* default.img */.ZP.img(BrokerAvatar_style_templateObject_2 || (BrokerAvatar_style_templateObject_2 = BrokerAvatar_style_makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n"], ["\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n"])));
var FaceWrapper = styled_components_browser_esm/* default.span */.ZP.span(BrokerAvatar_style_templateObject_5 || (BrokerAvatar_style_templateObject_5 = BrokerAvatar_style_makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isFooter = _a.isFooter;
    return isFooter
        ? (0,styled_components_browser_esm/* css */.iv)(BrokerAvatar_style_templateObject_3 || (BrokerAvatar_style_templateObject_3 = BrokerAvatar_style_makeTemplateObject(["\n          padding-left: 1px;\n        "], ["\n          padding-left: 1px;\n        "]))) : (0,styled_components_browser_esm/* css */.iv)(BrokerAvatar_style_templateObject_4 || (BrokerAvatar_style_templateObject_4 = BrokerAvatar_style_makeTemplateObject(["\n          ", "\n          ", "\n        "], ["\n          ", "\n          ", "\n        "])), (0,spacing_esm.pt)('xxs'), (0,spacing_esm.pl)('xxxs'));
});
var BrokerAvatar_style_templateObject_1, BrokerAvatar_style_templateObject_2, BrokerAvatar_style_templateObject_3, BrokerAvatar_style_templateObject_4, BrokerAvatar_style_templateObject_5;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Face/dist/icon.esm.js






function SvgFace(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm6 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37a9.974 9.974 0 0010.41 3.97c.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Avatar/BrokerAvatar/index.js



var BrokerAvatar = function (_a) {
    var profilePictureURL = _a.profilePictureURL, isFooter = _a.isFooter;
    return (react.createElement(BrokerWrapper, { isFooter: isFooter }, profilePictureURL ? react.createElement(AvatarImage, { src: profilePictureURL }) : react.createElement(FaceAvatar, { isFooter: isFooter })));
};
var FaceAvatar = function (_a) {
    var isFooter = _a.isFooter;
    return (react.createElement(FaceWrapper, { isFooter: isFooter },
        react.createElement(SvgFace, { height: isFooter ? '14px' : '16px', width: isFooter ? '14px' : '16px' })));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Avatar/index.js






var Avatar = function (_a) {
    var member = _a.member, isFooter = _a.isFooter;
    var _b = member || {}, _c = _b.firstName, firstName = _c === void 0 ? '' : _c, _d = _b.lastName, lastName = _d === void 0 ? '' : _d, _e = _b.type, type = _e === void 0 ? LendiMemberType.CUSTOMER : _e;
    var initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    var insideAvartar = function () {
        switch (type) {
            case LendiMemberType.CUSTOMER:
                return react.createElement(CustomerAvatar, { initials: initials, isFooter: isFooter });
            case LendiMemberType.TEAM:
                return react.createElement(BrokerAvatar, { profilePictureURL: member === null || member === void 0 ? void 0 : member.profilePictureURL, isFooter: isFooter });
            case LendiMemberType.BOT:
                return (react.createElement(BotWrapper, { isFooter: isFooter },
                    react.createElement(BotIcon, null)));
            default:
                return react.createElement(react.Fragment, null);
        }
    };
    return (react.createElement(react.Fragment, null, type === LendiMemberType.BOT ? (insideAvartar()) : isFooter === true ? (react.createElement(FooterAvatarWrapper, null, insideAvartar())) : (react.createElement(DisplayWrapper, null, insideAvartar()))));
};
/* harmony default export */ var Message_Avatar = (Avatar);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Footer/style.js
var Footer_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var FooterTime = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(Footer_style_templateObject_1 || (Footer_style_templateObject_1 = Footer_style_makeTemplateObject(["\n  display: inline;\n"], ["\n  display: inline;\n"])));
var Footer_style_templateObject_1;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/Footer/index.js





var Footer_Footer = function (_a) {
    var message = _a.message, nextMessage = _a.nextMessage, members = _a.members, shouldShowAvatars = _a.shouldShowAvatars;
    var currentMembers = message.currentMembers;
    return (react.createElement(components_ChatBubble.Footer, null,
        react.createElement(FooterTime, { size: "xxs", color: "shade.700", mt: "xxxs" }, format(message.dateCreated, 'h:mm aaa')),
        shouldShowAvatars &&
            currentMembers.map(function (member) {
                return react.createElement(Message_Avatar, { key: member.identity, member: member, isFooter: true });
            })));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/SentMessage/style.js
var SentMessage_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var style_Content = (0,styled_components_browser_esm/* default */.ZP)(BubbleContent)(SentMessage_style_templateObject_1 || (SentMessage_style_templateObject_1 = SentMessage_style_makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'));
var SentMessage_style_templateObject_1;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/SentMessage/index.js





var SentMessage = function (_a) {
    var message = _a.message, nextMessage = _a.nextMessage, members = _a.members, shouldShowTimestamp = _a.shouldShowTimestamp, shouldShowAvatars = _a.shouldShowAvatars, shouldShowSeenBy = _a.shouldShowSeenBy;
    return (react.createElement(react.Fragment, null,
        react.createElement(style_Content, null,
            react.createElement(MessageBodyWrapper, null, message.text)),
        (shouldShowTimestamp || shouldShowAvatars) && (react.createElement(Footer_Footer, { message: message, nextMessage: nextMessage, members: members, shouldShowAvatars: shouldShowAvatars })),
        shouldShowSeenBy && (react.createElement(typography_esm/* Body */.uT, { size: "xxs", color: "shade.700", mt: "xxxs" },
            react.createElement("strong", null, "Seen by"),
            " ",
            message.seenByNames))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/ReceivedMessage/style.js
var ReceivedMessage_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var MessageWrapper = styled_components_browser_esm/* default.div */.ZP.div(ReceivedMessage_style_templateObject_1 || (ReceivedMessage_style_templateObject_1 = ReceivedMessage_style_makeTemplateObject([""], [""])));
var style_ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(ReceivedMessage_style_templateObject_2 || (ReceivedMessage_style_templateObject_2 = ReceivedMessage_style_makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n\n  ", " {\n    display: inline-block;\n    align-self: flex-end;\n\n    z-index: 1;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n\n  ", " {\n    display: inline-block;\n    align-self: flex-end;\n\n    z-index: 1;\n  }\n"])), BaseAvatar);
var ReceivedMessage_style_Content = (0,styled_components_browser_esm/* default */.ZP)(BubbleContent)(ReceivedMessage_style_templateObject_5 || (ReceivedMessage_style_templateObject_5 = ReceivedMessage_style_makeTemplateObject(["\n  ", ";\n  ", ";\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", "\n"])), (0,color_esm.bg)('shade.50'), (0,color_esm.fg)('shade.800'), function (_a) {
    var hasAvatar = _a.hasAvatar;
    return hasAvatar
        ? (0,styled_components_browser_esm/* css */.iv)(ReceivedMessage_style_templateObject_3 || (ReceivedMessage_style_templateObject_3 = ReceivedMessage_style_makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), (0,spacing_esm.ml)('xxs')) : (0,styled_components_browser_esm/* css */.iv)(ReceivedMessage_style_templateObject_4 || (ReceivedMessage_style_templateObject_4 = ReceivedMessage_style_makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), (0,spacing_esm.ml)('lg'));
});
var TimeWrapper = styled_components_browser_esm/* default.div */.ZP.div(ReceivedMessage_style_templateObject_6 || (ReceivedMessage_style_templateObject_6 = ReceivedMessage_style_makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), (0,spacing_esm.ml)('xl'));
var ReceivedMessage_style_templateObject_1, ReceivedMessage_style_templateObject_2, ReceivedMessage_style_templateObject_3, ReceivedMessage_style_templateObject_4, ReceivedMessage_style_templateObject_5, ReceivedMessage_style_templateObject_6;
//# sourceMappingURL=style.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/index.js
var utils = __webpack_require__(10212);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/giveMeHyperlink/index.js
var giveMeHyperlink = function (_a) {
    var text = _a.text, url = _a.url, _b = _a.openNewTab, openNewTab = _b === void 0 ? true : _b;
    if (text === '' || url === '') {
        return text;
    }
    return "<a href='".concat(url, "' target='").concat(openNewTab ? '_blank' : '_self', "'>").concat(text, "</a>");
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/constants.js
var constants = __webpack_require__(12818);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/ReceivedMessage/index.js












var BRAND_LENDI = 'Lendi';
var BRAND_DOMAIN = 'Domain Home Loans';
var BRAND_AUSSIE = 'Aussie';
var ReceivedMessage = function (_a) {
    var _b;
    var message = _a.message, nextMessage = _a.nextMessage, members = _a.members, identity = _a.identity, teamMember = _a.teamMember, shouldShowTimestamp = _a.shouldShowTimestamp, shouldShowAvatars = _a.shouldShowAvatars, shouldShowSeenBy = _a.shouldShowSeenBy, isExperiment = _a.isExperiment;
    var brand = (0,lala_utils_dist_esm/* getBrandFromHostname */.Y6)();
    var me = members.find(function (member) { return member.identity === identity; });
    var coApplicants = members.filter(function (member) { return member.type === LendiMemberType.CUSTOMER && member.identity !== identity; });
    var coApplicantsNames = '';
    if (coApplicants.length === 0) {
        // Do nothing
    }
    else if (coApplicants.length === 1) {
        coApplicantsNames = "".concat(coApplicants[0].firstName, " ").concat(coApplicants[0].lastName);
    }
    else {
        var fullNames = coApplicants.map(function (member) { return "".concat(member.firstName, " ").concat(member.lastName); });
        coApplicantsNames = fullNames.slice(0, coApplicants.length - 1).join(', ');
        coApplicantsNames += " and ".concat(fullNames[fullNames.length - 1]);
    }
    var messageWithNames = message.text, author = message.author;
    if (author && author.type === LendiMemberType.BOT) {
        switch (brand) {
            case lala_utils_dist_esm/* Brand.Aussie */.H2.Aussie:
                messageWithNames = messageWithNames.split('{{home_loan_provider_name}}').join(BRAND_AUSSIE);
                break;
            case lala_utils_dist_esm/* Brand.Domain */.H2.Domain:
                messageWithNames = messageWithNames.split(BRAND_LENDI).join(BRAND_DOMAIN); // this is for previously created channel persisted with welcome message containing `Lendi`
                messageWithNames = messageWithNames.split('{{home_loan_provider_name}}').join(BRAND_DOMAIN);
                break;
            case lala_utils_dist_esm/* Brand.Lendi */.H2.Lendi:
            default:
                messageWithNames = messageWithNames.split('{{home_loan_provider_name}}').join(BRAND_LENDI);
                break;
        }
        messageWithNames = messageWithNames.replace('{{current_user_first_name}}', (me === null || me === void 0 ? void 0 : me.type) === LendiMemberType.CUSTOMER
            ? me.firstName === 'Customer'
                ? ''
                : me.firstName
            : ((_b = coApplicants[0]) === null || _b === void 0 ? void 0 : _b.firstName) || '');
        var hlsName = 'Home Loan Specialist';
        if ((teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName) && (teamMember === null || teamMember === void 0 ? void 0 : teamMember.lastName)) {
            // If both FN & LN are available, show both
            hlsName = "".concat(teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName, " ").concat(teamMember === null || teamMember === void 0 ? void 0 : teamMember.lastName);
        }
        else if (teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName) {
            // If firstName is available, show firstName
            hlsName = teamMember === null || teamMember === void 0 ? void 0 : teamMember.firstName;
        }
        messageWithNames = messageWithNames.replace('{{hls_name}}', hlsName);
        if (coApplicants.length > 0) {
            messageWithNames = messageWithNames.split('{{applicant}}').join(coApplicantsNames);
        }
    }
    var shouldShowAuthor = !nextMessage || message.author !== nextMessage.author || !isSameDay(nextMessage.dateCreated, message.dateCreated);
    return (react.createElement(MessageWrapper, null,
        react.createElement(style_ContentWrapper, null,
            shouldShowAuthor && react.createElement(Message_Avatar, { member: author, isFooter: false }),
            react.createElement(ReceivedMessage_style_Content, { hasAvatar: shouldShowAuthor },
                react.createElement(MessageBodyWrapper, { isExperiment: isExperiment }, author &&
                    author.type !== LendiMemberType.CUSTOMER &&
                    messageWithNames.indexOf(constants/* PRIVACY_POLICY_TEXT */.BT) > -1 ? (react.createElement("span", { dangerouslySetInnerHTML: {
                        __html: messageWithNames.replace(constants/* PRIVACY_POLICY_TEXT */.BT, giveMeHyperlink({
                            text: constants/* PRIVACY_POLICY_TEXT */.BT,
                            url: (0,utils/* getPrivacyPolicyLink */.uC)(brand),
                            // url: getPri :,
                        })),
                    } })) : (react.createElement(react.Fragment, null, messageWithNames))))),
        react.createElement(TimeWrapper, null,
            (shouldShowTimestamp || shouldShowAvatars) && (react.createElement(Footer_Footer, { message: message, nextMessage: nextMessage, members: members, shouldShowAvatars: shouldShowAvatars })),
            shouldShowSeenBy && (react.createElement(typography_esm/* Body */.uT, { size: "xxs", color: "shade.700", mt: "xxxs" },
                react.createElement("strong", null, "Seen by"),
                " ",
                message.seenByNames)))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/constants/index.js
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
var daysInYear = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
var minTime = -maxTime;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
var secondsInHour = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
var secondsInDay = secondsInHour * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
var secondsInWeek = secondsInDay * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
var secondsInYear = secondsInDay * daysInYear;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
var secondsInMonth = secondsInYear / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var secondsInQuarter = secondsInMonth * 3;
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/differenceInMilliseconds/index.js


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE
};

var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
;// CONCATENATED MODULE: ../../../node_modules/date-fns/esm/differenceInMinutes/index.js




/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */
function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/Message/index.js





var Message = react.memo(function (_a) {
    var _b;
    var members = _a.members, identity = _a.identity, message = _a.message, nextMessage = _a.nextMessage, teamMember = _a.teamMember, isSelected = _a.isSelected, isExperiment = _a.isExperiment;
    var ownedByMe = message.authorIdentity === identity;
    var shouldShowTimestamp = !nextMessage ||
        message.authorIdentity !== nextMessage.authorIdentity ||
        differenceInMinutes(nextMessage.dateCreated, message.dateCreated) > 0;
    var shouldShowAvatars = ((_b = message === null || message === void 0 ? void 0 : message.currentMembers) === null || _b === void 0 ? void 0 : _b.length) > 0; // lendi_bot will NEVER have read any message, hence needs to less 1
    return (react.createElement(ChatBubbleWrapper, { direction: ownedByMe ? 'right' : 'left', id: String(message.index) }, ownedByMe ? (react.createElement(SentMessage, { identity: identity, message: message, nextMessage: nextMessage, members: members, shouldShowTimestamp: shouldShowTimestamp, shouldShowAvatars: shouldShowAvatars, shouldShowSeenBy: isSelected && !!message.seenByNames })) : (react.createElement(ReceivedMessage, { identity: identity, message: message, nextMessage: nextMessage, members: members, teamMember: teamMember, shouldShowTimestamp: shouldShowTimestamp, shouldShowAvatars: shouldShowAvatars, shouldShowSeenBy: isSelected && !!message.seenByNames, isExperiment: isExperiment }))));
});
/* harmony default export */ var MessageList_Message = (Message);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/TypingIndicator/style.js
var TypingIndicator_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var EmptySpace = styled_components_browser_esm/* default.div */.ZP.div(TypingIndicator_style_templateObject_1 || (TypingIndicator_style_templateObject_1 = TypingIndicator_style_makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), (0,spacing_esm.pt)('xs'));
var TypingIndicator_style_templateObject_1;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/TypingIndicator/index.js
var TypingIndicator_assign = (undefined && undefined.__assign) || function () {
    TypingIndicator_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return TypingIndicator_assign.apply(this, arguments);
};





var TypingIndicator = function (_a) {
    var identity = _a.identity, members = _a.members;
    members = members.map(function (member) {
        return member.identity === LENDI_BOT_IDENTITY ? TypingIndicator_assign(TypingIndicator_assign({}, member), { firstName: (0,utils/* getFirstNameForBrand */.Lv)() }) : member;
    });
    var otherTypingMembers = members.filter(function (member) { return member.identity !== identity && member.isTyping; });
    var indicatorMessage = '';
    if (otherTypingMembers.length === 0) {
        return react.createElement(EmptySpace, null);
    }
    else if (otherTypingMembers.length === 1) {
        var _b = otherTypingMembers[0].firstName, firstName = _b === void 0 ? 'Member' : _b;
        indicatorMessage = "".concat(firstName, " is typing...");
    }
    else {
        var firstNames = otherTypingMembers.map(function (member) { return "".concat(member.firstName, " ").concat(member.lastName); });
        indicatorMessage = firstNames.slice(0, otherTypingMembers.length - 1).join(', ');
        indicatorMessage += " and ".concat(firstNames[firstNames.length - 1], " ");
        indicatorMessage += 'are typing...';
    }
    return (react.createElement(typography_esm/* Body */.uT, { size: "xxs", color: "shade.700", mt: "xxxs" }, indicatorMessage));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/MessageList/index.js






var MessageList = function (_a) {
    var identity = _a.identity, members = _a.members, messages = _a.messages, teamMember = _a.teamMember, userType = _a.userType, isExperiment = _a.isExperiment, hideDay = _a.hideDay;
    return (react.createElement(MessageListWrapper, { isExperiment: isExperiment },
        (messages === null || messages === void 0 ? void 0 : messages.length) > 0 &&
            renderMessageList(identity, members, messages, userType, teamMember, hideDay, isExperiment),
        react.createElement(TypingIndicator, { identity: identity, members: members })));
};
var renderMessageList = function (identity, members, messages, userType, teamMember, hideDay, isExperiment) {
    var filteredMessages = messages.filter(function (message) {
        var shouldHideBotMessageForTeamMember = userType === 'broker' && message.authorIdentity === constants/* BOT_IDENTITY */.Zo;
        return !shouldHideBotMessageForTeamMember;
    });
    var _a = (0,react.useState)(-1), selectedIndex = _a[0], setSelectedIndex = _a[1];
    return filteredMessages.map(function (message, i) {
        var previousMessage = i > 0 ? filteredMessages[i - 1] : undefined;
        var nextMessage = i < messages.length - 1 ? filteredMessages[i + 1] : undefined;
        return (react.createElement("div", { key: i, onClick: function () { return (i === selectedIndex ? setSelectedIndex(-1) : setSelectedIndex(i)); } },
            !hideDay && react.createElement(MessageList_DateDivider, { message: message, previousMessage: previousMessage }),
            react.createElement(MessageList_Message, { key: message.index, identity: identity, previousMessage: previousMessage, message: message, nextMessage: nextMessage, members: members, teamMember: teamMember, isSelected: i === selectedIndex, isExperiment: isExperiment })));
    });
};
/* harmony default export */ var ChatComponent_MessageList = (MessageList);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/style.js
var ChatComponent_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var style_MessageListWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: FULLSTORY_EXCLUDE_CLASS,
})(ChatComponent_style_templateObject_1 || (ChatComponent_style_templateObject_1 = ChatComponent_style_makeTemplateObject(["\n  overflow-x: hidden;\n  overflow-y: auto;\n  ", ";\n  ", ";\n\n  ", ";\n"], ["\n  overflow-x: hidden;\n  overflow-y: auto;\n  ", ";\n  ", ";\n\n  ", ";\n"])), (0,spacing_esm.pr)('sm'), (0,spacing_esm.pl)('xxs'), function (props) {
    return !props.isExperiment
        ? "\n          height: 100%;\n        "
        : "\n          & > div:first-child {\n            margin-top: 30px;\n          }\n        ";
});
var ChatComponent_style_templateObject_1;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/useDebounce.js

function useDebounce(value, delay) {
    // State and setters for debounced value
    var _a = (0,react.useState)(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    (0,react.useEffect)(function () {
        // Update debounced value after delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function () {
            clearTimeout(handler);
        };
    }, [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}
//# sourceMappingURL=useDebounce.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/ErrorComponent/style.js
var ErrorComponent_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var HeadingWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Heading */.X6)(ErrorComponent_style_templateObject_1 || (ErrorComponent_style_templateObject_1 = ErrorComponent_style_makeTemplateObject(["\n  text-align: center;\n  max-width: 580px;\n"], ["\n  text-align: center;\n  max-width: 580px;\n"])));
var BodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(ErrorComponent_style_templateObject_2 || (ErrorComponent_style_templateObject_2 = ErrorComponent_style_makeTemplateObject(["\n  text-align: center;\n  max-width: 280px;\n  font-size: 16px;\n"], ["\n  text-align: center;\n  max-width: 280px;\n  font-size: 16px;\n"])));
var Main = styled_components_browser_esm/* default.div */.ZP.div(ErrorComponent_style_templateObject_3 || (ErrorComponent_style_templateObject_3 = ErrorComponent_style_makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  ", ";\n"], ["\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  ", ";\n"])), (0,spacing_esm.mt)('md'));
var ButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx)(ErrorComponent_style_templateObject_4 || (ErrorComponent_style_templateObject_4 = ErrorComponent_style_makeTemplateObject(["\n  width: 280px;\n"], ["\n  width: 280px;\n"])));
var ErrorComponent_style_templateObject_1, ErrorComponent_style_templateObject_2, ErrorComponent_style_templateObject_3, ErrorComponent_style_templateObject_4;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/FatalError/index.js



var FatalError = function (_a) {
    var onRetry = _a.onRetry;
    return (react.createElement(Main, null,
        react.createElement(HeadingWrapper, { size: "md", color: "shade.700", mb: "xs", mt: "md" }, "Something went wrong."),
        react.createElement(BodyWrapper, { size: "md", color: "shade.700", mb: "md", mx: "xl" },
            "Chat did not work, please try again or let us know\u00A0",
            react.createElement(typography_esm/* Link */.rU, { "data-testid": "contact-us", href: "/contactus" }, "here")),
        react.createElement(ButtonWrapper, { variant: "primary", onClick: onRetry }, "TRY AGAIN")));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/states/state/types/index.js
var SmartCheckpoint;
(function (SmartCheckpoint) {
    SmartCheckpoint["ON_PHONE_NUMBER_VALIDATION_CHECK"] = "ON_PHONE_NUMBER_VALIDATION_CHECK";
    SmartCheckpoint["ON_REQUEST_CODE_CHECK"] = "ON_REQUEST_CODE_CHECK";
    SmartCheckpoint["ON_NEW_CUSTOMER_CHECK"] = "ON_CHECK_NEW_CUSTOMER";
    SmartCheckpoint["ON_CODE_RESEND_CHECK"] = "ON_CODE_RESEND_CHECK";
    SmartCheckpoint["ON_CHANGE_PHONE_NUMBER_CHECK"] = "ON_CHANGE_PHONE_NUMBER_CHECK";
    SmartCheckpoint["ON_CODE_VALIDATION_CHECK"] = "ON_CODE_VALIDATION_CHECK";
    SmartCheckpoint["ON_CODE_VERIFY_CHECK"] = "ON_CODE_VERIFY_CHECK";
    SmartCheckpoint["ON_NAME_CHECK"] = "ON_NAME_CHECK";
    SmartCheckpoint["ON_EMAIL_VALIDATION_CHECK"] = "ON_EMAIL_VALIDATION_CHECK";
    SmartCheckpoint["ON_ERROR_CHECK"] = "ON_ERROR_CHECK";
    SmartCheckpoint["ON_FINAL_CHECK"] = "ON_FINAL_CHECK";
})(SmartCheckpoint || (SmartCheckpoint = {}));
var SmartExperimentCheckpoint;
(function (SmartExperimentCheckpoint) {
    SmartExperimentCheckpoint["ON_SIGN_IN_CHECK"] = "ON_SIGN_IN_CHECK";
    SmartExperimentCheckpoint["ON_VERIFY_CHECK"] = "ON_VERIFY_CHECK";
})(SmartExperimentCheckpoint || (SmartExperimentCheckpoint = {}));
var StepNames;
(function (StepNames) {
    StepNames["START_STEP_BUTTONS"] = "START_STEP_BUTTONS";
    StepNames["MESSAGE_LIST"] = "MESSAGE_LIST";
    StepNames["VERIFY"] = "VERIFY";
    StepNames["SIGNIN"] = "SIGNIN";
    StepNames["INITIAL_MESSAGES"] = "INITIAL_MESSAGES";
})(StepNames || (StepNames = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/states/actions/SmartChatActions/index.js
var Types;
(function (Types) {
    Types["NEW_MESSAGE"] = "NEW_MESSAGE";
    Types["CLEAR_MESSAGE"] = "CLEAR_MESSAGE";
    Types["RESET_MESSAGE"] = "RESET_MESSAGE";
    Types["IS_TIMEDOUT"] = "IS_TIMEDOUT";
    Types["START_TIMEOUT"] = "START_TIMEOUT";
    Types["RESET_TIMEOUT"] = "RESET_TIMEOUT";
    Types["UPDATE_TIMEOUT"] = "UPDATE_TIMEOUT";
    Types["START_BOT_TYPING"] = "START_BOT_TYPING";
    Types["STOP_BOT_TYPING"] = "STOP_BOT_TYPING";
    Types["PASS_MESSAGE_TO_BOT"] = "PASS_MESSAGE_TO_BOT";
    Types["NEXT_SMART_STATE"] = "NEXT_SMART_STATE";
    Types["UPDATE_PHONE_NUMBER"] = "UPDATE_PHONE_NUMBER";
    Types["UPDATE_EMAIL"] = "UPDATE_EMAIL";
    Types["UPDATE_FIRST_NAME"] = "UPDATE_FIRST_NAME";
    Types["UPDATE_CODE"] = "UPDATE_CODE";
    Types["SHOW_CONTANT_US"] = "SHOW_CONTANT_US";
    Types["HIDE_CONTANT_US"] = "HIDE_CONTANT_US";
    Types["SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR"] = "SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR";
    Types["SHOW_FATAL_ERROR_PAGE"] = "SHOW_FATAL_ERROR_PAGE";
    Types["HIDE_FATAL_ERROR_PAGE"] = "HIDE_FATAL_ERROR_PAGE";
    Types["SHOW_SEND_CODE_ACTION"] = "SHOW_SEND_CODE_ACTION";
    Types["HIDE_SEND_CODE_ACTION"] = "HIDE_SEND_CODE_ACTION";
    Types["SHOW_CHANGE_PHONE_ACTION"] = "SHOW_CHANGE_PHONE_ACTION";
    Types["HIDE_CHANGE_PHONE_ACTION"] = "HIDE_CHANGE_PHONE_ACTION";
    Types["SAVE_LEADS"] = "SAVE_LEADS";
    Types["NEXT_EXPERIMENT_ONE_SMART_STATE"] = "NEXT_EXPERIMENT_ONE_SMART_STATE";
    Types["SIGN_IN_SUBMITTED"] = "SIGN_IN_SUBMITTED";
    Types["START_STEP_BUTTON_CLICKED"] = "START_STEP_BUTTON_CLICKED";
})(Types || (Types = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/metadata.min.json.js
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
/* harmony default export */ var metadata_min_json = ({"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","[24-689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],"BL":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","[56]94\\d{6}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([3-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","9008\\d{3}|(?:[2-467]\\d\\d|510|862)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29[1289]|389)","529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","596\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[047]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}|(?:708|80\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"],["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-8]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[04]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["5056(?:[0-35-9]\\d|4[468])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:20|33|[5-79]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"],["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}});
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.


function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(metadata_min_json)
	return func.apply(this, args)
}
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/isObject.js
var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}
//# sourceMappingURL=isObject.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/normalizeArguments.js
function normalizeArguments_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? normalizeArguments_ownKeys(Object(source), !0).forEach(function (key) { normalizeArguments_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : normalizeArguments_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function normalizeArguments_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Extracts the following properties from function arguments:
// * input `text`
// * `options` object
// * `metadata` JSON

function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
}
//# sourceMappingURL=normalizeArguments.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/constants.js
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/ParseError.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  _inherits(ParseError, _Error);

  var _super = _createSuper(ParseError);

  function ParseError(code) {
    var _this;

    _classCallCheck(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return _createClass(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));


//# sourceMappingURL=ParseError.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/tools/semver-compare.js
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ function semver_compare(a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
//# sourceMappingURL=semver-compare.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/metadata.js
function metadata_typeof(obj) { "@babel/helpers - typeof"; return metadata_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, metadata_typeof(obj); }

function metadata_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function metadata_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function metadata_createClass(Constructor, protoProps, staticProps) { if (protoProps) metadata_defineProperties(Constructor.prototype, protoProps); if (staticProps) metadata_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


 // Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".

var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    metadata_classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  metadata_createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();



var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    metadata_classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  metadata_createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new metadata_Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    metadata_classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  metadata_createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var metadata_Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    metadata_classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  metadata_createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var typeOf = function typeOf(_) {
  return metadata_typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries.hasOwnProperty(country);
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
 // The RFC 3966 format for extensions.

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js

 //  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber_isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
 // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/parseDigits.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseDigits_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseDigits_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseDigits_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseDigits_arrayLikeToArray(o, minLen); }

function parseDigits_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function parseIncompletePhoneNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseIncompletePhoneNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseIncompletePhoneNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); }

function parseIncompletePhoneNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = parseIncompletePhoneNumber_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function mergeArrays_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = mergeArrays_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mergeArrays_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mergeArrays_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mergeArrays_arrayLikeToArray(o, minLen); }

function mergeArrays_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = mergeArrays_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/isPossible.js


/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossible.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function getNumberType_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getNumberType_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getNumberType_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getNumberType_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getNumberType_arrayLikeToArray(o, minLen); }

function getNumberType_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.

  if (!input.country && !input.countryCallingCode) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = getNumberType_createForOfIteratorHelperLoose(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}
//# sourceMappingURL=getNumberType.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/isValid.js



/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}
//# sourceMappingURL=isValid.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js

/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */

function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);

  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return [];
  }

  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}

function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);

  _metadata.selectNumberingPlan(country);

  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }

  return false;
}
//# sourceMappingURL=getPossibleCountriesForNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
 // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
 // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
//# sourceMappingURL=getIddPrefix.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function RFC3966_slicedToArray(arr, i) { return RFC3966_arrayWithHoles(arr) || RFC3966_iterableToArrayLimit(arr, i) || RFC3966_unsupportedIterableToArray(arr, i) || RFC3966_nonIterableRest(); }

function RFC3966_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function RFC3966_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RFC3966_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = RFC3966_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return RFC3966_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RFC3966_arrayLikeToArray(o, minLen); }

function RFC3966_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 // https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = RFC3966_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;) {
    var part = _step.value;

    var _part$split = part.split('='),
        _part$split2 = RFC3966_slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/format.js
function format_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = format_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function format_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return format_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return format_arrayLikeToArray(o, minLen); }

function format_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function format_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function format_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? format_ownKeys(Object(source), !0).forEach(function (key) { format_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : format_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function format_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js





var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = format_objectSpread(format_objectSpread({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = format_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
//# sourceMappingURL=format.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/PhoneNumber.js
function PhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { PhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhoneNumber_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhoneNumber_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PhoneNumber_createClass(Constructor, protoProps, staticProps) { if (protoProps) PhoneNumber_defineProperties(Constructor.prototype, protoProps); if (staticProps) PhoneNumber_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



 // import checkNumberLength from './helpers/checkNumberLength.js'




var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    PhoneNumber_classCallCheck(this, PhoneNumber);

    if (!countryOrCountryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }

    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;

    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.

    this.getMetadata = function () {
      return metadata;
    };
  }

  PhoneNumber_createClass(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }

      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? PhoneNumber_objectSpread(PhoneNumber_objectSpread({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();



var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.

  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
    /* istanbul ignore if */

    if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
      if (metadata.isNonGeographicCallingCode(countryCallingCode)) {
        country = '001';
      }
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}
//# sourceMappingURL=PhoneNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js



/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}
//# sourceMappingURL=extractNationalNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js





/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js




/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }

  var isNumberWithIddPrefix; // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376

  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
} // The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }
//# sourceMappingURL=extractCountryCallingCode.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js
function getCountryByNationalNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getCountryByNationalNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getCountryByNationalNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getCountryByNationalNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getCountryByNationalNumber_arrayLikeToArray(o, minLen); }

function getCountryByNationalNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);
  var matchingCountries = [];

  for (var _iterator = getCountryByNationalNumber_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // If the `defaultCountry` is among the `matchingCountries` then return it.
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }

        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  } // Return the first ("main") one of the `matchingCountries`.


  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}
//# sourceMappingURL=getCountryByNationalNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js

var getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;

  /* istanbul ignore if */
  if (getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  }

  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry: defaultCountry,
    metadata: metadata.metadata
  });
}
//# sourceMappingURL=getCountryByCallingCode.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extractPhoneContext.js
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */

var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS

var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */

var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */

function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_); // If no phone-context parameter is present

  if (indexOfPhoneContext < 0) {
    return null;
  }

  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length; // If phone-context parameter is empty

  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }

  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter

  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */

function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }

  if (phoneContext.length === 0) {
    return false;
  } // Does phone-context value match pattern of global-number-digits or domainname.


  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
//# sourceMappingURL=extractPhoneContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js


/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */

function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);

  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }

  var phoneNumberString;

  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.

    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    } // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.


    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.

    /* istanbul ignore else */

    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }

    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  } // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.


  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);

  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  } // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.


  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}
//# sourceMappingURL=extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/parse.js
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js







 // import { parseRFC3966 } from './helpers/RFC3966.js'







 // We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
var parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  }); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber_isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is passed in "national" format
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    } else {
      /* istanbul ignore if */
      if (parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = '001';
        }
      }
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    defaultCountry: defaultCountry,
    metadata: metadata
  });

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js
function parsePhoneNumberWithError_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumberWithError_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumberWithError_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumberWithError_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumberWithError_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumberWithError_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, parsePhoneNumberWithError_objectSpread(parsePhoneNumberWithError_objectSpread({}, options), {}, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumberWithError_.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/parsePhoneNumber_.js
function parsePhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function parsePhoneNumber_parsePhoneNumber(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = parsePhoneNumber_objectSpread(parsePhoneNumber_objectSpread({}, options), {}, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) {//
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumber_.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/es6/parsePhoneNumber.js


function es6_parsePhoneNumber_parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumber_parsePhoneNumber(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumber.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js



function exports_parsePhoneNumber_parsePhoneNumber() {
	return withMetadataArgument(es6_parsePhoneNumber_parsePhoneNumber, arguments)
}
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/utils/index.js


var GUEST_IDENTITY = 'guest';
var BOT_IDENTITY = 'bot';
var TIMEOUT_VALUE = 15; // in sec
var LENDI_BOT_MEMBER = {
    identity: BOT_IDENTITY,
    type: LendiMemberType.BOT,
    isOnline: false,
    isTyping: false,
    firstName: 'Lendi',
    lastName: 'Singh',
    lastConsumedMessageIndex: 0,
};
var smartChatMembers = [
    LENDI_BOT_MEMBER,
    {
        identity: 'guest',
        type: LendiMemberType.CUSTOMER,
        isOnline: false,
        isTyping: false,
        firstName: 'Guest',
        lastName: 'Singh',
        lastConsumedMessageIndex: 0,
    },
];
var chatMessage = function (msg) { return [
    {
        index: 1,
        text: msg,
        authorIdentity: BOT_IDENTITY,
        author: LENDI_BOT_MEMBER,
        dateCreated: new Date(),
        currentMembers: [],
    },
]; };
var sleep = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
var createBotMessage = function (text, index) {
    return {
        index: index,
        text: text,
        authorIdentity: BOT_IDENTITY,
        author: LENDI_BOT_MEMBER,
        dateCreated: new Date(),
        currentMembers: [],
    };
};
var createGuestMessage = function (text, index) {
    return {
        index: index,
        text: text,
        authorIdentity: GUEST_IDENTITY,
        author: LENDI_BOT_MEMBER,
        dateCreated: new Date(),
        currentMembers: [],
    };
};
var scrollToBottom = function (target) {
    if (target && target.scrollIntoView) {
        target.scrollIntoView({ block: 'end', behavior: 'auto' });
    }
};
var trim = function (input) {
    return input
        .replace(/\r?\n|\r/g, ' ')
        .split(' ')
        .join('');
};
var formatPhone = function (phoneNumber) {
    var chunks = phoneNumber.match(/.{1,3}/g);
    return chunks.join(' ');
};
var validateAndFormatPhoneNumber = function (input) {
    var formattedMobileNumber = exports_parsePhoneNumber_parsePhoneNumber(input, 'AU');
    if (formattedMobileNumber) {
        if (!formattedMobileNumber.isValid() || formattedMobileNumber.getType() !== 'MOBILE') {
            return null;
        }
        else {
            return formattedMobileNumber.number.toString();
        }
    }
    return null;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/decorators/sendMessageWithMockTyping.js
var sendMessageWithMockTyping_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var sendMessageWithMockTyping_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/**
 * Add message to the chatState with mock typing
 */
var sendMessageWithTypingDecorator = function (chatDispatch, msg, nextMessageIndex) { return sendMessageWithMockTyping_awaiter(void 0, void 0, void 0, function () {
    return sendMessageWithMockTyping_generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                chatDispatch({ type: Types.START_BOT_TYPING });
                return [4 /*yield*/, sleep(2000)];
            case 1:
                _a.sent();
                chatDispatch({
                    type: Types.NEW_MESSAGE,
                    payload: createBotMessage(msg, nextMessageIndex),
                });
                chatDispatch({ type: Types.STOP_BOT_TYPING });
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=sendMessageWithMockTyping.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/Constants/index.js
// DON'T remove new lines formats from this file.
var WELCOME_TEXT = "Hi there,\n\nWelcome to {{home_loan_provider_name}}.\n\nCan you please confirm your mobile number? This will help us quickly connect you with the right person at {{home_loan_provider_name}}.";
var EXPERIMENT_TWO_WELCOME_TEXT = "Hi there,\n\nWelcome to {{home_loan_provider_name}}.\n\nCan you please confirm your details before we proceed? This will help us quickly connect you with the right person at {{home_loan_provider_name}}.";
var EXPERIMENT_THREE_WELCOME_TEXT_ONE = "Hi there,\n\nWelcome to {{home_loan_provider_name}}.\n\nOur experts are here to answer all your home loan related questions.\n\nWould you prefer to one of our Home Loan specialists to call you or continue here with chat?\n";
var CONFIRM_DETAILS_TEXT = "Thank you.\n\nCan you please confirm your details before we proceed? This will help us quickly connect you with the right person at {{home_loan_provider_name}}.";
var PHONE_VALIDATION_ERROR_MESSAGE = "It looks like that number didn\u2019t work.\n\nPlease provide an Australian mobile phone number.\n\nAn Australian mobile phone number starts with 04 or 05 followed by 8 numbers.";
var PHONE_VALIDATION_SUCCESS_MESSAGE_1 = "Thank you.\n\nYou will receive a one-time password via SMS in a few seconds.";
var PHONE_VALIDATION_SUCCESS_MESSAGE_2 = "Thank you!\n\nPlease now enter the 6 digit code you have received by SMS on";
var PHONE_VALIDATION_SUCCESS_MESSAGE_2_WITHOUT_THANKS = 'Please now enter the 6 digit code you have received by SMS on';
var WHAT_PHONE_NUMBER = 'What is your mobile phone number?';
var HAVE_NOT_RECEIVED_CODE = "Haven't received your code?";
var CODE_VERIFIED_SUCCESS_MESSAGE = "Success! Your number has been verified.\n\nWe're now connecting you with one of our friendly experts. This will take a few moments.";
var CODE_VERIFIED_ERROR_MESSAGE = 'That code is incorrect. Please enter the 6 digit code again.';
var TOO_MANY_ATTEMPTS_MESSAGE = 'That code is incorrect. Please enter the 6 digit code again.';
var BLOCKED_USER_ERROR_MESSAGE = 'Sorry, you may be blocked from logging in.';
var RESEND_CODE_MESSAGE = "No worries.\nYou will receive a new OTP by SMS in a few seconds.";
var CHANGE_PHONE_NUMBER = "No worries.\n".concat(WHAT_PHONE_NUMBER);
var CUSTOMER_SAY_NOT_RECEIVED_CODE = 'I did not receive the SMS.';
var CUSTOMER_SAY_WRONG_PHONE = 'I provided a wrong phone number.';
var NEW_CUSTOMER_CHECK_MESSAGE = "Can you please provide your first name?";
var THANK_YOU_NAME_MESSAGE = 'Thank you';
var WHAT_IS_EMAIL_ADDRESS = 'One last thing before we verify your account. What is your email address?';
var INVALID_EMAIL = 'Please enter a valid email address.';
var NUMBER_NOT_WORKING = 'The provided number is not working, please check again.';
var PRIVACY_POLICY_MESSAGE = 'We will never sell your personal details to anyone. Ever. By registering you agree to {{home_loan_provider_name}}’s Privacy Policy and receive emails from {{home_loan_provider_name}}.';
var CHAT_EXPERIMENT_1_HEADER = 'We are here to answer all your home loan related questions. Enter your details so we can quickly connect you with the right person at Lendi.';
var OTP_VERIFY_FIELD_LABEL = 'Please enter your one-time passcode';
var EMAIL_FIELD_EMPTY_LABEL = 'Please enter your email address';
var EMAIL_FIELD_VALIDATION_LABEL = 'Please provide a valid email address';
var MOBILE_ERROR = 'Please provide an Australian mobile phone number';
var FIRST_NAME_ERROR = 'Please enter your first name';
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/usePhoneNumberValidation.js
var usePhoneNumberValidation_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var usePhoneNumberValidation_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





/**
 * Hook - this runs some validations on Guest inputs to the SmartChat.
 */
function usePhoneNumberValidation(state, chatDispatch) {
    var messages = state.messages, messageToBot = state.messageToBot, checkpoint = state.checkpoint;
    (0,react.useEffect)(function () {
        function phoneNumberValidationHandler() {
            return usePhoneNumberValidation_awaiter(this, void 0, void 0, function () {
                var phoneNumber, oldIndex, nextIndex;
                return usePhoneNumberValidation_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(messageToBot && checkpoint === SmartCheckpoint.ON_PHONE_NUMBER_VALIDATION_CHECK)) return [3 /*break*/, 5];
                            phoneNumber = validateAndFormatPhoneNumber(messageToBot);
                            if (!phoneNumber) return [3 /*break*/, 1];
                            chatDispatch({ type: Types.UPDATE_PHONE_NUMBER, payload: phoneNumber });
                            chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_REQUEST_CODE_CHECK });
                            return [3 /*break*/, 4];
                        case 1:
                            oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                            nextIndex = ++oldIndex;
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, PHONE_VALIDATION_ERROR_MESSAGE, nextIndex)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, WHAT_PHONE_NUMBER, ++nextIndex)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            // reset after processing
                            chatDispatch({ type: Types.PASS_MESSAGE_TO_BOT, payload: '' });
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        phoneNumberValidationHandler();
    }, [messageToBot]);
}
//# sourceMappingURL=usePhoneNumberValidation.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useCodeValidation.js
var useCodeValidation_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useCodeValidation_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





/**
 * Hook - this runs some validations on Guest inputs to the SmartChat.
 */
function useCodeValidation(state, chatDispatch) {
    var messages = state.messages, messageToBot = state.messageToBot, checkpoint = state.checkpoint;
    (0,react.useEffect)(function () {
        function codeValidationHandler() {
            return useCodeValidation_awaiter(this, void 0, void 0, function () {
                var inputCode, oldIndex;
                return useCodeValidation_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(messageToBot && checkpoint === SmartCheckpoint.ON_CODE_VALIDATION_CHECK)) return [3 /*break*/, 4];
                            inputCode = trim(messageToBot);
                            if (!/^\d{6}$/g.test(inputCode)) return [3 /*break*/, 1];
                            chatDispatch({ type: Types.HIDE_SEND_CODE_ACTION });
                            chatDispatch({ type: Types.HIDE_CHANGE_PHONE_ACTION });
                            // chatDispatch({ type: SmartChatTypes.CODE_VALIDATED, payload: inputCode });
                            chatDispatch({ type: Types.UPDATE_CODE, payload: inputCode });
                            chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_CODE_VERIFY_CHECK });
                            return [3 /*break*/, 3];
                        case 1:
                            oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, CODE_VERIFIED_ERROR_MESSAGE, ++oldIndex)];
                        case 2:
                            _a.sent();
                            chatDispatch({ type: Types.RESET_TIMEOUT });
                            _a.label = 3;
                        case 3:
                            // reset after processing
                            chatDispatch({ type: Types.PASS_MESSAGE_TO_BOT, payload: '' });
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        codeValidationHandler();
    }, [messageToBot]);
}
//# sourceMappingURL=useCodeValidation.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useTimeout.js


var useTimeout = function (debouncedChange, chatState, chatDispatch) {
    var showSendCodeAction = chatState.showSendCodeAction, showChangePhoneAction = chatState.showChangePhoneAction, timerValue = chatState.timerValue, checkpoint = chatState.checkpoint;
    // start the timer on phone number validation success.
    (0,react.useEffect)(function () {
        if (checkpoint === SmartCheckpoint.ON_CODE_VALIDATION_CHECK) {
            chatDispatch({ type: Types.START_TIMEOUT });
        }
    }, [checkpoint]);
    // stop the time when code is validated
    (0,react.useEffect)(function () {
        if (checkpoint === SmartCheckpoint.ON_FINAL_CHECK) {
            chatDispatch({ type: Types.IS_TIMEDOUT, payload: false }); // stop the timeout
        }
    }, [checkpoint]);
    // on every debouncedChange, reset the timeout
    (0,react.useEffect)(function () {
        if (checkpoint === SmartCheckpoint.ON_CODE_VALIDATION_CHECK && !(showSendCodeAction || showChangePhoneAction)) {
            // if timeout actions are already shown, then don't reset
            chatDispatch({ type: Types.RESET_TIMEOUT });
            chatDispatch({ type: Types.IS_TIMEDOUT, payload: false });
        }
    }, [debouncedChange]);
    // a timer, which ticks in every second.
    (0,react.useEffect)(function () {
        var timer = timerValue > 0 &&
            checkpoint === SmartCheckpoint.ON_CODE_VALIDATION_CHECK &&
            setInterval(function () { return chatDispatch({ type: Types.UPDATE_TIMEOUT }); }, 1000);
        if (timerValue === 0) {
            //  means it is timedout
            chatDispatch({ type: Types.IS_TIMEDOUT, payload: true });
        }
        return function () { return clearInterval(Number(timer)); };
    }, [timerValue]);
};
//# sourceMappingURL=useTimeout.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useOnTimeout.js
var useOnTimeout_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useOnTimeout_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




/**
 * This triggers when Guest timeout to interact with SmartChat.
 *
 * @param state
 * @param dispatch
 */
var useOnTimeout = function (state, dispatch) {
    var isTimedout = state.isTimedout, messages = state.messages;
    (0,react.useEffect)(function () {
        function callTimeoutMessage() {
            return useOnTimeout_awaiter(this, void 0, void 0, function () {
                var oldIndex;
                return useOnTimeout_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!isTimedout) return [3 /*break*/, 2];
                            oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                            return [4 /*yield*/, sendMessageWithTypingDecorator(dispatch, HAVE_NOT_RECEIVED_CODE, ++oldIndex)];
                        case 1:
                            _a.sent();
                            dispatch({ type: Types.SHOW_SEND_CODE_ACTION });
                            dispatch({ type: Types.SHOW_CHANGE_PHONE_ACTION });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        callTimeoutMessage();
    }, [isTimedout]);
};
//# sourceMappingURL=useOnTimeout.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useSendCodeAgain.js
var useSendCodeAgain_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useSendCodeAgain_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





/**
 * Hook - this trigers when a Guest requests for code again.
 */
var useSendCodeAgain = function (chatState, chatDispatch) {
    var messages = chatState.messages, checkpoint = chatState.checkpoint;
    (0,react.useEffect)(function () {
        function sendCodeAgainHandler() {
            return useSendCodeAgain_awaiter(this, void 0, void 0, function () {
                var oldIndex, nextIndex;
                return useSendCodeAgain_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(checkpoint === SmartCheckpoint.ON_CODE_RESEND_CHECK)) return [3 /*break*/, 2];
                            chatDispatch({ type: Types.HIDE_SEND_CODE_ACTION });
                            chatDispatch({ type: Types.HIDE_CHANGE_PHONE_ACTION });
                            oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                            nextIndex = ++oldIndex;
                            chatDispatch({
                                type: Types.NEW_MESSAGE,
                                payload: createGuestMessage(CUSTOMER_SAY_NOT_RECEIVED_CODE, nextIndex),
                            });
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, RESEND_CODE_MESSAGE, ++nextIndex)];
                        case 1:
                            _a.sent();
                            chatDispatch({ type: Types.UPDATE_CODE, payload: '' });
                            chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_CODE_VALIDATION_CHECK });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        sendCodeAgainHandler();
    }, [checkpoint]);
};
//# sourceMappingURL=useSendCodeAgain.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useChangePhone.js
var useChangePhone_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useChangePhone_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






/**
 * Hook - this trigers when a Guest requests for changing the phoneNumber.
 */
var useChangePhone = function (chatState, chatDispatch) {
    var messages = chatState.messages, checkpoint = chatState.checkpoint;
    (0,react.useEffect)(function () {
        var changePhoneNumberHandler = function () { return useChangePhone_awaiter(void 0, void 0, void 0, function () {
            var oldIndex, nextIndex;
            return useChangePhone_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(checkpoint === SmartCheckpoint.ON_CHANGE_PHONE_NUMBER_CHECK)) return [3 /*break*/, 3];
                        chatDispatch({ type: Types.HIDE_SEND_CODE_ACTION });
                        chatDispatch({ type: Types.HIDE_CHANGE_PHONE_ACTION });
                        chatDispatch({ type: Types.UPDATE_PHONE_NUMBER, payload: '' });
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_PHONE_NUMBER_VALIDATION_CHECK });
                        return [4 /*yield*/, sleep(500)];
                    case 1:
                        _a.sent();
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        nextIndex = ++oldIndex;
                        chatDispatch({
                            type: Types.NEW_MESSAGE,
                            payload: createGuestMessage(CUSTOMER_SAY_WRONG_PHONE, nextIndex),
                        });
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, CHANGE_PHONE_NUMBER, ++nextIndex)];
                    case 2:
                        _a.sent();
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_PHONE_NUMBER_VALIDATION_CHECK });
                        analytics({
                            event_name: types/* ChatEventName.PHONE_NUMBER_CHANGED */.Y.PHONE_NUMBER_CHANGED,
                            category: common/* EventCategory.CHAT */.Jk.CHAT,
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        changePhoneNumberHandler();
    }, [checkpoint]);
};
//# sourceMappingURL=useChangePhone.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useScrollToEnd.js
var useScrollToEnd_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useScrollToEnd_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var useScrollToEnd = function (messages, docElement) {
    var _a = (0,react.useState)(-1), lastMessageIndex = _a[0], setLastMessageIndex = _a[1];
    var scrollerHandler = function () { return useScrollToEnd_awaiter(void 0, void 0, void 0, function () {
        var lastMessage;
        return useScrollToEnd_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    lastMessage = messages.length > 0 && messages[messages.length - 1];
                    if (!(lastMessage && lastMessage.index !== lastMessageIndex)) return [3 /*break*/, 2];
                    if (!(docElement && docElement.current)) return [3 /*break*/, 2];
                    return [4 /*yield*/, sleep(1)];
                case 1:
                    _a.sent();
                    scrollToBottom(docElement.current);
                    setLastMessageIndex(lastMessage.index);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        scrollerHandler();
    }, [messages]);
};
//# sourceMappingURL=useScrollToEnd.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/states/actions/AuthActions/index.js
var AuthActions_Types;
(function (Types) {
    Types[Types["SEND_CODE"] = 0] = "SEND_CODE";
    Types[Types["VERIFY_CODE"] = 1] = "VERIFY_CODE";
    Types[Types["SENT_CODE"] = 2] = "SENT_CODE";
    Types[Types["VERIFIED_CODE"] = 3] = "VERIFIED_CODE";
    Types[Types["ERROR"] = 4] = "ERROR";
})(AuthActions_Types || (AuthActions_Types = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useCheckExistingCustomer.js
var useCheckExistingCustomer_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useCheckExistingCustomer_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var useCheckExistingCustomer = function (smartChatState, chatDispatch, authDispatch) {
    var checkpoint = smartChatState.checkpoint, phoneNumber = smartChatState.phoneNumber, messages = smartChatState.messages;
    var sendCode = (0,dist_esm/* useSession */.kP)().sendCode;
    var onException = useError().onException;
    // We get lost the SmartChat State once user is verified, so we need to track it via AnalyticsProvider.
    var setIsExistingCustomer = useChatAuthAnalytics().setIsExistingCustomer;
    function checkNewCustomer() {
        return useCheckExistingCustomer_awaiter(this, void 0, void 0, function () {
            var isExist, oldIndex, err_1, err_2;
            return useCheckExistingCustomer_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        isExist = false;
                        setIsExistingCustomer(isExist);
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        if (!isExist) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        authDispatch({ type: AuthActions_Types.SEND_CODE });
                        return [4 /*yield*/, sendCode(phoneNumber)];
                    case 2:
                        _a.sent();
                        authDispatch({ type: AuthActions_Types.SENT_CODE });
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, "".concat(PHONE_VALIDATION_SUCCESS_MESSAGE_2_WITHOUT_THANKS, " ").concat(formatPhone(phoneNumber)), ++oldIndex)];
                    case 3:
                        _a.sent();
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_CODE_VALIDATION_CHECK });
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        chatDispatch({ type: Types.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR });
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_ERROR_CHECK });
                        authDispatch({ type: AuthActions_Types.ERROR, payload: err_1 });
                        onException(new Error("@lendi/chat: SmartChat: unable to send code: ".concat(err_1)));
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 9];
                    case 6: 
                    // we retrieve the index of the previousMessage to calculate the index for next bot message.
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, PRIVACY_POLICY_MESSAGE, ++oldIndex)];
                    case 7:
                        // we retrieve the index of the previousMessage to calculate the index for next bot message.
                        _a.sent();
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, NEW_CUSTOMER_CHECK_MESSAGE, ++oldIndex)];
                    case 8:
                        _a.sent();
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_NAME_CHECK });
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        err_2 = _a.sent();
                        chatDispatch({ type: Types.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR }); // set the current checkpoint as previousCheckpoint on getting error
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_ERROR_CHECK });
                        chatDispatch({ type: Types.SHOW_FATAL_ERROR_PAGE });
                        onException(new Error("@lendi/chat: SmartChat: error captured while checking the existence of the provided phone number: ".concat(err_2)));
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    }
    (0,react.useEffect)(function () {
        if (checkpoint === SmartCheckpoint.ON_NEW_CUSTOMER_CHECK) {
            checkNewCustomer();
        }
    }, [checkpoint]);
};
//# sourceMappingURL=useCheckExistingCustomer.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useCustomerName.js
var useCustomerName_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useCustomerName_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var useCustomerName = function (chatState, chatDispatch) {
    var checkpoint = chatState.checkpoint, messageToBot = chatState.messageToBot, messages = chatState.messages;
    (0,react.useEffect)(function () {
        function thankYouNewCustomer() {
            return useCustomerName_awaiter(this, void 0, void 0, function () {
                var customerFirstName, oldIndex, nextIndex;
                return useCustomerName_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(messageToBot && checkpoint === SmartCheckpoint.ON_NAME_CHECK)) return [3 /*break*/, 3];
                            customerFirstName = trim(messageToBot);
                            chatDispatch({ type: Types.UPDATE_FIRST_NAME, payload: customerFirstName });
                            oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                            nextIndex = ++oldIndex;
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, "".concat(THANK_YOU_NAME_MESSAGE, " ").concat(customerFirstName, "."), nextIndex)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, WHAT_IS_EMAIL_ADDRESS, ++nextIndex)];
                        case 2:
                            _a.sent();
                            chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_EMAIL_VALIDATION_CHECK });
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        thankYouNewCustomer();
    }, [messageToBot]);
};
//# sourceMappingURL=useCustomerName.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useCustomerEmail.js
var useCustomerEmail_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useCustomerEmail_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var useCustomerEmail = function (chatState, chatDispatch, authDispatch) {
    var checkpoint = chatState.checkpoint, messageToBot = chatState.messageToBot, messages = chatState.messages, phoneNumber = chatState.phoneNumber;
    var sendCode = (0,dist_esm/* useSession */.kP)().sendCode;
    (0,react.useEffect)(function () {
        function emailValidationHandler() {
            return useCustomerEmail_awaiter(this, void 0, void 0, function () {
                var emailInput, oldIndex, nextIndex, err_1, oldIndex, nextIndex;
                return useCustomerEmail_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(messageToBot && checkpoint === SmartCheckpoint.ON_EMAIL_VALIDATION_CHECK)) return [3 /*break*/, 9];
                            emailInput = trim(messageToBot);
                            if (!emailInput.match(/^[^@\s]+@[^@\s]{2,}\.[^@\s]{2,}$/)) return [3 /*break*/, 6];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            chatDispatch({ type: Types.UPDATE_EMAIL, payload: emailInput });
                            authDispatch({ type: AuthActions_Types.SEND_CODE });
                            return [4 /*yield*/, sendCode(phoneNumber)];
                        case 2:
                            _a.sent();
                            authDispatch({ type: AuthActions_Types.SENT_CODE });
                            oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                            nextIndex = ++oldIndex;
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, "".concat(PHONE_VALIDATION_SUCCESS_MESSAGE_2, " ").concat(formatPhone(phoneNumber)), nextIndex)];
                        case 3:
                            _a.sent();
                            chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_CODE_VALIDATION_CHECK });
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _a.sent();
                            chatDispatch({ type: Types.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR });
                            authDispatch({ type: AuthActions_Types.ERROR, payload: err_1 });
                            chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_ERROR_CHECK });
                            return [3 /*break*/, 5];
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                            nextIndex = ++oldIndex;
                            return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, INVALID_EMAIL, nextIndex)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8:
                            chatDispatch({ type: Types.PASS_MESSAGE_TO_BOT, payload: '' });
                            _a.label = 9;
                        case 9: return [2 /*return*/];
                    }
                });
            });
        }
        emailValidationHandler();
    }, [messageToBot]);
};
//# sourceMappingURL=useCustomerEmail.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useRequestCode.js
var useRequestCode_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useRequestCode_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var useRequestCode = function (chatState, authDispatch, chatDispatch) {
    var phoneNumber = chatState.phoneNumber, checkpoint = chatState.checkpoint, messages = chatState.messages;
    var sendCode = (0,dist_esm/* useSession */.kP)().sendCode;
    function initiateRequestCode() {
        return useRequestCode_awaiter(this, void 0, void 0, function () {
            var oldIndex;
            return useRequestCode_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, PHONE_VALIDATION_SUCCESS_MESSAGE_1, ++oldIndex)];
                    case 1:
                        _a.sent();
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_NEW_CUSTOMER_CHECK });
                        return [2 /*return*/];
                }
            });
        });
    }
    function resendCode() {
        return useRequestCode_awaiter(this, void 0, void 0, function () {
            var oldIndex, err_1;
            return useRequestCode_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authDispatch({ type: AuthActions_Types.SEND_CODE });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, sendCode(phoneNumber)];
                    case 2:
                        _a.sent();
                        authDispatch({ type: AuthActions_Types.SENT_CODE });
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        // if existingCustomerCheck is already done (like if you request the code again, then no need to check for existingCustomerCheck, so skip the Name and email check and go to code validation,)
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, "".concat(PHONE_VALIDATION_SUCCESS_MESSAGE_2, " ").concat(formatPhone(phoneNumber)), ++oldIndex)];
                    case 3:
                        // if existingCustomerCheck is already done (like if you request the code again, then no need to check for existingCustomerCheck, so skip the Name and email check and go to code validation,)
                        _a.sent();
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_CODE_VALIDATION_CHECK });
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        chatDispatch({ type: Types.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR });
                        authDispatch({ type: AuthActions_Types.ERROR, payload: err_1 });
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_ERROR_CHECK });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    (0,react.useEffect)(function () {
        if (checkpoint === SmartCheckpoint.ON_REQUEST_CODE_CHECK) {
            initiateRequestCode();
        }
    }, [checkpoint]);
    (0,react.useEffect)(function () {
        if (checkpoint === SmartCheckpoint.ON_CODE_RESEND_CHECK) {
            resendCode();
        }
    }, [checkpoint]);
};
//# sourceMappingURL=useRequestCode.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useVerifyCode.js
var useVerifyCode_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useVerifyCode_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var useVerifyCode = function (chatState, authState, authDispatch, chatDispatch) {
    var code = chatState.code, phone = chatState.phoneNumber, messages = chatState.messages, checkpoint = chatState.checkpoint, email = chatState.email, firstName = chatState.firstName, leadId = chatState.leadId;
    var verifyCode = (0,dist_esm/* useSession */.kP)().verifyCode;
    var setAuthViaSmartChat = useChatAuthAnalytics().setAuthViaSmartChat;
    function verifyCodeHandler() {
        return useVerifyCode_awaiter(this, void 0, void 0, function () {
            var valid, oldIndex, err_1;
            return useVerifyCode_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(checkpoint === SmartCheckpoint.ON_CODE_VERIFY_CHECK)) return [3 /*break*/, 7];
                        authDispatch({ type: AuthActions_Types.VERIFY_CODE });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        setAuthViaSmartChat(true);
                        analytics({
                            event_name: types/* ChatEventName.OTP_ENTERED */.Y.OTP_ENTERED,
                            category: common/* EventCategory.CHAT */.Jk.CHAT,
                        });
                        return [4 /*yield*/, verifyCode({ phone: phone, code: code, email: email, leadId: leadId, firstName: firstName })];
                    case 2:
                        valid = (_a.sent()).valid;
                        if (!valid) return [3 /*break*/, 5];
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, CODE_VERIFIED_SUCCESS_MESSAGE, ++oldIndex)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, sleep(4000)];
                    case 4:
                        _a.sent();
                        authDispatch({ type: AuthActions_Types.VERIFIED_CODE, payload: true });
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_FINAL_CHECK });
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _a.sent();
                        chatDispatch({ type: Types.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR });
                        authDispatch({ type: AuthActions_Types.ERROR, payload: err_1 });
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_ERROR_CHECK });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    (0,react.useEffect)(function () {
        verifyCodeHandler();
    }, [checkpoint]);
};
//# sourceMappingURL=useVerifyCode.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useAuthError.js
var useAuthError_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useAuthError_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var useAuthError = function (chatState, authState, chatDispatch) {
    var error = authState.error;
    var messages = chatState.messages, checkpoint = chatState.checkpoint;
    var onException = useError().onException;
    function authErrorHandler() {
        return useAuthError_awaiter(this, void 0, void 0, function () {
            var oldIndex, _a;
            return useAuthError_generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(checkpoint === SmartCheckpoint.ON_ERROR_CHECK)) return [3 /*break*/, 11];
                        oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
                        _a = error.code;
                        switch (_a) {
                            case dist_esm/* ErrorCodes.ACCESS_DENIED */.SM.ACCESS_DENIED: return [3 /*break*/, 1];
                            case dist_esm/* ErrorCodes.TOO_MANY_ATTEMPTS */.SM.TOO_MANY_ATTEMPTS: return [3 /*break*/, 3];
                            case dist_esm/* ErrorCodes.BLOCKED_USER */.SM.BLOCKED_USER: return [3 /*break*/, 5];
                            case dist_esm/* ErrorCodes.NUMBER_NOT_WORKING */.SM.NUMBER_NOT_WORKING: return [3 /*break*/, 7];
                            case dist_esm/* ErrorCodes.GENERIC */.SM.GENERIC: return [3 /*break*/, 9];
                            case dist_esm/* ErrorCodes.SMS_PROVIDER_ERROR */.SM.SMS_PROVIDER_ERROR: return [3 /*break*/, 9];
                            case dist_esm/* ErrorCodes.PARSE_STATE */.SM.PARSE_STATE: return [3 /*break*/, 9];
                        }
                        return [3 /*break*/, 9];
                    case 1: // when code verification failed
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, CODE_VERIFIED_ERROR_MESSAGE, ++oldIndex)];
                    case 2:
                        _b.sent();
                        chatDispatch({ type: Types.NEXT_SMART_STATE, payload: SmartCheckpoint.ON_CODE_VALIDATION_CHECK });
                        return [3 /*break*/, 10];
                    case 3: // when user keep trying with incorrect code
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, TOO_MANY_ATTEMPTS_MESSAGE, ++oldIndex)];
                    case 4:
                        _b.sent();
                        // timeout actions
                        chatDispatch({ type: Types.SHOW_SEND_CODE_ACTION });
                        chatDispatch({ type: Types.SHOW_CHANGE_PHONE_ACTION });
                        return [3 /*break*/, 10];
                    case 5: // when a blocked user trying to access
                    return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, BLOCKED_USER_ERROR_MESSAGE, ++oldIndex)];
                    case 6:
                        _b.sent();
                        analytics({
                            event_name: types/* ChatEventName.CONTACT_US_SHOWN */.Y.CONTACT_US_SHOWN,
                            category: common/* EventCategory.CHAT */.Jk.CHAT,
                        });
                        chatDispatch({ type: Types.SHOW_CONTANT_US });
                        return [3 /*break*/, 10];
                    case 7: return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, NUMBER_NOT_WORKING, ++oldIndex)];
                    case 8:
                        _b.sent();
                        chatDispatch({ type: Types.SHOW_CHANGE_PHONE_ACTION });
                        return [3 /*break*/, 10];
                    case 9:
                        // show error page
                        chatDispatch({ type: Types.SHOW_FATAL_ERROR_PAGE });
                        return [3 /*break*/, 10];
                    case 10:
                        onException(new Error("@lendi/chat: SmartChat: error captured while interacting with @lendi/lala-react: ".concat(error.description)));
                        _b.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    }
    (0,react.useEffect)(function () {
        authErrorHandler();
    }, [checkpoint]);
};
//# sourceMappingURL=useAuthError.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/lendigroup-leads-library/dist/esm/index.js + 213 modules
var lendigroup_leads_library_dist_esm = __webpack_require__(45262);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/hooks/useLeads.js
var useLeads_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useLeads_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var useLeads = function (_a) {
    var phoneNumber = _a.phoneNumber, email = _a.email, firstName = _a.firstName, chatDispatch = _a.chatDispatch;
    var _b = (0,dist_esm/* useSession */.kP)(), environment = _b.environment, brand = _b.brand;
    var baseUrl = (0,lala_utils_dist_esm/* getAPIBaseURL */.K0)(environment);
    var onException = useError().onException;
    // leads with phone number
    (0,react.useEffect)(function () {
        var sendPhoneLeads = function () { return useLeads_awaiter(void 0, void 0, void 0, function () {
            var data, response, err_1;
            var _a, _b;
            return useLeads_generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!phoneNumber) return [3 /*break*/, 4];
                        data = {
                            generatedAt: new Date().toISOString(),
                            mobileNumber: phoneNumber,
                            origin: lendigroup_leads_library_dist_esm/* Origin.Chat */.aP.Chat,
                            brand: brand,
                            accountOrigin: window.location.href,
                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, lendigroup_leads_library_dist_esm/* LendiGroupLeads.sendLatestLead */.vA.sendLatestLead(baseUrl, data)];
                    case 2:
                        response = _c.sent();
                        response && chatDispatch({ type: Types.SAVE_LEADS, payload: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        onException(new Error("@lendi/chat: useLeads: Could not send phone leads for the customer: ".concat(err_1)));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendPhoneLeads();
    }, [phoneNumber]);
    // TODO: there is no benefit of sending it as leads ignore subsequent leads, may be need to revist this
    // leads with phone number, firstname
    (0,react.useEffect)(function () {
        var sendFirstNameLeads = function () { return useLeads_awaiter(void 0, void 0, void 0, function () {
            var data, err_2;
            return useLeads_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!firstName) return [3 /*break*/, 4];
                        data = {
                            generatedAt: new Date().toISOString(),
                            firstName: firstName,
                            mobileNumber: phoneNumber,
                            origin: lendigroup_leads_library_dist_esm/* Origin.Chat */.aP.Chat,
                            brand: brand,
                            accountOrigin: window.location.href,
                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, lendigroup_leads_library_dist_esm/* LendiGroupLeads.sendLatestLead */.vA.sendLatestLead(baseUrl, data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        onException(new Error("@lendi/chat: useLeads: Could not send firstName 'leads' for the customer: ".concat(err_2)));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendFirstNameLeads();
    }, [firstName]);
    // TODO: there is no benefit of sending it as leads ignore subsequent leads, may be need to revist this
    // leads with phone number, firstname and email
    (0,react.useEffect)(function () {
        var sendEmailLeads = function () { return useLeads_awaiter(void 0, void 0, void 0, function () {
            var data, err_3;
            return useLeads_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!email) return [3 /*break*/, 4];
                        data = {
                            generatedAt: new Date().toISOString(),
                            firstName: firstName,
                            email: email,
                            mobileNumber: phoneNumber,
                            origin: lendigroup_leads_library_dist_esm/* Origin.Chat */.aP.Chat,
                            brand: brand,
                            accountOrigin: window.location.href,
                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, lendigroup_leads_library_dist_esm/* LendiGroupLeads.sendLatestLead */.vA.sendLatestLead(baseUrl, data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        onException(new Error("@lendi/chat: useLeads: Could not send email leads for the customer: ".concat(err_3)));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendEmailLeads();
    }, [email]);
};
//# sourceMappingURL=useLeads.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/MoreActions/style.js
var MoreActions_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledButton = styled_components_browser_esm/* default.button */.ZP.button(MoreActions_style_templateObject_1 || (MoreActions_style_templateObject_1 = MoreActions_style_makeTemplateObject(["\n  ", ";\n  ", ";\n  ", "\n  background-color: transparent;\n  ", "\n  ", "\n  border-radius: 5px;\n  border: 2px solid ", ";\n  font-weight: bold;\n  cursor: pointer;\n"], ["\n  ", ";\n  ", ";\n  ", "\n  background-color: transparent;\n  ", "\n  ", "\n  border-radius: 5px;\n  border: 2px solid ", ";\n  font-weight: bold;\n  cursor: pointer;\n"])), (0,spacing_esm.ml)('lg'), (0,spacing_esm.mb)('xxs'), (0,color_esm.fg)('shade.700'), (0,spacing_esm.px)('xs'), (0,spacing_esm.py)('xxs'), (0,color_esm/* color */.$)('shade.300'));
var MoreActions_style_templateObject_1;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/MoreActions/changePhoneAction/index.js


var ChangePhoneAction = function (_a) {
    var onPhoneChange = _a.onPhoneChange;
    return (react.createElement(StyledButton, { type: "button", onClick: onPhoneChange }, "Change mobile phone number"));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/MoreActions/contactUs/index.js


var ContactUs = function () {
    return (react.createElement("a", { href: "/contactus", target: "_blank" },
        react.createElement(StyledButton, { type: "button" }, "Contact Us")));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/MoreActions/sendCodeAction/index.js


var SendCodeAction = function (_a) {
    var onSendAgain = _a.onSendAgain;
    return (react.createElement(StyledButton, { type: "button", onClick: onSendAgain }, "Send again"));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/states/state/index.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};




var initialSmartChatState = {
    messages: chatMessage(WELCOME_TEXT),
    members: __spreadArray([], smartChatMembers, true),
    isTimedout: false,
    timerValue: -1,
    messageToBot: '',
    phoneNumber: '',
    code: '',
    email: '',
    firstName: '',
    checkpoint: SmartCheckpoint.ON_PHONE_NUMBER_VALIDATION_CHECK,
    previousCheckpoint: SmartCheckpoint.ON_PHONE_NUMBER_VALIDATION_CHECK,
    experimentCheckpoint: SmartExperimentCheckpoint.ON_SIGN_IN_CHECK,
    isFatalError: false,
    contactUs: false,
    showSendCodeAction: false,
    showChangePhoneAction: false,
    leadId: undefined,
    signInSubmitted: false,
    startStepButtonClicked: false,
};
var initialAuthState = {
    status: dist_esm/* Status.Unauthenticated */.qb.Unauthenticated,
    sendingCode: false,
    verifyingCode: false,
    verifiedCode: false,
    error: null,
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/states/reducers/SmartChatReducer/index.js
var SmartChatReducer_assign = (undefined && undefined.__assign) || function () {
    SmartChatReducer_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return SmartChatReducer_assign.apply(this, arguments);
};
var SmartChatReducer_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};



var smartChatReducer = function (state, action) {
    if (state === void 0) { state = initialSmartChatState; }
    switch (action.type) {
        case Types.NEW_MESSAGE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { messages: SmartChatReducer_spreadArray(SmartChatReducer_spreadArray([], state.messages, true), [action.payload], false) });
        case Types.CLEAR_MESSAGE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { messages: [action.payload] });
        case Types.RESET_MESSAGE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { messages: [] });
        case Types.PASS_MESSAGE_TO_BOT:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { messageToBot: action.payload });
        case Types.UPDATE_PHONE_NUMBER:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { phoneNumber: action.payload });
        case Types.UPDATE_EMAIL:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { email: action.payload });
        case Types.UPDATE_FIRST_NAME:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { firstName: action.payload });
        case Types.UPDATE_CODE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { code: action.payload });
        case Types.IS_TIMEDOUT:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { isTimedout: action.payload });
        case Types.START_TIMEOUT:
        case Types.RESET_TIMEOUT:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { timerValue: TIMEOUT_VALUE });
        case Types.UPDATE_TIMEOUT:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { timerValue: state.timerValue - 1 });
        case Types.START_BOT_TYPING:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { members: state.members.map(function (member) {
                    return member.identity === BOT_IDENTITY ? SmartChatReducer_assign(SmartChatReducer_assign({}, member), { isTyping: true }) : member;
                }) });
        case Types.STOP_BOT_TYPING:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { members: state.members.map(function (member) {
                    return member.identity === BOT_IDENTITY ? SmartChatReducer_assign(SmartChatReducer_assign({}, member), { isTyping: false }) : member;
                }) });
        case Types.SHOW_SEND_CODE_ACTION:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { showSendCodeAction: true, isTimedout: false });
        case Types.HIDE_SEND_CODE_ACTION:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { showSendCodeAction: false });
        case Types.SHOW_CHANGE_PHONE_ACTION:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { showChangePhoneAction: true, isTimedout: false });
        case Types.HIDE_CHANGE_PHONE_ACTION:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { showChangePhoneAction: false });
        case Types.SHOW_CONTANT_US:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { contactUs: true });
        case Types.HIDE_CONTANT_US:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { contactUs: false });
        case Types.NEXT_SMART_STATE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { checkpoint: action.payload });
        case Types.NEXT_EXPERIMENT_ONE_SMART_STATE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { experimentCheckpoint: action.payload });
        case Types.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { previousCheckpoint: state.checkpoint });
        case Types.SHOW_FATAL_ERROR_PAGE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { isFatalError: true });
        case Types.HIDE_FATAL_ERROR_PAGE:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { isFatalError: false });
        case Types.SAVE_LEADS:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { leadId: action.payload });
        case Types.SIGN_IN_SUBMITTED:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { signInSubmitted: action.payload });
        case Types.START_STEP_BUTTON_CLICKED:
            return SmartChatReducer_assign(SmartChatReducer_assign({}, state), { startStepButtonClicked: action.payload });
        default:
            return state;
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/states/reducers/AuthReducer/index.js
var AuthReducer_assign = (undefined && undefined.__assign) || function () {
    AuthReducer_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return AuthReducer_assign.apply(this, arguments);
};


var authReducer = function (state, action) {
    if (state === void 0) { state = initialAuthState; }
    switch (action.type) {
        case AuthActions_Types.SEND_CODE:
            return AuthReducer_assign(AuthReducer_assign({}, state), { sendingCode: true });
        case AuthActions_Types.SENT_CODE:
            return AuthReducer_assign(AuthReducer_assign({}, state), { sendingCode: false });
        case AuthActions_Types.VERIFY_CODE:
            return AuthReducer_assign(AuthReducer_assign({}, state), { verifyingCode: true });
        case AuthActions_Types.VERIFIED_CODE:
            return AuthReducer_assign(AuthReducer_assign({}, state), { verifyingCode: false, verifiedCode: action.payload });
        case AuthActions_Types.ERROR:
            return AuthReducer_assign(AuthReducer_assign({}, state), { error: action.payload });
        default:
            return AuthReducer_assign({}, state);
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChat/index.js
















var SmartChat = function () {
    var _a = react.useReducer(smartChatReducer, initialSmartChatState), chatState = _a[0], chatDispatch = _a[1];
    var _b = react.useReducer(authReducer, initialAuthState), authState = _b[0], authDispatch = _b[1];
    var _c = react.useState(''), messageToSend = _c[0], setMessageToSend = _c[1];
    var authViaSmartChat = useChatAuthAnalytics().authViaSmartChat;
    var messages = chatState.messages, members = chatState.members, isFatalError = chatState.isFatalError, previousCheckpoint = chatState.previousCheckpoint, contactUs = chatState.contactUs, phoneNumber = chatState.phoneNumber, email = chatState.email, firstName = chatState.firstName, showSendCodeAction = chatState.showSendCodeAction, showChangePhoneAction = chatState.showChangePhoneAction;
    var displayRefTheOther = react.useRef(null);
    var debouncedChange = useDebounce(messageToSend, 500);
    // front end validation hooks on every Guest inputs to SmartChat
    // hook for validating phone number
    usePhoneNumberValidation(chatState, chatDispatch);
    // hook for validating code
    useCodeValidation(chatState, chatDispatch);
    useTimeout(debouncedChange, chatState, chatDispatch);
    // onTimeout hook - to send messages with updated message when Guest timeout the interaction
    useOnTimeout(chatState, chatDispatch);
    // action hook if Guest request to send code again
    useSendCodeAgain(chatState, chatDispatch);
    // action hook if Guest request to change phoneNumber
    useChangePhone(chatState, chatDispatch);
    // hook to take scroller to the last new message
    useScrollToEnd(messages, displayRefTheOther);
    useCheckExistingCustomer(chatState, chatDispatch, authDispatch);
    // hook to take customer fisrtname
    useCustomerName(chatState, chatDispatch);
    // hook to take customer email
    useCustomerEmail(chatState, chatDispatch, authDispatch);
    // chat open tracking
    useChatOpenTracking(authViaSmartChat);
    // LALA hooks
    // hook request code to Auth0
    useRequestCode(chatState, authDispatch, chatDispatch);
    // hook verify code to Auth0
    useVerifyCode(chatState, authState, authDispatch, chatDispatch);
    // hook on getting any auth0 error
    useAuthError(chatState, authState, chatDispatch);
    // hook to track smart analytics
    useSmartChatTracking(phoneNumber, email, firstName);
    // leads data
    useLeads({ phoneNumber: phoneNumber, email: email, firstName: firstName, chatDispatch: chatDispatch });
    var send = function () {
        if (!messageToSend) {
            return;
        }
        // if timeout actions are already displayed, just hide them always on sending new message.
        chatDispatch({ type: Types.HIDE_SEND_CODE_ACTION });
        chatDispatch({ type: Types.HIDE_CHANGE_PHONE_ACTION });
        var oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
        // pass message as Guest customer
        chatDispatch({ type: Types.NEW_MESSAGE, payload: createGuestMessage(messageToSend, ++oldIndex) });
        // pass message to Bot for processing
        chatDispatch({ type: Types.PASS_MESSAGE_TO_BOT, payload: messageToSend });
        setMessageToSend('');
    };
    var onKeyDown = function (e) {
        if (e.key === 'Enter') {
            send();
            var customEnterPushedEvent = {
                event_name: 'Return Pressed',
                category: common/* EventCategory.CHAT */.Jk.CHAT,
                inputElement: 'message input area',
                noOfCharacters: messageToSend.length,
            };
            analytics(customEnterPushedEvent);
            e.preventDefault();
        }
    };
    return (react.createElement(react.Fragment, null, isFatalError ? (react.createElement(FatalError, { onRetry: function () {
            chatDispatch({ type: Types.NEXT_SMART_STATE, payload: previousCheckpoint });
            chatDispatch({ type: Types.HIDE_FATAL_ERROR_PAGE });
        } })) : (react.createElement(react.Fragment, null,
        react.createElement(ChatHeader, { activePanel: ChatPanels.Default, showBackArrow: true }),
        react.createElement(style_MessageListWrapper, null,
            react.createElement(react.Fragment, null,
                react.createElement("div", null,
                    react.createElement(ChatComponent_MessageList, { identity: GUEST_IDENTITY, members: members, messages: messages, userType: 'customer' }),
                    showSendCodeAction && (react.createElement(SendCodeAction, { onSendAgain: function () {
                            return chatDispatch({
                                type: Types.NEXT_SMART_STATE,
                                payload: SmartCheckpoint.ON_CODE_RESEND_CHECK,
                            });
                        } })),
                    showChangePhoneAction && (react.createElement(ChangePhoneAction, { onPhoneChange: function () {
                            return chatDispatch({
                                type: Types.NEXT_SMART_STATE,
                                payload: SmartCheckpoint.ON_CHANGE_PHONE_NUMBER_CHECK,
                            });
                        } })),
                    contactUs && react.createElement(ContactUs, null),
                    react.createElement("div", { ref: displayRefTheOther })))),
        react.createElement(ChatInput, { value: messageToSend, onChange: function (e) { return setMessageToSend(e.target.value); }, send: send, onKeyDown: onKeyDown, userType: "customer" })))));
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(23712);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/Loader/style.js
var Loader_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var SpinnerLoaderWrapper = styled_components_browser_esm/* default.div */.ZP.div(Loader_style_templateObject_1 || (Loader_style_templateObject_1 = Loader_style_makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  min-width: 325px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  min-width: 325px;\n"])));
var StyledSpinner = (0,styled_components_browser_esm/* default */.ZP)(spinner_esm/* default */.Z)(Loader_style_templateObject_2 || (Loader_style_templateObject_2 = Loader_style_makeTemplateObject(["\n  width: 3em;\n  height: 3em;\n"], ["\n  width: 3em;\n  height: 3em;\n"])));
var LendiLogoSvgWrapper = styled_components_browser_esm/* default.svg */.ZP.svg(Loader_style_templateObject_3 || (Loader_style_templateObject_3 = Loader_style_makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n"])), (0,utils_esm/* deriveSize */.MS)(7), (0,utils_esm/* deriveSize */.MS)(7));
var LendiLogoPathWrapper = styled_components_browser_esm/* default.path */.ZP.path(Loader_style_templateObject_4 || (Loader_style_templateObject_4 = Loader_style_makeTemplateObject(["\n  fill: none;\n  stroke: ", ";\n  stroke-miterlimit: 10;\n  stroke-width: 18px;\n  stroke-linecap: round;\n  stroke-dasharray: 377;\n  stroke-dashoffset: 297;\n  animation: dash 3s linear infinite;\n\n  @keyframes dash {\n    0% {\n      stroke-dashoffset: 297;\n    }\n    50% {\n      stroke-dashoffset: 0;\n    }\n    100% {\n      stroke-dashoffset: -457;\n    }\n  }\n"], ["\n  fill: none;\n  stroke: ", ";\n  stroke-miterlimit: 10;\n  stroke-width: 18px;\n  stroke-linecap: round;\n  stroke-dasharray: 377;\n  stroke-dashoffset: 297;\n  animation: dash 3s linear infinite;\n\n  @keyframes dash {\n    0% {\n      stroke-dashoffset: 297;\n    }\n    50% {\n      stroke-dashoffset: 0;\n    }\n    100% {\n      stroke-dashoffset: -457;\n    }\n  }\n"])), (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'));
var StyledTransitionLoader = styled_components_browser_esm/* default.div */.ZP.div(Loader_style_templateObject_5 || (Loader_style_templateObject_5 = Loader_style_makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n"])));
var LoaderWrapper = styled_components_browser_esm/* default.div */.ZP.div(Loader_style_templateObject_6 || (Loader_style_templateObject_6 = Loader_style_makeTemplateObject(["\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var StyledBody = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(style_templateObject_7 || (style_templateObject_7 = Loader_style_makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var Loader_style_templateObject_1, Loader_style_templateObject_2, Loader_style_templateObject_3, Loader_style_templateObject_4, Loader_style_templateObject_5, Loader_style_templateObject_6, style_templateObject_7;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/Loader/index.js


// this is used when we are fetching user-group(channel) from chat-service
var SpinnerLoader = function () { return (react.createElement(SpinnerLoaderWrapper, null,
    react.createElement(StyledSpinner, { variant: "dark" }))); };
// this is specifically used when we are creating connection with twilio and fetching chat messages
// Copied from LUI: because https://lendi.design/packages/auth-loader/example/AuthLoader does have a hardcoded underlying message, it needs to be customized.
var TransitionLoader = function (_a) {
    var transitionMessage = _a.transitionMessage;
    return (react.createElement(LoaderWrapper, null,
        react.createElement(StyledTransitionLoader, null,
            react.createElement(LendiLogoSvgWrapper, { viewBox: "0 0 120 120" },
                react.createElement(LendiLogoPathWrapper, { d: "M100.456,98.513h-43.3V70.057H53.582V98.513H10.28A1.28,1.28,0,0,1,9,97.233V40.059a1.281,1.281,0,0,1,.583-1.074L55.5,9.206a1.281,1.281,0,0,1,1.409.011l44.265,29.65a1.28,1.28,0,0,1,.567,1.063v57.3A1.28,1.28,0,0,1,100.456,98.513Z" })),
            react.createElement(StyledBody, { size: "lg", color: "shade.700", mt: "lg", mx: "lg" }, transitionMessage))));
};
/* harmony default export */ var Loader = (SpinnerLoader);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/RestrictedTeamViewChat/index.js








var RestrictedTeamViewChat = function (_a) {
    var _b;
    var _c = _a.restrictedViewResponse, messages = _c.messages, nextPage = _c.nextPage, fetchNextPage = _a.fetchNextPage, restrictedViewLoading = _a.restrictedViewLoading;
    var session = (0,dist_esm/* useSession */.kP)();
    var displayRef = react.useRef(null);
    var scrollToBottom = function () {
        if (displayRef && displayRef.current && displayRef.current.scrollIntoView) {
            displayRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
        }
    };
    react.useEffect(scrollToBottom, []);
    var hasMoreItems = nextPage.pageNumber !== null;
    useChatOpenTracking(false);
    return restrictedViewLoading ? (react.createElement(Loader, null)) : (react.createElement(react.Fragment, null,
        react.createElement(style_MessageListWrapper, null,
            react.createElement((react_infinite_scroller_default()), { pageStart: 0, loadMore: fetchNextPage, hasMore: hasMoreItems, isReverse: true, initialLoad: false, useWindow: false },
                react.createElement(ChatComponent_MessageList, { identity: (_b = session === null || session === void 0 ? void 0 : session.identity) === null || _b === void 0 ? void 0 : _b.id, members: [], messages: messages, userType: 'broker' }),
                react.createElement("div", { ref: displayRef }))),
        react.createElement(ChatInput, { value: "You are not the member of this channel, so you can't communicate.", disabledSend: true, disabledTextArea: true, send: function () { }, onKeyDown: function () { }, onChange: function () { }, userType: "broker" })));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/RestrictedTeamViewProvider/context.js

var RestrictedTeamViewContext = react.createContext(undefined);
var useRestrictedTeamView = function () {
    var restrictedTeamViewState = react.useContext(RestrictedTeamViewContext);
    if (!restrictedTeamViewState) {
        // eslint-disable-next-line no-console
        console.warn('Please setup <RestrictedTeamViewProvider /> as a parent component, before using useRestrictedTeamView() otherwise you will get default RestrictedTeamViewState');
        return {
            restrictedViewResponse: undefined,
            teamRestrictedView: false,
            restrictedViewLoading: false,
            fetchNextPage: undefined,
        };
    }
    return restrictedTeamViewState;
};
//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useActivateUserGroup/activateUserGroup/index.js
var activateUserGroup_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var activateUserGroup_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/**
 * activateUserGroup will make an API call to `chat-service` to activate user-group
 *
 * token:   Twilio Access Token using user's Lendi Session Token
 * identity: Current User's Twilio User Identity
 *
 * @since 9.0.0
 *
 * @param userGroupHash           Customer's selected applicationId from Dashboard
 * @param session           Customer's selected applicationId from Dashboard
 */
var activateUserGroup = function (userGroupHash, session) { return activateUserGroup_awaiter(void 0, void 0, void 0, function () {
    var requestURL;
    return activateUserGroup_generator(this, function (_a) {
        requestURL = "/v2/chat/activate/".concat(userGroupHash);
        return [2 /*return*/, activateUserGroupRequest(requestURL, session)];
    });
}); };
var activateUserGroup_config = function (session) { return ({
    baseURL: (0,lala_utils_dist_esm/* getAPIBaseURL */.K0)(session.environment),
    headers: {
        Authorization: "Bearer ".concat(session.token),
        'Content-Type': 'application/json',
    },
}); };
var activateUserGroupRequest = function (requestURL, session) { return activateUserGroup_awaiter(void 0, void 0, void 0, function () {
    var _a, status, data, _b, accessToken, identity;
    return activateUserGroup_generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, axios/* default.get */.Z.get(requestURL, activateUserGroup_config(session))];
            case 1:
                _a = _c.sent(), status = _a.status, data = _a.data;
                if (status === 200) {
                    _b = data.data, accessToken = _b.token, identity = _b.identity;
                    if (!accessToken) {
                        throw new Error('activateUserGroupRequest: accessToken is null. (Likely inconsistent response from chat-service)');
                    }
                    if (!identity) {
                        throw new Error('activateUserGroupRequest: identity is null. (Likely inconsistent response from chat-service)');
                    }
                    return [2 /*return*/, { accessToken: accessToken, identity: identity }];
                }
                else {
                    throw new Error("activateUserGroup: unable to activateUserGroupRequest");
                }
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useActivateUserGroup/index.js
var useActivateUserGroup_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useActivateUserGroup_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var useActivateUserGroup = function (openChat, session, channelId) {
    var _a = (0,react.useState)(), identity = _a[0], setIdentity = _a[1];
    var _b = (0,react.useState)(), accessToken = _b[0], setAccessToken = _b[1];
    var _c = (0,react.useState)(true), shouldActivateChat = _c[0], setShouldActivateChat = _c[1];
    var onException = useError().onException;
    (0,react.useEffect)(function () {
        if (openChat && channelId && shouldActivateChat) {
            var activate = function () { return useActivateUserGroup_awaiter(void 0, void 0, void 0, function () {
                var _a, accessToken_1, identity_1, e_1;
                return useActivateUserGroup_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, activateUserGroup(channelId, session)];
                        case 1:
                            _a = _b.sent(), accessToken_1 = _a.accessToken, identity_1 = _a.identity;
                            setIdentity(identity_1);
                            setAccessToken(accessToken_1);
                            setShouldActivateChat(false);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _b.sent();
                            onException(new Error("@lendi/chat: unable to activate userGroup: ".concat(e_1)));
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            activate();
        }
    }, [openChat, channelId, shouldActivateChat]);
    return [identity, accessToken];
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatExposureProvider/index.js

// Context to expose chat data like online stats and unread notification to the parent components.
var ChatDataExposureContext = (0,react.createContext)(undefined);
var useChatDataExposureContext = function () {
    var context = (0,react.useContext)(ChatDataExposureContext);
    if (!context) {
        throw new Error('Chat status Context cannot be rendered outside the Navigation component');
    }
    return context;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatExposureProvider/ChatDataExposer/index.js



/**
 * This component intent to provide online status and read notification out of the box so that <ChatProvider> can be given at the deep level where it is required.
 * And if anything else is needed from `useChat`, those are getting exposed via this component.
 */
var ChatDataExposer = function (_a) {
    var _b, _c;
    var children = _a.children, userType = _a.userType;
    var _d = useChat(), hasNew = _d.hasNew, members = _d.members;
    // TODO: will this work when it is run as Team view
    var isOtherUserOnline;
    if (userType === 'customer') {
        isOtherUserOnline = ((_b = members.find(function (member) { return member.type === LendiMemberType.TEAM; })) === null || _b === void 0 ? void 0 : _b.isOnline) || false;
    }
    else if (userType === 'broker') {
        isOtherUserOnline = ((_c = members.find(function (member) { return member.type === LendiMemberType.CUSTOMER; })) === null || _c === void 0 ? void 0 : _c.isOnline) || false;
    }
    else {
        isOtherUserOnline = false;
    }
    var _e = useChatDataExposureContext(), setStatus = _e.setStatus, setHasUnReadMessage = _e.setHasUnReadMessage;
    react.useEffect(function () {
        setStatus && setStatus(isOtherUserOnline);
    }, [isOtherUserOnline]);
    react.useEffect(function () {
        setHasUnReadMessage && setHasUnReadMessage(hasNew);
    }, [hasNew]);
    return react.createElement(react.Fragment, null, children);
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@twilio/conversations/builds/browser.js
var browser = __webpack_require__(80588);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/apis/refreshAccessToken/index.js
var refreshAccessToken_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var refreshAccessToken_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var refreshAccessToken_config = function (url, token) { return ({
    baseURL: url,
    headers: {
        Authorization: "Bearer ".concat(token),
        'Content-Type': 'application/json',
    },
}); };
var refreshAccessToken = function (lendiAuthToken, apiBaseurl, channelId) { return refreshAccessToken_awaiter(void 0, void 0, void 0, function () {
    var accessToken, userIdentity, _a, status, data, _b, token, identity;
    return refreshAccessToken_generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (apiBaseurl === '') {
                    throw new Error('apiBaseurl cannot be empty');
                }
                accessToken = undefined;
                userIdentity = undefined;
                return [4 /*yield*/, axios/* default.get */.Z.get("".concat(apiBaseurl, "/v2/chat/refresh-token/").concat(channelId), refreshAccessToken_config(apiBaseurl, lendiAuthToken))];
            case 1:
                _a = _c.sent(), status = _a.status, data = _a.data;
                if (status === 200) {
                    _b = data.data, token = _b.token, identity = _b.identity;
                    if (!token) {
                        throw new Error('refreshToken: accessToken is null. (Likely inconsistent response from chat-service)');
                    }
                    if (!identity) {
                        throw new Error('refreshToken: userIdentity is null. (Likely inconsistent response from chat-service)');
                    }
                    if (!token || !identity) {
                        throw new Error('refreshToken: token or identity is undefined. (Likely inconsistent response from chat-service)');
                    }
                    accessToken = token;
                    userIdentity = identity;
                }
                else {
                    throw new Error("refreshToken: failed to call refresh-token endpoint");
                }
                return [2 /*return*/, { accessToken: accessToken, userIdentity: userIdentity }];
        }
    });
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/actions/TwilioActions.js
var TwilioActions_Types;
(function (Types) {
    Types["UPDATE_CLIENT"] = "UPDATE_CLIENT";
    Types["UPDATE_ACCESS_TOKEN"] = "UPDATE_ACCESS_TOKEN";
})(TwilioActions_Types || (TwilioActions_Types = {}));
//# sourceMappingURL=TwilioActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/actions/ChannelActions.js
var ChannelActions_Types;
(function (Types) {
    Types["UPDATE_CHANNEL_ID"] = "UPDATE_CHANNEL_ID";
    Types["UPDATE_CHANNEL"] = "UPDATE_CHANNEL";
    Types["RETRY_FETCH"] = "RETRY_FETCH";
})(ChannelActions_Types || (ChannelActions_Types = {}));
//# sourceMappingURL=ChannelActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/actions/MessageActions.js
var MessageActions_Types;
(function (Types) {
    Types["UPDATE_MESSAGES"] = "UPDATE_MESSAGES";
    Types["NEW_MESSAGE"] = "NEW_MESSAGE";
    Types["UDPATE_HAS_NEW"] = "UDPATE_HAS_NEW";
    Types["UPDATE_FETCH_MORE_METHOD"] = "UPDATE_FETCH_MORE_METHOD";
    Types["UPDATE_FETCH_MORE_MESSAGES"] = "UPDATE_FETCH_MORE_MESSAGES";
    Types["UPDATE_MARK_READ_METHOD"] = "UPDATE_MARK_READ_METHOD";
    Types["UPDATE_HAS_MORE"] = "UPDATE_HAS_MORE";
    Types["RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE"] = "RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE";
})(MessageActions_Types || (MessageActions_Types = {}));
//# sourceMappingURL=MessageActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/actions/MemberActions.js
var MemberActions_Types;
(function (Types) {
    Types["UPDATE_IDENTITY"] = "UPDATE_IDENTITY";
    Types["UPDATE_RECIPIENT_ID"] = "UPDATE_RECIPIENT_ID";
    Types["UPDATE_MEMBERS"] = "UPDATE_MEMBERS";
    Types["UPDATE_OTHER_USER_STATUS"] = "UPDATE_OTHER_USER_STATUS";
    Types["TYPING_STARTED"] = "TYPING_STARTED";
    Types["TYPING_ENDED"] = "TYPING_ENDED";
})(MemberActions_Types || (MemberActions_Types = {}));
//# sourceMappingURL=MemberActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/actions/UserActions.js
var UserActions_Types;
(function (Types) {
    Types["UPDATE_FETCH_MORE_STATUS"] = "UPDATE_FETCH_MORE_STATUS";
})(UserActions_Types || (UserActions_Types = {}));
//# sourceMappingURL=UserActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/actions/OtherActions.js
var OtherActions_Types;
(function (Types) {
    Types["UPDATE_ERROR"] = "UPDATE_ERROR";
    Types["UPDATE_CHAT_ENABLED"] = "UPDATE_CHAT_ENABLED";
    Types["LOADING"] = "LOADING";
    Types["START_BOT_TYPING"] = "START_BOT_TYPING";
    Types["STOP_BOT_TYPING"] = "STOP_BOT_TYPING";
})(OtherActions_Types || (OtherActions_Types = {}));
//# sourceMappingURL=OtherActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/actions/Types.js
var Types_assign = (undefined && undefined.__assign) || function () {
    Types_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Types_assign.apply(this, arguments);
};






var Types_Types = Types_assign(Types_assign(Types_assign(Types_assign(Types_assign(Types_assign({}, TwilioActions_Types), ChannelActions_Types), MessageActions_Types), MemberActions_Types), UserActions_Types), OtherActions_Types);
//# sourceMappingURL=Types.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useConversations/useConversationSDK/useClient/index.js
var useClient_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useClient_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




/**
 * `useClient` hook can be used to create a Twilio Conversation SDK client
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
function useClient(chatState, dispatch, sessionToken, apiBaseurl) {
    var _this = this;
    var client = chatState.client, accessToken = chatState.accessToken, channelId = chatState.channelId;
    // Whenever user accessToken is updated, we wish to either
    // 1. Create client
    // 2. Update client
    // 3. Remove client
    (0,react.useEffect)(function () {
        var getClientAsync = function (accessToken) { return useClient_awaiter(_this, void 0, void 0, function () {
            var client;
            var _this = this;
            return useClient_generator(this, function (_a) {
                client = new browser/* Client */.KU(accessToken);
                client.on('initFailed', function (_a) {
                    var error = _a.error;
                    throw new Error("@lendi/chat: useClient: Conversation Connection error object: %c".concat(JSON.stringify(error, undefined, 2)));
                });
                // when an access token is in its final three minutes, the token about to expire event is triggered
                client.on('tokenAboutToExpire', function () { return useClient_awaiter(_this, void 0, void 0, function () {
                    var accessToken;
                    return useClient_generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, refreshAccessToken(sessionToken, apiBaseurl, channelId)];
                            case 1:
                                accessToken = (_a.sent()).accessToken;
                                // Once we receive the latest Twilio accessToken, we can dispatch it to chatState, which would in turn trigger updateToken() method from above.
                                dispatch({ type: Types_Types.UPDATE_ACCESS_TOKEN, payload: accessToken });
                                return [2 /*return*/];
                        }
                    });
                }); });
                // eslint-disable-next-line no-console
                console.log('Conversation client');
                dispatch({
                    type: Types_Types.UPDATE_CLIENT,
                    payload: client,
                });
                return [2 /*return*/];
            });
        }); };
        if (accessToken) {
            dispatch({
                type: Types_Types.LOADING,
                payload: true,
            });
            if (client) {
                // Twilio Client already initiated, only update AccessToken
                client.updateToken(accessToken); // TODO: Error Handling
            }
            else {
                getClientAsync(accessToken); // TODO: Error Handling
            }
            dispatch({
                type: Types_Types.LOADING,
                payload: false,
            });
        }
        else {
            // Access Token was removed
            dispatch({
                type: Types_Types.UPDATE_CLIENT,
                payload: undefined,
            });
        }
    }, [accessToken]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useConversations/useConversationSDK/useChannel/index.js
var useChannel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useChannel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/**
 * `useChannel` hook can be used to get Twilio Conversation
 *
 * @param chatState
 * @param dispatch
 */
function useChannel(chatState, dispatch) {
    var _this = this;
    var client = chatState.client, channelId = chatState.channelId, retryingFetch = chatState.retryingFetch;
    var getChannelAsync = function () { return useChannel_awaiter(_this, void 0, void 0, function () {
        var channel_1, err_1, sendMessage;
        var _this = this;
        return useChannel_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(client && channelId)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.getConversationByUniqueName(channelId)];
                case 2:
                    channel_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    throw Error("@lendi/chat: unable to get Twilio Conversation: ".concat(err_1));
                case 4:
                    sendMessage = function (message) { return useChannel_awaiter(_this, void 0, void 0, function () {
                        var err_2;
                        return useChannel_generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, channel_1.sendMessage(message)];
                                case 1:
                                    _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_2 = _a.sent();
                                    throw Error("@lendi/chat: unable to send Twilio Conversation message: ".concat(err_2));
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    dispatch({
                        type: Types_Types.UPDATE_CHANNEL,
                        payload: {
                            channel: channel_1,
                            sendMessage: sendMessage,
                        },
                    });
                    return [3 /*break*/, 6];
                case 5:
                    dispatch({
                        type: Types_Types.UPDATE_CHANNEL,
                        payload: {
                            channel: undefined,
                            sendMessage: undefined,
                        },
                    });
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // When client OR channelId is updated, we wish to retrieve Twilio Conversation
    (0,react.useEffect)(function () {
        if (client) {
            dispatch({
                type: Types_Types.LOADING,
                payload: true,
            });
            getChannelAsync();
            dispatch({
                type: Types_Types.LOADING,
                payload: false,
            });
        }
    }, [client, channelId]);
    // When retryingFetch is updated, we wish to retrieve Twilio Conversation
    (0,react.useEffect)(function () {
        dispatch({
            type: Types_Types.LOADING,
            payload: true,
        });
        getChannelAsync();
        dispatch({
            type: Types_Types.LOADING,
            payload: false,
        });
    }, [retryingFetch]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/utils/parsers.js
var parsers_assign = (undefined && undefined.__assign) || function () {
    parsers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return parsers_assign.apply(this, arguments);
};

var generateMessageMemberStatus = function (members, messageIndex, messageAuthor) {
    var authorMember; // The author
    var readByMembers = []; // ALL members who has read the message
    var currentMembers = []; // ALL members who's lastReadMessage is the current one
    // Using 1 loop instead of 3
    members.forEach(function (member) {
        if (member.identity === messageAuthor) {
            authorMember = member;
        }
        if (member.lastConsumedMessageIndex === messageIndex) {
            if (member.identity !== LENDI_BOT_IDENTITY) {
                currentMembers.push(member);
            }
        }
        if (member.lastConsumedMessageIndex >= messageIndex) {
            if (member.identity !== LENDI_BOT_IDENTITY) {
                readByMembers.push(member);
            }
        }
    });
    var seenByNames = generateSeenByNames(readByMembers, members);
    return {
        authorMember: authorMember,
        currentMembers: currentMembers,
        seenByNames: seenByNames,
    };
};
var generateSeenByNames = function (readByMembers, allMembers) {
    var seenByNames;
    if (readByMembers.length === 0) {
        // readByMembers not ready yet
    }
    else if (readByMembers.length === allMembers.length - 1) {
        // readByMembers will ALWAYS exclude lendi_bot, hence -1
        seenByNames = 'everyone';
    }
    else if (readByMembers.length === 1) {
        // readByMembers only has 1 member
        seenByNames = readByMembers[0].firstName;
    }
    else {
        var seenByMembers = readByMembers;
        var lastSeenMember = seenByMembers.pop();
        seenByNames = "".concat(seenByMembers.map(function (m) { return m.firstName; }).join(', '), " and ").concat(lastSeenMember === null || lastSeenMember === void 0 ? void 0 : lastSeenMember.firstName);
    }
    return seenByNames;
};
var parseLendiMessage = function (message, members) {
    var index = message.index, authorIdentity = message.authorIdentity;
    var _a = generateMessageMemberStatus(members, index, authorIdentity), authorMember = _a.authorMember, seenByNames = _a.seenByNames, currentMembers = _a.currentMembers;
    return parsers_assign(parsers_assign({}, message), { author: authorMember, currentMembers: currentMembers, seenByNames: seenByNames });
};
var parseTwilioMessage = function (message, members) {
    var index = message.index, body = message.body, author = message.author, dateCreated = message.dateCreated;
    var _a = generateMessageMemberStatus(members, index, author), authorMember = _a.authorMember, seenByNames = _a.seenByNames, currentMembers = _a.currentMembers;
    return {
        index: index,
        text: body,
        authorIdentity: author,
        author: authorMember,
        dateCreated: dateCreated,
        currentMembers: currentMembers,
        seenByNames: seenByNames,
    };
};
var parseLendiMember = function (member, descriptor) {
    if (member.identity === descriptor.identity) {
        var identity = descriptor.identity, online = descriptor.online, attributes = descriptor.attributes;
        var userAttributes = attributes;
        var isTyping = member.isTyping, lastConsumedMessageIndex = member.lastConsumedMessageIndex;
        var defaultFirstName = userAttributes.type === LendiMemberType.CUSTOMER ? 'Customer' : 'Home Loan Specialist';
        var firstName = userAttributes.firstName ? formatName(userAttributes.firstName) : defaultFirstName;
        var lastName = userAttributes.lastName ? formatName(userAttributes.lastName) : '';
        var profilePictureURL = userAttributes.profilePictureURL;
        return {
            identity: identity,
            isOnline: online,
            isTyping: isTyping,
            firstName: firstName,
            lastName: lastName,
            type: userAttributes.type,
            lastConsumedMessageIndex: lastConsumedMessageIndex !== null && lastConsumedMessageIndex !== void 0 ? lastConsumedMessageIndex : 0,
            profilePictureURL: profilePictureURL,
        };
    }
    else {
        throw new Error('parseLendiMember(): member and userDescriptor mismatch');
    }
};
// conversations types are different from old chat SDK so there is a need to parse it differenlty
var parseLendiConversationMember = function (member, user) {
    if (member.identity === user.identity) {
        var identity = user.identity, isOnline = user.isOnline, attributes = user.attributes;
        var userAttributes = attributes;
        var isTyping = member.isTyping, lastReadMessageIndex = member.lastReadMessageIndex;
        var defaultFirstName = userAttributes.type === LendiMemberType.CUSTOMER ? 'Customer' : 'Home Loan Specialist';
        var firstName = userAttributes.firstName ? formatName(userAttributes.firstName) : defaultFirstName;
        var lastName = userAttributes.lastName ? formatName(userAttributes.lastName) : '';
        var profilePictureURL = userAttributes.profilePictureURL;
        return {
            identity: identity,
            isOnline: !!isOnline,
            isTyping: isTyping,
            firstName: firstName,
            lastName: lastName,
            type: userAttributes.type,
            lastConsumedMessageIndex: lastReadMessageIndex !== null && lastReadMessageIndex !== void 0 ? lastReadMessageIndex : 0,
            profilePictureURL: profilePictureURL,
        };
    }
    else {
        throw new Error('parseLendiMember(): member and userDescriptor mismatch');
    }
};
var formatName = function (name) {
    return name.charAt(0).toUpperCase() + name.slice(1);
};
//# sourceMappingURL=parsers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useConversations/useConversationSDK/useMembers/index.js
var useMembers_assign = (undefined && undefined.__assign) || function () {
    useMembers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useMembers_assign.apply(this, arguments);
};
var useMembers_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useMembers_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var useMembers_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};





var channelMembers = [];
/**
 * `useMembers` hook can be used to get members for Twilio Channel
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
function useMembers(chatState, dispatch) {
    var _this = this;
    var channel = chatState.channel, members = chatState.members, messages = chatState.messages;
    // When Channel changed, get members
    (0,react.useEffect)(function () {
        if (channel) {
            var getMembersAsync = function () { return useMembers_awaiter(_this, void 0, void 0, function () {
                var err_1, lendiMembers;
                var _this = this;
                return useMembers_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, channel.getParticipants()];
                        case 1:
                            channelMembers = _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            throw new Error("@lendi/chat: unable to get Twilio members: ".concat(err_1));
                        case 3: return [4 /*yield*/, Promise.all(channelMembers.map(function (member) { return useMembers_awaiter(_this, void 0, void 0, function () {
                                var userDescriptor;
                                return useMembers_generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, member.getUser()];
                                        case 1:
                                            userDescriptor = _a.sent();
                                            return [2 /*return*/, parseLendiConversationMember(member, userDescriptor)];
                                    }
                                });
                            }); }))];
                        case 4:
                            lendiMembers = _a.sent();
                            lendiMembers.push(lendiBot);
                            dispatch({
                                type: Types_Types.UPDATE_MEMBERS,
                                payload: lendiMembers,
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            getMembersAsync();
        }
        else {
            dispatch({
                type: Types_Types.UPDATE_MEMBERS,
                payload: [lendiBot],
            });
        }
    }, [channel]);
    // When channel or members change, update listener
    (0,react.useEffect)(function () {
        if (channel) {
            // Listen for members joining a channel
            channel.on('participantJoined', function (member) { return useMembers_awaiter(_this, void 0, void 0, function () {
                var userDescriptor, newLendiMember;
                return useMembers_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, member.getUser()];
                        case 1:
                            userDescriptor = _a.sent();
                            return [4 /*yield*/, parseLendiConversationMember(member, userDescriptor)];
                        case 2:
                            newLendiMember = _a.sent();
                            dispatch({
                                type: Types_Types.UPDATE_MEMBERS,
                                payload: useMembers_spreadArray(useMembers_spreadArray([], members, true), [newLendiMember], false),
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
            // Listen for members user info changing
            channel.on('participantUpdated', function (update) {
                var updatedMember = update.participant;
                update.updateReasons.forEach(function (reason) {
                    var _a;
                    if (reason === 'lastConsumedMessageIndex') {
                        var updatedLendiMembers = useMembers_spreadArray([], members, true); // 1. Make a shallow copy of the items
                        var memberIndex = members.findIndex(function (member) { return member.identity === updatedMember.identity; });
                        if (memberIndex !== -1) {
                            var updatedLendiMember = useMembers_assign(useMembers_assign({}, members[memberIndex]), { lastConsumedMessageIndex: (_a = updatedMember.lastReadMessageIndex) !== null && _a !== void 0 ? _a : 0 });
                            updatedLendiMembers[memberIndex] = updatedLendiMember; // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
                            dispatch({
                                type: Types_Types.UPDATE_MEMBERS,
                                payload: updatedLendiMembers,
                            });
                        }
                    }
                    else if (reason === 'lastConsumptionTimestamp') {
                        // Do nothing
                    }
                    else {
                        // console.log('Member ', updatedMember, ' other update reason: ', reason);
                    }
                });
            });
            // Listen for members leaving a channel
            channel.on('participantLeft', function (member) {
                var membersLeft = members.filter(function (lendiMember) { return lendiMember.identity !== member.identity; });
                dispatch({
                    type: Types_Types.UPDATE_MEMBERS,
                    payload: membersLeft,
                });
            });
            // Listen for members typing
            channel.on('typingStarted', function (member) {
                dispatch({
                    type: Types_Types.TYPING_STARTED,
                    payload: member.identity,
                });
            });
            // Listen for members typing
            channel.on('typingEnded', function (member) {
                dispatch({
                    type: Types_Types.TYPING_ENDED,
                    payload: member.identity,
                });
            });
        }
    }, [members, channel]);
    (0,react.useEffect)(function () {
        // Subscribe to each member's online status
        channelMembers.forEach(function (member) {
            var getUserAsync = function () { return useMembers_awaiter(_this, void 0, void 0, function () {
                var user;
                return useMembers_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, member.getUser()];
                        case 1:
                            user = _a.sent();
                            // Register User updated event handler (online/offline)
                            user.on('updated', function (update) {
                                var user = update.user;
                                // loop over each reason and check for reachability change
                                update.updateReasons.forEach(function (reason) {
                                    if (reason === 'online') {
                                        var updatedLendiMembers = useMembers_spreadArray([], members, true); // 1. Make a shallow copy of the items
                                        var memberIndex = members.findIndex(function (member) { return member.identity === user.identity; });
                                        if (memberIndex !== -1) {
                                            var updatedLendiMember = useMembers_assign(useMembers_assign({}, members[memberIndex]), { isOnline: !!user.isOnline });
                                            updatedLendiMembers[memberIndex] = updatedLendiMember; // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
                                            dispatch({
                                                type: Types_Types.UPDATE_MEMBERS,
                                                payload: updatedLendiMembers,
                                            });
                                        }
                                    }
                                    else {
                                        // console.log('userMember: User ', user, ' updated because: ', reason);
                                    }
                                });
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            getUserAsync();
        });
    }, [members]);
    // Whenever members array changes, meaning
    // - members are 1st retrieved and updated, or
    // - new member joined, or
    // - existing member updated lastConsumedMessageIndex)
    // - existing member updated onlineState
    // We update each message if applicable
    (0,react.useEffect)(function () {
        var updatedMessages = messages.map(function (message) { return parseLendiMessage(message, members); });
        dispatch({
            type: Types_Types.UPDATE_MESSAGES,
            payload: updatedMessages,
        });
    }, [members]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/apis/postBotMessage/index.js
var postBotMessage_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var postBotMessage_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var Triggers;
(function (Triggers) {
    Triggers["CustomerAwaitingTeamMemberResponse"] = "CustomerAwaitingTeamMemberResponse";
    Triggers["NoChatHistory"] = "NoChatHistory";
})(Triggers || (Triggers = {}));
var postBotMessage = function (userGroupHash, lendiAuthToken, apiBaseurl, triggerType) { return postBotMessage_awaiter(void 0, void 0, void 0, function () {
    var config, response, error_1;
    return postBotMessage_generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (userGroupHash === '' || apiBaseurl === '') {
                    throw new Error('postBotMessage: apiBaseurl/userGroupHash cannot be empty');
                }
                config = {
                    baseURL: apiBaseurl,
                    headers: {
                        Authorization: "Bearer ".concat(lendiAuthToken),
                        'Content-Type': 'application/json',
                    },
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios/* default.post */.Z.post("".concat(apiBaseurl, "/v2/chat/bot-message/").concat(userGroupHash), {
                        triggerType: triggerType,
                    }, config)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.status === 202];
            case 3:
                error_1 = _a.sent();
                throw new Error('postBotMessage: bot message error');
            case 4: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useConversations/useConversationSDK/useMessages/index.js
var useMessages_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useMessages_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var PAGE_SIZE = 20;
var messagePaginator; // Twilio SDK Messages Instance
/**
 * `useMessages` hook can be used to retrieve and update data related to Twilio Channel Messages.
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseUrl
 */
function useMessages(chatState, dispatch, sessionToken, apiBaseUrl, userType) {
    var _this = this;
    var channel = chatState.channel, messages = chatState.messages, members = chatState.members, hasMore = chatState.hasMore, fetchingMore = chatState.fetchingMore;
    // Whenever channel is update, we wish to retrieve all messages, and handle other events (should fire once only)
    (0,react.useEffect)(function () {
        if (channel) {
            var getPreviousMessages = function () { return useMessages_awaiter(_this, void 0, void 0, function () {
                return useMessages_generator(this, function (_a) {
                    dispatch({
                        type: Types_Types.UPDATE_FETCH_MORE_STATUS,
                        payload: true,
                    });
                    return [2 /*return*/];
                });
            }); };
            dispatch({
                type: Types_Types.UPDATE_FETCH_MORE_METHOD,
                payload: getPreviousMessages,
            });
            var fetchMessages = function () { return useMessages_awaiter(_this, void 0, void 0, function () {
                var err_1, lendiMessages, successful, error_1;
                return useMessages_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dispatch({
                                type: Types_Types.LOADING,
                                payload: true,
                            });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, channel.getMessages(PAGE_SIZE)];
                        case 2:
                            messagePaginator = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            throw new Error("@lendi/chat: unable to get Twilio messages: ".concat(err_1));
                        case 4:
                            dispatch({
                                type: Types_Types.LOADING,
                                payload: false,
                            });
                            // Update hasPrevPage
                            dispatch({
                                type: Types_Types.UPDATE_HAS_MORE,
                                payload: !!(messagePaginator === null || messagePaginator === void 0 ? void 0 : messagePaginator.hasPrevPage),
                            });
                            lendiMessages = messagePaginator === null || messagePaginator === void 0 ? void 0 : messagePaginator.items.map(function (message) { return parseTwilioMessage(message, members); });
                            dispatch({
                                type: Types_Types.UPDATE_MESSAGES,
                                payload: lendiMessages || [],
                            });
                            if (!(userType === 'customer' && (lendiMessages === null || lendiMessages === void 0 ? void 0 : lendiMessages.length) === 0)) return [3 /*break*/, 9];
                            dispatch({ type: Types_Types.START_BOT_TYPING });
                            _a.label = 5;
                        case 5:
                            _a.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, postBotMessage(channel.uniqueName, sessionToken, apiBaseUrl, Triggers.NoChatHistory)];
                        case 6:
                            successful = _a.sent();
                            if (!successful) {
                                throw new Error("useSendBotMessage could not send the message with: ".concat(Triggers.NoChatHistory));
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            error_1 = _a.sent();
                            throw new Error("@lendi/chat: ".concat(error_1.message, " with: ").concat(Triggers.CustomerAwaitingTeamMemberResponse));
                        case 8:
                            dispatch({ type: Types_Types.STOP_BOT_TYPING });
                            _a.label = 9;
                        case 9: return [2 /*return*/];
                    }
                });
            }); };
            fetchMessages();
            channel.on('messageAdded', function (newMessage) {
                dispatch({
                    type: Types_Types.NEW_MESSAGE,
                    payload: parseTwilioMessage(newMessage, members),
                });
            });
        }
        else {
            // Channel was removed, clear data
            dispatch({
                type: Types_Types.UPDATE_HAS_MORE,
                payload: false,
            });
            dispatch({
                type: Types_Types.UPDATE_MESSAGES,
                payload: [],
            });
            dispatch({
                type: Types_Types.UDPATE_HAS_NEW,
                payload: false,
            });
        }
    }, [channel === null || channel === void 0 ? void 0 : channel.sid]);
    // Whenever messages is update, we wish to update the markRead method
    (0,react.useEffect)(function () {
        var setMessagesRead = function () { return useMessages_awaiter(_this, void 0, void 0, function () {
            var lastMessage;
            return useMessages_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            type: Types_Types.UDPATE_HAS_NEW,
                            payload: false,
                        });
                        lastMessage = messages.length > 0 && messages[messages.length - 1];
                        if (!lastMessage) return [3 /*break*/, 2];
                        return [4 /*yield*/, channel.updateLastReadMessageIndex(lastMessage.index)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        dispatch({
            type: Types_Types.UPDATE_MARK_READ_METHOD,
            payload: setMessagesRead,
        });
    }, [messages]);
    (0,react.useEffect)(function () {
        if (fetchingMore) {
            var fetchMoreMessagesAsync = function () { return useMessages_awaiter(_this, void 0, void 0, function () {
                var moreMessages, lendiMessages;
                return useMessages_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(hasMore && messagePaginator)) return [3 /*break*/, 2];
                            return [4 /*yield*/, messagePaginator.prevPage()];
                        case 1:
                            moreMessages = _a.sent();
                            dispatch({
                                type: Types_Types.UPDATE_HAS_MORE,
                                payload: moreMessages.hasPrevPage,
                            });
                            messagePaginator = moreMessages;
                            lendiMessages = moreMessages.items.map(function (message) { return parseTwilioMessage(message, members); });
                            dispatch({
                                type: Types_Types.UPDATE_FETCH_MORE_MESSAGES,
                                payload: lendiMessages,
                            });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); };
            fetchMoreMessagesAsync();
        }
        else {
            // DO nothing
        }
    }, [fetchingMore]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useConversations/useConversationSDK/index.js






/**
 * `useConversationSDK` hook can be used to exchange data with `Twilio Conversation SDK`
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
function useConversationSDK(chatState, dispatch, sessionToken, apiBaseurl, userType) {
    var onException = useError().onException;
    try {
        // useClient hook to create a Twilio Conversation client
        useClient(chatState, dispatch, sessionToken, apiBaseurl);
        // useChannel hook to retrieve Twilio Conversation channel
        useChannel(chatState, dispatch);
        // useMessages hook to retrieve and update Channel Messages
        useMessages(chatState, dispatch, sessionToken, apiBaseurl, userType);
        // useMembers hook to retrieve Twilio Conversation Channel Members
        useMembers(chatState, dispatch);
    }
    catch (err) {
        dispatch({
            type: Types_Types.UPDATE_ERROR,
            payload: err,
        });
        onException(new Error("@lendi/chat: something wrong with Twilio Conversation: ".concat(err)));
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/reducers/ChannelReducers.js
var ChannelReducers_assign = (undefined && undefined.__assign) || function () {
    ChannelReducers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ChannelReducers_assign.apply(this, arguments);
};
var updateChannel = function (state, action) {
    var _a = action.payload, channel = _a.channel, sendMessage = _a.sendMessage;
    return ChannelReducers_assign(ChannelReducers_assign({}, state), { retryingFetch: false, channel: channel, sendMessage: sendMessage });
};
var retryFetch = function (state) {
    return ChannelReducers_assign(ChannelReducers_assign({}, state), { error: undefined, retryingFetch: true });
};
//# sourceMappingURL=ChannelReducers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/reducers/MessageReducers.js
var MessageReducers_assign = (undefined && undefined.__assign) || function () {
    MessageReducers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return MessageReducers_assign.apply(this, arguments);
};
var MessageReducers_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var updateMessages = function (state, action) {
    return MessageReducers_assign(MessageReducers_assign({}, state), { messages: action.payload });
};
var updateHasNew = function (state, action) {
    return MessageReducers_assign(MessageReducers_assign({}, state), { hasNew: action.payload });
};
var newMessage = function (state, action) {
    var newMessage = action.payload;
    var isNew = newMessage.author !== state.identity;
    var hasCustomerAddedNewMessage = !!state.members
        .filter(function (mem) { return mem.type === 'customer'; })
        .find(function (mem) { return mem.identity === newMessage.authorIdentity; });
    return MessageReducers_assign(MessageReducers_assign({}, state), { hasNew: isNew, hasCustomerAddedNewMessage: hasCustomerAddedNewMessage, messages: MessageReducers_spreadArray(MessageReducers_spreadArray([], (state.messages || []), true), [action.payload], false) });
};
var updateHasMore = function (state, action) {
    return MessageReducers_assign(MessageReducers_assign({}, state), { hasMore: action.payload });
};
var updateFetchMoreMethod = function (state, action) {
    return MessageReducers_assign(MessageReducers_assign({}, state), { fetchMore: action.payload });
};
var updateFetchedMoreMessages = function (state, action) {
    return MessageReducers_assign(MessageReducers_assign({}, state), { fetchingMore: false, messages: MessageReducers_spreadArray(MessageReducers_spreadArray([], action.payload, true), state.messages, true) });
};
var updateMarkReadMethod = function (state, action) {
    return MessageReducers_assign(MessageReducers_assign({}, state), { setMessagesRead: action.payload });
};
var resetHasCustomerAddedNewMessage = function (state) { return (MessageReducers_assign(MessageReducers_assign({}, state), { hasCustomerAddedNewMessage: false })); };
//# sourceMappingURL=MessageReducers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/reducers/OtherReducers.js
var OtherReducers_assign = (undefined && undefined.__assign) || function () {
    OtherReducers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return OtherReducers_assign.apply(this, arguments);
};

var updateLoading = function (state, action) {
    return OtherReducers_assign(OtherReducers_assign({}, state), { loading: action.payload });
};
var updateError = function (state, action) {
    return OtherReducers_assign(OtherReducers_assign({}, state), { error: action.payload, loading: false });
};
var startLendiBotTyping = function (state) {
    var membersWithBotTypingStart = state.members.map(function (mem) {
        return mem.identity === LENDI_BOT_IDENTITY ? OtherReducers_assign(OtherReducers_assign({}, mem), { isTyping: true }) : mem;
    });
    return OtherReducers_assign(OtherReducers_assign({}, state), { members: membersWithBotTypingStart });
};
var stopLendiBotTyping = function (state) {
    var membersWithBotTypingStop = state.members.map(function (mem) {
        return mem.identity === LENDI_BOT_IDENTITY ? OtherReducers_assign(OtherReducers_assign({}, mem), { isTyping: false }) : mem;
    });
    return OtherReducers_assign(OtherReducers_assign({}, state), { members: membersWithBotTypingStop });
};
//# sourceMappingURL=OtherReducers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/reducers/UserReducers.js
var UserReducers_assign = (undefined && undefined.__assign) || function () {
    UserReducers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return UserReducers_assign.apply(this, arguments);
};
var updateFetchingMoreStatus = function (state, action) {
    return UserReducers_assign(UserReducers_assign({}, state), { fetchingMore: action.payload });
};
//# sourceMappingURL=UserReducers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/reducers/MemberReducers.js
var MemberReducers_assign = (undefined && undefined.__assign) || function () {
    MemberReducers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return MemberReducers_assign.apply(this, arguments);
};

var updateIdentity = function (state, action) {
    return MemberReducers_assign(MemberReducers_assign({}, state), { identity: action.payload });
};
var updateRecipientId = function (state, action) {
    return MemberReducers_assign(MemberReducers_assign({}, state), { recipientIdentity: action.payload });
};
var updateMembers = function (state, action) {
    return MemberReducers_assign(MemberReducers_assign({}, state), { members: action.payload });
};
var updateTyping = function (state, action) {
    var type = action.type, memberId = action.payload;
    var members = state.members;
    var memberIndex = members.findIndex(function (m) { return m.identity === memberId; });
    if (memberIndex !== -1)
        members[memberIndex].isTyping = type === Types_Types.TYPING_STARTED;
    return MemberReducers_assign(MemberReducers_assign({}, state), { members: members });
};
//# sourceMappingURL=MemberReducers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/reducers/TwilioReducers.js
var TwilioReducers_assign = (undefined && undefined.__assign) || function () {
    TwilioReducers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return TwilioReducers_assign.apply(this, arguments);
};
var updateClient = function (state, action) {
    return TwilioReducers_assign(TwilioReducers_assign({}, state), { client: action.payload });
};
var updateAccessToken = function (state, action) {
    return TwilioReducers_assign(TwilioReducers_assign({}, state), { accessToken: action.payload });
};
//# sourceMappingURL=TwilioReducers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/states/reducers/index.js








function chatReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        // chat-service
        case Types_Types.UPDATE_IDENTITY:
            return updateIdentity(state, action);
        case Types_Types.UPDATE_RECIPIENT_ID:
            return updateRecipientId(state, action);
        // twilio SDK
        case Types_Types.UPDATE_ACCESS_TOKEN:
            return updateAccessToken(state, action);
        case Types_Types.UPDATE_CLIENT:
            return updateClient(state, action);
        case Types_Types.UPDATE_CHANNEL:
            return updateChannel(state, action);
        // messages
        case Types_Types.UPDATE_MESSAGES:
            return updateMessages(state, action);
        case Types_Types.NEW_MESSAGE:
            return newMessage(state, action);
        case Types_Types.RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE:
            return resetHasCustomerAddedNewMessage(state);
        case Types_Types.UDPATE_HAS_NEW:
            return updateHasNew(state, action);
        case Types_Types.UPDATE_FETCH_MORE_METHOD:
            return updateFetchMoreMethod(state, action);
        case Types_Types.UPDATE_FETCH_MORE_MESSAGES:
            return updateFetchedMoreMessages(state, action);
        case Types_Types.UPDATE_MARK_READ_METHOD:
            return updateMarkReadMethod(state, action);
        case Types_Types.UPDATE_HAS_MORE:
            return updateHasMore(state, action);
        // members
        case Types_Types.UPDATE_MEMBERS:
            return updateMembers(state, action);
        case Types_Types.TYPING_STARTED:
        case Types_Types.TYPING_ENDED:
            return updateTyping(state, action);
        // user
        case Types_Types.UPDATE_FETCH_MORE_STATUS:
            return updateFetchingMoreStatus(state, action);
        // utils
        case Types_Types.LOADING:
            return updateLoading(state, action);
        case Types_Types.UPDATE_ERROR:
            return updateError(state, action);
        case Types_Types.START_BOT_TYPING:
            return startLendiBotTyping(state);
        case Types_Types.STOP_BOT_TYPING:
            return stopLendiBotTyping(state);
        default:
            // eslint-disable-next-line no-console
            console.warn('lendi-chat: unhandled reducer: ', action);
            return state;
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/useSendBotMessage/index.js
var useSendBotMessage_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useSendBotMessage_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






// Trigger API to send a bot message.
function useSendBotMessage(chatState, dispatch, sessionToken, apiBaseUrl) {
    var _this = this;
    var hasCustomerAddedNewMessage = chatState.hasCustomerAddedNewMessage, _a = chatState.channelId, channelId = _a === void 0 ? '' : _a;
    var _b = (0,react.useState)(true), shouldSendMessage = _b[0], setShouldSendMessage = _b[1];
    var onException = useError().onException;
    (0,react.useEffect)(function () {
        // send bot message when team member is not assigned yet
        var botMessageWhenCustomerAwaitingResponse = function () { return useSendBotMessage_awaiter(_this, void 0, void 0, function () {
            var userSession, in8Hours, error_1;
            return useSendBotMessage_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hasCustomerAddedNewMessage) return [3 /*break*/, 5];
                        userSession = api.get('user_in_session');
                        if (!!userSession) return [3 /*break*/, 5];
                        in8Hours = new Date(new Date().getTime() + 8 * 60 * 60 * 1000);
                        api.set('user_in_session', 'Yes', { expires: in8Hours }); // expires 8 hours
                        dispatch({ type: Types_Types.START_BOT_TYPING });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, postBotMessage(channelId, sessionToken, apiBaseUrl, Triggers.CustomerAwaitingTeamMemberResponse)];
                    case 2:
                        _a.sent();
                        analytics({
                            event_name: types/* ChatEventName.NO_RESPONSE_MESSAGE_SENT */.Y.NO_RESPONSE_MESSAGE_SENT,
                            category: common/* EventCategory.CHAT */.Jk.CHAT,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        onException(new Error("@lendi/chat: ".concat(error_1.message, " with: ").concat(Triggers.CustomerAwaitingTeamMemberResponse)));
                        return [3 /*break*/, 4];
                    case 4:
                        dispatch({ type: Types_Types.STOP_BOT_TYPING });
                        setShouldSendMessage(false);
                        dispatch({ type: Types_Types.RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE });
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        if (shouldSendMessage) {
            botMessageWhenCustomerAwaitingResponse();
        }
    }, [hasCustomerAddedNewMessage]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useConversations/ConversationProvider.js
var ConversationProvider_assign = (undefined && undefined.__assign) || function () {
    ConversationProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ConversationProvider_assign.apply(this, arguments);
};








/**
 * `ConversationProvider` Context Provider can be used to exchange data with `chat-service`
 *
 * @param session
 * @param channelId
 */
var ConversationProvider = function (_a) {
    var children = _a.children, session = _a.session, channelId = _a.channelId, accessToken = _a.accessToken, identity = _a.identity, userType = _a.userType;
    // Create initial chatState
    var _b = react.useReducer(chatReducer, ConversationProvider_assign(ConversationProvider_assign({}, initialState), { channelId: channelId, accessToken: accessToken, identity: identity })), chatState = _b[0], dispatch = _b[1];
    var environment = session.environment, sessionToken = session.token;
    var apiBaseUrl = (0,lala_utils_dist_esm/* getAPIBaseURL */.K0)(environment);
    useSendBotMessage(chatState, dispatch, sessionToken, apiBaseUrl);
    // useConversationSDK hook to update data with Twilio conversation SDK
    useConversationSDK(chatState, dispatch, sessionToken, apiBaseUrl, userType);
    return (react.createElement(ChatContext.Provider, { value: ConversationProvider_assign(ConversationProvider_assign({}, chatState), { retryFetch: function () {
                dispatch({
                    type: Types_Types.RETRY_FETCH,
                });
            } }) }, children));
};
//# sourceMappingURL=ConversationProvider.js.map
// EXTERNAL MODULE: ../../../node_modules/twilio-chat/builds/browser.js
var builds_browser = __webpack_require__(49232);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/useTwilioSDK/useClient/index.js
var useTwilioSDK_useClient_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useTwilioSDK_useClient_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




/**
 * `useClient` hook can be used to create a Twilio SDK client
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
function useClient_useClient(chatState, dispatch, sessionToken, apiBaseurl) {
    var _this = this;
    var client = chatState.client, accessToken = chatState.accessToken, channelId = chatState.channelId;
    // Whenever user accessToken is updated, we wish to either
    // 1. Create client
    // 2. Update client
    // 3. Remove client
    (0,react.useEffect)(function () {
        var getClientAsync = function (accessToken) { return useTwilioSDK_useClient_awaiter(_this, void 0, void 0, function () {
            var client, err_1;
            var _this = this;
            return useTwilioSDK_useClient_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, builds_browser/* Client.create */.KU.create(accessToken)];
                    case 1:
                        client = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw new Error("@lendi/chat: unable to create Twilio client: ".concat(err_1));
                    case 3:
                        if (client) {
                            client.on('connectionError', function (connError) {
                                throw new Error("@lendi/chat: useClient: ConnectionError object: %c".concat(JSON.stringify(connError, undefined, 2)));
                            });
                            // when an access token is in its final three minutes, the token about to expire event is triggered
                            client.on('tokenAboutToExpire', function () { return useTwilioSDK_useClient_awaiter(_this, void 0, void 0, function () {
                                var accessToken;
                                return useTwilioSDK_useClient_generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, refreshAccessToken(sessionToken, apiBaseurl, channelId)];
                                        case 1:
                                            accessToken = (_a.sent()).accessToken;
                                            // Once we receive the latest Twilio accessToken, we can dispatch it to chatState, which would in turn trigger updateToken() method from above.
                                            dispatch({ type: Types_Types.UPDATE_ACCESS_TOKEN, payload: accessToken });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        // eslint-disable-next-line no-console
                        console.log('PC client');
                        dispatch({
                            type: Types_Types.UPDATE_CLIENT,
                            payload: client,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        if (accessToken) {
            dispatch({
                type: Types_Types.LOADING,
                payload: true,
            });
            if (client) {
                // Twilio Client already initiated, only update AccessToken
                client.updateToken(accessToken); // TODO: Error Handling
            }
            else {
                getClientAsync(accessToken); // TODO: Error Handling
            }
            dispatch({
                type: Types_Types.LOADING,
                payload: false,
            });
        }
        else {
            // Access Token was removed
            dispatch({
                type: Types_Types.UPDATE_CLIENT,
                payload: undefined,
            });
        }
    }, [accessToken]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/useTwilioSDK/useChannel/index.js
var useTwilioSDK_useChannel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useTwilioSDK_useChannel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/**
 * `useChannel` hook can be used to get Twilio Channel
 *
 * @param chatState
 * @param dispatch
 */
function useChannel_useChannel(chatState, dispatch) {
    var _this = this;
    var client = chatState.client, channelId = chatState.channelId, retryingFetch = chatState.retryingFetch;
    var getChannelAsync = function () { return useTwilioSDK_useChannel_awaiter(_this, void 0, void 0, function () {
        var channel_1, err_1, sendMessage;
        var _this = this;
        return useTwilioSDK_useChannel_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(client && channelId)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.getChannelByUniqueName(channelId)];
                case 2:
                    channel_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    throw Error("@lendi/chat: unable to get Twilio channel: ".concat(err_1));
                case 4:
                    sendMessage = function (message) { return useTwilioSDK_useChannel_awaiter(_this, void 0, void 0, function () {
                        var err_2;
                        return useTwilioSDK_useChannel_generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, channel_1.sendMessage(message)];
                                case 1:
                                    _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_2 = _a.sent();
                                    throw Error("@lendi/chat: unable to send Twilio message: ".concat(err_2));
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    dispatch({
                        type: Types_Types.UPDATE_CHANNEL,
                        payload: {
                            channel: channel_1,
                            sendMessage: sendMessage,
                        },
                    });
                    return [3 /*break*/, 6];
                case 5:
                    dispatch({
                        type: Types_Types.UPDATE_CHANNEL,
                        payload: {
                            channel: undefined,
                            sendMessage: undefined,
                        },
                    });
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // When client OR channelId is updated, we wish to retrieve Twilio channel
    (0,react.useEffect)(function () {
        if (client) {
            dispatch({
                type: Types_Types.LOADING,
                payload: true,
            });
            getChannelAsync();
            dispatch({
                type: Types_Types.LOADING,
                payload: false,
            });
        }
    }, [client, channelId]);
    // When retryingFetch is updated, we wish to retrieve Twilio channel
    (0,react.useEffect)(function () {
        dispatch({
            type: Types_Types.LOADING,
            payload: true,
        });
        getChannelAsync();
        dispatch({
            type: Types_Types.LOADING,
            payload: false,
        });
    }, [retryingFetch]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/useTwilioSDK/useMembers/index.js
var useTwilioSDK_useMembers_assign = (undefined && undefined.__assign) || function () {
    useTwilioSDK_useMembers_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useTwilioSDK_useMembers_assign.apply(this, arguments);
};
var useTwilioSDK_useMembers_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useTwilioSDK_useMembers_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var useTwilioSDK_useMembers_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};





var useMembers_channelMembers = [];
/**
 * `useMembers` hook can be used to get members for Twilio Channel
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
function useMembers_useMembers(chatState, dispatch) {
    var _this = this;
    var channel = chatState.channel, members = chatState.members, messages = chatState.messages;
    // When Channel changed, get members
    (0,react.useEffect)(function () {
        if (channel) {
            var getMembersAsync = function () { return useTwilioSDK_useMembers_awaiter(_this, void 0, void 0, function () {
                var err_1, lendiMembers;
                var _this = this;
                return useTwilioSDK_useMembers_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, channel.getMembers()];
                        case 1:
                            useMembers_channelMembers = _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            throw new Error("@lendi/chat: unable to get Twilio members: ".concat(err_1));
                        case 3: return [4 /*yield*/, Promise.all(useMembers_channelMembers.map(function (member) { return useTwilioSDK_useMembers_awaiter(_this, void 0, void 0, function () {
                                var userDescriptor;
                                return useTwilioSDK_useMembers_generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, member.getUserDescriptor()];
                                        case 1:
                                            userDescriptor = _a.sent();
                                            return [2 /*return*/, parseLendiMember(member, userDescriptor)];
                                    }
                                });
                            }); }))];
                        case 4:
                            lendiMembers = _a.sent();
                            lendiMembers.push(lendiBot);
                            dispatch({
                                type: Types_Types.UPDATE_MEMBERS,
                                payload: lendiMembers,
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            getMembersAsync();
        }
        else {
            dispatch({
                type: Types_Types.UPDATE_MEMBERS,
                payload: [lendiBot],
            });
        }
    }, [channel]);
    // When channel or members change, update listener
    (0,react.useEffect)(function () {
        if (channel) {
            // Listen for members joining a channel
            channel.on('memberJoined', function (member) { return useTwilioSDK_useMembers_awaiter(_this, void 0, void 0, function () {
                var userDescriptor, newLendiMember;
                return useTwilioSDK_useMembers_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, member.getUserDescriptor()];
                        case 1:
                            userDescriptor = _a.sent();
                            return [4 /*yield*/, parseLendiMember(member, userDescriptor)];
                        case 2:
                            newLendiMember = _a.sent();
                            dispatch({
                                type: Types_Types.UPDATE_MEMBERS,
                                payload: useTwilioSDK_useMembers_spreadArray(useTwilioSDK_useMembers_spreadArray([], members, true), [newLendiMember], false),
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
            // Listen for members user info changing
            channel.on('memberUpdated', function (update) {
                var updatedMember = update.member;
                update.updateReasons.forEach(function (reason) {
                    var _a;
                    if (reason === 'lastConsumedMessageIndex') {
                        var updatedLendiMembers = useTwilioSDK_useMembers_spreadArray([], members, true); // 1. Make a shallow copy of the items
                        var memberIndex = members.findIndex(function (member) { return member.identity === updatedMember.identity; });
                        if (memberIndex !== -1) {
                            var updatedLendiMember = useTwilioSDK_useMembers_assign(useTwilioSDK_useMembers_assign({}, members[memberIndex]), { lastConsumedMessageIndex: (_a = updatedMember.lastConsumedMessageIndex) !== null && _a !== void 0 ? _a : 0 });
                            updatedLendiMembers[memberIndex] = updatedLendiMember; // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
                            dispatch({
                                type: Types_Types.UPDATE_MEMBERS,
                                payload: updatedLendiMembers,
                            });
                        }
                    }
                    else if (reason === 'lastConsumptionTimestamp') {
                        // Do nothing
                    }
                    else {
                        // console.log('Member ', updatedMember, ' other update reason: ', reason);
                    }
                });
            });
            // Listen for members leaving a channel
            channel.on('memberLeft', function (member) {
                var membersLeft = members.filter(function (lendiMember) { return lendiMember.identity !== member.identity; });
                dispatch({
                    type: Types_Types.UPDATE_MEMBERS,
                    payload: membersLeft,
                });
            });
            // Listen for members typing
            channel.on('typingStarted', function (member) {
                dispatch({
                    type: Types_Types.TYPING_STARTED,
                    payload: member.identity,
                });
            });
            // Listen for members typing
            channel.on('typingEnded', function (member) {
                dispatch({
                    type: Types_Types.TYPING_ENDED,
                    payload: member.identity,
                });
            });
        }
    }, [members, channel]);
    (0,react.useEffect)(function () {
        // Subscribe to each member's online status
        useMembers_channelMembers.forEach(function (member) {
            var getUserAsync = function () { return useTwilioSDK_useMembers_awaiter(_this, void 0, void 0, function () {
                var user;
                return useTwilioSDK_useMembers_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, member.getUser()];
                        case 1:
                            user = _a.sent();
                            // Register User updated event handler (online/offline)
                            user.on('updated', function (update) {
                                var user = update.user;
                                // loop over each reason and check for reachability change
                                update.updateReasons.forEach(function (reason) {
                                    if (reason === 'online') {
                                        var updatedLendiMembers = useTwilioSDK_useMembers_spreadArray([], members, true); // 1. Make a shallow copy of the items
                                        var memberIndex = members.findIndex(function (member) { return member.identity === user.identity; });
                                        if (memberIndex !== -1) {
                                            var updatedLendiMember = useTwilioSDK_useMembers_assign(useTwilioSDK_useMembers_assign({}, members[memberIndex]), { isOnline: user.online });
                                            updatedLendiMembers[memberIndex] = updatedLendiMember; // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
                                            dispatch({
                                                type: Types_Types.UPDATE_MEMBERS,
                                                payload: updatedLendiMembers,
                                            });
                                        }
                                    }
                                    else {
                                        // console.log('userMember: User ', user, ' updated because: ', reason);
                                    }
                                });
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            getUserAsync();
        });
    }, [members]);
    // Whenever members array changes, meaning
    // - members are 1st retrieved and updated, or
    // - new member joined, or
    // - existing member updated lastConsumedMessageIndex)
    // - existing member updated onlineState
    // We update each message if applicable
    (0,react.useEffect)(function () {
        var updatedMessages = messages.map(function (message) { return parseLendiMessage(message, members); });
        dispatch({
            type: Types_Types.UPDATE_MESSAGES,
            payload: updatedMessages,
        });
    }, [members]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/useTwilioSDK/useMessages/index.js
var useTwilioSDK_useMessages_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useTwilioSDK_useMessages_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var useMessages_PAGE_SIZE = 20;
var useMessages_messagePaginator; // Twilio SDK Messages Instance
/**
 * `useMessages` hook can be used to retrieve and update data related to Twilio Channel Messages.
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseUrl
 */
function useMessages_useMessages(chatState, dispatch, sessionToken, apiBaseUrl, userType) {
    var _this = this;
    var channel = chatState.channel, messages = chatState.messages, members = chatState.members, hasMore = chatState.hasMore, fetchingMore = chatState.fetchingMore;
    // Whenever channel is update, we wish to retrieve all messages, and handle other events (should fire once only)
    (0,react.useEffect)(function () {
        if (channel) {
            var getPreviousMessages = function () { return useTwilioSDK_useMessages_awaiter(_this, void 0, void 0, function () {
                return useTwilioSDK_useMessages_generator(this, function (_a) {
                    dispatch({
                        type: Types_Types.UPDATE_FETCH_MORE_STATUS,
                        payload: true,
                    });
                    return [2 /*return*/];
                });
            }); };
            dispatch({
                type: Types_Types.UPDATE_FETCH_MORE_METHOD,
                payload: getPreviousMessages,
            });
            var fetchMessages = function () { return useTwilioSDK_useMessages_awaiter(_this, void 0, void 0, function () {
                var err_1, lendiMessages, successful, error_1;
                return useTwilioSDK_useMessages_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dispatch({
                                type: Types_Types.LOADING,
                                payload: true,
                            });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, channel.getMessages(useMessages_PAGE_SIZE)];
                        case 2:
                            useMessages_messagePaginator = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            throw new Error("@lendi/chat: unable to get Twilio messages: ".concat(err_1));
                        case 4:
                            dispatch({
                                type: Types_Types.LOADING,
                                payload: false,
                            });
                            // Update hasPrevPage
                            dispatch({
                                type: Types_Types.UPDATE_HAS_MORE,
                                payload: !!(useMessages_messagePaginator === null || useMessages_messagePaginator === void 0 ? void 0 : useMessages_messagePaginator.hasPrevPage),
                            });
                            lendiMessages = useMessages_messagePaginator === null || useMessages_messagePaginator === void 0 ? void 0 : useMessages_messagePaginator.items.map(function (message) { return parseTwilioMessage(message, members); });
                            dispatch({
                                type: Types_Types.UPDATE_MESSAGES,
                                payload: lendiMessages || [],
                            });
                            if (!(userType === 'customer' && (lendiMessages === null || lendiMessages === void 0 ? void 0 : lendiMessages.length) === 0)) return [3 /*break*/, 9];
                            dispatch({ type: Types_Types.START_BOT_TYPING });
                            _a.label = 5;
                        case 5:
                            _a.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, postBotMessage(channel.uniqueName, sessionToken, apiBaseUrl, Triggers.NoChatHistory)];
                        case 6:
                            successful = _a.sent();
                            if (!successful) {
                                throw new Error("useSendBotMessage could not send the message with: ".concat(Triggers.NoChatHistory));
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            error_1 = _a.sent();
                            throw new Error("@lendi/chat: ".concat(error_1.message, " with: ").concat(Triggers.CustomerAwaitingTeamMemberResponse));
                        case 8:
                            dispatch({ type: Types_Types.STOP_BOT_TYPING });
                            _a.label = 9;
                        case 9: return [2 /*return*/];
                    }
                });
            }); };
            fetchMessages();
            channel.on('messageAdded', function (newMessage) {
                dispatch({
                    type: Types_Types.NEW_MESSAGE,
                    payload: parseTwilioMessage(newMessage, members),
                });
            });
        }
        else {
            // Channel was removed, clear data
            dispatch({
                type: Types_Types.UPDATE_HAS_MORE,
                payload: false,
            });
            dispatch({
                type: Types_Types.UPDATE_MESSAGES,
                payload: [],
            });
            dispatch({
                type: Types_Types.UDPATE_HAS_NEW,
                payload: false,
            });
        }
    }, [channel === null || channel === void 0 ? void 0 : channel.sid]);
    // Whenever messages is update, we wish to update the markRead method
    (0,react.useEffect)(function () {
        var setMessagesRead = function () { return useTwilioSDK_useMessages_awaiter(_this, void 0, void 0, function () {
            var lastMessage;
            return useTwilioSDK_useMessages_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            type: Types_Types.UDPATE_HAS_NEW,
                            payload: false,
                        });
                        lastMessage = messages.length > 0 && messages[messages.length - 1];
                        if (!lastMessage) return [3 /*break*/, 2];
                        return [4 /*yield*/, channel.updateLastConsumedMessageIndex(lastMessage.index)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        dispatch({
            type: Types_Types.UPDATE_MARK_READ_METHOD,
            payload: setMessagesRead,
        });
    }, [messages]);
    (0,react.useEffect)(function () {
        if (fetchingMore) {
            var fetchMoreMessagesAsync = function () { return useTwilioSDK_useMessages_awaiter(_this, void 0, void 0, function () {
                var moreMessages, lendiMessages;
                return useTwilioSDK_useMessages_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(hasMore && useMessages_messagePaginator)) return [3 /*break*/, 2];
                            return [4 /*yield*/, useMessages_messagePaginator.prevPage()];
                        case 1:
                            moreMessages = _a.sent();
                            dispatch({
                                type: Types_Types.UPDATE_HAS_MORE,
                                payload: moreMessages.hasPrevPage,
                            });
                            useMessages_messagePaginator = moreMessages;
                            lendiMessages = moreMessages.items.map(function (message) { return parseTwilioMessage(message, members); });
                            dispatch({
                                type: Types_Types.UPDATE_FETCH_MORE_MESSAGES,
                                payload: lendiMessages,
                            });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); };
            fetchMoreMessagesAsync();
        }
        else {
            // DO nothing
        }
    }, [fetchingMore]);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/useTwilioSDK/index.js






/**
 * `useTwilioSDK` hook can be used to exchange data with `Twilio SDK`
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
function useTwilioSDK(chatState, dispatch, sessionToken, apiBaseurl, userType) {
    var onException = useError().onException;
    try {
        // useClient hook to create a Twilio client
        useClient_useClient(chatState, dispatch, sessionToken, apiBaseurl);
        // useChannel hook to retrieve Twilio channel
        useChannel_useChannel(chatState, dispatch);
        // useMessages hook to retrieve and update Channel Messages
        useMessages_useMessages(chatState, dispatch, sessionToken, apiBaseurl, userType);
        // useMembers hook to retrieve Twilio Channel Members
        useMembers_useMembers(chatState, dispatch);
    }
    catch (err) {
        dispatch({
            type: Types_Types.UPDATE_ERROR,
            payload: err,
        });
        onException(new Error("@lendi/chat: something wrong with Twilio: ".concat(err)));
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/twilio/hooks/useChat/ChatProvider.js
var ChatProvider_assign = (undefined && undefined.__assign) || function () {
    ChatProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ChatProvider_assign.apply(this, arguments);
};








/**
 * `ChatProvider` Context Provider can be used to exchange data with `chat-service`
 *
 * @param session
 * @param channelId
 */
var ChatProvider = function (_a) {
    var children = _a.children, session = _a.session, channelId = _a.channelId, accessToken = _a.accessToken, identity = _a.identity, userType = _a.userType;
    // Create initial chatState
    var _b = react.useReducer(chatReducer, ChatProvider_assign(ChatProvider_assign({}, initialState), { channelId: channelId, accessToken: accessToken, identity: identity })), chatState = _b[0], dispatch = _b[1];
    var environment = session.environment, sessionToken = session.token;
    var apiBaseUrl = (0,lala_utils_dist_esm/* getAPIBaseURL */.K0)(environment);
    useSendBotMessage(chatState, dispatch, sessionToken, apiBaseUrl);
    // useTwilioSDK hook to update data with Twilio SDK
    useTwilioSDK(chatState, dispatch, sessionToken, apiBaseUrl, userType);
    return (react.createElement(ChatContext.Provider, { value: ChatProvider_assign(ChatProvider_assign({}, chatState), { retryFetch: function () {
                dispatch({
                    type: Types_Types.RETRY_FETCH,
                });
            } }) }, children));
};
//# sourceMappingURL=ChatProvider.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/timeTakenToReplyTracking/index.js

// track how much time each recipients are taking to respond againt the last receieved message dateCreated
var timeTakenToReply = function (sender, recepients, messages, userType, channelSid) {
    var _loop_1 = function (recepient) {
        var otherMemMessages = messages.filter(function (message) { return message.authorIdentity === recepient.identity; });
        var unReadMessages = otherMemMessages.filter(function (otherMemMessage) { var _a; return otherMemMessage.index > ((_a = sender === null || sender === void 0 ? void 0 : sender.lastConsumedMessageIndex) !== null && _a !== void 0 ? _a : 0); });
        if (unReadMessages.length > 0) {
            var worstCaseTimestamp = unReadMessages.sort(function (one, two) {
                return one.dateCreated.getTime() - two.dateCreated.getTime();
            })[0].dateCreated;
            var diff = Date.now() - Number(worstCaseTimestamp);
            // The Time Difference between (when the other member sends the message) and (when I read the message)
            var minutes = diff / (1000 * 60);
            var timeToRead = "".concat(minutes);
            var event_1 = {
                time_to_read: timeToRead,
                category: common/* EventCategory.CHAT */.Jk.CHAT,
                event_name: types/* ChatEventName.MESSAGE_READ */.Y.MESSAGE_READ,
                channel_sid: channelSid,
                user_type: userType,
            };
            analytics(event_1);
        }
    };
    for (var _i = 0, recepients_1 = recepients; _i < recepients_1.length; _i++) {
        var recepient = recepients_1[_i];
        _loop_1(recepient);
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/sendMessageTracking/index.js


// track first chat message and consecutive messages from each parties.
var useSendMessageTracking = function (messages, userType, sender, channelSid) {
    var event;
    var isInitialMessage = messages.filter(function (x) { return x.authorIdentity !== LENDI_BOT_IDENTITY; }).length === 0;
    if (isInitialMessage) {
        event = {
            event_name: types/* ChatEventName.FIRST_MESSAGE_SENT */.Y.FIRST_MESSAGE_SENT,
            category: common/* EventCategory.CHAT */.Jk.CHAT,
            Channel_id: channelSid,
            user_type: userType,
            sender_id: sender.identity,
            time_to_message: new Date().toISOString(),
        };
    }
    else {
        event = {
            event_name: types/* ChatEventName.MESSAGE_SENT */.Y.MESSAGE_SENT,
            category: common/* EventCategory.CHAT */.Jk.CHAT,
            Channel_id: channelSid,
            user_type: userType,
            sender_id: sender.identity,
            time_to_message: new Date().toISOString(),
        };
    }
    analytics(event);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/hooks/useAuthTransitionTracking/index.js


// track when transition is done from smart chat to twilio chat
var useAuthTransitionTracking = function (client, loading) {
    var authViaSmartChat = useChatAuthAnalytics().authViaSmartChat;
    (0,react.useEffect)(function () {
        if (client && client.connectionState === 'connected' && !loading) {
            // this is the point where transition is done, so track it if coming from SmartChat.
            if (authViaSmartChat) {
                analytics({
                    event_name: types/* ChatEventName.TRANSITIONED_FROM_SMART_TO_LENDI */.Y.TRANSITIONED_FROM_SMART_TO_LENDI,
                    category: common/* EventCategory.CHAT */.Jk.CHAT,
                });
            }
        }
    }, [client, loading]);
    return authViaSmartChat;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/ErrorComponent/index.js


var ErrorComponent = function (_a) {
    var onRetry = _a.onRetry;
    return (react.createElement(Main, { "data-testid": "error-component" },
        react.createElement(HeadingWrapper, { size: { mobile: 'xs', tablet: 'sm' }, color: "shade.700", mb: "sm" }, "Ooooops"),
        react.createElement(HeadingWrapper, { size: { mobile: 'xs', tablet: 'sm' }, color: "shade.700", mb: "lg" }, "Something went wrong."),
        onRetry && (react.createElement(ButtonWrapper, { variant: "primary", onClick: onRetry }, "TRY AGAIN"))));
};
/* harmony default export */ var ChatComponent_ErrorComponent = (ErrorComponent);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/TwilioChatComponent/index.js
var TwilioChatComponent_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var TwilioChatComponent_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};










var TwilioChatComponent = function (_a) {
    var userType = _a.userType, teamMember = _a.teamMember;
    var _b = react.useState(''), messageToSend = _b[0], setMessageToSend = _b[1];
    var _c = react.useState(false), isSendDisabled = _c[0], setIsSendDisabled = _c[1];
    var _d = react.useState(false), messageRead = _d[0], setMessageRead = _d[1];
    var _e = react.useState(-1), lastMessageIndex = _e[0], setLastMessageIndex = _e[1];
    var onException = useError().onException;
    var _f = useChat(), identity = _f.identity, loading = _f.loading, members = _f.members, messages = _f.messages, setMessagesRead = _f.setMessagesRead, error = _f.error, hasMore = _f.hasMore, retryFetch = _f.retryFetch, fetchMore = _f.fetchMore, channel = _f.channel, sendMessage = _f.sendMessage, client = _f.client;
    if (error) {
        return react.createElement(ChatComponent_ErrorComponent, { onRetry: retryFetch });
    }
    var sender = members.filter(function (m) { return m.identity === identity; })[0];
    var recipients = members.filter(function (member) { return member.type !== (sender === null || sender === void 0 ? void 0 : sender.type) || member.type !== LendiMemberType.BOT; });
    var onKeyDown = function (e) {
        if (e.key === 'Enter') {
            send();
            var customEnterPushedEvent = {
                event_name: 'Return Pressed',
                category: common/* EventCategory.CHAT */.Jk.CHAT,
                inputElement: 'message input area',
                noOfCharacters: messageToSend.length,
            };
            analytics(customEnterPushedEvent);
            e.preventDefault();
        }
        // Send Typing Indicator
        channel && channel.typing();
    };
    var scrollToBottom = function () {
        if (displayRef && displayRef.current && displayRef.current.scrollIntoView) {
            displayRef.current.scrollIntoView({ block: 'end', behavior: 'auto' });
        }
    };
    var markMessagesRead = function () {
        timeTakenToReply(sender, recipients, messages, userType, channel === null || channel === void 0 ? void 0 : channel.sid);
        setMessagesRead && setMessagesRead();
    };
    var onInputChange = function (value) {
        setMessageRead(true);
        setMessageToSend(value);
    };
    react.useEffect(function () {
        messageRead && markMessagesRead();
    }, [messageRead]);
    useChatOpenTracking(true);
    // When 'send' is clicked or messages updates Triggering 'read' status from UI
    // TODO: Consider Changing the `sendClicked` UI Trigger to when new message is sent by customer (detect by useEffect(messages))
    react.useEffect(function () {
        // If the update in `messages` are caused by newly sent message (by customer OR broker)
        var lastMessage = messages.length > 0 && messages[messages.length - 1];
        if (lastMessage && lastMessage.index !== lastMessageIndex) {
            // only for updating last message index
            // if (setMessagesRead) setMessagesRead([lastMessage.index]);
            // If sent by customer
            /// / Scroll bottom
            // Else if sent by broker
            /// / Scroll bottom
            /// / TODO: Enhancement: Show dot, until user manually scroll to the end / or type / or send
            scrollToBottom();
            // Else
            /// / Error: Should never happen
            // Update `lastMessageIndex`
            setLastMessageIndex(lastMessage.index);
        }
        else {
            // `messages` update are caused by user scrolling up and loading old messages
            /// / Do nothing
        }
    }, [messages]);
    // The logic that will run, when user opens panel
    react.useEffect(function () {
        if (!loading && members.length > 1) {
            scrollToBottom();
            setMessageRead(true);
        }
    }, [loading, members]);
    var displayRef = react.useRef(null);
    var send = function () { return TwilioChatComponent_awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return TwilioChatComponent_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (messageToSend === '' || loading)
                        return [2 /*return*/];
                    setIsSendDisabled(true);
                    if (!sendMessage) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendMessage(messageToSend)];
                case 2:
                    _a.sent();
                    useSendMessageTracking(messages, userType, sender, channel === null || channel === void 0 ? void 0 : channel.sid);
                    setMessageToSend('');
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    onException(new Error("@lendi/chat: unable to send message to Twilio: ".concat(e_1)));
                    return [3 /*break*/, 4];
                case 4:
                    setIsSendDisabled(false);
                    setMessageRead(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var isChannelMember = members.find(function (member) { return member.identity === identity; }) !== undefined;
    var authViaSmartChat = useAuthTransitionTracking(client, loading);
    var transitionMessage = authViaSmartChat
        ? "Your mobile phone number has been verified.\n\n    We are connecting you with your expert.\n        Please wait for a few moments."
        : 'We are retrieving your chat history. Please wait for a few moments.';
    return client && client.connectionState === 'connected' && !loading ? (react.createElement(react.Fragment, null,
        react.createElement(style_MessageListWrapper, null,
            react.createElement((react_infinite_scroller_default()), { pageStart: 0, loadMore: fetchMore || (function () { }), hasMore: hasMore, isReverse: true, initialLoad: false, useWindow: false },
                identity && (react.createElement(ChatComponent_MessageList, { identity: identity, members: members, messages: messages, teamMember: teamMember, userType: userType })),
                react.createElement("div", { ref: displayRef }))),
        react.createElement(ChatInput, { value: messageToSend, disabledSend: isSendDisabled || messageToSend.trim() === '' || !isChannelMember, disabledTextArea: !isChannelMember, onChange: function (e) { return onInputChange(e.target.value); }, send: function () { return send(); }, onKeyDown: onKeyDown, userType: userType }))) : (react.createElement(TransitionLoader, { transitionMessage: transitionMessage }));
};
/* harmony default export */ var ChatComponent_TwilioChatComponent = (TwilioChatComponent);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/ui/dist/objectWithoutProperties-7e1dfdab.esm.js
function objectWithoutProperties_7e1dfdab_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutProperties_7e1dfdab_esm_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/ui/dist/RichText-50b4a7f5.esm.js








var getFontSize = variant => {
  var styles = styleData[variant];
  return styles.fontSize;
};
var getLineHeight = variant => {
  var styles = styleData[variant];
  return styles.lineHeight;
};
var getTextColor = (theme, appearance) => {
  if (appearance) {
    if (appearance === 'error') {
      return theme.color.interaction.error;
    }
    if (appearance === 'subtle') {
      return theme.color.text.subtle;
    }
  }
  return theme.color.text.main;
};
var linkStyle = theme => {
  return {
    textDecoration: 'underline',
    color: theme.color.interaction.main,
    fontFamily: theme.asset.font.body.family,
    '&:hover': {
      textDecoration: 'none'
    }
  };
};
var styleData = {
  display: {
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(36),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[10])
    },
    lineHeight: 1.31
  },
  display1: {
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[9]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[10])
    },
    lineHeight: LineHeight.heading
  },
  display2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[8]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[9])
    },
    lineHeight: LineHeight.heading
  },
  title1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[7]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[8])
    },
    lineHeight: LineHeight.heading
  },
  title2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[6])
    },
    lineHeight: LineHeight.heading
  },
  title3: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[5])
    },
    lineHeight: LineHeight.heading
  },
  title4: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[4])
    },
    lineHeight: LineHeight.heading
  },
  lead1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[5]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[6])
    },
    lineHeight: LineHeight.body
  },
  lead2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3]),
      desktop: (0,commons_esm/* pxToRem */.Q1)(fontSize[5])
    },
    lineHeight: LineHeight.body
  },
  subtitle1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3])
    },
    lineHeight: LineHeight.body
  },
  subtitle2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.body
  },
  body1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3])
    },
    lineHeight: LineHeight.body
  },
  body2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.body
  },
  detail1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[1])
    },
    lineHeight: LineHeight.body
  },
  detail2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[1])
    },
    lineHeight: LineHeight.body
  },
  overline: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.heading
  },
  button1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[3])
    },
    lineHeight: LineHeight.body
  },
  button2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,commons_esm/* pxToRem */.Q1)(fontSize[2])
    },
    lineHeight: LineHeight.body
  }
};

var RichText_50b4a7f5_esm_excluded$1 = ["children", "variant", "className"];
var getThemeTextAlignment = themeName => {
  if (themeName === commons_esm/* ThemeNames.Lendi */.hN.Lendi) {
    return 'center';
  }
  return 'left';
};
var checkIsHeading = variant => {
  var headingsVariants = ['display', 'display1', 'display2', 'title1', 'title2', 'title3', 'title4'];
  return headingsVariants.includes(variant);
};
var Component = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Text__Component",
  componentId: "lui__sc-xe5utb-0"
})(_ref => {
  var _theme$name;
  var {
    variant,
    theme,
    align,
    isMobile,
    styleTarget,
    $display,
    appearance,
    isInverse
  } = _ref;
  var fontSizeValue = getFontSize(variant);
  var isHeading = checkIsHeading(variant);
  var hasDesktopFontSize = Object.prototype.hasOwnProperty.call(fontSizeValue, 'desktop');
  var themeName = (_theme$name = theme === null || theme === void 0 ? void 0 : theme.name) !== null && _theme$name !== void 0 ? _theme$name : (0,commons_esm/* getThemeName */.Yo)(); // fallback to old getTheme function when latest Theme not being used. To be removed in next major

  var styleObj = {
    margin: 0,
    display: $display !== null && $display !== void 0 ? $display : 'block',
    fontFamily: isHeading ? theme.asset.font.heading.family : theme.asset.font.body.family,
    fontWeight: (0,typography_dist_commons_esm/* default */.Z)(variant, 'fontWeight'),
    textAlign: align !== null && align !== void 0 ? align : getThemeTextAlignment(themeName),
    color: isInverse ? theme.color.text.inverse : getTextColor(theme, appearance),
    fontSize: fontSizeValue.mobile,
    lineHeight: getLineHeight(variant),
    a: linkStyle(theme)
  };
  if (variant === 'overline') {
    styleObj = Object.assign({
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }, styleObj);
  }
  if (hasDesktopFontSize && !isMobile) {
    styleObj = Object.assign({
      [BreakpointMedia.sm]: {
        fontSize: fontSizeValue.desktop
      }
    }, styleObj);
  }
  if (styleTarget) {
    return {
      [styleTarget]: styleObj
    };
  }
  return styleObj;
});
var Text = _ref2 => {
  var {
      children,
      variant = 'body1',
      className
    } = _ref2,
    props = objectWithoutProperties_7e1dfdab_esm_objectWithoutProperties(_ref2, RichText_50b4a7f5_esm_excluded$1);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var textVariantClass;
  switch (variant) {
    case 'display':
      textVariantClass = 'lui-display';
      break;
    case 'display1':
      textVariantClass = 'lui-display1';
      break;
    case 'display2':
      textVariantClass = 'lui-display2';
      break;
    case 'title1':
      textVariantClass = 'lui-title1';
      break;
    case 'title2':
      textVariantClass = 'lui-title2';
      break;
    case 'title3':
      textVariantClass = 'lui-title3';
      break;
    case 'title4':
      textVariantClass = 'lui-title4';
      break;
    case 'lead1':
      textVariantClass = 'lui-lead1';
      break;
    case 'lead2':
      textVariantClass = 'lui-lead2';
      break;
    case 'subtitle1':
      textVariantClass = 'lui-subtitle1';
      break;
    case 'subtitle2':
      textVariantClass = 'lui-subtitle2';
      break;
    case 'body1':
      textVariantClass = 'lui-body1';
      break;
    case 'body2':
      textVariantClass = 'lui-body2';
      break;
    case 'button1':
      textVariantClass = 'lui-button1';
      break;
    case 'button2':
      textVariantClass = 'lui-button2';
      break;
    case 'detail1':
      textVariantClass = 'lui-detail1';
      break;
    case 'detail2':
      textVariantClass = 'lui-detail2';
      break;
    case 'overline':
      textVariantClass = 'lui-overline';
      break;
    default:
      textVariantClass = 'lui-body1';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, index_03130070_esm_objectSpread2(index_03130070_esm_objectSpread2({
    id: props.id,
    className: className ? "".concat(className, " ").concat(textVariantClass) : textVariantClass,
    as: props.tag,
    variant: variant,
    align: props.align,
    appearance: props.appearance,
    isMobile: props.isMobile,
    htmlFor: props.for,
    $display: props.display,
    role: props.role,
    isInverse: props.isInverse
  }, globalProps), {}, {
    children: children
  }));
};

var Paragraph = (0,styled_components_browser_esm/* default */.ZP)(Text).withConfig({
  displayName: "Paragraph",
  componentId: "lui__sc-iqzapc-0"
})(_ref => {
  var {
    theme
  } = _ref;
  return {
    a: linkStyle(theme)
  };
});
var P = _ref2 => {
  var {
    appearance,
    variant,
    children
  } = _ref2;
  return /*#__PURE__*/jsx(Paragraph, {
    variant: variant !== null && variant !== void 0 ? variant : 'body1',
    tag: "p",
    appearance: appearance,
    children: children
  });
};

var A = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Link__A",
  componentId: "lui__sc-1u7drzy-0"
})(["", ""], _ref => {
  var {
    theme
  } = _ref;
  return linkStyle(theme);
});

var RichText_50b4a7f5_esm_excluded = (/* unused pure expression or super */ null && (["children", "textSize"]));
var StyledRichText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RichText__StyledRichText",
  componentId: "lui__sc-nganh6-0"
})(["font-size:", ";line-height:", ";color:", ";", "{font-size:", ";}> *{font-family:", ";font-weight:", ";font-size:1em;margin-bottom:0;margin-top:0;}> * + *{margin-top:", ";", "{margin-top:", ";}}> * li{margin-top:0.5em;}> * + h1,> * + h2,> * + div,> div + *{margin-top:", ";}> h1 + *,> h2 + *{margin-top:", ";}> h3 + *,> h4 + *{margin-top:", ";}> * + h3,> * + h4{margin-top:", ";}> h1,> h2,> h3,> h4{font-family:", ";line-height:", ";font-weight:", ";color:", ";}> h1{font-size:", ";", ";}> h2{font-size:", ";", ";}> h3{font-size:", ";}> h4{font-size:", ";}> a,li > a,p > a{", ";}"], (0,commons_esm/* pxToRem */.Q1)(baseFontSize), styleData.body1.lineHeight, _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.subtle;
}, BreakpointMedia.sm, _ref2 => {
  var {
    textSize
  } = _ref2;
  return textSize === 'lg' && (0,commons_esm/* pxToRem */.Q1)(fontSize[5]);
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.asset.font.body.family;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.asset.font.body.weight;
}, (0,commons_esm/* pxToRem */.Q1)(fontSize[3]), BreakpointMedia.sm, _ref5 => {
  var {
    textSize
  } = _ref5;
  return textSize === 'lg' && (0,commons_esm/* pxToRem */.Q1)(fontSize[5]);
}, (0,commons_esm/* pxToRem */.Q1)(fontSize[10]), (0,commons_esm/* pxToRem */.Q1)(fontSize[6]), (0,commons_esm/* pxToRem */.Q1)(fontSize[5]), (0,commons_esm/* pxToRem */.Q1)(fontSize[9]), _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.asset.font.body.family;
}, LineHeight.heading, _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.asset.font.heading.weight;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.color.text.main;
}, styleData.display2.fontSize.mobile, 'desktop' in styleData.display2.fontSize && (0,styled_components_browser_esm/* css */.iv)(["", "{font-size:", ";}"], BreakpointMedia.sm, styleData.display2.fontSize.desktop), styleData.title1.fontSize.mobile, 'desktop' in styleData.title1.fontSize && (0,styled_components_browser_esm/* css */.iv)(["", "{font-size:", ";}"], BreakpointMedia.sm, styleData.title1.fontSize.desktop), styleData.title2.fontSize.mobile, styleData.title3.fontSize.mobile, _ref9 => {
  var {
    theme
  } = _ref9;
  return linkStyle(theme);
});

// Direct children have margin removed and are spaced out xs
var RichText = _ref10 => {
  var {
      children,
      textSize = 'md'
    } = _ref10,
    props = _objectWithoutProperties(_ref10, RichText_50b4a7f5_esm_excluded);
  return /*#__PURE__*/jsx(StyledRichText, _objectSpread2(_objectSpread2({
    textSize: textSize
  }, props), {}, {
    children: children
  }));
};



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/ui/Typography/dist/ui.esm.js









;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/apis/getThreads/index.js
var getThreads_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var getThreads_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var getThreads = function (session, onException) { return getThreads_awaiter(void 0, void 0, void 0, function () {
    var apiBaseUrl, config, _a, status, data, threads;
    return getThreads_generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiBaseUrl = (0,lala_utils_dist_esm/* getAPIBaseURL */.K0)(session.environment);
                config = {
                    apiBaseUrl: apiBaseUrl,
                    headers: {
                        Authorization: "Bearer ".concat(session.token),
                        'Content-Type': 'application/json',
                    },
                };
                return [4 /*yield*/, axios/* default.get */.Z.get("".concat(apiBaseUrl, "/v2/chat/threads"), config)];
            case 1:
                _a = _b.sent(), status = _a.status, data = _a.data;
                if (status === 200) {
                    threads = data.data.threads;
                    return [2 /*return*/, {
                            threads: threads,
                        }];
                }
                else {
                    onException(new Error("@lendi/chat: getThreads: failed to get messages ".concat(status)));
                    return [2 /*return*/, { threads: [] }];
                }
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/StatusBar/style.js
var StatusBar_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var style_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(StatusBar_style_templateObject_3 || (StatusBar_style_templateObject_3 = StatusBar_style_makeTemplateObject(["\n  padding: 8px 0;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  font-weight: 400;\n  font-size: 12px;\n  justify-content: center;\n  font-family: ", ";\n\n  ", "\n"], ["\n  padding: 8px 0;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  font-weight: 400;\n  font-size: 12px;\n  justify-content: center;\n  font-family: ", ";\n\n  ", "\n"])), (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'), function (_a) {
    var highlighted = _a.highlighted;
    return highlighted
        ? (0,styled_components_browser_esm/* css */.iv)(StatusBar_style_templateObject_1 || (StatusBar_style_templateObject_1 = StatusBar_style_makeTemplateObject(["\n          background: ", ";\n          color: ", ";\n        "], ["\n          background: ", ";\n          color: ", ";\n        "])), (0,colours_dist_commons_esm/* default */.ZP)('fill', 'contrast'), (0,colours_dist_commons_esm/* default */.ZP)('text', 'inverse')) : (0,styled_components_browser_esm/* css */.iv)(StatusBar_style_templateObject_2 || (StatusBar_style_templateObject_2 = StatusBar_style_makeTemplateObject(["\n          background: ", ";\n          color: ", ";\n        "], ["\n          background: ", ";\n          color: ", ";\n        "])), (0,colours_dist_commons_esm/* default */.ZP)('background', 'surface'), (0,colours_dist_commons_esm/* default */.ZP)('text', 'subtle'));
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU)(StatusBar_style_templateObject_4 || (StatusBar_style_templateObject_4 = StatusBar_style_makeTemplateObject([""], [""])));
var UnreadCount = styled_components_browser_esm/* default.span */.ZP.span(StatusBar_style_templateObject_5 || (StatusBar_style_templateObject_5 = StatusBar_style_makeTemplateObject(["\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  position: relative;\n  background: white;\n  margin-right: 5px;\n  color: ", ";\n  font-size: 12px;\n  text-align: center;\n  line-height: 2;\n"], ["\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  position: relative;\n  background: white;\n  margin-right: 5px;\n  color: ", ";\n  font-size: 12px;\n  text-align: center;\n  line-height: 2;\n"])), (0,colours_dist_commons_esm/* default */.ZP)('fill', 'contrast'));
var StatusBar_style_templateObject_1, StatusBar_style_templateObject_2, StatusBar_style_templateObject_3, StatusBar_style_templateObject_4, StatusBar_style_templateObject_5;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/StatusBar/index.js
var StatusBar_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var StatusBar_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var REFRESH_TIMEOUT_MS = 30 * 1000;
var StatusBar = function (_a) {
    var currentThread = _a.currentThread, showThreadsPanel = _a.showThreadsPanel;
    var _b = (0,react.useState)({ threads: [] }), otherThreadsResponse = _b[0], setOtherThreadsResponse = _b[1];
    var _c = (0,react.useState)(0), unReadMessageCount = _c[0], setUnReadMessageCount = _c[1];
    var _d = (0,react.useState)(''), unreadMessage = _d[0], setUnreadMessage = _d[1];
    var session = (0,dist_esm/* useSession */.kP)();
    var onException = useError().onException;
    (0,react.useEffect)(function () {
        var getMessagesStatus = function () { return StatusBar_awaiter(void 0, void 0, void 0, function () {
            var threads, otherThreads;
            return StatusBar_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getThreads(session, onException)];
                    case 1:
                        threads = (_a.sent()).threads;
                        otherThreads = threads.filter(function (t) { return t.userGroupHash !== currentThread; });
                        setOtherThreadsResponse({ threads: otherThreads });
                        return [2 /*return*/];
                }
            });
        }); };
        getMessagesStatus();
        var timerId = setInterval(getMessagesStatus, REFRESH_TIMEOUT_MS);
        return function () {
            clearTimeout(timerId);
        };
    }, []);
    (0,react.useEffect)(function () {
        var noOfUnreadMessages = otherThreadsResponse.threads.reduce(function (total, thread) { return total + thread.unreadMessageCount; }, 0);
        setUnReadMessageCount(noOfUnreadMessages);
    }, [otherThreadsResponse]);
    (0,react.useEffect)(function () {
        var noOfOtherThreads = otherThreadsResponse.threads.length;
        if (unReadMessageCount > 0) {
            var dynamicVariable1 = unReadMessageCount > 1 ? "Messages" : 'Message';
            var dynamicVariable2 = noOfOtherThreads > 1 ? "other threads" : 'another thread';
            var message = "New ".concat(dynamicVariable1, " on ").concat(dynamicVariable2);
            setUnreadMessage(message);
        }
    }, [unReadMessageCount, otherThreadsResponse]);
    return otherThreadsResponse.threads.length >= 1 ? (react.createElement(style_Wrapper, { highlighted: unReadMessageCount > 0 }, unReadMessageCount > 0 ? (react.createElement(react.Fragment, null,
        react.createElement(UnreadCount, null, unReadMessageCount),
        react.createElement(Text, { variant: "body2", tag: "span", isInverse: unReadMessageCount > 0 },
            unreadMessage,
            " ",
            ' - ',
            react.createElement(StyledLink, { onClick: showThreadsPanel }, "Click here")))) : (react.createElement(Text, { variant: "body2", tag: "span" },
        "There are multiple threads ",
        ' - ',
        react.createElement(StyledLink, { onClick: showThreadsPanel }, "View threads"))))) : (react.createElement(react.Fragment, null));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/CurrentThread/index.js















var CurrentThread = function (_a) {
    var migratedToConversation = _a.migratedToConversation, channelId = _a.channelId, openChat = _a.openChat, userType = _a.userType, teamMember = _a.teamMember, setActivePanel = _a.setActivePanel, onClose = _a.onClose;
    var errorState = (0,context/* useBootstrappedChatState */.D)().errorState;
    var session = (0,dist_esm/* useSession */.kP)();
    var _b = useActivateUserGroup(openChat, session, channelId), identity = _b[0], accessToken = _b[1];
    var ChatProviderComponent = migratedToConversation ? ConversationProvider : ChatProvider;
    var isTeamView = userType === 'broker';
    var _c = useRestrictedTeamView(), teamRestrictedView = _c.teamRestrictedView, restrictedViewLoading = _c.restrictedViewLoading, restrictedViewResponse = _c.restrictedViewResponse, fetchNextPage = _c.fetchNextPage;
    var onShowHistory = function () {
        setActivePanel(ChatPanels.Threads);
        analytics({
            event_name: 'Menu Item Clicked',
            category: common/* EventCategory.CHAT */.Jk.CHAT,
            menuName: 'Kebab menu',
            text: 'History',
        });
    };
    if (errorState) {
        return react.createElement(ChatComponent_ErrorComponent, null);
    }
    if (!channelId || !identity || !accessToken || restrictedViewLoading) {
        return react.createElement(Loader, null);
    }
    if (teamRestrictedView) {
        return (react.createElement(react.Fragment, null,
            react.createElement(ChatHeader, { activePanel: ChatPanels.CurrentThread, onShowHistory: onShowHistory, showBackArrow: !isTeamView, teamRestrictedViewProps: {
                    teamRestrictedView: teamRestrictedView,
                    teamRestrictedViewParticipantsCount: restrictedViewResponse === null || restrictedViewResponse === void 0 ? void 0 : restrictedViewResponse.participantsCount,
                }, onClose: onClose }),
            react.createElement(RestrictedTeamViewChat, { restrictedViewResponse: restrictedViewResponse, fetchNextPage: fetchNextPage, restrictedViewLoading: restrictedViewLoading })));
    }
    return (react.createElement(ChatProviderComponent, { key: channelId, session: session, channelId: channelId, accessToken: accessToken, identity: identity, userType: userType },
        react.createElement(ChatDataExposer, { userType: userType },
            react.createElement(ChatHeader, { activePanel: ChatPanels.CurrentThread, onShowHistory: onShowHistory, showBackArrow: !isTeamView }),
            react.createElement(StatusBar, { showThreadsPanel: function () {
                    analytics({
                        event_name: 'Link Clicked',
                        category: common/* EventCategory.CHAT */.Jk.CHAT,
                        text: 'Click here',
                    });
                    setActivePanel(ChatPanels.Threads);
                }, currentThread: channelId }),
            openChat && react.createElement(ChatComponent_TwilioChatComponent, { userType: userType, teamMember: teamMember }))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/Threads/Thread/style.js
var Thread_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var ThreadWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(Thread_style_templateObject_1 || (Thread_style_templateObject_1 = Thread_style_makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 25px;\n  gap: 10px;\n  isolation: isolate;\n  height: 100px;\n  left: calc(50% - 375px / 2 + 7.5px);\n  top: calc(50% - 100px / 2 - 240px);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 115%;\n  text-align: justify;\n  border-bottom: 1px solid ", ";\n  color: ", ";\n  background: ", ";\n\n  :hover {\n    background: ", ";\n  }\n\n  cursor: pointer;\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 25px;\n  gap: 10px;\n  isolation: isolate;\n  height: 100px;\n  left: calc(50% - 375px / 2 + 7.5px);\n  top: calc(50% - 100px / 2 - 240px);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 115%;\n  text-align: justify;\n  border-bottom: 1px solid ", ";\n  color: ", ";\n  background: ", ";\n\n  :hover {\n    background: ", ";\n  }\n\n  cursor: pointer;\n"])), (0,colours_dist_commons_esm/* default */.ZP)('border', 'container'), (0,colours_dist_commons_esm/* default */.ZP)('text', 'main'), function (_a) {
    var highlighted = _a.highlighted;
    return (highlighted ? (0,colours_dist_commons_esm/* default */.ZP)('primary', '100') : (0,colours_dist_commons_esm/* default */.ZP)('base', 'primary'));
}, function (_a) {
    var highlighted = _a.highlighted;
    return (highlighted ? (0,colours_dist_commons_esm/* default */.ZP)('primary', '100') : (0,colours_dist_commons_esm/* default */.ZP)('secondary', '25'));
});
var FirstRowWrapper = styled_components_browser_esm/* default.div */.ZP.div(Thread_style_templateObject_2 || (Thread_style_templateObject_2 = Thread_style_makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
var SecondRowWrapper = styled_components_browser_esm/* default.div */.ZP.div(Thread_style_templateObject_3 || (Thread_style_templateObject_3 = Thread_style_makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
var style_TitleWrapper = styled_components_browser_esm/* default.div */.ZP.div(Thread_style_templateObject_4 || (Thread_style_templateObject_4 = Thread_style_makeTemplateObject(["\n  float: left;\n  font-family: ", ";\n  font-weight: ", ";\n"], ["\n  float: left;\n  font-family: ", ";\n  font-weight: ", ";\n"])), function (_a) {
    var boldTitle = _a.boldTitle;
    return (0,typography_dist_commons_esm/* default */.Z)(boldTitle ? 'title2' : 'body1', 'fontFamily');
}, function (_a) {
    var boldTitle = _a.boldTitle;
    return (0,typography_dist_commons_esm/* default */.Z)(boldTitle ? 'title2' : 'body1', 'fontWeight');
});
var style_TimeWrapper = styled_components_browser_esm/* default.div */.ZP.div(Thread_style_templateObject_5 || (Thread_style_templateObject_5 = Thread_style_makeTemplateObject(["\n  font-size: 12px;\n  flex-basis: 30%;\n  text-align: right;\n  float: right;\n"], ["\n  font-size: 12px;\n  flex-basis: 30%;\n  text-align: right;\n  float: right;\n"])));
var style_MessageWrapper = styled_components_browser_esm/* default.div */.ZP.div(Thread_style_templateObject_6 || (Thread_style_templateObject_6 = Thread_style_makeTemplateObject(["\n  font-size: 12px;\n  line-height: 115%;\n"], ["\n  font-size: 12px;\n  line-height: 115%;\n"])));
var UnreadCountWrapper = styled_components_browser_esm/* default.div */.ZP.div(Thread_style_templateObject_7 || (Thread_style_templateObject_7 = Thread_style_makeTemplateObject(["\n  width: 22px;\n  height: 22px;\n  text-align: center;\n  font-family: 'Open Sans';\n  font-size: 12px;\n  line-height: 16px;\n  float: right;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  color: ", ";\n"], ["\n  width: 22px;\n  height: 22px;\n  text-align: center;\n  font-family: 'Open Sans';\n  font-size: 12px;\n  line-height: 16px;\n  float: right;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  color: ", ";\n"])), (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'main'), (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'subtle'));
var Thread_style_templateObject_1, Thread_style_templateObject_2, Thread_style_templateObject_3, Thread_style_templateObject_4, Thread_style_templateObject_5, Thread_style_templateObject_6, Thread_style_templateObject_7;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/Threads/Thread/joinNames.js
function joinNames(allNames) {
    switch (allNames.length) {
        case 0:
            return 'None!';
        case 1:
            return allNames[0];
        case 2:
            return "".concat(allNames[0], " & ").concat(allNames[1]);
        case 3:
            return "".concat(allNames[0], ", ").concat(allNames[1], " & ").concat(allNames[2]);
        default:
            return "".concat(allNames[0], ", ").concat(allNames[1], " +").concat(allNames.length - 2);
    }
}
//# sourceMappingURL=joinNames.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/Threads/Thread/timeDiff.js
// Copied from https://stackoverflow.com/questions/6108819/javascript-timestamp-to-relative-time
function timeDifference(current, previous) {
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerWeek = msPerDay * 7;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;
    var elapsed = current.getTime() - previous.getTime();
    if (elapsed < msPerMinute) {
        return buildText(elapsed / 1000, 'second');
    }
    else if (elapsed < msPerHour) {
        return buildText(elapsed / msPerMinute, 'minute');
    }
    else if (elapsed < msPerDay) {
        return buildText(elapsed / msPerHour, 'hour');
    }
    else if (elapsed < msPerWeek) {
        return buildText(elapsed / msPerDay, 'day');
    }
    else if (elapsed < msPerMonth) {
        return buildText(elapsed / msPerWeek, 'week');
    }
    else if (elapsed < msPerYear) {
        return buildText(elapsed / msPerMonth, 'month');
    }
    else {
        return buildText(elapsed / msPerYear, 'year');
    }
}
function buildText(unit, unitName) {
    var roundedUnit = Math.round(unit);
    return roundedUnit === 1 ? "a ".concat(unitName, " ago") : "".concat(roundedUnit, " ").concat(unitName, "s ago");
}
//# sourceMappingURL=timeDiff.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/Threads/Thread/index.js
var Thread_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;





var brandTitle = (_a = {},
    _a[lala_utils_dist_esm/* Brand.Lendi */.H2.Lendi] = 'Lendi',
    _a[lala_utils_dist_esm/* Brand.Aussie */.H2.Aussie] = 'Aussie',
    _a[lala_utils_dist_esm/* Brand.Domain */.H2.Domain] = 'Domain Home Loans',
    _a);
var Thread = function (_a) {
    var userGroup = _a.userGroup, names = _a.names, highlighted = _a.highlighted, lastMessage = _a.lastMessage, lastMessageDatetimeUTC = _a.lastMessageDatetimeUTC, UnreadMessageCount = _a.UnreadMessageCount, onSelected = _a.onSelected;
    var brand = brandTitle[(0,lala_utils_dist_esm/* getBrandFromHostname */.Y6)()];
    return (react.createElement(ThreadWrapper, { highlighted: highlighted !== null && highlighted !== void 0 ? highlighted : false, onClick: function () { return onSelected(userGroup); } },
        react.createElement(FirstRowWrapper, null,
            react.createElement(style_TitleWrapper, { className: "threadTitle", boldTitle: UnreadMessageCount > 0 }, joinNames(Thread_spreadArray(Thread_spreadArray([], names, true), [brand], false))),
            react.createElement(style_TimeWrapper, null, lastMessageDatetimeUTC ? timeDifference(new Date(), new Date(lastMessageDatetimeUTC)) : '')),
        react.createElement(SecondRowWrapper, null,
            react.createElement(style_MessageWrapper, null, lastMessage.length > 30 ? lastMessage.slice(0, 30) + '...' : lastMessage),
            UnreadMessageCount > 0 && react.createElement(UnreadCountWrapper, null, UnreadMessageCount))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/Threads/index.js
var Threads_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Threads_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var REFRESH_INTERVAL_MS = 1000;
var Threads = function (_a) {
    var channelId = _a.channelId, onSelectThread = _a.onSelectThread, activePanel = _a.activePanel, onClose = _a.onClose;
    var _b = react.useState(false), loading = _b[0], setLoading = _b[1];
    var session = (0,dist_esm/* useSession */.kP)();
    var isTeamView = session.type === dist_esm/* Type.Team */.Dy.Team;
    var _c = react.useState({ threads: [] }), threadsResponse = _c[0], setThreadsResponse = _c[1];
    (0,react.useEffect)(function () {
        var fetchThreads = function () { return Threads_awaiter(void 0, void 0, void 0, function () {
            var getThreadFailed, threads;
            return Threads_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        getThreadFailed = false;
                        return [4 /*yield*/, getThreads(session, function (error) {
                                getThreadFailed = true;
                                console.error('Error fetching threads:', error);
                            })];
                    case 1:
                        threads = (_a.sent()).threads;
                        setThreadsResponse({ threads: threads });
                        if (threads.length === 1) {
                            // as there is only one thread, so that will become default active selected thread
                            onSelectThread(threads[0]);
                        }
                        if (getThreadFailed) {
                            setTimeout(fetchThreads, REFRESH_INTERVAL_MS);
                        }
                        setLoading(getThreadFailed);
                        return [2 /*return*/];
                }
            });
        }); };
        if (session.identity && activePanel === ChatPanels.Threads) {
            fetchThreads();
        }
    }, [session.identity, activePanel]);
    return loading ? (react.createElement(Loader, null)) : threadsResponse.threads.length > 1 ? (react.createElement("span", { "data-testid": "threads-component" },
        react.createElement(ChatHeader, { activePanel: ChatPanels.Threads, showBackArrow: !isTeamView, onClose: onClose }),
        threadsResponse.threads.map(function (ug) { return (react.createElement(Thread, { key: ug.userGroupHash, userGroup: ug, highlighted: channelId === ug.userGroupHash, lastMessage: ug.lastMessage.content, names: ug.customers.map(function (c) { return c.firstName; }), lastMessageDatetimeUTC: ug.lastMessage.utcDateTime, UnreadMessageCount: ug.unreadMessageCount, onSelected: function (ug) { return onSelectThread(ug); } })); }))) : (react.createElement(react.Fragment, null));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/ThreadsPanel/index.js




var ThreadsPanel = function (_a) {
    var openChat = _a.openChat, userType = _a.userType, channelId = _a.channelId, teamMember = _a.teamMember, migratedToConversation = _a.migratedToConversation, setSelectedThread = _a.setSelectedThread, applicationId = _a.applicationId, onClose = _a.onClose;
    var _b = (0,react.useState)(ChatPanels.Default), activePanel = _b[0], setActivePanel = _b[1];
    (0,react.useEffect)(function () {
        setActivePanel(applicationId ? ChatPanels.CurrentThread : ChatPanels.Threads);
    }, [applicationId]);
    var onSelectThread = function (selectedThread) {
        setSelectedThread({
            userGroupHash: selectedThread.userGroupHash,
            teamMemberIds: selectedThread.teamMembers.map(function (u) { return u.userId; }),
            isMigrated: selectedThread.migratedToConversation,
        });
        setActivePanel(ChatPanels.CurrentThread);
    };
    // no channelId or show history panel
    if (activePanel === ChatPanels.Threads) {
        // load threads
        return (react.createElement(Threads, { channelId: channelId, onSelectThread: onSelectThread, activePanel: activePanel, onClose: onClose }));
    }
    // load channel
    return (react.createElement(CurrentThread, { migratedToConversation: !!migratedToConversation, openChat: openChat, userType: userType, channelId: channelId, teamMember: teamMember, setActivePanel: setActivePanel, onClose: onClose }));
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/grid/dist/grid.esm.js
var grid_esm = __webpack_require__(63518);
// EXTERNAL MODULE: ../../../node_modules/react-final-form/dist/react-final-form.es.js + 1 modules
var react_final_form_es = __webpack_require__(75514);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/sendLeads.js
var sendLeads_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var sendLeads_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var sendLeads = function (_a) {
    var phoneNumber = _a.phoneNumber, firstName = _a.firstName, email = _a.email, chatDispatch = _a.chatDispatch, environment = _a.environment, brand = _a.brand, onException = _a.onException;
    return sendLeads_awaiter(void 0, void 0, void 0, function () {
        var baseUrl, data, response, err_1;
        var _b, _c;
        return sendLeads_generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    baseUrl = (0,lala_utils_dist_esm/* getAPIBaseURL */.K0)(environment);
                    if (!(phoneNumber && firstName)) return [3 /*break*/, 4];
                    data = {
                        generatedAt: new Date().toISOString(),
                        mobileNumber: phoneNumber,
                        firstName: firstName,
                        email: email,
                        origin: lendigroup_leads_library_dist_esm/* Origin.Chat */.aP.Chat,
                        brand: brand,
                        accountOrigin: window.location.href,
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, lendigroup_leads_library_dist_esm/* LendiGroupLeads.sendLatestLead */.vA.sendLatestLead(baseUrl, data)];
                case 2:
                    response = _d.sent();
                    response && chatDispatch({ type: Types.SAVE_LEADS, payload: (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.id });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _d.sent();
                    onException(new Error("@lendi/chat: useLeads: Could not send leads for the customer: ".concat(err_1)));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=sendLeads.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/validateInput.js

var trimPhoneNumber = function (phoneNumber) { return phoneNumber.split(' ').join(''); };
var validateInput = function (values, showEmail) {
    var errors = {};
    if (!values.firstName) {
        errors.firstName = FIRST_NAME_ERROR;
    }
    if (!values.phoneNumber || !trimPhoneNumber(values.phoneNumber).match(/^0?4\d{8}$/)) {
        errors.phoneNumber = MOBILE_ERROR;
    }
    if (showEmail &&
        (!values.email ||
            !String(values.email)
                .toLowerCase()
                .match(/^((?!.*#)([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))) {
        errors.email = values.email ? EMAIL_FIELD_VALIDATION_LABEL : EMAIL_FIELD_EMPTY_LABEL;
    }
    return errors;
};
var validateOtpInput = function (values, wrongNumberClicked) {
    var errors = {};
    if (!wrongNumberClicked && (!values.code || values.code.length !== 6)) {
        errors.code = OTP_VERIFY_FIELD_LABEL;
    }
    return errors;
};
//# sourceMappingURL=validateInput.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/atoms/ButtonWithMargin.js
var ButtonWithMargin_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



// @ts-ignore
var Button = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx)(ButtonWithMargin_templateObject_1 || (ButtonWithMargin_templateObject_1 = ButtonWithMargin_makeTemplateObject(["\n  ", ";\n  width: 70%;\n  height: 48px;\n"], ["\n  ", ";\n  width: 70%;\n  height: 48px;\n"])), spacing_esm/* margin */.e);
var ButtonWithMargin_templateObject_1;
//# sourceMappingURL=ButtonWithMargin.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/atoms/LoadingButton.js
var LoadingButton_assign = (undefined && undefined.__assign) || function () {
    LoadingButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return LoadingButton_assign.apply(this, arguments);
};
var LoadingButton_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



var LoadingButton = function (_a) {
    var loading = _a.loading, children = _a.children, props = LoadingButton_rest(_a, ["loading", "children"]);
    return react.createElement(Button, LoadingButton_assign({}, props), loading ? react.createElement(spinner_esm/* default */.Z, { variant: "light" }) : children);
};
//# sourceMappingURL=LoadingButton.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/field/dist/field.esm.js + 4 modules
var field_esm = __webpack_require__(136);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/Person/dist/icon.esm.js
var dist_icon_esm = __webpack_require__(81114);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/Smartphone/dist/icon.esm.js
var Smartphone_dist_icon_esm = __webpack_require__(33540);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/Message/dist/icon.esm.js
var Message_dist_icon_esm = __webpack_require__(5924);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/icon/Email/dist/icon.esm.js
var Email_dist_icon_esm = __webpack_require__(79007);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/FieldComponents/index.js
var FieldComponents_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var FieldComponents_assign = (undefined && undefined.__assign) || function () {
    FieldComponents_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return FieldComponents_assign.apply(this, arguments);
};










var PersonIcon = function () { return (react.createElement(FieldComponents_BeforeWrapper, null,
    react.createElement(dist_icon_esm/* default */.Z, { color: (0,colours_dist_commons_esm/* default */.ZP)('fill', 'accent'), width: "24px", height: "24px" }))); };
var PhoneIcon = function () { return (react.createElement(FieldComponents_BeforeWrapper, null,
    react.createElement(Smartphone_dist_icon_esm/* default */.Z, { color: (0,colours_dist_commons_esm/* default */.ZP)('fill', 'accent'), width: "24px", height: "24px" }),
    " ",
    react.createElement(react.Fragment, null, "+61"))); };
var MessageIcon = function () { return (react.createElement(FieldComponents_BeforeWrapper, null,
    react.createElement(Message_dist_icon_esm/* default */.Z, { color: (0,colours_dist_commons_esm/* default */.ZP)('fill', 'accent'), width: "24px", height: "24px" }))); };
var EmailIcon = function () { return (react.createElement(FieldComponents_BeforeWrapper, null,
    react.createElement(Email_dist_icon_esm/* default */.Z, { color: (0,colours_dist_commons_esm/* default */.ZP)('fill', 'accent'), width: "24px", height: "24px" }))); };
var RFFFieldWrapper = styled_components_browser_esm/* default.div */.ZP.div(FieldComponents_templateObject_1 || (FieldComponents_templateObject_1 = FieldComponents_makeTemplateObject(["\n  .khJtlg {\n    font-family: 'Open Sans';\n  }\n  .sc-TOsTZ,\n  .Heading-lui__sc-37fddq-0 {\n    font-size: 14px;\n  }\n  .indexstyle__Layout-lui__sc-lnm15l-0 {\n    height: 40px;\n  }\n  .Body-lui__sc-1yhxwuv-0 {\n    font-size: 10px;\n  }\n  .indexstyle__InputWrapper-lui__sc-lnm15l-1 {\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  ", "\n  ", "\n  text-align: center;\n"], ["\n  .khJtlg {\n    font-family: 'Open Sans';\n  }\n  .sc-TOsTZ,\n  .Heading-lui__sc-37fddq-0 {\n    font-size: 14px;\n  }\n  .indexstyle__Layout-lui__sc-lnm15l-0 {\n    height: 40px;\n  }\n  .Body-lui__sc-1yhxwuv-0 {\n    font-size: 10px;\n  }\n  .indexstyle__InputWrapper-lui__sc-lnm15l-1 {\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  ", "\n  ", "\n  text-align: center;\n"])), (0,spacing_esm.my)('sm'), (0,color_esm.fg)('shade.500'));
// @ts-ignore
var FieldComponents_BeforeWrapper = styled_components_browser_esm/* default.span */.ZP.span(FieldComponents_templateObject_2 || (FieldComponents_templateObject_2 = FieldComponents_makeTemplateObject(["\n  white-space: nowrap;\n  ", "\n  ", "\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"], ["\n  white-space: nowrap;\n  ", "\n  ", "\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"])), (0,spacing_esm.ml)('sm'), (0,typography_esm/* body */.d1)({ size: 'lg', color: 'shade.500' }));
var FirstNameField = function (_a) {
    var labelText = _a.labelText, autoFocus = _a.autoFocus, onInputChange = _a.onInputChange, error = _a.error, resetAuthError = _a.resetAuthError, isDisabled = _a.isDisabled;
    return (react.createElement(RFFFieldWrapper, null,
        react.createElement(react_final_form_es/* Field */.gN, { name: "firstName", type: "text" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (react.createElement(field_esm/* default */.Z, FieldComponents_assign({}, meta, { label: labelText, htmlFor: "firstNameInput" }),
                react.createElement(Input
                // to pass the UTs
                , FieldComponents_assign({ 
                    // to pass the UTs
                    crossOrigin: "" }, input, { enterKeyHint: 'enter', type: "text", isFullWidth: true, disabled: isDisabled, placeholder: "Type your first name here", "data-testid": "request-first-name", "aria-label": "first name", size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, autoFocus: autoFocus, before: react.createElement(PersonIcon, null), onChange: function (e) {
                        if (error)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    }, className: "fs-exclude" }))));
        })));
};
var MobileField = function (_a) {
    var autoFocus = _a.autoFocus, error = _a.error, resetAuthError = _a.resetAuthError, labelText = _a.labelText, onInputChange = _a.onInputChange, isDisabled = _a.isDisabled;
    return (react.createElement(RFFFieldWrapper, null,
        react.createElement(react_final_form_es/* Field */.gN, { name: "phoneNumber", type: "tel" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (react.createElement(field_esm/* default */.Z, FieldComponents_assign({}, meta, { label: labelText, htmlFor: "phoneNumberInput" }),
                react.createElement(Input
                // to pass the UTs
                , FieldComponents_assign({ 
                    // to pass the UTs
                    crossOrigin: "" }, input, { enterKeyHint: 'enter', type: "tel", isFullWidth: true, disabled: isDisabled, "data-testid": "request-code-phone-number", autoComplete: "tel", autoFocus: autoFocus, size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, "aria-label": "phone number", before: react.createElement(PhoneIcon, null), onChange: function (e) {
                        if (error)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    }, className: "fs-exclude" }))));
        })));
};
var EmailField = function (_a) {
    var error = _a.error, resetAuthError = _a.resetAuthError, label = _a.label, onInputChange = _a.onInputChange, isDisabled = _a.isDisabled;
    return (react.createElement(RFFFieldWrapper, null,
        react.createElement(react_final_form_es/* Field */.gN, { name: "email" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (react.createElement(field_esm/* default */.Z, FieldComponents_assign({}, meta, { label: label, htmlFor: "emailInput" }),
                react.createElement(Input
                // to pass the UTs
                , FieldComponents_assign({ 
                    // to pass the UTs
                    crossOrigin: "" }, input, { enterKeyHint: 'enter', placeholder: "Enter your email address", autoComplete: "email", type: "email", "data-testid": "email-field", disabled: isDisabled, size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, isFullWidth: true, before: react.createElement(EmailIcon, null), onChange: function (e) {
                        if (error && resetAuthError)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    }, className: "fs-exclude" }))));
        })));
};
var VerifyOtpField = function (_a) {
    var autoFocus = _a.autoFocus, error = _a.error, resetAuthError = _a.resetAuthError, label = _a.label, isDisabled = _a.isDisabled, onInputChange = _a.onInputChange;
    return (react.createElement(RFFFieldWrapper, null,
        react.createElement(react_final_form_es/* Field */.gN, { name: "code", type: "tel" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (react.createElement(field_esm/* default */.Z, FieldComponents_assign({}, meta, { label: label, htmlFor: "verifyCodeInput" }),
                react.createElement(Input
                // to pass the UTs
                , FieldComponents_assign({ 
                    // to pass the UTs
                    crossOrigin: "", type: "tel", autoFocus: autoFocus, enterKeyHint: 'enter', autoComplete: "one-time-code", size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, isFullWidth: true, disabled: isDisabled, className: "fs-exclude", placeholder: "Enter 6 digit code", before: react.createElement(MessageIcon, null) }, input, { "data-testid": "verify-code-input", onChange: function (e) {
                        if (error && resetAuthError)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    } }))));
        })));
};
var FieldComponents_templateObject_1, FieldComponents_templateObject_2;
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SignIn/style.js
var SignIn_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var SignIn_style_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(SignIn_style_templateObject_1 || (SignIn_style_templateObject_1 = SignIn_style_makeTemplateObject(["\n  padding: 0px 20px;\n\n  ", ";\n"], ["\n  padding: 0px 20px;\n\n  ", ";\n"])), function (props) {
    return props.experiment1
        ? "\n      padding: 0px 20px 40px 20px;\n    "
        : "\n      padding: 0px 20px;\n    ";
});
var Margin = styled_components_browser_esm/* default.div */.ZP.div(SignIn_style_templateObject_2 || (SignIn_style_templateObject_2 = SignIn_style_makeTemplateObject(["\n  margin-top: 20px;\n"], ["\n  margin-top: 20px;\n"])));
var SignIn_style_templateObject_1, SignIn_style_templateObject_2;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/authError.js


var authError_matchPatterns;
(function (matchPatterns) {
    matchPatterns["WRONG_CODE"] = "passcode incorrect";
    matchPatterns["TOO_MANY_ATTEMPTS"] = "attempts";
    matchPatterns["BLOCKED_USER"] = "blocked";
    matchPatterns["NUMBER_NOT_WORKING"] = "not working";
    matchPatterns["SMS_GATEWAY_NOT_WORKING"] = "SMS gateway";
    matchPatterns["POPUP_CLOSED"] = "User closed the popup window";
    matchPatterns["INVALID_COUNTRY"] = "non-allowed country";
})(authError_matchPatterns || (authError_matchPatterns = {}));
var handleAuthError = function (_a) {
    var error = _a.error, authDispatch = _a.authDispatch, onException = _a.onException;
    if (!error) {
        return;
    }
    switch (error.code) {
        case lala_utils_dist_esm/* ErrorCodes.ACCESS_DENIED */.SM.ACCESS_DENIED:
            if (error.description.toLowerCase().includes(authError_matchPatterns.WRONG_CODE)) {
                authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* WrongCode */.zl() });
            }
            else if (error.description.toLowerCase().includes(authError_matchPatterns.TOO_MANY_ATTEMPTS)) {
                authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* TooManyAttempts */.LQ() });
            }
            break;
        case lala_utils_dist_esm/* ErrorCodes.BLOCKED_USER */.SM.BLOCKED_USER:
            authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* BlockedUser */.Xd() });
            break;
        case lala_utils_dist_esm/* ErrorCodes.TOO_MANY_ATTEMPTS */.SM.TOO_MANY_ATTEMPTS:
            authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* TooManyAttempts */.LQ() });
            break;
        case lala_utils_dist_esm/* ErrorCodes.UNAUTHORIZED */.SM.UNAUTHORIZED:
            if (error.description.toLowerCase().includes(authError_matchPatterns.INVALID_COUNTRY)) {
                authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* InvalidCountry */.CQ() });
            }
            break;
        case lala_utils_dist_esm/* ErrorCodes.SMS_PROVIDER_ERROR */.SM.SMS_PROVIDER_ERROR:
            if (error.description.toLowerCase().includes(authError_matchPatterns.NUMBER_NOT_WORKING)) {
                authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* NumberNotWorking */.Up() });
            }
            else if (error.description.toLowerCase().includes(authError_matchPatterns.SMS_GATEWAY_NOT_WORKING)) {
                authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* SMSGatewayError */.Zb() });
            }
            break;
        case lala_utils_dist_esm/* ErrorCodes.NUMBER_NOT_WORKING */.SM.NUMBER_NOT_WORKING:
            authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* NumberNotWorking */.Up() });
            break;
        case lala_utils_dist_esm/* ErrorCodes.GENERIC */.SM.GENERIC:
        case lala_utils_dist_esm/* ErrorCodes.PARSE_STATE */.SM.PARSE_STATE:
        default:
            authDispatch({ type: AuthActions_Types.ERROR, payload: new lala_utils_dist_esm/* GenericError */.pY() });
            break;
    }
    onException(new Error("@lendi/chat: SmartChat: unable to send code: ".concat(error.description)));
};
//# sourceMappingURL=authError.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChatExperiment1/style.js
var SmartChatExperiment1_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var TextCommonStyle = (0,styled_components_browser_esm/* css */.iv)(SmartChatExperiment1_style_templateObject_1 || (SmartChatExperiment1_style_templateObject_1 = SmartChatExperiment1_style_makeTemplateObject(["\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n"], ["\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n"])));
var BrokerFaces = styled_components_browser_esm/* default.img */.ZP.img(SmartChatExperiment1_style_templateObject_2 || (SmartChatExperiment1_style_templateObject_2 = SmartChatExperiment1_style_makeTemplateObject(["\n  padding: 16px 40px 0px 40px;\n"], ["\n  padding: 16px 40px 0px 40px;\n"])));
var HeaderText = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(SmartChatExperiment1_style_templateObject_3 || (SmartChatExperiment1_style_templateObject_3 = SmartChatExperiment1_style_makeTemplateObject(["\n  ", "\n  padding: 16px 17px;\n  font-weight: 400;\n  color: ", ";\n"], ["\n  ", "\n  padding: 16px 17px;\n  font-weight: 400;\n  color: ", ";\n"])), TextCommonStyle, (0,colours_dist_commons_esm/* default */.ZP)('text', 'subtle'));
var style_HeaderWrapper = styled_components_browser_esm/* default.div */.ZP.div(SmartChatExperiment1_style_templateObject_4 || (SmartChatExperiment1_style_templateObject_4 = SmartChatExperiment1_style_makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var Heading = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(SmartChatExperiment1_style_templateObject_5 || (SmartChatExperiment1_style_templateObject_5 = SmartChatExperiment1_style_makeTemplateObject(["\n  font-weight: 700;\n  ", "\n  color:", ";\n"], ["\n  font-weight: 700;\n  ", "\n  color:", ";\n"])), TextCommonStyle, (0,color_esm/* color */.$)('shade.700'));
var Devider = styled_components_browser_esm/* default.div */.ZP.div(SmartChatExperiment1_style_templateObject_6 || (SmartChatExperiment1_style_templateObject_6 = SmartChatExperiment1_style_makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n  ", ";\n"])), (0,color_esm/* color */.$)('shade.100'), function (props) {
    return props.hasMargin
        ? "\n      margin: 0px -34px 20px -29px;\n    "
        : "\n      width: 100%;\n    ";
});
var SmartChatExperiment1_style_templateObject_1, SmartChatExperiment1_style_templateObject_2, SmartChatExperiment1_style_templateObject_3, SmartChatExperiment1_style_templateObject_4, SmartChatExperiment1_style_templateObject_5, SmartChatExperiment1_style_templateObject_6;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SignIn/index.js
var SignIn_assign = (undefined && undefined.__assign) || function () {
    SignIn_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return SignIn_assign.apply(this, arguments);
};
var SignIn_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SignIn_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

















var SignIn = function (_a) {
    var chatState = _a.chatState, chatDispatch = _a.chatDispatch, authState = _a.authState, authDispatch = _a.authDispatch, showEmail = _a.showEmail, experiment1 = _a.experiment1;
    var _b = (0,context/* useBootstrappedChatState */.D)(), chatInputFields = _b.chatInputFields, setChatInputFields = _b.setChatInputFields;
    var _c = (0,dist_esm/* useSession */.kP)(), environment = _c.environment, brand = _c.brand, sendCode = _c.sendCode;
    var onException = useError().onException;
    var _d = (0,react.useState)(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = (0,react.useState)(false), submitted = _e[0], setSubmitted = _e[1];
    var phoneNumber = chatState.phoneNumber, firstName = chatState.firstName, _f = chatState.email, email = _f === void 0 ? '' : _f;
    var error = authState.error;
    var resetAuthError = function () {
        authDispatch({ type: AuthActions_Types.ERROR, payload: null });
    };
    var onSubmit = function (values) { return SignIn_awaiter(void 0, void 0, void 0, function () {
        var firstName, phoneNumber, email, phone, error_1;
        return SignIn_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    firstName = values.firstName, phoneNumber = values.phoneNumber, email = values.email;
                    phone = "+61".concat(trimPhoneNumber(phoneNumber));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    chatDispatch({ type: Types.UPDATE_FIRST_NAME, payload: firstName });
                    chatDispatch({ type: Types.UPDATE_PHONE_NUMBER, payload: phone });
                    showEmail && chatDispatch({ type: Types.UPDATE_EMAIL, payload: email });
                    authDispatch({ type: AuthActions_Types.SEND_CODE });
                    return [4 /*yield*/, sendCode(phone)];
                case 2:
                    _a.sent();
                    authDispatch({ type: AuthActions_Types.SENT_CODE });
                    chatDispatch({
                        type: Types.NEXT_EXPERIMENT_ONE_SMART_STATE,
                        payload: SmartExperimentCheckpoint.ON_VERIFY_CHECK,
                    });
                    chatDispatch({ type: Types.SIGN_IN_SUBMITTED, payload: true });
                    sendLeads({
                        phoneNumber: phoneNumber,
                        email: email,
                        firstName: firstName,
                        chatDispatch: chatDispatch,
                        environment: environment,
                        brand: brand,
                        onException: onException,
                    });
                    analytics({
                        event_name: types/* ChatEventName.SUBMIT_FORM_CLICKED */.Y.SUBMIT_FORM_CLICKED,
                        category: common/* EventCategory.CHAT */.Jk.CHAT,
                    });
                    setSubmitted(true);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleAuthError({ error: error_1, authDispatch: authDispatch, onException: onException });
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    (0,react.useEffect)(function () {
        var trackEvent = function (event, value) {
            if (value) {
                analytics({
                    event_name: event,
                    category: common/* EventCategory.CHAT */.Jk.CHAT,
                });
            }
        };
        trackEvent(types/* ChatEventName.PHONE_NUMBER_ENTERED */.Y.PHONE_NUMBER_ENTERED, phoneNumber);
        showEmail && trackEvent(types/* ChatEventName.EMAIL_ENTERED */.Y.EMAIL_ENTERED, email);
        trackEvent(types/* ChatEventName.FIRST_NAME_ENTERED */.Y.FIRST_NAME_ENTERED, firstName);
    }, [phoneNumber, email, firstName]);
    var onInputChange = function (e) {
        var _a = e.target || {}, name = _a.name, value = _a.value;
        setChatInputFields(function (prev) {
            var _a;
            return (SignIn_assign(SignIn_assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    return (react.createElement(SignIn_style_Wrapper, { experiment1: experiment1 },
        !experiment1 && (react.createElement(react.Fragment, null,
            react.createElement(Devider, { hasMargin: true }),
            react.createElement(Heading, null, "Enter your details before we get started."))),
        react.createElement(grid_esm/* default */.ZP, { halign: "center" },
            react.createElement(grid_esm/* default.Unit */.ZP.Unit, { size: 1 },
                react.createElement(react_final_form_es/* Form */.l0, { initialValues: {
                        phoneNumber: (0,utils/* formatInitialPhoneNumber */.Z1)(phoneNumber || (chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.phoneNumber) || ''),
                        firstName: firstName || (chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.firstName),
                        email: email || (chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.email) || '',
                    }, validate: function (values) { return validateInput(values, showEmail); }, onSubmit: onSubmit }, function (_a) {
                    var handleSubmit = _a.handleSubmit, invalid = _a.invalid;
                    return (react.createElement("form", { style: { textAlign: 'center' }, onSubmit: handleSubmit },
                        react.createElement(FirstNameField, { autoFocus: true, labelText: "First Name", error: error, resetAuthError: resetAuthError, onInputChange: onInputChange, isDisabled: submitted }),
                        react.createElement(MobileField, { error: error, resetAuthError: resetAuthError, labelText: "Mobile number", onInputChange: onInputChange, isDisabled: submitted }),
                        showEmail && (react.createElement(EmailField, { error: error, resetAuthError: resetAuthError, label: "Email", isDisabled: submitted, onInputChange: onInputChange })),
                        react.createElement(LoadingButton, { type: "submit", mt: "xxs", variant: "primary", "data-testid": "sign-in", isDisabled: invalid || submitted, loading: isLoading, isFullWidth: true }, 'SUBMIT')));
                }))),
        !experiment1 && (react.createElement(Margin, null,
            react.createElement(Devider, { hasMargin: true })))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/Verify/style.js
var Verify_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var style_TextCommonStyle = (0,styled_components_browser_esm/* css */.iv)(Verify_style_templateObject_1 || (Verify_style_templateObject_1 = Verify_style_makeTemplateObject(["\n  font-size: 16px;\n  font-style: normal;\n  line-height: 24px;\n"], ["\n  font-size: 16px;\n  font-style: normal;\n  line-height: 24px;\n"])));
var BoldHeading = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(Verify_style_templateObject_2 || (Verify_style_templateObject_2 = Verify_style_makeTemplateObject(["\n  ", "\n  font-weight: 700;\n"], ["\n  ", "\n  font-weight: 700;\n"])), style_TextCommonStyle);
var style_StyledBody = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT)(Verify_style_templateObject_3 || (Verify_style_templateObject_3 = Verify_style_makeTemplateObject(["\n  ", "\n  font-weight: 400;\n"], ["\n  ", "\n  font-weight: 400;\n"])), style_TextCommonStyle);
var Verify_style_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(Verify_style_templateObject_4 || (Verify_style_templateObject_4 = Verify_style_makeTemplateObject(["\n  padding: 0px 20px 50px 20px;\n"], ["\n  padding: 0px 20px 50px 20px;\n"])));
var NoBr = styled_components_browser_esm/* default.span */.ZP.span(Verify_style_templateObject_5 || (Verify_style_templateObject_5 = Verify_style_makeTemplateObject(["\n  white-space: nowrap;\n  padding-left: 5px;\n"], ["\n  white-space: nowrap;\n  padding-left: 5px;\n"])));
var Verify_style_templateObject_1, Verify_style_templateObject_2, Verify_style_templateObject_3, Verify_style_templateObject_4, Verify_style_templateObject_5;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/AlertError/index.js
var AlertError_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var AlertError = function (_a) {
    var error = _a.error;
    return (error && (react.createElement(AlertWrapper, { "data-testid": "errorMessage", variant: "error" },
        react.createElement(react.Fragment, null,
            error.description,
            error && error.contactUs && (react.createElement(react.Fragment, null,
                ' ',
                "Please",
                ' ',
                react.createElement(typography_esm/* Link */.rU, { "data-testid": "contactUs", href: "/contactus", color: "error.500" }, "contact us"),
                ' ',
                "to proceed."))))));
};
var AlertWrapper = (0,styled_components_browser_esm/* default */.ZP)(alert_esm/* default */.Z)(AlertError_templateObject_1 || (AlertError_templateObject_1 = AlertError_makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), (0,spacing_esm.mb)('sm'));
var AlertError_templateObject_1;
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/WrongNumber/index.js
var WrongNumber_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU)(WrongNumber_templateObject_1 || (WrongNumber_templateObject_1 = WrongNumber_makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n"], ["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n"])), function () { return (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'main'); }, function (props) { return (props.wrongNumberClicked ? 'none' : 'auto'); });
var WrongNumber = function (_a) {
    var onClick = _a.onClick, wrongNumberClicked = _a.wrongNumberClicked;
    return (react.createElement(LinkWrapper, { wrongNumberClicked: wrongNumberClicked, onClick: onClick }, "Wrong number?"));
};
var WrongNumber_templateObject_1;
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/ResendComponent/index.js
var ResendComponent_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var ResendComponent_assign = (undefined && undefined.__assign) || function () {
    ResendComponent_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ResendComponent_assign.apply(this, arguments);
};
var ResendComponent_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var ResendComponent_LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU)(ResendComponent_templateObject_1 || (ResendComponent_templateObject_1 = ResendComponent_makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n"], ["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n"])), function (_) { return (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'main'); }, function (props) { return (props.wrongNumberClicked ? 'none' : 'auto'); });
var ResendAction = function (_a) {
    var _b = _a.countdown, countdown = _b === void 0 ? 20 : _b, handleClick = _a.handleClick, wrongNumberClicked = _a.wrongNumberClicked, props = ResendComponent_rest(_a, ["countdown", "handleClick", "wrongNumberClicked"]);
    var _c = react.useState(countdown), timeLeft = _c[0], setTimeLeft = _c[1];
    var _d = react.useState(true), isCounting = _d[0], setIsCounting = _d[1];
    react.useEffect(function () {
        var intervalId;
        if (isCounting && timeLeft > 0) {
            intervalId = setInterval(function () {
                setTimeLeft(function (prevTimeLeft) { return prevTimeLeft - 1; });
            }, 1000);
        }
        return function () {
            clearInterval(intervalId);
        };
    }, [isCounting, timeLeft]);
    react.useEffect(function () {
        setIsCounting(!wrongNumberClicked);
    }, [wrongNumberClicked]);
    return (react.createElement(typography_esm/* Body */.uT, ResendComponent_assign({ align: "center" }, props), timeLeft > 0 ? ("Didn\u2019t receive a one-time passcode? You can request a new one in ".concat(timeLeft, "s")) : (react.createElement(ResendComponent_LinkWrapper, { wrongNumberClicked: wrongNumberClicked, onClick: function () {
            handleClick();
            setTimeLeft(countdown);
        } }, "Request a new one-time passcode"))));
};
var ResendComponent_templateObject_1;
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/Verify/index.js
var Verify_assign = (undefined && undefined.__assign) || function () {
    Verify_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Verify_assign.apply(this, arguments);
};
var Verify_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Verify_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



















var Verify = function (_a) {
    var chatState = _a.chatState, chatDispatch = _a.chatDispatch, authState = _a.authState, authDispatch = _a.authDispatch, experimentStateHandler = _a.experimentStateHandler, experiment1 = _a.experiment1;
    var _b = (0,dist_esm/* useSession */.kP)(), sendCode = _b.sendCode, verifyCode = _b.verifyCode;
    var setChatInputFields = (0,context/* useBootstrappedChatState */.D)().setChatInputFields;
    var onException = useError().onException;
    var _c = (0,react.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0,react.useState)(false), wrongNumberClicked = _d[0], setWrongNumberClicked = _d[1];
    var phoneNumber = chatState.phoneNumber, email = chatState.email, firstName = chatState.firstName, leadId = chatState.leadId;
    var error = authState.error;
    var handleWrongNumberClick = function () {
        resetAuthError();
        chatDispatch({
            type: Types.NEXT_EXPERIMENT_ONE_SMART_STATE,
            payload: SmartExperimentCheckpoint.ON_SIGN_IN_CHECK,
        });
        experimentStateHandler();
        setWrongNumberClicked(true);
        chatDispatch({ type: Types.SIGN_IN_SUBMITTED, payload: false });
        chatDispatch({ type: Types.START_STEP_BUTTON_CLICKED, payload: false });
    };
    var handleResendAction = function () { return Verify_awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return Verify_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    authDispatch({ type: AuthActions_Types.SEND_CODE });
                    return [4 /*yield*/, sendCode(phoneNumber)];
                case 1:
                    _a.sent();
                    authDispatch({ type: AuthActions_Types.SENT_CODE });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    authDispatch({ type: AuthActions_Types.ERROR, payload: error_1 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (values) { return Verify_awaiter(void 0, void 0, void 0, function () {
        var code, valid, error_2;
        return Verify_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    chatDispatch({ type: Types.SIGN_IN_SUBMITTED, payload: false });
                    chatDispatch({ type: Types.START_STEP_BUTTON_CLICKED, payload: false });
                    setIsLoading(true);
                    code = values.code;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    chatDispatch({ type: Types.UPDATE_CODE, payload: values.code });
                    authDispatch({ type: AuthActions_Types.VERIFY_CODE });
                    return [4 /*yield*/, verifyCode({
                            phone: phoneNumber,
                            code: code,
                            email: email,
                            leadId: leadId,
                            firstName: firstName,
                        })];
                case 2:
                    valid = (_a.sent()).valid;
                    if (valid) {
                        authDispatch({ type: AuthActions_Types.VERIFIED_CODE, payload: true });
                    }
                    analytics({
                        event_name: types/* ChatEventName.OTP_ENTERED */.Y.OTP_ENTERED,
                        category: common/* EventCategory.CHAT */.Jk.CHAT,
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    handleAuthError({ error: error_2, authDispatch: authDispatch, onException: onException });
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var resetAuthError = function () {
        authDispatch({ type: AuthActions_Types.ERROR, payload: null });
    };
    var onInputChange = function (e) {
        var _a = e.target || {}, name = _a.name, value = _a.value;
        setChatInputFields(function (prev) {
            var _a;
            return (Verify_assign(Verify_assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    return (react.createElement(react.Fragment, null,
        react.createElement(Devider, { hasMargin: true }),
        react.createElement(Verify_style_Wrapper, null,
            react.createElement(BoldHeading, { color: "shade.1000", mb: "xs", align: "center" }, "Verify to continue"),
            react.createElement(style_StyledBody, { color: "shade.1000", align: "center", mt: "md", mb: "xs" },
                "Your one-time passcode has been sent to",
                react.createElement(NoBr, { className: "fs-exclude" },
                    (0,utils/* formattedPhoneNumber */.p3)(phoneNumber),
                    "."),
                react.createElement("br", null),
                react.createElement(WrongNumber, { onClick: handleWrongNumberClick, wrongNumberClicked: wrongNumberClicked }, "Wrong number?")),
            react.createElement(grid_esm/* default */.ZP, { halign: "center" },
                react.createElement(grid_esm/* default.Unit */.ZP.Unit, { size: 1 },
                    react.createElement(react_final_form_es/* Form */.l0, { validate: function (values) { return validateOtpInput(values, wrongNumberClicked); }, onSubmit: onSubmit }, function (_a) {
                        var handleSubmit = _a.handleSubmit, invalid = _a.invalid;
                        return (react.createElement("form", { style: { textAlign: 'center' }, onSubmit: handleSubmit },
                            react.createElement(VerifyOtpField, { autoFocus: true, error: error, resetAuthError: resetAuthError, isDisabled: wrongNumberClicked, onInputChange: onInputChange }),
                            experiment1 && react.createElement(AlertError, { error: error }),
                            react.createElement(LoadingButton, { type: "submit", mt: "xxs", isFullWidth: true, variant: "primary", "data-testid": "sign-in", isDisabled: invalid || wrongNumberClicked, loading: isLoading }, "VERIFY")));
                    }))),
            react.createElement(ResendAction, { handleClick: handleResendAction, wrongNumberClicked: wrongNumberClicked, mt: "lg" }))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChatExperiment1/Header.js



var Header = function () {
    return (react.createElement(style_HeaderWrapper, null,
        react.createElement(BrokerFaces, { src: 'https://lendicdn.net/327bd43fb6e1de7a0a3f44af5ad14156/71ccb7a35a452ea8153b6d920f9f190e/images/lendi.png', alt: "Friendly broker image" }),
        react.createElement(HeaderText, null, CHAT_EXPERIMENT_1_HEADER),
        react.createElement(Devider, null)));
};
//# sourceMappingURL=Header.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChatExperiment1/index.js
var SmartChatExperiment1_assign = (undefined && undefined.__assign) || function () {
    SmartChatExperiment1_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return SmartChatExperiment1_assign.apply(this, arguments);
};
var SmartChatExperiment1_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SmartChatExperiment1_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};













var SmartChatExperiment1 = function () {
    var _a = (0,react.useReducer)(smartChatReducer, SmartChatExperiment1_assign(SmartChatExperiment1_assign({}, initialSmartChatState), { messages: [] })), chatState = _a[0], chatDispatch = _a[1];
    var _b = (0,react.useReducer)(authReducer, initialAuthState), authState = _b[0], authDispatch = _b[1];
    var _c = (0,react.useState)(false), showVerify = _c[0], setShowVerify = _c[1];
    var members = chatState.members, messages = chatState.messages, experimentCheckpoint = chatState.experimentCheckpoint;
    var displayRefTheOther = react.useRef(null);
    var experimentStateHandler = function () {
        setShowVerify(false);
        chatDispatch({ type: Types.RESET_MESSAGE });
    };
    (0,react.useEffect)(function () {
        (function () { return SmartChatExperiment1_awaiter(void 0, void 0, void 0, function () {
            return SmartChatExperiment1_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(experimentCheckpoint === SmartExperimentCheckpoint.ON_VERIFY_CHECK)) return [3 /*break*/, 2];
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, PRIVACY_POLICY_MESSAGE, messages.length + 1)];
                    case 1:
                        _a.sent();
                        chatDispatch({
                            type: Types.NEXT_EXPERIMENT_ONE_SMART_STATE,
                            payload: SmartExperimentCheckpoint.ON_VERIFY_CHECK,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        if (experimentCheckpoint === SmartExperimentCheckpoint.ON_SIGN_IN_CHECK) {
                            chatDispatch({
                                type: Types.CLEAR_MESSAGE,
                                payload: createBotMessage(PHONE_VALIDATION_SUCCESS_MESSAGE_1, 1),
                            });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, [experimentCheckpoint]);
    (0,react.useEffect)(function () {
        (function () { return SmartChatExperiment1_awaiter(void 0, void 0, void 0, function () {
            return SmartChatExperiment1_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(messages.length >= 2)) return [3 /*break*/, 2];
                        return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setShowVerify(true);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
    }, [messages]);
    return (react.createElement(react.Fragment, null,
        react.createElement(ChatHeader, { activePanel: ChatPanels.Default, showBackArrow: true }),
        react.createElement(Header, null),
        react.createElement(style_MessageListWrapper, null,
            experimentCheckpoint === SmartExperimentCheckpoint.ON_SIGN_IN_CHECK && (react.createElement(SignIn, { chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, showEmail: true, experiment1: true })),
            experimentCheckpoint === SmartExperimentCheckpoint.ON_VERIFY_CHECK && (react.createElement(react.Fragment, null,
                react.createElement(ChatComponent_MessageList, { identity: GUEST_IDENTITY, members: members, messages: messages, userType: 'customer', isExperiment: true }),
                showVerify && (react.createElement(Verify, { chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, experimentStateHandler: experimentStateHandler, experiment1: true })))),
            react.createElement("div", { ref: displayRefTheOther }))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/useScrollToEnd.js
var utils_useScrollToEnd_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var utils_useScrollToEnd_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var scrollerHandler = function (docElement) { return utils_useScrollToEnd_awaiter(void 0, void 0, void 0, function () {
    return utils_useScrollToEnd_generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(docElement && docElement.current)) return [3 /*break*/, 2];
                return [4 /*yield*/, sleep(1)];
            case 1:
                _a.sent();
                scrollToBottom(docElement.current);
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
var useScrollToEnd_useScrollToEnd = function (steps, docElement) {
    (0,react.useEffect)(function () {
        scrollerHandler(docElement);
    }, [steps]);
};
//# sourceMappingURL=useScrollToEnd.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChatExperiment2/index.js
var SmartChatExperiment2_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SmartChatExperiment2_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var SmartChatExperiment2_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};














var SmartChatExperiment2 = function () {
    var chatInputFields = (0,context/* useBootstrappedChatState */.D)().chatInputFields;
    var _a = (0,react.useReducer)(smartChatReducer, initialSmartChatState), chatState = _a[0], chatDispatch = _a[1];
    var _b = (0,react.useReducer)(authReducer, initialAuthState), authState = _b[0], authDispatch = _b[1];
    var members = chatState.members;
    var error = authState.error;
    var displayRefTheOther = react.useRef(null);
    var displayRef = react.useRef(null);
    var _c = (0,react.useState)([
        { name: StepNames.MESSAGE_LIST, params: { message: EXPERIMENT_TWO_WELCOME_TEXT } },
    ]), stepsData = _c[0], setStepsData = _c[1];
    (0,react.useEffect)(function () {
        var delayMessages = function () { return SmartChatExperiment2_awaiter(void 0, void 0, void 0, function () {
            return SmartChatExperiment2_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment2_spreadArray(SmartChatExperiment2_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.SIGNIN,
                            },
                        ], false); });
                        return [2 /*return*/];
                }
            });
        }); };
        delayMessages();
    }, []);
    (0,react.useEffect)(function () {
        if (!(chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.otp)) {
            authDispatch({ type: AuthActions_Types.ERROR, payload: null });
        }
    }, [chatInputFields]);
    (0,react.useEffect)(function () {
        (function () { return SmartChatExperiment2_awaiter(void 0, void 0, void 0, function () {
            return SmartChatExperiment2_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!chatState.signInSubmitted) return [3 /*break*/, 3];
                        setStepsData(function (prevStepsData) { return SmartChatExperiment2_spreadArray(SmartChatExperiment2_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: PHONE_VALIDATION_SUCCESS_MESSAGE_1 },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment2_spreadArray(SmartChatExperiment2_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: PRIVACY_POLICY_MESSAGE },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 2:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment2_spreadArray(SmartChatExperiment2_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.VERIFY,
                            },
                        ], false); });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, [chatState.signInSubmitted]);
    var experimentStateHandler = function () {
        chatDispatch({ type: Types.SIGN_IN_SUBMITTED, payload: false });
        setStepsData(function (prevStepsData) { return SmartChatExperiment2_spreadArray(SmartChatExperiment2_spreadArray([], prevStepsData, true), [
            {
                name: StepNames.SIGNIN,
            },
        ], false); });
    };
    useScrollToEnd_useScrollToEnd(stepsData, displayRefTheOther);
    (0,react.useEffect)(function () {
        if (error) {
            scrollerHandler(displayRef);
        }
    }, [error]);
    var renderStepComponent = function (step, index) {
        var _a;
        switch (step.name) {
            case StepNames.MESSAGE_LIST:
                return (react.createElement(ChatComponent_MessageList, { identity: GUEST_IDENTITY, members: members, messages: chatMessage((_a = step.params) === null || _a === void 0 ? void 0 : _a.message), userType: 'customer', isExperiment: true, hideDay: true, key: "DelayedMessageList_".concat(stepsData.length, "_").concat(index) }));
            case StepNames.VERIFY:
                return (react.createElement(Verify, { key: "Verify", chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, experimentStateHandler: experimentStateHandler }));
            case StepNames.SIGNIN:
                return (react.createElement(SignIn, { key: "signIn", chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, showEmail: false }));
            default:
                return react.createElement(react.Fragment, null);
        }
    };
    return (react.createElement(react.Fragment, null,
        react.createElement(ChatHeader, { activePanel: ChatPanels.Default, showBackArrow: true }),
        react.createElement(style_MessageListWrapper, { isExperiment: true },
            react.createElement(react.Fragment, null, stepsData.map(function (step, index) { return (react.createElement("div", { key: "step_".concat(index) },
                renderStepComponent(step, index),
                react.createElement("div", { ref: displayRefTheOther }))); })),
            react.createElement("div", { ref: displayRef },
                react.createElement(AlertError, { error: error })))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChatExperiment3/style.js
var SmartChatExperiment3_style_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var SmartChatExperiment3_style_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(SmartChatExperiment3_style_templateObject_1 || (SmartChatExperiment3_style_templateObject_1 = SmartChatExperiment3_style_makeTemplateObject(["\n  padding-left: 50px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n"], ["\n  padding-left: 50px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n"])));
var StyledBox = styled_components_browser_esm/* default.div */.ZP.div(SmartChatExperiment3_style_templateObject_2 || (SmartChatExperiment3_style_templateObject_2 = SmartChatExperiment3_style_makeTemplateObject(["\n  width: 100%;\n  height: 96px;\n  border-radius: 6px;\n  border: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  width: 100%;\n  height: 96px;\n  border-radius: 6px;\n  border: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])), (0,color_esm/* color */.$)('shade.100'));
var style_StyledText = styled_components_browser_esm/* default.div */.ZP.div(SmartChatExperiment3_style_templateObject_3 || (SmartChatExperiment3_style_templateObject_3 = SmartChatExperiment3_style_makeTemplateObject(["\n  color: ", ";\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n"])), (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'main'));
var StyledRow = styled_components_browser_esm/* default.div */.ZP.div(SmartChatExperiment3_style_templateObject_4 || (SmartChatExperiment3_style_templateObject_4 = SmartChatExperiment3_style_makeTemplateObject(["\n  width: 100%;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: ", ";\n  transition: background-color 0.3s;\n\n  &:not(:disabled):hover {\n    background: ", ";\n    color: ", ";\n    cursor: pointer;\n    border-radius: ", ";\n  }\n\n  ", "\n"], ["\n  width: 100%;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: ", ";\n  transition: background-color 0.3s;\n\n  &:not(:disabled):hover {\n    background: ", ";\n    color: ", ";\n    cursor: pointer;\n    border-radius: ", ";\n  }\n\n  ", "\n"])), function (props) { return (props.topRow ? '1px solid #F1F1F1' : 'none'); }, (0,colours_dist_commons_esm/* default */.ZP)('fill', 'contrast'), (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'subtle'), function (props) { return (props.topRow ? '6px 6px 0 0' : '0 0 6px 6px'); }, function (props) {
    return props.isDisabled &&
        "cursor: not-allowed;\n     pointer-events: none;\n  ";
});
var SmartChatExperiment3_style_templateObject_1, SmartChatExperiment3_style_templateObject_2, SmartChatExperiment3_style_templateObject_3, SmartChatExperiment3_style_templateObject_4;
//# sourceMappingURL=style.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChatExperiment3/startStepButtons.js
var startStepButtons_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var startStepButtons_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var StartStepButtons = function (_a) {
    var onButtonClick = _a.onButtonClick;
    var _b = (0,react.useState)(false), buttonsDisabled = _b[0], setButtonsDisabled = _b[1];
    var setCallMeBackClicked = (0,context/* useBootstrappedChatState */.D)().setCallMeBackClicked;
    var handleButtonClick = function (callMeBack) { return startStepButtons_awaiter(void 0, void 0, void 0, function () {
        return startStepButtons_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setButtonsDisabled(true);
                    if (callMeBack) {
                        setCallMeBackClicked(true);
                    }
                    return [4 /*yield*/, onButtonClick()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react.createElement(SmartChatExperiment3_style_Wrapper, null,
        react.createElement(StyledBox, null,
            react.createElement(StyledRow, { topRow: true, onClick: function () { return !buttonsDisabled && handleButtonClick(true); }, isDisabled: buttonsDisabled },
                react.createElement(style_StyledText, null, "Yes, arrange a callback")),
            react.createElement(StyledRow, { onClick: function () { return !buttonsDisabled && handleButtonClick(false); }, isDisabled: buttonsDisabled },
                react.createElement(style_StyledText, null, "No, Continue Chat")))));
};
//# sourceMappingURL=startStepButtons.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/SmartChatExperiment3/index.js
var SmartChatExperiment3_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SmartChatExperiment3_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var SmartChatExperiment3_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};















var SmartChatExperiment3 = function () {
    var chatInputFields = (0,context/* useBootstrappedChatState */.D)().chatInputFields;
    var _a = (0,react.useReducer)(smartChatReducer, initialSmartChatState), chatState = _a[0], chatDispatch = _a[1];
    var _b = (0,react.useReducer)(authReducer, initialAuthState), authState = _b[0], authDispatch = _b[1];
    var members = chatState.members;
    var error = authState.error;
    var displayRefTheOther = react.useRef(null);
    var displayRef = react.useRef(null);
    var onButtonClick = function () { return SmartChatExperiment3_awaiter(void 0, void 0, void 0, function () {
        return SmartChatExperiment3_generator(this, function (_a) {
            chatDispatch({ type: Types.START_STEP_BUTTON_CLICKED, payload: true });
            return [2 /*return*/];
        });
    }); };
    var _c = (0,react.useState)([
        { name: StepNames.MESSAGE_LIST, params: { message: EXPERIMENT_THREE_WELCOME_TEXT_ONE } },
    ]), stepsData = _c[0], setStepsData = _c[1];
    (0,react.useEffect)(function () {
        var delayMessages = function () { return SmartChatExperiment3_awaiter(void 0, void 0, void 0, function () {
            return SmartChatExperiment3_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment3_spreadArray(SmartChatExperiment3_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.START_STEP_BUTTONS,
                            },
                        ], false); });
                        return [2 /*return*/];
                }
            });
        }); };
        delayMessages();
    }, []);
    (0,react.useEffect)(function () {
        if (!(chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.otp)) {
            authDispatch({ type: AuthActions_Types.ERROR, payload: null });
        }
    }, [chatInputFields]);
    (0,react.useEffect)(function () {
        (function () { return SmartChatExperiment3_awaiter(void 0, void 0, void 0, function () {
            return SmartChatExperiment3_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!chatState.signInSubmitted) return [3 /*break*/, 3];
                        setStepsData(function (prevStepsData) { return SmartChatExperiment3_spreadArray(SmartChatExperiment3_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: PHONE_VALIDATION_SUCCESS_MESSAGE_1 },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment3_spreadArray(SmartChatExperiment3_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: PRIVACY_POLICY_MESSAGE },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 2:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment3_spreadArray(SmartChatExperiment3_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.VERIFY,
                            },
                        ], false); });
                        return [3 /*break*/, 6];
                    case 3:
                        if (!chatState.startStepButtonClicked) return [3 /*break*/, 6];
                        return [4 /*yield*/, sleep(1000)];
                    case 4:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment3_spreadArray(SmartChatExperiment3_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: CONFIRM_DETAILS_TEXT },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 5:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return SmartChatExperiment3_spreadArray(SmartChatExperiment3_spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.SIGNIN,
                            },
                        ], false); });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); })();
    }, [chatState.signInSubmitted, chatState.startStepButtonClicked]);
    var experimentStateHandler = function () {
        chatDispatch({ type: Types.SIGN_IN_SUBMITTED, payload: false });
        chatDispatch({ type: Types.START_STEP_BUTTON_CLICKED, payload: false });
        setStepsData(SmartChatExperiment3_spreadArray(SmartChatExperiment3_spreadArray([], stepsData, true), [
            {
                name: StepNames.SIGNIN,
            },
        ], false));
    };
    useScrollToEnd_useScrollToEnd(stepsData, displayRefTheOther);
    (0,react.useEffect)(function () {
        if (error) {
            scrollerHandler(displayRef);
        }
    }, [error]);
    var renderStepComponent = function (step, index) {
        var _a;
        switch (step.name) {
            case StepNames.START_STEP_BUTTONS:
                return react.createElement(StartStepButtons, { onButtonClick: onButtonClick });
            case StepNames.MESSAGE_LIST:
                return (react.createElement(ChatComponent_MessageList, { identity: GUEST_IDENTITY, members: members, messages: chatMessage((_a = step.params) === null || _a === void 0 ? void 0 : _a.message), userType: 'customer', isExperiment: true, hideDay: true, key: "DelayedMessageList_".concat(stepsData.length, "_").concat(index) }));
            case StepNames.VERIFY:
                return (react.createElement(Verify, { key: "Verify", chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, experimentStateHandler: experimentStateHandler }));
            case StepNames.SIGNIN:
                return (react.createElement(SignIn, { key: "signIn", chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, showEmail: true }));
            default:
                return react.createElement(react.Fragment, null);
        }
    };
    return (react.createElement(react.Fragment, null,
        react.createElement(ChatHeader, { activePanel: ChatPanels.Default, showBackArrow: true }),
        react.createElement(style_MessageListWrapper, { isExperiment: true },
            react.createElement(react.Fragment, null, stepsData.map(function (step, index) { return (react.createElement("div", { key: "step_".concat(index) },
                renderStepComponent(step, index),
                react.createElement("div", { ref: displayRefTheOther }))); })),
            react.createElement("div", { ref: displayRef },
                react.createElement(AlertError, { error: error })))));
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/components/ChatComponent/index.js
var ChatComponent_assign = (undefined && undefined.__assign) || function () {
    ChatComponent_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ChatComponent_assign.apply(this, arguments);
};













var ChatComponentInner = function (props) {
    var callMeBackClicked = (0,context/* useBootstrappedChatState */.D)().callMeBackClicked;
    var chatExperiment = (0,lib.useFlags)().chatExperiment;
    var session = (0,dist_esm/* useSession */.kP)();
    // chat window open
    // unauthenticated
    // load smart chat
    if (session.status !== dist_esm/* Status.Authenticated */.qb.Authenticated) {
        switch (chatExperiment) {
            case 'Experiment1':
                return react.createElement(SmartChatExperiment1, null);
            case 'Experiment2':
                return react.createElement(SmartChatExperiment2, null);
            case 'Experiment3':
                return react.createElement(SmartChatExperiment3, null);
            default:
                return react.createElement(SmartChat, null);
        }
    }
    if (session.status === dist_esm/* Status.Authenticated */.qb.Authenticated && callMeBackClicked) {
        if (commons_esm/* isBrowser */.jU) {
            window.location.assign('/book-appointment/time-selection');
        }
        else {
            // eslint-disable-next-line no-console
            console.error('window object is not available.');
        }
    }
    // else load chat threads
    return react.createElement(ThreadsPanel, ChatComponent_assign({}, props));
};
var ChatComponent = withErrorProvider(withChatAnalytics(withSafetyNetProvider(ChatComponentInner)));
/* harmony default export */ var components_ChatComponent = (ChatComponent);
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatBootstrapperProvider/provider.js + 15 modules
var provider = __webpack_require__(22237);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatBootstrapperProvider/hoc.js
var hoc_assign = (undefined && undefined.__assign) || function () {
    hoc_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return hoc_assign.apply(this, arguments);
};



var withCustomerChatProvider = function (Component) {
    return function (props) {
        var customerChatState = react.useContext(context/* ChatBootstrapperContext */.h);
        if (!customerChatState) {
            return (react.createElement(provider/* CustomerChatBootstrapperProvider */.e, null,
                react.createElement(Component, hoc_assign({}, props))));
        }
        else {
            return react.createElement(Component, hoc_assign({}, props));
        }
    };
};
//# sourceMappingURL=hoc.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Phone/dist/icon.esm.js






function SvgPhone(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Calendar/dist/icon.esm.js






function SvgCalendar(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
      })
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Chat/dist/icon.esm.js






function SvgChat(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/KeyboardArrowRight/dist/icon.esm.js






function SvgKeyboardArrowRight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0-.25h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/react-focus-lock/dist/es2015/index.js + 38 modules
var es2015 = __webpack_require__(57971);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/Menu/dist/icon.esm.js






function SvgMenu(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      })]
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/overlay/dist/overlay.esm.js
var overlay_esm = __webpack_require__(50191);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/transition/dist/transition.esm.js
var transition_esm = __webpack_require__(4459);
;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/sidebar/dist/sidebar.esm.js









function sidebar_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function sidebar_esm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function sidebar_esm_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? sidebar_esm_ownKeys(Object(source), !0).forEach(function (key) {
      sidebar_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : sidebar_esm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function sidebar_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function sidebar_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = sidebar_esm_objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var SIDEBAR_ZINDEX = 999;
var MINIMUM_GUTTER_WIDTH = '3rem';

var sidebar_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-1oc64o8-0"
})(["", " display:flex;flex-direction:column;position:fixed;bottom:0;width:calc(100% - ", ");max-width:22.5rem;overflow:hidden;transition:transform 0.25s;z-index:", ";", " ", ";", " ", ";"], utils_esm/* normalise */.W$, MINIMUM_GUTTER_WIDTH, SIDEBAR_ZINDEX, (0,color_esm.bg)('shade.0'), (0,depth_esm/* depth */.Y)(1), _ref => {
  var {
    side,
    top
  } = _ref;

  if (side === 'left') {
    return (0,styled_components_browser_esm/* css */.iv)(["left:0;top:", "px;transform:translateX(-100%);"], top);
  } else {
    return (0,styled_components_browser_esm/* css */.iv)(["right:0;top:", "px;transform:translateX(100%);"], top);
  }
}, _ref2 => {
  var {
    side,
    transition
  } = _ref2;

  if (side === 'left') {
    return (0,transition_esm/* mixin */.jB)(transition, {
      entering: {
        transform: 'translateX(0)'
      },
      entered: {
        transform: 'translateX(0)'
      },
      exit: {
        transform: 'translateX(0)'
      },
      exiting: {
        transform: 'translateX(-100%)'
      }
    });
  } else {
    return (0,transition_esm/* mixin */.jB)(transition, {
      entering: {
        transform: 'translateX(0)'
      },
      entered: {
        transform: 'translateX(0)'
      },
      exit: {
        transform: 'translateX(0)'
      },
      exiting: {
        transform: 'translateX(100%)'
      }
    });
  }
});
var SidebarContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__SidebarContent",
  componentId: "lui__sc-1oc64o8-1"
})(["width:100%;overflow-y:scroll;flex:1;"]);
var SidebarFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__SidebarFooter",
  componentId: "lui__sc-1oc64o8-2"
})(["width:100%;align-self:flex-end;", ""], _ref3 => {
  var {
    hasTopShadow
  } = _ref3;

  if (hasTopShadow) {
    return (0,styled_components_browser_esm/* css */.iv)(["flex-shrink:0;border-top:1px solid ", ";", ";"], (0,color_esm/* color */.$)('shade.100'), (0,depth_esm/* depth */.Y)(4));
  }

  return undefined;
});

var sidebar_esm_excluded = ["children", "direction", "top", "isVisible", "onHide", "overlayZIndex", "className"];

var Sidebar = _ref => {
  var {
    children: _children,
    direction = 'left',
    top = 0,
    isVisible = false,
    onHide,
    overlayZIndex = 2,
    // We just default this value to 2 right now in order to keep consistensy with NavbarBase and update it once LUI z-index management completed.
    className
  } = _ref,
      otherProps = sidebar_esm_objectWithoutProperties(_ref, sidebar_esm_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(overlay_esm/* default */.Z, {
      isVisible: isVisible,
      zIndex: overlayZIndex,
      onHide: onHide
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* default */.ZP, {
      isActive: isVisible,
      timeout: 250,
      children: state => /*#__PURE__*/(0,jsx_runtime.jsx)(sidebar_esm_Wrapper, sidebar_esm_objectSpread2(sidebar_esm_objectSpread2({
        side: direction,
        transition: state,
        top: top,
        className: className
      }, otherProps), {}, {
        children: _children
      }))
    })]
  });
};

Sidebar.Content = _ref2 => {
  var {
    children
  } = _ref2;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SidebarContent, {
    children: children
  });
};

Sidebar.Footer = _ref3 => {
  var {
    children,
    hasTopShadow = false
  } = _ref3;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SidebarFooter, {
    hasTopShadow: hasTopShadow,
    children: children
  });
};



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/ArrowDropDown/dist/icon.esm.js






function SvgArrowDropDown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7 10l5 5 5-5z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/ExitToApp/dist/icon.esm.js






function SvgExitToApp(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 00-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/ExpandMore/dist/icon.esm.js






function SvgExpandMore(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/ChevronDown/dist/icon.esm.js






function SvgChevronDown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.59 8.59L18 10l-6 6-6-6 1.41-1.41L12 13.17z"
      })
    })
  }));
}



;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/ChevronUp/dist/icon.esm.js






function SvgChevronUp(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.41 15.41L6 14l6-6 6 6-1.41 1.41L12 10.83z"
      })
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index-68cf36c7.esm.js
var index_68cf36c7_esm = __webpack_require__(67623);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index-c76be973.esm.js
var index_c76be973_esm = __webpack_require__(32386);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/Layout/dist/ui.esm.js








;// CONCATENATED MODULE: ../../../node_modules/@lendi-ui/icon/ArrowForward/dist/icon.esm.js






function SvgArrowForward(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_e9280b89_esm.I, (0,Icon_e9280b89_esm._)((0,Icon_e9280b89_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
      })]
    })
  }));
}



// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/RichText-1658459e.esm.js
var RichText_1658459e_esm = __webpack_require__(24467);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/Typography/dist/ui.esm.js









// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/AnchorButton-92f301b4.esm.js
var AnchorButton_92f301b4_esm = __webpack_require__(9387);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index.style-741fda20.esm.js
var index_style_741fda20_esm = __webpack_require__(23512);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index-ada59f60.esm.js
var index_ada59f60_esm = __webpack_require__(97520);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/Button/dist/ui.esm.js















;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const utils_isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const utils_isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => utils_isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const utils_trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function utils_findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && utils_findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (utils_isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (utils_isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var lib_utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: utils_isObject,
  isPlainObject,
  isUndefined,
  isDate: utils_isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim: utils_trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey: utils_findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

lib_utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: lib_utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  lib_utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(75291)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return lib_utils.isPlainObject(thing) || lib_utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return lib_utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return lib_utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = lib_utils.toFlatObject(lib_utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!lib_utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = lib_utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !lib_utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && lib_utils.isSpecCompliantForm(formData);

  if (!lib_utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (lib_utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && lib_utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (lib_utils.isArrayBuffer(value) || lib_utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (lib_utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (lib_utils.isArray(value) && isFlatArray(value)) ||
        ((lib_utils.isFileList(value) || lib_utils.endsWith(key, '[]')) && (arr = lib_utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(lib_utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (lib_utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    lib_utils.forEach(value, function each(el, key) {
      const result = !(lib_utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, lib_utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!lib_utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = lib_utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    lib_utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var platform_browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...platform_browser
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && lib_utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return lib_utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && lib_utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (lib_utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !lib_utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && lib_utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (lib_utils.isFormData(formData) && lib_utils.isFunction(formData.entries)) {
    const obj = {};

    lib_utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (lib_utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return lib_utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = lib_utils.isObject(data);

    if (isObjectPayload && lib_utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = lib_utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (lib_utils.isArrayBuffer(data) ||
      lib_utils.isBuffer(data) ||
      lib_utils.isStream(data) ||
      lib_utils.isFile(data) ||
      lib_utils.isBlob(data)
    ) {
      return data;
    }
    if (lib_utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (lib_utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = lib_utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && lib_utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

lib_utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = lib_utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return lib_utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (lib_utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!lib_utils.isString(value)) return;

  if (lib_utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (lib_utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = lib_utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = lib_utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      lib_utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (lib_utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(lib_utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = lib_utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (lib_utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (lib_utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = lib_utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = lib_utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (lib_utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    lib_utils.forEach(this, (value, header) => {
      const key = lib_utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    lib_utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && lib_utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    lib_utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
lib_utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

lib_utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  lib_utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

lib_utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      lib_utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      lib_utils.isString(path) && cookie.push('path=' + path);

      lib_utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (lib_utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (lib_utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && lib_utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      lib_utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!lib_utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

lib_utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => lib_utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = lib_utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (lib_utils.isPlainObject(target) && lib_utils.isPlainObject(source)) {
      return lib_utils.merge.call({caseless}, target, source);
    } else if (lib_utils.isPlainObject(source)) {
      return lib_utils.merge({}, source);
    } else if (lib_utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!lib_utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!lib_utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!lib_utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!lib_utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!lib_utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  lib_utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (lib_utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/env/data.js
const VERSION = "1.6.2";
;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (lib_utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && lib_utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && lib_utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
lib_utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

lib_utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return lib_utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  lib_utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  lib_utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios_axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios_axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios_axios.CanceledError = cancel_CanceledError;
axios_axios.CancelToken = cancel_CancelToken;
axios_axios.isCancel = isCancel;
axios_axios.VERSION = VERSION;
axios_axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios_axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios_axios.Cancel = axios_axios.CanceledError;

// Expose all/spread
axios_axios.all = function all(promises) {
  return Promise.all(promises);
};

axios_axios.spread = spread;

// Expose isAxiosError
axios_axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios_axios.mergeConfig = mergeConfig;

axios_axios.AxiosHeaders = core_AxiosHeaders;

axios_axios.formToJSON = thing => helpers_formDataToJSON(lib_utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios_axios.getAdapter = adapters.getAdapter;

axios_axios.HttpStatusCode = helpers_HttpStatusCode;

axios_axios.default = axios_axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios_axios);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/navbar/dist/navbar.esm.js



















































function navbar_esm_toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function navbar_esm_toPropertyKey(arg) {
  var key = navbar_esm_toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function navbar_esm_defineProperty(obj, key, value) {
  key = navbar_esm_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function navbar_esm_ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function navbar_esm_objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? navbar_esm_ownKeys(Object(t), !0).forEach(function (r) {
      navbar_esm_defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : navbar_esm_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

var navbar_esm_analytics = navbarAnalyticsEvent => {
  if (window) {
    trackEvent(navbar_esm_objectSpread2({}, navbarAnalyticsEvent));
  } else {
    if (false) {} else {
      // eslint-disable-next-line no-console
      console.error('Segment is not loaded');
    }
  }
};

function navbar_esm_taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$g, _templateObject2$6, _templateObject3$2, _templateObject4$1, _templateObject5$1;
var StyledHeaderLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo).withConfig({
  displayName: "style__StyledHeaderLogo",
  componentId: "lui__sc-17ip4hk-0"
})(["", ";width:auto;height:28px;color:", ";", ";"], _ref => {
  var {
    isHref
  } = _ref;
  return isHref ? (0,styled_components_browser_esm/* css */.iv)(["cursor:pointer;"]) : (0,styled_components_browser_esm/* css */.iv)(["cursor:auto;"]);
}, _ref2 => {
  var {
    variant
  } = _ref2;
  return variant === 'dark' ? 'secondary.900' : 'shade.0';
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return (0,ui_esm/* select */.Ys)('logo.logoName')({
    theme
  }) === 'LendiLogo' ? (0,styled_components_browser_esm/* css */.iv)(["", ";", ";"], (0,breakpoint_esm/* gte */.eg)('tablet')(_templateObject$g || (_templateObject$g = navbar_esm_taggedTemplateLiteral(["\n            width: auto;\n            height: 28px;\n          "]))), (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject2$6 || (_templateObject2$6 = navbar_esm_taggedTemplateLiteral(["\n            width: auto;\n            height: 36px;\n          "])))) : (0,styled_components_browser_esm/* css */.iv)(["", ";", ";"], (0,breakpoint_esm/* gte */.eg)('tablet')(_templateObject3$2 || (_templateObject3$2 = navbar_esm_taggedTemplateLiteral(["\n            width: auto;\n            height: 28px;\n          "]))), (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject4$1 || (_templateObject4$1 = navbar_esm_taggedTemplateLiteral(["\n            width: auto;\n            height: 36px;\n          "]))));
});
var LogoLink$1 = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "style__LogoLink",
  componentId: "lui__sc-17ip4hk-1"
})([""]);
var navbar_esm_LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__LogoWrapper",
  componentId: "lui__sc-17ip4hk-2"
})(["", ";", ";", ";"], (0,spacing_esm.mb)('xxxs'), _ref4 => {
  var {
    hasHamburgerMenu
  } = _ref4;
  return hasHamburgerMenu ? (0,styled_components_browser_esm/* css */.iv)(["", ""], (0,spacing_esm.ml)('xs')) : (0,styled_components_browser_esm/* css */.iv)(["", ""], (0,spacing_esm.ml)('nil'));
}, (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject5$1 || (_templateObject5$1 = navbar_esm_taggedTemplateLiteral(["\n    ", "\n    margin-bottom: 5px;\n  "])), (0,spacing_esm.ml)('nil')));

var LogoComponent = _ref => {
  var {
    homeURL,
    params,
    hasHamburgerMenu = true
  } = _ref;
  var {
    isTransparent
  } = useNavbarBaseContext();
  var variant = isTransparent ? 'light' : 'dark';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_LogoWrapper, {
    hasHamburgerMenu: hasHamburgerMenu,
    children: homeURL ? /*#__PURE__*/(0,jsx_runtime.jsx)(LogoLink$1, {
      href: "".concat(homeURL).concat(params),
      "aria-label": "Logo",
      onClick: () => {
        var event = {
          event_name: 'Link Clicked',
          category: EventCategory.NAVBAR,
          text: 'Logo',
          linkType: 'Logo'
        };
        navbar_esm_analytics(event);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeaderLogo, {
        variant: variant,
        isHref: true
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LogoLink$1, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeaderLogo, {
        variant: variant,
        "aria-label": "Logo",
        isHref: false
      })
    })
  });
};
var LogoComponent$1 = LogoComponent;

var _templateObject$f;
var navTokens = {
  size: {
    height: {
      navbar: {
        mobile: {
          value: '3.5rem'
        },
        desktop: {
          value: '5.5rem'
        }
      }
    }
  }
};
var NavbarWrapper = (0,styled_components_browser_esm/* default */.ZP)(NavbarBase).withConfig({
  displayName: "styles__NavbarWrapper",
  componentId: "lui__sc-ej7i4l-0"
})(["", ";", " height:", ";", ";"], (0,spacing_esm.pl)({
  mobile: 'sm',
  tablet: 'sm',
  desktop: 'lg'
}), _ref => {
  var {
    isAuthenticated
  } = _ref;
  return isAuthenticated ? (0,styled_components_browser_esm/* css */.iv)(["", ";"], (0,spacing_esm.pr)('nil')) : (0,styled_components_browser_esm/* css */.iv)(["", ";"], (0,spacing_esm.pr)({
    mobile: 'sm',
    tablet: 'sm',
    desktop: 'lg'
  }));
}, navTokens.size.height.navbar.mobile.value, (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject$f || (_templateObject$f = navbar_esm_taggedTemplateLiteral(["\n    height: ", "\n  "])), navTokens.size.height.navbar.desktop.value));
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Container",
  componentId: "lui__sc-ej7i4l-1"
})(["display:flex;align-items:center;"]);
var MenuLogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__MenuLogoWrapper",
  componentId: "lui__sc-ej7i4l-2"
})(["display:flex;align-items:center;"]);
var navbar_esm_NavbarLeftWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__NavbarLeftWrapper",
  componentId: "lui__sc-ej7i4l-3"
})(["flex:1 0 auto;"]);
var navbar_esm_NavbarRightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__NavbarRightWrapper",
  componentId: "lui__sc-ej7i4l-4"
})([""]);
var AlertBanner = (0,styled_components_browser_esm/* default */.ZP)(alert_esm/* default */.Z).withConfig({
  displayName: "styles__AlertBanner",
  componentId: "lui__sc-ej7i4l-5"
})(["", ""], (0,spacing_esm.my)({
  mobile: 'xs',
  tablet: 'xs',
  desktop: 'sm'
}));

var _templateObject$e, _templateObject2$5;
var TalkExpertAction$1 = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "style__TalkExpertAction",
  componentId: "lui__sc-9anjvz-0"
})(["width:100%;", " ", ";min-width:180px;", ""], (0,spacing_esm.mr)('sm'), (0,breakpoint_esm/* between */.vX)('mobile', 'desktop')(_templateObject$e || (_templateObject$e = navbar_esm_taggedTemplateLiteral(["\n    border: none;\n  "]))), _ref => {
  var {
    bigLabelAccomodate
  } = _ref;
  return bigLabelAccomodate && (0,styled_components_browser_esm/* css */.iv)(["min-width:202px;"]);
});
var TalkExpertActionMobile = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "style__TalkExpertActionMobile",
  componentId: "lui__sc-9anjvz-1"
})(["", " ", ";min-width:102px;padding:0;line-height:1.33;", ""], (0,spacing_esm.mr)('sm'), (0,breakpoint_esm/* between */.vX)('mobile', 'desktop')(_templateObject2$5 || (_templateObject2$5 = navbar_esm_taggedTemplateLiteral(["\n    border: none;\n  "]))), _ref2 => {
  var {
    isContinue
  } = _ref2;
  return isContinue && (0,styled_components_browser_esm/* css */.iv)(["min-width:90px;"]);
});
var SecondaryAction = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "style__SecondaryAction",
  componentId: "lui__sc-9anjvz-2"
})(["min-width:180px;", " word-wrap:break-word;"], _ref3 => {
  var {
    bigLabelAccomodate
  } = _ref3;
  return bigLabelAccomodate && (0,styled_components_browser_esm/* css */.iv)(["min-width:202px;"]);
});
var SecondaryActionMobile = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "style__SecondaryActionMobile",
  componentId: "lui__sc-9anjvz-3"
})(["width:90px;padding:0;"]);
styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__DesktopLogoutWrapper",
  componentId: "lui__sc-9anjvz-4"
})(["", ""], (0,utils_esm/* display */.jf)({
  mobile: 'none',
  desktop: 'block'
}));
var UnreadMessageWrapper = (0,styled_components_browser_esm/* default */.ZP)(SvgUnreadMessage).withConfig({
  displayName: "style__UnreadMessageWrapper",
  componentId: "lui__sc-9anjvz-5"
})(["margin-top:-0.4em;margin-right:0.5em;margin-left:-0.5em;"]);

var BOOK_AN_APPOINTMENT = 'BOOK AN APPOINTMENT';
var UNREAD_MESSAGE = 'YOU HAVE AN UNREAD MESSAGE';
var UNREAD_MESSAGE_MOBILE = 'UNREAD MESSAGE';
var CONTACT_US = 'CONTACT US';
var LABEL_TALK_TO_EXPERT = 'TALK TO AN EXPERT';
var LABEL_TALK_TO_A_BROKER = 'TALK TO A BROKER';
var LABEL_SIGN_IN = 'SIGN IN';
var LABEL_CONTINUE = 'CONTINUE';
var LABEL_APPLICATIONS = 'Applications';
var LABEL_DASHBOARD = 'Dashboard';
var LABEL_PROPERTY_REPORT = 'Property reports';
var LABEL_REFER_A_FRIEND = 'Refer a friend';
var LABEL_SEND_FEEDBACK = 'Send Feedback';
var LABEL_LOG_OUT = 'Sign out';
var LABEL_MORE_OPTIONS = 'More options';
var DASHBOARD_V2_PATH = '/v2/dashboard';
var PATH_LENDI = '';
var PATH_DOMAIN = '/loanfinder';
var ROUTE_SIGN_IN = '/sign-in';
var ROUTE_BOOK_APPOINTMENT = '/book-appointment/';
var ROUTE_APPLICATIONS = '/dashboard/applications';
var ROUTE_REFER_A_FRIEND = '/referral';
var ROUTE_NEW_PROPERTY_REPORT = '/property-report/my-properties';
var CMS_AHL_MAIN_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/?$/gm;
var CMS_AHL_ACTIVATE_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/aussie-activate\/?$/gm;
var CMS_AHL_ELEVATE_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/aussie-elevate\/?$/gm;
var CMS_AHL_SELECT_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/aussie-select\/?$/gm;
var FUNNEL1_URL_MATCH = /^\/?home-loans\/basics\/?([a-zA-Z0-9.%?=\-]*\/?)*$/gm;
var AHLProducts = /*#__PURE__*/function (AHLProducts) {
  AHLProducts["AUSSIE_ACTIVATE"] = "aussie-activate";
  AHLProducts["AUSSIE_ELEVATE"] = "aussie-elevate";
  AHLProducts["AUSSIE_SELECT"] = "aussie-select";
  return AHLProducts;
}({});
var SURVEY_ID = '931186d4c71ec937';

var _templateObject$d;
var TalkExpertAction = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "indexstyle__TalkExpertAction",
  componentId: "lui__sc-altm9z-0"
})(["", ";", " min-width:202px;", ";", ""], (0,spacing_esm.mr)('sm'), _ref => {
  var {
    dashboardVariant
  } = _ref;
  return dashboardVariant && (0,styled_components_browser_esm/* css */.iv)(["", ""], (0,spacing_esm.mr)('nil'));
}, (0,breakpoint_esm/* between */.vX)('mobile', 'desktop')(_templateObject$d || (_templateObject$d = navbar_esm_taggedTemplateLiteral(["\n  min-width: 90px;\n    border: none;\n    ", "\n  "])), (0,spacing_esm.p)('nil')), _ref2 => {
  var {
    continueExist
  } = _ref2;
  return continueExist && (0,styled_components_browser_esm/* css */.iv)(["min-width:180px;"]);
});
var ContinueAction = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "indexstyle__ContinueAction",
  componentId: "lui__sc-altm9z-1"
})(["width:90px;padding:0;"]);

var navbar_esm_initialState = {
  hideDashboardItem: false,
  hideManageApplicationsItem: false,
  onLogout: undefined
};

var DropdownMenuContext = /*#__PURE__*/react.createContext(navbar_esm_initialState);
var useDropdownMenu = () => {
  var state = react.useContext(DropdownMenuContext);
  if (!state) {
    throw new Error('Please setup <DropdownMenuProvider /> as a parent component, before using useDropdownMenu().');
  }
  return state;
};

var _templateObject$c;
var LogoutWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__LogoutWrapper",
  componentId: "lui__sc-t6my6e-0"
})(["position:absolute;right:5px;top:56px;", ";display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:", ";border-radius:", ";", ""], (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject$c || (_templateObject$c = navbar_esm_taggedTemplateLiteral(["top: 70px;"]))), _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.inverse;
}, () => (0,dist_commons_esm/* getRadius */.H5)(), (0,depth_esm/* depth */.Y)(2));
var MenuItem$1 = (0,styled_components_browser_esm/* css */.iv)(["", " ", ""], (0,spacing_esm.px)('sm'), (0,spacing_esm.py)('sm'));
var MyAccountTitle = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "style__MyAccountTitle",
  componentId: "lui__sc-t6my6e-1"
})(["", ";font-weight:bold;width:100%;box-sizing:border-box;border-bottom:1px solid ", ";"], MenuItem$1, () => (0,colours_dist_commons_esm/* default */.ZP)('shade', 100));
var LinkWrapper$1 = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU).withConfig({
  displayName: "style__LinkWrapper",
  componentId: "lui__sc-t6my6e-2"
})(["", ";overflow:hidden;text-decoration:none;font-weight:normal;width:100%;text-align:left;box-sizing:border-box;background-color:transparent;"], MenuItem$1);
var LaunchIcon = (0,styled_components_browser_esm/* default */.ZP)(SvgLaunch).withConfig({
  displayName: "style__LaunchIcon",
  componentId: "lui__sc-t6my6e-3"
})(["", ""], (0,spacing_esm.mx)('xl'));

var checkSVA = () => {
  if (typeof window !== undefined && window._sva !== undefined) {
    return window._sva;
  }
  return false;
};
var sendFeedBackOnClick = () => {
  window._sva.showSurvey(SURVEY_ID, {
    forceDisplay: true
  });
};

var DropdownMenu = () => {
  var {
    brand
  } = (0,dist_esm/* useSession */.kP)();
  var isDomain = getBrandFromHostname() === Brand_Brand.Domain;
  var isLendi = brand === Brand_Brand.Lendi;
  var isSVA = checkSVA();
  var path = isDomain ? PATH_DOMAIN : PATH_LENDI;
  var {
    hideDashboardItem,
    hideManageApplicationsItem,
    onLogout
  } = useDropdownMenu();
  var {
    sendFeedback,
    referAFriend
  } = (0,lib.useFlags)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LogoutWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MyAccountTitle, {
      children: "My account"
    }), !hideManageApplicationsItem && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_APPLICATIONS
        };
        navbar_esm_analytics(event);
      },
      href: "".concat(path).concat(ROUTE_APPLICATIONS),
      "aria-label": LABEL_APPLICATIONS,
      children: LABEL_APPLICATIONS
    }), !hideDashboardItem && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_DASHBOARD
        };
        navbar_esm_analytics(event);
      },
      href: "".concat(path).concat(DASHBOARD_V2_PATH),
      "aria-label": LABEL_DASHBOARD,
      children: LABEL_DASHBOARD
    }), !isDomain && /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_PROPERTY_REPORT
        };
        navbar_esm_analytics(event);
      },
      href: "".concat(ROUTE_NEW_PROPERTY_REPORT),
      target: "_blank",
      "aria-label": LABEL_PROPERTY_REPORT,
      children: [LABEL_PROPERTY_REPORT, /*#__PURE__*/(0,jsx_runtime.jsx)(LaunchIcon, {
        width: "18px",
        height: "18px"
      })]
    }), referAFriend && !isDomain && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_REFER_A_FRIEND
        };
        navbar_esm_analytics(event);
      },
      href: "".concat(path).concat(ROUTE_REFER_A_FRIEND),
      "aria-label": LABEL_REFER_A_FRIEND,
      children: LABEL_REFER_A_FRIEND
    }), isLendi && sendFeedback && isSVA && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_SEND_FEEDBACK
        };
        sendFeedBackOnClick();
        navbar_esm_analytics(event);
      },
      target: "_blank",
      "aria-label": LABEL_SEND_FEEDBACK,
      children: LABEL_SEND_FEEDBACK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        if (onLogout) onLogout();
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_LOG_OUT
        };
        navbar_esm_analytics(event);
      },
      "aria-label": LABEL_LOG_OUT,
      children: LABEL_LOG_OUT
    })]
  });
};

var KebabMenu = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* IconButton */.hU).withConfig({
  displayName: "style__KebabMenu",
  componentId: "lui__sc-1kjveb6-0"
})(["", ""], (0,spacing_esm.ml)('xxxs'));

var LogoutComponent = () => {
  var {
    isTransparent
  } = useNavbarBaseContext();
  var [isLogoutDisplay, setIsLogoutDisplay] = react.useState(false);
  var logoutPanel = react.useRef();
  var hasWindow = typeof window !== 'undefined';
  var theme = (0,ui_esm/* useTheme */.Fg)();
  var closeLogoutPanel = e => {
    if (logoutPanel && logoutPanel.current && !logoutPanel.current.contains(e.target)) {
      setIsLogoutDisplay(false);
    }
  };
  react.useEffect(() => {
    if (hasWindow) {
      window.addEventListener('mousedown', closeLogoutPanel);
    }
    return () => {
      if (hasWindow) {
        window.removeEventListener('mousedown', closeLogoutPanel);
      }
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: logoutPanel,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(KebabMenu, {
      size: "sm",
      color: isTransparent ? theme.color.interaction.subtle : theme.color.interaction.main,
      onClick: () => {
        setIsLogoutDisplay(!isLogoutDisplay);
        var event = {
          event_name: 'Menu Clicked',
          menuName: 'Kebab Menu',
          category: EventCategory.NAVBAR
        };
        navbar_esm_analytics(event);
      },
      "aria-label": LABEL_MORE_OPTIONS,
      icon: SvgMoreVert
    }), isLogoutDisplay && /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownMenu, {})]
  });
};

var _templateObject$b;
var DesktopActionsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__DesktopActionsWrapper",
  componentId: "lui__sc-jh42qz-0"
})(["display:flex;", ";"], (0,breakpoint_esm/* between */.vX)('mobile', 'desktop')(_templateObject$b || (_templateObject$b = navbar_esm_taggedTemplateLiteral(["\n    display: none;\n  "]))));

var DEFAULT_DASHBOARD_URL = '/v2/dashboard/';
var getSignInURL = (brand, env, returnURL) => {
  var urls = getURLs_getURLs(brand, dist_esm/* Type.Customer */.Dy.Customer, env);
  var dashboardReturnURL = brand === dist_esm/* Brand.Domain */.H2.Domain ? "/loanfinder".concat(DEFAULT_DASHBOARD_URL) : DEFAULT_DASHBOARD_URL;
  // Confirmed with CMS team, all Lendi and Aussie landing pages will under /lp/ route.
  var lendiOrAussieLandingPageRoute = "".concat(urls.origin, "lp/");
  var hasNoReturnURL = returnURL === undefined || returnURL === '';
  var isReturnURLOrigin = returnURL === urls.origin;
  var isReturnURLLendiOrAussieLandingPage = (returnURL === null || returnURL === void 0 ? void 0 : returnURL.includes(lendiOrAussieLandingPageRoute)) && brand !== dist_esm/* Brand.Domain */.H2.Domain;

  /**
   * The return URL should be based on origin
   * If origin is homepage, not given, or Lendi & Aussie marketing landing page, then return URL should be dashboard
   * else, whatever is given.
   */
  var newReturnURL = hasNoReturnURL || isReturnURLOrigin || isReturnURLLendiOrAussieLandingPage ? dashboardReturnURL : returnURL;
  return "".concat(urls.authenticate, "?returnURL=").concat(encodeURIComponent(newReturnURL));
};

var getEnvFromHostname = hostname => {
  if (hostname !== null && hostname !== void 0 && hostname.includes('dev.')) {
    return dist_esm/* Environment.Development */.qA.Development;
  } else if (hostname !== null && hostname !== void 0 && hostname.includes('stg.') || hostname !== null && hostname !== void 0 && hostname.includes('stage.')) {
    return dist_esm/* Environment.Staging */.qA.Staging;
  } else if (hostname !== null && hostname !== void 0 && hostname.includes('preprod.')) {
    return dist_esm/* Environment.Preproduction */.qA.Preproduction;
  } else if (hostname !== null && hostname !== void 0 && hostname.includes('lendi.com.au') || hostname !== null && hostname !== void 0 && hostname.includes('domain.com.au') || hostname !== null && hostname !== void 0 && hostname.includes('aussie.com.au')) {
    return dist_esm/* Environment.Production */.qA.Production;
  } else {
    return dist_esm/* Environment.Development */.qA.Development;
  }
};

var RenderChatOrSideBar = _ref => {
  var {
    openCommPanel = () => {},
    customerOwner,
    dashboardVariant,
    hasUnreadMessages
  } = _ref;
  var brand = getBrandFromHostname();
  var primaryLabel = customerOwner !== null && customerOwner !== void 0 && customerOwner.firstName ? "Talk to ".concat(customerOwner.firstName) : brand === 'aussie' ? LABEL_TALK_TO_A_BROKER : LABEL_TALK_TO_EXPERT;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TalkExpertAction, {
    dashboardVariant: dashboardVariant,
    size: "sm",
    variant: "secondary",
    onClick: () => {
      openCommPanel();
      var event = {
        event_name: 'Button Clicked',
        category: EventCategory.NAVBAR,
        buttonType: ButtonType.SECONDARY,
        text: hasUnreadMessages ? 'You have an unread message' : brand === 'aussie' ? 'Talk to a broker' : 'Talk to an expert'
      };
      navbar_esm_analytics(event);
    },
    children: hasUnreadMessages ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnreadMessageWrapper, {
        "data-testid": "customer-view-unread-icon",
        color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'),
        height: "2em",
        width: "2em"
      }), UNREAD_MESSAGE]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: primaryLabel
    })
  });
};
var RenderDesktopAction = _ref2 => {
  var _window, _window2;
  var {
    dashboardVariant,
    isAuthenticated,
    continueURL,
    showContinueAction = false,
    showTalkToExpertCta = true,
    showBookanAppointmentCta = true,
    openCommPanel = () => {},
    customerOwner,
    hasUnreadMessages
  } = _ref2;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var isDomain = brand === Brand_Brand.Domain;
  var path = isDomain ? PATH_DOMAIN : PATH_LENDI;
  var renderSecondaryBtn = (isAuthenticated, showBookanAppointmentCta, showContinueAction) => {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [showContinueAction && isAuthenticated && /*#__PURE__*/(0,jsx_runtime.jsx)(SecondaryAction, {
        size: "sm",
        variant: 'emphasis',
        href: continueURL,
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            buttonType: ButtonType.EMPHASIS,
            text: 'Continue',
            category: EventCategory.NAVBAR
          };
          navbar_esm_analytics(event);
        },
        "aria-label": continueURL,
        children: LABEL_CONTINUE
      }), showContinueAction && !isAuthenticated && /*#__PURE__*/(0,jsx_runtime.jsx)(SecondaryAction, {
        size: "sm",
        variant: 'primary',
        href: signInURL,
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            buttonType: ButtonType.PRIMARY,
            text: 'Sign In',
            category: EventCategory.NAVBAR
          };
          navbar_esm_analytics(event);
        },
        "aria-label": signInURL,
        children: LABEL_SIGN_IN
      }), !showContinueAction && showBookanAppointmentCta && /*#__PURE__*/(0,jsx_runtime.jsx)(SecondaryAction, {
        size: "sm",
        variant: 'primary',
        href: "".concat(path).concat(ROUTE_BOOK_APPOINTMENT),
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            buttonType: ButtonType.PRIMARY,
            text: 'Book an Appointment',
            category: EventCategory.NAVBAR
          };
          navbar_esm_analytics(event);
        },
        "aria-label": "".concat(path).concat(ROUTE_BOOK_APPOINTMENT),
        children: BOOK_AN_APPOINTMENT
      })]
    });
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/(0,jsx_runtime.jsx)(RenderChatOrSideBar, {
      openCommPanel: openCommPanel,
      customerOwner: customerOwner,
      dashboardVariant: dashboardVariant,
      hasUnreadMessages: hasUnreadMessages
    }), renderSecondaryBtn(isAuthenticated, showBookanAppointmentCta, showContinueAction), isAuthenticated && /*#__PURE__*/(0,jsx_runtime.jsx)(LogoutComponent, {})]
  });
};
var RenderDesktopAction$1 = RenderDesktopAction;

var _templateObject$a;
var MobileActionsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__MobileActionsWrapper",
  componentId: "lui__sc-jzhj4e-0"
})(["display:flex;", ";.noHover{", ";:hover{box-shadow:none;}}"], (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject$a || (_templateObject$a = navbar_esm_taggedTemplateLiteral(["\n    display: none;\n  "]))), (0,spacing_esm.mr)('nil'));

var RenderMobileAction = _ref => {
  var _window, _window2;
  var {
    isAuthenticated,
    continueURL,
    customerOwner,
    openCommPanel = () => {},
    showContinueAction = false,
    showTalkToExpertCta = true,
    hasUnreadMessages
  } = _ref;
  var {
    isTransparent
  } = useNavbarBaseContext();
  var needToContinue = () => isAuthenticated && showContinueAction;
  var needToSignIn = () => !isAuthenticated && showContinueAction;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var primaryLabel = customerOwner !== null && customerOwner !== void 0 && customerOwner.firstName ? "Talk to ".concat(customerOwner.firstName) : needToContinue() ? CONTACT_US : brand === 'aussie' ? LABEL_TALK_TO_A_BROKER : LABEL_TALK_TO_EXPERT;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/(0,jsx_runtime.jsx)(TalkExpertAction, {
      size: "sm",
      isInverse: isTransparent,
      className: "noHover",
      variant: "secondary",
      onClick: () => {
        openCommPanel();
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          buttonType: ButtonType.SECONDARY,
          text: hasUnreadMessages ? 'You have an unread message' : brand === 'aussie' ? 'Talk to a broker' : 'Talk to an expert'
        };
        navbar_esm_analytics(event);
      },
      children: hasUnreadMessages ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnreadMessageWrapper, {
          "data-testid": "customer-view-unread-icon",
          color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'),
          height: "2em",
          width: "2em"
        }), UNREAD_MESSAGE_MOBILE]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: primaryLabel
      })
    }), needToSignIn() && /*#__PURE__*/(0,jsx_runtime.jsx)(SecondaryActionMobile, {
      size: "sm",
      variant: isAuthenticated ? 'emphasis' : 'primary',
      href: signInURL,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          buttonType: isAuthenticated ? ButtonType.EMPHASIS : ButtonType.PRIMARY,
          text: 'Sign In',
          category: EventCategory.NAVBAR
        };
        navbar_esm_analytics(event);
      },
      "aria-label": signInURL,
      children: LABEL_SIGN_IN
    }), needToContinue() && /*#__PURE__*/(0,jsx_runtime.jsx)(ContinueAction, {
      variant: "emphasis",
      href: continueURL,
      "aria-label": LABEL_CONTINUE,
      size: "sm",
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          text: 'Continue',
          buttonType: ButtonType.EMPHASIS
        };
        navbar_esm_analytics(event);
      },
      children: LABEL_CONTINUE
    }), isAuthenticated && /*#__PURE__*/(0,jsx_runtime.jsx)(LogoutComponent, {})]
  });
};
var RenderMobileAction$1 = RenderMobileAction;

var CTAButtons$2 = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RenderDesktopAction$1, navbar_esm_objectSpread2({
      hasUnreadMessages: props.hasUnreadMessages
    }, props)), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderMobileAction$1, navbar_esm_objectSpread2({
      hasUnreadMessages: props.hasUnreadMessages
    }, props))]
  });
};
var CTAButtons$3 = CTAButtons$2;

function navbar_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function navbar_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = navbar_esm_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded$e = ["showTalkToExpertCta"];
var withDomainChat = Component => _ref => {
  var {
      showTalkToExpertCta = true
    } = _ref,
    otherProps = navbar_esm_objectWithoutProperties(_ref, _excluded$e);
  var session = (0,dist_esm/* useSession */.kP)();
  var isAuthenticated = session.status === dist_esm/* Status.Authenticated */.qb.Authenticated;
  var isDomain = getBrandFromHostname() === Brand_Brand.Domain;
  var isDomainUnauthenticated = isDomain && !isAuthenticated;
  var shouldShowChat = showTalkToExpertCta && !isDomainUnauthenticated;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, navbar_esm_objectSpread2(navbar_esm_objectSpread2({}, otherProps), {}, {
    showTalkToExpertCta: shouldShowChat
  }));
};

var DropdownProvider = _ref => {
  var {
    children,
    hideDashboardItem,
    hideManageApplicationsItem,
    onLogout
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownMenuContext.Provider, {
    value: {
      hideDashboardItem,
      hideManageApplicationsItem,
      onLogout
    },
    children: children
  });
};

var navbar_esm_ErrorContext = /*#__PURE__*/react.createContext(undefined);
var navbar_esm_useError = () => {
  var errorState = react.useContext(navbar_esm_ErrorContext);
  if (!errorState) {
    throw new Error('Please setup <ErrorProvider /> as a parent component, before using useError().');
  }
  return errorState;
};

var navbar_esm_ErrorProvider = _ref => {
  var {
    children,
    onException
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_ErrorContext.Provider, {
    value: {
      onException
    },
    children: children
  });
};

var navbar_esm_withErrorProvider = Component => props => /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_ErrorProvider, {
  onException: props.onException,
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, navbar_esm_objectSpread2({}, props))
});

var CommPanelWrapper$1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__CommPanelWrapper",
  componentId: "lui__sc-no953w-0"
})(["", ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility;display:flex;flex-direction:column;height:100%;"], utils_esm/* normalise */.W$);

var calculateChatDisabled = (brand, _ref) => {
  var {
    disableChat,
    enableAussieChat,
    chatx
  } = _ref;
  var isChatDisabled = true;
  if (chatx) {
    isChatDisabled = true; // Disable chat if chatx flag is true
  } else if (brand === Brand_Brand.Aussie && enableAussieChat !== undefined) {
    isChatDisabled = enableAussieChat; // Enable chat for Aussie brand if enableAussieChat flag is defined
  } else if (disableChat !== undefined) {
    // lendi check
    isChatDisabled = disableChat; // Disable chat if disableChat flag is defined and set its value
  } else {
    isChatDisabled = true; // disable chat if none of the disabling conditions are met
  }
  return isChatDisabled;
};

var HeadWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__HeadWrapper",
  componentId: "lui__sc-zy0mzz-0"
})(["border-bottom:1px solid ", ";", ";"], (0,color_esm/* color */.$)('shade.100'), (0,spacing_esm.mt)('xxl'));
var navbar_esm_BrokerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__BrokerWrapper",
  componentId: "lui__sc-zy0mzz-1"
})(["display:flex;align-items:center;", ";"], (0,spacing_esm.ml)('xl'));
var BrokerImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__BrokerImgWrapper",
  componentId: "lui__sc-zy0mzz-2"
})(["", ";position:relative;"], (0,spacing_esm.mr)('xs'));
var BrokerFace$1 = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "style__BrokerFace",
  componentId: "lui__sc-zy0mzz-3"
})(["width:65px;height:65px;border-radius:50%;border:1px solid ", ";margin:auto;"], (0,color_esm/* color */.$)('shade.100'));
var BrokerDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__BrokerDetail",
  componentId: "lui__sc-zy0mzz-4"
})(["display:flex;flex-direction:column;justify-content:space-between;", ";"], (0,spacing_esm.ml)('xxs'));
var BrokerName = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Heading */.X6).withConfig({
  displayName: "style__BrokerName",
  componentId: "lui__sc-zy0mzz-5"
})(["font-weight:bold;"]);
var StyledFace$1 = (0,styled_components_browser_esm/* default */.ZP)(SvgFace).withConfig({
  displayName: "style__StyledFace",
  componentId: "lui__sc-zy0mzz-6"
})(["width:4.5em;height:4.5em;"]);
var StatusIcon$1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__StatusIcon",
  componentId: "lui__sc-zy0mzz-7"
})(["width:17px;height:17px;border-radius:50%;position:absolute;right:1px;bottom:8px;", ";"], props => props.isOnline ? (0,color_esm.bg)('success.600') : (0,color_esm.bg)('shade.400'));
var StyledBrokerFaces = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "style__StyledBrokerFaces",
  componentId: "lui__sc-zy0mzz-8"
})(["width:191px;display:block;margin-left:56px;"]);
var navbar_esm_StyledBody = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "style__StyledBody",
  componentId: "lui__sc-zy0mzz-9"
})(["margin-top:4px;"]);

var IMAGE_CDN = 'https://lendicdn.net/327bd43fb6e1de7a0a3f44af5ad14156/71ccb7a35a452ea8153b6d920f9f190e'; // This is the production CDN link for Shaka Storybook, which hosts static images

var mapProfileToTitle = profile => {
  switch (profile) {
    case 'Associate':
      return 'Home Loan Associate';
    case 'Broker':
      return 'Home Loan Specialist';
    case 'Broker Manager':
      return 'Home Loan Specialist';
    case 'Customer Solutions':
      return 'Customer Solutions';
    case 'Offboarded User':
      return 'Home Loan Specialist';
    case 'Partner Broker':
      return 'Home Loan Consultant';
    case 'Relationship Manager':
      return 'Relationship Manager';
    case 'Senior Relationship Manager':
      return 'Relationship Manager';
  }
};
var TeamMemberInfo = /*#__PURE__*/react.memo(_ref => {
  var {
    teamMember,
    isOtherUserOnline
  } = _ref;
  var {
    brand
  } = (0,dist_esm/* useSession */.kP)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HeadWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_BrokerWrapper, {
      children: teamMember ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BrokerImgWrapper, {
          children: [teamMember.profilePictureURL ? /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerFace$1, {
            src: teamMember.profilePictureURL
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFace$1, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(StatusIcon$1, {
            isOnline: isOtherUserOnline,
            "aria-label": isOtherUserOnline ? 'Online' : 'Offline'
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BrokerDetail, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BrokerName, {
            size: "sm",
            color: "shade.700",
            children: teamMember.firstName
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerName, {
            size: "sm",
            color: "shade.700",
            children: teamMember.lastName
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_StyledBody, {
            size: "xs",
            color: "shade.400",
            mb: "xs",
            children: mapProfileToTitle(teamMember.profile) || 'Home Loan Specialist'
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBrokerFaces, {
        src: "".concat(IMAGE_CDN, "/images/").concat(brand, ".png"),
        alt: "Friendly broker image"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_esm/* Body */.uT, {
      size: "md",
      align: "center",
      mx: "lg",
      color: "shade.700",
      mb: "sm",
      mt: "sm",
      children: teamMember ? "I'm here to support your loan journey. Got a question? Just ask!" : "Get in touch with one of our ".concat(brand === 'aussie' ? 'brokers' : 'experts', " who can answer all your home loan related questions.")
    })]
  });
});

// LUI-465 we are hard-coding theming for this component as not all colours are part of our semantic palette
var theming = {
  lendi: {
    background: '#E6EEF0',
    foreground: '#0D5A6D'
  },
  domain: {
    background: '#E6E8EC',
    foreground: '#06193A'
  },
  aussie: {
    background: '#EEEAF1',
    foreground: '#522B6F'
  }
};
var getThemedColour = property => {
  var theTheme = (0,commons_esm/* getThemeName */.Yo)();
  var theme = theTheme === 'lendi-next' ? theming.lendi : theming[theTheme];
  return theme[property];
};

var ULOptions = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "style__ULOptions",
  componentId: "lui__sc-absiyo-0"
})(["list-style-type:none;width:100%;", " ", " ", ";"], (0,spacing_esm.m)('nil'), (0,spacing_esm.p)('nil'), (0,spacing_esm.pb)('xxs'));
var selectedStyle = (0,styled_components_browser_esm/* css */.iv)(["background-color:", ";p{", ";}svg{fill:", ";}"], () => getThemedColour('background'), (0,color_esm.fg)('shade.0'), (0,color_esm/* color */.$)('shade.0'));
var navbar_esm_ItemWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "style__ItemWrapper",
  componentId: "lui__sc-absiyo-1"
})(["list-style-type:none;width:100%;border-bottom:1px solid ", ";:focus,:hover,:visited{text-decoration:none;}:hover{", "}"], (0,color_esm/* color */.$)('shade.100'), selectedStyle);
var navbar_esm_LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU).withConfig({
  displayName: "style__LinkWrapper",
  componentId: "lui__sc-absiyo-2"
})(["color:", ";width:100%;display:flex;align-items:center;text-decoration:none;font-weight:600;:focus,:hover{background-color:", ";color:", ";text-decoration:none;}padding-left:20px;", ";"], () => getThemedColour('foreground'), () => (0,colours_dist_commons_esm/* default */.ZP)('fill', 'contrast'), () => (0,colours_dist_commons_esm/* default */.ZP)('text', 'inverse'), (0,spacing_esm.py)('xs'));
var navbar_esm_BodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "style__BodyWrapper",
  componentId: "lui__sc-absiyo-3"
})(["", ";color:", ";font-family:", ";font-size:16px;font-weight:bold;"], (0,spacing_esm.pl)('sm'), () => (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'secondary'), (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'));
var ChatBodyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__ChatBodyWrapper",
  componentId: "lui__sc-absiyo-4"
})(["display:flex;justify-content:space-between;align-items:center;", ";"], (0,spacing_esm.pr)('md'));

var CONTACT_NUMBERS = {
  lendi: '1300 323 181',
  domain: '1300 525 454',
  aussie: '13 13 33'
};
var BOOKING_PATHS = {
  lendi: '',
  domain: '/loanfinder',
  aussie: ''
};
var toTel = phoneNumber => "tel:+61".concat(phoneNumber.replace(/ /g, ''));
var PanelLinks = _ref => {
  var _teamMember$phoneNumb;
  var {
    teamMember,
    store,
    broker
  } = _ref;
  var {
    enhancedPrl
  } = (0,lib.useFlags)();
  var {
    name
  } = (0,ui_esm/* useTheme */.Fg)();
  var currentTheme = name;
  if (currentTheme === 'lendi-next') currentTheme = 'lendi';
  var path = BOOKING_PATHS[currentTheme];
  var phoneLabel = (_teamMember$phoneNumb = teamMember === null || teamMember === void 0 ? void 0 : teamMember.phoneNumber) !== null && _teamMember$phoneNumb !== void 0 ? _teamMember$phoneNumb : CONTACT_NUMBERS[currentTheme];
  var phoneLink = teamMember !== null && teamMember !== void 0 && teamMember.phoneNumber ? toTel(teamMember.phoneNumber) : "tel:".concat(phoneLabel.replace(/ /g, ''));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_ItemWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(navbar_esm_LinkWrapper, {
        href: phoneLink,
        "aria-label": "contact us by phone",
        "data-testid": "header-link-contact-us",
        "data-component": "customer-view-phone-link",
        onClick: () => {
          var levent = {
            event_name: 'Link Clicked',
            text: phoneLabel,
            category: EventCategory.COMMSPANEL,
            linkType: 'link',
            position: 'Contact Us',
            customerType: CustomerType.CUSTOMER
          };
          navbar_esm_analytics(levent);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgPhone, {
          "data-testid": "customer-view-phone-icon",
          height: "18px",
          width: "18px"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_BodyWrapper, {
          size: "md",
          children: phoneLabel
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_ItemWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(navbar_esm_LinkWrapper, {
        href: "".concat(path, "/book-appointment/"),
        "aria-label": "book an appointment",
        "data-testid": "header-link-book-appointment",
        "data-component": "customer-view-appointment-link",
        onClick: () => {
          // Set Leads if customer clicked on BookApointment from Store page.
          // Unset Leads (to undefined) if customer clicked on BookApointment from non-Store page.
          // Set and Unset Leads if customer clicked on BookApointment from Broker page.
          // Unset Leads (to undefined) if customer clicked on BookApointment from non-Broker page.
          if (!enhancedPrl) {
            store !== null && store !== void 0 && store.id ? lendigroup_leads_library_dist_esm/* LendiGroupLeads.setStoreId */.vA.setStoreId(store === null || store === void 0 ? void 0 : store.id) : lendigroup_leads_library_dist_esm/* LendiGroupLeads.unsetStoreId */.vA.unsetStoreId();
            broker !== null && broker !== void 0 && broker.id ? lendigroup_leads_library_dist_esm/* LendiGroupLeads.setBrokerId */.vA.setBrokerId(broker === null || broker === void 0 ? void 0 : broker.id) : lendigroup_leads_library_dist_esm/* LendiGroupLeads.unsetBrokerId */.vA.unsetBrokerId();
          } else {
            store !== null && store !== void 0 && store.id ? sessionStorage.setItem(SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID, store === null || store === void 0 ? void 0 : store.id) : sessionStorage.removeItem(SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID);
            broker !== null && broker !== void 0 && broker.id ? sessionStorage.setItem(SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID, broker === null || broker === void 0 ? void 0 : broker.id) : sessionStorage.removeItem(SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID);
          }
          // Analytics
          var linkEvent = {
            event_name: 'Link Clicked',
            text: 'Book an appointment',
            category: EventCategory.COMMSPANEL,
            linkType: 'link',
            customerType: CustomerType.CUSTOMER
          };
          navbar_esm_analytics(linkEvent);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgCalendar, {
          "data-testid": "customer-view-calendar-icon",
          height: "18px",
          width: "18px"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_BodyWrapper, {
          size: "md",
          children: "Book an appointment"
        })]
      })
    })]
  });
};

var UnReadDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__UnReadDot",
  componentId: "lui__sc-10i6qtc-0"
})(["width:7px;height:7px;border-radius:50%;position:absolute;right:-2px;top:-2px;", ";"], (0,color_esm.bg)('error.600'));
var StyledChatIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "style__StyledChatIcon",
  componentId: "lui__sc-10i6qtc-1"
})(["position:relative;"]);

var ChatIcon = _ref => {
  var {
    hasNew
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledChatIcon, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgChat, {
      color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'secondary'),
      height: "18px",
      width: "18px"
    }), hasNew ? /*#__PURE__*/(0,jsx_runtime.jsx)(UnReadDot, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
  });
};

var ChatLinKWrapper = (0,styled_components_browser_esm/* default */.ZP)(navbar_esm_ItemWrapper).withConfig({
  displayName: "style__ChatLinKWrapper",
  componentId: "lui__sc-1pa95jd-0"
})(["", ";", ";"], _ref => {
  var {
    disabled
  } = _ref;
  return disabled && (0,styled_components_browser_esm/* css */.iv)(["pointer-events:none;opacity:0.6;"]);
}, _ref2 => {
  var {
    isChatOpen
  } = _ref2;
  return isChatOpen && (0,styled_components_browser_esm/* css */.iv)(["background-color:", ";p{color:", ";}svg{fill:", ";}"], (0,colours_dist_commons_esm/* default */.ZP)('fill', 'contrast'), (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'subtle'), (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'subtle'));
});
var positionedRight = (0,styled_components_browser_esm/* css */.iv)(["position:absolute;right:10px;"]);
(0,styled_components_browser_esm/* default */.ZP)(SvgKeyboardArrowDown).withConfig({
  displayName: "style__ChevronUpDownIcon",
  componentId: "lui__sc-1pa95jd-1"
})(["", ";", ""], positionedRight, _ref3 => {
  var {
    isChatOpen
  } = _ref3;
  return (0,styled_components_browser_esm/* css */.iv)(["transition:transform 0.25s;transform:rotate(", ");"], isChatOpen ? '180deg' : '0deg');
});
var ChevronRightIcon = (0,styled_components_browser_esm/* default */.ZP)(SvgKeyboardArrowRight).withConfig({
  displayName: "style__ChevronRightIcon",
  componentId: "lui__sc-1pa95jd-2"
})([""]);
var StyledChevronRightIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronRightIcon).withConfig({
  displayName: "style__StyledChevronRightIcon",
  componentId: "lui__sc-1pa95jd-3"
})(["", ";"], positionedRight);

var ChatLink = _ref => {
  var {
    disabled,
    onChatLinkClick,
    hasNew,
    isChatOpen
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ChatLinKWrapper, {
    disabled: disabled,
    isChatOpen: isChatOpen,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(navbar_esm_LinkWrapper, {
      onClick: onChatLinkClick,
      "aria-label": "Chat Online",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ChatIcon, {
        hasNew: hasNew
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChatBodyWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_BodyWrapper, {
          size: "md",
          children: "Chat Now"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledChevronRightIcon, {
          color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'),
          height: "24px",
          width: "24px"
        })]
      })]
    })
  });
};

var SidePanel = _ref => {
  var {
    teamMember,
    broker,
    store,
    hasChat,
    isChatOpen,
    onChatLinkClick,
    disabled,
    isOtherUserOnline,
    hasNew
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TeamMemberInfo, {
      teamMember: teamMember,
      isOtherUserOnline: isOtherUserOnline
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ULOptions, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PanelLinks, {
        teamMember: teamMember,
        broker: broker,
        store: store
      }), hasChat && /*#__PURE__*/(0,jsx_runtime.jsx)(ChatLink, {
        isChatOpen: isChatOpen,
        disabled: disabled,
        onChatLinkClick: onChatLinkClick,
        hasNew: hasNew
      })]
    })]
  });
};

styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__MobileBrokerInfoWrapper",
  componentId: "lui__sc-18wuygo-0"
})(["display:flex;align-items:center;"]);
var navbar_esm_FaceWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "style__FaceWrapper",
  componentId: "lui__sc-18wuygo-1"
})(["position:relative;"]);
var BrokerFace = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "style__BrokerFace",
  componentId: "lui__sc-18wuygo-2"
})(["width:20px;height:20px;border-radius:50%;border:1px solid ", ";"], (0,color_esm/* color */.$)('shade.100'));
var StatusIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "style__StatusIcon",
  componentId: "lui__sc-18wuygo-3"
})(["width:8px;height:8px;border-radius:50%;position:absolute;right:-1px;bottom:4px;", ";"], props => props.isOnline ? (0,color_esm.bg)('success.600') : (0,color_esm.bg)('shade.400'));
var StyledFace = (0,styled_components_browser_esm/* default */.ZP)(SvgFace).withConfig({
  displayName: "style__StyledFace",
  componentId: "lui__sc-18wuygo-4"
})(["height:26px;width:22px;"]);

var ChatHeaderTeamMemberAvatar = _ref => {
  var {
    teamMember,
    isBrokerOnline
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(navbar_esm_FaceWrapper, {
    children: [teamMember !== null && teamMember !== void 0 && teamMember.profilePictureURL ? /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerFace, {
      src: teamMember.profilePictureURL
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFace, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(StatusIcon, {
      isOnline: isBrokerOnline,
      "aria-label": isBrokerOnline ? 'Online' : 'Offline'
    })]
  });
};

var StickyHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__StickyHeader",
  componentId: "lui__sc-1pqeqpe-0"
})(["top:0;position:relative;display:flex;flex-direction:row;z-index:3;width:100%;background-color:", ";align-items:center;padding-left:10px;", " ", "   border-bottom:1px solid ", ";cursor:pointer;"], (0,colours_dist_commons_esm/* default */.ZP)('interaction', 'subtle'), (0,spacing_esm.pt)('xs'), (0,spacing_esm.pb)('xxs'), (0,colours_dist_commons_esm/* default */.ZP)('background', 'surface'));
var TeamMemberBodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "style__TeamMemberBodyWrapper",
  componentId: "lui__sc-1pqeqpe-1"
})(["", ";font-size:16px;font-weight:bold;"], (0,spacing_esm.pl)('xxs'));
var ChevronLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(SvgKeyboardArrowLeft).withConfig({
  displayName: "style__ChevronLeftIcon",
  componentId: "lui__sc-1pqeqpe-2"
})([""]);

var FullViewChatHeader = _ref => {
  var {
    onClick,
    teamMember,
    isOtherUserOnline
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StickyHeader, {
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: teamMember ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ChevronLeftIcon, {
          color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'secondary'),
          height: "24px",
          width: "24px"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChatHeaderTeamMemberAvatar, {
          teamMember: teamMember,
          isBrokerOnline: isOtherUserOnline
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChatBodyWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TeamMemberBodyWrapper, {
            size: "md",
            color: "secondary.500",
            children: teamMember ? "".concat(teamMember.firstName, " ").concat(teamMember.lastName) : 'Home Loan Specialist'
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgKeyboardArrowLeft, {
          color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'secondary'),
          height: "24px",
          width: "24px"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_BodyWrapper, {
          size: "md",
          children: "Chat online"
        })]
      })
    })
  });
};

var StyledClose = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* IconButton */.hU).withConfig({
  displayName: "style__StyledClose",
  componentId: "lui__sc-qeih4b-0"
})(["position:absolute;"]);

var _excluded$d = ["enableHistoricalThreads"];
var WithChatView = _ref => {
  var {
    legacySupport,
    userType,
    isOtherUserOnline,
    hasNew,
    onException
  } = _ref;
  var {
    closeCommPanel,
    isCommPanelOpen,
    isChatOpen,
    openChat,
    teamMember,
    broker,
    store,
    channelId,
    migratedToConversation,
    setSelectedThread,
    applicationId,
    closeChat
  } = (0,context/* useBootstrappedChatState */.D)();
  var _useFlags = (0,lib.useFlags)(),
    {
      enableHistoricalThreads
    } = _useFlags,
    otherFlags = navbar_esm_objectWithoutProperties(_useFlags, _excluded$d);
  var {
    brand
  } = (0,dist_esm/* useSession */.kP)();
  // TODO: Need to revisit this logic - as a part of this ticket : https://creditandfinance.atlassian.net/browse/SUBS-1012
  // Disabling Aussie chat by hardcoding instead relying on FF
  var hasChat = brand === dist_esm/* Brand.Aussie */.H2.Aussie ? false : !calculateChatDisabled(brand, otherFlags);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [(isCommPanelOpen && !isChatOpen || !enableHistoricalThreads) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledClose, {
      color: "shade.300",
      onClick: closeCommPanel,
      size: "md",
      "aria-label": "Close comm panel",
      icon: icon_esm/* default */.Z
    }), isChatOpen && !enableHistoricalThreads && /*#__PURE__*/(0,jsx_runtime.jsx)(FullViewChatHeader, {
      teamMember: teamMember,
      isOtherUserOnline: isOtherUserOnline,
      onClick: closeChat
    }), !isChatOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(SidePanel, {
      teamMember: teamMember,
      store: store,
      broker: broker,
      hasChat: hasChat,
      isChatOpen: isChatOpen,
      disabled: false,
      onChatLinkClick: openChat,
      isOtherUserOnline: isOtherUserOnline,
      hasNew: hasNew
    }), hasChat && /*#__PURE__*/(0,jsx_runtime.jsx)(components_ChatComponent, {
      openChat: isChatOpen,
      userType: userType,
      teamMember: teamMember,
      channelId: channelId,
      migratedToConversation: migratedToConversation,
      onException: onException,
      setSelectedThread: setSelectedThread,
      applicationId: applicationId
    })]
  });
};

var CustomerCommPanel = _ref => {
  var {
    legacySupport = false,
    isOtherUserOnline = false,
    hasNew,
    onException
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CommPanelWrapper$1, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(WithChatView, {
      legacySupport: legacySupport,
      userType: 'customer',
      isOtherUserOnline: isOtherUserOnline,
      hasNew: hasNew,
      onException: onException
    })
  });
};

var _excluded$c = ["children", "className", "isOpen", "handleClose", "topOffset"];
var _templateObject$9, _templateObject2$4;
var IS_OPEN_DATA_ATTRIBUTE = 'data-slideout-isOpen';
var slideInRight = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{transform:translate3d(100%,0,0);}100%{transform:translate3d(0,0,0);}"]);
var slideOutRight = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{transform:translate3d(0,0,0);}100%{transform:translate3d(100%,0,0);}"]);

/**
 * @todo z-index: tokenise z-index to make it easier to manage levels
 */

var StyledSlideoutMenu$1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SlideoutMenuBase__StyledSlideoutMenu",
  componentId: "lui__sc-msuqad-0"
})(["display:none;width:100%;position:fixed;top:0;bottom:0;right:0;z-index:2;animation-fill-mode:forwards;animation-duration:0.3s;animation-timing-function:ease;", " &.is-open{transform:translate3d(0,0,0);display:block;}&.slide-in-right{animation-name:", ";}&.slide-out-right{animation-name:", ";}", ""], (0,breakpoint_esm/* gte */.eg)('sm')(_templateObject$9 || (_templateObject$9 = navbar_esm_taggedTemplateLiteral(["\n    width: ", ";;\n  "])), (0,commons_esm/* pxToRem */.Q1)(375)), slideInRight, slideOutRight, _ref => {
  var {
    topOffset
  } = _ref;
  return topOffset && (0,breakpoint_esm/* map */.UI)(topOffset, value => value && "top: ".concat(value));
});

// Sorry, 'any' typing hack to get rid of 'not a valid JSX element' warning when using in component return block
// @todo this is also an issue in the Theme component with global styles
// https://github.com/styled-components/styled-components/issues/3738
var BodyStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(["", ""], _ref2 => {
  var {
    isOpen
  } = _ref2;
  return isOpen && (0,styled_components_browser_esm/* css */.iv)(["[data-slideout-isOpen]{", "}"], (0,breakpoint_esm/* between */.vX)('xs', 'sm')(_templateObject2$4 || (_templateObject2$4 = navbar_esm_taggedTemplateLiteral(["\n      overflow: hidden;  \n    "]))));
});
var useSlideoutMenu = () => {
  var [showMenu, setShowMenu] = (0,react.useState)(false);
  var toggleMenu = () => setShowMenu(!showMenu);
  return {
    showMenu,
    toggleMenu
  };
};
var SlideoutMenuBase = _ref3 => {
  var {
      children,
      className,
      isOpen,
      handleClose,
      topOffset
    } = _ref3,
    props = navbar_esm_objectWithoutProperties(_ref3, _excluded$c);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var slideoutRef = (0,react.useRef)(null);
  var animationClassnames = isOpen ? "is-open slide-in-right" : 'slide-out-right';
  var classNames = className ? "".concat(className, " ").concat(animationClassnames) : animationClassnames;

  // If the item is open listen for escape key
  (0,react.useEffect)(() => {
    var escapeEvent = event => {
      if (event.key === 'Escape') {
        // if there are multiple menus open, make sure we only close the one that is currently focused
        if (slideoutRef.current !== null && slideoutRef !== null && slideoutRef !== void 0 && slideoutRef.current.contains(document.activeElement)) {
          handleClose();
        }
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', escapeEvent);
      if (slideoutRef !== null && slideoutRef !== void 0 && slideoutRef.current) slideoutRef.current.style.display = 'block';
    }
    return () => {
      window.removeEventListener('keydown', escapeEvent);
    };
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  // Add data attribute to body as hook for indicating a slideout menu is open
  (0,react.useEffect)(() => {
    var allMenus = document.querySelectorAll('[data-is-open]');
    var atLeastOneIsOpen = Array.from(allMenus).some(item => item.getAttribute('data-is-open') === 'true');
    if (isOpen) {
      document.body.setAttribute(IS_OPEN_DATA_ATTRIBUTE, '');
    } else {
      // If multiple menus are open, we only want to remove the open attribute when they are all closed
      if (!atLeastOneIsOpen) {
        document.body.removeAttribute(IS_OPEN_DATA_ATTRIBUTE);
      }
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  var onAnimationEnd = () => {
    if (!isOpen) {
      var _slideoutRef$current;
      // happens after close
      slideoutRef === null || slideoutRef === void 0 || (_slideoutRef$current = slideoutRef.current) === null || _slideoutRef$current === void 0 || (_slideoutRef$current = _slideoutRef$current.classList) === null || _slideoutRef$current === void 0 || _slideoutRef$current.remove("slide-out-right");
      if (slideoutRef !== null && slideoutRef !== void 0 && slideoutRef.current) slideoutRef.current.style.display = 'none';
    } else {
      var _slideoutRef$current2;
      // happens after open
      slideoutRef === null || slideoutRef === void 0 || (_slideoutRef$current2 = slideoutRef.current) === null || _slideoutRef$current2 === void 0 || _slideoutRef$current2.classList.remove("slide-in-right");
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(es2015/* default */.ZP, {
    disabled: !isOpen,
    returnFocus: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BodyStyles, {
      isOpen: isOpen
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSlideoutMenu$1, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
      className: classNames,
      topOffset: topOffset
    }, globalProps), {}, {
      onAnimationEnd: onAnimationEnd,
      ref: slideoutRef,
      "data-is-open": isOpen,
      children: children
    }))]
  });
};

var _templateObject$8, _templateObject2$3;
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__StyledWrapper",
  componentId: "lui__sc-1hl3v3a-0"
})(["", ";right:14px;position:fixed;bottom:30px;padding:14px;align-items:center;gap:10px;border-radius:40px;color:#fff;background-color:#e52c64;cursor:pointer;box-shadow:0px 0px 2px 0px rgba(0,0,0,0.12),0px 2px 2px 0px rgba(0,0,0,0.12),0px 1px 3px 0px rgba(0,0,0,0.14);transition:width 600ms ease-in-out;width:", ";&:hover{width:143px;}"], (0,breakpoint_esm/* gte */.eg)('tablet')(_templateObject$8 || (_templateObject$8 = navbar_esm_taggedTemplateLiteral(["\n  right: 16px;\n  "]))), _ref => {
  var {
    isContracted
  } = _ref;
  return isContracted ? '50px' : '143px';
});
var BubbleBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "style__BubbleBody",
  componentId: "lui__sc-1hl3v3a-1"
})(["display:flex;flex-direction:row;gap:10px;align-items:center;position:relative;"]);
var Label$1 = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "style__Label",
  componentId: "lui__sc-1hl3v3a-2"
})(["", ";color:#fff;text-align:center;font-size:12px;font-style:normal;font-weight:700;line-height:20px;&.hidden{display:none;}"], (0,breakpoint_esm/* gte */.eg)('tablet')(_templateObject2$3 || (_templateObject2$3 = navbar_esm_taggedTemplateLiteral(["\n  font-size: 14px;\n  "]))));
var Dot = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "style__Dot",
  componentId: "lui__sc-1hl3v3a-3"
})(["width:24px;height:24px;border-radius:40px;background-color:", ";position:absolute;top:-21px;right:-19px;"], (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'));

var navbar_esm_ChatBubble = _ref => {
  var {
    onClick: _onClick
  } = _ref;
  var [isContracted, setContracted] = (0,react.useState)(false);
  var [showLabel, setShowLabel] = (0,react.useState)(true);
  (0,react.useEffect)(() => {
    var timeout = setTimeout(() => {
      setContracted(true);
      setShowLabel(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);
  (0,react.useEffect)(() => {
    var timeout;
    if (isContracted) {
      setShowLabel(false);
    } else {
      timeout = setTimeout(() => {
        setShowLabel(true);
      }, 650);
    }
    return () => clearTimeout(timeout);
  }, [isContracted, showLabel]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapper, {
    isContracted: isContracted,
    onClick: () => {
      _onClick();
      var bubbleEvent = {
        event_name: 'Chat Bubble Opened',
        category: EventCategory.NAVBAR,
        text: 'Chat online',
        customerType: CustomerType.CUSTOMER
      };
      navbar_esm_analytics(bubbleEvent);
    },
    onMouseEnter: () => setContracted(false),
    onMouseLeave: () => setContracted(true),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(BubbleBody, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgChat, {
        width: "24px",
        height: "24px"
      }), showLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(Label$1, {
        children: "Chat online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dot, {})]
    })
  });
};
var ChatBubble$1 = navbar_esm_ChatBubble;

var _templateObject$7;
var CommPanelWrapper = (0,styled_components_browser_esm/* default */.ZP)(SlideoutMenuBase).withConfig({
  displayName: "CommPanelProvider__CommPanelWrapper",
  componentId: "lui__sc-jqofne-0"
})(["max-width:", ";background-color:", ";box-shadow:0px 4px 4px 0px ", ";", " ", ";"], (0,commons_esm/* pxToRem */.Q1)(375), (0,colours_dist_commons_esm/* default */.ZP)('shade', 0), (0,colours_dist_commons_esm/* default */.ZP)('shade', 200), _ref => {
  var {
    topOffset,
    toTheTop
  } = _ref;
  if (!toTheTop) {
    if (topOffset) {
      return (0,breakpoint_esm/* map */.UI)(topOffset, value => value && "top: ".concat(value, ";"));
    } else {
      return (0,styled_components_browser_esm/* css */.iv)(["top:", ";", ";"], navTokens.size.height.navbar.mobile.value, (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject$7 || (_templateObject$7 = navbar_esm_taggedTemplateLiteral(["\n            top: ", ";\n          "])), navTokens.size.height.navbar.desktop.value));
    }
  }
}, _ref2 => {
  var {
    toTheTop
  } = _ref2;
  return toTheTop && (0,styled_components_browser_esm/* css */.iv)(["top:0;z-index:999;"]);
});
var withCommPanelWrapper = Component =>
// eslint-disable-next-line react/display-name
props => {
  var {
    onException
  } = navbar_esm_useError();
  var {
    chatBubble,
    chatExperiment,
    chatx
  } = (0,lib.useFlags)();
  var {
    isCommPanelOpen,
    openCommPanel,
    closeCommPanel,
    channelId,
    customerOwner,
    openChat,
    storeName
  } = (0,context/* useBootstrappedChatState */.D)();
  var [hasUnread, setHasUnread] = react.useState(false);
  var [isOtherUserOnline, setIsOtherUserOnline] = react.useState(false);
  var [breakpoint, setBreakpoint] = react.useState();
  var [renderChatBubble, setRenderChatBubble] = (0,react.useState)(false);
  (0,breakpoint_esm/* useBreakpoint */.Gc)(setBreakpoint);
  var theme = (0,commons_esm/* getThemeName */.Yo)();
  var shouldFullScreen = theme === 'aussie' || breakpoint === 'mobile';
  var isExperiment = chatExperiment === 'Experiment1' || chatExperiment === 'Experiment3';
  (0,react.useEffect)(() => {
    if (chatx) {
      setRenderChatBubble(false);
    } else if (props.enableChatBubble && chatBubble && isExperiment) {
      setRenderChatBubble(true);
    } else {
      setRenderChatBubble(false);
    }
  }, [props, chatBubble, isExperiment, chatx]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ChatDataExposureContext.Provider, {
    value: {
      setHasUnReadMessage: hasUnreadMessages => setHasUnread(hasUnreadMessages),
      setStatus: status => setIsOtherUserOnline(status)
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Component, navbar_esm_objectSpread2(navbar_esm_objectSpread2({}, props), {}, {
      isCommPanelOpen: isCommPanelOpen,
      hasUnread: hasUnread,
      closeCommPanel: closeCommPanel,
      openCommPanel: openCommPanel,
      customerOwner: customerOwner,
      storeName: storeName
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(CommPanelWrapper, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
      isOpen: isCommPanelOpen,
      handleClose: closeCommPanel,
      toTheTop: shouldFullScreen,
      topOffset: props === null || props === void 0 ? void 0 : props.topOffset
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomerCommPanel, {
        channelId: channelId,
        hasNew: hasUnread,
        isOtherUserOnline: isOtherUserOnline,
        onException: onException
      })
    })), renderChatBubble && /*#__PURE__*/(0,jsx_runtime.jsx)(ChatBubble$1, {
      onClick: openChat
    })]
  });
};
var withCommPanel = Component => withCustomerChatProvider(withCommPanelWrapper(Component));

var setLenderIdInSessionStorage = id => {
  if (!id) return;
  sessionStorage.setItem('AHL', id);
};
var unsetLenderIdInSessionStorage = () => {
  sessionStorage.removeItem('AHL');
};
var useAHLParam = () => {
  (0,react.useEffect)(() => {
    if (typeof window !== undefined && window.sessionStorage) {
      var url = window.location.pathname;
      if (url.match(CMS_AHL_MAIN_URL_MATCH) || url.match(CMS_AHL_ELEVATE_URL_MATCH)) {
        return setLenderIdInSessionStorage(AHLProducts.AUSSIE_ELEVATE);
      }
      if (url.match(CMS_AHL_ACTIVATE_URL_MATCH)) {
        return setLenderIdInSessionStorage(AHLProducts.AUSSIE_ACTIVATE);
      }
      if (url.match(CMS_AHL_SELECT_URL_MATCH)) {
        return setLenderIdInSessionStorage(AHLProducts.AUSSIE_SELECT);
      }
      if (!url.match(FUNNEL1_URL_MATCH)) {
        return unsetLenderIdInSessionStorage();
      }
    }
  }, []);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var SimpleNavbarComponent = _ref => {
  var {
    // Public props
    useTransparent = false,
    showBookanAppointmentCta = true,
    showTalkToExpertCta = true,
    homeURL,
    params = '',
    continueURL = '/',
    onLogout,
    showContinueAction = false,
    hideDashboardItem,
    hideManageApplicationsItem,
    // Internal props, from ChatProps
    isCommPanelOpen,
    hasUnread,
    closeCommPanel,
    openCommPanel: _openCommPanel,
    customerOwner
  } = _ref;
  var {
    primaryBrandCustomerAlert
  } = (0,lib.useFlags)();
  var session = (0,dist_esm/* useSession */.kP)();
  var isAuthenticated = session.status === dist_esm/* Status.Authenticated */.qb.Authenticated;

  // to set AHL value in session storage for funnel1 journey
  useAHLParam();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NavbarWrapper, {
      isTransparent: useTransparent,
      isAuthenticated: isAuthenticated,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_NavbarLeftWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoComponent$1, {
          homeURL: homeURL,
          params: params,
          "aria-label": "Logo",
          hasHamburgerMenu: false
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_NavbarRightWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownProvider, {
          hideDashboardItem: hideDashboardItem,
          hideManageApplicationsItem: hideManageApplicationsItem,
          onLogout: onLogout,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButtons$3, {
            showTalkToExpertCta: showTalkToExpertCta,
            showBookanAppointmentCta: showBookanAppointmentCta,
            isAuthenticated: isAuthenticated,
            continueURL: continueURL,
            showContinueAction: showContinueAction,
            openCommPanel: () => isCommPanelOpen ? closeCommPanel() : _openCommPanel(),
            customerOwner: customerOwner,
            hasUnreadMessages: hasUnread
          })
        })
      })]
    }), primaryBrandCustomerAlert && (session === null || session === void 0 ? void 0 : session.brand) === 'lendi' && /*#__PURE__*/(0,jsx_runtime.jsxs)(AlertBanner, {
      variant: "info",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        children: "Your home loan journey just got even better"
      }), "\u2014welcome to Aussie!", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(typography_esm/* Link */.rU, {
        href: "https://aussie.com.au/lp/welcome-to-aussie",
        target: "_blank",
        children: "Learn more."
      })]
    })]
  });
};
var SimpleNavbar = navbar_esm_withErrorProvider(withLendiLDProvider(withCommPanel(withDomainChat(SimpleNavbarComponent))));

var GuestNavbar = _ref => {
  var {
    useTransparent = false,
    homeURL,
    params = ''
  } = _ref;
  return /*#__PURE__*/jsx(NavbarWrapper, {
    isTransparent: useTransparent,
    isAuthenticated: false,
    children: /*#__PURE__*/jsx(navbar_esm_NavbarLeftWrapper, {
      children: /*#__PURE__*/jsx(LogoComponent$1, {
        homeURL: homeURL,
        params: params,
        "aria-label": "Logo",
        hasHamburgerMenu: false
      })
    })
  });
};

var MULTI_MENU_OPTIONS = [{
  label: 'Home loans',
  link: '/home-loans/',
  children: [{
    label: 'Find your home loan',
    link: '/home-loans/basics/'
  }, {
    label: 'Refinance your loan',
    link: '/home-loans/refinance/'
  }, {
    label: 'Buy your first home',
    link: '/home-loans/first-home-buyer/'
  }, {
    label: 'Buy your next home',
    link: '/home-loans/buying/'
  }, {
    label: 'Invest in property',
    link: '/home-loans/investment/'
  }, {
    label: 'Build your home',
    link: '/home-loans/construction/'
  }, {
    label: 'Property value report',
    link: '/property-report/'
  }]
}, {
  label: 'Calculators',
  link: '/calculators/',
  children: [{
    label: 'Property report',
    link: '/property-report/'
  }, {
    label: 'Credit score',
    link: '/calculators/check-your-credit-score/'
  }, {
    label: 'Borrowing power calculator',
    link: '/home-loans/basics/borrowing-power/'
  }, {
    label: 'Repayment calculator',
    link: '/calculators/home-loan-repayment-calculator/'
  }, {
    label: 'Stamp duty calculator',
    link: '/stamp-duty-calculator/'
  }, {
    label: 'Offset calculator',
    link: '/calculators/offset-calculator/'
  }, {
    label: 'Equity calculator',
    link: '/calculators/equity-calculator/'
  }, {
    label: 'Debt consolidation calculator',
    link: '/calculators/debt-consolidation-calculator/'
  }]
}, {
  label: 'Blog',
  link: '/inspire/',
  children: [{
    label: 'Insights',
    link: '/inspire/category/insights/'
  }, {
    label: 'Finance',
    link: '/inspire/category/finance/'
  }, {
    label: 'Lifestyle',
    link: '/inspire/category/lifestyle/'
  }, {
    label: 'Lendi homes',
    link: '/inspire/category/lendi-homes/'
  }, {
    label: 'Property',
    link: '/inspire/category/property/'
  }, {
    label: 'Design',
    link: '/inspire/category/design/'
  }, {
    label: 'Life at Lendi',
    link: '/inspire/category/life-at-lendi/'
  }]
}];
var MULTI_MENU_OPTIONS_WITH_HEALTH_CHECK = MULTI_MENU_OPTIONS.map(menu => navbar_esm_objectSpread2(navbar_esm_objectSpread2({}, menu), {}, {
  children: menu.children.map(child => child.link === '/calculators/debt-consolidation-calculator/' ? {
    label: 'Home loan health check',
    link: '/home-loans/health-check/'
  } : child)
}));
var getMultiMenuOptions = function getMultiMenuOptions() {
  var featureFlags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // replace debt-consolidation-calculator with health-check if gpHomeLoanHealthCheck enabled
  return featureFlags.gpHomeLoanHealthCheck ? MULTI_MENU_OPTIONS_WITH_HEALTH_CHECK : MULTI_MENU_OPTIONS;
};

var DesktopActions = _ref => {
  var _window, _window2;
  var {
    isAuthenticated,
    continueURL,
    showContinueAction = false,
    openCommPanel = () => {},
    teamMember,
    hasUnreadMessages,
    showTalkToExpertCta
  } = _ref;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var primaryLabel = teamMember !== null && teamMember !== void 0 && teamMember.firstName ? "Talk to ".concat(teamMember.firstName) : brand === 'aussie' ? LABEL_TALK_TO_A_BROKER : LABEL_TALK_TO_EXPERT;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/(0,jsx_runtime.jsx)(TalkExpertAction$1, {
      variant: "secondary",
      onClick: () => {
        openCommPanel();
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          buttonType: ButtonType.SECONDARY,
          text: hasUnreadMessages ? 'You have an unread message' : brand === 'aussie' ? 'Talk to a broker' : 'Talk to an expert'
        };
        navbar_esm_analytics(event);
      },
      size: "sm",
      bigLabelAccomodate: isAuthenticated ? !showContinueAction : false,
      children: hasUnreadMessages ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnreadMessageWrapper, {
          "data-testid": "customer-view-unread-icon",
          color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'),
          height: "2em",
          width: "2em"
        }), UNREAD_MESSAGE]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: primaryLabel
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SecondaryAction, {
      bigLabelAccomodate: isAuthenticated ? !showContinueAction : false,
      size: "sm",
      variant: isAuthenticated ? showContinueAction ? 'emphasis' : 'primary' : 'primary',
      href: isAuthenticated ? showContinueAction ? continueURL : ROUTE_BOOK_APPOINTMENT : signInURL,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          text: isAuthenticated ? showContinueAction ? 'Continue' : 'Book an Appointment' : 'Sign In',
          buttonType: isAuthenticated ? showContinueAction ? ButtonType.EMPHASIS : ButtonType.PRIMARY : ButtonType.PRIMARY
        };
        navbar_esm_analytics(event);
      },
      "aria-label": isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : signInURL,
      children: isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : LABEL_SIGN_IN
    }), isAuthenticated && /*#__PURE__*/(0,jsx_runtime.jsx)(LogoutComponent, {})]
  });
};

var MobileActions = _ref => {
  var _window, _window2;
  var {
    isAuthenticated,
    continueURL,
    showContinueAction = false,
    openCommPanel = () => {},
    teamMember,
    hasUnreadMessages,
    showTalkToExpertCta
  } = _ref;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var {
    isTransparent
  } = useNavbarBaseContext();
  var secondaryLabel = teamMember !== null && teamMember !== void 0 && teamMember.firstName ? "Talk to ".concat(teamMember.firstName) : CONTACT_US;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/(0,jsx_runtime.jsx)(TalkExpertActionMobile, {
      className: "noHover",
      variant: "secondary",
      onClick: () => {
        openCommPanel();
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          buttonType: ButtonType.SECONDARY,
          text: hasUnreadMessages ? 'You have an unread message' : 'Contact us'
        };
        navbar_esm_analytics(event);
      },
      "aria-label": CONTACT_US,
      size: "sm",
      isInverse: isTransparent,
      isContinue: showContinueAction,
      children: hasUnreadMessages ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnreadMessageWrapper, {
          "data-testid": "customer-view-unread-icon",
          color: (0,colours_dist_commons_esm/* getColour */.hs)('interaction', 'main'),
          height: "2em",
          width: "2em"
        }), UNREAD_MESSAGE_MOBILE]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [" ", secondaryLabel]
      })
    }), isAuthenticated ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: showContinueAction && /*#__PURE__*/(0,jsx_runtime.jsx)(SecondaryActionMobile, {
        size: "sm",
        variant: 'emphasis',
        href: continueURL,
        "aria-label": LABEL_CONTINUE,
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            category: EventCategory.NAVBAR,
            text: 'Continue',
            buttonType: ButtonType.EMPHASIS
          };
          navbar_esm_analytics(event);
        },
        children: LABEL_CONTINUE
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SecondaryActionMobile, {
      size: "sm",
      variant: 'primary',
      href: signInURL,
      "aria-label": signInURL,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          text: 'Sign In',
          buttonType: ButtonType.PRIMARY
        };
        navbar_esm_analytics(event);
      },
      children: LABEL_SIGN_IN
    })]
  });
};

var CTAButtons = props => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DesktopActions, navbar_esm_objectSpread2({}, props)), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileActions, navbar_esm_objectSpread2({}, props))]
  });
};
var CTAButtons$1 = CTAButtons;

var _templateObject$6;
var HamBurgerMenu = _ref => {
  var {
    toggleSidebar,
    leftSidebarState
  } = _ref;
  var {
    isTransparent
  } = useNavbarBaseContext();
  var commonButtonStyle = (0,styled_components_browser_esm/* css */.iv)(["height:", ";width:", ";color:", ";"], (0,utils_esm/* deriveSize */.MS)(1.6), (0,utils_esm/* deriveSize */.MS)(1.6), _ref2 => {
    var {
      theme
    } = _ref2;
    return isTransparent ? theme.color.interaction.subtle : theme.color.interaction.main;
  });
  var CloseButton = (0,styled_components_browser_esm/* default */.ZP)(icon_esm/* default */.Z).withConfig({
    displayName: "HamBurgerMenu__CloseButton",
    componentId: "lui__sc-y1cjve-0"
  })(["", ""], commonButtonStyle);
  var MenuButton = (0,styled_components_browser_esm/* default */.ZP)(SvgMenu).withConfig({
    displayName: "HamBurgerMenu__MenuButton",
    componentId: "lui__sc-y1cjve-1"
  })(["", ""], commonButtonStyle);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HamBurgerWrapper, {
    onClick: () => {
      toggleSidebar(!leftSidebarState);
      var event = {
        event_name: 'Menu Clicked',
        category: EventCategory.NAVBAR,
        menuName: 'Hamburger Menu'
      };
      navbar_esm_analytics(event);
    },
    children: leftSidebarState ? /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {
      "aria-label": "close menu"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
      "aria-label": "open menu"
    })
  });
};
var HamBurgerWrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "HamBurgerMenu__HamBurgerWrapper",
  componentId: "lui__sc-y1cjve-2"
})(["", ";cursor:pointer;"], (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject$6 || (_templateObject$6 = navbar_esm_taggedTemplateLiteral(["\n    display: none;\n  "]))));
var HamBurgerMenu$1 = HamBurgerMenu;

var MARKETING_TRACKING_SESSION_STORAGE_KEY = 'marketing_tracking';
var EXTERNAL_PLATFORM_LINK_REGEX = /^(?:\/property-report\/my-properties|\/property-report\/relationship|\/book-appointment|\/home-loans\/basics|\/credit-score|\/stamp-duty-calculator)(?:\/.*)?$/;
function embedMarketingTrackingIntoURL(link, baseUrl) {
  var targetURL = new URL(link, baseUrl);
  if (targetURL.origin !== baseUrl || !EXTERNAL_PLATFORM_LINK_REGEX.test(targetURL.pathname)) {
    // Do not embed UTM params for external links with different origin or internal CMS links
    return link;
  }
  try {
    var trackingParams = JSON.parse(sessionStorage.getItem(MARKETING_TRACKING_SESSION_STORAGE_KEY) || '{}');
    Object.keys(trackingParams).forEach(key => {
      targetURL.searchParams.set(key, trackingParams[key]);
    });
    return targetURL.pathname + targetURL.search;
  } catch (e) {
    return link;
  }
}

var ITEM_HEIGHT = '40px';
var ItemsWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "indexstyle__ItemsWrapper",
  componentId: "lui__sc-1j3tn22-0"
})(["", ";", ";list-style:none;height:100%;overflow-y:scroll;overflow-x:hidden;"], (0,spacing_esm.my)('nil'), (0,spacing_esm.pl)('nil'));
var Item = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "indexstyle__Item",
  componentId: "lui__sc-1j3tn22-1"
})([":last-child{border-bottom:1px solid ", ";}background-color:inherit;border:none;text-align:left;cursor:pointer;border-top:1px solid ", ";font-family:", ";font-weight:600;font-size:11px;text-transform:uppercase;", ";width:100%;height:", ";line-height:", ";", ";:hover{", ";}"], (0,color_esm/* color */.$)('shade.100'), (0,color_esm/* color */.$)('shade.100'), (0,ui_esm/* select */.Ys)('typography.body.fontFamily'), (0,color_esm.fg)('secondary.500'), ITEM_HEIGHT, ITEM_HEIGHT, (0,spacing_esm.pl)('sm'), (0,color_esm.bg)('shade.25'));
var RightArrow = (0,styled_components_browser_esm/* default */.ZP)(SvgArrowDropDown).attrs({
  color: 'secondary.500'
}).withConfig({
  displayName: "indexstyle__RightArrow",
  componentId: "lui__sc-1j3tn22-2"
})(["line-height:0;", ";transform:rotate(-90deg);height:18px;width:18px;transition:transform 0.5s;", ""], (0,spacing_esm.mr)('sm'), _ref => {
  var {
    shouldRotate
  } = _ref;
  return (0,styled_components_browser_esm/* css */.iv)(["transform:rotate(", ");"], shouldRotate ? '0deg' : '-90deg');
});
var Accordion = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "indexstyle__Accordion",
  componentId: "lui__sc-1j3tn22-3"
})(["", ";list-style:none;height:0px;width:100%;transition:height 0.3s linear;overflow:hidden;", ""], (0,spacing_esm.pl)('nil'), _ref2 => {
  var {
    isVisible,
    children
  } = _ref2;
  return isVisible && (0,styled_components_browser_esm/* css */.iv)(["height:calc(", " * ", ");"], react.Children.count(children), ITEM_HEIGHT);
});
var SubItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "indexstyle__SubItem",
  componentId: "lui__sc-1j3tn22-4"
})(["font-family:", ";font-size:12px;width:100%;", ";height:", ";transition:height 1s ease-out;line-height:", ";background-color:", ";"], (0,ui_esm/* select */.Ys)('typography.body.fontFamily'), (0,spacing_esm.pl)('nil'), ITEM_HEIGHT, ITEM_HEIGHT, (0,color_esm/* color */.$)('shade.25'));
var ItemLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "indexstyle__ItemLink",
  componentId: "lui__sc-1j3tn22-5"
})(["text-decoration:none;color:", ";width:100%;"], (0,color_esm/* color */.$)('secondary.500'));
var SubItemLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "indexstyle__SubItemLink",
  componentId: "lui__sc-1j3tn22-6"
})(["text-decoration:none;color:", ";display:block;padding-left:48px;"], (0,color_esm/* color */.$)('shade.900'));
var ListItem$1 = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "indexstyle__ListItem",
  componentId: "lui__sc-1j3tn22-7"
})([""]);

var LeftSidebarContent = _ref => {
  var {
    menuOptions: MENU_OPTIONS
  } = _ref;
  var {
    sendFeedback
  } = (0,lib.useFlags)();
  var isSVA = checkSVA();
  var [selected, setSelected] = react.useState(-1);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ItemsWrapper, {
    role: "menu",
    children: [MENU_OPTIONS.map((item, index) => item.children.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ListItem$1, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
        onClick: () => {
          setSelected(index);
          var event = {
            event_name: 'Menu Clicked',
            menuName: item.label,
            category: EventCategory.NAVBAR
          };
          navbar_esm_analytics(event);
        },
        "aria-label": item.label,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RightArrow, {
          shouldRotate: selected === index
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: item.label
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
        isVisible: selected === index,
        "aria-expanded": selected === index,
        children: item.children.map((child, childIndex) => {
          var _child$link;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SubItem, {
            role: "none",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubItemLink, {
              role: "menuitem",
              href: embedMarketingTrackingIntoURL((_child$link = child.link) !== null && _child$link !== void 0 ? _child$link : '', 'https://www.lendi.com.au'),
              "aria-label": child.label,
              onClick: () => {
                var event = {
                  event_name: 'Menu Element Clicked',
                  menuName: item.label,
                  text: child.label,
                  category: EventCategory.NAVBAR
                };
                navbar_esm_analytics(event);
              },
              children: child.label
            })
          }, index + '-' + childIndex);
        })
      })]
    }, index) : /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem$1, {
      role: "none",
      children: item.link ? /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ItemLink, {
          role: "menuitem",
          href: embedMarketingTrackingIntoURL(item.link, 'https://www.lendi.com.au'),
          "aria-label": item.label,
          onClick: () => {
            var event = {
              event_name: 'Menu Element Clicked',
              menuName: item.label,
              text: '',
              category: EventCategory.NAVBAR
            };
            navbar_esm_analytics(event);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: item.label
          })
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
        "aria-label": item.label,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: item.label
        })
      })
    }, index)), sendFeedback && isSVA && /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem$1, {
      role: "none",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
        "aria-label": LABEL_SEND_FEEDBACK,
        onClick: () => {
          var event = {
            event_name: 'Menu Element Clicked',
            menuName: 'Send Feedback',
            text: '',
            category: EventCategory.NAVBAR
          };
          sendFeedBackOnClick();
          navbar_esm_analytics(event);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: LABEL_SEND_FEEDBACK
        })
      })
    }, "send-feedback")]
  });
};

var FooterCTA = _ref => {
  var {
    isAuthenticated = false,
    continueURL = '/',
    onLogout = () => {},
    showContinueAction = false
  } = _ref;
  var theme = (0,ui_esm/* useTheme */.Fg)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FooterAction, {
      variant: isAuthenticated ? showContinueAction ? 'emphasis' : 'primary' : 'primary',
      isFullWidth: true,
      href: isAuthenticated ? showContinueAction ? continueURL : ROUTE_BOOK_APPOINTMENT : ROUTE_SIGN_IN,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          buttonType: isAuthenticated ? showContinueAction ? ButtonType.EMPHASIS : ButtonType.PRIMARY : ButtonType.PRIMARY,
          text: isAuthenticated ? showContinueAction ? 'Continue' : 'Book an Appointment' : 'Sign In',
          category: EventCategory.NAVBAR
        };
        navbar_esm_analytics(event);
      },
      "aria-label": isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : LABEL_SIGN_IN,
      children: isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : LABEL_SIGN_IN
    }), isAuthenticated && /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterAction, {
      variant: "empty",
      onClick: () => {
        onLogout();
        var event = {
          event_name: 'Button Clicked',
          buttonType: ButtonType.EMPTY,
          text: 'Log Out',
          category: EventCategory.NAVBAR
        };
        navbar_esm_analytics(event);
      },
      "aria-label": LABEL_LOG_OUT,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgExitToApp, {
        color: theme.color.interaction.main
      }), LABEL_LOG_OUT]
    })]
  });
};
var FooterAction = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "FooterCTA__FooterAction",
  componentId: "lui__sc-uimopi-0"
})(["width:100%;border:none;line-height:1.1;"]);
var FooterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterCTA__FooterWrapper",
  componentId: "lui__sc-uimopi-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;box-shadow:0 3px 5px 0 rgba(0,0,0,0.14),0 1px 18px 0 rgba(0,0,0,0.12),0 6px 10px 0 rgba(0,0,0,0.14);", ";", ""], (0,spacing_esm.px)('sm'), (0,spacing_esm.py)('sm'));
var FooterCTA$1 = FooterCTA;

var LeftSidebar = _ref => {
  var {
    openSidebar,
    closeSidebar,
    isAuthenticated,
    onLogout,
    continueURL,
    showContinueAction,
    menuOptions
  } = _ref;
  // Left sidebar only appears for mobile/tablet and navbar-base height will be 56px, which could be offsetTop value for left-sidebar.
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Sidebar, {
    isVisible: openSidebar,
    onHide: closeSidebar,
    top: 56,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Sidebar.Content, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LeftSidebarContent, {
        menuOptions: menuOptions
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Sidebar.Footer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterCTA$1, {
        isAuthenticated: isAuthenticated,
        onLogout: onLogout,
        continueURL: continueURL,
        showContinueAction: showContinueAction
      })
    })]
  });
};
var LeftSidebar$1 = LeftSidebar;

var _templateObject$5;
var PanelLink = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU).withConfig({
  displayName: "indexstyle__PanelLink",
  componentId: "lui__sc-56jb5a-0"
})(["text-decoration:none;overflow:hidden;font-weight:normal;:hover,:focus,:active{", "}"], (0,color_esm.fg)('shade.700'));
var PanelButton = (0,styled_components_browser_esm/* default */.ZP)(button_esm/* Button */.zx).withConfig({
  displayName: "indexstyle__PanelButton",
  componentId: "lui__sc-56jb5a-1"
})(["", ""], (0,spacing_esm.ml)('sm'));
var LinksGroup = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "indexstyle__LinksGroup",
  componentId: "lui__sc-56jb5a-2"
})(["list-style-type:none;", " ", " ", ""], (0,grid_esm/* grid */.eC)(), (0,spacing_esm.p)('nil'), (0,spacing_esm.m)('nil'));
var LinkItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "indexstyle__LinkItem",
  componentId: "lui__sc-56jb5a-3"
})(["", " ", " ", ""], (0,grid_esm/* unit */.bf)({
  size: 1 / 4
}), (0,spacing_esm.py)('xxs'), (0,spacing_esm.pr)('xs'));
var navbar_esm_HeadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__HeadingWrapper",
  componentId: "lui__sc-56jb5a-4"
})(["display:flex;flex-direction:row;align-items:center;", ""], (0,spacing_esm.mb)('xs'));
var HeadingLink = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU).withConfig({
  displayName: "indexstyle__HeadingLink",
  componentId: "lui__sc-56jb5a-5"
})(["display:flex;flex-direction:row;align-items:center;overflow:hidden;text-decoration:none;:hover,:focus,:active{", "}"], (0,color_esm.fg)('secondary.500'));
var DisplayPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__DisplayPanel",
  componentId: "lui__sc-56jb5a-6"
})(["width:100%;position:absolute;margin-top:10px;border-radius:", ";max-width:500px;left:0;", " ", " ", ""], (0,ui_esm/* select */.Ys)('borderRadius'), (0,depth_esm/* depth */.Y)(4), (0,color_esm.bg)('shade.0'), (0,spacing_esm.p)('md'));
var Bar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__Bar",
  componentId: "lui__sc-56jb5a-7"
})(["height:2px;width:", ";transition:width ease-in-out 300ms;", ""], _ref => {
  var {
    isSelected
  } = _ref;
  return isSelected ? 'calc(100% - 16px)' : '0';
}, _ref2 => {
  var {
    isTransparent
  } = _ref2;
  return isTransparent ? (0,styled_components_browser_esm/* css */.iv)(["", ""], (0,color_esm.bg)('shade.0')) : (0,styled_components_browser_esm/* css */.iv)(["", ";"], (0,color_esm.bg)('secondary.500'));
});
var UnOrderedList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "indexstyle__UnOrderedList",
  componentId: "lui__sc-56jb5a-8"
})(["list-style-type:none;display:flex;flex-direction:row;justify-content:center;align-items:center;", " ", ""], (0,spacing_esm.p)('nil'), (0,spacing_esm.m)('nil'));
var ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "indexstyle__ListItem",
  componentId: "lui__sc-56jb5a-9"
})(["list-style-type:none;"]);
var LinkOption = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Link */.rU).withConfig({
  displayName: "indexstyle__LinkOption",
  componentId: "lui__sc-56jb5a-10"
})(["display:inline-flex;flex-direction:column;overflow:hidden;", ";", ";text-decoration:none;:hover,:focus,:active{text-decoration:none;}color:", ";"], (0,spacing_esm.pr)('md'), (0,spacing_esm.pl)('nil'), _ref3 => {
  var {
    theme,
    isTransparent
  } = _ref3;
  if (isTransparent) return theme.color.text.inverse;
  if (theme.name === 'lendi') return theme.color.text.contrast;
  return theme.color.text.contrast;
});
var ExpandMoreWrapper = (0,styled_components_browser_esm/* default */.ZP)(SvgExpandMore).withConfig({
  displayName: "indexstyle__ExpandMoreWrapper",
  componentId: "lui__sc-56jb5a-11"
})(["& svg{display:block;}font-weight:bold;transform:", ";transition:transform ease-in-out 300ms;color:", ";"], _ref4 => {
  var {
    isSelected
  } = _ref4;
  return isSelected ? 'rotate(180deg)' : undefined;
}, _ref5 => {
  var {
    theme,
    isTransparent
  } = _ref5;
  if (isTransparent) return theme.color.text.inverse;
  return theme.color.text.contrast;
});
var BarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__BarWrapper",
  componentId: "lui__sc-56jb5a-12"
})(["display:inline-flex;align-items:center;"]);
var Label = (0,styled_components_browser_esm/* default */.ZP)(typography_esm/* Body */.uT).withConfig({
  displayName: "indexstyle__Label",
  componentId: "lui__sc-56jb5a-13"
})(["text-transform:uppercase;font-weight:bold;letter-spacing:0.8px;line-height:1;"]);
var OptionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__OptionsContainer",
  componentId: "lui__sc-56jb5a-14"
})(["width:100%;display:none;flex-direction:row;justify-content:space-between;align-items:center;", " ", ""], (0,spacing_esm.ml)('lg'), (0,breakpoint_esm/* gte */.eg)('desktop')(_templateObject$5 || (_templateObject$5 = navbar_esm_taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n"]))));

var prevSelected = '';
var MenuOptions = props => {
  var {
    isTransparent
  } = useNavbarBaseContext();
  var {
    isAuthenticated,
    params,
    continueURL
  } = props;
  var [currentSelected, setCurrentSelected] = react.useState('');
  var flags = (0,lib.useFlags)();
  var displayPanel = react.useRef(null);
  var selectedItem = getMultiMenuOptions(flags).find(menuItem => menuItem.label === currentSelected);
  var hasWindow = typeof window !== 'undefined';
  react.useEffect(() => {
    if (hasWindow) {
      window.addEventListener('mousedown', closeDisplayPanel);
    }
    return () => {
      if (hasWindow) {
        window.removeEventListener('mousedown', closeDisplayPanel);
      }
    };
  });
  var closeDisplayPanel = e => {
    prevSelected = currentSelected;
    if (displayPanel && displayPanel.current && !displayPanel.current.contains(e.target)) {
      setCurrentSelected('');
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OptionsContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(UnOrderedList, {
      children: getMultiMenuOptions(flags).map(_ref => {
        var _selectedItem$link;
        var {
          label,
          children
        } = _ref;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(ListItem, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LinkOption, {
            onClick: () => {
              onClickOption(label, setCurrentSelected);
              var event = {
                event_name: 'Menu Clicked',
                category: EventCategory.NAVBAR,
                menuName: label
              };
              navbar_esm_analytics(event);
            },
            isTransparent: isTransparent,
            type: "button",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BarWrapper, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
                size: "xs",
                children: label
              }), children && /*#__PURE__*/(0,jsx_runtime.jsx)(ExpandMoreWrapper, {
                isSelected: currentSelected === label,
                isTransparent: isTransparent
              })]
            }), children && /*#__PURE__*/(0,jsx_runtime.jsx)(Bar, {
              isSelected: currentSelected === label,
              isTransparent: isTransparent
            })]
          }), currentSelected === label && /*#__PURE__*/(0,jsx_runtime.jsxs)(DisplayPanel, {
            ref: displayPanel,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(navbar_esm_HeadingWrapper, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeadingLink, {
                href: embedMarketingTrackingIntoURL((_selectedItem$link = selectedItem.link) !== null && _selectedItem$link !== void 0 ? _selectedItem$link : '', 'https://www.lendi.com.au'),
                onClick: () => {
                  var event = {
                    event_name: 'Menu Element Clicked',
                    menuName: currentSelected,
                    text: selectedItem.label,
                    category: EventCategory.NAVBAR
                  };
                  navbar_esm_analytics(event);
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_esm/* Heading */.X6, {
                  size: "md",
                  color: "secondary.500",
                  mr: "xxs",
                  children: currentSelected
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgKeyboardArrowRight, {
                  color: "secondary.500"
                })]
              }), currentSelected === 'Home loans' && /*#__PURE__*/(0,jsx_runtime.jsx)(PanelButton, {
                size: "xs",
                variant: isAuthenticated ? 'emphasis' : 'primary',
                href: isAuthenticated ? continueURL : ROUTE_SIGN_IN,
                onClick: () => {
                  var event = {
                    event_name: 'Menu Element Clicked',
                    category: EventCategory.NAVBAR,
                    menuName: currentSelected,
                    text: isAuthenticated ? 'Continue' : 'Sign In'
                  };
                  navbar_esm_analytics(event);
                },
                children: isAuthenticated ? LABEL_CONTINUE : LABEL_SIGN_IN
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksGroup, {
              children: selectedItem.children.map(child => {
                var _child$link;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkItem, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(PanelLink, {
                    size: "sm",
                    color: "shade.700",
                    href: embedMarketingTrackingIntoURL((_child$link = child.link) !== null && _child$link !== void 0 ? _child$link : '', 'https://www.lendi.com.au'),
                    onClick: () => {
                      var event = {
                        event_name: 'Menu Element Clicked',
                        menuName: selectedItem.label,
                        text: child.label,
                        category: EventCategory.NAVBAR
                      };
                      navbar_esm_analytics(event);
                    },
                    children: child.label
                  })
                }, child.label);
              })
            })]
          })]
        }, label);
      })
    })
  });
};
var onClickOption = (label, setCurrentSelected) => {
  if (prevSelected === label) {
    setCurrentSelected('');
  } else {
    setCurrentSelected(label);
  }
};
var MenuOptions$1 = MenuOptions;

var _excluded$b = ["useTransparent", "homeURL", "params", "continueURL", "onLogout", "application", "showContinueAction", "showTalkToExpertCta", "hideDashboardItem", "hideManageApplicationsItem", "isCommPanelOpen", "hasUnread", "closeCommPanel", "openCommPanel", "customerOwner"];
var MultiNavbarComponent = _ref => {
  var {
      // Public props
      useTransparent = false,
      homeURL,
      params = '',
      continueURL = '/',
      onLogout = () => {},
      application,
      showContinueAction,
      showTalkToExpertCta,
      hideDashboardItem,
      hideManageApplicationsItem,
      // Internal props, from ChatProps
      isCommPanelOpen,
      hasUnread,
      closeCommPanel,
      openCommPanel: _openCommPanel,
      customerOwner
    } = _ref,
    otherProps = navbar_esm_objectWithoutProperties(_ref, _excluded$b);
  var session = (0,dist_esm/* useSession */.kP)();
  var isAuthenticated = session.status === dist_esm/* Status.Authenticated */.qb.Authenticated;
  var flags = (0,lib.useFlags)();
  var [leftSidebarState, setLeftSidebarState] = react.useState(false);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LeftSidebar$1, {
      menuOptions: getMultiMenuOptions(flags),
      openSidebar: leftSidebarState,
      closeSidebar: () => setLeftSidebarState(false),
      isAuthenticated: isAuthenticated,
      continueURL: continueURL,
      onLogout: onLogout,
      showContinueAction: showContinueAction
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavbarWrapper, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
      isTransparent: useTransparent,
      isAuthenticated: isAuthenticated
    }, otherProps), {}, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_NavbarLeftWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MenuLogoWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HamBurgerMenu$1, {
              toggleSidebar: toggle => setLeftSidebarState(toggle),
              leftSidebarState: leftSidebarState
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoComponent$1, {
              homeURL: homeURL,
              params: params
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuOptions$1, {
            isAuthenticated: isAuthenticated,
            continueURL: continueURL,
            params: params
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(navbar_esm_NavbarRightWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownProvider, {
          hideDashboardItem: hideDashboardItem,
          hideManageApplicationsItem: hideManageApplicationsItem,
          onLogout: onLogout,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButtons$1, {
            showTalkToExpertCta: showTalkToExpertCta,
            isAuthenticated: isAuthenticated,
            continueURL: continueURL,
            showContinueAction: showContinueAction,
            openCommPanel: () => isCommPanelOpen ? closeCommPanel() : _openCommPanel(),
            customerOwner: customerOwner,
            hasUnreadMessages: hasUnread
          })
        })
      })]
    }))]
  });
};
var MultiNavbar = navbar_esm_withErrorProvider(withLendiLDProvider(withCommPanel(withDomainChat(MultiNavbarComponent))));

var _templateObject$4, _templateObject2$2, _templateObject3$1, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var LargeTweakpoint = '65.825rem';
var ExtraLargeTweakpoint = '82.5rem';
var Px = (0,styled_components_browser_esm/* css */.iv)(["padding-left:", ";padding-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(16));
var Py = (0,styled_components_browser_esm/* css */.iv)(["padding-top:", ";padding-bottom:", ";"], (0,commons_esm/* pxToRem */.Q1)(24), (0,commons_esm/* pxToRem */.Q1)(24));
var MenuPadding = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__MenuPadding",
  componentId: "lui__sc-631j2u-0"
})(["", ";", ";"], Px, Py);
var MenuPaddingAlt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__MenuPaddingAlt",
  componentId: "lui__sc-631j2u-1"
})(["padding-top:", ";padding-bottom:", ";", ";"], (0,commons_esm/* pxToRem */.Q1)(24), (0,commons_esm/* pxToRem */.Q1)(12), Px);
var listReset = (0,styled_components_browser_esm/* css */.iv)(["margin:0;list-style:none;padding:0;"]);
var buttonReset = (0,styled_components_browser_esm/* css */.iv)(["border:0;border-radius:0;background:none;width:100%;white-space:nowrap;text-decoration:none;margin:0;cursor:pointer;"]);
var insetFocusVisible = (0,styled_components_browser_esm/* css */.iv)(["&:focus-visible{background-color:#331745;outline:0;box-shadow:inset ", " 0.125rem 0.125rem 0 0,inset ", " -0.125rem -0.125rem 0 0,inset ", " 0.25rem 0.25rem 0 0,inset ", " -0.25rem -0.25rem 0 0;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.border.interaction.focus;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.border.interaction.focus;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.fill.main;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.color.fill.main;
});
var focusVisible = (0,styled_components_browser_esm/* css */.iv)(["&:focus-visible{outline:0;box-shadow:", ";}"], (0,dist_commons_esm/* getFocusRing */.yb)());
var StyledHR = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
  displayName: "sharedstyles__StyledHR",
  componentId: "lui__sc-631j2u-2"
})(["margin-top:", ";margin-bottom:", ";&:last-child{margin-bottom:0;}"], (0,commons_esm/* pxToRem */.Q1)(24), (0,commons_esm/* pxToRem */.Q1)(24));
styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__HideFromLarge",
  componentId: "lui__sc-631j2u-3"
})(["display:block;", ""], (0,breakpoint_esm/* gte */.eg)('lg')(_templateObject$4 || (_templateObject$4 = navbar_esm_taggedTemplateLiteral(["\n    display: none;\n  "]))));
var HideFromTweakExtraLarge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__HideFromTweakExtraLarge",
  componentId: "lui__sc-631j2u-4"
})(["display:block;@media (min-width:", "){display:none;}"], ExtraLargeTweakpoint);
var ShowFromTweakExtraLarge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__ShowFromTweakExtraLarge",
  componentId: "lui__sc-631j2u-5"
})(["display:none;@media (min-width:", "){display:block;}"], ExtraLargeTweakpoint);
var HideFromTweakLarge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__HideFromTweakLarge",
  componentId: "lui__sc-631j2u-6"
})(["display:block;@media (min-width:", "){display:none;}"], LargeTweakpoint);
var ShowFromTweakLarge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__ShowFromTweakLarge",
  componentId: "lui__sc-631j2u-7"
})(["display:none;@media (min-width:", "){display:block;}"], LargeTweakpoint);
styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__ShowFromLarge",
  componentId: "lui__sc-631j2u-8"
})(["display:none;", ""], (0,breakpoint_esm/* gte */.eg)('lg')(_templateObject2$2 || (_templateObject2$2 = navbar_esm_taggedTemplateLiteral(["\n    display: block;\n  "]))));
var HideFromMedium = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__HideFromMedium",
  componentId: "lui__sc-631j2u-9"
})(["display:block;", ""], (0,breakpoint_esm/* gte */.eg)('md')(_templateObject3$1 || (_templateObject3$1 = navbar_esm_taggedTemplateLiteral(["\n    display: none;\n  "]))));
var ShowFromMedium = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__ShowFromMedium",
  componentId: "lui__sc-631j2u-10"
})(["display:none;", ""], (0,breakpoint_esm/* gte */.eg)('md')(_templateObject4 || (_templateObject4 = navbar_esm_taggedTemplateLiteral(["\n    display: block;\n  "]))));
var ShowFromSmall = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__ShowFromSmall",
  componentId: "lui__sc-631j2u-11"
})(["display:none;", ""], (0,breakpoint_esm/* gte */.eg)('sm')(_templateObject5 || (_templateObject5 = navbar_esm_taggedTemplateLiteral(["\n    display: block;\n  "]))));
styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__HideFromSmall",
  componentId: "lui__sc-631j2u-12"
})(["display:block;", ""], (0,breakpoint_esm/* gte */.eg)('sm')(_templateObject6 || (_templateObject6 = navbar_esm_taggedTemplateLiteral(["\n    display: none;\n  "]))));
var ShowAtSmallOnly = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__ShowAtSmallOnly",
  componentId: "lui__sc-631j2u-13"
})(["display:none;", ";"], (0,breakpoint_esm/* between */.vX)('xs', 'sm')(_templateObject7 || (_templateObject7 = navbar_esm_taggedTemplateLiteral(["\n    display: block;\n  "]))));
var ShowAtMediumOnly = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "sharedstyles__ShowAtMediumOnly",
  componentId: "lui__sc-631j2u-14"
})(["display:none;", ";"], (0,breakpoint_esm/* between */.vX)('sm', 'lg')(_templateObject8 || (_templateObject8 = navbar_esm_taggedTemplateLiteral(["\n    display: block;\n  "]))));
var SrOnlySpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "sharedstyles__SrOnlySpan",
  componentId: "lui__sc-631j2u-15"
})(["", ";"], commons_esm/* srOnly */.im);

var _excluded$a = ["children", "isOpen", "onClick"],
  _excluded2$1 = ["children", "href", "onClick", "badge", "isActive"];
/**
 * @todo Line-height: prefer to use token but the current one is not accessible here
 * @todo Helper functions: getTypography you have to specify each property of the font you need should this be simpler
 * @todo Colors: Access the color pallett or update to semantic values
 * @todo Remove font smoothing when wider solution reached for when we remove it globally
 */

var StyledNavButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "NavButtons__StyledNavButton",
  componentId: "lui__sc-1rf7mpw-0"
})(["", ";color:", ";background-color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:1.5;padding:", " ", ";display:flex;align-items:center;justify-content:", ";&:hover{color:", ";}@media (min-width:", "){padding:", " ", ";}", " ", ""], buttonReset, _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.inverse;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.interaction.main;
}, () => (0,typography_dist_commons_esm/* default */.Z)('display', 'fontFamily'), () => (0,typography_dist_commons_esm/* default */.Z)('display', 'fontWeight'), (0,commons_esm/* pxToRem */.Q1)(14), (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(12), _ref3 => {
  var {
    isBadge
  } = _ref3;
  return isBadge ? "flex-start" : "space-between";
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.color.interaction.emphasis;
}, ExtraLargeTweakpoint, (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(8), _ref5 => {
  var {
    isOpen,
    isActive,
    theme
  } = _ref5;
  return (isOpen !== null && isOpen !== void 0 ? isOpen : isActive) ? "color: ".concat(theme.color.interaction.emphasis, ";") : null;
}, insetFocusVisible);
var StyledNavButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "NavButtons__StyledNavButtonText",
  componentId: "lui__sc-1rf7mpw-1"
})(["margin-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(4));
var NavButton = _ref6 => {
  var {
      children,
      isOpen = false,
      onClick
    } = _ref6,
    props = navbar_esm_objectWithoutProperties(_ref6, _excluded$a);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledNavButton, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    type: "button",
    "aria-expanded": isOpen,
    isOpen: isOpen,
    onClick: onClick
  }, globalProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledNavButtonText, {
      children: children
    }), !isOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgChevronDown, {
      width: "21px",
      height: "21px"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgChevronUp, {
      width: "21px",
      height: "21px"
    })]
  }));
};
var NavLink = _ref7 => {
  var {
      children,
      href,
      onClick,
      badge,
      isActive
    } = _ref7,
    props = navbar_esm_objectWithoutProperties(_ref7, _excluded2$1);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledNavButton, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    href: href,
    as: "a",
    onClick: onClick,
    isActive: isActive,
    isBadge: badge
  }, globalProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: children
    }), badge ? /*#__PURE__*/(0,jsx_runtime.jsx)(Badge, {
      children: badge
    }) : null]
  }));
};

var _excluded$9 = ["children", "align", "minWidth", "className"];
/**
 * @todo Border radius: Update border radius to use tokens or replace with exisiting mechanism
 * @todo Colors: Access the color pallett or update to semantic values
 */

var StyledDropdown$1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Dropdown__StyledDropdown",
  componentId: "lui__sc-1mv978l-0"
})(["display:block;position:absolute;background:#4b1f68;border-radius:0px 0px ", " ", ";top:100%;", ";min-width:", ";max-width:", ";overflow:hidden;"], (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(16), _ref => {
  var {
    align
  } = _ref;
  return align === 'right' ? "right: 0" : "left: 0";
}, _ref2 => {
  var {
    minWidth
  } = _ref2;
  return minWidth !== null && minWidth !== void 0 ? minWidth : (0,commons_esm/* pxToRem */.Q1)(222);
}, (0,commons_esm/* pxToRem */.Q1)(300));
var DropdownComponent = (_ref3, ref) => {
  var {
      children,
      align,
      minWidth,
      className
    } = _ref3,
    props = navbar_esm_objectWithoutProperties(_ref3, _excluded$9);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDropdown$1, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    className: className,
    align: align,
    minWidth: minWidth,
    role: "menu",
    ref: ref
  }, globalProps), {}, {
    children: children
  }));
};
var Dropdown = /*#__PURE__*/(0,react.forwardRef)(DropdownComponent);

var _excluded$8 = ["navSlot", "ctaSlot", "isExperiment"];
var _templateObject$3, _templateObject2$1;
var HeaderPaddingSmall = 10;
var HeaderPaddingLarge = 16;

/**
 * @todo z-index: tokenise z-index to make it easier to manage levels
 */
var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "HeaderBase__StyledHeader",
  componentId: "lui__sc-1ik75ai-0"
})(["background:", ";position:sticky;top:0;z-index:999;padding:", " 0;width:100%;min-width:max-content;", ""], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.fill.contrast;
}, (0,commons_esm/* pxToRem */.Q1)(HeaderPaddingSmall), (0,breakpoint_esm/* gte */.eg)('md')(_templateObject$3 || (_templateObject$3 = navbar_esm_taggedTemplateLiteral(["\n    padding: ", " 0;\n  "])), (0,commons_esm/* pxToRem */.Q1)(HeaderPaddingLarge)));
var HeaderInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeaderBase__HeaderInner",
  componentId: "lui__sc-1ik75ai-1"
})(["display:flex;align-items:center;"]);
var LogoLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "HeaderBase__LogoLink",
  componentId: "lui__sc-1ik75ai-2"
})(["width:", ";height:", ";order:1;flex:0 0 auto;", " ", ""], (0,commons_esm/* pxToRem */.Q1)(87), (0,commons_esm/* pxToRem */.Q1)(16), (0,breakpoint_esm/* gte */.eg)('md')(_templateObject2$1 || (_templateObject2$1 = navbar_esm_taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n  "])), (0,commons_esm/* pxToRem */.Q1)(99), (0,commons_esm/* pxToRem */.Q1)(22), (0,commons_esm/* pxToRem */.Q1)(32)), focusVisible);
var StyledNavSlot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeaderBase__StyledNavSlot",
  componentId: "lui__sc-1ik75ai-3"
})(["order:3;@media (min-width:", "){order:2;}"], _ref2 => {
  var {
    isExperiment
  } = _ref2;
  return isExperiment ? ExtraLargeTweakpoint : LargeTweakpoint;
});
var StyledCtaSlot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeaderBase__StyledCtaSlot",
  componentId: "lui__sc-1ik75ai-4"
})(["margin-left:auto;order:2;@media (min-width:", "){order:3;}"], _ref3 => {
  var {
    isExperiment
  } = _ref3;
  return isExperiment ? ExtraLargeTweakpoint : LargeTweakpoint;
});
var HeaderBase = _ref4 => {
  var {
      navSlot,
      ctaSlot,
      isExperiment
    } = _ref4,
    props = navbar_esm_objectWithoutProperties(_ref4, _excluded$8);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeader, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    role: "banner"
  }, globalProps), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_68cf36c7_esm.W, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderInner, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LogoLink, {
          href: "/",
          onClick: () => {
            var event = {
              event_name: 'Link Clicked',
              category: EventCategory.NAVBAR,
              position: EventCategory.CMS,
              text: 'Logo',
              linkType: 'Logo',
              customerType: CustomerType.CUSTOMER
            };
            navbar_esm_analytics(event);
          },
          "data-testid": "header-logo",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {
            variant: "light",
            width: "100%",
            height: "auto",
            brand: "aussie"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SrOnlySpan, {
            children: "Go to Aussie homepage"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledNavSlot, {
          isExperiment: isExperiment,
          children: navSlot
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCtaSlot, {
          isExperiment: isExperiment,
          children: ctaSlot
        })]
      })
    })
  }));
};

var trimStringWithEllipsis = str => {
  if (str.length > 10) {
    return str.substring(0, 10) + '...';
  } else {
    return str;
  }
};
var trimSpaceWithDash = str => {
  return str.toLowerCase().replaceAll(' ', '-');
};

var _excluded$7 = ["label", "children", "onClick", "minDropdownWidth", "align"];
var _templateObject$2;
// Make dropdown content flush to the bottom of the header not it's trigger button
var StyledDropdown = (0,styled_components_browser_esm/* default */.ZP)(Dropdown).withConfig({
  displayName: "NavDropdown__StyledDropdown",
  componentId: "lui__sc-1xymxh7-0"
})(["", ";", " ", ""], _ref => {
  var {
    minWidth
  } = _ref;
  return minWidth && "min-width: ".concat(minWidth);
}, () => (0,styled_components_browser_esm/* css */.iv)(["top:calc(100% + ", ");"], (0,commons_esm/* pxToRem */.Q1)(HeaderPaddingSmall)), () => (0,styled_components_browser_esm/* css */.iv)(["", ""], (0,breakpoint_esm/* gte */.eg)('md')(_templateObject$2 || (_templateObject$2 = navbar_esm_taggedTemplateLiteral(["\n        top: calc(100% + ", ");\n        "])), (0,commons_esm/* pxToRem */.Q1)(HeaderPaddingLarge))));
var NavDropdown = _ref2 => {
  var {
      label,
      children,
      onClick,
      minDropdownWidth,
      align = 'left'
    } = _ref2,
    props = navbar_esm_objectWithoutProperties(_ref2, _excluded$7);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var dropdownRef = (0,react.useRef)(null);
  var dropdownGroupRef = (0,react.useRef)(null);
  var [isOpen, setIsOpen] = (0,react.useState)(false);
  var handleClick = event => {
    setIsOpen(!isOpen);
    onClick === null || onClick === void 0 || onClick(event, !isOpen);
  };
  var pageClickEvent = event => {
    var target = event.target;

    /**
     * When button clicked, global click event will be fired as well, but after the button click event.
     * So we need prevent global event fired when user click button.
     *
     * When the button click event fired, the icon will be changed. So event target will be the unmounted svg.
     * That unmounted svg will hack the contains logic. So we do mount check on line.67
     */
    if (!target.isConnected) return;
    if (dropdownRef.current && dropdownGroupRef.current && !dropdownGroupRef.current.contains(target)) {
      setIsOpen(false);
    }
  };
  var escapeEvent = event => {
    if (event.key === 'Escape' && isOpen) {
      setIsOpen(!isOpen);
    }
  };
  (0,react.useEffect)(() => {
    // If the item is open listen for clicks or escape key
    if (isOpen) {
      window.addEventListener('click', pageClickEvent);
      window.addEventListener('keydown', escapeEvent);
    }
    return () => {
      window.removeEventListener('click', pageClickEvent);
      window.removeEventListener('keydown', escapeEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  return (
    /*#__PURE__*/
    // Needs to be relative so we position the dropdown content relative to this wrapper
    (0,jsx_runtime.jsxs)("div", navbar_esm_objectSpread2(navbar_esm_objectSpread2({}, globalProps), {}, {
      style: {
        position: 'relative'
      },
      ref: dropdownGroupRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavButton, {
        isOpen: isOpen,
        onClick: e => handleClick(e),
        "data-testid": "header-dropdown-".concat(trimSpaceWithDash(label)),
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(es2015/* default */.ZP, {
        disabled: !isOpen,
        returnFocus: true,
        children: isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDropdown, {
          minWidth: minDropdownWidth,
          align: align,
          ref: dropdownRef,
          children: children
        })
      })]
    }))
  );
};

var _excluded$6 = ["children", "href", "background", "isActive", "isExternal", "onClick"],
  _excluded2 = ["children", "onClick"];
/**
 * @todo Line-height: prefer to use token but the current one is not accessible here
 * @todo Helper functions: getTypography you have to specify each property of the font you need should this be simpler
 * @todo Colors: Access the color palette or update to semantic values
 */

var MenuItemStyles = (0,styled_components_browser_esm/* css */.iv)(["padding:", " ", ";color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:1.5;text-decoration:none;&:hover{background-color:#633482;}", ""], (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(16), _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.inverse;
}, () => (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'), () => (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontWeight'), (0,commons_esm/* pxToRem */.Q1)(16), insetFocusVisible);
var StyledMenuLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "MenuLink__StyledMenuLink",
  componentId: "lui__sc-dpbddc-0"
})(["", " background-color:", ";display:flex;align-items:center;justify-content:space-between;position:relative;", ""], () => MenuItemStyles, _ref2 => {
  var {
    background,
    theme
  } = _ref2;
  return background === 'darker' ? '#331745' : theme.color.interaction.main;
}, _ref3 => {
  var {
    isActive,
    theme
  } = _ref3;
  return isActive && "background-color: #633482;\n    font-weight: bold;\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 4px;\n      height: 100%;\n      background-color: ".concat(theme.color.interaction.emphasis, ";\n    }\n\n  ");
});
var ExternalIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "MenuLink__ExternalIcon",
  componentId: "lui__sc-dpbddc-1"
})(["transform:rotate(-45deg);width:", ";height:", ";"], (0,commons_esm/* pxToRem */.Q1)(24), (0,commons_esm/* pxToRem */.Q1)(24));
var MenuLink = _ref4 => {
  var {
      children,
      href,
      background,
      isActive = false,
      isExternal = false,
      onClick
    } = _ref4,
    props = navbar_esm_objectWithoutProperties(_ref4, _excluded$6);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var conditionalProps = {};
  if (isExternal) {
    conditionalProps = {
      target: '_blank',
      rel: 'noopener'
    };
  }
  if (isActive) {
    conditionalProps = {
      'aria-current': 'page'
    };
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledMenuLink, navbar_esm_objectSpread2(navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    href: href,
    isActive: isActive,
    onClick: onClick,
    background: background
  }, conditionalProps), globalProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: children
    }), isExternal && /*#__PURE__*/(0,jsx_runtime.jsxs)(ExternalIcon, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgArrowForward, {
        width: (0,commons_esm/* pxToRem */.Q1)(24),
        height: (0,commons_esm/* pxToRem */.Q1)(24)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SrOnlySpan, {
        children: " (Opens in new window)"
      })]
    })]
  }));
};
/**
 * @todo Colors: Access the color palette or update to semantic values
 */

var StyledMenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "MenuLink__StyledMenuButton",
  componentId: "lui__sc-dpbddc-2"
})(["", ";", ";text-align:left;"], () => buttonReset, () => MenuItemStyles);
var MenuButton = _ref5 => {
  var {
      children,
      onClick
    } = _ref5,
    props = navbar_esm_objectWithoutProperties(_ref5, _excluded2);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMenuButton, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    type: "button",
    onClick: onClick
  }, globalProps), {}, {
    children: children
  }));
};

var _excluded$5 = ["navOptions", "isSlideout"];
var NavMobileStyled = (0,styled_components_browser_esm/* css */.iv)(["ul{", "}"], listReset);
var Badge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Nav__Badge",
  componentId: "lui__sc-zq7yzs-0"
})(["height:24px;padding:4px 8px;margin-left:8px;font-family:", ";font-weight:700;color:", ";font-size:", ";line-height:16px;background-color:#ffd11f;border-radius:4px;"], () => (0,typography_dist_commons_esm/* default */.Z)('body1', 'fontFamily'), () => (0,colours_dist_commons_esm/* default */.ZP)('text', 'main'), (0,commons_esm/* pxToRem */.Q1)(12));
var NavDesktopStyled = (0,styled_components_browser_esm/* css */.iv)(["ul{", ";display:flex;align-items:center;}"], listReset);
var NavElement = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Nav__NavElement",
  componentId: "lui__sc-zq7yzs-1"
})(["", ""], _ref => {
  var {
    isSlideout
  } = _ref;
  return isSlideout ? NavMobileStyled : NavDesktopStyled;
});
var StyledChildrenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Nav__StyledChildrenWrapper",
  componentId: "lui__sc-zq7yzs-2"
})(["::after{content:'';display:block;", "}"], _ref2 => {
  var {
    isOpen,
    theme
  } = _ref2;
  return isOpen && "height: 0.0625rem; background-color: ".concat(theme.color.text.inverse, "; margin: .75rem 1rem;");
});
var MenuItem = _ref3 => {
  var {
    label,
    children
  } = _ref3;
  var [isOpen, setIsOpen] = (0,react.useState)(false);
  var handleClick = () => {
    setIsOpen(!isOpen);
    var event = {
      event_name: 'Menu Clicked',
      category: EventCategory.NAVBAR,
      menuName: label,
      position: 'CMS',
      customerType: CustomerType.CUSTOMER
    };
    navbar_esm_analytics(event);
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavButton, {
      onClick: () => handleClick(),
      isOpen: isOpen,
      "data-testid": "header-menu-item-".concat(trimSpaceWithDash(label)),
      children: label
    }), isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledChildrenWrapper, {
      isOpen: isOpen,
      children: children
    })]
  });
};
var Nav = _ref4 => {
  var {
      navOptions,
      isSlideout
    } = _ref4,
    props = navbar_esm_objectWithoutProperties(_ref4, _excluded$5);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var listItems = navOptions.map((item, index) => {
    var _item$children, _item$children2;
    var navItems = isSlideout ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
        label: item.label,
        children: (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.map((childItem, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuLink, {
            href: childItem.link,
            isActive: childItem.isActive,
            onClick: () => {
              var event = {
                category: EventCategory.NAVBAR,
                event_name: 'Menu Element Clicked',
                menuName: item.label,
                text: childItem.label,
                position: EventCategory.CMS,
                customerType: CustomerType.CUSTOMER
              };
              navbar_esm_analytics(event);
            },
            "data-testid": "header-menu-link-".concat(trimSpaceWithDash(childItem.label)),
            children: childItem.label
          }, index);
        })
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NavDropdown, {
      label: item.label,
      minDropdownWidth: item === null || item === void 0 ? void 0 : item.minDropdownWidth,
      onClick: () => {
        var event = {
          event_name: 'Menu Clicked',
          category: EventCategory.NAVBAR,
          menuName: item.label,
          position: 'CMS',
          customerType: CustomerType.CUSTOMER
        };
        navbar_esm_analytics(event);
      },
      children: (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.map((childItem, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuLink, {
            href: childItem.link,
            isActive: childItem.isActive,
            onClick: () => {
              var event = {
                category: EventCategory.NAVBAR,
                event_name: 'Menu Element Clicked',
                menuName: item.label,
                text: childItem.label,
                position: EventCategory.CMS,
                customerType: CustomerType.CUSTOMER
              };
              navbar_esm_analytics(event);
            },
            "data-testid": "header-dropdown-menu-link-".concat(trimSpaceWithDash(childItem.label)),
            children: childItem.label
          }, index)
        });
      })
    });
    if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: navItems
      }, index);
    }
    return item.link && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavLink, {
        href: item.link,
        isActive: item.isActive,
        badge: item.badge,
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            text: item.label,
            linkType: 'LinkToPage',
            position: EventCategory.CMS,
            customerType: CustomerType.CUSTOMER
          };
          navbar_esm_analytics(event);
        },
        "data-testid": "header-menu-link-".concat(trimSpaceWithDash(item.label)),
        children: item.label
      })
    }, index);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavElement, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    isSlideout: isSlideout
  }, globalProps), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: listItems
    })
  }));
};

var _excluded$4 = ["title", "children", "className", "isOpen", "hasTitleDivider", "handleClose"];
var _templateObject$1, navbar_esm_templateObject2, _templateObject3;
var headerTokens = {
  size: {
    height: {
      navbar: {
        default: {
          value: (0,commons_esm/* pxToRem */.Q1)(64)
        },
        sm: {
          value: (0,commons_esm/* pxToRem */.Q1)(72)
        },
        md: {
          value: (0,commons_esm/* pxToRem */.Q1)(96)
        }
      }
    }
  }
};
var StyledCloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "SlideoutMenu__StyledCloseButton",
  componentId: "lui__sc-8pev43-0"
})(["background-color:", ";border:0;margin:0;padding:0;width:", ";height:", ";color:", ";position:absolute;top:", ";right:", ";", " &:hover{background-color:#633482;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.interaction.main;
}, (0,commons_esm/* pxToRem */.Q1)(40), (0,commons_esm/* pxToRem */.Q1)(40), _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.inverse;
}, (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(16), (0,breakpoint_esm/* gte */.eg)('md')(_templateObject$1 || (_templateObject$1 = navbar_esm_taggedTemplateLiteral(["\n    top: ", ";\n  "])), (0,commons_esm/* pxToRem */.Q1)(28)));

/**
 * @todo z-index: tokenise z-index to make it easier to manage levels
 */

var StyledSlideoutMenu = (0,styled_components_browser_esm/* default */.ZP)(SlideoutMenuBase).withConfig({
  displayName: "SlideoutMenu__StyledSlideoutMenu",
  componentId: "lui__sc-8pev43-1"
})(["background-color:", ";overflow-y:scroll;color:", ";z-index:999;"], _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.fill.contrast;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.color.text.inverse;
});
var StyledSlideoutHR = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
  displayName: "SlideoutMenu__StyledSlideoutHR",
  componentId: "lui__sc-8pev43-2"
})(["margin:0 ", " ", " ", ";border:0;height:0;border-top:1px solid ", ";"], (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(16), _ref5 => {
  var {
    theme
  } = _ref5;
  return theme.color.text.inverse;
});
var StyledSlideoutHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SlideoutMenu__StyledSlideoutHeader",
  componentId: "lui__sc-8pev43-3"
})(["padding-right:", ";padding-left:", ";min-height:", ";display:flex;align-items:center;", " ", ""], (0,commons_esm/* pxToRem */.Q1)(72), (0,commons_esm/* pxToRem */.Q1)(16), headerTokens.size.height.navbar.default.value, (0,breakpoint_esm/* gte */.eg)('sm')(navbar_esm_templateObject2 || (navbar_esm_templateObject2 = navbar_esm_taggedTemplateLiteral(["\n    min-height: ", ";\n  "])), headerTokens.size.height.navbar.sm.value), (0,breakpoint_esm/* gte */.eg)('md')(_templateObject3 || (_templateObject3 = navbar_esm_taggedTemplateLiteral(["\n    min-height: ", ";\n  "])), headerTokens.size.height.navbar.md.value));
var StyledSlideoutContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SlideoutMenu__StyledSlideoutContent",
  componentId: "lui__sc-8pev43-4"
})(["display:flex;flex-direction:column;height:100%;"]);
var SlideoutMenu = _ref6 => {
  var {
      title,
      children,
      className,
      isOpen,
      hasTitleDivider = true,
      handleClose
    } = _ref6,
    props = navbar_esm_objectWithoutProperties(_ref6, _excluded$4);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var theme = (0,ui_esm/* useTheme */.Fg)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSlideoutMenu, navbar_esm_objectSpread2(navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    handleClose: handleClose,
    isOpen: isOpen
  }, globalProps), props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSlideoutContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSlideoutHeader, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RichText_1658459e_esm.T, {
          variant: "title2",
          tag: "h2",
          isInverse: true,
          children: title
        })
      }), hasTitleDivider && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSlideoutHR, {}), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCloseButton, {
      type: "button",
      onClick: handleClose,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icon_esm/* default */.Z, {
        color: theme.color.text.inverse,
        width: "1.5rem",
        height: "1.5rem"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SrOnlySpan, {
        children: ["Close ", title]
      })]
    })]
  }));
};

var navbar_esm_excluded$3 = ["talkTo"];
var TalkToExpertButton = _ref => {
  var {
      talkTo
    } = _ref,
    props = navbar_esm_objectWithoutProperties(_ref, navbar_esm_excluded$3);
  var {
    store,
    broker
  } = (0,context/* useBootstrappedChatState */.D)();
  var {
    gpBookAppointmentInterim
  } = (0,lib.useFlags)();
  var bookAppointmentCtaUrl = gpBookAppointmentInterim ? '/home-loans/basics/appointment/' : '/book-appointment/';
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var handleClick = () => {
    var event = {
      event_name: 'Button Clicked',
      category: EventCategory.NAVBAR,
      text: talkTo || 'Talk to a broker',
      position: EventCategory.CMS,
      customerType: CustomerType.CUSTOMER,
      buttonType: ButtonType.SECONDARY
    };
    store !== null && store !== void 0 && store.id ? sessionStorage.setItem(SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID, store === null || store === void 0 ? void 0 : store.id) : sessionStorage.removeItem(SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID);
    broker !== null && broker !== void 0 && broker.id ? sessionStorage.setItem(SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID, broker === null || broker === void 0 ? void 0 : broker.id) : sessionStorage.removeItem(SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID);
    navbar_esm_analytics(event);
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorButton_92f301b4_esm.A, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    variant: "secondary",
    href: embedMarketingTrackingIntoURL(bookAppointmentCtaUrl, 'https://www.aussie.com.au'),
    size: "sm",
    "data-component": "navbar-button-talk-to-expert",
    isInverse: true,
    width: "100%",
    onClick: handleClick,
    minWidth: (0,commons_esm/* pxToRem */.Q1)(152)
  }, globalProps), {}, {
    children: talkTo
  }));
};

var navbar_esm_excluded$2 = ["onClick", "width", "size"];
var APPLY_HREF = '/home-loans/basics';
var ApplyNowButton = _ref => {
  var {
      onClick,
      width,
      size
    } = _ref,
    props = navbar_esm_objectWithoutProperties(_ref, navbar_esm_excluded$2);
  var globalProps = (0,commons_esm/* filterGlobalProps */.jC)(props);
  var handleClick = () => {
    onClick === null || onClick === void 0 || onClick();
    var event = {
      event_name: 'Button Clicked',
      category: EventCategory.NAVBAR,
      text: 'Apply now',
      position: EventCategory.CMS,
      customerType: CustomerType.CUSTOMER,
      buttonType: ButtonType.PRIMARY
    };
    navbar_esm_analytics(event);
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorButton_92f301b4_esm.A, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    width: width,
    onPress: handleClick,
    href: embedMarketingTrackingIntoURL(APPLY_HREF, 'https://www.aussie.com.au'),
    variant: "primary",
    isInverse: true,
    size: size
  }, globalProps), {}, {
    children: "Apply now"
  }));
};

var navbar_esm_excluded$1 = ["application", "isAuthenticated", "handleApplyNowClick"];
var PrimaryCTA = _ref => {
  var {
      application,
      isAuthenticated,
      handleApplyNowClick
    } = _ref,
    props = navbar_esm_objectWithoutProperties(_ref, navbar_esm_excluded$1);
  return !(application !== null && application !== void 0 && application.id) ? /*#__PURE__*/(0,jsx_runtime.jsx)(ApplyNowButton, navbar_esm_objectSpread2(navbar_esm_objectSpread2({
    onClick: handleApplyNowClick,
    width: "100%"
  }, props), {}, {
    size: "sm"
  })) : !isAuthenticated ? /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorButton_92f301b4_esm.A, {
    onClick: () => {
      var event = {
        event_name: 'Button Clicked',
        category: EventCategory.NAVBAR,
        text: 'Continue Application',
        position: EventCategory.CMS,
        customerType: CustomerType.CUSTOMER,
        buttonType: ButtonType.PRIMARY
      };
      navbar_esm_analytics(event);
    },
    href: "/v2/dashboard/application/".concat(application.id),
    variant: "primary",
    isInverse: true,
    width: "100%",
    "data-testid": "header-continue-application",
    size: "sm",
    children: "Continue Application"
  }) : null;
};

var navbar_esm_excluded = ["navOptions"];
var navbar_esm_templateObject;
var HamburgerCtaBlock = _ref => {
  var {
    handleApplyNowClick,
    talkTo,
    application
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuPadding, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_68cf36c7_esm.S, {
      ygap: "12",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PrimaryCTA, {
        handleApplyNowClick: handleApplyNowClick,
        application: application,
        "data-testid": "header-apply-now-mobile"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TalkToExpertButton, {
        talkTo: talkTo,
        "data-testid": "header-talk-to-expert-mobile"
      })]
    })
  });
};
var StyledWrapperForButtonHack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HamburgerMenu__StyledWrapperForButtonHack",
  componentId: "lui__sc-302min-0"
})(["button{padding:0;margin-left:0.75rem;", "}"], (0,breakpoint_esm/* gte */.eg)('sm')(navbar_esm_templateObject || (navbar_esm_templateObject = navbar_esm_taggedTemplateLiteral(["\n      margin-left: .25rem; // Make sure focus outline doesn't get cut off by preceding links with bg colour\n    "]))));
var HamburgerMenu = _ref2 => {
  var {
      navOptions
    } = _ref2,
    props = navbar_esm_objectWithoutProperties(_ref2, navbar_esm_excluded);
  var {
    showMenu,
    toggleMenu
  } = useSlideoutMenu();
  var theme = (0,ui_esm/* useTheme */.Fg)();
  var handleClick = () => {
    toggleMenu();
    var event = {
      event_name: 'Menu Clicked',
      category: EventCategory.NAVBAR,
      menuName: 'Hamburger Menu',
      position: EventCategory.CMS,
      customerType: CustomerType.CUSTOMER
    };
    navbar_esm_analytics(event);
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapperForButtonHack, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(AnchorButton_92f301b4_esm.B, {
        onPress: handleClick,
        ariaExpanded: showMenu,
        variant: "text",
        size: "sm",
        isInverse: true,
        width: "auto",
        minWidth: "auto",
        "data-testid": "header-show-menu",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SrOnlySpan, {
          children: "Open main menu"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgMenu, {
          width: "1.5rem",
          height: "1.5rem",
          color: theme.color.text.inverse
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideoutMenu, {
      isOpen: showMenu,
      handleClose: toggleMenu,
      title: "Menu",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HamburgerCtaBlock, navbar_esm_objectSpread2({}, props)), /*#__PURE__*/(0,jsx_runtime.jsx)(Nav, {
        navOptions: navOptions,
        isSlideout: true
      })]
    })]
  });
};

var DropdownPrimaryContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AccountMenu__DropdownPrimaryContent",
  componentId: "lui__sc-4ssigl-0"
})(["", ";padding-top:", ";background-color:", ";flex-grow:1;"], Px, (0,commons_esm/* pxToRem */.Q1)(16), _ref => {
  var {
    theme
  } = _ref;
  return theme.color.fill.contrast;
});
var DropwdownSecondaryContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AccountMenu__DropwdownSecondaryContent",
  componentId: "lui__sc-4ssigl-1"
})(["padding-bottom:", ";background-color:#331745;"], (0,commons_esm/* pxToRem */.Q1)(24));
var LOGGEDIN_TEXT = 'My Account';
var LOGGEDOUT_TEXT = 'Login';
var MANAGE_APP_TEXT = 'Manage application';
var DropdownHeader = () => /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(RichText_1658459e_esm.T, {
    tag: "h2",
    variant: "title4",
    isInverse: true,
    children: "Loan application login"
  })
});
var DropdownHeaderLoggedIn = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RichText_1658459e_esm.T, {
    tag: "h2",
    variant: "title4",
    isInverse: true,
    children: "Manage your loan applications"
  }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHR, {})]
});
var LoggedInContent = _ref2 => {
  var {
    handleApplyNowClick,
    application,
    talkTo,
    onLogout
  } = _ref2;
  var {
    referAFriend
  } = (0,lib.useFlags)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DropdownPrimaryContent, {
      style: {
        flexGrow: '0'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropdownHeaderLoggedIn, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          marginBottom: '.75rem'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PrimaryCTA, {
          handleApplyNowClick: handleApplyNowClick,
          application: application,
          "data-testid": "header-dropdown-apply-now"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TalkToExpertButton, {
        talkTo: talkTo,
        "data-testid": "header-dropdown-talk-to-broker"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        marginTop: '.75rem'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuLink, {
        href: "/dashboard/applications",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: 'My Applications',
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          navbar_esm_analytics(event);
        },
        "data-testid": "header-menu-link-my-applications",
        children: "My Applications"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuLink, {
        href: "/property-report/my-properties",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: 'Property reports',
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          navbar_esm_analytics(event);
        },
        "data-testid": "header-menu-link-my-properties",
        children: "Property reports"
      }), referAFriend && /*#__PURE__*/(0,jsx_runtime.jsx)(MenuLink, {
        href: "/referral",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: 'Refer a friend',
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          navbar_esm_analytics(event);
        },
        "data-testid": "header-menu-link-refer",
        children: "Refer a friend"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
        onClick: onLogout,
        "data-testid": "header-menu-button-sign-out",
        children: "Sign out"
      })]
    })]
  });
};
var MENU_LINKS = [{
  label: 'Aussie Select',
  link: 'https://online.aussie.com.au/AHL/BankFast-Username-Logon#sst'
}, {
  label: 'Aussie Elevate',
  link: 'https://www.adelaidebank.com.au/mortgage-managers/aussieelevate/home/'
}, {
  label: 'Aussie Activate',
  link: 'https://www.lsn.com.au/LsnWeb/faces/LsnrLogin.jsp?EWF_FORM_NAME=0001939&EWF_BUTTON_Submit=Submit'
}, {
  label: 'Aussie Edge',
  link: 'https://www.adelaidebank.com.au/mortgage-managers/aussieedge/home/home/'
}, {
  label: 'All online banking logins',
  link: 'https://www.aussie.com.au/get-in-touch/log-in-page/'
}
// {
//   label: 'Aussie IQ, Aussie Optimizer and all other Aussie Home Loans settled before 2012',
//   link: 'https://aussie.openportal.com.au/portal/ahl/#/',
// },
];
var LoggedOutContent = () => {
  var _window, _window2;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DropwdownSecondaryContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuPaddingAlt, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RichText_1658459e_esm.T, {
          tag: "h2",
          variant: "title4",
          isInverse: true,
          children: "Online banking login"
        })
      }), MENU_LINKS.map((menuLink, i) => /*#__PURE__*/(0,jsx_runtime.jsx)(MenuLink, {
        href: menuLink.link,
        isExternal: true,
        background: "darker",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: menuLink.label,
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          navbar_esm_analytics(event);
        },
        children: menuLink.label
      }, i))]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DropdownPrimaryContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropdownHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          marginTop: '1.5rem',
          marginBottom: '1.5rem'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorButton_92f301b4_esm.A, {
          width: "100%",
          variant: "secondary",
          isInverse: true,
          href: signInURL,
          onPress: () => {
            var event = {
              event_name: 'Button Clicked',
              category: EventCategory.NAVBAR,
              text: MANAGE_APP_TEXT,
              position: EventCategory.CMS,
              customerType: CustomerType.CUSTOMER,
              buttonType: ButtonType.SECONDARY
            };
            navbar_esm_analytics(event);
          },
          "data-testid": "header-menu-link-sign-in",
          children: MANAGE_APP_TEXT
        })
      })]
    })]
  });
};
var AccountDropdown = _ref3 => {
  var {
    application,
    session,
    handleApplyNowClick,
    talkTo,
    onLogout
  } = _ref3;
  var isAuthenticated = (session === null || session === void 0 ? void 0 : session.status) === dist_esm/* Status.Authenticated */.qb.Authenticated;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavDropdown, {
    label: isAuthenticated ? LOGGEDIN_TEXT : LOGGEDOUT_TEXT,
    align: "right",
    minDropdownWidth: "18.75rem",
    onClick: () => {
      var event = {
        event_name: 'Menu Clicked',
        category: EventCategory.NAVBAR,
        menuName: isAuthenticated ? LOGGEDIN_TEXT : LOGGEDOUT_TEXT,
        position: 'CMS',
        customerType: CustomerType.CUSTOMER
      };
      navbar_esm_analytics(event);
    },
    children: isAuthenticated ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoggedInContent, {
      talkTo: talkTo,
      application: application,
      handleApplyNowClick: handleApplyNowClick,
      onLogout: onLogout,
      "data-testid": "header-menu-link-log-out"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LoggedOutContent, {})
  });
};
var AccountSlideoutMenu = _ref4 => {
  var {
    session,
    application,
    talkTo,
    handleApplyNowClick,
    onLogout
  } = _ref4;
  var {
    showMenu,
    toggleMenu
  } = useSlideoutMenu();
  var isAuthenticated = (session === null || session === void 0 ? void 0 : session.status) === dist_esm/* Status.Authenticated */.qb.Authenticated;
  var loggedInOutText = isAuthenticated ? LOGGEDIN_TEXT : LOGGEDOUT_TEXT;
  var handleClick = () => {
    toggleMenu();
    var event = {
      event_name: 'Menu Clicked',
      category: EventCategory.NAVBAR,
      menuName: loggedInOutText,
      position: 'CMS',
      customerType: CustomerType.CUSTOMER
    };
    navbar_esm_analytics(event);
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShowAtMediumOnly, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavButton, {
        "aria-expanded": showMenu,
        onClick: handleClick,
        isOpen: showMenu,
        children: loggedInOutText
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShowAtSmallOnly, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorButton_92f301b4_esm.B, {
        ariaExpanded: showMenu,
        onPress: handleClick,
        variant: "primary",
        size: "sm",
        isInverse: true,
        children: loggedInOutText
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideoutMenu, {
      isOpen: showMenu,
      handleClose: toggleMenu,
      title: loggedInOutText,
      hasTitleDivider: false,
      children: isAuthenticated ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoggedInContent, {
        talkTo: talkTo,
        application: application,
        handleApplyNowClick: handleApplyNowClick,
        onLogout: onLogout
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LoggedOutContent, {})
    })]
  });
};

var CtaNav = _ref => {
  var {
    handleApplyNowClick,
    session,
    application,
    talkTo,
    onLogout,
    isExperiment,
    isAuthenticated
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_68cf36c7_esm.S, {
    xalign: "center",
    gap: "0",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_68cf36c7_esm.S, {
      xalign: "center",
      gap: "xs",
      end: "8",
      width: "unset",
      children: [isExperiment ? /*#__PURE__*/(0,jsx_runtime.jsx)(ShowFromTweakExtraLarge, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TalkToExpertButton, {
          talkTo: talkTo,
          "data-testid": "header-talk-to-broker-desktop"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ShowFromTweakLarge, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TalkToExpertButton, {
          talkTo: talkTo,
          "data-testid": "header-talk-to-broker-desktop"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShowFromSmall, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PrimaryCTA, {
          handleApplyNowClick: handleApplyNowClick,
          application: application,
          isAuthenticated: isAuthenticated,
          "data-testid": "header-apply-now-desktop"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HideFromMedium, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountSlideoutMenu, {
          handleApplyNowClick: handleApplyNowClick,
          session: session,
          talkTo: talkTo,
          application: application,
          onLogout: onLogout
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShowFromMedium, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountDropdown, {
        handleApplyNowClick: handleApplyNowClick,
        session: session,
        talkTo: talkTo,
        application: application,
        onLogout: onLogout
      })
    })]
  });
};

function navbar_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function navbar_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        navbar_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        navbar_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var getApplications = /*#__PURE__*/function () {
  var _ref = navbar_esm_asyncToGenerator(function* (session, customerId, limit, orderBy) {
    var response = yield lib_axios.get("/v1/applications/", {
      baseURL: getAPIBaseURL(session.environment),
      headers: {
        Authorization: "Bearer ".concat(session.token),
        'Content-Type': 'application/json'
      },
      params: navbar_esm_objectSpread2(navbar_esm_objectSpread2(navbar_esm_objectSpread2({}, customerId && {
        customerId
      }), limit && {
        limit
      }), orderBy && {
        orderBy
      })
    });
    return response.data;
  });
  return function getApplications(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var useApplication = session => {
  var [application, setApplication] = react.useState();
  var {
    onException
  } = navbar_esm_useError();
  react.useEffect(() => {
    if (session.status === dist_esm/* Status.Authenticated */.qb.Authenticated) {
      var _session$identity;
      getApplications(session, (_session$identity = session.identity) === null || _session$identity === void 0 ? void 0 : _session$identity.id, 1, 'updatedAt').then(res => {
        var applications = res.data;
        var mostRecentlyUpdatedApplication = applications[0];
        setApplication(mostRecentlyUpdatedApplication);
      }).catch(error => {
        onException(new Error("@lendi/navbar: unable to fetch application: ".concat(error)));
      });
    } else {
      setApplication(undefined);
    }
  }, [session, onException]);
  return application;
};

var HeaderWithContext = _ref => {
  var {
    // Public props
    handleApplyNow,
    onLogout,
    navOptions = [],
    // Internal props, from ChatProps
    customerOwner,
    storeName,
    isExperiment
  } = _ref;
  var session = (0,dist_esm/* useSession */.kP)();
  var application = useApplication(session);
  var isAuthenticated = (session === null || session === void 0 ? void 0 : session.status) === dist_esm/* Status.Authenticated */.qb.Authenticated;
  // to set AHL value in session storage for funnel1 journey
  useAHLParam();
  var textForTalkTo = "Talk to ".concat(trimStringWithEllipsis((customerOwner === null || customerOwner === void 0 ? void 0 : customerOwner.firstName) || storeName || 'a broker'));
  var navbarMenu = isExperiment ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShowFromTweakExtraLarge, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Nav, {
        navOptions: navOptions
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HideFromTweakExtraLarge, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HamburgerMenu, {
        handleApplyNowClick: handleApplyNow,
        application: application,
        talkTo: textForTalkTo,
        navOptions: navOptions
      })
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShowFromTweakLarge, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Nav, {
        navOptions: navOptions
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HideFromTweakLarge, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HamburgerMenu, {
        handleApplyNowClick: handleApplyNow,
        application: application,
        talkTo: textForTalkTo,
        navOptions: navOptions
      })
    })]
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderBase, {
    navSlot: navbarMenu,
    isExperiment: isExperiment,
    ctaSlot: /*#__PURE__*/(0,jsx_runtime.jsx)(CtaNav, {
      handleApplyNowClick: handleApplyNow,
      application: application,
      session: session,
      talkTo: textForTalkTo,
      onLogout: onLogout,
      isExperiment: isExperiment,
      isAuthenticated: isAuthenticated
    })
  });
};
var navbar_esm_Header = navbar_esm_withErrorProvider(withLendiLDProvider(withCommPanel(HeaderWithContext)));

/* eslint-disable camelcase */

var ApplicationStage = /*#__PURE__*/function (ApplicationStage) {
  ApplicationStage["started_application"] = "started_application";
  ApplicationStage["finished_funnel2"] = "finished_funnel2";
  ApplicationStage["finished_funnel3"] = "finished_funnel3";
  ApplicationStage["finalised_application"] = "finalised_application";
  ApplicationStage["loan_selected"] = "loan_selected";
  return ApplicationStage;
}({});




/***/ }),

/***/ 9387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ AnchorButton; },
/* harmony export */   "B": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32386);
/* harmony import */ var _objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11147);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90471);
/* harmony import */ var _index_style_741fda20_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23512);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74512);
/* harmony import */ var react_helmet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74758);
/* harmony import */ var react_element_to_jsx_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44782);
/* harmony import */ var _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7401);
/* harmony import */ var _index_ada59f60_esm_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97520);
/* harmony import */ var _lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53075);
/* harmony import */ var _lendi_ui_commons_depth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46706);














var getIconMargin = props => {
  var marginSize;
  switch (props.size) {
    case 'lg':
      marginSize = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(20));
      break;
    case 'sm':
      marginSize = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(8));
      break;
    case 'xs':
      marginSize = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(6));
      break;
    default:
    case 'md':
      marginSize = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(12));
  }
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(["", ""], props.position === 'start' ? "margin-right: ".concat(marginSize, ";") : props.position === 'end' ? "margin-left: ".concat(marginSize, ";") : '');
};
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "lui__sc-1c5jz0y-0"
})(["display:inline-flex;", " ", ""], _ref => {
  var {
    position,
    size
  } = _ref;
  return getIconMargin({
    size,
    position
  });
}, props => props.isLoading && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(["visibility:hidden;"]));
var Icon = _ref2 => {
  var {
    isLoading,
    icon,
    position,
    size
  } = _ref2;
  var IconComponent = icon === null || icon === void 0 ? void 0 : icon.component;
  var isSmall = size === 'xs';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(IconWrapper, {
    size: size,
    position: position,
    isLoading: isLoading,
    "aria-hidden": true,
    children: IconComponent && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(IconComponent, {
      height: isSmall ? '1.43em' : '1.5em',
      width: "auto"
    })
  });
};

var ButtonContent = _ref => {
  var {
    isLoading,
    icon,
    children,
    size
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [icon && icon.position !== 'end' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    }), children && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      style: isLoading ? {
        visibility: 'hidden'
      } : undefined,
      children: children
    }), icon && icon.position === 'end' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    })]
  });
};

/**
 * This is a 100% duplicate of `@lendi-ui/icon/spinner`.
 *
 * It is used in LUI Next Button
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SpinnerIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_index_style_741fda20_esm_js__WEBPACK_IMPORTED_MODULE_2__.I, (0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M10.088.584v3c2.96 0 5.062 1.734 6.006 4.014.944 2.28.682 4.99-1.41 7.082-2.093 2.092-4.803 2.354-7.082 1.41-2.28-.944-4.014-3.047-4.014-6.006h-3c0 4.168 2.576 7.415 5.865 8.777 3.289 1.362 7.406.889 10.354-2.058 2.947-2.947 3.42-7.065 2.058-10.354C17.503 3.16 14.256.584 10.088.584z"
      })
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var spin = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .keyframes */ .F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerIconWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(SpinnerIcon).withConfig({
  displayName: "indexstyle__SpinnerIconWrapper",
  componentId: "lui__sc-ilwsxi-0"
})(["animation:", " 1.2s linear infinite;display:flex;line-height:0;width:100%;height:100%;svg{fill:currentColor;}"], spin);

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var Spinner = _ref => {
  var {
    variant = 'dark'
  } = _ref;
  var theme = (0,_index_ada59f60_esm_js__WEBPACK_IMPORTED_MODULE_7__.u)();
  var color = variant === 'dark' ? theme.color.buttonForeground.default : 'white';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SpinnerIconWrapper, {
    color: color
  });
};

var BaseButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(["display:inline-block;text-align:center;position:relative;transition:background-color 0.2s ease-out,color 0.2s ease-out,box-shadow 0.2s ease-out;cursor:pointer;font-family:", ";font-weight:700;border:solid 2px transparent;:focus-visible{outline:solid 2px ", ";outline-offset:2px;}:disabled{cursor:default;pointer-events:none;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.asset.font.body.family;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.border.interaction.focus;
});
var getButtonSize = props => {
  var _props$minWidth;
  var minWidth;
  var padding;

  /**
   * @todo Tokens: font-size
   */
  var fontSizeValue = props.size === 'xs' ? 14 : 16;
  var lineHeightValue = props.size === 'xs' ? 1.43 : 1.5;
  switch (props.size) {
    case 'lg':
      padding = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(18), " ").concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(40));
      minWidth = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(144);
      break;
    case 'sm':
      padding = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(6), " ").concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(14));
      minWidth = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(90);
      break;
    case 'xs':
      padding = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(4), " ").concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(10));
      minWidth = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(72);
      break;
    default:
    case 'md':
      padding = "".concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(10), " ").concat((0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(22));
      minWidth = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(108);
  }
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(["", ";", ";min-width:", ";padding:", ";border-radius:", ";font-size:", ";line-height:", ";"], props.width ? "width: ".concat(props.width) : '', props.maxWidth ? "max-width: ".concat(props.maxWidth) : '', (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : minWidth, padding, (0,_lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_8__/* .getRadius */ .H5)('button'), (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .pxToRem */ .Q1)(fontSizeValue), lineHeightValue);
};
var getColorStyle = (variant, state) => {
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(["background-color:", ";color:", ";border-color:", ";"], _ref3 => {
    var {
      theme
    } = _ref3;
    return theme.color.buttonFill[variant][state];
  }, _ref4 => {
    var {
      theme
    } = _ref4;
    return theme.color.buttonForeground[variant][state];
  }, _ref5 => {
    var {
      theme
    } = _ref5;
    return theme.color.buttonBorder[variant][state];
  });
};

//
// OLD LENDI BUTTON STYLES
// This will be removed, this code is here to bridge the gap untill lendi theme is turned off
//
var getOldLendiStyles = (variantName, isInverse) => (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(["text-transform:uppercase;letter-spacing:1.2px;border-width:1px;", ";&:disabled{opacity:0.4;}&:hover{box-shadow:", ";", ";}&:active{box-shadow:none;}:focus-visible{outline:0;box-shadow:", ",", ";}"], variantName.includes('text') ? "text-decoration: none; " : '', (0,_lendi_ui_commons_depth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(4), variantName.includes('text') && !isInverse ? "box-shadow: ".concat((0,_lendi_ui_commons_depth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(3)) : '', (0,_lendi_ui_commons_borders__WEBPACK_IMPORTED_MODULE_8__/* .getFocusRing */ .yb)(), (0,_lendi_ui_commons_depth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(2, 'focusRing'));
var StyledButtonBase = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "buttonstyles__StyledButtonBase",
  componentId: "lui__sc-1juyc07-0"
})(["", ";", ";", ""], BaseButtonStyles, props => getButtonSize(props), _ref6 => {
  var {
    isInverse,
    variant
  } = _ref6;
  var variantName = isInverse ? "".concat(variant, "Inverse") : variant;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(["", ";", " &:disabled{", ";pointer-events:none;}&:hover{", ";", "}&:focus-visible{", ";", "}&:active{", ";transform:translateY(1px);", "}", ";"], getColorStyle(variantName, 'default'), variantName.includes('text') && "text-decoration: underline;", getColorStyle(variantName, 'disabled'), getColorStyle(variantName, 'hover'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'focus'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'pressed'), variantName.includes('text') && "text-decoration: none;", _ref7 => {
    var {
      theme
    } = _ref7;
    return theme.name === 'lendi' && getOldLendiStyles(variantName, isInverse);
  });
});

var _excluded$1 = ["variant", "width", "size", "ariaExpanded", "ariaLabel", "className", "isInverse", "minWidth", "maxWidth", "isLoading", "isDisabled", "icon", "children", "onPress", "onClick", "type"];
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Button__Loader",
  componentId: "lui__sc-12k3xs9-0"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:flex;width:", ";height:", ";"], _ref => {
  var {
    size
  } = _ref;
  return size === 'xs' ? '1.43em' : '1.5em';
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === 'xs' ? '1.43em' : '1.5em';
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(StyledButtonBase).withConfig({
  displayName: "Button__StyledButton",
  componentId: "lui__sc-12k3xs9-1"
})(["", ";"], _ref3 => {
  var {
    icon
  } = _ref3;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var Button = _ref4 => {
  var {
      variant = 'primary',
      width = 'auto',
      size = 'md',
      ariaExpanded,
      ariaLabel,
      className,
      isInverse,
      minWidth,
      maxWidth,
      isLoading,
      isDisabled,
      icon,
      children,
      onPress,
      onClick,
      type = 'button'
    } = _ref4,
    props = (0,_objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_11__._)(_ref4, _excluded$1);
  var globalProps = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .filterGlobalProps */ .jC)(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledButton, (0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    className: className,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress,
    variant: variant,
    type: type,
    isLoading: isLoading,
    disabled: isDisabled,
    icon: icon
  }, globalProps), {}, {
    children: [isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Loader, {
      size: size,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Spinner, {
        variant: variant === 'primary' ? 'light' : 'dark'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        className: "sr-only",
        children: "Loading"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ButtonContent, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      children: children
    })]
  }));
};

var _excluded = ["href", "target", "variant", "width", "isInverse", "ariaLabel", "minWidth", "maxWidth", "onPress", "onClick", "children", "className", "icon", "size"];
var StyledAnchorButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(StyledButtonBase).withConfig({
  displayName: "AnchorButton__StyledAnchorButton",
  componentId: "lui__sc-6oc08b-0"
})(["", ";text-decoration:none;"], _ref => {
  var {
    icon
  } = _ref;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var AnchorButton = _ref2 => {
  var {
      href,
      target,
      variant = 'primary',
      width,
      isInverse,
      ariaLabel,
      minWidth,
      maxWidth,
      onPress,
      onClick,
      children,
      className,
      icon,
      size = 'md'
    } = _ref2,
    props = (0,_objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_11__._)(_ref2, _excluded);
  var globalProps = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_6__/* .filterGlobalProps */ .jC)(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledAnchorButton, (0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({
    as: "a",
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    className: className,
    variant: variant,
    href: href,
    target: target,
    icon: icon,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress
  }, globalProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ButtonContent, {
      size: size,
      icon: icon,
      children: children
    })
  }));
};




/***/ }),

/***/ 24467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports A, P, R */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90471);
/* harmony import */ var _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32386);
/* harmony import */ var _objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11147);
/* harmony import */ var _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7401);
/* harmony import */ var _lendi_ui_commons_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70757);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74512);








var getFontSize = variant => {
  var styles = styleData[variant];
  return styles.fontSize;
};
var getLineHeight = variant => {
  var styles = styleData[variant];
  return styles.lineHeight;
};
var getTextColor = (theme, appearance) => {
  if (appearance) {
    if (appearance === 'error') {
      return theme.color.interaction.error;
    }
    if (appearance === 'subtle') {
      return theme.color.text.subtle;
    }
  }
  return theme.color.text.main;
};
var linkStyle = theme => {
  return {
    textDecoration: 'underline',
    color: theme.color.interaction.main,
    fontFamily: theme.asset.font.body.family,
    '&:hover': {
      textDecoration: 'none'
    }
  };
};
var styleData = {
  display: {
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(36),
      desktop: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[10])
    },
    lineHeight: 1.31
  },
  display1: {
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[9]),
      desktop: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[10])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading
  },
  display2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[8]),
      desktop: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[9])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading
  },
  title1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[7]),
      desktop: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[8])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading
  },
  title2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[6])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading
  },
  title3: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[5])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading
  },
  title4: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[4])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading
  },
  lead1: {
    hasMobile: true,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[5]),
      desktop: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[6])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  lead2: {
    hasMobile: true,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[3]),
      desktop: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[5])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  subtitle1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[3])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  subtitle2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[2])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  body1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[3])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  body2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[2])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  detail1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[1])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  detail2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[1])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  overline: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[2])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading
  },
  button1: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[3])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  },
  button2: {
    hasMobile: false,
    fontSize: {
      mobile: (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[2])
    },
    lineHeight: _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.body
  }
};

var _excluded$1 = ["children", "variant", "className"];
var getThemeTextAlignment = themeName => {
  if (themeName === _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .ThemeNames.Lendi */ .hN.Lendi) {
    return 'center';
  }
  return 'left';
};
var checkIsHeading = variant => {
  var headingsVariants = ['display', 'display1', 'display2', 'title1', 'title2', 'title3', 'title4'];
  return headingsVariants.includes(variant);
};
var Component = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "Text__Component",
  componentId: "lui__sc-xe5utb-0"
})(_ref => {
  var _theme$name;
  var {
    variant,
    theme,
    align,
    isMobile,
    styleTarget,
    $display,
    appearance,
    isInverse
  } = _ref;
  var fontSizeValue = getFontSize(variant);
  var isHeading = checkIsHeading(variant);
  var hasDesktopFontSize = Object.prototype.hasOwnProperty.call(fontSizeValue, 'desktop');
  var themeName = (_theme$name = theme === null || theme === void 0 ? void 0 : theme.name) !== null && _theme$name !== void 0 ? _theme$name : (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .getThemeName */ .Yo)(); // fallback to old getTheme function when latest Theme not being used. To be removed in next major

  var styleObj = {
    margin: 0,
    display: $display !== null && $display !== void 0 ? $display : 'block',
    fontFamily: isHeading ? theme.asset.font.heading.family : theme.asset.font.body.family,
    fontWeight: (0,_lendi_ui_commons_typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(variant, 'fontWeight'),
    textAlign: align !== null && align !== void 0 ? align : getThemeTextAlignment(themeName),
    color: isInverse ? theme.color.text.inverse : getTextColor(theme, appearance),
    fontSize: fontSizeValue.mobile,
    lineHeight: getLineHeight(variant),
    a: linkStyle(theme)
  };
  if (variant === 'overline') {
    styleObj = Object.assign({
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }, styleObj);
  }
  if (hasDesktopFontSize && !isMobile) {
    styleObj = Object.assign({
      [_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.B.sm]: {
        fontSize: fontSizeValue.desktop
      }
    }, styleObj);
  }
  if (styleTarget) {
    return {
      [styleTarget]: styleObj
    };
  }
  return styleObj;
});
var Text = _ref2 => {
  var {
      children,
      variant = 'body1',
      className
    } = _ref2,
    props = (0,_objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_6__._)(_ref2, _excluded$1);
  var globalProps = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .filterGlobalProps */ .jC)(props);
  var textVariantClass;
  switch (variant) {
    case 'display':
      textVariantClass = 'lui-display';
      break;
    case 'display1':
      textVariantClass = 'lui-display1';
      break;
    case 'display2':
      textVariantClass = 'lui-display2';
      break;
    case 'title1':
      textVariantClass = 'lui-title1';
      break;
    case 'title2':
      textVariantClass = 'lui-title2';
      break;
    case 'title3':
      textVariantClass = 'lui-title3';
      break;
    case 'title4':
      textVariantClass = 'lui-title4';
      break;
    case 'lead1':
      textVariantClass = 'lui-lead1';
      break;
    case 'lead2':
      textVariantClass = 'lui-lead2';
      break;
    case 'subtitle1':
      textVariantClass = 'lui-subtitle1';
      break;
    case 'subtitle2':
      textVariantClass = 'lui-subtitle2';
      break;
    case 'body1':
      textVariantClass = 'lui-body1';
      break;
    case 'body2':
      textVariantClass = 'lui-body2';
      break;
    case 'button1':
      textVariantClass = 'lui-button1';
      break;
    case 'button2':
      textVariantClass = 'lui-button2';
      break;
    case 'detail1':
      textVariantClass = 'lui-detail1';
      break;
    case 'detail2':
      textVariantClass = 'lui-detail2';
      break;
    case 'overline':
      textVariantClass = 'lui-overline';
      break;
    default:
      textVariantClass = 'lui-body1';
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Component, (0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__._)({
    id: props.id,
    className: className ? "".concat(className, " ").concat(textVariantClass) : textVariantClass,
    as: props.tag,
    variant: variant,
    align: props.align,
    appearance: props.appearance,
    isMobile: props.isMobile,
    htmlFor: props.for,
    $display: props.display,
    role: props.role,
    isInverse: props.isInverse
  }, globalProps), {}, {
    children: children
  }));
};

var Paragraph = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(Text).withConfig({
  displayName: "Paragraph",
  componentId: "lui__sc-iqzapc-0"
})(_ref => {
  var {
    theme
  } = _ref;
  return {
    a: linkStyle(theme)
  };
});
var P = _ref2 => {
  var {
    appearance,
    variant,
    children
  } = _ref2;
  return /*#__PURE__*/jsx(Paragraph, {
    variant: variant !== null && variant !== void 0 ? variant : 'body1',
    tag: "p",
    appearance: appearance,
    children: children
  });
};

var A = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "Link__A",
  componentId: "lui__sc-1u7drzy-0"
})(["", ""], _ref => {
  var {
    theme
  } = _ref;
  return linkStyle(theme);
});

var _excluded = (/* unused pure expression or super */ null && (["children", "textSize"]));
var StyledRichText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RichText__StyledRichText",
  componentId: "lui__sc-nganh6-0"
})(["font-size:", ";line-height:", ";color:", ";", "{font-size:", ";}> *{font-family:", ";font-weight:", ";font-size:1em;margin-bottom:0;margin-top:0;}> * + *{margin-top:", ";", "{margin-top:", ";}}> * li{margin-top:0.5em;}> * + h1,> * + h2,> * + div,> div + *{margin-top:", ";}> h1 + *,> h2 + *{margin-top:", ";}> h3 + *,> h4 + *{margin-top:", ";}> * + h3,> * + h4{margin-top:", ";}> h1,> h2,> h3,> h4{font-family:", ";line-height:", ";font-weight:", ";color:", ";}> h1{font-size:", ";", ";}> h2{font-size:", ";", ";}> h3{font-size:", ";}> h4{font-size:", ";}> a,li > a,p > a{", ";}"], (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.b), styleData.body1.lineHeight, _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.subtle;
}, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.B.sm, _ref2 => {
  var {
    textSize
  } = _ref2;
  return textSize === 'lg' && (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[5]);
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.asset.font.body.family;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.asset.font.body.weight;
}, (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[3]), _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.B.sm, _ref5 => {
  var {
    textSize
  } = _ref5;
  return textSize === 'lg' && (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[5]);
}, (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[10]), (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[6]), (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[5]), (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q1)(_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.f[9]), _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.asset.font.body.family;
}, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.L.heading, _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.asset.font.heading.weight;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.color.text.main;
}, styleData.display2.fontSize.mobile, 'desktop' in styleData.display2.fontSize && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["", "{font-size:", ";}"], _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.B.sm, styleData.display2.fontSize.desktop), styleData.title1.fontSize.mobile, 'desktop' in styleData.title1.fontSize && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["", "{font-size:", ";}"], _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_1__.B.sm, styleData.title1.fontSize.desktop), styleData.title2.fontSize.mobile, styleData.title3.fontSize.mobile, _ref9 => {
  var {
    theme
  } = _ref9;
  return linkStyle(theme);
});

// Direct children have margin removed and are spaced out xs
var RichText = _ref10 => {
  var {
      children,
      textSize = 'md'
    } = _ref10,
    props = _objectWithoutProperties(_ref10, _excluded);
  return /*#__PURE__*/jsx(StyledRichText, _objectSpread2(_objectSpread2({
    textSize: textSize
  }, props), {}, {
    children: children
  }));
};




/***/ }),

/***/ 67623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Spacer; },
/* harmony export */   "W": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* unused harmony exports G, V, a, b, c, d, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90471);
/* harmony import */ var _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7401);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74512);
/* harmony import */ var _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32386);
/* harmony import */ var _objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11147);







// remove this once safari support ships
function checkFlexGap() {
  var _flex$parentNode;
  // create flex container with row-gap set
  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex === null || flex === void 0 || (_flex$parentNode = flex.parentNode) === null || _flex$parentNode === void 0 || _flex$parentNode.removeChild(flex);
  return isSupported;
}
function useFlexGap() {
  var [isFlexGapSupported, setIsFlexGapSupported] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (document.documentElement.classList.contains('flexbox-gap')) {
      setIsFlexGapSupported(true);
    } else if (document.documentElement.classList.contains('no-flexbox-gap')) {
      setIsFlexGapSupported(false);
    }
  }, []);
  return isFlexGapSupported;
}
function useFlexGapPolyfill() {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    // first check if it's already been run
    if (!document.documentElement.classList.contains('flexbox-gap') && !document.documentElement.classList.contains('no-flexbox-gap')) {
      if (checkFlexGap()) {
        document.documentElement.classList.add('flexbox-gap');
      } else {
        document.documentElement.classList.add('no-flexbox-gap');
      }
    }
  }, []);
}

// reset margin between direct children
// add extra space before headings
var VerticalRhythmWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "VerticalRhythm__VerticalRhythmWrapper",
  componentId: "lui__sc-z5vadw-0"
})(["display:flex;flex-direction:column;gap:var(--gap);align-items:", ";& > *{margin-top:0;margin-bottom:0;}& > .lui-title1:not(:first-child),& > .lui-title2:not(:first-child),& > .lui-subtitle1:not(:first-child),& > .lui-subtitle2:not(:first-child){margin-top:", "px;}.no-flexbox-gap &{gap:initial;margin-top:calc(var(--gap) / -2);margin-bottom:calc(var(--gap) / -2);> *{margin-top:calc(var(--gap) / 2);margin-bottom:calc(var(--gap) / 2);}& > .lui-title1:not(:first-child),& > .lui-title2:not(:first-child),& > .lui-subtitle1:not(:first-child),& > .lui-subtitle2:not(:first-child){margin-top:calc(calc(var(--gap) / 2) + ", "px);}}"], props => props.align === "start" ? "flex-start" : props.align, _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xs */ .W0.xs, _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xs */ .W0.xs);

// Direct children have margin removed and are spaced out xs
var VerticalRhythm = _ref => {
  var {
    density = 'md',
    align = 'stretch',
    children
  } = _ref;
  useFlexGapPolyfill();
  var isFlexGapSupported = useFlexGap();
  var gap = "".concat(spacing.md, "px");
  if (density === 'sm') {
    gap = "".concat(spacing.sm, "px");
  } else if (density === 'lg') {
    gap = "".concat(spacing.lg, "px");
  }
  var Markup = /*#__PURE__*/jsx(VerticalRhythmWrapper, {
    className: "vertical-rhythm",
    align: align,
    style: {
      '--gap': gap
    },
    children: children
  });
  return !isFlexGapSupported ? /*#__PURE__*/jsx("div", {
    className: "flex-gap-polyfill-wrapper",
    children: Markup
  }) : Markup;
};

var _excluded$4 = ["width", "xgap", "ygap", "gap", "className", "minWidth", "maxWidth"];
var getYSpacing = props => {
  if (props.ygap) {
    return _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[props.ygap];
  }
  if (props.gap) {
    return _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[props.gap];
  }
  return '0';
};
var getXSpacing = props => {
  if (props.xgap) {
    return _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[props.xgap];
  }
  if (props.gap) {
    return _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[props.gap];
  }
  return '0';
};
var getMarginTop = function getMarginTop(direction, start) {
  var isFlexGapSupported = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!isFlexGapSupported) {
    if (start) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["margin-top:calc(calc(var(--row-gap) / -2) + ", "px);"], _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[start]);
    }
    return "margin-top: calc(var(--row-gap) / -2);";
  }
  return start && direction === 'column' ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["margin-top:", "px;"], _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[start]) : null;
};
var getMarginBottom = function getMarginBottom(direction, end) {
  var isFlexGapSupported = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!isFlexGapSupported) {
    if (end) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["margin-bottom:calc(calc(var(--row-gap) / -2) + ", "px);"], _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[end]);
    }
    return "margin-bottom: calc(var(--row-gap) / -2);";
  }
  return end && direction === 'column' ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["margin-bottom:", "px;"], _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[end]) : null;
};
var getMarginLeft = (direction, start) => {
  return start && direction === 'row' ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["margin-left:", "px;"], _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[start]) : null;
};
var getMarginRight = (direction, end) => {
  return end && direction === 'row' ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["margin-right:", "px;"], _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0[end]) : null;
};
var getAlign = align => {
  switch (align) {
    case 'center':
      return "center";
    case 'start':
      return 'flex-start';
    case 'end':
      return 'flex-end';
    case 'stretch':
      return 'stretch';
    default:
      return 'flex-start';
  }
};
var getAlignment = props => {
  if (props.align) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["justify-content:", ";align-items:", ";"], getAlign(props.align), getAlign(props.align));
  }

  // horizontal spacer
  if (props.direction === 'row') {
    if (props.xalign && props.yalign) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["justify-content:", ";align-items:", ";"], getAlign(props.yalign), getAlign(props.xalign));
    }
    if (props.xalign) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["align-items:", ";justify-content:flex-start;"], getAlign(props.xalign));
    }
    if (props.yalign) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["justify-content:", ";"], getAlign(props.yalign));
    } else {
      return "\n        justify-content: flex-start;\n        align-items: flex-start;\n      ";
    }
  } else {
    // vertical spacer
    if (props.xalign && props.yalign) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["justify-content:", ";align-items:", ";"], getAlign(props.xalign), getAlign(props.yalign));
    }
    if (props.xalign) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["justify-content:", ";"], getAlign(props.xalign));
    }
    if (props.yalign) {
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["align-items:", ";"], getAlign(props.yalign));
    } else {
      return "\n        justify-content: flex-start;\n        align-items: flex-start;\n      ";
    }
  }
};
var Wrapper$1 = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Spacer__Wrapper",
  componentId: "lui__sc-n3gfm-0"
})(["display:flex;flex-direction:", ";column-gap:var(--column-gap);row-gap:var(--row-gap);flex-wrap:", ";width:", ";", " ", " ", " ", " ", " ", " ", " .no-flexbox-gap &{gap:initial;margin-left:calc(var(--column-gap) / -2);margin-right:calc(var(--column-gap) / -2);", " ", " > *{margin-top:calc(var(--row-gap) / 2);margin-bottom:calc(var(--row-gap) / 2);margin-left:calc(var(--column-gap) / 2);margin-right:calc(var(--column-gap) / 2);}}"], props => props.$direction, props => props.shouldWrap ? "wrap" : "nowrap", props => props.$width, props => props.minWidth && "min-width: ".concat(props.minWidth, ";"), props => props.maxWidth && "max-width: ".concat(props.maxWidth, ";"), props => getMarginLeft(props.$direction, props.start), props => getMarginRight(props.$direction, props.$end), props => getMarginTop(props.$direction, props.start), props => getMarginBottom(props.$direction, props.$end), props => getAlignment(props.align ? {
  align: props.align,
  direction: props.$direction
} : {
  xalign: props.xalign,
  yalign: props.yalign,
  direction: props.$direction
}), props => getMarginTop(props.$direction, props.start, false), props => getMarginBottom(props.$direction, props.$end, false));
var FlexGapWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Spacer__FlexGapWrapper",
  componentId: "lui__sc-n3gfm-1"
})(["width:", ";"], props => props.$width);
var Spacer = _ref => {
  var {
      width = '100%',
      xgap,
      ygap,
      gap,
      className,
      minWidth,
      maxWidth
    } = _ref,
    props = (0,_objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_5__._)(_ref, _excluded$4);
  var globalProps = (0,_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .filterGlobalProps */ .jC)(props);
  useFlexGapPolyfill();
  var isFlexGapSupported = useFlexGap();
  var direction = 'row';
  var shouldWrap = false;
  if (props !== null && props !== void 0 && props.shouldWrap) {
    shouldWrap = props.shouldWrap;
  } else if (gap) {
    // if we have a gap or both xgap and ygap
    shouldWrap = true;
  } else if (xgap && ygap) {
    shouldWrap = true;
  }

  // if we only have ygap
  if (ygap && !xgap) {
    direction = 'column';
  }

  // or if we have no gap
  if (!xgap && !ygap && !gap) {
    // default to 16
    gap = '16';
  }
  var Markup = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper$1, (0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({
    className: className ? "lui-spacer ".concat(className) : "lui-spacer",
    style: {
      '--row-gap': "".concat(getYSpacing(gap ? {
        gap
      } : {
        xgap,
        ygap
      }), "px"),
      '--column-gap': "".concat(getXSpacing(gap ? {
        gap
      } : {
        xgap,
        ygap
      }), "px")
    },
    $direction: direction,
    align: props.align,
    xalign: props.xalign,
    yalign: props.yalign,
    shouldWrap: shouldWrap,
    $end: props.end,
    $width: width && isFlexGapSupported ? width : 'auto',
    minWidth: minWidth,
    maxWidth: maxWidth,
    start: props.start
  }, isFlexGapSupported && globalProps), {}, {
    children: props.children
  }));
  return !isFlexGapSupported ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FlexGapWrapper, (0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({
    className: "flex-gap-polyfill-wrapper",
    $width: width
  }, globalProps), {}, {
    children: Markup
  })) : Markup;
};

var _excluded$3 = (/* unused pure expression or super */ null && (["children"]));
var StyledGrid = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "lui__sc-1jtonxt-0"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";margin-top:-", ";", "{margin-left:-", ";margin-top:-", ";}> *{padding-left:", ";padding-top:", ";", "{padding-left:", ";padding-top:", ";}}"], _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.md, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.md, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.md, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.md);
var Grid = _ref => {
  var {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/jsx(StyledGrid, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded$2 = (/* unused pure expression or super */ null && (["children"]));
var SmallScreenGrid = '4';
var LargeScreenGrid = '12';
var calculatePercentage = (partial, total) => "".concat(Number(partial) / Number(total) * 100, "%");
var getWidth = (size, totalColumns) => {
  if (!size) return;
  if (size === 'auto') {
    return 'auto';
  } else {
    return calculatePercentage(size, totalColumns);
  }
};
var StyledGridItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "GridItem__StyledGridItem",
  componentId: "lui__sc-y5ttjj-0"
})(["max-width:100%;width:", ";", " ", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}", "{flex:0 0 auto;width:", ";}"], _ref => {
  var {
    xs
  } = _ref;
  return xs ? getWidth(xs, SmallScreenGrid) : '100%';
}, _ref2 => {
  var {
    xs
  } = _ref2;
  return xs ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["flex:0 0 auto;"]) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["flex-shrink:0;"]);
}, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.sm, _ref3 => {
  var {
    sm
  } = _ref3;
  return getWidth(sm, LargeScreenGrid);
}, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.md, _ref4 => {
  var {
    md
  } = _ref4;
  return getWidth(md, LargeScreenGrid);
}, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.lg, _ref5 => {
  var {
    lg
  } = _ref5;
  return getWidth(lg, LargeScreenGrid);
}, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.xl, _ref6 => {
  var {
    xl
  } = _ref6;
  return getWidth(xl, LargeScreenGrid);
});
var GridItem = _ref7 => {
  var {
      children
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded$2);
  return /*#__PURE__*/jsx(StyledGridItem, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var _excluded$1 = ["children"];
var MaxWidths = {
  xxl: '82.5rem',
  // 1320px
  xl: '71.25rem' // 1140px
};
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Wrapper__StyledWrapper",
  componentId: "lui__sc-5zleyr-0"
})(["max-width:", ";margin-left:auto;margin-right:auto;padding-left:", ";padding-right:", ";@media (min-width:", "){padding-left:", ";padding-right:", ";}"], _ref => {
  var {
    maxWidth
  } = _ref;
  return maxWidth ? MaxWidths[maxWidth] : MaxWidths.xxl;
}, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.a.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.md, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.G.md);
var Wrapper = _ref2 => {
  var {
      children
    } = _ref2,
    props = (0,_objectWithoutProperties_7e1dfdab_esm_js__WEBPACK_IMPORTED_MODULE_5__._)(_ref2, _excluded$1);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledWrapper, (0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__._)((0,_index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__._)({}, props), {}, {
    children: children
  }));
};

var _excluded = (/* unused pure expression or super */ null && (["children"]));
var StyledSection = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Section__StyledSection",
  componentId: "lui__sc-1pbxoat-0"
})(["padding-top:3rem;padding-bottom:3rem;", "{padding-top:4rem;padding-bottom:4rem;}", "{padding-top:6rem;padding-bottom:6rem;}"], _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.sm, _index_c76be973_esm_js__WEBPACK_IMPORTED_MODULE_3__.B.lg);
var Section = _ref => {
  var {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(StyledSection, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};




/***/ }),

/***/ 23512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90471);


/**
 * This is a 100% duplicate of `@lendi-ui/icon/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-1vln477-0"
})(["width:", ";height:", ";vertical-align:middle;display:inline-block;& > svg{fill:", ";width:inherit;height:inherit;}[class$='fillPath']{fill:", ";}"], _ref => {
  var {
    width
  } = _ref;
  return width !== null && width !== void 0 ? width : '1em';
}, _ref2 => {
  var {
    height
  } = _ref2;
  return height !== null && height !== void 0 ? height : '1em';
}, _ref3 => {
  var {
    color
  } = _ref3;
  return color;
}, _ref4 => {
  var {
    color
  } = _ref4;
  return color;
});




/***/ }),

/***/ 11147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}




/***/ }),

/***/ 97049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ AnchorButton_92f301b4_esm.B; }
});

// UNUSED EXPORTS: A, AnchorButton, ClearActionButton, DateField, DollarField, ErrorText, FieldLabel, Grid, GridItem, HelpText, InputBaseComponent, LUIProvider, NumericField, P, PhoneField, RichText, Section, SelectField, Spacer, StyledSection, Text, TextField, Theme, UnitField, VerticalRhythm, Wrapper, aussieTheme, cleanNumericValue, dollarToNumber, domainTheme, lendiNextTheme, select, theme, useClearAction, useFlexGap, useFlexGapPolyfill, useTheme

// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index-68cf36c7.esm.js
var index_68cf36c7_esm = __webpack_require__(67623);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/RichText-1658459e.esm.js
var RichText_1658459e_esm = __webpack_require__(24467);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/Theme-fed7db47.esm.js + 1 modules
var Theme_fed7db47_esm = __webpack_require__(37257);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index-ada59f60.esm.js
var index_ada59f60_esm = __webpack_require__(97520);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/AnchorButton-92f301b4.esm.js
var AnchorButton_92f301b4_esm = __webpack_require__(9387);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index-c76be973.esm.js
var index_c76be973_esm = __webpack_require__(32386);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(90471);
// EXTERNAL MODULE: ../../../node_modules/cuid/index.js
var node_modules_cuid = __webpack_require__(56219);
// EXTERNAL MODULE: ../../../node_modules/@lendi/ui/dist/index.style-741fda20.esm.js
var index_style_741fda20_esm = __webpack_require__(23512);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/utils/dist/commons.esm.js
var commons_esm = __webpack_require__(7401);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/borders/dist/commons.esm.js
var dist_commons_esm = __webpack_require__(53075);
// EXTERNAL MODULE: ../../../node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(74758);
// EXTERNAL MODULE: ../../../node_modules/react-element-to-jsx-string/dist/cjs/index.js
var cjs = __webpack_require__(44782);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/TextField-1eb922c0.esm.js

















/**
 * This is a 100% duplicate of `@lendi-ui/icon/email`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgEmail(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

// TODO: refactor text field into a cleaner package (e.g. `@lendi-ui/input`) and promote the InputBase to include all common functionality between numeric, phone, text and unit fields, possibly Select?

var InputBaseComponent = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "InputBase__InputBaseComponent",
  componentId: "lui__sc-ncc05m-0"
})(["font-family:", ";font-size:", ";color:", ";background-color:", ";border:", ";border-radius:", ";padding:", ";height:", ";width:100%;&:hover{", ";}&::placeholder{color:", ";}&:focus-visible{outline:0;box-shadow:", ";}&:disabled{background-color:", ";border:1px solid ", ";&::placeholder{color:", ";}}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.asset.font.body.family;
}, (0,commons_esm/* pxToRem */.Q1)(16), _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.main;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.background.container;
}, _ref4 => {
  var {
    validationState,
    theme
  } = _ref4;
  return validationState === 'invalid' ? "2px solid ".concat(theme.color.interaction.error) : "1px solid ".concat(theme.color.border.interaction.default);
}, () => (0,dist_commons_esm/* getRadius */.H5)(), (0,commons_esm/* pxToRem */.Q1)(16), (0,commons_esm/* pxToRem */.Q1)(48), _ref5 => {
  var {
    validationState,
    theme
  } = _ref5;
  return validationState !== 'invalid' && "border: 1px solid ".concat(theme.color.border.interaction.hover);
}, _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.color.text.main;
}, (0,dist_commons_esm/* getFocusRing */.yb)(), _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.color.fill.disabled;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.color.interaction.disabled;
}, _ref9 => {
  var {
    theme
  } = _ref9;
  return theme.color.interaction.disabled;
});

/**
 * This is a 100% duplicate of `@lendi-ui/icon/clear`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgClear(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

function TextField_1eb922c0_esm_useClearAction(onChange, ref, value) {
  var [isCleared, setIsCleared] = useState(false);
  useEffect(() => {
    var inputRef = ref;

    // When the component first renders, check if value is empty
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && inputRef.current.value === '') {
      setIsCleared(true);
    } else if (value === '') {
      setIsCleared(true);
    }

    // When we have cleared, set value for uncontrolled inputs
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && isCleared) {
      inputRef.current.value = '';
    }
  }, [isCleared, ref, value]);
  var clearValue = () => {
    setIsCleared(true);
  };
  var handleChange = e => {
    if (e.target.value === '') {
      setIsCleared(true);
    } else {
      // once a value has been typed, we are no longer clearing
      setIsCleared(false);
    }
    // call the consumer's onChange
    if (onChange) {
      onChange(e);
    }
  };
  return {
    clearValue,
    handleChange,
    isCleared
  };
}

// TODO: this should be our button component
// ^^^ Until Button allows className we can't do that
var ActionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ClearAction__ActionButton",
  componentId: "lui__sc-1cpgla3-0"
})(["position:absolute;right:", ";top:", ";border:0;border-radius:", ";background:none;padding:", ";cursor:pointer;&:focus-visible{outline:0;box-shadow:", ";}"], (0,commons_esm/* pxToRem */.Q1)(6), (0,commons_esm/* pxToRem */.Q1)(7), (0,commons_esm/* pxToRem */.Q1)(4), (0,commons_esm/* pxToRem */.Q1)(5), (0,dist_commons_esm/* getFocusRing */.yb)());
var TextField_1eb922c0_esm_ClearActionButton = _ref => {
  var {
    isCleared,
    clearValue
  } = _ref;
  var theme = useTheme();
  if (isCleared) {
    return null;
  } else {
    return /*#__PURE__*/jsx(ActionButton, {
      "aria-label": "Clear",
      type: "button",
      onClick: clearValue,
      children: /*#__PURE__*/jsx(SvgClear, {
        color: theme.color.interaction.contrast,
        width: "24px",
        height: "24px"
      })
    });
  }
};

/**
 * This is a 100% duplicate of `@lendi-ui/icon/error`.
 *
 * It is used in LUI Next TextField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgError(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm.I, (0,index_c76be973_esm._)((0,index_c76be973_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      })]
    })
  }));
}

var ErrorIcon = (0,styled_components_browser_esm/* default */.ZP)(SvgError).withConfig({
  displayName: "ErrorText__ErrorIcon",
  componentId: "lui__sc-1xismmk-0"
})(["display:inline;"]);
var TextField_1eb922c0_esm_ErrorText = _ref => {
  var {
    id,
    text
  } = _ref;
  var theme = useTheme();
  return /*#__PURE__*/jsxs(Spacer, {
    xgap: "xxs",
    children: [/*#__PURE__*/jsx(ErrorIcon, {
      color: theme.color.interaction.error
    }), /*#__PURE__*/jsx(Text, {
      id: id,
      tag: "p",
      variant: "detail1",
      appearance: "error",
      display: "flex",
      children: text
    })]
  });
};

var TextField_1eb922c0_esm_HelpText = _ref => {
  var {
    id,
    text
  } = _ref;
  return /*#__PURE__*/jsx(Text, {
    id: id,
    tag: "p",
    variant: "detail2",
    appearance: "subtle",
    children: text
  });
};

var TextField_1eb922c0_esm_FieldLabel = _ref => {
  var {
    tag = 'label',
    label,
    labelSuffix,
    forId
  } = _ref;
  var LabelComponent = label;
  var props = {};
  if (tag === 'label') {
    props = {
      for: forId
    };
  }
  return /*#__PURE__*/jsxs(Text, _objectSpread2(_objectSpread2({
    variant: "subtitle2",
    tag: tag
  }, props), {}, {
    children: [typeof label === 'string' ? label : /*#__PURE__*/jsx(LabelComponent, {}), labelSuffix && " ".concat(labelSuffix)]
  }));
};

var _excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "value", "defaultValue", "onChange", "validationState", "label", "ariaLabel", "ariaLabelledBy", "labelSuffix", "inlineAction", "autoComplete", "placeholder", "helpText", "errorText", "isDisabled", "isRequired", "maxCharCount", "minCharCount", "width", "minWidth", "maxWidth"]));
var Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "TextField__Input",
  componentId: "lui__sc-1h9z42q-0"
})(["padding-left:", ";padding-right:", ";"], props => props.hasLeftItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16), props => props.hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TextField__Wrapper",
  componentId: "lui__sc-1h9z42q-1"
})(["position:relative;width:100%;"]);
var LeftIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TextField__LeftIcon",
  componentId: "lui__sc-1h9z42q-2"
})(["position:absolute;top:12px;left:12px;"]);
function TextFieldComponent(_ref, ref) {
  var {
      inputId,
      name,
      variant = 'text',
      value,
      defaultValue,
      onChange,
      validationState,
      label,
      ariaLabel,
      ariaLabelledBy,
      labelSuffix,
      inlineAction,
      autoComplete,
      placeholder,
      helpText,
      errorText,
      isDisabled,
      isRequired,
      maxCharCount,
      minCharCount,
      width = '100%',
      minWidth,
      maxWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var globalProps = filterGlobalProps(props);
  var {
    isCleared,
    handleChange,
    clearValue
  } = TextField_1eb922c0_esm_useClearAction(onChange, ref, value);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(TextField_1eb922c0_esm_FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(Wrapper, {
        children: [variant === 'email' && /*#__PURE__*/jsx(LeftIcon, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgEmail, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(Input, {
          id: inputElId,
          name: name,
          type: variant,
          placeholder: placeholder,
          validationState: validationState,
          value: value && isCleared ? '' : value,
          defaultValue: defaultValue,
          onChange: handleChange,
          ref: ref,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          autoComplete: variant === 'email' ? 'email' : autoComplete,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          hasLeftItem: variant === 'email',
          hasRightItem: !!inlineAction
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(TextField_1eb922c0_esm_ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(TextField_1eb922c0_esm_HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(TextField_1eb922c0_esm_ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var TextField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(TextFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/NumericField-a0185c7b.esm.js











/**
 * Remove invalid characters
 */
var removeInvalidChars = function removeInvalidChars(value) {
  if (value) {
    var reg = new RegExp("[^\\d.]", 'gi');
    return value.replace(reg, '');
  }
  return '';
};

/**
 * Remove group separator from value eg. 1,000 > 1000
 */
var removeSeparators = function removeSeparators(value) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var reg = new RegExp(escapeRegExp(separator), 'g');
  return value.replace(reg, '');
};

var NumericField_a0185c7b_esm_cleanNumericValue = _ref => {
  var {
    value,
    allowDecimal = false
  } = _ref;
  var groupSeparator = ',';
  var decimalSeparator = '.';
  var decimalsLimit = 2;
  var withoutSeparators = removeSeparators(value, groupSeparator);
  var withoutInvalidChars = removeInvalidChars(withoutSeparators);
  var valueOnly = withoutInvalidChars;

  // This is the part that takes care of trimming the decimals
  if (valueOnly.includes(decimalSeparator)) {
    var [int, decimals] = withoutInvalidChars.split(decimalSeparator);
    var trimmedDecimals = decimals ? decimals.slice(0, decimalsLimit) : decimals;
    var includeDecimals = allowDecimal ? "".concat(decimalSeparator).concat(trimmedDecimals) : '';
    return "".concat(int).concat(includeDecimals);
  }
  return valueOnly;
};

var NumericField_a0185c7b_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var NumericField_a0185c7b_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "NumericField__Input",
  componentId: "lui__sc-1xofghe-0"
})(["padding-left:", ";padding-right:", ";"], _ref => {
  var {
    variant
  } = _ref;
  return variant && variant === 'dollar' ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
}, _ref2 => {
  var {
    hasRightItem
  } = _ref2;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var NumericField_a0185c7b_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NumericField__Wrapper",
  componentId: "lui__sc-1xofghe-1"
})(["position:relative;width:100%;"]);
function NumericFieldComponent(_ref3, ref) {
  var {
      inputId,
      name,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      onValueChange,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref3,
    props = _objectWithoutProperties(_ref3, NumericField_a0185c7b_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var handleOnChange = event => {
    var valueOnly = NumericField_a0185c7b_esm_cleanNumericValue({
      value: event.target.value
    });
    event.target.value = valueOnly;
    onChange === null || onChange === void 0 || onChange(event);
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 || onValueChange(undefined, name);
      return;
    }
    onValueChange === null || onValueChange === void 0 || onValueChange(Number(valueOnly), name);
  };
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleOnChange, ref, value === null || value === void 0 ? void 0 : value.toString());
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(NumericField_a0185c7b_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(NumericField_a0185c7b_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: "[0-9]*",
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value && isCleared ? '' : value,
          defaultValue: defaultValue,
          onChange: handleChange,
          ref: ref,
          hasRightItem: !!inlineAction,
          inputMode: "numeric"
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var NumericField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(NumericFieldComponent)));



// EXTERNAL MODULE: ../../../node_modules/leading-zeroes/dist/index.js
var dist = __webpack_require__(41699);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/DateField-d2eb9fa7.esm.js






















var DateField_d2eb9fa7_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "isRequired", "isDisabled", "defaultValue", "value", "onChange", "width", "minWidth", "maxWidth", "minDate", "maxDate"]));
var DateField_d2eb9fa7_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "DateField__Input",
  componentId: "lui__sc-uzb5tf-0"
})(["--border-radius:", ";border-radius:0;&:first-of-type{border-radius:var(--border-radius) 0 0 var(--border-radius);}&:nth-of-type(2){border-left:none;}&:last-of-type{border-left:none;border-radius:0 var(--border-radius) var(--border-radius) 0;}&:focus-visible{box-shadow:none;}"], _ref => {
  var {
    theme
  } = _ref;
  return (0,dist_commons_esm/* getBorderRadius */.wK)({
    theme: theme.name
  });
});
var DateField_d2eb9fa7_esm_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(index_68cf36c7_esm.S).withConfig({
  displayName: "DateField__Wrapper",
  componentId: "lui__sc-uzb5tf-1"
})(["position:relative;"]);
var DateFieldsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DateField__DateFieldsWrapper",
  componentId: "lui__sc-uzb5tf-2"
})(["display:flex;border-radius:", ";box-shadow:", ";&:hover{", "{border-color:", ";}}"], _ref2 => {
  var {
    theme
  } = _ref2;
  return (0,dist_commons_esm/* getBorderRadius */.wK)({
    theme: theme.name
  });
}, props => props.isFocused && (0,dist_commons_esm/* getFocusRing */.yb)(), DateField_d2eb9fa7_esm_Input, _ref3 => {
  var {
    isDisabled,
    validationState,
    theme
  } = _ref3;
  if (isDisabled) {
    return theme.color.border.container;
  }
  if (validationState === 'invalid') {
    return theme.color.interaction.error;
  } else {
    return theme.color.border.interaction.hover;
  }
});

// Worth moving this when something else needs a fieldset/legend
// but for now its only one :)
var Fieldset = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
  displayName: "DateField__Fieldset",
  componentId: "lui__sc-uzb5tf-3"
})(["margin:0;padding:0;border:none;legend{margin-bottom:", ";}"], (0,commons_esm/* pxToRem */.Q1)(8));
var filterAlphabet = value => value.replace(/\D*/g, '');
function DateFieldComponent(_ref4, ref) {
  var {
      inputId,
      name,
      variant = 'daymonthyear',
      helpText,
      errorText,
      validationState,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      isRequired,
      isDisabled,
      defaultValue,
      value,
      onChange,
      width = '100%',
      minWidth,
      maxWidth,
      minDate,
      maxDate
    } = _ref4,
    props = _objectWithoutProperties(_ref4, DateField_d2eb9fa7_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var [isFocused, setIsFocused] = useState(false);
  var [day, setDay] = useState('');
  var [month, setMonth] = useState('');
  var [year, setYear] = useState('');
  var [fullDate, setFullDate] = useState('');
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var hasFullDate = fullDate.length > 0;
  var inputRef = ref;
  var yearRef = useRef(null);
  var getRealMonth = dateObject => getMonth(dateObject) + 1;
  var applyDateToState = date => {
    var dateObject = toDate(date);
    if (dateIsValid(dateObject)) {
      setDay(leadingZeroes(getDate(dateObject).toString(), 2));
      setMonth(leadingZeroes(getRealMonth(dateObject).toString(), 2));
      setYear(getYear(dateObject).toString());
    }
  };
  // Used only to initialise the fields with default values
  useEffect(() => {
    var defaultDate = value !== null && value !== void 0 ? value : defaultValue;
    if (defaultDate) {
      applyDateToState(defaultDate);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Manage when to update the full date
  useEffect(() => {
    if (day && month && year) {
      setFullDate("".concat(year, "-").concat(month, "-").concat(day));
    }
  }, [day, month, year]);

  // Manage reporting the full date string & other details back to the consumer:
  // This effectively is a fake onChange handler in place of the lack of a real onChange given the management of 3 different input fields.
  useEffect(() => {
    if (onChange && hasFullDate) {
      // Because I'm doing this outside of a real change event, I have created a fakeEvent to send back to consumer
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      var fakeEvent = {
        target: {
          value: fullDate,
          validity: getValidity(fullDate)
        }
        // using `as` here to bypass typescript's requirements to add missing values in the real event object
      };
      onChange(fakeEvent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFullDate, fullDate]);
  var getValidity = fullDate => {
    var validity = {
      patternMismatch: false,
      rangeOverflow: false,
      rangeUnderflow: false
    };
    if (day.length !== 2 && month.length !== 2 && year.length !== 4) {
      validity.patternMismatch = true;
      return validity;
    }
    var dateInput = toDate(new Date(fullDate));

    // dateIsValid handles dates which exceed days in a month etc.
    if (dateIsValid(dateInput)) {
      var minDateObject = minDate && toDate(minDate);
      var maxDateObject = maxDate && toDate(maxDate);
      var dateIsBeforeIsBeforeMinDate = minDateObject && isBefore(dateInput, minDateObject);
      var dateIsAfterMaxDate = maxDateObject && isAfter(dateInput, maxDateObject);
      if (dateIsBeforeIsBeforeMinDate) {
        validity.rangeUnderflow = true;
        inputRef === null || inputRef === void 0 || inputRef.current.setCustomValidity('You have entered a date before the accepted minimum date');
      }
      if (dateIsAfterMaxDate) {
        validity.rangeOverflow = true;
        inputRef === null || inputRef === void 0 || inputRef.current.setCustomValidity('You have exceeded the number of days in this month');
      }
    } else {
      validity.patternMismatch = true;
    }
    return validity;
  };
  var handleChange = type => e => {
    // Ensures there's no alphabet in the inputs
    if (e.target.value !== '') {
      e.target.value = filterAlphabet(e.target.value);
    }
    if (type === 'day') setDay(e.target.value);
    if (type === 'month') setMonth(e.target.value);
    if (type === 'year') setYear(e.target.value);
  };
  var handleOnPaste = e => {
    e.clipboardData.items[0].getAsString(text => {
      // Only really supporting the Queen's date format here
      var parsedDate = text && dateParse(text, 'dd/MM/yyyy', new Date());
      if (parsedDate && dateIsValid(parsedDate)) {
        var _yearRef$current;
        applyDateToState(parsedDate);
        // Once we apply the date to the state, we shift the user to the year input
        // to create the affect of having entered the date manually, and to provide
        // a better flow
        yearRef === null || yearRef === void 0 || (_yearRef$current = yearRef.current) === null || _yearRef$current === void 0 || _yearRef$current.focus();
      }
    });
  };
  var onFocusHandler = () => !isFocused && setIsFocused(true);
  var onBlurHandler = () => isFocused && setIsFocused(false);
  var showDayField = variant === 'daymonthyear';
  var showMonthField = variant === 'daymonthyear' || variant === 'monthyear';
  var showYearField = variant === 'daymonthyear' || variant === 'monthyear';
  return /*#__PURE__*/jsx(Spacer, _objectSpread2(_objectSpread2({
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: /*#__PURE__*/jsxs(Fieldset, {
      disabled: isDisabled,
      children: [label && /*#__PURE__*/jsxs("legend", {
        children: [/*#__PURE__*/jsx(FieldLabel, {
          forId: "",
          tag: "span",
          label: label,
          labelSuffix: labelSuffix
        }), helpText && /*#__PURE__*/jsx("span", {
          className: "sr-only",
          children: helpText
        }), hasError && errorText && /*#__PURE__*/jsx("span", {
          className: "sr-only",
          children: errorText
        })]
      }), /*#__PURE__*/jsxs(DateField_d2eb9fa7_esm_Wrapper, {
        ygap: "xxs",
        children: [/*#__PURE__*/jsx("input", {
          type: "text",
          value: fullDate,
          ref: inputRef,
          "aria-disabled": true,
          "aria-hidden": true,
          hidden: true,
          disabled: true,
          readOnly: true
        }), /*#__PURE__*/jsxs(DateFieldsWrapper, {
          isFocused: isFocused,
          isDisabled: isDisabled,
          validationState: validationState,
          children: [showDayField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-day"),
                label: "Day"
              })
            }), /*#__PURE__*/jsx(DateField_d2eb9fa7_esm_Input, {
              id: "".concat(inputElId, "-day"),
              placeholder: "DD",
              inputMode: "numeric",
              pattern: "[0-9]{2}",
              minLength: 2,
              maxLength: 2,
              validationState: validationState,
              value: day,
              required: isRequired,
              onChange: handleChange('day'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-day"
            })]
          }), showMonthField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-month"),
                label: "Month"
              })
            }), /*#__PURE__*/jsx(DateField_d2eb9fa7_esm_Input, {
              id: "".concat(inputElId, "-month"),
              placeholder: "MM",
              inputMode: "numeric",
              pattern: "[0-9]{2}",
              minLength: 2,
              maxLength: 2,
              validationState: validationState,
              value: month,
              required: isRequired,
              onChange: handleChange('month'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-month"
            })]
          }), showYearField && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: /*#__PURE__*/jsx(FieldLabel, {
                forId: "".concat(inputElId, "-year"),
                label: "Year"
              })
            }), /*#__PURE__*/jsx(DateField_d2eb9fa7_esm_Input, {
              id: "".concat(inputElId, "-year"),
              placeholder: "YYYY",
              inputMode: "numeric",
              pattern: "[0-9]{4}",
              minLength: 4,
              maxLength: 4,
              validationState: validationState,
              value: year,
              required: isRequired,
              onChange: handleChange('year'),
              onFocus: onFocusHandler,
              onBlur: onBlurHandler,
              onPaste: handleOnPaste,
              autoComplete: "bday-year",
              ref: yearRef
            })]
          })]
        }), helpText && /*#__PURE__*/jsx("div", {
          "aria-hidden": "true",
          children: /*#__PURE__*/jsx(HelpText, {
            id: helpTextId,
            text: helpText
          })
        }), hasError && errorText && /*#__PURE__*/jsx("div", {
          "aria-hidden": "true",
          children: /*#__PURE__*/jsx(ErrorText, {
            id: errorTextId,
            text: errorText
          })
        })]
      })]
    })
  }));
}
var DateField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(DateFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/helpers-5a181519.esm.js

















/**
 * This is a 100% duplicate of `@lendi-ui/icon/Call`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgAttachMoney(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var formatToCurrency = _value => {
  var _value$match;
  var decimalSeparator = '.';
  if (_value === '' || _value === undefined) {
    return '';
  }
  var value = _value;

  // This is somewhat of an overkill way to do currency formatting,
  // but it covers some interesting edge cases like if there's a decimal number (123.10)
  // and you delete the 123, it will magically replace it with a 0 to ensure proper format (0.10)
  var numberFormatter = new Intl.NumberFormat('en-AU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20
  });
  var formatted = numberFormatter.format(Number(value));

  // Include decimal separator if user input ends with decimal separator
  var includeDecimalSeparator = _value.slice(-1) === decimalSeparator ? decimalSeparator : '';
  var [, decimals] = (_value$match = value.match(RegExp('\\d+\\.(\\d+)'))) !== null && _value$match !== void 0 ? _value$match : [];

  // Keep original decimal padding if no decimalScale
  if (decimals && decimalSeparator) {
    if (formatted.includes(decimalSeparator)) {
      formatted = formatted.replace(RegExp("(\\d+)(".concat(escapeRegExp(decimalSeparator), ")(\\d+)"), 'g'), "$1$2".concat(decimals));
    } else {
      formatted = "".concat(formatted).concat(decimalSeparator).concat(decimals);
    }
  }
  return [formatted, includeDecimalSeparator].join('');
};

var padTrimValue = function padTrimValue(value) {
  var decimalSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var decimalScale = 2;
  if (value === '' || value === undefined || !value.includes(decimalSeparator)) {
    return value;
  }
  if (!value.match(/\d/g)) {
    return '';
  }
  var [int, decimals] = value.split(decimalSeparator);
  var newValue = decimals || '';
  if (newValue.length < decimalScale) {
    while (newValue.length < decimalScale) {
      newValue += '0';
    }
  } else {
    newValue = newValue.slice(0, decimalScale);
  }
  return "".concat(int).concat(decimalSeparator).concat(newValue);
};

var helpers_5a181519_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "onBlur", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var helpers_5a181519_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "DollarField__Input",
  componentId: "lui__sc-1g3sog3-0"
})(["padding-left:", ";padding-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(46), _ref => {
  var {
    hasRightItem
  } = _ref;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var helpers_5a181519_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DollarField__Wrapper",
  componentId: "lui__sc-1g3sog3-1"
})(["position:relative;width:100%;"]);
var LeftInputFieldIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DollarField__LeftInputFieldIconWrapper",
  componentId: "lui__sc-1g3sog3-2"
})(["position:absolute;top:12px;left:12px;"]);
function DollarFieldComponent(_ref2, ref) {
  var {
      inputId,
      name,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value: userValue,
      defaultValue,
      onChange,
      onValueChange,
      onBlur,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref2,
    props = _objectWithoutProperties(_ref2, helpers_5a181519_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();

  // This is of course against hook rules, but in order for cursor tracking to work,
  // we must always have a valid ref to the input available
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var inputRef = ref !== null && ref !== void 0 ? ref : useRef(null);
  var initialStateValue = defaultValue !== undefined ? formatToCurrency(String(defaultValue)) : userValue !== undefined ? formatToCurrency(String(userValue)) : '';
  var [stateValue, setStateValue] = useState(initialStateValue);
  var [dirty, setDirty] = useState(false);
  var [cursor, setCursor] = useState(0);
  var processValue = (value, selectionStart, name) => {
    setDirty(true);
    var valueOnly = cleanNumericValue({
      value,
      allowDecimal: true
    });
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 || onValueChange(undefined, name);
      setStateValue('');
      return;
    }
    if (maxCharCount && valueOnly.length > maxCharCount) {
      return;
    }
    if (valueOnly === '.') {
      onValueChange === null || onValueChange === void 0 || onValueChange(undefined, name);
      setStateValue(valueOnly);
      return;
    }
    var formatted = formatToCurrency(valueOnly);
    if (selectionStart !== undefined && selectionStart !== null) {
      // Prevent cursor jumping
      var newCursor = selectionStart + (formatted.length - value.length) || 0;
      var isNegative = Math.sign(newCursor) < 0;
      setCursor(isNegative ? 0 : newCursor);
    }
    setStateValue(formatted);
    onValueChange === null || onValueChange === void 0 || onValueChange(valueOnly, name);
  };
  var handleOnChange = event => {
    event.persist();
    var {
      target: {
        value,
        selectionStart
      }
    } = event;
    processValue(value, selectionStart);
    onChange === null || onChange === void 0 || onChange(event);
  };
  var handleOnKeyUp = event => {
    var {
      key,
      currentTarget: {
        selectionStart
      }
    } = event;
    if (key !== 'ArrowUp' && key !== 'ArrowDown') {
      if (selectionStart && selectionStart > stateValue.length) {
        if (inputRef && typeof inputRef === 'object' && inputRef.current) {
          var newCursor = stateValue.length;
          inputRef.current.setSelectionRange(newCursor, newCursor);
        }
      }
    }
  };
  var handleOnFocus = event => {
    return stateValue ? stateValue.length : 0;
  };
  var handleOnBlur = event => {
    event.persist();
    var {
      target: {
        value
      }
    } = event;
    if (value) {
      var valueOnly = cleanNumericValue({
        value,
        allowDecimal: true
      });
      if (!valueOnly) {
        setStateValue('');
        return;
      }
      var paddedDecimalsValue = padTrimValue(valueOnly);
      onValueChange === null || onValueChange === void 0 || onValueChange(paddedDecimalsValue, name);
      var formattedValue = formatToCurrency(paddedDecimalsValue);
      setStateValue(formattedValue);
    }
    onBlur === null || onBlur === void 0 || onBlur(event);
  };
  useEffect(() => {
    // prevent cursor jumping if editing value
    if (dirty && inputRef && typeof inputRef === 'object' && inputRef.current) {
      inputRef.current.setSelectionRange(cursor, cursor);
    }
  }, [stateValue, cursor, inputRef, dirty]);
  var formattedPropsValue = userValue !== undefined ? formatToCurrency(String(userValue)) : undefined;
  var inputValue = formattedPropsValue !== undefined && stateValue !== '.' ? formattedPropsValue : stateValue;
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleOnChange, inputRef, inputValue);
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: validationState === 'invalid' ? 'xxs' : 'xs',
      children: [/*#__PURE__*/jsxs(helpers_5a181519_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(LeftInputFieldIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgAttachMoney, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(helpers_5a181519_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: "[0-9,.]*",
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          onBlur: handleOnBlur,
          onKeyUp: handleOnKeyUp,
          onFocus: handleOnFocus,
          value: inputValue && isCleared ? '' : inputValue,
          onChange: handleChange,
          hasRightItem: !!inlineAction,
          inputMode: "decimal",
          ref: inputRef
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var DollarField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(DollarFieldComponent)));

var dollarToNumber = dollar => parseFloat(dollar === null || dollar === void 0 ? void 0 : dollar.replace(',', ''));



;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/PhoneField-84d15182.esm.js

















/**
 * This is a 100% duplicate of `@lendi-ui/icon/Call`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgCall(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      })]
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/icon/PhoneAndroid`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgPhoneAndroid(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var PhoneField_84d15182_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PhoneFieldstyle__Wrapper",
  componentId: "lui__sc-c2e1lq-0"
})(["position:relative;width:100%;"]);
var PhoneField_84d15182_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "PhoneFieldstyle__Input",
  componentId: "lui__sc-c2e1lq-1"
})(["padding-left:", ";padding-right:", ";"], (0,commons_esm/* pxToRem */.Q1)(46), _ref => {
  var {
    hasRightItem
  } = _ref;
  return hasRightItem ? (0,commons_esm/* pxToRem */.Q1)(46) : (0,commons_esm/* pxToRem */.Q1)(16);
});
var PhoneIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "PhoneFieldstyle__PhoneIconWrapper",
  componentId: "lui__sc-c2e1lq-2"
})(["position:absolute;top:", ";left:", ";"], (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(12));
var MobileIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "PhoneFieldstyle__MobileIconWrapper",
  componentId: "lui__sc-c2e1lq-3"
})(["position:absolute;top:", ";left:", ";"], (0,commons_esm/* pxToRem */.Q1)(12), (0,commons_esm/* pxToRem */.Q1)(12));

var getPattern = variant => {
  switch (variant) {
    case 'mobile':
      return "^04{1}[0-9]{2}[0-9]{3}[0-9]{3}$";
    default:
      return "^0{1}[2378]{1}[0-9]{4}[0-9]{4}$";
  }
};

var PhoneField_84d15182_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "width", "maxCharCount", "minCharCount", "minWidth", "maxWidth"]));
var PhoneField_84d15182_esm_filterAlphabet = value => value.replace(/\D*/g, '');
var handleFormatting = value => {
  // because we handle uncontrolled, this function could receive undefined.
  if (value) {
    return PhoneField_84d15182_esm_filterAlphabet(value);
  }
  return value;
};
var PhoneFieldComponent = (_ref, ref) => {
  var {
      inputId,
      name,
      variant,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      width = '100%',
      maxCharCount,
      minCharCount,
      minWidth,
      maxWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, PhoneField_84d15182_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();
  var handleValueChange = e => {
    if (e.target.value !== '') {
      var _handleFormatting;
      e.target.value = (_handleFormatting = handleFormatting(e.target.value)) !== null && _handleFormatting !== void 0 ? _handleFormatting : '';
    }
    if (onChange) {
      onChange(e);
    }
  };
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleValueChange, ref, value);
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(PhoneField_84d15182_esm_Wrapper, {
        children: [variant === 'mobile' ? /*#__PURE__*/jsx(MobileIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgPhoneAndroid, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }) : /*#__PURE__*/jsx(PhoneIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgCall, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(PhoneField_84d15182_esm_Input, {
          id: inputElId,
          name: name,
          type: "tel",
          autoComplete: "tel",
          inputMode: "tel",
          pattern: getPattern(variant),
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value && isCleared ? '' : handleFormatting(value),
          defaultValue: handleFormatting(defaultValue),
          onChange: handleChange,
          ref: ref,
          hasRightItem: !!inlineAction,
          variant: variant
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
};
var PhoneField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(PhoneFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/UnitField-2cdbe130.esm.js














var UnitField_2cdbe130_esm_excluded = (/* unused pure expression or super */ null && (["inputId", "name", "variant", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "onValueChange", "width", "minWidth", "maxWidth", "maxCharCount", "minCharCount"]));
var getPaddingRight = variant => {
  switch (variant) {
    case 'age':
      return 98;
    case 'years':
      return 70;
    case 'months':
      return 86;
    case 'days':
      return 62;
    case 'percent':
      return 42;
  }
};
var UnitField_2cdbe130_esm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).withConfig({
  displayName: "UnitField__Input",
  componentId: "lui__sc-1ywqqq4-0"
})(["padding-right:", ";"], props => "".concat(getPaddingRight(props.variant), "px"));
var UnitLabelWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "UnitField__UnitLabelWrapper",
  componentId: "lui__sc-1ywqqq4-1"
})(["position:absolute;right:1rem;top:50%;transform:translateY(-50%);"]);
var UnitField_2cdbe130_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "UnitField__Wrapper",
  componentId: "lui__sc-1ywqqq4-2"
})(["position:relative;width:100%;"]);
var getVariantLabel = variant => {
  switch (variant) {
    case 'age':
      return 'years old';
    case 'percent':
      return '%';
    default:
      return variant;
  }
};
var UnitLabel = _ref => {
  var {
    variant
  } = _ref;
  return /*#__PURE__*/jsx(UnitLabelWrapper, {
    "aria-hidden": "true",
    children: /*#__PURE__*/jsx(Text, {
      variant: "subtitle1",
      tag: "span",
      appearance: "subtle",
      children: getVariantLabel(variant)
    })
  });
};
function UnitFieldComponent(_ref2, ref) {
  var {
      inputId,
      name,
      variant,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label: _label,
      labelSuffix,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      onValueChange,
      width = '100%',
      minWidth,
      maxWidth,
      maxCharCount,
      minCharCount
    } = _ref2,
    props = _objectWithoutProperties(_ref2, UnitField_2cdbe130_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  var handleOnChange = event => {
    var valueOnly = cleanNumericValue({
      value: event.target.value,
      allowDecimal: variant === 'percent'
    });
    var [, hasDecimals] = valueOnly.split('.');
    event.target.value = valueOnly;
    onChange === null || onChange === void 0 || onChange(event);
    if (valueOnly === '') {
      onValueChange === null || onValueChange === void 0 || onValueChange(undefined, name);
      return;
    }
    if (valueOnly === '.') {
      onValueChange === null || onValueChange === void 0 || onValueChange(undefined, name);
      return;
    }
    if (hasDecimals) {
      onValueChange === null || onValueChange === void 0 || onValueChange(parseFloat(valueOnly), name);
      return;
    }
    onValueChange === null || onValueChange === void 0 || onValueChange(Number(valueOnly), name);
  };
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [_label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: () => /*#__PURE__*/jsxs(Fragment, {
        children: [_label, /*#__PURE__*/jsx(VisuallyHidden, {
          children: "(".concat(getVariantLabel(variant), ")")
        })]
      }),
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(UnitField_2cdbe130_esm_Wrapper, {
        children: [/*#__PURE__*/jsx(UnitField_2cdbe130_esm_Input, {
          id: inputElId,
          name: name,
          type: "text",
          pattern: variant === 'percent' ? '[0-9.]*' : '[0-9]*',
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value,
          defaultValue: defaultValue,
          onChange: handleOnChange,
          ref: ref,
          inputMode: variant === 'percent' ? 'decimal' : 'numeric',
          variant: variant
        }), /*#__PURE__*/jsx(UnitLabel, {
          variant: variant
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var UnitField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(UnitFieldComponent)));



;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/SelectField-16c714ea.esm.js
















/**
 * This is a 100% duplicate of `@lendi-ui/icon/KeyboardArrowDown`.
 *
 * It is used in LUI Next SelectField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgKeyboardArrowDown(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_style_741fda20_esm.I, (0,index_c76be973_esm._)((0,index_c76be973_esm._)({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0-.75h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var SelectField_16c714ea_esm_excluded = (/* unused pure expression or super */ null && (["name", "inputId", "validationState", "helpText", "errorText", "placeholder", "label", "ariaLabel", "ariaLabelledBy", "labelSuffix", "isRequired", "isDisabled", "width", "minWidth", "maxWidth", "options", "onChange", "defaultValue", "value"]));
// TODO: if placeholder is active, color should be 600
// prettier-ignore
var Select = (0,styled_components_browser_esm/* default */.ZP)(InputBaseComponent).attrs({
  as: 'select'
}).withConfig({
  displayName: "SelectField__Select",
  componentId: "lui__sc-bl1fdz-0"
})(["appearance:none;display:flex;align-items:center;padding-top:0;padding-bottom:0;padding-right:40px;color:", ";&:disabled{color:", ";}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.subtle;
});
var Arrow = (0,styled_components_browser_esm/* default */.ZP)(SvgKeyboardArrowDown).withConfig({
  displayName: "SelectField__Arrow",
  componentId: "lui__sc-bl1fdz-1"
})(["position:absolute;right:0.75em;top:50%;margin-top:calc(-0.75em + 1px);width:1.5em;height:1.5em;pointer-events:none;"]);
var SelectField_16c714ea_esm_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectField__Wrapper",
  componentId: "lui__sc-bl1fdz-2"
})(["position:relative;width:100%;"]);
function SelectFieldComponent(_ref3, ref) {
  var {
      name,
      inputId,
      validationState,
      helpText,
      errorText,
      placeholder,
      label,
      ariaLabel,
      ariaLabelledBy,
      labelSuffix,
      isRequired,
      isDisabled,
      width = '100%',
      minWidth,
      maxWidth,
      options,
      onChange,
      defaultValue,
      value
    } = _ref3,
    props = _objectWithoutProperties(_ref3, SelectField_16c714ea_esm_excluded);
  var globalProps = filterGlobalProps(props);
  var selectElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var hasNoValue = defaultValue === undefined && value === undefined;
  var theme = useTheme();
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: selectElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(SelectField_16c714ea_esm_Wrapper, {
        children: [/*#__PURE__*/jsxs(Select, {
          name: name,
          id: selectElId,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          onChange: onChange,
          value: onChange && hasNoValue && placeholder ? '' : value,
          defaultValue: !onChange && hasNoValue && placeholder ? '' : defaultValue,
          ref: ref,
          placeholder: placeholder,
          children: [placeholder && /*#__PURE__*/jsx("option", {
            value: "",
            disabled: true,
            hidden: true,
            children: placeholder
          }), options.length > 0 && options.map(option => {
            if ('value' in option) {
              if (option.value === '') {
                throw new Error('value cannot be an empty string');
              }
              return /*#__PURE__*/jsx("option", {
                value: option.value,
                children: option.label
              }, option.value);
            } else if ('header' in option) {
              return /*#__PURE__*/jsx("optgroup", {
                label: option.header,
                children: option.options.map(option => /*#__PURE__*/jsx("option", {
                  value: option.value,
                  children: option.label
                }, option.value))
              }, option.header);
            }
            return null;
          })]
        }), /*#__PURE__*/jsx(Arrow, {
          "aria-hidden": "true",
          color: isDisabled ? theme.color.interaction.disabled : theme.color.interaction.contrast
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
}
var SelectField = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SelectFieldComponent)));



// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/typography/dist/commons.esm.js
var typography_dist_commons_esm = __webpack_require__(70757);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/depth/dist/commons.esm.js
var depth_dist_commons_esm = __webpack_require__(46706);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/ui/dist/ui.esm.js






































/***/ }),

/***/ 1596:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
function composeRefs() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    if (refs.length === 2) { // micro-optimize the hot path
        return composeTwoRefs(refs[0], refs[1]) || null;
    }
    var composedRef = refs.slice(1).reduce(function (semiCombinedRef, refToInclude) { return composeTwoRefs(semiCombinedRef, refToInclude); }, refs[0]);
    return composedRef || null;
}
exports.Z = composeRefs;
var composedRefCache = new WeakMap();
function composeTwoRefs(ref1, ref2) {
    if (ref1 && ref2) {
        var ref1Cache = composedRefCache.get(ref1) || new WeakMap();
        composedRefCache.set(ref1, ref1Cache);
        var composedRef = ref1Cache.get(ref2) || (function (instance) {
            updateRef(ref1, instance);
            updateRef(ref2, instance);
        });
        ref1Cache.set(ref2, composedRef);
        return composedRef;
    }
    if (!ref1) {
        return ref2;
    }
    else {
        return ref1;
    }
}
function updateRef(ref, instance) {
    if (typeof ref === 'function') {
        ref(instance);
    }
    else {
        ref.current = instance;
    }
}
//# sourceMappingURL=composeRefs.js.map

/***/ }),

/***/ 82390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* binding */ configure; },
  "BX": function() { return /* binding */ fireEvent; }
});

// UNUSED EXPORTS: buildQueries, createEvent, findAllByAltText, findAllByDisplayValue, findAllByLabelText, findAllByPlaceholderText, findAllByRole, findAllByTestId, findAllByText, findAllByTitle, findByAltText, findByDisplayValue, findByLabelText, findByPlaceholderText, findByRole, findByTestId, findByText, findByTitle, getAllByAltText, getAllByDisplayValue, getAllByLabelText, getAllByPlaceholderText, getAllByRole, getAllByTestId, getAllByText, getAllByTitle, getByAltText, getByDisplayValue, getByLabelText, getByPlaceholderText, getByRole, getByTestId, getByText, getByTitle, getConfig, getDefaultNormalizer, getElementError, getMultipleElementsFoundError, getNodeText, getQueriesForElement, getRoles, getSuggestedQuery, isInaccessible, logDOM, logRoles, makeFindQuery, makeGetAllQuery, makeSingleQuery, prettyDOM, prettyFormat, queries, queryAllByAltText, queryAllByAttribute, queryAllByDisplayValue, queryAllByLabelText, queryAllByPlaceholderText, queryAllByRole, queryAllByTestId, queryAllByText, queryAllByTitle, queryByAltText, queryByAttribute, queryByDisplayValue, queryByLabelText, queryByPlaceholderText, queryByRole, queryByTestId, queryByText, queryByTitle, queryHelpers, screen, waitFor, waitForElementToBeRemoved, within, wrapAllByQueryWithSuggestion, wrapSingleQueryWithSuggestion

// EXTERNAL MODULE: ../../../node_modules/@testing-library/dom/node_modules/pretty-format/build/index.js
var build = __webpack_require__(57739);
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/polyfills/array.from.mjs
/**
 * @source {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill}
 * but without thisArg (too hard to type, no need to `this`)
 */
var toStr = Object.prototype.toString;
function isCallable(fn) {
  return typeof fn === "function" || toStr.call(fn) === "[object Function]";
}
function toInteger(value) {
  var number = Number(value);
  if (isNaN(number)) {
    return 0;
  }
  if (number === 0 || !isFinite(number)) {
    return number;
  }
  return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(value) {
  var len = toInteger(value);
  return Math.min(Math.max(len, 0), maxSafeInteger);
}
/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 */

/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 * @param mapfn A mapping function to call on every element of the array.
 * @param thisArg Value of 'this' used to invoke the mapfn.
 */
function arrayFrom(arrayLike, mapFn) {
  // 1. Let C be the this value.
  // edit(@eps1lon): we're not calling it as Array.from
  var C = Array;

  // 2. Let items be ToObject(arrayLike).
  var items = Object(arrayLike);

  // 3. ReturnIfAbrupt(items).
  if (arrayLike == null) {
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  }

  // 4. If mapfn is undefined, then let mapping be false.
  // const mapFn = arguments.length > 1 ? arguments[1] : void undefined;

  if (typeof mapFn !== "undefined") {
    // 5. else
    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
    if (!isCallable(mapFn)) {
      throw new TypeError("Array.from: when provided, the second argument must be a function");
    }
  }

  // 10. Let lenValue be Get(items, "length").
  // 11. Let len be ToLength(lenValue).
  var len = toLength(items.length);

  // 13. If IsConstructor(C) is true, then
  // 13. a. Let A be the result of calling the [[Construct]] internal method
  // of C with an argument list containing the single item len.
  // 14. a. Else, Let A be ArrayCreate(len).
  var A = isCallable(C) ? Object(new C(len)) : new Array(len);

  // 16. Let k be 0.
  var k = 0;
  // 17. Repeat, while k < len… (also steps a - h)
  var kValue;
  while (k < len) {
    kValue = items[k];
    if (mapFn) {
      A[k] = mapFn(kValue, k);
    } else {
      A[k] = kValue;
    }
    k += 1;
  }
  // 18. Let putStatus be Put(A, "length", len, true).
  A.length = len;
  // 20. Return A.
  return A;
}
//# sourceMappingURL=array.from.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/polyfills/SetLike.mjs
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// for environments without Set we fallback to arrays with unique members
var SetLike = /*#__PURE__*/function () {
  function SetLike() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, SetLike);
    _defineProperty(this, "items", void 0);
    this.items = items;
  }
  _createClass(SetLike, [{
    key: "add",
    value: function add(value) {
      if (this.has(value) === false) {
        this.items.push(value);
      }
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      var previousLength = this.items.length;
      this.items = this.items.filter(function (item) {
        return item !== value;
      });
      return previousLength !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn) {
      var _this = this;
      this.items.forEach(function (item) {
        callbackfn(item, item, _this);
      });
    }
  }, {
    key: "has",
    value: function has(value) {
      return this.items.indexOf(value) !== -1;
    }
  }, {
    key: "size",
    get: function get() {
      return this.items.length;
    }
  }]);
  return SetLike;
}();
/* harmony default export */ var polyfills_SetLike = (typeof Set === "undefined" ? Set : SetLike);
//# sourceMappingURL=SetLike.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/getRole.mjs
// https://w3c.github.io/html-aria/#document-conformance-requirements-for-use-of-aria-attributes-in-html

/**
 * Safe Element.localName for all supported environments
 * @param element
 */
function getLocalName(element) {
  var _element$localName;
  return (// eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName :
    // eslint-disable-next-line no-restricted-properties -- required for the fallback
    element.tagName.toLowerCase()
  );
}
var localNameToRoleMappings = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
};
var prohibitedAttributes = {
  caption: new Set(["aria-label", "aria-labelledby"]),
  code: new Set(["aria-label", "aria-labelledby"]),
  deletion: new Set(["aria-label", "aria-labelledby"]),
  emphasis: new Set(["aria-label", "aria-labelledby"]),
  generic: new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: new Set(["aria-label", "aria-labelledby"]),
  paragraph: new Set(["aria-label", "aria-labelledby"]),
  presentation: new Set(["aria-label", "aria-labelledby"]),
  strong: new Set(["aria-label", "aria-labelledby"]),
  subscript: new Set(["aria-label", "aria-labelledby"]),
  superscript: new Set(["aria-label", "aria-labelledby"])
};

/**
 *
 * @param element
 * @param role The role used for this element. This is specified to control whether you want to use the implicit or explicit role.
 */
function hasGlobalAriaAttributes(element, role) {
  // https://rawgit.com/w3c/aria/stable/#global_states
  // commented attributes are deprecated
  return ["aria-atomic", "aria-busy", "aria-controls", "aria-current", "aria-describedby", "aria-details",
  // "disabled",
  "aria-dropeffect",
  // "errormessage",
  "aria-flowto", "aria-grabbed",
  // "haspopup",
  "aria-hidden",
  // "invalid",
  "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-live", "aria-owns", "aria-relevant", "aria-roledescription"].some(function (attributeName) {
    var _prohibitedAttributes;
    return element.hasAttribute(attributeName) && !((_prohibitedAttributes = prohibitedAttributes[role]) !== null && _prohibitedAttributes !== void 0 && _prohibitedAttributes.has(attributeName));
  });
}
function ignorePresentationalRole(element, implicitRole) {
  // https://rawgit.com/w3c/aria/stable/#conflict_resolution_presentation_none
  return hasGlobalAriaAttributes(element, implicitRole);
}
function getRole(element) {
  var explicitRole = getExplicitRole(element);
  if (explicitRole === null || explicitRole === "presentation") {
    var implicitRole = getImplicitRole(element);
    if (explicitRole !== "presentation" || ignorePresentationalRole(element, implicitRole || "")) {
      return implicitRole;
    }
  }
  return explicitRole;
}
function getImplicitRole(element) {
  var mappedByTag = localNameToRoleMappings[getLocalName(element)];
  if (mappedByTag !== undefined) {
    return mappedByTag;
  }
  switch (getLocalName(element)) {
    case "a":
    case "area":
    case "link":
      if (element.hasAttribute("href")) {
        return "link";
      }
      break;
    case "img":
      if (element.getAttribute("alt") === "" && !ignorePresentationalRole(element, "img")) {
        return "presentation";
      }
      return "img";
    case "input":
      {
        var _ref = element,
          type = _ref.type;
        switch (type) {
          case "button":
          case "image":
          case "reset":
          case "submit":
            return "button";
          case "checkbox":
          case "radio":
            return type;
          case "range":
            return "slider";
          case "email":
          case "tel":
          case "text":
          case "url":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "textbox";
          case "search":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "searchbox";
          case "number":
            return "spinbutton";
          default:
            return null;
        }
      }
    case "select":
      if (element.hasAttribute("multiple") || element.size > 1) {
        return "listbox";
      }
      return "combobox";
  }
  return null;
}
function getExplicitRole(element) {
  var role = element.getAttribute("role");
  if (role !== null) {
    var explicitRole = role.trim().split(" ")[0];
    // String.prototype.split(sep, limit) will always return an array with at least one member
    // as long as limit is either undefined or > 0
    if (explicitRole.length > 0) {
      return explicitRole;
    }
  }
  return null;
}
//# sourceMappingURL=getRole.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/util.mjs


function isElement(node) {
  return node !== null && node.nodeType === node.ELEMENT_NODE;
}
function isHTMLTableCaptionElement(node) {
  return isElement(node) && getLocalName(node) === "caption";
}
function isHTMLInputElement(node) {
  return isElement(node) && getLocalName(node) === "input";
}
function isHTMLOptGroupElement(node) {
  return isElement(node) && getLocalName(node) === "optgroup";
}
function isHTMLSelectElement(node) {
  return isElement(node) && getLocalName(node) === "select";
}
function isHTMLTableElement(node) {
  return isElement(node) && getLocalName(node) === "table";
}
function isHTMLTextAreaElement(node) {
  return isElement(node) && getLocalName(node) === "textarea";
}
function safeWindow(node) {
  var _ref = node.ownerDocument === null ? node : node.ownerDocument,
    defaultView = _ref.defaultView;
  if (defaultView === null) {
    throw new TypeError("no window available");
  }
  return defaultView;
}
function isHTMLFieldSetElement(node) {
  return isElement(node) && getLocalName(node) === "fieldset";
}
function isHTMLLegendElement(node) {
  return isElement(node) && getLocalName(node) === "legend";
}
function isHTMLSlotElement(node) {
  return isElement(node) && getLocalName(node) === "slot";
}
function isSVGElement(node) {
  return isElement(node) && node.ownerSVGElement !== undefined;
}
function isSVGSVGElement(node) {
  return isElement(node) && getLocalName(node) === "svg";
}
function isSVGTitleElement(node) {
  return isSVGElement(node) && getLocalName(node) === "title";
}

/**
 *
 * @param {Node} node -
 * @param {string} attributeName -
 * @returns {Element[]} -
 */
function queryIdRefs(node, attributeName) {
  if (isElement(node) && node.hasAttribute(attributeName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
    var ids = node.getAttribute(attributeName).split(" ");

    // Browsers that don't support shadow DOM won't have getRootNode
    var root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    return ids.map(function (id) {
      return root.getElementById(id);
    }).filter(function (element) {
      return element !== null;
    }
    // TODO: why does this not narrow?
    );
  }

  return [];
}
function hasAnyConcreteRoles(node, roles) {
  if (isElement(node)) {
    return roles.indexOf(getRole(node)) !== -1;
  }
  return false;
}
//# sourceMappingURL=util.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-name-and-description.mjs
/**
 * implements https://w3c.github.io/accname/
 */




/**
 *  A string of characters where all carriage returns, newlines, tabs, and form-feeds are replaced with a single space, and multiple spaces are reduced to a single space. The string contains only character data; it does not contain any markup.
 */

/**
 *
 * @param {string} string -
 * @returns {FlatString} -
 */
function asFlatString(s) {
  return s.trim().replace(/\s\s+/g, " ");
}

/**
 *
 * @param node -
 * @param options - These are not optional to prevent accidentally calling it without options in `computeAccessibleName`
 * @returns {boolean} -
 */
function isHidden(node, getComputedStyleImplementation) {
  if (!isElement(node)) {
    return false;
  }
  if (node.hasAttribute("hidden") || node.getAttribute("aria-hidden") === "true") {
    return true;
  }
  var style = getComputedStyleImplementation(node);
  return style.getPropertyValue("display") === "none" || style.getPropertyValue("visibility") === "hidden";
}

/**
 * @param {Node} node -
 * @returns {boolean} - As defined in step 2E of https://w3c.github.io/accname/#mapping_additional_nd_te
 */
function isControl(node) {
  return hasAnyConcreteRoles(node, ["button", "combobox", "listbox", "textbox"]) || hasAbstractRole(node, "range");
}
function hasAbstractRole(node, role) {
  if (!isElement(node)) {
    return false;
  }
  switch (role) {
    case "range":
      return hasAnyConcreteRoles(node, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
  }
}

/**
 * element.querySelectorAll but also considers owned tree
 * @param element
 * @param selectors
 */
function querySelectorAllSubtree(element, selectors) {
  var elements = arrayFrom(element.querySelectorAll(selectors));
  queryIdRefs(element, "aria-owns").forEach(function (root) {
    // babel transpiles this assuming an iterator
    elements.push.apply(elements, arrayFrom(root.querySelectorAll(selectors)));
  });
  return elements;
}
function querySelectedOptions(listbox) {
  if (isHTMLSelectElement(listbox)) {
    // IE11 polyfill
    return listbox.selectedOptions || querySelectorAllSubtree(listbox, "[selected]");
  }
  return querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}
function isMarkedPresentational(node) {
  return hasAnyConcreteRoles(node, ["none", "presentation"]);
}

/**
 * Elements specifically listed in html-aam
 *
 * We don't need this for `label` or `legend` elements.
 * Their implicit roles already allow "naming from content".
 *
 * sources:
 *
 * - https://w3c.github.io/html-aam/#table-element
 */
function isNativeHostLanguageTextAlternativeElement(node) {
  return isHTMLTableCaptionElement(node);
}

/**
 * https://w3c.github.io/aria/#namefromcontent
 */
function allowsNameFromContent(node) {
  return hasAnyConcreteRoles(node, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}

/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/100
 */
function isDescendantOfNativeHostLanguageTextAlternativeElement(
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet
node) {
  return false;
}
function getValueOfTextbox(element) {
  if (isHTMLInputElement(element) || isHTMLTextAreaElement(element)) {
    return element.value;
  }
  // https://github.com/eps1lon/dom-accessibility-api/issues/4
  return element.textContent || "";
}
function getTextualContent(declaration) {
  var content = declaration.getPropertyValue("content");
  if (/^["'].*["']$/.test(content)) {
    return content.slice(1, -1);
  }
  return "";
}

/**
 * https://html.spec.whatwg.org/multipage/forms.html#category-label
 * TODO: form-associated custom elements
 * @param element
 */
function isLabelableElement(element) {
  var localName = getLocalName(element);
  return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}

/**
 * > [...], then the first such descendant in tree order is the label element's labeled control.
 * -- https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param element
 */
function findLabelableElement(element) {
  if (isLabelableElement(element)) {
    return element;
  }
  var labelableElement = null;
  element.childNodes.forEach(function (childNode) {
    if (labelableElement === null && isElement(childNode)) {
      var descendantLabelableElement = findLabelableElement(childNode);
      if (descendantLabelableElement !== null) {
        labelableElement = descendantLabelableElement;
      }
    }
  });
  return labelableElement;
}

/**
 * Polyfill of HTMLLabelElement.control
 * https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param label
 */
function getControlOfLabel(label) {
  if (label.control !== undefined) {
    return label.control;
  }
  var htmlFor = label.getAttribute("for");
  if (htmlFor !== null) {
    return label.ownerDocument.getElementById(htmlFor);
  }
  return findLabelableElement(label);
}

/**
 * Polyfill of HTMLInputElement.labels
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/labels
 * @param element
 */
function getLabels(element) {
  var labelsProperty = element.labels;
  if (labelsProperty === null) {
    return labelsProperty;
  }
  if (labelsProperty !== undefined) {
    return arrayFrom(labelsProperty);
  }

  // polyfill
  if (!isLabelableElement(element)) {
    return null;
  }
  var document = element.ownerDocument;
  return arrayFrom(document.querySelectorAll("label")).filter(function (label) {
    return getControlOfLabel(label) === element;
  });
}

/**
 * Gets the contents of a slot used for computing the accname
 * @param slot
 */
function getSlotContents(slot) {
  // Computing the accessible name for elements containing slots is not
  // currently defined in the spec. This implementation reflects the
  // behavior of NVDA 2020.2/Firefox 81 and iOS VoiceOver/Safari 13.6.
  var assignedNodes = slot.assignedNodes();
  if (assignedNodes.length === 0) {
    // if no nodes are assigned to the slot, it displays the default content
    return arrayFrom(slot.childNodes);
  }
  return assignedNodes;
}

/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_te
 * @param root
 * @param options
 * @returns
 */
function computeTextAlternative(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var consultedNodes = new polyfills_SetLike();
  var window = safeWindow(root);
  var _options$compute = options.compute,
    compute = _options$compute === void 0 ? "name" : _options$compute,
    _options$computedStyl = options.computedStyleSupportsPseudoElements,
    computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options.getComputedStyle !== undefined : _options$computedStyl,
    _options$getComputedS = options.getComputedStyle,
    getComputedStyle = _options$getComputedS === void 0 ? window.getComputedStyle.bind(window) : _options$getComputedS,
    _options$hidden = options.hidden,
    hidden = _options$hidden === void 0 ? false : _options$hidden;

  // 2F.i
  function computeMiscTextAlternative(node, context) {
    var accumulatedText = "";
    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoBefore = getComputedStyle(node, "::before");
      var beforeContent = getTextualContent(pseudoBefore);
      accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
    }

    // FIXME: Including aria-owns is not defined in the spec
    // But it is required in the web-platform-test
    var childNodes = isHTMLSlotElement(node) ? getSlotContents(node) : arrayFrom(node.childNodes).concat(queryIdRefs(node, "aria-owns"));
    childNodes.forEach(function (child) {
      var result = computeTextAlternative(child, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false,
        recursion: true
      });
      // TODO: Unclear why display affects delimiter
      // see https://github.com/w3c/accname/issues/3
      var display = isElement(child) ? getComputedStyle(child).getPropertyValue("display") : "inline";
      var separator = display !== "inline" ? " " : "";
      // trailing separator for wpt tests
      accumulatedText += "".concat(separator).concat(result).concat(separator);
    });
    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoAfter = getComputedStyle(node, "::after");
      var afterContent = getTextualContent(pseudoAfter);
      accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
    }
    return accumulatedText.trim();
  }

  /**
   *
   * @param element
   * @param attributeName
   * @returns A string non-empty string or `null`
   */
  function useAttribute(element, attributeName) {
    var attribute = element.getAttributeNode(attributeName);
    if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
      consultedNodes.add(attribute);
      return attribute.value;
    }
    return null;
  }
  function computeTooltipAttributeValue(node) {
    if (!isElement(node)) {
      return null;
    }
    return useAttribute(node, "title");
  }
  function computeElementTextAlternative(node) {
    if (!isElement(node)) {
      return null;
    }

    // https://w3c.github.io/html-aam/#fieldset-and-legend-elements
    if (isHTMLFieldSetElement(node)) {
      consultedNodes.add(node);
      var children = arrayFrom(node.childNodes);
      for (var i = 0; i < children.length; i += 1) {
        var child = children[i];
        if (isHTMLLegendElement(child)) {
          return computeTextAlternative(child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isHTMLTableElement(node)) {
      // https://w3c.github.io/html-aam/#table-element
      consultedNodes.add(node);
      var _children = arrayFrom(node.childNodes);
      for (var _i = 0; _i < _children.length; _i += 1) {
        var _child = _children[_i];
        if (isHTMLTableCaptionElement(_child)) {
          return computeTextAlternative(_child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isSVGSVGElement(node)) {
      // https://www.w3.org/TR/svg-aam-1.0/
      consultedNodes.add(node);
      var _children2 = arrayFrom(node.childNodes);
      for (var _i2 = 0; _i2 < _children2.length; _i2 += 1) {
        var _child2 = _children2[_i2];
        if (isSVGTitleElement(_child2)) {
          return _child2.textContent;
        }
      }
      return null;
    } else if (getLocalName(node) === "img" || getLocalName(node) === "area") {
      // https://w3c.github.io/html-aam/#area-element
      // https://w3c.github.io/html-aam/#img-element
      var nameFromAlt = useAttribute(node, "alt");
      if (nameFromAlt !== null) {
        return nameFromAlt;
      }
    } else if (isHTMLOptGroupElement(node)) {
      var nameFromLabel = useAttribute(node, "label");
      if (nameFromLabel !== null) {
        return nameFromLabel;
      }
    }
    if (isHTMLInputElement(node) && (node.type === "button" || node.type === "submit" || node.type === "reset")) {
      // https://w3c.github.io/html-aam/#input-type-text-input-type-password-input-type-search-input-type-tel-input-type-email-input-type-url-and-textarea-element-accessible-description-computation
      var nameFromValue = useAttribute(node, "value");
      if (nameFromValue !== null) {
        return nameFromValue;
      }

      // TODO: l10n
      if (node.type === "submit") {
        return "Submit";
      }
      // TODO: l10n
      if (node.type === "reset") {
        return "Reset";
      }
    }
    var labels = getLabels(node);
    if (labels !== null && labels.length !== 0) {
      consultedNodes.add(node);
      return arrayFrom(labels).map(function (element) {
        return computeTextAlternative(element, {
          isEmbeddedInLabel: true,
          isReferenced: false,
          recursion: true
        });
      }).filter(function (label) {
        return label.length > 0;
      }).join(" ");
    }

    // https://w3c.github.io/html-aam/#input-type-image-accessible-name-computation
    // TODO: wpt test consider label elements but html-aam does not mention them
    // We follow existing implementations over spec
    if (isHTMLInputElement(node) && node.type === "image") {
      var _nameFromAlt = useAttribute(node, "alt");
      if (_nameFromAlt !== null) {
        return _nameFromAlt;
      }
      var nameFromTitle = useAttribute(node, "title");
      if (nameFromTitle !== null) {
        return nameFromTitle;
      }

      // TODO: l10n
      return "Submit Query";
    }
    if (hasAnyConcreteRoles(node, ["button"])) {
      // https://www.w3.org/TR/html-aam-1.0/#button-element
      var nameFromSubTree = computeMiscTextAlternative(node, {
        isEmbeddedInLabel: false,
        isReferenced: false
      });
      if (nameFromSubTree !== "") {
        return nameFromSubTree;
      }
    }
    return null;
  }
  function computeTextAlternative(current, context) {
    if (consultedNodes.has(current)) {
      return "";
    }

    // 2A
    if (!hidden && isHidden(current, getComputedStyle) && !context.isReferenced) {
      consultedNodes.add(current);
      return "";
    }

    // 2B
    var labelAttributeNode = isElement(current) ? current.getAttributeNode("aria-labelledby") : null;
    // TODO: Do we generally need to block query IdRefs of attributes we have already consulted?
    var labelElements = labelAttributeNode !== null && !consultedNodes.has(labelAttributeNode) ? queryIdRefs(current, "aria-labelledby") : [];
    if (compute === "name" && !context.isReferenced && labelElements.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Can't be null here otherwise labelElements would be empty
      consultedNodes.add(labelAttributeNode);
      return labelElements.map(function (element) {
        // TODO: Chrome will consider repeated values i.e. use a node multiple times while we'll bail out in computeTextAlternative.
        return computeTextAlternative(element, {
          isEmbeddedInLabel: context.isEmbeddedInLabel,
          isReferenced: true,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: false
        });
      }).join(" ");
    }

    // 2C
    // Changed from the spec in anticipation of https://github.com/w3c/accname/issues/64
    // spec says we should only consider skipping if we have a non-empty label
    var skipToStep2E = context.recursion && isControl(current) && compute === "name";
    if (!skipToStep2E) {
      var ariaLabel = (isElement(current) && current.getAttribute("aria-label") || "").trim();
      if (ariaLabel !== "" && compute === "name") {
        consultedNodes.add(current);
        return ariaLabel;
      }

      // 2D
      if (!isMarkedPresentational(current)) {
        var elementTextAlternative = computeElementTextAlternative(current);
        if (elementTextAlternative !== null) {
          consultedNodes.add(current);
          return elementTextAlternative;
        }
      }
    }

    // special casing, cheating to make tests pass
    // https://github.com/w3c/accname/issues/67
    if (hasAnyConcreteRoles(current, ["menu"])) {
      consultedNodes.add(current);
      return "";
    }

    // 2E
    if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
      if (hasAnyConcreteRoles(current, ["combobox", "listbox"])) {
        consultedNodes.add(current);
        var selectedOptions = querySelectedOptions(current);
        if (selectedOptions.length === 0) {
          // defined per test `name_heading_combobox`
          return isHTMLInputElement(current) ? current.value : "";
        }
        return arrayFrom(selectedOptions).map(function (selectedOption) {
          return computeTextAlternative(selectedOption, {
            isEmbeddedInLabel: context.isEmbeddedInLabel,
            isReferenced: false,
            recursion: true
          });
        }).join(" ");
      }
      if (hasAbstractRole(current, "range")) {
        consultedNodes.add(current);
        if (current.hasAttribute("aria-valuetext")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuetext");
        }
        if (current.hasAttribute("aria-valuenow")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuenow");
        }
        // Otherwise, use the value as specified by a host language attribute.
        return current.getAttribute("value") || "";
      }
      if (hasAnyConcreteRoles(current, ["textbox"])) {
        consultedNodes.add(current);
        return getValueOfTextbox(current);
      }
    }

    // 2F: https://w3c.github.io/accname/#step2F
    if (allowsNameFromContent(current) || isElement(current) && context.isReferenced || isNativeHostLanguageTextAlternativeElement(current) || isDescendantOfNativeHostLanguageTextAlternativeElement(current)) {
      var accumulatedText2F = computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
      if (accumulatedText2F !== "") {
        consultedNodes.add(current);
        return accumulatedText2F;
      }
    }
    if (current.nodeType === current.TEXT_NODE) {
      consultedNodes.add(current);
      return current.textContent || "";
    }
    if (context.recursion) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
    }
    var tooltipAttributeValue = computeTooltipAttributeValue(current);
    if (tooltipAttributeValue !== null) {
      consultedNodes.add(current);
      return tooltipAttributeValue;
    }

    // TODO should this be reachable?
    consultedNodes.add(current);
    return "";
  }
  return asFlatString(computeTextAlternative(root, {
    isEmbeddedInLabel: false,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: compute === "description",
    recursion: false
  }));
}
//# sourceMappingURL=accessible-name-and-description.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-description.mjs
function accessible_description_typeof(obj) { "@babel/helpers - typeof"; return accessible_description_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, accessible_description_typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { accessible_description_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function accessible_description_defineProperty(obj, key, value) { key = accessible_description_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function accessible_description_toPropertyKey(arg) { var key = accessible_description_toPrimitive(arg, "string"); return accessible_description_typeof(key) === "symbol" ? key : String(key); }
function accessible_description_toPrimitive(input, hint) { if (accessible_description_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (accessible_description_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



/**
 * @param root
 * @param options
 * @returns
 */
function computeAccessibleDescription(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var description = queryIdRefs(root, "aria-describedby").map(function (element) {
    return computeTextAlternative(element, _objectSpread(_objectSpread({}, options), {}, {
      compute: "description"
    }));
  }).join(" ");

  // TODO: Technically we need to make sure that node wasn't used for the accessible name
  //       This causes `description_1.0_combobox-focusable-manual` to fail
  //
  // https://www.w3.org/TR/html-aam-1.0/#accessible-name-and-description-computation
  // says for so many elements to use the `title` that we assume all elements are considered
  if (description === "") {
    var title = root.getAttribute("title");
    description = title === null ? "" : title;
  }
  return description;
}
//# sourceMappingURL=accessible-description.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-name.mjs



/**
 * https://w3c.github.io/aria/#namefromprohibited
 */
function prohibitsNaming(node) {
  return hasAnyConcreteRoles(node, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}

/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_name
 * @param root
 * @param options
 * @returns
 */
function computeAccessibleName(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (prohibitsNaming(root)) {
    return "";
  }
  return computeTextAlternative(root, options);
}
//# sourceMappingURL=accessible-name.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/index.mjs




//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ../../../node_modules/aria-query/lib/index.js
var lib = __webpack_require__(41516);
// EXTERNAL MODULE: ../../../node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__(26499);
var lz_string_default = /*#__PURE__*/__webpack_require__.n(lz_string);
;// CONCATENATED MODULE: ../../../node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(13158);






/**
 * Source: https://github.com/facebook/jest/blob/e7bb6a1e26ffab90611b2593912df15b69315611/packages/pretty-format/src/plugins/DOMElement.ts
 */
/* eslint-disable -- trying to stay as close to the original as possible */
/* istanbul ignore file */

function escapeHTML(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
// Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer) => {
  const indentationNext = indentation + config.indent;
  const colors = config.colors;
  return keys.map(key => {
    const value = props[key];
    let printed = printer(value, config, indentationNext, depth, refs);
    if (typeof value !== 'string') {
      if (printed.indexOf('\n') !== -1) {
        printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
      }
      printed = '{' + printed + '}';
    }
    return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
  }).join('');
};

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const NodeTypeTextNode = 3;

// Return empty string if children is empty.
const printChildren = (children, config, indentation, depth, refs, printer) => children.map(child => {
  const printedChild = typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs);
  if (printedChild === '' && typeof child === 'object' && child !== null && child.nodeType !== NodeTypeTextNode) {
    // A plugin serialized this Node to '' meaning we should ignore it.
    return '';
  }
  return config.spacingOuter + indentation + printedChild;
}).join('');
const printText = (text, config) => {
  const contentColor = config.colors.content;
  return contentColor.open + escapeHTML(text) + contentColor.close;
};
const printComment = (comment, config) => {
  const commentColor = config.colors.comment;
  return commentColor.open + '<!--' + escapeHTML(comment) + '-->' + commentColor.close;
};

// Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.
const printElement = (type, printedProps, printedChildren, config, indentation) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
};
const printElementAsLeaf = (type, config) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + tagColor.close + ' …' + tagColor.open + ' />' + tagColor.close;
};
const ELEMENT_NODE$1 = 1;
const TEXT_NODE$1 = 3;
const COMMENT_NODE$1 = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
const testNode = val => {
  const constructorName = val.constructor.name;
  const {
    nodeType,
    tagName
  } = val;
  const isCustomElement = typeof tagName === 'string' && tagName.includes('-') || typeof val.hasAttribute === 'function' && val.hasAttribute('is');
  return nodeType === ELEMENT_NODE$1 && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$1 && constructorName === 'Text' || nodeType === COMMENT_NODE$1 && constructorName === 'Comment' || nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment';
};
function nodeIsText(node) {
  return node.nodeType === TEXT_NODE$1;
}
function nodeIsComment(node) {
  return node.nodeType === COMMENT_NODE$1;
}
function nodeIsFragment(node) {
  return node.nodeType === FRAGMENT_NODE;
}
function createDOMElementFilter(filterNode) {
  return {
    test: val => {
      var _val$constructor2;
      return (val == null ? void 0 : (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) && testNode(val);
    },
    serialize: (node, config, indentation, depth, refs, printer) => {
      if (nodeIsText(node)) {
        return printText(node.data, config);
      }
      if (nodeIsComment(node)) {
        return printComment(node.data, config);
      }
      const type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();
      if (++depth > config.maxDepth) {
        return printElementAsLeaf(type, config);
      }
      return printElement(type, printProps(nodeIsFragment(node) ? [] : Array.from(node.attributes).map(attr => attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute) => {
        props[attribute.name] = attribute.value;
        return props;
      }, {}), config, indentation + config.indent, depth, refs, printer), printChildren(Array.prototype.slice.call(node.childNodes || node.children).filter(filterNode), config, indentation + config.indent, depth, refs, printer), config, indentation);
    }
  };
}

// We try to load node dependencies
let chalk = null;
let readFileSync = null;
let codeFrameColumns = null;
try {
  const nodeRequire = module && module.require;
  readFileSync = nodeRequire.call(module, 'fs').readFileSync;
  codeFrameColumns = nodeRequire.call(module, '@babel/code-frame').codeFrameColumns;
  chalk = nodeRequire.call(module, 'chalk');
} catch {
  // We're in a browser environment
}

// frame has the form "at myMethod (location/to/my/file.js:10:2)"
function getCodeFrame(frame) {
  const locationStart = frame.indexOf('(') + 1;
  const locationEnd = frame.indexOf(')');
  const frameLocation = frame.slice(locationStart, locationEnd);
  const frameLocationElements = frameLocation.split(':');
  const [filename, line, column] = [frameLocationElements[0], parseInt(frameLocationElements[1], 10), parseInt(frameLocationElements[2], 10)];
  let rawFileContents = '';
  try {
    rawFileContents = readFileSync(filename, 'utf-8');
  } catch {
    return '';
  }
  const codeFrame = codeFrameColumns(rawFileContents, {
    start: {
      line,
      column
    }
  }, {
    highlightCode: true,
    linesBelow: 0
  });
  return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame() {
  // If we couldn't load dependencies, we can't generate the user trace
  /* istanbul ignore next */
  if (!readFileSync || !codeFrameColumns) {
    return '';
  }
  const err = new Error();
  const firstClientCodeFrame = err.stack.split('\n').slice(1) // Remove first line which has the form "Error: TypeError"
  .find(frame => !frame.includes('node_modules/')); // Ignore frames from 3rd party libraries

  return getCodeFrame(firstClientCodeFrame);
}

// Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants
const TEXT_NODE = 3;
function jestFakeTimersAreEnabled() {
  /* istanbul ignore else */
  // eslint-disable-next-line
  if (typeof jest !== 'undefined' && jest !== null) {
    return (
      // legacy timers
      setTimeout._isMockFunction === true ||
      // modern timers
      Object.prototype.hasOwnProperty.call(setTimeout, 'clock')
    );
  }
  // istanbul ignore next
  return false;
}
function getDocument() {
  /* istanbul ignore if */
  if (typeof window === 'undefined') {
    throw new Error('Could not find default container');
  }
  return window.document;
}
function getWindowFromNode(node) {
  if (node.defaultView) {
    // node is document
    return node.defaultView;
  } else if (node.ownerDocument && node.ownerDocument.defaultView) {
    // node is a DOM node
    return node.ownerDocument.defaultView;
  } else if (node.window) {
    // node is window
    return node.window;
  } else if (node.ownerDocument && node.ownerDocument.defaultView === null) {
    throw new Error("It looks like the window object is not available for the provided node.");
  } else if (node.then instanceof Function) {
    throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
  } else if (Array.isArray(node)) {
    throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
  } else if (typeof node.debug === 'function' && typeof node.logTestingPlaygroundURL === 'function') {
    throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
  } else {
    // The user passed something unusual to a calling function
    throw new Error("The given node is not an Element, the node type is: " + typeof node + ".");
  }
}
function checkContainerType(container) {
  if (!container || !(typeof container.querySelector === 'function') || !(typeof container.querySelectorAll === 'function')) {
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container) + ".");
  }
  function getTypeName(object) {
    if (typeof object === 'object') {
      return object === null ? 'null' : object.constructor.name;
    }
    return typeof object;
  }
}

const shouldHighlight = () => {
  let colors;
  try {
    var _process, _process$env;
    colors = JSON.parse((_process = process) == null ? void 0 : (_process$env = _process.env) == null ? void 0 : _process$env.COLORS);
  } catch (e) {
    // If this throws, process?.env?.COLORS wasn't parsable. Since we only
    // care about `true` or `false`, we can safely ignore the error.
  }
  if (typeof colors === 'boolean') {
    // If `colors` is set explicitly (both `true` and `false`), use that value.
    return colors;
  } else {
    // If `colors` is not set, colorize if we're in node.
    return typeof process !== 'undefined' && process.versions !== undefined && process.versions.node !== undefined;
  }
};
const {
  DOMCollection
} = build/* plugins */.Gr;

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const ELEMENT_NODE = 1;
const COMMENT_NODE = 8;

// https://github.com/facebook/jest/blob/615084195ae1ae61ddd56162c62bbdda17587569/packages/pretty-format/src/plugins/DOMElement.ts#L50
function filterCommentsAndDefaultIgnoreTagsTags(value) {
  return value.nodeType !== COMMENT_NODE && (value.nodeType !== ELEMENT_NODE || !value.matches(getConfig().defaultIgnore));
}
function prettyDOM(dom, maxLength, options) {
  if (options === void 0) {
    options = {};
  }
  if (!dom) {
    dom = getDocument().body;
  }
  if (typeof maxLength !== 'number') {
    maxLength = typeof process !== 'undefined' && process.env.DEBUG_PRINT_LIMIT || 7000;
  }
  if (maxLength === 0) {
    return '';
  }
  if (dom.documentElement) {
    dom = dom.documentElement;
  }
  let domTypeName = typeof dom;
  if (domTypeName === 'object') {
    domTypeName = dom.constructor.name;
  } else {
    // To don't fall with `in` operator
    dom = {};
  }
  if (!('outerHTML' in dom)) {
    throw new TypeError("Expected an element or document but got " + domTypeName);
  }
  const {
    filterNode = filterCommentsAndDefaultIgnoreTagsTags,
    ...prettyFormatOptions
  } = options;
  const debugContent = build/* format */.WU(dom, {
    plugins: [createDOMElementFilter(filterNode), DOMCollection],
    printFunctionName: false,
    highlight: shouldHighlight(),
    ...prettyFormatOptions
  });
  return maxLength !== undefined && dom.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
const logDOM = function () {
  const userCodeFrame = getUserCodeFrame();
  if (userCodeFrame) {
    console.log(prettyDOM(...arguments) + "\n\n" + userCodeFrame);
  } else {
    console.log(prettyDOM(...arguments));
  }
};

// It would be cleaner for this to live inside './queries', but
// other parts of the code assume that all exports from
// './queries' are query functions.
let config = {
  testIdAttribute: 'data-testid',
  asyncUtilTimeout: 1000,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: cb => cb(),
  unstable_advanceTimersWrapper: cb => cb(),
  eventWrapper: cb => cb(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: false,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: 'script, style',
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: false,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: false,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(message, container) {
    const prettifiedDOM = prettyDOM(container);
    const error = new Error([message, "Ignored nodes: comments, " + config.defaultIgnore + "\n" + prettifiedDOM].filter(Boolean).join('\n\n'));
    error.name = 'TestingLibraryElementError';
    return error;
  },
  _disableExpensiveErrorDiagnostics: false,
  computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
  try {
    config._disableExpensiveErrorDiagnostics = true;
    return callback();
  } finally {
    config._disableExpensiveErrorDiagnostics = false;
  }
}
function configure(newConfig) {
  if (typeof newConfig === 'function') {
    // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig(config);
  }

  // Merge the incoming config delta
  config = {
    ...config,
    ...newConfig
  };
}
function getConfig() {
  return config;
}

const labelledNodeNames = ['button', 'meter', 'output', 'progress', 'select', 'textarea', 'input'];
function getTextContent(node) {
  if (labelledNodeNames.includes(node.nodeName.toLowerCase())) {
    return '';
  }
  if (node.nodeType === TEXT_NODE) return node.textContent;
  return Array.from(node.childNodes).map(childNode => getTextContent(childNode)).join('');
}
function getLabelContent(element) {
  let textContent;
  if (element.tagName.toLowerCase() === 'label') {
    textContent = getTextContent(element);
  } else {
    textContent = element.value || element.textContent;
  }
  return textContent;
}

// Based on https://github.com/eps1lon/dom-accessibility-api/pull/352
function getRealLabels(element) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- types are not aware of older browsers that don't implement `labels`
  if (element.labels !== undefined) {
    var _labels;
    return (_labels = element.labels) != null ? _labels : [];
  }
  if (!isLabelable(element)) return [];
  const labels = element.ownerDocument.querySelectorAll('label');
  return Array.from(labels).filter(label => label.control === element);
}
function isLabelable(element) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === 'INPUT' && element.getAttribute('type') !== 'hidden';
}
function dom_esm_getLabels(container, element, _temp) {
  let {
    selector = '*'
  } = _temp === void 0 ? {} : _temp;
  const ariaLabelledBy = element.getAttribute('aria-labelledby');
  const labelsId = ariaLabelledBy ? ariaLabelledBy.split(' ') : [];
  return labelsId.length ? labelsId.map(labelId => {
    const labellingElement = container.querySelector("[id=\"" + labelId + "\"]");
    return labellingElement ? {
      content: getLabelContent(labellingElement),
      formControl: null
    } : {
      content: '',
      formControl: null
    };
  }) : Array.from(getRealLabels(element)).map(label => {
    const textToMatch = getLabelContent(label);
    const formControlSelector = 'button, input, meter, output, progress, select, textarea';
    const labelledFormControl = Array.from(label.querySelectorAll(formControlSelector)).filter(formControlElement => formControlElement.matches(selector))[0];
    return {
      content: textToMatch,
      formControl: labelledFormControl
    };
  });
}

function assertNotNullOrUndefined(matcher) {
  if (matcher === null || matcher === undefined) {
    throw new Error( // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
    "It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?");
  }
}
function fuzzyMatches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (typeof matcher === 'string' || typeof matcher === 'number') {
    return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
  } else if (typeof matcher === 'function') {
    return matcher(normalizedText, node);
  } else {
    return matchRegExp(matcher, normalizedText);
  }
}
function matches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (matcher instanceof Function) {
    return matcher(normalizedText, node);
  } else if (matcher instanceof RegExp) {
    return matchRegExp(matcher, normalizedText);
  } else {
    return normalizedText === String(matcher);
  }
}
function getDefaultNormalizer(_temp) {
  let {
    trim = true,
    collapseWhitespace = true
  } = _temp === void 0 ? {} : _temp;
  return text => {
    let normalizedText = text;
    normalizedText = trim ? normalizedText.trim() : normalizedText;
    normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, ' ') : normalizedText;
    return normalizedText;
  };
}

/**
 * Constructs a normalizer to pass to functions in matches.js
 * @param {boolean|undefined} trim The user-specified value for `trim`, without
 * any defaulting having been applied
 * @param {boolean|undefined} collapseWhitespace The user-specified value for
 * `collapseWhitespace`, without any defaulting having been applied
 * @param {Function|undefined} normalizer The user-specified normalizer
 * @returns {Function} A normalizer
 */

function makeNormalizer(_ref) {
  let {
    trim,
    collapseWhitespace,
    normalizer
  } = _ref;
  if (!normalizer) {
    // No custom normalizer specified. Just use default.
    return getDefaultNormalizer({
      trim,
      collapseWhitespace
    });
  }
  if (typeof trim !== 'undefined' || typeof collapseWhitespace !== 'undefined') {
    // They've also specified a value for trim or collapseWhitespace
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. ' + 'If you want to use the default trim and collapseWhitespace logic in your normalizer, ' + 'use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  }
  return normalizer;
}
function matchRegExp(matcher, text) {
  const match = matcher.test(text);
  if (matcher.global && matcher.lastIndex !== 0) {
    console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
    matcher.lastIndex = 0;
  }
  return match;
}

function getNodeText(node) {
  if (node.matches('input[type=submit], input[type=button], input[type=reset]')) {
    return node.value;
  }
  return Array.from(node.childNodes).filter(child => child.nodeType === TEXT_NODE && Boolean(child.textContent)).map(c => c.textContent).join('');
}

const elementRoleList = buildElementRoleList(lib/* elementRoles */.Qv);

/**
 * @param {Element} element -
 * @returns {boolean} - `true` if `element` and its subtree are inaccessible
 */
function isSubtreeInaccessible(element) {
  if (element.hidden === true) {
    return true;
  }
  if (element.getAttribute('aria-hidden') === 'true') {
    return true;
  }
  const window = element.ownerDocument.defaultView;
  if (window.getComputedStyle(element).display === 'none') {
    return true;
  }
  return false;
}

/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param {Element} element -
 * @param {object} [options] -
 * @param {function (element: Element): boolean} options.isSubtreeInaccessible -
 * can be used to return cached results from previous isSubtreeInaccessible calls
 * @returns {boolean} true if excluded, otherwise false
 */
function isInaccessible(element, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    isSubtreeInaccessible: isSubtreeInaccessibleImpl = isSubtreeInaccessible
  } = options;
  const window = element.ownerDocument.defaultView;
  // since visibility is inherited we can exit early
  if (window.getComputedStyle(element).visibility === 'hidden') {
    return true;
  }
  let currentElement = element;
  while (currentElement) {
    if (isSubtreeInaccessibleImpl(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function getImplicitAriaRoles(currentNode) {
  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (const {
    match,
    roles
  } of elementRoleList) {
    if (match(currentNode)) {
      return [...roles];
    }
  }
  return [];
}
function buildElementRoleList(elementRolesMap) {
  function makeElementSelector(_ref) {
    let {
      name,
      attributes
    } = _ref;
    return "" + name + attributes.map(_ref2 => {
      let {
        name: attributeName,
        value,
        constraints = []
      } = _ref2;
      const shouldNotExist = constraints.indexOf('undefined') !== -1;
      if (shouldNotExist) {
        return ":not([" + attributeName + "])";
      } else if (value) {
        return "[" + attributeName + "=\"" + value + "\"]";
      } else {
        return "[" + attributeName + "]";
      }
    }).join('');
  }
  function getSelectorSpecificity(_ref3) {
    let {
      attributes = []
    } = _ref3;
    return attributes.length;
  }
  function bySelectorSpecificity(_ref4, _ref5) {
    let {
      specificity: leftSpecificity
    } = _ref4;
    let {
      specificity: rightSpecificity
    } = _ref5;
    return rightSpecificity - leftSpecificity;
  }
  function match(element) {
    let {
      attributes = []
    } = element;

    // https://github.com/testing-library/dom-testing-library/issues/814
    const typeTextIndex = attributes.findIndex(attribute => attribute.value && attribute.name === 'type' && attribute.value === 'text');
    if (typeTextIndex >= 0) {
      // not using splice to not mutate the attributes array
      attributes = [...attributes.slice(0, typeTextIndex), ...attributes.slice(typeTextIndex + 1)];
    }
    const selector = makeElementSelector({
      ...element,
      attributes
    });
    return node => {
      if (typeTextIndex >= 0 && node.type !== 'text') {
        return false;
      }
      return node.matches(selector);
    };
  }
  let result = [];

  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (const [element, roles] of elementRolesMap.entries()) {
    result = [...result, {
      match: match(element),
      roles: Array.from(roles),
      specificity: getSelectorSpecificity(element)
    }];
  }
  return result.sort(bySelectorSpecificity);
}
function getRoles(container, _temp) {
  let {
    hidden = false
  } = _temp === void 0 ? {} : _temp;
  function flattenDOM(node) {
    return [node, ...Array.from(node.children).reduce((acc, child) => [...acc, ...flattenDOM(child)], [])];
  }
  return flattenDOM(container).filter(element => {
    return hidden === false ? isInaccessible(element) === false : true;
  }).reduce((acc, node) => {
    let roles = [];
    // TODO: This violates html-aria which does not allow any role on every element
    if (node.hasAttribute('role')) {
      roles = node.getAttribute('role').split(' ').slice(0, 1);
    } else {
      roles = getImplicitAriaRoles(node);
    }
    return roles.reduce((rolesAcc, role) => Array.isArray(rolesAcc[role]) ? {
      ...rolesAcc,
      [role]: [...rolesAcc[role], node]
    } : {
      ...rolesAcc,
      [role]: [node]
    }, acc);
  }, {});
}
function prettyRoles(dom, _ref6) {
  let {
    hidden,
    includeDescription
  } = _ref6;
  const roles = getRoles(dom, {
    hidden
  });
  // We prefer to skip generic role, we don't recommend it
  return Object.entries(roles).filter(_ref7 => {
    let [role] = _ref7;
    return role !== 'generic';
  }).map(_ref8 => {
    let [role, elements] = _ref8;
    const delimiterBar = '-'.repeat(50);
    const elementsString = elements.map(el => {
      const nameString = "Name \"" + computeAccessibleName(el, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      }) + "\":\n";
      const domString = prettyDOM(el.cloneNode(false));
      if (includeDescription) {
        const descriptionString = "Description \"" + computeAccessibleDescription(el, {
          computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }) + "\":\n";
        return "" + nameString + descriptionString + domString;
      }
      return "" + nameString + domString;
    }).join('\n\n');
    return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
  }).join('\n');
}
const logRoles = function (dom, _temp2) {
  let {
    hidden = false
  } = _temp2 === void 0 ? {} : _temp2;
  return console.log(prettyRoles(dom, {
    hidden
  }));
};

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)selected, undefined if not selectable
 */
function computeAriaSelected(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-97
  if (element.tagName === 'OPTION') {
    return element.selected;
  }

  // explicit value
  return checkBooleanAttribute(element, 'aria-selected');
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)checked, undefined if not checked-able
 */
function computeAriaChecked(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-56
  // https://www.w3.org/TR/html-aam-1.0/#details-id-67
  if ('indeterminate' in element && element.indeterminate) {
    return undefined;
  }
  if ('checked' in element) {
    return element.checked;
  }

  // explicit value
  return checkBooleanAttribute(element, 'aria-checked');
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)pressed, undefined if not press-able
 */
function computeAriaPressed(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-pressed
  return checkBooleanAttribute(element, 'aria-pressed');
}

/**
 * @param {Element} element -
 * @returns {boolean | string | null} -
 */
function computeAriaCurrent(element) {
  var _ref9, _checkBooleanAttribut;
  // https://www.w3.org/TR/wai-aria-1.1/#aria-current
  return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute(element, 'aria-current')) != null ? _checkBooleanAttribut : element.getAttribute('aria-current')) != null ? _ref9 : false;
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)expanded, undefined if not expand-able
 */
function computeAriaExpanded(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
  return checkBooleanAttribute(element, 'aria-expanded');
}
function checkBooleanAttribute(element, attribute) {
  const attributeValue = element.getAttribute(attribute);
  if (attributeValue === 'true') {
    return true;
  }
  if (attributeValue === 'false') {
    return false;
  }
  return undefined;
}

/**
 * @param {Element} element -
 * @returns {number | undefined} - number if implicit heading or aria-level present, otherwise undefined
 */
function computeHeadingLevel(element) {
  // https://w3c.github.io/html-aam/#el-h1-h6
  // https://w3c.github.io/html-aam/#el-h1-h6
  const implicitHeadingLevels = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  // explicit aria-level value
  // https://www.w3.org/TR/wai-aria-1.2/#aria-level
  const ariaLevelAttribute = element.getAttribute('aria-level') && Number(element.getAttribute('aria-level'));
  return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}

const normalize = getDefaultNormalizer();
function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function getRegExpMatcher(string) {
  return new RegExp(escapeRegExp(string.toLowerCase()), 'i');
}
function makeSuggestion(queryName, element, content, _ref) {
  let {
    variant,
    name
  } = _ref;
  let warning = '';
  const queryOptions = {};
  const queryArgs = [['Role', 'TestId'].includes(queryName) ? content : getRegExpMatcher(content)];
  if (name) {
    queryOptions.name = getRegExpMatcher(name);
  }
  if (queryName === 'Role' && isInaccessible(element)) {
    queryOptions.hidden = true;
    warning = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
  }
  if (Object.keys(queryOptions).length > 0) {
    queryArgs.push(queryOptions);
  }
  const queryMethod = variant + "By" + queryName;
  return {
    queryName,
    queryMethod,
    queryArgs,
    variant,
    warning,
    toString() {
      if (warning) {
        console.warn(warning);
      }
      let [text, options] = queryArgs;
      text = typeof text === 'string' ? "'" + text + "'" : text;
      options = options ? ", { " + Object.entries(options).map(_ref2 => {
        let [k, v] = _ref2;
        return k + ": " + v;
      }).join(', ') + " }" : '';
      return queryMethod + "(" + text + options + ")";
    }
  };
}
function canSuggest(currentMethod, requestedMethod, data) {
  return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}
function getSuggestedQuery(element, variant, method) {
  var _element$getAttribute, _getImplicitAriaRoles;
  if (variant === void 0) {
    variant = 'get';
  }
  // don't create suggestions for script and style elements
  if (element.matches(getConfig().defaultIgnore)) {
    return undefined;
  }

  //We prefer to suggest something else if the role is generic
  const role = (_element$getAttribute = element.getAttribute('role')) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];
  if (role !== 'generic' && canSuggest('Role', method, role)) {
    return makeSuggestion('Role', element, role, {
      variant,
      name: computeAccessibleName(element, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      })
    });
  }
  const labelText = dom_esm_getLabels(document, element).map(label => label.content).join(' ');
  if (canSuggest('LabelText', method, labelText)) {
    return makeSuggestion('LabelText', element, labelText, {
      variant
    });
  }
  const placeholderText = element.getAttribute('placeholder');
  if (canSuggest('PlaceholderText', method, placeholderText)) {
    return makeSuggestion('PlaceholderText', element, placeholderText, {
      variant
    });
  }
  const textContent = normalize(getNodeText(element));
  if (canSuggest('Text', method, textContent)) {
    return makeSuggestion('Text', element, textContent, {
      variant
    });
  }
  if (canSuggest('DisplayValue', method, element.value)) {
    return makeSuggestion('DisplayValue', element, normalize(element.value), {
      variant
    });
  }
  const alt = element.getAttribute('alt');
  if (canSuggest('AltText', method, alt)) {
    return makeSuggestion('AltText', element, alt, {
      variant
    });
  }
  const title = element.getAttribute('title');
  if (canSuggest('Title', method, title)) {
    return makeSuggestion('Title', element, title, {
      variant
    });
  }
  const testId = element.getAttribute(getConfig().testIdAttribute);
  if (canSuggest('TestId', method, testId)) {
    return makeSuggestion('TestId', element, testId, {
      variant
    });
  }
  return undefined;
}

// This is so the stack trace the developer sees is one that's
// closer to their code (because async stack traces are hard to follow).
function copyStackTrace(target, source) {
  target.stack = source.stack.replace(source.message, target.message);
}
function waitFor(callback, _ref) {
  let {
    container = getDocument(),
    timeout = getConfig().asyncUtilTimeout,
    showOriginalStackTrace = getConfig().showOriginalStackTrace,
    stackTraceError,
    interval = 50,
    onTimeout = error => {
      error.message = getConfig().getElementError(error.message, container).message;
      return error;
    },
    mutationObserverOptions = {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    }
  } = _ref;
  if (typeof callback !== 'function') {
    throw new TypeError('Received `callback` arg must be a function');
  }
  return new Promise(async (resolve, reject) => {
    let lastError, intervalId, observer;
    let finished = false;
    let promiseStatus = 'idle';
    const overallTimeoutTimer = setTimeout(handleTimeout, timeout);
    const usingJestFakeTimers = jestFakeTimersAreEnabled();
    if (usingJestFakeTimers) {
      const {
        unstable_advanceTimersWrapper: advanceTimersWrapper
      } = getConfig();
      checkCallback();
      // this is a dangerous rule to disable because it could lead to an
      // infinite loop. However, eslint isn't smart enough to know that we're
      // setting finished inside `onDone` which will be called when we're done
      // waiting or when we've timed out.
      // eslint-disable-next-line no-unmodified-loop-condition
      while (!finished) {
        if (!jestFakeTimersAreEnabled()) {
          const error = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
          reject(error);
          return;
        }
        // we *could* (maybe should?) use `advanceTimersToNextTimer` but it's
        // possible that could make this loop go on forever if someone is using
        // third party code that's setting up recursive timers so rapidly that
        // the user's timer's don't get a chance to resolve. So we'll advance
        // by an interval instead. (We have a test for this case).
        advanceTimersWrapper(() => {
          jest.advanceTimersByTime(interval);
        });

        // It's really important that checkCallback is run *before* we flush
        // in-flight promises. To be honest, I'm not sure why, and I can't quite
        // think of a way to reproduce the problem in a test, but I spent
        // an entire day banging my head against a wall on this.
        checkCallback();
        if (finished) {
          break;
        }

        // In this rare case, we *need* to wait for in-flight promises
        // to resolve before continuing. We don't need to take advantage
        // of parallelization so we're fine.
        // https://stackoverflow.com/a/59243586/971592
        // eslint-disable-next-line no-await-in-loop
        await advanceTimersWrapper(async () => {
          await new Promise(r => {
            setTimeout(r, 0);
            jest.advanceTimersByTime(0);
          });
        });
      }
    } else {
      try {
        checkContainerType(container);
      } catch (e) {
        reject(e);
        return;
      }
      intervalId = setInterval(checkRealTimersCallback, interval);
      const {
        MutationObserver
      } = getWindowFromNode(container);
      observer = new MutationObserver(checkRealTimersCallback);
      observer.observe(container, mutationObserverOptions);
      checkCallback();
    }
    function onDone(error, result) {
      finished = true;
      clearTimeout(overallTimeoutTimer);
      if (!usingJestFakeTimers) {
        clearInterval(intervalId);
        observer.disconnect();
      }
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    }
    function checkRealTimersCallback() {
      if (jestFakeTimersAreEnabled()) {
        const error = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
        return reject(error);
      } else {
        return checkCallback();
      }
    }
    function checkCallback() {
      if (promiseStatus === 'pending') return;
      try {
        const result = runWithExpensiveErrorDiagnosticsDisabled(callback);
        if (typeof (result == null ? void 0 : result.then) === 'function') {
          promiseStatus = 'pending';
          result.then(resolvedValue => {
            promiseStatus = 'resolved';
            onDone(null, resolvedValue);
          }, rejectedValue => {
            promiseStatus = 'rejected';
            lastError = rejectedValue;
          });
        } else {
          onDone(null, result);
        }
        // If `callback` throws, wait for the next mutation, interval, or timeout.
      } catch (error) {
        // Save the most recent callback error to reject the promise with it in the event of a timeout
        lastError = error;
      }
    }
    function handleTimeout() {
      let error;
      if (lastError) {
        error = lastError;
        if (!showOriginalStackTrace && error.name === 'TestingLibraryElementError') {
          copyStackTrace(error, stackTraceError);
        }
      } else {
        error = new Error('Timed out in waitFor.');
        if (!showOriginalStackTrace) {
          copyStackTrace(error, stackTraceError);
        }
      }
      onDone(onTimeout(error), null);
    }
  });
}
function waitForWrapper(callback, options) {
  // create the error here so its stack trace is as close to the
  // calling code as possible
  const stackTraceError = new Error('STACK_TRACE_MESSAGE');
  return getConfig().asyncWrapper(() => waitFor(callback, {
    stackTraceError,
    ...options
  }));
}

/*
eslint
  max-lines-per-function: ["error", {"max": 200}],
*/

function getElementError(message, container) {
  return getConfig().getElementError(message, container);
}
function getMultipleElementsFoundError(message, container) {
  return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container);
}
function queryAllByAttribute(attribute, container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("[" + attribute + "]")).filter(node => matcher(node.getAttribute(attribute), node, text, matchNormalizer));
}
function queryByAttribute(attribute, container, text, options) {
  const els = queryAllByAttribute(attribute, container, text, options);
  if (els.length > 1) {
    throw getMultipleElementsFoundError("Found multiple elements by [" + attribute + "=" + text + "]", container);
  }
  return els[0] || null;
}

// this accepts a query function and returns a function which throws an error
// if more than one elements is returned, otherwise it returns the first
// element or null
function makeSingleQuery(allQuery, getMultipleError) {
  return function (container) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const els = allQuery(container, ...args);
    if (els.length > 1) {
      const elementStrings = els.map(element => getElementError(null, element).message).join('\n\n');
      throw getMultipleElementsFoundError(getMultipleError(container, ...args) + "\n\nHere are the matching elements:\n\n" + elementStrings, container);
    }
    return els[0] || null;
  };
}
function getSuggestionError(suggestion, container) {
  return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container);
}

// this accepts a query function and returns a function which throws an error
// if an empty list of elements is returned
function makeGetAllQuery(allQuery, getMissingError) {
  return function (container) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const els = allQuery(container, ...args);
    if (!els.length) {
      throw getConfig().getElementError(getMissingError(container, ...args), container);
    }
    return els;
  };
}

// this accepts a getter query function and returns a function which calls
// waitFor and passing a function which invokes the getter.
function makeFindQuery(getter) {
  return (container, text, options, waitForOptions) => {
    return waitForWrapper(() => {
      return getter(container, text, options);
    }, {
      container,
      ...waitForOptions
    });
  };
}
const wrapSingleQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  const element = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (element && suggest) {
    const suggestion = getSuggestedQuery(element, variant);
    if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) {
      throw getSuggestionError(suggestion.toString(), container);
    }
  }
  return element;
};
const wrapAllByQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  const els = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (els.length && suggest) {
    // get a unique list of all suggestion messages.  We are only going to make a suggestion if
    // all the suggestions are the same
    const uniqueSuggestionMessages = [...new Set(els.map(element => {
      var _getSuggestedQuery;
      return (_getSuggestedQuery = getSuggestedQuery(element, variant)) == null ? void 0 : _getSuggestedQuery.toString();
    }))];
    if (
    // only want to suggest if all the els have the same suggestion.
    uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
    getSuggestedQuery(els[0], variant).queryName)) {
      throw getSuggestionError(uniqueSuggestionMessages[0], container);
    }
  }
  return els;
};

// TODO: This deviates from the published declarations
// However, the implementation always required a dyadic (after `container`) not variadic `queryAllBy` considering the implementation of `makeFindQuery`
// This is at least statically true and can be verified by accepting `QueryMethod<Arguments, HTMLElement[]>`
function buildQueries(queryAllBy, getMultipleError, getMissingError) {
  const queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError), queryAllBy.name, 'query');
  const getAllBy = makeGetAllQuery(queryAllBy, getMissingError);
  const getBy = makeSingleQuery(getAllBy, getMultipleError);
  const getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'get');
  const getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace('query', 'get'), 'getAll');
  const findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, 'findAll'));
  const findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'find'));
  return [queryBy, getAllWithSuggestions, getByWithSuggestions, findAllBy, findBy];
}

var queryHelpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getElementError: getElementError,
  wrapAllByQueryWithSuggestion: wrapAllByQueryWithSuggestion,
  wrapSingleQueryWithSuggestion: wrapSingleQueryWithSuggestion,
  getMultipleElementsFoundError: getMultipleElementsFoundError,
  queryAllByAttribute: queryAllByAttribute,
  queryByAttribute: queryByAttribute,
  makeSingleQuery: makeSingleQuery,
  makeGetAllQuery: makeGetAllQuery,
  makeFindQuery: makeFindQuery,
  buildQueries: buildQueries
});

function queryAllLabels(container) {
  return Array.from(container.querySelectorAll('label,input')).map(node => {
    return {
      node,
      textToMatch: getLabelContent(node)
    };
  }).filter(_ref => {
    let {
      textToMatch
    } = _ref;
    return textToMatch !== null;
  });
}
const queryAllLabelsByText = function (container, text, _temp) {
  let {
    exact = true,
    trim,
    collapseWhitespace,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const textToMatchByLabels = queryAllLabels(container);
  return textToMatchByLabels.filter(_ref2 => {
    let {
      node,
      textToMatch
    } = _ref2;
    return matcher(textToMatch, node, text, matchNormalizer);
  }).map(_ref3 => {
    let {
      node
    } = _ref3;
    return node;
  });
};
const queryAllByLabelText = function (container, text, _temp2) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp2 === void 0 ? {} : _temp2;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const matchingLabelledElements = Array.from(container.querySelectorAll('*')).filter(element => {
    return getRealLabels(element).length || element.hasAttribute('aria-labelledby');
  }).reduce((labelledElements, labelledElement) => {
    const labelList = dom_esm_getLabels(container, labelledElement, {
      selector
    });
    labelList.filter(label => Boolean(label.formControl)).forEach(label => {
      if (matcher(label.content, label.formControl, text, matchNormalizer) && label.formControl) labelledElements.push(label.formControl);
    });
    const labelsValue = labelList.filter(label => Boolean(label.content)).map(label => label.content);
    if (matcher(labelsValue.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
    if (labelsValue.length > 1) {
      labelsValue.forEach((labelValue, index) => {
        if (matcher(labelValue, labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        const labelsFiltered = [...labelsValue];
        labelsFiltered.splice(index, 1);
        if (labelsFiltered.length > 1) {
          if (matcher(labelsFiltered.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        }
      });
    }
    return labelledElements;
  }, []).concat(queryAllByAttribute('aria-label', container, text, {
    exact,
    normalizer: matchNormalizer
  }));
  return Array.from(new Set(matchingLabelledElements)).filter(element => element.matches(selector));
};

// the getAll* query would normally look like this:
// const getAllByLabelText = makeGetAllQuery(
//   queryAllByLabelText,
//   (c, text) => `Unable to find a label with the text of: ${text}`,
// )
// however, we can give a more helpful error message than the generic one,
// so we're writing this one out by hand.
const getAllByLabelText = function (container, text) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  const els = queryAllByLabelText(container, text, ...rest);
  if (!els.length) {
    const labels = queryAllLabelsByText(container, text, ...rest);
    if (labels.length) {
      const tagNames = labels.map(label => getTagNameOfElementAssociatedWithLabelViaFor(container, label)).filter(tagName => !!tagName);
      if (tagNames.length) {
        throw getConfig().getElementError(tagNames.map(tagName => "Found a label with the text of: " + text + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.").join('\n\n'), container);
      } else {
        throw getConfig().getElementError("Found a label with the text of: " + text + ", however no form control was found associated to that label. Make sure you're using the \"for\" attribute or \"aria-labelledby\" attribute correctly.", container);
      }
    } else {
      throw getConfig().getElementError("Unable to find a label with the text of: " + text, container);
    }
  }
  return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor(container, label) {
  const htmlFor = label.getAttribute('for');
  if (!htmlFor) {
    return null;
  }
  const element = container.querySelector("[id=\"" + htmlFor + "\"]");
  return element ? element.tagName.toLowerCase() : null;
}

// the reason mentioned above is the same reason we're not using buildQueries
const getMultipleError$7 = (c, text) => "Found multiple elements with the text of: " + text;
const queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, 'query');
const getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
const findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'findAll'));
const findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'find'));
const getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'getAll');
const getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'get');
const queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, 'queryAll');

const queryAllByPlaceholderText = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute('placeholder', ...args);
};
const getMultipleError$6 = (c, text) => "Found multiple elements with the placeholder text of: " + text;
const getMissingError$6 = (c, text) => "Unable to find an element with the placeholder text of: " + text;
const queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, 'queryAll');
const [queryByPlaceholderText, getAllByPlaceholderText, getByPlaceholderText, findAllByPlaceholderText, findByPlaceholderText] = buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6);

const queryAllByText = function (container, text, _temp) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    ignore = getConfig().defaultIgnore,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  let baseArray = [];
  if (typeof container.matches === 'function' && container.matches(selector)) {
    baseArray = [container];
  }
  return [...baseArray, ...Array.from(container.querySelectorAll(selector))]
  // TODO: `matches` according lib.dom.d.ts can get only `string` but according our code it can handle also boolean :)
  .filter(node => !ignore || !node.matches(ignore)).filter(node => matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$5 = (c, text) => "Found multiple elements with the text: " + text;
const getMissingError$5 = function (c, text, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    collapseWhitespace,
    trim,
    normalizer,
    selector
  } = options;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const normalizedText = matchNormalizer(text.toString());
  const isNormalizedDifferent = normalizedText !== text.toString();
  const isCustomSelector = (selector != null ? selector : '*') !== '*';
  return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text + "')" : text) + (isCustomSelector ? ", which matches selector '" + selector + "'" : '') + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
const queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, 'queryAll');
const [queryByText, getAllByText, getByText, findAllByText, findByText] = buildQueries(queryAllByText, getMultipleError$5, getMissingError$5);

const queryAllByDisplayValue = function (container, value, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("input,textarea,select")).filter(node => {
    if (node.tagName === 'SELECT') {
      const selectedOptions = Array.from(node.options).filter(option => option.selected);
      return selectedOptions.some(optionNode => matcher(getNodeText(optionNode), optionNode, value, matchNormalizer));
    } else {
      return matcher(node.value, node, value, matchNormalizer);
    }
  });
};
const getMultipleError$4 = (c, value) => "Found multiple elements with the display value: " + value + ".";
const getMissingError$4 = (c, value) => "Unable to find an element with the display value: " + value + ".";
const queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, 'queryAll');
const [queryByDisplayValue, getAllByDisplayValue, getByDisplayValue, findAllByDisplayValue, findByDisplayValue] = buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4);

// Valid tags are img, input, area and custom elements
const VALID_TAG_REGEXP = /^(img|input|area|.+-.+)$/i;
const queryAllByAltText = function (container, alt, options) {
  if (options === void 0) {
    options = {};
  }
  checkContainerType(container);
  return queryAllByAttribute('alt', container, alt, options).filter(node => VALID_TAG_REGEXP.test(node.tagName));
};
const getMultipleError$3 = (c, alt) => "Found multiple elements with the alt text: " + alt;
const getMissingError$3 = (c, alt) => "Unable to find an element with the alt text: " + alt;
const queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, 'queryAll');
const [queryByAltText, getAllByAltText, getByAltText, findAllByAltText, findByAltText] = buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3);

const isSvgTitle = node => {
  var _node$parentElement;
  return node.tagName.toLowerCase() === 'title' && ((_node$parentElement = node.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === 'svg';
};
const queryAllByTitle = function (container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll('[title], svg > title')).filter(node => matcher(node.getAttribute('title'), node, text, matchNormalizer) || isSvgTitle(node) && matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$2 = (c, title) => "Found multiple elements with the title: " + title + ".";
const getMissingError$2 = (c, title) => "Unable to find an element with the title: " + title + ".";
const queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, 'queryAll');
const [queryByTitle, getAllByTitle, getByTitle, findAllByTitle, findByTitle] = buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2);

function queryAllByRole(container, role, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    hidden = getConfig().defaultHidden,
    name,
    description,
    trim,
    normalizer,
    queryFallbacks = false,
    selected,
    checked,
    pressed,
    current,
    level,
    expanded
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  if (selected !== undefined) {
    var _allRoles$get;
    // guard against unknown roles
    if (((_allRoles$get = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get.props['aria-selected']) === undefined) {
      throw new Error("\"aria-selected\" is not supported on role \"" + role + "\".");
    }
  }
  if (checked !== undefined) {
    var _allRoles$get2;
    // guard against unknown roles
    if (((_allRoles$get2 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get2.props['aria-checked']) === undefined) {
      throw new Error("\"aria-checked\" is not supported on role \"" + role + "\".");
    }
  }
  if (pressed !== undefined) {
    var _allRoles$get3;
    // guard against unknown roles
    if (((_allRoles$get3 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get3.props['aria-pressed']) === undefined) {
      throw new Error("\"aria-pressed\" is not supported on role \"" + role + "\".");
    }
  }
  if (current !== undefined) {
    var _allRoles$get4;
    /* istanbul ignore next */
    // guard against unknown roles
    // All currently released ARIA versions support `aria-current` on all roles.
    // Leaving this for symetry and forward compatibility
    if (((_allRoles$get4 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get4.props['aria-current']) === undefined) {
      throw new Error("\"aria-current\" is not supported on role \"" + role + "\".");
    }
  }
  if (level !== undefined) {
    // guard against using `level` option with any role other than `heading`
    if (role !== 'heading') {
      throw new Error("Role \"" + role + "\" cannot have \"level\" property.");
    }
  }
  if (expanded !== undefined) {
    var _allRoles$get5;
    // guard against unknown roles
    if (((_allRoles$get5 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get5.props['aria-expanded']) === undefined) {
      throw new Error("\"aria-expanded\" is not supported on role \"" + role + "\".");
    }
  }
  const subtreeIsInaccessibleCache = new WeakMap();
  function cachedIsSubtreeInaccessible(element) {
    if (!subtreeIsInaccessibleCache.has(element)) {
      subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
    }
    return subtreeIsInaccessibleCache.get(element);
  }
  return Array.from(container.querySelectorAll(
  // Only query elements that can be matched by the following filters
  makeRoleSelector(role, exact, normalizer ? matchNormalizer : undefined))).filter(node => {
    const isRoleSpecifiedExplicitly = node.hasAttribute('role');
    if (isRoleSpecifiedExplicitly) {
      const roleValue = node.getAttribute('role');
      if (queryFallbacks) {
        return roleValue.split(' ').filter(Boolean).some(text => matcher(text, node, role, matchNormalizer));
      }
      // if a custom normalizer is passed then let normalizer handle the role value
      if (normalizer) {
        return matcher(roleValue, node, role, matchNormalizer);
      }
      // other wise only send the first word to match
      const [firstWord] = roleValue.split(' ');
      return matcher(firstWord, node, role, matchNormalizer);
    }
    const implicitRoles = getImplicitAriaRoles(node);
    return implicitRoles.some(implicitRole => matcher(implicitRole, node, role, matchNormalizer));
  }).filter(element => {
    if (selected !== undefined) {
      return selected === computeAriaSelected(element);
    }
    if (checked !== undefined) {
      return checked === computeAriaChecked(element);
    }
    if (pressed !== undefined) {
      return pressed === computeAriaPressed(element);
    }
    if (current !== undefined) {
      return current === computeAriaCurrent(element);
    }
    if (expanded !== undefined) {
      return expanded === computeAriaExpanded(element);
    }
    if (level !== undefined) {
      return level === computeHeadingLevel(element);
    }
    // don't care if aria attributes are unspecified
    return true;
  }).filter(element => {
    if (name === undefined) {
      // Don't care
      return true;
    }
    return matches(computeAccessibleName(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, name, text => text);
  }).filter(element => {
    if (description === undefined) {
      // Don't care
      return true;
    }
    return matches(computeAccessibleDescription(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, description, text => text);
  }).filter(element => {
    return hidden === false ? isInaccessible(element, {
      isSubtreeInaccessible: cachedIsSubtreeInaccessible
    }) === false : true;
  });
}
function makeRoleSelector(role, exact, customNormalizer) {
  var _roleElements$get;
  if (typeof role !== 'string') {
    // For non-string role parameters we can not determine the implicitRoleSelectors.
    return '*';
  }
  const explicitRoleSelector = exact && !customNormalizer ? "*[role~=\"" + role + "\"]" : '*[role]';
  const roleRelations = (_roleElements$get = lib/* roleElements.get */.UN.get(role)) != null ? _roleElements$get : new Set();
  const implicitRoleSelectors = new Set(Array.from(roleRelations).map(_ref => {
    let {
      name
    } = _ref;
    return name;
  }));

  // Current transpilation config sometimes assumes `...` is always applied to arrays.
  // `...` is equivalent to `Array.prototype.concat` for arrays.
  // If you replace this code with `[explicitRoleSelector, ...implicitRoleSelectors]`, make sure every transpilation target retains the `...` in favor of `Array.prototype.concat`.
  return [explicitRoleSelector].concat(Array.from(implicitRoleSelectors)).join(',');
}
const getNameHint = name => {
  let nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  return nameHint;
};
const getMultipleError$1 = function (c, role, _temp2) {
  let {
    name
  } = _temp2 === void 0 ? {} : _temp2;
  return "Found multiple elements with the role \"" + role + "\"" + getNameHint(name);
};
const getMissingError$1 = function (container, role, _temp3) {
  let {
    hidden = getConfig().defaultHidden,
    name,
    description
  } = _temp3 === void 0 ? {} : _temp3;
  if (getConfig()._disableExpensiveErrorDiagnostics) {
    return "Unable to find role=\"" + role + "\"" + getNameHint(name);
  }
  let roles = '';
  Array.from(container.children).forEach(childElement => {
    roles += prettyRoles(childElement, {
      hidden,
      includeDescription: description !== undefined
    });
  });
  let roleMessage;
  if (roles.length === 0) {
    if (hidden === false) {
      roleMessage = 'There are no accessible roles. But there might be some inaccessible roles. ' + 'If you wish to access them, then set the `hidden` option to `true`. ' + 'Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole';
    } else {
      roleMessage = 'There are no available roles.';
    }
  } else {
    roleMessage = ("\nHere are the " + (hidden === false ? 'accessible' : 'available') + " roles:\n\n  " + roles.replace(/\n/g, '\n  ').replace(/\n\s\s\n/g, '\n\n') + "\n").trim();
  }
  let nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  let descriptionHint = '';
  if (description === undefined) {
    descriptionHint = '';
  } else if (typeof description === 'string') {
    descriptionHint = " and description \"" + description + "\"";
  } else {
    descriptionHint = " and description `" + description + "`";
  }
  return ("\nUnable to find an " + (hidden === false ? 'accessible ' : '') + "element with the role \"" + role + "\"" + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};
const queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, 'queryAll');
const [queryByRole, getAllByRole, getByRole, findAllByRole, findByRole] = buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1);

const getTestIdAttribute = () => getConfig().testIdAttribute;
const queryAllByTestId = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute(getTestIdAttribute(), ...args);
};
const getMultipleError = (c, id) => "Found multiple elements by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
const getMissingError = (c, id) => "Unable to find an element by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
const queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, 'queryAll');
const [queryByTestId, getAllByTestId, getByTestId, findAllByTestId, findByTestId] = buildQueries(queryAllByTestId, getMultipleError, getMissingError);

var queries = /*#__PURE__*/Object.freeze({
  __proto__: null,
  queryAllByLabelText: queryAllByLabelTextWithSuggestions,
  queryByLabelText: queryByLabelText,
  getAllByLabelText: getAllByLabelTextWithSuggestions,
  getByLabelText: getByLabelTextWithSuggestions,
  findAllByLabelText: findAllByLabelText,
  findByLabelText: findByLabelText,
  queryByPlaceholderText: queryByPlaceholderText,
  queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
  getByPlaceholderText: getByPlaceholderText,
  getAllByPlaceholderText: getAllByPlaceholderText,
  findAllByPlaceholderText: findAllByPlaceholderText,
  findByPlaceholderText: findByPlaceholderText,
  queryByText: queryByText,
  queryAllByText: queryAllByTextWithSuggestions,
  getByText: getByText,
  getAllByText: getAllByText,
  findAllByText: findAllByText,
  findByText: findByText,
  queryByDisplayValue: queryByDisplayValue,
  queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
  getByDisplayValue: getByDisplayValue,
  getAllByDisplayValue: getAllByDisplayValue,
  findAllByDisplayValue: findAllByDisplayValue,
  findByDisplayValue: findByDisplayValue,
  queryByAltText: queryByAltText,
  queryAllByAltText: queryAllByAltTextWithSuggestions,
  getByAltText: getByAltText,
  getAllByAltText: getAllByAltText,
  findAllByAltText: findAllByAltText,
  findByAltText: findByAltText,
  queryByTitle: queryByTitle,
  queryAllByTitle: queryAllByTitleWithSuggestions,
  getByTitle: getByTitle,
  getAllByTitle: getAllByTitle,
  findAllByTitle: findAllByTitle,
  findByTitle: findByTitle,
  queryByRole: queryByRole,
  queryAllByRole: queryAllByRoleWithSuggestions,
  getAllByRole: getAllByRole,
  getByRole: getByRole,
  findAllByRole: findAllByRole,
  findByRole: findByRole,
  queryByTestId: queryByTestId,
  queryAllByTestId: queryAllByTestIdWithSuggestions,
  getByTestId: getByTestId,
  getAllByTestId: getAllByTestId,
  findAllByTestId: findAllByTestId,
  findByTestId: findByTestId
});

/**
 * @typedef {{[key: string]: Function}} FuncMap
 */

/**
 * @param {HTMLElement} element container
 * @param {FuncMap} queries object of functions
 * @param {Object} initialValue for reducer
 * @returns {FuncMap} returns object of functions bound to container
 */
function getQueriesForElement(element, queries$1, initialValue) {
  if (queries$1 === void 0) {
    queries$1 = queries;
  }
  if (initialValue === void 0) {
    initialValue = {};
  }
  return Object.keys(queries$1).reduce((helpers, key) => {
    const fn = queries$1[key];
    helpers[key] = fn.bind(null, element);
    return helpers;
  }, initialValue);
}

const isRemoved = result => !result || Array.isArray(result) && !result.length;

// Check if the element is not present.
// As the name implies, waitForElementToBeRemoved should check `present` --> `removed`
function initialCheck(elements) {
  if (isRemoved(elements)) {
    throw new Error('The element(s) given to waitForElementToBeRemoved are already removed. waitForElementToBeRemoved requires that the element(s) exist(s) before waiting for removal.');
  }
}
async function waitForElementToBeRemoved(callback, options) {
  // created here so we get a nice stacktrace
  const timeoutError = new Error('Timed out in waitForElementToBeRemoved.');
  if (typeof callback !== 'function') {
    initialCheck(callback);
    const elements = Array.isArray(callback) ? callback : [callback];
    const getRemainingElements = elements.map(element => {
      let parent = element.parentElement;
      if (parent === null) return () => null;
      while (parent.parentElement) parent = parent.parentElement;
      return () => parent.contains(element) ? element : null;
    });
    callback = () => getRemainingElements.map(c => c()).filter(Boolean);
  }
  initialCheck(callback());
  return waitForWrapper(() => {
    let result;
    try {
      result = callback();
    } catch (error) {
      if (error.name === 'TestingLibraryElementError') {
        return undefined;
      }
      throw error;
    }
    if (!isRemoved(result)) {
      throw timeoutError;
    }
    return undefined;
  }, options);
}

/*
eslint
  require-await: "off"
*/

const eventMap = {
  // Clipboard Events
  copy: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  cut: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  paste: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionStart: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionUpdate: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyPress: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyUp: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  // Focus Events
  focus: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  blur: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  focusIn: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  focusOut: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // Form Events
  change: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  input: {
    EventType: 'InputEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  invalid: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: true
    }
  },
  submit: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  reset: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // Mouse Events
  click: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      button: 0,
      composed: true
    }
  },
  contextMenu: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dblClick: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drag: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragEnd: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragEnter: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragExit: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragLeave: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragOver: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragStart: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drop: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseDown: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseEnter: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseLeave: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseMove: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOut: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOver: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseUp: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Selection Events
  select: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Touch Events
  touchCancel: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  touchEnd: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchMove: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchStart: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // UI Events
  resize: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  scroll: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Wheel Events
  wheel: {
    EventType: 'WheelEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Media Events
  abort: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlay: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlayThrough: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  durationChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  emptied: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  encrypted: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  ended: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedData: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedMetadata: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadStart: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pause: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  play: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  playing: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  progress: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  rateChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeked: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeking: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  stalled: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  suspend: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  timeUpdate: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  volumeChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  waiting: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  error: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Animation Events
  animationStart: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationEnd: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationIteration: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionEnd: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  transitionRun: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionStart: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // pointer events
  pointerOver: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerEnter: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pointerDown: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerMove: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerUp: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerCancel: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  pointerOut: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerLeave: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  gotPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  lostPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // history events
  popState: {
    EventType: 'PopStateEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // window events
  offline: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  online: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  }
};
const eventAliasMap = {
  doubleClick: 'dblClick'
};

function fireEvent(element, event) {
  return getConfig().eventWrapper(() => {
    if (!event) {
      throw new Error("Unable to fire an event - please provide an event object.");
    }
    if (!element) {
      throw new Error("Unable to fire a \"" + event.type + "\" event - please provide a DOM element.");
    }
    return element.dispatchEvent(event);
  });
}
function createEvent(eventName, node, init, _temp) {
  let {
    EventType = 'Event',
    defaultInit = {}
  } = _temp === void 0 ? {} : _temp;
  if (!node) {
    throw new Error("Unable to fire a \"" + eventName + "\" event - please provide a DOM element.");
  }
  const eventInit = {
    ...defaultInit,
    ...init
  };
  const {
    target: {
      value,
      files,
      ...targetProperties
    } = {}
  } = eventInit;
  if (value !== undefined) {
    setNativeValue(node, value);
  }
  if (files !== undefined) {
    // input.files is a read-only property so this is not allowed:
    // input.files = [file]
    // so we have to use this workaround to set the property
    Object.defineProperty(node, 'files', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: files
    });
  }
  Object.assign(node, targetProperties);
  const window = getWindowFromNode(node);
  const EventConstructor = window[EventType] || window.Event;
  let event;
  /* istanbul ignore else  */
  if (typeof EventConstructor === 'function') {
    event = new EventConstructor(eventName, eventInit);
  } else {
    // IE11 polyfill from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
    event = window.document.createEvent(EventType);
    const {
      bubbles,
      cancelable,
      detail,
      ...otherInit
    } = eventInit;
    event.initEvent(eventName, bubbles, cancelable, detail);
    Object.keys(otherInit).forEach(eventKey => {
      event[eventKey] = otherInit[eventKey];
    });
  }

  // DataTransfer is not supported in jsdom: https://github.com/jsdom/jsdom/issues/1568
  const dataTransferProperties = ['dataTransfer', 'clipboardData'];
  dataTransferProperties.forEach(dataTransferKey => {
    const dataTransferValue = eventInit[dataTransferKey];
    if (typeof dataTransferValue === 'object') {
      /* istanbul ignore if  */
      if (typeof window.DataTransfer === 'function') {
        Object.defineProperty(event, dataTransferKey, {
          value: Object.getOwnPropertyNames(dataTransferValue).reduce((acc, propName) => {
            Object.defineProperty(acc, propName, {
              value: dataTransferValue[propName]
            });
            return acc;
          }, new window.DataTransfer())
        });
      } else {
        Object.defineProperty(event, dataTransferKey, {
          value: dataTransferValue
        });
      }
    }
  });
  return event;
}
Object.keys(eventMap).forEach(key => {
  const {
    EventType,
    defaultInit
  } = eventMap[key];
  const eventName = key.toLowerCase();
  createEvent[key] = (node, init) => createEvent(eventName, node, init, {
    EventType,
    defaultInit
  });
  fireEvent[key] = (node, init) => fireEvent(node, createEvent[key](node, init));
});

// function written after some investigation here:
// https://github.com/facebook/react/issues/10135#issuecomment-401496776
function setNativeValue(element, value) {
  const {
    set: valueSetter
  } = Object.getOwnPropertyDescriptor(element, 'value') || {};
  const prototype = Object.getPrototypeOf(element);
  const {
    set: prototypeValueSetter
  } = Object.getOwnPropertyDescriptor(prototype, 'value') || {};
  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    /* istanbul ignore if */
    // eslint-disable-next-line no-lonely-if -- Can't be ignored by istanbul otherwise
    if (valueSetter) {
      valueSetter.call(element, value);
    } else {
      throw new Error('The given element does not have a value setter');
    }
  }
}
Object.keys(eventAliasMap).forEach(aliasKey => {
  const key = eventAliasMap[aliasKey];
  fireEvent[aliasKey] = function () {
    return fireEvent[key](...arguments);
  };
});

/* eslint complexity:["error", 9] */

// WARNING: `lz-string` only has a default export but statically we assume named exports are allowd
function unindent(string) {
  // remove white spaces first, to save a few bytes.
  // testing-playground will reformat on load any ways.
  return string.replace(/[ \t]*[\n][ \t]*/g, '\n');
}
function encode(value) {
  return lz_string_default().compressToEncodedURIComponent(unindent(value));
}
function getPlaygroundUrl(markup) {
  return "https://testing-playground.com/#markup=" + encode(markup);
}
const debug = (element, maxLength, options) => Array.isArray(element) ? element.forEach(el => logDOM(el, maxLength, options)) : logDOM(element, maxLength, options);
const logTestingPlaygroundURL = function (element) {
  if (element === void 0) {
    element = getDocument().body;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!element || !('innerHTML' in element)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!element.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  const playgroundUrl = getPlaygroundUrl(element.innerHTML);
  console.log("Open this URL in your browser\n\n" + playgroundUrl);
  return playgroundUrl;
};
const initialValue = {
  debug,
  logTestingPlaygroundURL
};
const screen = typeof document !== 'undefined' && document.body // eslint-disable-line @typescript-eslint/no-unnecessary-condition
? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce((helpers, key) => {
  // `key` is for all intents and purposes the type of keyof `helpers`, which itself is the type of `initialValue` plus incoming properties from `queries`
  // if `Object.keys(something)` returned Array<keyof typeof something> this explicit type assertion would not be necessary
  // see https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
  helpers[key] = () => {
    throw new TypeError('For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error');
  };
  return helpers;
}, initialValue);




/***/ }),

/***/ 76429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


const ANSI_BACKGROUND_OFFSET = 10;

const wrapAnsi256 = (offset = 0) => code => `\u001B[${38 + offset};5;${code}m`;

const wrapAnsi16m = (offset = 0) => (red, green, blue) => `\u001B[${38 + offset};2;${red};${green};${blue}m`;

function assembleStyles() {
	const codes = new Map();
	const styles = {
		modifier: {
			reset: [0, 0],
			// 21 isn't widely supported and 22 does the same thing
			bold: [1, 22],
			dim: [2, 22],
			italic: [3, 23],
			underline: [4, 24],
			overline: [53, 55],
			inverse: [7, 27],
			hidden: [8, 28],
			strikethrough: [9, 29]
		},
		color: {
			black: [30, 39],
			red: [31, 39],
			green: [32, 39],
			yellow: [33, 39],
			blue: [34, 39],
			magenta: [35, 39],
			cyan: [36, 39],
			white: [37, 39],

			// Bright color
			blackBright: [90, 39],
			redBright: [91, 39],
			greenBright: [92, 39],
			yellowBright: [93, 39],
			blueBright: [94, 39],
			magentaBright: [95, 39],
			cyanBright: [96, 39],
			whiteBright: [97, 39]
		},
		bgColor: {
			bgBlack: [40, 49],
			bgRed: [41, 49],
			bgGreen: [42, 49],
			bgYellow: [43, 49],
			bgBlue: [44, 49],
			bgMagenta: [45, 49],
			bgCyan: [46, 49],
			bgWhite: [47, 49],

			// Bright color
			bgBlackBright: [100, 49],
			bgRedBright: [101, 49],
			bgGreenBright: [102, 49],
			bgYellowBright: [103, 49],
			bgBlueBright: [104, 49],
			bgMagentaBright: [105, 49],
			bgCyanBright: [106, 49],
			bgWhiteBright: [107, 49]
		}
	};

	// Alias bright black as gray (and grey)
	styles.color.gray = styles.color.blackBright;
	styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
	styles.color.grey = styles.color.blackBright;
	styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;

	for (const [groupName, group] of Object.entries(styles)) {
		for (const [styleName, style] of Object.entries(group)) {
			styles[styleName] = {
				open: `\u001B[${style[0]}m`,
				close: `\u001B[${style[1]}m`
			};

			group[styleName] = styles[styleName];

			codes.set(style[0], style[1]);
		}

		Object.defineProperty(styles, groupName, {
			value: group,
			enumerable: false
		});
	}

	Object.defineProperty(styles, 'codes', {
		value: codes,
		enumerable: false
	});

	styles.color.close = '\u001B[39m';
	styles.bgColor.close = '\u001B[49m';

	styles.color.ansi256 = wrapAnsi256();
	styles.color.ansi16m = wrapAnsi16m();
	styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
	styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);

	// From https://github.com/Qix-/color-convert/blob/3f0e0d4e92e235796ccb17f6e85c72094a651f49/conversions.js
	Object.defineProperties(styles, {
		rgbToAnsi256: {
			value: (red, green, blue) => {
				// We use the extended greyscale palette here, with the exception of
				// black and white. normal palette only has 4 greyscale shades.
				if (red === green && green === blue) {
					if (red < 8) {
						return 16;
					}

					if (red > 248) {
						return 231;
					}

					return Math.round(((red - 8) / 247) * 24) + 232;
				}

				return 16 +
					(36 * Math.round(red / 255 * 5)) +
					(6 * Math.round(green / 255 * 5)) +
					Math.round(blue / 255 * 5);
			},
			enumerable: false
		},
		hexToRgb: {
			value: hex => {
				const matches = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex.toString(16));
				if (!matches) {
					return [0, 0, 0];
				}

				let {colorString} = matches.groups;

				if (colorString.length === 3) {
					colorString = colorString.split('').map(character => character + character).join('');
				}

				const integer = Number.parseInt(colorString, 16);

				return [
					(integer >> 16) & 0xFF,
					(integer >> 8) & 0xFF,
					integer & 0xFF
				];
			},
			enumerable: false
		},
		hexToAnsi256: {
			value: hex => styles.rgbToAnsi256(...styles.hexToRgb(hex)),
			enumerable: false
		}
	});

	return styles;
}

// Make the export immutable
Object.defineProperty(module, 'exports', {
	enumerable: true,
	get: assembleStyles
});


/***/ }),

/***/ 31551:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printIteratorEntries = printIteratorEntries;
exports.printIteratorValues = printIteratorValues;
exports.printListItems = printListItems;
exports.printObjectProperties = printObjectProperties;

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const getKeysOfEnumerableProperties = (object, compareKeys) => {
  const keys = Object.keys(object).sort(compareKeys);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(object).forEach(symbol => {
      if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) {
        keys.push(symbol);
      }
    });
  }

  return keys;
};
/**
 * Return entries (for example, of a map)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */

function printIteratorEntries(
  iterator,
  config,
  indentation,
  depth,
  refs,
  printer, // Too bad, so sad that separator for ECMAScript Map has been ' => '
  // What a distracting diff if you change a data structure to/from
  // ECMAScript Object or Immutable.Map/OrderedMap which use the default.
  separator = ': '
) {
  let result = '';
  let current = iterator.next();

  if (!current.done) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    while (!current.done) {
      const name = printer(
        current.value[0],
        config,
        indentationNext,
        depth,
        refs
      );
      const value = printer(
        current.value[1],
        config,
        indentationNext,
        depth,
        refs
      );
      result += indentationNext + name + separator + value;
      current = iterator.next();

      if (!current.done) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return values (for example, of a set)
 * with spacing, indentation, and comma
 * without surrounding punctuation (braces or brackets)
 */

function printIteratorValues(
  iterator,
  config,
  indentation,
  depth,
  refs,
  printer
) {
  let result = '';
  let current = iterator.next();

  if (!current.done) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    while (!current.done) {
      result +=
        indentationNext +
        printer(current.value, config, indentationNext, depth, refs);
      current = iterator.next();

      if (!current.done) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return items (for example, of an array)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, brackets)
 **/

function printListItems(list, config, indentation, depth, refs, printer) {
  let result = '';

  if (list.length) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    for (let i = 0; i < list.length; i++) {
      result += indentationNext;

      if (i in list) {
        result += printer(list[i], config, indentationNext, depth, refs);
      }

      if (i < list.length - 1) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return properties of an object
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */

function printObjectProperties(val, config, indentation, depth, refs, printer) {
  let result = '';
  const keys = getKeysOfEnumerableProperties(val, config.compareKeys);

  if (keys.length) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const name = printer(key, config, indentationNext, depth, refs);
      const value = printer(val[key], config, indentationNext, depth, refs);
      result += indentationNext + name + ': ' + value;

      if (i < keys.length - 1) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}


/***/ }),

/***/ 57739:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = void 0;
exports.WU = format;
exports.Gr = void 0;

var _ansiStyles = _interopRequireDefault(__webpack_require__(76429));

var _collections = __webpack_require__(31551);

var _AsymmetricMatcher = _interopRequireDefault(
  __webpack_require__(38215)
);

var _ConvertAnsi = _interopRequireDefault(__webpack_require__(81635));

var _DOMCollection = _interopRequireDefault(__webpack_require__(50655));

var _DOMElement = _interopRequireDefault(__webpack_require__(4425));

var _Immutable = _interopRequireDefault(__webpack_require__(51727));

var _ReactElement = _interopRequireDefault(__webpack_require__(87247));

var _ReactTestComponent = _interopRequireDefault(
  __webpack_require__(85642)
);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable local/ban-types-eventually */
const toString = Object.prototype.toString;
const toISOString = Date.prototype.toISOString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
/**
 * Explicitly comparing typeof constructor to function avoids undefined as name
 * when mock identity-obj-proxy returns the key as the value for any key.
 */

const getConstructorName = val =>
  (typeof val.constructor === 'function' && val.constructor.name) || 'Object';
/* global window */

/** Is val is equal to global window object? Works even if it does not exist :) */

const isWindow = val => typeof window !== 'undefined' && val === window;

const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
const NEWLINE_REGEXP = /\n/gi;

class PrettyFormatPluginError extends Error {
  constructor(message, stack) {
    super(message);
    this.stack = stack;
    this.name = this.constructor.name;
  }
}

function isToStringedArrayType(toStringed) {
  return (
    toStringed === '[object Array]' ||
    toStringed === '[object ArrayBuffer]' ||
    toStringed === '[object DataView]' ||
    toStringed === '[object Float32Array]' ||
    toStringed === '[object Float64Array]' ||
    toStringed === '[object Int8Array]' ||
    toStringed === '[object Int16Array]' ||
    toStringed === '[object Int32Array]' ||
    toStringed === '[object Uint8Array]' ||
    toStringed === '[object Uint8ClampedArray]' ||
    toStringed === '[object Uint16Array]' ||
    toStringed === '[object Uint32Array]'
  );
}

function printNumber(val) {
  return Object.is(val, -0) ? '-0' : String(val);
}

function printBigInt(val) {
  return String(`${val}n`);
}

function printFunction(val, printFunctionName) {
  if (!printFunctionName) {
    return '[Function]';
  }

  return '[Function ' + (val.name || 'anonymous') + ']';
}

function printSymbol(val) {
  return String(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
}

function printError(val) {
  return '[' + errorToString.call(val) + ']';
}
/**
 * The first port of call for printing an object, handles most of the
 * data-types in JS.
 */

function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
  if (val === true || val === false) {
    return '' + val;
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (val === null) {
    return 'null';
  }

  const typeOf = typeof val;

  if (typeOf === 'number') {
    return printNumber(val);
  }

  if (typeOf === 'bigint') {
    return printBigInt(val);
  }

  if (typeOf === 'string') {
    if (escapeString) {
      return '"' + val.replace(/"|\\/g, '\\$&') + '"';
    }

    return '"' + val + '"';
  }

  if (typeOf === 'function') {
    return printFunction(val, printFunctionName);
  }

  if (typeOf === 'symbol') {
    return printSymbol(val);
  }

  const toStringed = toString.call(val);

  if (toStringed === '[object WeakMap]') {
    return 'WeakMap {}';
  }

  if (toStringed === '[object WeakSet]') {
    return 'WeakSet {}';
  }

  if (
    toStringed === '[object Function]' ||
    toStringed === '[object GeneratorFunction]'
  ) {
    return printFunction(val, printFunctionName);
  }

  if (toStringed === '[object Symbol]') {
    return printSymbol(val);
  }

  if (toStringed === '[object Date]') {
    return isNaN(+val) ? 'Date { NaN }' : toISOString.call(val);
  }

  if (toStringed === '[object Error]') {
    return printError(val);
  }

  if (toStringed === '[object RegExp]') {
    if (escapeRegex) {
      // https://github.com/benjamingr/RegExp.escape/blob/main/polyfill.js
      return regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    return regExpToString.call(val);
  }

  if (val instanceof Error) {
    return printError(val);
  }

  return null;
}
/**
 * Handles more complex objects ( such as objects with circular references.
 * maps and sets etc )
 */

function printComplexValue(
  val,
  config,
  indentation,
  depth,
  refs,
  hasCalledToJSON
) {
  if (refs.indexOf(val) !== -1) {
    return '[Circular]';
  }

  refs = refs.slice();
  refs.push(val);
  const hitMaxDepth = ++depth > config.maxDepth;
  const min = config.min;

  if (
    config.callToJSON &&
    !hitMaxDepth &&
    val.toJSON &&
    typeof val.toJSON === 'function' &&
    !hasCalledToJSON
  ) {
    return printer(val.toJSON(), config, indentation, depth, refs, true);
  }

  const toStringed = toString.call(val);

  if (toStringed === '[object Arguments]') {
    return hitMaxDepth
      ? '[Arguments]'
      : (min ? '' : 'Arguments ') +
          '[' +
          (0, _collections.printListItems)(
            val,
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          ']';
  }

  if (isToStringedArrayType(toStringed)) {
    return hitMaxDepth
      ? '[' + val.constructor.name + ']'
      : (min
          ? ''
          : !config.printBasicPrototype && val.constructor.name === 'Array'
          ? ''
          : val.constructor.name + ' ') +
          '[' +
          (0, _collections.printListItems)(
            val,
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          ']';
  }

  if (toStringed === '[object Map]') {
    return hitMaxDepth
      ? '[Map]'
      : 'Map {' +
          (0, _collections.printIteratorEntries)(
            val.entries(),
            config,
            indentation,
            depth,
            refs,
            printer,
            ' => '
          ) +
          '}';
  }

  if (toStringed === '[object Set]') {
    return hitMaxDepth
      ? '[Set]'
      : 'Set {' +
          (0, _collections.printIteratorValues)(
            val.values(),
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          '}';
  } // Avoid failure to serialize global window object in jsdom test environment.
  // For example, not even relevant if window is prop of React element.

  return hitMaxDepth || isWindow(val)
    ? '[' + getConstructorName(val) + ']'
    : (min
        ? ''
        : !config.printBasicPrototype && getConstructorName(val) === 'Object'
        ? ''
        : getConstructorName(val) + ' ') +
        '{' +
        (0, _collections.printObjectProperties)(
          val,
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}';
}

function isNewPlugin(plugin) {
  return plugin.serialize != null;
}

function printPlugin(plugin, val, config, indentation, depth, refs) {
  let printed;

  try {
    printed = isNewPlugin(plugin)
      ? plugin.serialize(val, config, indentation, depth, refs, printer)
      : plugin.print(
          val,
          valChild => printer(valChild, config, indentation, depth, refs),
          str => {
            const indentationNext = indentation + config.indent;
            return (
              indentationNext +
              str.replace(NEWLINE_REGEXP, '\n' + indentationNext)
            );
          },
          {
            edgeSpacing: config.spacingOuter,
            min: config.min,
            spacing: config.spacingInner
          },
          config.colors
        );
  } catch (error) {
    throw new PrettyFormatPluginError(error.message, error.stack);
  }

  if (typeof printed !== 'string') {
    throw new Error(
      `pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`
    );
  }

  return printed;
}

function findPlugin(plugins, val) {
  for (let p = 0; p < plugins.length; p++) {
    try {
      if (plugins[p].test(val)) {
        return plugins[p];
      }
    } catch (error) {
      throw new PrettyFormatPluginError(error.message, error.stack);
    }
  }

  return null;
}

function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
  const plugin = findPlugin(config.plugins, val);

  if (plugin !== null) {
    return printPlugin(plugin, val, config, indentation, depth, refs);
  }

  const basicResult = printBasicValue(
    val,
    config.printFunctionName,
    config.escapeRegex,
    config.escapeString
  );

  if (basicResult !== null) {
    return basicResult;
  }

  return printComplexValue(
    val,
    config,
    indentation,
    depth,
    refs,
    hasCalledToJSON
  );
}

const DEFAULT_THEME = {
  comment: 'gray',
  content: 'reset',
  prop: 'yellow',
  tag: 'cyan',
  value: 'green'
};
const DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
const DEFAULT_OPTIONS = {
  callToJSON: true,
  compareKeys: undefined,
  escapeRegex: false,
  escapeString: true,
  highlight: false,
  indent: 2,
  maxDepth: Infinity,
  min: false,
  plugins: [],
  printBasicPrototype: true,
  printFunctionName: true,
  theme: DEFAULT_THEME
};
__webpack_unused_export__ = DEFAULT_OPTIONS;

function validateOptions(options) {
  Object.keys(options).forEach(key => {
    if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
      throw new Error(`pretty-format: Unknown option "${key}".`);
    }
  });

  if (options.min && options.indent !== undefined && options.indent !== 0) {
    throw new Error(
      'pretty-format: Options "min" and "indent" cannot be used together.'
    );
  }

  if (options.theme !== undefined) {
    if (options.theme === null) {
      throw new Error('pretty-format: Option "theme" must not be null.');
    }

    if (typeof options.theme !== 'object') {
      throw new Error(
        `pretty-format: Option "theme" must be of type "object" but instead received "${typeof options.theme}".`
      );
    }
  }
}

const getColorsHighlight = options =>
  DEFAULT_THEME_KEYS.reduce((colors, key) => {
    const value =
      options.theme && options.theme[key] !== undefined
        ? options.theme[key]
        : DEFAULT_THEME[key];
    const color = value && _ansiStyles.default[value];

    if (
      color &&
      typeof color.close === 'string' &&
      typeof color.open === 'string'
    ) {
      colors[key] = color;
    } else {
      throw new Error(
        `pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`
      );
    }

    return colors;
  }, Object.create(null));

const getColorsEmpty = () =>
  DEFAULT_THEME_KEYS.reduce((colors, key) => {
    colors[key] = {
      close: '',
      open: ''
    };
    return colors;
  }, Object.create(null));

const getPrintFunctionName = options =>
  options && options.printFunctionName !== undefined
    ? options.printFunctionName
    : DEFAULT_OPTIONS.printFunctionName;

const getEscapeRegex = options =>
  options && options.escapeRegex !== undefined
    ? options.escapeRegex
    : DEFAULT_OPTIONS.escapeRegex;

const getEscapeString = options =>
  options && options.escapeString !== undefined
    ? options.escapeString
    : DEFAULT_OPTIONS.escapeString;

const getConfig = options => {
  var _options$printBasicPr;

  return {
    callToJSON:
      options && options.callToJSON !== undefined
        ? options.callToJSON
        : DEFAULT_OPTIONS.callToJSON,
    colors:
      options && options.highlight
        ? getColorsHighlight(options)
        : getColorsEmpty(),
    compareKeys:
      options && typeof options.compareKeys === 'function'
        ? options.compareKeys
        : DEFAULT_OPTIONS.compareKeys,
    escapeRegex: getEscapeRegex(options),
    escapeString: getEscapeString(options),
    indent:
      options && options.min
        ? ''
        : createIndent(
            options && options.indent !== undefined
              ? options.indent
              : DEFAULT_OPTIONS.indent
          ),
    maxDepth:
      options && options.maxDepth !== undefined
        ? options.maxDepth
        : DEFAULT_OPTIONS.maxDepth,
    min:
      options && options.min !== undefined ? options.min : DEFAULT_OPTIONS.min,
    plugins:
      options && options.plugins !== undefined
        ? options.plugins
        : DEFAULT_OPTIONS.plugins,
    printBasicPrototype:
      (_options$printBasicPr =
        options === null || options === void 0
          ? void 0
          : options.printBasicPrototype) !== null &&
      _options$printBasicPr !== void 0
        ? _options$printBasicPr
        : true,
    printFunctionName: getPrintFunctionName(options),
    spacingInner: options && options.min ? ' ' : '\n',
    spacingOuter: options && options.min ? '' : '\n'
  };
};

function createIndent(indent) {
  return new Array(indent + 1).join(' ');
}
/**
 * Returns a presentation string of your `val` object
 * @param val any potential JavaScript object
 * @param options Custom settings
 */

function format(val, options) {
  if (options) {
    validateOptions(options);

    if (options.plugins) {
      const plugin = findPlugin(options.plugins, val);

      if (plugin !== null) {
        return printPlugin(plugin, val, getConfig(options), '', 0, []);
      }
    }
  }

  const basicResult = printBasicValue(
    val,
    getPrintFunctionName(options),
    getEscapeRegex(options),
    getEscapeString(options)
  );

  if (basicResult !== null) {
    return basicResult;
  }

  return printComplexValue(val, getConfig(options), '', 0, []);
}

const plugins = {
  AsymmetricMatcher: _AsymmetricMatcher.default,
  ConvertAnsi: _ConvertAnsi.default,
  DOMCollection: _DOMCollection.default,
  DOMElement: _DOMElement.default,
  Immutable: _Immutable.default,
  ReactElement: _ReactElement.default,
  ReactTestComponent: _ReactTestComponent.default
};
exports.Gr = plugins;
var _default = format;
__webpack_unused_export__ = _default;


/***/ }),

/***/ 38215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(31551);

var global = (function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')();
  }
})();

var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
const asymmetricMatcher =
  typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('jest.asymmetricMatcher')
    : 0x1357a5;
const SPACE = ' ';

const serialize = (val, config, indentation, depth, refs, printer) => {
  const stringedValue = val.toString();

  if (
    stringedValue === 'ArrayContaining' ||
    stringedValue === 'ArrayNotContaining'
  ) {
    if (++depth > config.maxDepth) {
      return '[' + stringedValue + ']';
    }

    return (
      stringedValue +
      SPACE +
      '[' +
      (0, _collections.printListItems)(
        val.sample,
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      ']'
    );
  }

  if (
    stringedValue === 'ObjectContaining' ||
    stringedValue === 'ObjectNotContaining'
  ) {
    if (++depth > config.maxDepth) {
      return '[' + stringedValue + ']';
    }

    return (
      stringedValue +
      SPACE +
      '{' +
      (0, _collections.printObjectProperties)(
        val.sample,
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      '}'
    );
  }

  if (
    stringedValue === 'StringMatching' ||
    stringedValue === 'StringNotMatching'
  ) {
    return (
      stringedValue +
      SPACE +
      printer(val.sample, config, indentation, depth, refs)
    );
  }

  if (
    stringedValue === 'StringContaining' ||
    stringedValue === 'StringNotContaining'
  ) {
    return (
      stringedValue +
      SPACE +
      printer(val.sample, config, indentation, depth, refs)
    );
  }

  return val.toAsymmetricMatcher();
};

exports.serialize = serialize;

const test = val => val && val.$$typeof === asymmetricMatcher;

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 81635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _ansiRegex = _interopRequireDefault(__webpack_require__(29470));

var _ansiStyles = _interopRequireDefault(__webpack_require__(76429));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const toHumanReadableAnsi = text =>
  text.replace((0, _ansiRegex.default)(), match => {
    switch (match) {
      case _ansiStyles.default.red.close:
      case _ansiStyles.default.green.close:
      case _ansiStyles.default.cyan.close:
      case _ansiStyles.default.gray.close:
      case _ansiStyles.default.white.close:
      case _ansiStyles.default.yellow.close:
      case _ansiStyles.default.bgRed.close:
      case _ansiStyles.default.bgGreen.close:
      case _ansiStyles.default.bgYellow.close:
      case _ansiStyles.default.inverse.close:
      case _ansiStyles.default.dim.close:
      case _ansiStyles.default.bold.close:
      case _ansiStyles.default.reset.open:
      case _ansiStyles.default.reset.close:
        return '</>';

      case _ansiStyles.default.red.open:
        return '<red>';

      case _ansiStyles.default.green.open:
        return '<green>';

      case _ansiStyles.default.cyan.open:
        return '<cyan>';

      case _ansiStyles.default.gray.open:
        return '<gray>';

      case _ansiStyles.default.white.open:
        return '<white>';

      case _ansiStyles.default.yellow.open:
        return '<yellow>';

      case _ansiStyles.default.bgRed.open:
        return '<bgRed>';

      case _ansiStyles.default.bgGreen.open:
        return '<bgGreen>';

      case _ansiStyles.default.bgYellow.open:
        return '<bgYellow>';

      case _ansiStyles.default.inverse.open:
        return '<inverse>';

      case _ansiStyles.default.dim.open:
        return '<dim>';

      case _ansiStyles.default.bold.open:
        return '<bold>';

      default:
        return '';
    }
  });

const test = val =>
  typeof val === 'string' && !!val.match((0, _ansiRegex.default)());

exports.test = test;

const serialize = (val, config, indentation, depth, refs, printer) =>
  printer(toHumanReadableAnsi(val), config, indentation, depth, refs);

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 50655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(31551);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable local/ban-types-eventually */
const SPACE = ' ';
const OBJECT_NAMES = ['DOMStringMap', 'NamedNodeMap'];
const ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;

const testName = name =>
  OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name);

const test = val =>
  val &&
  val.constructor &&
  !!val.constructor.name &&
  testName(val.constructor.name);

exports.test = test;

const isNamedNodeMap = collection =>
  collection.constructor.name === 'NamedNodeMap';

const serialize = (collection, config, indentation, depth, refs, printer) => {
  const name = collection.constructor.name;

  if (++depth > config.maxDepth) {
    return '[' + name + ']';
  }

  return (
    (config.min ? '' : name + SPACE) +
    (OBJECT_NAMES.indexOf(name) !== -1
      ? '{' +
        (0, _collections.printObjectProperties)(
          isNamedNodeMap(collection)
            ? Array.from(collection).reduce((props, attribute) => {
                props[attribute.name] = attribute.value;
                return props;
              }, {})
            : {...collection},
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}'
      : '[' +
        (0, _collections.printListItems)(
          Array.from(collection),
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        ']')
  );
};

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 4425:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _markup = __webpack_require__(54092);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const ELEMENT_NODE = 1;
const TEXT_NODE = 3;
const COMMENT_NODE = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;

const testHasAttribute = val => {
  try {
    return typeof val.hasAttribute === 'function' && val.hasAttribute('is');
  } catch {
    return false;
  }
};

const testNode = val => {
  const constructorName = val.constructor.name;
  const {nodeType, tagName} = val;
  const isCustomElement =
    (typeof tagName === 'string' && tagName.includes('-')) ||
    testHasAttribute(val);
  return (
    (nodeType === ELEMENT_NODE &&
      (ELEMENT_REGEXP.test(constructorName) || isCustomElement)) ||
    (nodeType === TEXT_NODE && constructorName === 'Text') ||
    (nodeType === COMMENT_NODE && constructorName === 'Comment') ||
    (nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment')
  );
};

const test = val => {
  var _val$constructor;

  return (
    (val === null || val === void 0
      ? void 0
      : (_val$constructor = val.constructor) === null ||
        _val$constructor === void 0
      ? void 0
      : _val$constructor.name) && testNode(val)
  );
};

exports.test = test;

function nodeIsText(node) {
  return node.nodeType === TEXT_NODE;
}

function nodeIsComment(node) {
  return node.nodeType === COMMENT_NODE;
}

function nodeIsFragment(node) {
  return node.nodeType === FRAGMENT_NODE;
}

const serialize = (node, config, indentation, depth, refs, printer) => {
  if (nodeIsText(node)) {
    return (0, _markup.printText)(node.data, config);
  }

  if (nodeIsComment(node)) {
    return (0, _markup.printComment)(node.data, config);
  }

  const type = nodeIsFragment(node)
    ? 'DocumentFragment'
    : node.tagName.toLowerCase();

  if (++depth > config.maxDepth) {
    return (0, _markup.printElementAsLeaf)(type, config);
  }

  return (0, _markup.printElement)(
    type,
    (0, _markup.printProps)(
      nodeIsFragment(node)
        ? []
        : Array.from(node.attributes)
            .map(attr => attr.name)
            .sort(),
      nodeIsFragment(node)
        ? {}
        : Array.from(node.attributes).reduce((props, attribute) => {
            props[attribute.name] = attribute.value;
            return props;
          }, {}),
      config,
      indentation + config.indent,
      depth,
      refs,
      printer
    ),
    (0, _markup.printChildren)(
      Array.prototype.slice.call(node.childNodes || node.children),
      config,
      indentation + config.indent,
      depth,
      refs,
      printer
    ),
    config,
    indentation
  );
};

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 51727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(31551);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// SENTINEL constants are from https://github.com/facebook/immutable-js
const IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
const IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
const IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
const IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
const IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
const IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@'; // immutable v4

const IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
const IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
const IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

const getImmutableName = name => 'Immutable.' + name;

const printAsLeaf = name => '[' + name + ']';

const SPACE = ' ';
const LAZY = '…'; // Seq is lazy if it calls a method like filter

const printImmutableEntries = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer,
  type
) =>
  ++depth > config.maxDepth
    ? printAsLeaf(getImmutableName(type))
    : getImmutableName(type) +
      SPACE +
      '{' +
      (0, _collections.printIteratorEntries)(
        val.entries(),
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      '}'; // Record has an entries method because it is a collection in immutable v3.
// Return an iterator for Immutable Record from version v3 or v4.

function getRecordEntries(val) {
  let i = 0;
  return {
    next() {
      if (i < val._keys.length) {
        const key = val._keys[i++];
        return {
          done: false,
          value: [key, val.get(key)]
        };
      }

      return {
        done: true,
        value: undefined
      };
    }
  };
}

const printImmutableRecord = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer
) => {
  // _name property is defined only for an Immutable Record instance
  // which was constructed with a second optional descriptive name arg
  const name = getImmutableName(val._name || 'Record');
  return ++depth > config.maxDepth
    ? printAsLeaf(name)
    : name +
        SPACE +
        '{' +
        (0, _collections.printIteratorEntries)(
          getRecordEntries(val),
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}';
};

const printImmutableSeq = (val, config, indentation, depth, refs, printer) => {
  const name = getImmutableName('Seq');

  if (++depth > config.maxDepth) {
    return printAsLeaf(name);
  }

  if (val[IS_KEYED_SENTINEL]) {
    return (
      name +
      SPACE +
      '{' + // from Immutable collection of entries or from ECMAScript object
      (val._iter || val._object
        ? (0, _collections.printIteratorEntries)(
            val.entries(),
            config,
            indentation,
            depth,
            refs,
            printer
          )
        : LAZY) +
      '}'
    );
  }

  return (
    name +
    SPACE +
    '[' +
    (val._iter || // from Immutable collection of values
    val._array || // from ECMAScript array
    val._collection || // from ECMAScript collection in immutable v4
    val._iterable // from ECMAScript collection in immutable v3
      ? (0, _collections.printIteratorValues)(
          val.values(),
          config,
          indentation,
          depth,
          refs,
          printer
        )
      : LAZY) +
    ']'
  );
};

const printImmutableValues = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer,
  type
) =>
  ++depth > config.maxDepth
    ? printAsLeaf(getImmutableName(type))
    : getImmutableName(type) +
      SPACE +
      '[' +
      (0, _collections.printIteratorValues)(
        val.values(),
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      ']';

const serialize = (val, config, indentation, depth, refs, printer) => {
  if (val[IS_MAP_SENTINEL]) {
    return printImmutableEntries(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      val[IS_ORDERED_SENTINEL] ? 'OrderedMap' : 'Map'
    );
  }

  if (val[IS_LIST_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      'List'
    );
  }

  if (val[IS_SET_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      val[IS_ORDERED_SENTINEL] ? 'OrderedSet' : 'Set'
    );
  }

  if (val[IS_STACK_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      'Stack'
    );
  }

  if (val[IS_SEQ_SENTINEL]) {
    return printImmutableSeq(val, config, indentation, depth, refs, printer);
  } // For compatibility with immutable v3 and v4, let record be the default.

  return printImmutableRecord(val, config, indentation, depth, refs, printer);
}; // Explicitly comparing sentinel properties to true avoids false positive
// when mock identity-obj-proxy returns the key as the value for any key.

exports.serialize = serialize;

const test = val =>
  val &&
  (val[IS_ITERABLE_SENTINEL] === true || val[IS_RECORD_SENTINEL] === true);

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 87247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var ReactIs = _interopRequireWildcard(__webpack_require__(72594));

var _markup = __webpack_require__(54092);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (typeof obj !== 'object' && typeof obj !== 'function')) {
    return {default: obj};
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Given element.props.children, or subtree during recursive traversal,
// return flattened array of children.
const getChildren = (arg, children = []) => {
  if (Array.isArray(arg)) {
    arg.forEach(item => {
      getChildren(item, children);
    });
  } else if (arg != null && arg !== false) {
    children.push(arg);
  }

  return children;
};

const getType = element => {
  const type = element.type;

  if (typeof type === 'string') {
    return type;
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || 'Unknown';
  }

  if (ReactIs.isFragment(element)) {
    return 'React.Fragment';
  }

  if (ReactIs.isSuspense(element)) {
    return 'React.Suspense';
  }

  if (typeof type === 'object' && type !== null) {
    if (ReactIs.isContextProvider(element)) {
      return 'Context.Provider';
    }

    if (ReactIs.isContextConsumer(element)) {
      return 'Context.Consumer';
    }

    if (ReactIs.isForwardRef(element)) {
      if (type.displayName) {
        return type.displayName;
      }

      const functionName = type.render.displayName || type.render.name || '';
      return functionName !== ''
        ? 'ForwardRef(' + functionName + ')'
        : 'ForwardRef';
    }

    if (ReactIs.isMemo(element)) {
      const functionName =
        type.displayName || type.type.displayName || type.type.name || '';
      return functionName !== '' ? 'Memo(' + functionName + ')' : 'Memo';
    }
  }

  return 'UNDEFINED';
};

const getPropKeys = element => {
  const {props} = element;
  return Object.keys(props)
    .filter(key => key !== 'children' && props[key] !== undefined)
    .sort();
};

const serialize = (element, config, indentation, depth, refs, printer) =>
  ++depth > config.maxDepth
    ? (0, _markup.printElementAsLeaf)(getType(element), config)
    : (0, _markup.printElement)(
        getType(element),
        (0, _markup.printProps)(
          getPropKeys(element),
          element.props,
          config,
          indentation + config.indent,
          depth,
          refs,
          printer
        ),
        (0, _markup.printChildren)(
          getChildren(element.props.children),
          config,
          indentation + config.indent,
          depth,
          refs,
          printer
        ),
        config,
        indentation
      );

exports.serialize = serialize;

const test = val => val != null && ReactIs.isElement(val);

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 85642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _markup = __webpack_require__(54092);

var global = (function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')();
  }
})();

var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
const testSymbol =
  typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('react.test.json')
    : 0xea71357;

const getPropKeys = object => {
  const {props} = object;
  return props
    ? Object.keys(props)
        .filter(key => props[key] !== undefined)
        .sort()
    : [];
};

const serialize = (object, config, indentation, depth, refs, printer) =>
  ++depth > config.maxDepth
    ? (0, _markup.printElementAsLeaf)(object.type, config)
    : (0, _markup.printElement)(
        object.type,
        object.props
          ? (0, _markup.printProps)(
              getPropKeys(object),
              object.props,
              config,
              indentation + config.indent,
              depth,
              refs,
              printer
            )
          : '',
        object.children
          ? (0, _markup.printChildren)(
              object.children,
              config,
              indentation + config.indent,
              depth,
              refs,
              printer
            )
          : '',
        config,
        indentation
      );

exports.serialize = serialize;

const test = val => val && val.$$typeof === testSymbol;

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 62934:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = escapeHTML;

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function escapeHTML(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


/***/ }),

/***/ 54092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printText =
  exports.printProps =
  exports.printElementAsLeaf =
  exports.printElement =
  exports.printComment =
  exports.printChildren =
    void 0;

var _escapeHTML = _interopRequireDefault(__webpack_require__(62934));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer) => {
  const indentationNext = indentation + config.indent;
  const colors = config.colors;
  return keys
    .map(key => {
      const value = props[key];
      let printed = printer(value, config, indentationNext, depth, refs);

      if (typeof value !== 'string') {
        if (printed.indexOf('\n') !== -1) {
          printed =
            config.spacingOuter +
            indentationNext +
            printed +
            config.spacingOuter +
            indentation;
        }

        printed = '{' + printed + '}';
      }

      return (
        config.spacingInner +
        indentation +
        colors.prop.open +
        key +
        colors.prop.close +
        '=' +
        colors.value.open +
        printed +
        colors.value.close
      );
    })
    .join('');
}; // Return empty string if children is empty.

exports.printProps = printProps;

const printChildren = (children, config, indentation, depth, refs, printer) =>
  children
    .map(
      child =>
        config.spacingOuter +
        indentation +
        (typeof child === 'string'
          ? printText(child, config)
          : printer(child, config, indentation, depth, refs))
    )
    .join('');

exports.printChildren = printChildren;

const printText = (text, config) => {
  const contentColor = config.colors.content;
  return (
    contentColor.open + (0, _escapeHTML.default)(text) + contentColor.close
  );
};

exports.printText = printText;

const printComment = (comment, config) => {
  const commentColor = config.colors.comment;
  return (
    commentColor.open +
    '<!--' +
    (0, _escapeHTML.default)(comment) +
    '-->' +
    commentColor.close
  );
}; // Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.

exports.printComment = printComment;

const printElement = (
  type,
  printedProps,
  printedChildren,
  config,
  indentation
) => {
  const tagColor = config.colors.tag;
  return (
    tagColor.open +
    '<' +
    type +
    (printedProps &&
      tagColor.close +
        printedProps +
        config.spacingOuter +
        indentation +
        tagColor.open) +
    (printedChildren
      ? '>' +
        tagColor.close +
        printedChildren +
        config.spacingOuter +
        indentation +
        tagColor.open +
        '</' +
        type
      : (printedProps && !config.min ? '' : ' ') + '/') +
    '>' +
    tagColor.close
  );
};

exports.printElement = printElement;

const printElementAsLeaf = (type, config) => {
  const tagColor = config.colors.tag;
  return (
    tagColor.open +
    '<' +
    type +
    tagColor.close +
    ' …' +
    tagColor.open +
    ' />' +
    tagColor.close
  );
};

exports.printElementAsLeaf = printElementAsLeaf;


/***/ }),

/***/ 94662:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(90614);
__webpack_require__(29978);
__webpack_require__(38110);
__webpack_require__(71227);
__webpack_require__(47995);
__webpack_require__(29282);
__webpack_require__(86283);
__webpack_require__(89615);
__webpack_require__(26847);
__webpack_require__(84874);
__webpack_require__(31415);
var _typeof = __webpack_require__(8114);
__webpack_require__(92979);
var _slicedToArray = __webpack_require__(98371);
__webpack_require__(93786);
__webpack_require__(14334);
__webpack_require__(80437);
var _toConsumableArray = __webpack_require__(40299);
var _createClass = __webpack_require__(1023);
var _classCallCheck = __webpack_require__(62638);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
__webpack_require__(11478);
__webpack_require__(94184);
__webpack_require__(16669);
__webpack_require__(77428);
__webpack_require__(39837);
__webpack_require__(83793);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);

var custom = function custom() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return {
    checks: checks
  };
};

function _createForOfIteratorHelper$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var type = function type() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$4(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _type = _step.value;

        if (typeof _type === "string") {
          isValid = isValid || _typeof__default["default"](value) === _type;
          expectedTypes.push("of type ".concat(_type));
          continue;
        }

        isValid = isValid || value instanceof _type;
        expectedTypes.push("an instance of ".concat(_type.name));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var literal = function literal() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$3(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;
        isValid = isValid || value === type;
        expectedTypes.push(typeof type === "string" ? "\"".concat(type, "\"") : "".concat(type));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var runtimeTypeValidation = function runtimeTypeValidation(rules, values) {
  if (values.length > rules.length) {
    throw new Error("Expected at most ".concat(rules.length, " argument(s), but got ").concat(values.length));
  }

  while (values.length < rules.length) {
    values.push(undefined);
  }

  var _iterator = _createForOfIteratorHelper$2(values.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray__default["default"](_step.value, 2),
          index = _step$value[0],
          value = _step$value[1];

      var _validateValue = validateValue(rules[index], value),
          _validateValue2 = _slicedToArray__default["default"](_validateValue, 4),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2],
          delimeter = _validateValue2[3];

      if (isValid) {
        continue;
      }

      var argumentIndex = index + 1;
      throw new Error("Argument ".concat(argumentIndex, " is expected to be ").concat(expected).concat(delimeter, " but got ").concat(received));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var stringifyReceivedType = function stringifyReceivedType(value) {
  var _value$constructor;

  var receivedType;
  var types = ["undefined", "boolean", "number", "bigint", "string"];

  if (types.includes(_typeof__default["default"](value))) {
    receivedType = typeof value === "string" ? "\"".concat(value, "\"") : "".concat(value);
  }

  if (_typeof__default["default"](value) === "object" && (value === null || value === void 0 ? void 0 : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) !== "Object") {
    var _value$constructor2;

    receivedType = value === null ? "null" : "instance of ".concat(value === null || value === void 0 ? void 0 : (_value$constructor2 = value.constructor) === null || _value$constructor2 === void 0 ? void 0 : _value$constructor2.name);
  }

  if (!receivedType) {
    receivedType = _typeof__default["default"](value);
  }

  return receivedType;
};
/* eslint-disable @typescript-eslint/no-explicit-any */

var validateConstructorTypes = function validateConstructorTypes() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (ctor) {
    return /*#__PURE__*/function (_ctor) {
      _inherits__default["default"](_class, _ctor);

      var _super = _createSuper(_class);

      function _class() {
        _classCallCheck__default["default"](this, _class);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        runtimeTypeValidation(finalRuleSet, args);
        return _super.call.apply(_super, [this].concat(args));
      }

      return _createClass__default["default"](_class);
    }(ctor);
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any */

var validateTypes = function validateTypes() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypes decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      runtimeTypeValidation(finalRuleSet, args);
      return originalMethod.apply(this, args);
    };
  };
};
var validateTypesAsync = function validateTypesAsync() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      try {
        runtimeTypeValidation(finalRuleSet, args);
      } catch (e) {
        return Promise.reject(e);
      }

      return originalMethod.apply(this, args);
    };
  };
};
var convertRuleArguments = function convertRuleArguments(args) {
  var finalRuleDefinitionSet = [];

  var _iterator2 = _createForOfIteratorHelper$2(args),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var arg = _step2.value;
      finalRuleDefinitionSet.push(convertRuleArgument(arg));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return finalRuleDefinitionSet;
};
var convertRuleArgument = function convertRuleArgument(arg) {
  var finalArgumentRuleDefinitions = [];
  var declaredRules = Array.isArray(arg) ? arg : [arg];

  var _iterator3 = _createForOfIteratorHelper$2(declaredRules),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var rule = _step3.value;

      if (typeof rule === "string" || typeof rule === "function") {
        finalArgumentRuleDefinitions.push(type(rule));
        continue;
      }

      finalArgumentRuleDefinitions.push(rule);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return finalArgumentRuleDefinitions;
};
var validateValue = function validateValue(ruleDefinitions, value) {
  var expectedTypes = [];
  var customReceivedType;
  var isValid = false;

  var _iterator4 = _createForOfIteratorHelper$2(ruleDefinitions),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var definition = _step4.value;

      var _iterator5 = _createForOfIteratorHelper$2(definition.checks),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var check = _step5.value;

          var _check = check(value),
              _check2 = _slicedToArray__default["default"](_check, 3),
              checkPassed = _check2[0],
              typeDescription = _check2[1],
              _receivedType = _check2[2];

          isValid = isValid || checkPassed;

          if (!customReceivedType && _receivedType) {
            customReceivedType = _receivedType;
          }

          if (typeDescription) {
            expectedTypes = typeof typeDescription === "string" ? [].concat(_toConsumableArray__default["default"](expectedTypes), [typeDescription]) : [].concat(_toConsumableArray__default["default"](expectedTypes), _toConsumableArray__default["default"](typeDescription));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (isValid) {
    return [true];
  }

  var receivedType = customReceivedType || stringifyReceivedType(value);
  var lastIndex = expectedTypes.length - 1;
  var expectedTypesString = lastIndex > 0 ? "".concat(expectedTypes.slice(0, lastIndex).join(", "), " or ").concat(expectedTypes[lastIndex]) : expectedTypes.join(", ");
  return [false, receivedType, expectedTypesString, lastIndex > 1 ? ";" : ","];
};

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var nonEmptyArray = function nonEmptyArray(name, rules) {
  return custom(function (value) {
    if (!Array.isArray(value) || value.length < 1) {
      return [false, "a non-empty array of ".concat(name)];
    }

    var _iterator = _createForOfIteratorHelper$1(value.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray__default["default"](_step.value, 2),
            key = _step$value[0],
            valueOfKey = _step$value[1];

        var _validateValue = validateValue(convertRuleArgument(rules), valueOfKey),
            _validateValue2 = _slicedToArray__default["default"](_validateValue, 3),
            isValid = _validateValue2[0],
            received = _validateValue2[1],
            expected = _validateValue2[2];

        if (!isValid) {
          return [false, "a valid non-empty array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [true];
  });
};

var nonEmptyString = custom(function (value) {
  return [typeof value === "string" && value.length > 0, "a non-empty string"];
});

var nonNegativeInteger = custom(function (value) {
  return [typeof value === "number" && Number.isInteger(value) && value >= 0, "a non-negative integer"];
});

var pureObject = custom(function (value) {
  return [_typeof__default["default"](value) === "object" && value !== null && !Array.isArray(value), "a pure object (non-null and non-array)"];
});

var objectSchema = function objectSchema(name, schema) {
  return custom(function (object) {
    if (_typeof__default["default"](object) !== "object" || object === null || Array.isArray(object)) {
      return [false, "valid ".concat(name, " (should be a pure object)")];
    }

    for (var _i = 0, _Object$entries = Object.entries(schema); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default["default"](_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          rules = _Object$entries$_i[1];

      var _validateValue = validateValue(convertRuleArgument(rules), object[key]),
          _validateValue2 = _slicedToArray__default["default"](_validateValue, 3),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2];

      if (!isValid) {
        return [false, "valid ".concat(name, " (key \"").concat(key, "\" should be ").concat(expected, ")"), "malformed ".concat(name, " (key \"").concat(key, "\" is ").concat(received, ")")];
      }
    }

    return [true];
  });
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var array = function array(name, rules) {
  return custom(function (value) {
    if (!Array.isArray(value)) {
      return [false, "an array of ".concat(name)];
    }

    var _iterator = _createForOfIteratorHelper(value.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray__default["default"](_step.value, 2),
            key = _step$value[0],
            valueOfKey = _step$value[1];

        var _validateValue = validateValue(convertRuleArgument(rules), valueOfKey),
            _validateValue2 = _slicedToArray__default["default"](_validateValue, 3),
            isValid = _validateValue2[0],
            received = _validateValue2[1],
            expected = _validateValue2[2];

        if (!isValid) {
          return [false, "a valid array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [true];
  });
};

exports.array = array;
exports.custom = custom;
exports.literal = literal;
exports.nonEmptyArray = nonEmptyArray;
exports.nonEmptyString = nonEmptyString;
exports.nonNegativeInteger = nonNegativeInteger;
exports.objectSchema = objectSchema;
exports.pureObject = pureObject;
exports.runtimeTypeValidation = runtimeTypeValidation;
exports.stringifyReceivedType = stringifyReceivedType;
exports.type = type;
exports.validateConstructorTypes = validateConstructorTypes;
exports.validateTypes = validateTypes;
exports.validateTypesAsync = validateTypesAsync;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 49430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2018, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/


var global =
  typeof global !== "undefined"
    ? global
    : typeof self !== "undefined"
    ? self
    : typeof window !== "undefined"
    ? window
    : {};

Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(14334);
__webpack_require__(80437);
var _classCallCheck = __webpack_require__(62638);
var _createClass = __webpack_require__(1023);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
var _wrapNativeSuper = __webpack_require__(17164);
var _defineProperty = __webpack_require__(93213);
__webpack_require__(29978);
__webpack_require__(94184);
__webpack_require__(84874);
__webpack_require__(12702);
__webpack_require__(71227);
__webpack_require__(31415);
var _asyncToGenerator = __webpack_require__(20164);
var _regeneratorRuntime = __webpack_require__(72975);
__webpack_require__(93786);
__webpack_require__(16822);
__webpack_require__(98484);
var _typeof = __webpack_require__(8114);
__webpack_require__(38110);
var log$2 = __webpack_require__(33108);
__webpack_require__(63466);
__webpack_require__(24477);
__webpack_require__(47995);
__webpack_require__(74643);
__webpack_require__(9280);
__webpack_require__(16669);
__webpack_require__(90614);
__webpack_require__(73772);
__webpack_require__(24491);
__webpack_require__(14306);
__webpack_require__(95535);
var operationRetrier = __webpack_require__(65803);
var declarativeTypeValidator = __webpack_require__(94662);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultLegacy(_wrapNativeSuper);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var log__namespace = /*#__PURE__*/_interopNamespace(log$2);

var rngBrowser = {exports: {}};

// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.

var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  rngBrowser.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  rngBrowser.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid$2(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

var bytesToUuid_1 = bytesToUuid$2;

var rng$1 = rngBrowser.exports;
var bytesToUuid$1 = bytesToUuid_1; // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1$1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = rng$1();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid$1(b);
}

var v1_1 = v1$1;

var rng = rngBrowser.exports;
var bytesToUuid = bytesToUuid_1;

function v4$1(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

var v4_1 = v4$1;

var v1 = v1_1;
var v4 = v4_1;
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
var uuid_1 = uuid;

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Cancellable promise. Extends the functionality of the native Promise to include the cancel method.
 *
 * Example:
 *
 * ```ts
 *
 * const cancellableFetchPromise = new CancellablePromise(async (resolve, reject, onCancel) => {
 *     const request = fetch("https://example.com/");
 *
 *     onCancel(() => request.cancel());
 *
 *     try {
 *         const response = await request;
 *         resolve(response);
 *     } catch (err) {
 *         reject(err);
 *     }
 * });
 *
 * cancellableFetchPromise.cancel();
 * ```
 */

var CancellablePromise = /*#__PURE__*/function (_Promise) {
  _inherits__default["default"](CancellablePromise, _Promise);

  var _super = _createSuper$1(CancellablePromise);

  /**
   * Creates a new CancellablePromise.
   * @param executor A callback used to initialize the promise. This callback is passed three arguments:
   * a resolve callback used to resolve the promise with a value or the result of another promise,
   * a reject callback used to reject the promise with a provided reason or error,
   * and an onCancel callback used to define behavior of cancellation.
   */
  function CancellablePromise(executor) {
    var _this;

    _classCallCheck__default["default"](this, CancellablePromise);

    var outerId = uuid_1.v4();
    var outerRejectPromise;
    _this = _super.call(this, function (resolve, reject) {
      outerRejectPromise = reject;
      return executor(function (value) {
        CancellablePromise.cancellationMap.delete(outerId);
        resolve(value);
      }, function (reason) {
        CancellablePromise.cancellationMap.delete(outerId);
        reject(reason);
      }, function (cancellationFunction) {
        CancellablePromise.cancellationMap.set(outerId, cancellationFunction);
      });
    });
    _this.id = outerId;
    _this.rejectPromise = outerRejectPromise;
    return _this;
  }
  /**
   * Cancels the promise and invokes the cancellation callback if it was defined during instantiation. Cancellation will result in the promise being rejected.
   */


  _createClass__default["default"](CancellablePromise, [{
    key: "cancel",
    value: function cancel() {
      var onCancel = CancellablePromise.cancellationMap.get(this.id);
      onCancel === null || onCancel === void 0 ? void 0 : onCancel();

      if (this.rejectPromise) {
        this.catch(function () {
          return void 0;
        });
        this.rejectPromise(new Error("Promise was cancelled"));
      }

      return this;
    }
  }]);

  return CancellablePromise;
}( /*#__PURE__*/_wrapNativeSuper__default["default"](Promise));

_defineProperty__default["default"](CancellablePromise, "cancellationMap", new Map());

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default["default"](Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default["default"](Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function prepareLine(prefix, args) {
  return ["".concat(new Date().toISOString(), " MCS Client ").concat(prefix, ":")].concat(Array.from(args));
}

var Logger = /*#__PURE__*/function () {
  function Logger(prefix) {
    _classCallCheck__default["default"](this, Logger);

    _defineProperty__default["default"](this, "prefix", "");

    this.prefix = prefix !== null && prefix !== undefined && prefix.length > 0 ? prefix + " " : "";
  }

  _createClass__default["default"](Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      log__namespace.setLevel(level);
    }
  }, {
    key: "trace",
    value:
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
    function trace() {
      if (log__namespace.getLevel() == log__namespace.levels.TRACE) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        log__namespace.debug.apply(null, prepareLine(this.prefix + "T", args));
      }
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      log__namespace.debug.apply(null, prepareLine(this.prefix + "D", args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      log__namespace.info.apply(null, prepareLine(this.prefix + "I", args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      log__namespace.warn.apply(null, prepareLine(this.prefix + "W", args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      log__namespace.error.apply(null, prepareLine(this.prefix + "E", args));
    }
  }], [{
    key: "scope",
    value: function scope(prefix) {
      return new Logger(prefix);
    }
  }, {
    key: "setLevel",
    value: function setLevel(level) {
      log__namespace.setLevel(level);
    }
  }, {
    key: "trace",
    value: function trace() {
      if (log__namespace.getLevel() == log__namespace.levels.TRACE) {
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        log__namespace.debug.apply(null, prepareLine("T", args));
      }
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      log__namespace.debug.apply(null, prepareLine("D", args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      log__namespace.info.apply(null, prepareLine("I", args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      log__namespace.warn.apply(null, prepareLine("W", args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      log__namespace.error.apply(null, prepareLine("E", args));
    }
  }]);

  return Logger;
}();

var MINIMUM_RETRY_DELAY = 1000;
var MAXIMUM_RETRY_DELAY = 4000;
var MAXIMUM_ATTEMPTS_COUNT = 3;
var RETRY_WHEN_THROTTLED = true;

var regionalMcsHost = function regionalMcsHost(region) {
  return "https://mcs.".concat(region !== null && region !== void 0 ? region : "us1", ".twilio.com");
};

var isFullUrl = function isFullUrl(url) {
  return url.startsWith("http");
};

var fullUrl = function fullUrl(partUrl, region) {
  return "".concat(!isFullUrl(partUrl) ? regionalMcsHost(region) : "").concat(partUrl);
};

var Configuration = /*#__PURE__*/function () {
  function Configuration(token, baseUrl, baseSetUrl, options) {
    var _ref, _options$MCS, _ref2, _constructorOptions$r, _constructorOptions$r2, _constructorOptions$b;

    _classCallCheck__default["default"](this, Configuration);

    var constructorOptions = (_ref = (_options$MCS = options.MCS) !== null && _options$MCS !== void 0 ? _options$MCS : options) !== null && _ref !== void 0 ? _ref : {};
    this.region = (_ref2 = (_constructorOptions$r = constructorOptions.region) !== null && _constructorOptions$r !== void 0 ? _constructorOptions$r : options.region) !== null && _ref2 !== void 0 ? _ref2 : 'us1';
    this.mediaUrl = fullUrl(baseUrl, this.region);
    this.mediaSetUrl = baseSetUrl ? fullUrl(baseSetUrl) : "".concat(this.mediaUrl, "Set");
    this.token = token;
    this.retryWhenThrottledOverride = (_constructorOptions$r2 = constructorOptions.retryWhenThrottledOverride) !== null && _constructorOptions$r2 !== void 0 ? _constructorOptions$r2 : RETRY_WHEN_THROTTLED;
    this.backoffConfigOverride = (_constructorOptions$b = constructorOptions.backoffConfigOverride) !== null && _constructorOptions$b !== void 0 ? _constructorOptions$b : Configuration.backoffConfigDefault;
  }

  _createClass__default["default"](Configuration, [{
    key: "updateToken",
    value: function updateToken(token) {
      this.token = token;
    }
  }], [{
    key: "backoffConfigDefault",
    get: function get() {
      return {
        min: MINIMUM_RETRY_DELAY,
        max: MAXIMUM_RETRY_DELAY,
        maxAttemptsCount: MAXIMUM_ATTEMPTS_COUNT
      };
    }
  }, {
    key: "retryWhenThrottledDefault",
    get: function get() {
      return RETRY_WHEN_THROTTLED;
    }
  }]);

  return Configuration;
}();

/**
 * @classdesc A Media represents a metadata information for the media upload
 * @property {String} sid - The server-assigned unique identifier for Media
 * @property {String} serviceSid - Service instance id which Media belongs/uploaded to
 * @property {Date} dateCreated - When the Media was created
 * @property {Date} dateUpdated - When the Media was updated
 * @property {Number} size - Size of media, bytes
 * @property {String} contentType - content type of media
 * @property {String} fileName - file name, if present, null otherwise
 * @property {MediaCategory} category - attachment category
 */

var Media = /*#__PURE__*/function () {
  function Media(config, network, data) {
    _classCallCheck__default["default"](this, Media);

    this.config = config;
    this.network = network;

    this._update(data);
  }

  _createClass__default["default"](Media, [{
    key: "sid",
    get: function get() {
      return this.state.sid;
    }
  }, {
    key: "serviceSid",
    get: function get() {
      return this.state.serviceSid;
    }
  }, {
    key: "dateCreated",
    get: function get() {
      return this.state.dateCreated;
    }
  }, {
    key: "dateUpdated",
    get: function get() {
      return this.state.dateUpdated;
    }
  }, {
    key: "contentType",
    get: function get() {
      return this.state.contentType;
    }
  }, {
    key: "size",
    get: function get() {
      return this.state.size;
    }
    /** @deprecated Use filename instead */

  }, {
    key: "fileName",
    get: function get() {
      return this.state.filename;
    }
  }, {
    key: "filename",
    get: function get() {
      return this.state.filename;
    }
  }, {
    key: "category",
    get: function get() {
      return this.state.category;
    }
    /**
     * Returns direct content URL to uploaded binary. This URL will expire after some time.
     * This function gets a new URL every time, preventing it from expiring but putting additional load on backend.
     * See getCachedContentUrl() for a function that reduces the amount of network requests.
     *
     * It is reasonable to build your own refresh logic upon these two functions: as soon as URL returned
     * by getCachedContentUrl() returns 40x status you should call getContentUrl() to refresh it.
     */

  }, {
    key: "getContentUrl",
    value: function getContentUrl() {
      var _this = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(resolve, reject, onCancel) {
          var request, response;
          return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  request = _this.network.get("".concat(_this.config.mediaUrl, "/").concat(_this.sid));
                  onCancel(function () {
                    return request.cancel();
                  });
                  _context.prev = 2;
                  _context.next = 5;
                  return request;

                case 5:
                  response = _context.sent;

                  _this._update(response.body);

                  resolve(_this.state.contentDirectUrl);
                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](2);
                  reject(_context.t0);

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 10]]);
        }));

        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_update",
    value: function _update(data) {
      var _data$links$content_d, _data$filename, _data$category, _data$is_multipart_up;

      this.state = {
        sid: data.sid,
        serviceSid: data.service_sid,
        channelSid: data.channel_sid,
        messageSid: data.message_sid,
        dateCreated: data.date_created ? new Date(data.date_created) : null,
        dateUploadUpdated: data.date_upload_updated ? new Date(data.date_upload_updated) : null,
        dateUpdated: data.date_updated ? new Date(data.date_updated) : null,
        size: data.size,
        contentType: data.content_type,
        author: data.author,
        url: data.url,
        contentUrl: data.links.content,
        contentDirectUrl: (_data$links$content_d = data.links.content_direct_temporary) !== null && _data$links$content_d !== void 0 ? _data$links$content_d : null,
        filename: (_data$filename = data.filename) !== null && _data$filename !== void 0 ? _data$filename : null,
        category: (_data$category = data.category) !== null && _data$category !== void 0 ? _data$category : "media",
        isMultipartUpstream: (_data$is_multipart_up = data.is_multipart_upstream) !== null && _data$is_multipart_up !== void 0 ? _data$is_multipart_up : false
      };
    }
    /**
     * @internal
     * This payload is compatible with Conversations' media object _state().
     */

  }, {
    key: "_state",
    value: function _state() {
      var _this$state$filename;

      return {
        sid: this.state.sid,
        category: this.state.category,
        filename: (_this$state$filename = this.state.filename) !== null && _this$state$filename !== void 0 ? _this$state$filename : null,
        contentType: this.state.contentType,
        size: this.state.size
      };
    }
  }]);

  return Media;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TransportError = /*#__PURE__*/function (_Error) {
  _inherits__default["default"](TransportError, _Error);

  var _super = _createSuper(TransportError);

  function TransportError(message, code, body, status, headers) {
    var _this;

    _classCallCheck__default["default"](this, TransportError);

    _this = _super.call(this, message);
    _this.code = code;
    _this.body = body;
    _this.status = status;
    _this.headers = headers;
    return _this;
  }

  return _createClass__default["default"](TransportError);
}( /*#__PURE__*/_wrapNativeSuper__default["default"](Error));

var XHR = global["XMLHttpRequest"] || {};

function parseResponseHeaders(headerString) {
  if (!headerString) {
    return {};
  }

  return headerString.split("\r\n").map(function (el) {
    return el.split(": ");
  }).filter(function (el) {
    return el.length === 2 && el[1].length > 0;
  }).reduce(function (prev, curr) {
    prev[curr[0]] = curr[1];
    return prev;
  }, {});
}

function extractBody(xhr) {
  var contentType = xhr.getResponseHeader("Content-Type");

  if (!contentType || contentType.indexOf("application/json") !== 0 || xhr.responseText.length === 0) {
    return xhr.responseText;
  }

  try {
    return JSON.parse(xhr.responseText);
  } catch (e) {
    return xhr.responseText;
  }
}
/**
 * Provides generic network interface
 */


var Transport = /*#__PURE__*/function () {
  function Transport() {
    _classCallCheck__default["default"](this, Transport);
  }

  _createClass__default["default"](Transport, [{
    key: "get",
    value:
    /**
     * Make a GET request by given URL
     */
    function get(url, headers) {
      return Transport.request("GET", url, headers);
    }
    /**
     * Make a POST request by given URL
     */

  }, {
    key: "post",
    value: function post(url, headers, body) {
      return Transport.request("POST", url, headers, body);
    }
  }], [{
    key: "request",
    value: function request(method, url, headers, body) {
      return new CancellablePromise(function (resolve, reject, onCancel) {
        var xhr = new XHR();
        var isCancelled = false;
        onCancel(function () {
          xhr.abort();
          isCancelled = true;
        });
        xhr.open(method, url, true);

        xhr.onreadystatechange = function onreadystatechange() {
          if (xhr.readyState !== 4 || isCancelled) {
            return;
          }

          var responseHeaders = parseResponseHeaders(xhr.getAllResponseHeaders());
          var body = extractBody(xhr);

          if (200 <= xhr.status && xhr.status < 300) {
            resolve({
              status: xhr.status,
              headers: responseHeaders,
              body: body
            });
          } else {
            var _xhr$statusText;

            var status = (_xhr$statusText = xhr.statusText) !== null && _xhr$statusText !== void 0 ? _xhr$statusText : "NONE";
            var bodyRepresentation;

            if (typeof body === "string") {
              if (body && body.split("\n", 2).length === 1) bodyRepresentation = body;else {
                var _body$replace$split$f;

                // TODO: RTDSDK-3716: investigate why body is HTML string
                var errorInfo = (_body$replace$split$f = body.replace(/<.*?>/g, "").split(/\r\n/g).filter(function (str) {
                  return str.length;
                })[0]) === null || _body$replace$split$f === void 0 ? void 0 : _body$replace$split$f.split(" ");
                bodyRepresentation = (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.length) > 2 ? errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.slice(1).join(" ") : "";
              }
            } else {
              bodyRepresentation = JSON.stringify(body);
            }

            var message = "".concat(xhr.status, ": [").concat(status, "] ").concat(bodyRepresentation);
            reject(new TransportError(message, xhr.status, body, status, responseHeaders));
          }
        };

        for (var headerName in headers) {
          xhr.setRequestHeader(headerName, headers[headerName]);

          if (headerName === "Content-Type" && headers[headerName] === "application/json") {
            body = JSON.stringify(body);
          }
        }

        xhr.send(body);
      });
    }
  }]);

  return Transport;
}();

var log$1 = Logger.scope("Network");

var Network = /*#__PURE__*/function () {
  function Network(config, transport) {
    _classCallCheck__default["default"](this, Network);

    this.config = config;
    this.transport = transport;
  }

  _createClass__default["default"](Network, [{
    key: "backoffConfig",
    value: function backoffConfig() {
      return Object.assign(Configuration.backoffConfigDefault, this.config.backoffConfigOverride);
    }
  }, {
    key: "retryWhenThrottled",
    value: function retryWhenThrottled() {
      var _ref, _this$config$retryWhe;

      return (_ref = (_this$config$retryWhe = this.config.retryWhenThrottledOverride) !== null && _this$config$retryWhe !== void 0 ? _this$config$retryWhe : Configuration.retryWhenThrottledDefault) !== null && _ref !== void 0 ? _ref : false;
    }
  }, {
    key: "executeWithRetry",
    value: function executeWithRetry(request, retryWhenThrottled) {
      var _this = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2(resolve, reject, onCancel) {
          var retrier, codesToRetryOn;
          return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  retrier = new operationRetrier.Retrier(_this.backoffConfig());
                  codesToRetryOn = [502, 503, 504];

                  if (retryWhenThrottled) {
                    codesToRetryOn.push(429);
                  }

                  onCancel(function () {
                    retrier.cancel();
                    retrier.removeAllListeners();
                  });
                  retrier.on("attempt", /*#__PURE__*/_asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
                    var requestPromise, result;
                    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            requestPromise = request();
                            onCancel(function () {
                              requestPromise.cancel();
                              retrier.cancel();
                              retrier.removeAllListeners();
                            });
                            _context.next = 5;
                            return requestPromise;

                          case 5:
                            result = _context.sent;
                            retrier.succeeded(result);
                            _context.next = 12;
                            break;

                          case 9:
                            _context.prev = 9;
                            _context.t0 = _context["catch"](0);

                            if (codesToRetryOn.indexOf(_context.t0.status) > -1) {
                              retrier.failed(_context.t0);
                            } else if (_context.t0.message === "Twilsock disconnected") {
                              // Ugly hack. We must make a proper exceptions for twilsock
                              retrier.failed(_context.t0);
                            } else {
                              // Fatal error
                              retrier.removeAllListeners();
                              retrier.cancel();
                              reject(_context.t0);
                            }

                          case 12:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 9]]);
                  })));
                  retrier.on("succeeded", function (result) {
                    resolve(result);
                  });
                  retrier.on("cancelled", function (err) {
                    return reject(err);
                  });
                  retrier.on("failed", function (err) {
                    return reject(err);
                  });
                  retrier.start();

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "get",
    value: function get(url) {
      var _this2 = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(resolve, reject, onCancel) {
          var headers, request, response;
          return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  headers = {
                    "X-Twilio-Token": _this2.config.token
                  };
                  request = _this2.executeWithRetry(function () {
                    return _this2.transport.get(url, headers);
                  }, _this2.retryWhenThrottled());
                  log$1.trace("sending GET request to ", url, " headers ", headers);
                  onCancel(function () {
                    return request.cancel();
                  });
                  _context3.prev = 4;
                  _context3.next = 7;
                  return request;

                case 7:
                  response = _context3.sent;
                  log$1.trace("response", response);
                  resolve(response);
                  _context3.next = 16;
                  break;

                case 12:
                  _context3.prev = 12;
                  _context3.t0 = _context3["catch"](4);
                  log$1.debug("get() error ".concat(_context3.t0));
                  reject(_context3.t0);

                case 16:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[4, 12]]);
        }));

        return function (_x4, _x5, _x6) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "post",
    value: function post(url, category, media, contentType, filename) {
      var _this3 = this;

      var headers = {
        "X-Twilio-Token": this.config.token
      };

      if ((typeof FormData === "undefined" || !(media instanceof FormData)) && contentType) {
        Object.assign(headers, {
          "Content-Type": contentType
        });
      }

      var fullUrl = new URL(url);

      if (category) {
        fullUrl.searchParams.append("Category", category);
      }

      if (filename) {
        fullUrl.searchParams.append("Filename", filename);
      }

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee4(resolve, reject, onCancel) {
          var request, response;
          return _regeneratorRuntime__default["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  request = _this3.transport.post(fullUrl.href, headers, media);
                  onCancel(function () {
                    return request.cancel();
                  });
                  log$1.trace("sending POST request to ".concat(url, " with headers ").concat(headers));
                  _context4.prev = 3;
                  _context4.next = 6;
                  return request;

                case 6:
                  response = _context4.sent;
                  _context4.next = 17;
                  break;

                case 9:
                  _context4.prev = 9;
                  _context4.t0 = _context4["catch"](3);

                  if (!(global["XMLHttpRequest"] === undefined && media instanceof FormData)) {
                    _context4.next = 14;
                    break;
                  }

                  reject(new TypeError("Posting FormData supported only with browser engine's FormData"));
                  return _context4.abrupt("return");

                case 14:
                  log$1.debug("post() error ".concat(_context4.t0));
                  reject(_context4.t0);
                  return _context4.abrupt("return");

                case 17:
                  log$1.trace("response", response);
                  resolve(response);

                case 19:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[3, 9]]);
        }));

        return function (_x7, _x8, _x9) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }]);

  return Network;
}();

var version = "0.6.7";

var _class;
var log = Logger.scope("");
/**
 * @classdesc A Client provides an interface for Media Content Service
 */

exports["default"] = (_class = /*#__PURE__*/function () {
  // eslint-disable-next-line

  /**
   * Base URLs must be full URLs with host. If host is not provided it will be generated from a default configuration
   * template using options.region.
   *
   * @param {String} token - Access token
   * @param {String} baseUrl - Base URL for Media Content Service Media resource, i.e. /v1/Services/{serviceSid}/Media
   * @param {String} baseSetUrl - Base URL for Media Content Service MediaSet resource, i.e. /v1/Services/{serviceSid}/MediaSet
   * @param {Client#ClientOptions} [options] - Options to customize the Client
   */
  function Client(token, baseUrl, baseSetUrl) {
    var _this$options$logLeve, _this$options$transpo;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck__default["default"](this, Client);

    this.options = options;
    this.options.logLevel = (_this$options$logLeve = this.options.logLevel) !== null && _this$options$logLeve !== void 0 ? _this$options$logLeve : "silent";
    this.config = new Configuration(token, baseUrl, baseSetUrl, this.options);
    log.setLevel(this.options.logLevel);
    this.options.transport = (_this$options$transpo = this.options.transport) !== null && _this$options$transpo !== void 0 ? _this$options$transpo : new Transport();
    this.transport = this.options.transport;
    this.network = new Network(this.config, this.transport);
  }
  /**
   * These options can be passed to Client constructor
   * @typedef {Object} Client#ClientOptions
   * @property {String} [logLevel='silent'] - The level of logging to enable. Valid options
   *   (from strictest to broadest): ['silent', 'error', 'warn', 'info', 'debug', 'trace']
   */

  /**
   * Update the token used for Client operations
   * @param {String} token - The JWT string of the new token
   * @returns {void}
   */


  _createClass__default["default"](Client, [{
    key: "updateToken",
    value: function updateToken(token) {
      log.info("updateToken");
      this.config.updateToken(token);
    }
    /**
     * Gets media from media service
     * @param {String} sid - Media's SID
     */

  }, {
    key: "get",
    value: function get(sid) {
      var _this = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(resolve, reject, onCancel) {
          var request, response;
          return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  request = _this.network.get("".concat(_this.config.mediaUrl, "/").concat(sid));
                  onCancel(function () {
                    return request.cancel();
                  });
                  _context.prev = 2;
                  _context.next = 5;
                  return request;

                case 5:
                  response = _context.sent;
                  resolve(new Media(_this.config, _this.network, response.body));
                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](2);
                  reject(_context.t0);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 9]]);
        }));

        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * Posts raw content to media service
     * @param {String} contentType - content type of media
     * @param {String|Buffer|Blob} media - content to post
     * @param {MediaCategory|null} category - category for the media
     */

  }, {
    key: "post",
    value: function post(contentType, media, category, filename) {
      var _this2 = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2(resolve, reject, onCancel) {
          var request, response;
          return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  request = _this2.network.post(_this2.config.mediaUrl, category !== null && category !== void 0 ? category : "media", media, contentType, filename);
                  onCancel(function () {
                    return request.cancel();
                  });
                  _context2.prev = 2;
                  _context2.next = 5;
                  return request;

                case 5:
                  response = _context2.sent;
                  resolve(new Media(_this2.config, _this2.network, response.body));
                  _context2.next = 12;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2["catch"](2);
                  reject(_context2.t0);

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[2, 9]]);
        }));

        return function (_x4, _x5, _x6) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
    /**
     * Posts FormData to media service. Can be used only with browser engine's FormData.
     * In non-browser FormData case the method will do promise reject with
     * new TypeError("Posting FormData supported only with browser engine's FormData")
     * @param {FormData} formData - form data to post
     * @param {MediaCategory|null} category - category for the media
     */

  }, {
    key: "postFormData",
    value: function postFormData(formData, category) {
      var _this3 = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(resolve, reject, onCancel) {
          var request, response;
          return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  request = _this3.network.post(_this3.config.mediaUrl, category !== null && category !== void 0 ? category : "media", formData);
                  onCancel(function () {
                    return request.cancel();
                  });
                  _context3.prev = 2;
                  _context3.next = 5;
                  return request;

                case 5:
                  response = _context3.sent;
                  resolve(new Media(_this3.config, _this3.network, response.body));
                  _context3.next = 12;
                  break;

                case 9:
                  _context3.prev = 9;
                  _context3.t0 = _context3["catch"](2);
                  reject(_context3.t0);

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[2, 9]]);
        }));

        return function (_x7, _x8, _x9) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
    /**
     * Retrieve information about multiple media SIDs at the same time.
     * @param mediaSids Array of Media SIDs to get information from.
     */

  }, {
    key: "mediaSetGet",
    value: function mediaSetGet(mediaSids) {
      var _this4 = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee4(resolve, reject, onCancel) {
          var query, request, response, media;
          return _regeneratorRuntime__default["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  query = {
                    command: "get",
                    list: mediaSids.map(function (sid) {
                      return {
                        media_sid: sid
                      };
                    })
                  };
                  request = _this4.network.post("".concat(_this4.config.mediaSetUrl), null, query, "application/json");
                  onCancel(function () {
                    return request.cancel();
                  });
                  _context4.prev = 3;
                  _context4.next = 6;
                  return request;

                case 6:
                  response = _context4.sent;
                  media = response.body.map(function (item) {
                    if (item.code !== 200) {
                      reject("Failed to obtain detailed information about Media items (failed SID ".concat(item.media_record.sid, ")"));
                      return;
                    }

                    return new Media(_this4.config, _this4.network, item.media_record);
                  });
                  resolve(media);
                  _context4.next = 14;
                  break;

                case 11:
                  _context4.prev = 11;
                  _context4.t0 = _context4["catch"](3);
                  reject(_context4.t0);

                case 14:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[3, 11]]);
        }));

        return function (_x10, _x11, _x12) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
    /**
     * Retrieve temporary URLs for a set of media SIDs.
     * @param mediaSids array of the media SIDs to get URLs from.
     */

  }, {
    key: "mediaSetGetContentUrls",
    value: function mediaSetGetContentUrls(mediaSids) {
      var _this5 = this;

      return new CancellablePromise( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee5(resolve, reject, onCancel) {
          var query, request, response, urls;
          return _regeneratorRuntime__default["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  query = {
                    command: "get",
                    list: mediaSids.map(function (sid) {
                      return {
                        media_sid: sid
                      };
                    })
                  };
                  request = _this5.network.post("".concat(_this5.config.mediaSetUrl), null, query, "application/json");
                  onCancel(function () {
                    return request.cancel();
                  });
                  _context5.prev = 3;
                  _context5.next = 6;
                  return request;

                case 6:
                  response = _context5.sent;
                  urls = new Map();
                  response.body.forEach(function (item) {
                    if (item.code !== 200) {
                      reject("Failed to obtain detailed information about Media items (failed SID ".concat(item.media_record.sid, ")"));
                      return;
                    }

                    urls.set(item.media_record.sid, item.media_record.links.content_direct_temporary);
                  });
                  resolve(urls);
                  _context5.next = 15;
                  break;

                case 12:
                  _context5.prev = 12;
                  _context5.t0 = _context5["catch"](3);
                  reject(_context5.t0);

                case 15:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[3, 12]]);
        }));

        return function (_x13, _x14, _x15) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }]);

  return Client;
}(), _defineProperty__default["default"](_class, "version", version), _class);

__decorate([declarativeTypeValidator.validateTypes(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], exports["default"].prototype, "updateToken", null);

__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", CancellablePromise)], exports["default"].prototype, "get", null);

exports["default"] = __decorate([declarativeTypeValidator.validateConstructorTypes(declarativeTypeValidator.nonEmptyString, declarativeTypeValidator.nonEmptyString, [declarativeTypeValidator.nonEmptyString, declarativeTypeValidator.literal(null)], [declarativeTypeValidator.pureObject, "undefined"]), __metadata("design:paramtypes", [String, String, Object, Object])], exports["default"]); // Proper renames should happen in index.ts,

exports.CancellablePromise = CancellablePromise;
exports.Client = exports["default"];
exports.McsClient = exports["default"];
exports.McsMedia = Media;
exports.Media = Media;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 57950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
The MIT License (MIT)

Copyright (c) 2016 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(14334);
__webpack_require__(80437);
var _asyncToGenerator = __webpack_require__(20164);
var _classCallCheck = __webpack_require__(62638);
var _createClass = __webpack_require__(1023);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
var _regeneratorRuntime = __webpack_require__(72975);
__webpack_require__(84874);
__webpack_require__(12702);
__webpack_require__(29978);
__webpack_require__(71227);
__webpack_require__(31415);
__webpack_require__(93786);
__webpack_require__(98484);
__webpack_require__(94184);
var _typeof = __webpack_require__(8114);
var twilsock = __webpack_require__(99469);
var _assertThisInitialized = __webpack_require__(56121);
var _defineProperty = __webpack_require__(93213);
__webpack_require__(34365);
__webpack_require__(38110);
__webpack_require__(24491);
var operationRetrier = __webpack_require__(65803);
var _slicedToArray = __webpack_require__(98371);
var _toConsumableArray = __webpack_require__(40299);
__webpack_require__(86800);
__webpack_require__(24477);
var logger = __webpack_require__(33108);
var uuid = __webpack_require__(24819);
var declarativeTypeValidator = __webpack_require__(94662);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var logger__namespace = /*#__PURE__*/_interopNamespace(logger);
var uuid__namespace = /*#__PURE__*/_interopNamespace(uuid);

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default["default"](Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default["default"](Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };
    
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener){
    return this.removeListener(type, listener);
};

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

var log = logger__namespace.getLogger("twilio-notificatiions");

function prepareLine(prefix, args) {
  return ["".concat(new Date().toISOString(), " Twilio.Notifications ").concat(prefix, ":")].concat(Array.from(args));
}

var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck__default["default"](this, Logger);
  }

  _createClass__default["default"](Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      log.setLevel(level);
    }
  }, {
    key: "trace",
    value: function trace() {
      if (log.getLevel() == log.levels.TRACE) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        log.debug.apply(null, prepareLine("T", args));
      }
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      log.debug.apply(null, prepareLine("D", args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      log.info.apply(null, prepareLine("I", args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      log.warn.apply(null, prepareLine("W", args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      log.error.apply(null, prepareLine("E", args));
    }
  }]);

  return Logger;
}();

var logInstance = new Logger();

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RegistrationState = /*#__PURE__*/_createClass__default["default"](function RegistrationState() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var notificationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var messageTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();

  _classCallCheck__default["default"](this, RegistrationState);

  this.token = token;
  this.notificationId = notificationId;
  this.messageTypes = messageTypes;
});

function setDifference(a, b) {
  return [].concat(_toConsumableArray__default["default"](_toConsumableArray__default["default"](a).filter(function (x) {
    return !b.has(x);
  })), _toConsumableArray__default["default"](_toConsumableArray__default["default"](b).filter(function (x) {
    return !a.has(x);
  })));
}

function hasDifference(a, b) {
  var reasons = new Set();

  if (a.notificationId !== b.notificationId) {
    reasons.add("notificationId");
  }

  if (a.token !== b.token) {
    reasons.add("token");
  }

  if (setDifference(a.messageTypes, b.messageTypes).length > 0) {
    reasons.add("messageType");
  }

  return [reasons.size > 0, reasons];
}

var Connector = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default["default"](Connector, _EventEmitter);

  var _super = _createSuper$3(Connector);

  // @todo replace with FSM
  function Connector(channelType) {
    var _this;

    _classCallCheck__default["default"](this, Connector);

    _this = _super.call(this);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "desiredState", new RegistrationState());

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "currentState", new RegistrationState());

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "_hasActiveAttempt", false);

    _this.channelType = channelType;
    return _this;
  }
  /**
   * Set desired notification ID for the registration.
   * Call commitChanges() afterwards to commit this change.
   * @param notificationId Notification context ID to register.
   */


  _createClass__default["default"](Connector, [{
    key: "setNotificationId",
    value: function setNotificationId(notificationId) {
      this.desiredState.notificationId = notificationId;
    }
    /**
     * Return true is this connector is in usable state and should be able to commit changes.
     */

  }, {
    key: "isActive",
    value: function isActive() {
      return this.desiredState.notificationId !== "";
    }
  }, {
    key: "subscribe",
    value: function subscribe(messageType) {
      if (this.desiredState.messageTypes.has(messageType)) {
        logInstance.debug("message type '".concat(messageType, "' for channel ").concat(this.channelType, " is already registered"));
        return;
      }

      this.desiredState.messageTypes.add(messageType);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(messageType) {
      if (!this.desiredState.messageTypes.has(messageType)) {
        return;
      }

      this.desiredState.messageTypes.delete(messageType);
    }
  }, {
    key: "updateToken",
    value: function updateToken(token) {
      // @todo not entirely correct?
      this.desiredState.token = token;
    }
    /**
     * Perform actual registration after all required changes are settled.
     */

  }, {
    key: "commitChanges",
    value: function () {
      var _commitChanges = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
        var _hasDifference, _hasDifference2, needToUpdate, reasons, stateToPersist, persistedState;

        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._hasActiveAttempt) {
                  _context.next = 3;
                  break;
                }

                // Concurrent access violation
                logInstance.error("One registration attempt is already in progress");
                throw new Error("One registration attempt is already in progress");

              case 3:
                _hasDifference = hasDifference(this.desiredState, this.currentState), _hasDifference2 = _slicedToArray__default["default"](_hasDifference, 2), needToUpdate = _hasDifference2[0], reasons = _hasDifference2[1];

                if (needToUpdate) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                if (!this.currentState.notificationId) {
                  reasons.delete("notificationId");
                }

                logInstance.trace("Persisting ".concat(this.channelType, " registration"), reasons, this.desiredState);
                _context.prev = 8;
                this._hasActiveAttempt = true;
                stateToPersist = new RegistrationState();
                stateToPersist.token = this.desiredState.token;
                stateToPersist.notificationId = this.desiredState.notificationId;
                stateToPersist.messageTypes = new Set(this.desiredState.messageTypes);

                if (!(stateToPersist.messageTypes.size > 0)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 17;
                return this.updateRegistration(stateToPersist, reasons);

              case 17:
                persistedState = _context.sent;
                this.currentState.token = persistedState.token;
                this.currentState.notificationId = persistedState.notificationId;
                this.currentState.messageTypes = new Set(persistedState.messageTypes); // @todo twilsock emits registered(notificationContextId) when this context is reg'd

                this.emit("stateChanged", this.channelType, "registered", this.currentState);
                _context.next = 30;
                break;

              case 24:
                _context.next = 26;
                return this.removeRegistration();

              case 26:
                this.currentState.token = stateToPersist.token;
                this.currentState.notificationId = stateToPersist.notificationId;
                this.currentState.messageTypes.clear();
                this.emit("stateChanged", this.channelType, "unregistered", this.currentState);

              case 30:
                _context.next = 35;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](8);
                throw _context.t0;

              case 35:
                _context.prev = 35;
                this._hasActiveAttempt = false;
                return _context.finish(35);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 32, 35, 38]]);
      }));

      function commitChanges() {
        return _commitChanges.apply(this, arguments);
      }

      return commitChanges;
    }()
  }]);

  return Connector;
}(EventEmitter);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var retrierConfig = {
  min: 2000,
  max: 120000,
  randomness: 0.2
};
/**
 * Manages the registrations on ERS service.
 * Deduplicates registrations and manages them automatically.
 */

var RegistrarConnector = /*#__PURE__*/function (_Connector) {
  _inherits__default["default"](RegistrarConnector, _Connector);

  var _super = _createSuper$2(RegistrarConnector);

  /**
   * Creates new instance of the ERS registrar
   *
   * @param channelType {string} Channel this connector will be servicing.
   * @param context {any} productId, platform, and protocolVersion.
   * @param twilsock {TwilsockClient} connection transport.
   * @param registrarUrl {string}
   */
  function RegistrarConnector(channelType, context, // context is separate from config because it's not shared with other connectors
  twilsock, registrarUrl) {
    var _this;

    _classCallCheck__default["default"](this, RegistrarConnector);

    _this = _super.call(this, channelType);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "registrationId", null);

    _this.context = context;
    _this.twilsock = twilsock;
    _this.registrarUrl = registrarUrl;
    return _this;
  }

  _createClass__default["default"](RegistrarConnector, [{
    key: "updateRegistration",
    value: function () {
      var _updateRegistration = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(registration, reasons) {
        var _this2 = this;

        var registrarRequest, productId, url, headers, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!reasons.has("notificationId")) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.removeRegistration();

              case 3:
                if (!(!registration.notificationId || !registration.notificationId.length)) {
                  _context.next = 6;
                  break;
                }

                logInstance.error("No push notification ID for registration");
                throw new Error("No push notification ID for registration");

              case 6:
                logInstance.trace("Registering", this.channelType, registration);
                registrarRequest = {
                  endpoint_platform: this.context.platform,
                  channel_type: this.channelType,
                  version: this.context.protocolVersion.toString(),
                  message_types: Array.from(registration.messageTypes),
                  data: {
                    registration_id: registration.notificationId
                  } //ttl: 'PT24H' - This is totally ignored by notify, all bindings use PT1Y ttl.

                };
                productId = this.context.productId;
                url = "".concat(this.registrarUrl, "?productId=").concat(productId);
                headers = {
                  "Content-Type": "application/json" // 'X-Twilio-Token': registration.token

                };
                logInstance.trace("Creating registration for channel ".concat(this.channelType));
                _context.prev = 12;
                _context.next = 15;
                return new operationRetrier.AsyncRetrier(retrierConfig).run(function () {
                  return _this2.twilsock.post(url, headers, registrarRequest, productId);
                });

              case 15:
                response = _context.sent;
                this.registrationId = response.body.id;
                logInstance.debug("Registration created: ", response);
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](12);
                logInstance.error("Registration failed: ", _context.t0);
                throw _context.t0;

              case 24:
                return _context.abrupt("return", registration);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 20]]);
      }));

      function updateRegistration(_x, _x2) {
        return _updateRegistration.apply(this, arguments);
      }

      return updateRegistration;
    }()
  }, {
    key: "removeRegistration",
    value: function () {
      var _removeRegistration = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2() {
        var _this3 = this;

        var productId, url, headers;
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.registrationId) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                productId = this.context.productId;
                url = "".concat(this.registrarUrl, "/").concat(this.registrationId, "?productId=").concat(productId);
                headers = {
                  "Content-Type": "application/json" // 'X-Twilio-Token': this.config.token

                };
                logInstance.trace("Removing registration for ".concat(this.channelType));
                _context2.prev = 6;
                _context2.next = 9;
                return new operationRetrier.AsyncRetrier(Object.assign(retrierConfig, {
                  maxAttemptsCount: 3
                })).run(function () {
                  return _this3.twilsock.delete(url, headers, {}, productId);
                });

              case 9:
                this.registrationId = null;
                this.currentState.notificationId = "";
                logInstance.debug("Registration removed for ".concat(this.channelType));
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](6);
                logInstance.error("Failed to remove registration ", this.channelType, _context2.t0);
                throw _context2.t0;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 14]]);
      }));

      function removeRegistration() {
        return _removeRegistration.apply(this, arguments);
      }

      return removeRegistration;
    }()
  }, {
    key: "sendDeviceRemoveRequest",
    value: function () {
      var _sendDeviceRemoveRequest = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(registrationId) {
        var _this4 = this;

        var productId, url, headers, payload;
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(registrationId === "")) {
                  _context3.next = 2;
                  break;
                }

                throw new Error("Empty registration ID");

              case 2:
                productId = this.context.productId;
                url = "".concat(this.registrarUrl, "?productId=").concat(productId);
                headers = {
                  "Content-Type": "application/json" // @todo Content-Length??

                };
                payload = {
                  binding_type: this.channelType,
                  address: registrationId
                };
                _context3.prev = 6;
                logInstance.trace("Removing old registrations for ".concat(this.channelType));
                _context3.next = 10;
                return new operationRetrier.AsyncRetrier(Object.assign(retrierConfig, {
                  maxAttemptsCount: 3
                })).run(function () {
                  return _this4.twilsock.delete(url, headers, payload, productId);
                });

              case 10:
                this.registrationId = null;
                this.currentState.notificationId = "";
                logInstance.debug("Registration removed for ".concat(this.channelType));
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](6);
                logInstance.error("Failed to remove registration ", this.channelType, _context3.t0);
                throw _context3.t0;

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 15]]);
      }));

      function sendDeviceRemoveRequest(_x3) {
        return _sendDeviceRemoveRequest.apply(this, arguments);
      }

      return sendDeviceRemoveRequest;
    }()
  }]);

  return RegistrarConnector;
}(Connector);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Registrar connector implementation for twilsock -- @todo Drop twilsock.connector COMPLETELY?!
 */

var TwilsockConnector = /*#__PURE__*/function (_Connector) {
  _inherits__default["default"](TwilsockConnector, _Connector);

  var _super = _createSuper$1(TwilsockConnector);

  /**
   * Create twilsock registration connector.
   * @param productId product ID
   * @param platform platform ID string
   * @param twilsock {TwilsockClient} connection transport.
   */
  function TwilsockConnector(productId, platform, twilsock) {
    var _this;

    _classCallCheck__default["default"](this, TwilsockConnector);

    _this = _super.call(this, "twilsock");

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "contextId", uuid__namespace.v4());

    _this.productId = productId;
    _this.platform = platform;
    _this.twilsock = twilsock;
    return _this;
  }

  _createClass__default["default"](TwilsockConnector, [{
    key: "updateRegistration",
    value: function () {
      var _updateRegistration = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(registration, reasons) {
        var messageTypes, context;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (reasons.has("messageType")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", registration);

              case 2:
                messageTypes = Array.from(registration.messageTypes);
                context = {
                  product_id: this.productId,
                  notification_protocol_version: 4,
                  endpoint_platform: this.platform,
                  message_types: messageTypes
                };
                _context.prev = 4;
                _context.next = 7;
                return this.twilsock.setNotificationsContext(this.contextId, context);

              case 7:
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);
                logInstance.error("Failed to update twilsock notification context: ".concat(_context.t0));
                throw _context.t0;

              case 13:
                return _context.abrupt("return", registration);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 9]]);
      }));

      function updateRegistration(_x, _x2) {
        return _updateRegistration.apply(this, arguments);
      }

      return updateRegistration;
    }()
  }, {
    key: "removeRegistration",
    value: function () {
      var _removeRegistration = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2() {
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.twilsock.removeNotificationsContext(this.contextId);

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                logInstance.error("Failed to remove twilsock notification context: ".concat(_context2.t0));
                throw _context2.t0;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function removeRegistration() {
        return _removeRegistration.apply(this, arguments);
      }

      return removeRegistration;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "sendDeviceRemoveRequest",
    value: function () {
      var _sendDeviceRemoveRequest = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(registrationId) {
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function sendDeviceRemoveRequest(_x3) {
        return _sendDeviceRemoveRequest.apply(this, arguments);
      }

      return sendDeviceRemoveRequest;
    }()
  }]);

  return TwilsockConnector;
}(Connector);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Client_1;

var channelTypeRule = declarativeTypeValidator.literal("apn", "fcm", "twilsock");
/**
 * @class
 * @alias Notifications
 * @classdesc The helper library for the notification service.
 * Provides high level api for creating and managing notification subscriptions and receiving messages
 * Creates the instance of Notification helper library
 *
 * @constructor
 * @param {string} token - Twilio access token
 * @param {Notifications#ClientOptions} options - Options to customize client behavior
 *
 * @event stateChanged channelType (registered|unregistered) -- coming from connector, i.e. it's per-connector type!
 * @event transportState Forwarded from Twilsock's stateChanged event.
 * @event message Routed from twilsock as a notification event.
 */

exports.Notifications = Client_1 = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default["default"](Client, _EventEmitter);

  var _super = _createSuper(Client);

  function Client(token) {
    var _options$logLevel, _options$productId, _options$twilsockClie, _options$notification, _ref, _config$region;

    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck__default["default"](this, Client);

    _this = _super.call(this);
    options.logLevel = (_options$logLevel = options.logLevel) !== null && _options$logLevel !== void 0 ? _options$logLevel : "error";
    logInstance.setLevel(options.logLevel);
    var productId = (_options$productId = options.productId) !== null && _options$productId !== void 0 ? _options$productId : "notifications";
    var startTwilsock = !options.twilsockClient;
    var twilsock$1 = options.twilsockClient = (_options$twilsockClie = options.twilsockClient) !== null && _options$twilsockClie !== void 0 ? _options$twilsockClie : new twilsock.TwilsockClient(token, productId, options);
    var config = (_options$notification = options.notifications) !== null && _options$notification !== void 0 ? _options$notification : {};
    var region = (_ref = (_config$region = config.region) !== null && _config$region !== void 0 ? _config$region : options.region) !== null && _ref !== void 0 ? _ref : "us1";
    var defaultUrl = "https://ers.".concat(region, ".twilio.com/v1/registrations");
    var registrarUrl = config.ersUrl || defaultUrl;
    _this.connectors = new Map();

    var platform = Client_1._detectPlatform();

    _this.connectors.set("apn", new RegistrarConnector("apn", {
      protocolVersion: 4,
      productId: productId,
      platform: platform
    }, twilsock$1, registrarUrl));

    _this.connectors.set("fcm", new RegistrarConnector("fcm", {
      protocolVersion: 3,
      productId: productId,
      platform: platform
    }, twilsock$1, registrarUrl));

    _this.connectors.set("twilsock", new TwilsockConnector(productId, platform, twilsock$1));

    twilsock$1.on("stateChanged", function (state) {
      return _this.emit("transportState", state);
    });

    _this._connector("twilsock").on("stateChanged", function (type, value, state) {
      return _this.emit("stateChanged", type, value, state);
    });

    _this._connector("apn").on("stateChanged", function (type, value, state) {
      return _this.emit("stateChanged", type, value, state);
    });

    _this._connector("fcm").on("stateChanged", function (type, value, state) {
      return _this.emit("stateChanged", type, value, state);
    }); // Router


    twilsock$1.on("message", function (type, message) {
      return _this._routeMessage(type, message);
    });

    _this.updateToken(token); // Start only if we created twilsock locally,
    // otherwise it's the responsibility of whoever created the Twilsock client.


    if (startTwilsock) {
      twilsock$1.connect();
      _this.twilsock = twilsock$1;
    }

    return _this;
  }

  _createClass__default["default"](Client, [{
    key: "shutdown",
    value: function () {
      var _shutdown = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.connectors.clear();

                if (!this.twilsock) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.twilsock.disconnect();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function shutdown() {
        return _shutdown.apply(this, arguments);
      }

      return shutdown;
    }()
    /**
     * Set OS-provided APNS/FCM registration binding for the given channel type. Not used for 'twilsock'.
     *
     * You must call this function once you've received the ID of your device from the underlying OS.
     *
     * @param {ChannelType} channelType Channel type ('apn'/'fcm').
     * @param {string} pushRegistrationId Token received from FCM/APNS system on device.
     */

  }, {
    key: "setPushRegistrationId",
    value: function setPushRegistrationId(channelType, pushRegistrationId) {
      logInstance.debug("Set ".concat(channelType, " push registration id '").concat(pushRegistrationId, "'"));

      this._connector(channelType).setNotificationId(pushRegistrationId);
    }
    /**
     * Subscribe to a given message type for a given channel type.
     *
     * Creates a subscriptions to receive incoming messages according to message type.
     * Subscription establishes a binding and you will receive a signal when a notification
     * of this type has been received by the library.
     *
     * Subscribed binding is preserved for 1 year, after which time it needs to be re-subscribed.
     * This is the responsibility of the client SDK.
     *
     * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
     * @param {string} messageType The type of message that you want to receive
     */

  }, {
    key: "subscribe",
    value: function subscribe(channelType, messageType) {
      logInstance.debug("Add ".concat(channelType, " subscriptions for message type ").concat(messageType));

      this._connector(channelType).subscribe(messageType);
    }
    /**
     * Unsubscribe from a given message type.
     *
     * Unsubscribing breaks a binding and you will not receive more notifications for this message type.
     * Please note that you have to call commitChanges() and receive a successful result before
     * the subscription is actually removed.
     *
     * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
     * @param {string} messageType The type of message that you don't want to receive anymore
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(channelType, messageType) {
      logInstance.debug("Remove ".concat(channelType, " subscriptions for message type ").concat(messageType));

      this._connector(channelType).unsubscribe(messageType);
    }
    /**
     * Update subscription token. You must update the token when the old one expires.
     *
     * When you receive onTokenWillExpire event from twilsock, call this function with the new refreshed
     * token _after_ you have updated twilsock and other associated objects with the new token.
     *
     * @param {string} token Authentication token for registrations
     */

  }, {
    key: "updateToken",
    value: function updateToken(token) {
      this.connectors.forEach(function (connector) {
        return connector.updateToken(token);
      });
    }
    /**
     * Commit all collected subscription changes as a batched update. This function tries to reduce
     * number of network calls necessary to update bindings status.
     */

  }, {
    key: "commitChanges",
    value: function () {
      var _commitChanges = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2() {
        var promises;
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                promises = [];
                this.connectors.forEach(function (connector) {
                  if (connector.isActive()) {
                    promises.push(connector.commitChanges());
                  }
                });
                _context2.next = 4;
                return Promise.all(promises);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function commitChanges() {
        return _commitChanges.apply(this, arguments);
      }

      return commitChanges;
    }()
    /**
     * Clear existing registrations directly using provided device token.
     * This is useful to ensure stopped subscriptions without resubscribing.
     *
     * This function goes completely beside the state machine and removes all registrations.
     * Use with caution: if it races with current state machine operations, madness will ensue.
     *
     * @param {ChannelType} channelType Channel type ('apn'/'fcm').
     * @param {string} registrationId Token received from FCM/APNS system on device.
     */

  }, {
    key: "removeRegistrations",
    value: function () {
      var _removeRegistrations = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(channelType, registrationId) {
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._connector(channelType).sendDeviceRemoveRequest(registrationId);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeRegistrations(_x, _x2) {
        return _removeRegistrations.apply(this, arguments);
      }

      return removeRegistrations;
    }()
    /**
     * Handle incoming push notification.
     * Client application should call this method when it receives push notifications and pass the received data.
     * @param {Object} message push message
     * @return {PushNotification} A reformatted payload with extracted message type.
     */

  }, {
    key: "handlePushNotification",
    value: function handlePushNotification(message) {
      return {
        messageType: message.twi_message_type,
        payload: message.payload
      };
    }
    /**
     * Routes messages to the external subscribers
     */

  }, {
    key: "_routeMessage",
    value: function _routeMessage(type, message) {
      logInstance.debug("Notification message arrived: ", type, message);
      this.emit("message", type, message);
    }
    /**
     * @param {String} type Channel type
     * @throws {Error} Error with description
     */

  }, {
    key: "_connector",
    value: function _connector(type) {
      var connector = this.connectors.get(type);

      if (!connector) {
        throw new Error("Unknown channel type: ".concat(type));
      }

      return connector;
    }
    /**
     * Returns platform string limited to max 128 chars
     */

  }], [{
    key: "_detectPlatform",
    value: function _detectPlatform() {
      var platform = "";

      if (typeof navigator !== "undefined") {
        platform = "unknown";

        if (typeof navigator.product !== "undefined") {
          platform = navigator.product;
        }

        if (typeof navigator.userAgent !== "undefined") {
          platform = navigator.userAgent;
        }
      } else {
        platform = "web";
      }

      return platform.substring(0, 128);
    }
  }]);

  return Client;
}(EventEmitter);

__decorate([declarativeTypeValidator.validateTypes(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "setPushRegistrationId", null);

__decorate([declarativeTypeValidator.validateTypes(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "subscribe", null);

__decorate([declarativeTypeValidator.validateTypes(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "unsubscribe", null);

__decorate([declarativeTypeValidator.validateTypes(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "updateToken", null);

__decorate([declarativeTypeValidator.validateTypesAsync(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", Promise)], exports.Notifications.prototype, "removeRegistrations", null);

exports.Notifications = Client_1 = __decorate([declarativeTypeValidator.validateConstructorTypes(declarativeTypeValidator.nonEmptyString, [declarativeTypeValidator.pureObject, "undefined", declarativeTypeValidator.literal(null)]), __metadata("design:paramtypes", [String, Object])], exports.Notifications);
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 38810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(90614);
__webpack_require__(29978);
__webpack_require__(38110);
__webpack_require__(71227);
__webpack_require__(86283);
__webpack_require__(89615);
__webpack_require__(26847);
__webpack_require__(84874);
__webpack_require__(31415);
var _typeof = __webpack_require__(8114);
__webpack_require__(92979);
__webpack_require__(77428);
__webpack_require__(39837);
var _slicedToArray = __webpack_require__(98371);
__webpack_require__(83793);
__webpack_require__(93786);
__webpack_require__(80437);
var _toConsumableArray = __webpack_require__(40299);
var _classCallCheck = __webpack_require__(62638);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
__webpack_require__(11478);
__webpack_require__(94184);
__webpack_require__(16669);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);

var custom = function custom() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return {
    checks: checks
  };
};

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var type = function type() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$3(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _type = _step.value;

        if (typeof _type === "string") {
          isValid = isValid || _typeof__default['default'](value) === _type;
          expectedTypes.push("of type ".concat(_type));
          continue;
        }

        isValid = isValid || value instanceof _type;
        expectedTypes.push("an instance of ".concat(_type.name));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var literal = function literal() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$2(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;
        isValid = isValid || value === type;
        expectedTypes.push(typeof type === "string" ? "\"".concat(type, "\"") : "".concat(type));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

var nonEmptyString = custom(function (value) {
  return [typeof value === "string" && value.length > 0, "a non-empty string"];
});

var nonNegativeInteger = custom(function (value) {
  return [typeof value === "number" && Number.isInteger(value) && value >= 0, "a non-negative integer"];
});

var pureObject = custom(function (value) {
  return [_typeof__default['default'](value) === "object" && value !== null && !Array.isArray(value), "a pure object (non-null and non-array)"];
});

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var runtimeTypeValidation = function runtimeTypeValidation(rules, values) {
  if (values.length > rules.length) {
    throw new Error("Expected at most ".concat(rules.length, " argument(s), but got ").concat(values.length));
  }

  while (values.length < rules.length) {
    values.push(undefined);
  }

  var _iterator = _createForOfIteratorHelper$1(values.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray__default['default'](_step.value, 2),
          index = _step$value[0],
          value = _step$value[1];

      var _validateValue = validateValue(rules[index], value),
          _validateValue2 = _slicedToArray__default['default'](_validateValue, 4),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2],
          delimeter = _validateValue2[3];

      if (isValid) {
        continue;
      }

      var argumentIndex = index + 1;
      throw new Error("Argument ".concat(argumentIndex, " is expected to be ").concat(expected).concat(delimeter, " but got ").concat(received));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var stringifyReceivedType = function stringifyReceivedType(value) {
  var _value$constructor;

  var receivedType;
  var types = ["undefined", "boolean", "number", "bigint", "string"];

  if (types.includes(_typeof__default['default'](value))) {
    receivedType = typeof value === "string" ? "\"".concat(value, "\"") : "".concat(value);
  }

  if (_typeof__default['default'](value) === "object" && (value === null || value === void 0 ? void 0 : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) !== "Object") {
    var _value$constructor2;

    receivedType = value === null ? "null" : "instance of ".concat(value === null || value === void 0 ? void 0 : (_value$constructor2 = value.constructor) === null || _value$constructor2 === void 0 ? void 0 : _value$constructor2.name);
  }

  if (!receivedType) {
    receivedType = _typeof__default['default'](value);
  }

  return receivedType;
};
/* eslint-disable @typescript-eslint/no-explicit-any */

var validateConstructorTypes = function validateConstructorTypes() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (ctor) {
    return /*#__PURE__*/function (_ctor) {
      _inherits__default['default'](_class, _ctor);

      var _super = _createSuper(_class);

      function _class() {
        _classCallCheck__default['default'](this, _class);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        runtimeTypeValidation(finalRuleSet, args);
        return _super.call.apply(_super, [this].concat(args));
      }

      return _class;
    }(ctor);
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any */

var validateTypes = function validateTypes() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypes decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      runtimeTypeValidation(finalRuleSet, args);
      return originalMethod.apply(this, args);
    };
  };
};
var validateTypesAsync = function validateTypesAsync() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      try {
        runtimeTypeValidation(finalRuleSet, args);
      } catch (e) {
        return Promise.reject(e);
      }

      return originalMethod.apply(this, args);
    };
  };
};
var convertRuleArguments = function convertRuleArguments(args) {
  var finalRuleDefinitionSet = [];

  var _iterator2 = _createForOfIteratorHelper$1(args),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var arg = _step2.value;
      finalRuleDefinitionSet.push(convertRuleArgument(arg));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return finalRuleDefinitionSet;
};
var convertRuleArgument = function convertRuleArgument(arg) {
  var finalArgumentRuleDefinitions = [];
  var declaredRules = Array.isArray(arg) ? arg : [arg];

  var _iterator3 = _createForOfIteratorHelper$1(declaredRules),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var rule = _step3.value;

      if (typeof rule === "string" || typeof rule === "function") {
        finalArgumentRuleDefinitions.push(type(rule));
        continue;
      }

      finalArgumentRuleDefinitions.push(rule);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return finalArgumentRuleDefinitions;
};
var validateValue = function validateValue(ruleDefinitions, value) {
  var expectedTypes = [];
  var customReceivedType;
  var isValid = false;

  var _iterator4 = _createForOfIteratorHelper$1(ruleDefinitions),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var definition = _step4.value;

      var _iterator5 = _createForOfIteratorHelper$1(definition.checks),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var check = _step5.value;

          var _check = check(value),
              _check2 = _slicedToArray__default['default'](_check, 3),
              checkPassed = _check2[0],
              typeDescription = _check2[1],
              _receivedType = _check2[2];

          isValid = isValid || checkPassed;

          if (!customReceivedType && _receivedType) {
            customReceivedType = _receivedType;
          }

          if (typeDescription) {
            expectedTypes = typeof typeDescription === "string" ? [].concat(_toConsumableArray__default['default'](expectedTypes), [typeDescription]) : [].concat(_toConsumableArray__default['default'](expectedTypes), _toConsumableArray__default['default'](typeDescription));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (isValid) {
    return [true];
  }

  var receivedType = customReceivedType || stringifyReceivedType(value);
  var lastIndex = expectedTypes.length - 1;
  var expectedTypesString = lastIndex > 0 ? "".concat(expectedTypes.slice(0, lastIndex).join(", "), " or ").concat(expectedTypes[lastIndex]) : expectedTypes.join(", ");
  return [false, receivedType, expectedTypesString, lastIndex > 1 ? ";" : ","];
};

var objectSchema = function objectSchema(name, schema) {
  return custom(function (object) {
    if (_typeof__default['default'](object) !== "object" || object === null || Array.isArray(object)) {
      return [false, "valid ".concat(name, " (should be a pure object)")];
    }

    for (var _i = 0, _Object$entries = Object.entries(schema); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default['default'](_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          rules = _Object$entries$_i[1];

      var _validateValue = validateValue(convertRuleArgument(rules), object[key]),
          _validateValue2 = _slicedToArray__default['default'](_validateValue, 3),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2];

      if (!isValid) {
        return [false, "valid ".concat(name, " (key \"").concat(key, "\" should be ").concat(expected, ")"), "malformed ".concat(name, " (key \"").concat(key, "\" is ").concat(received, ")")];
      }
    }

    return [true];
  });
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var array = function array(name, rules) {
  return custom(function (value) {
    if (!Array.isArray(value)) {
      return [false, "an array of ".concat(name)];
    }

    var _iterator = _createForOfIteratorHelper(value.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray__default['default'](_step.value, 2),
            key = _step$value[0],
            valueOfKey = _step$value[1];

        var _validateValue = validateValue(convertRuleArgument(rules), valueOfKey),
            _validateValue2 = _slicedToArray__default['default'](_validateValue, 3),
            isValid = _validateValue2[0],
            received = _validateValue2[1],
            expected = _validateValue2[2];

        if (!isValid) {
          return [false, "a valid array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [true];
  });
};

exports.array = array;
exports.custom = custom;
exports.literal = literal;
exports.nonEmptyString = nonEmptyString;
exports.nonNegativeInteger = nonNegativeInteger;
exports.objectSchema = objectSchema;
exports.pureObject = pureObject;
exports.runtimeTypeValidation = runtimeTypeValidation;
exports.stringifyReceivedType = stringifyReceivedType;
exports.type = type;
exports.validateConstructorTypes = validateConstructorTypes;
exports.validateTypes = validateTypes;
exports.validateTypesAsync = validateTypesAsync;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 79627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(90614);
__webpack_require__(29978);
__webpack_require__(38110);
__webpack_require__(71227);
__webpack_require__(86283);
__webpack_require__(89615);
__webpack_require__(26847);
__webpack_require__(84874);
__webpack_require__(31415);
var _typeof = __webpack_require__(8114);
__webpack_require__(92979);
__webpack_require__(77428);
__webpack_require__(39837);
var _slicedToArray = __webpack_require__(98371);
__webpack_require__(83793);
__webpack_require__(93786);
__webpack_require__(80437);
var _toConsumableArray = __webpack_require__(40299);
var _classCallCheck = __webpack_require__(62638);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
__webpack_require__(11478);
__webpack_require__(94184);
__webpack_require__(16669);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);

var custom = function custom() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return {
    checks: checks
  };
};

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var type = function type() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$3(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _type = _step.value;

        if (typeof _type === "string") {
          isValid = isValid || _typeof__default['default'](value) === _type;
          expectedTypes.push("of type ".concat(_type));
          continue;
        }

        isValid = isValid || value instanceof _type;
        expectedTypes.push("an instance of ".concat(_type.name));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var literal = function literal() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$2(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;
        isValid = isValid || value === type;
        expectedTypes.push(typeof type === "string" ? "\"".concat(type, "\"") : "".concat(type));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

var nonEmptyString = custom(function (value) {
  return [typeof value === "string" && value.length > 0, "a non-empty string"];
});

var nonNegativeInteger = custom(function (value) {
  return [typeof value === "number" && Number.isInteger(value) && value >= 0, "a non-negative integer"];
});

var pureObject = custom(function (value) {
  return [_typeof__default['default'](value) === "object" && value !== null && !Array.isArray(value), "a pure object (non-null and non-array)"];
});

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var runtimeTypeValidation = function runtimeTypeValidation(rules, values) {
  if (values.length > rules.length) {
    throw new Error("Expected at most ".concat(rules.length, " argument(s), but got ").concat(values.length));
  }

  while (values.length < rules.length) {
    values.push(undefined);
  }

  var _iterator = _createForOfIteratorHelper$1(values.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray__default['default'](_step.value, 2),
          index = _step$value[0],
          value = _step$value[1];

      var _validateValue = validateValue(rules[index], value),
          _validateValue2 = _slicedToArray__default['default'](_validateValue, 4),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2],
          delimeter = _validateValue2[3];

      if (isValid) {
        continue;
      }

      var argumentIndex = index + 1;
      throw new Error("Argument ".concat(argumentIndex, " is expected to be ").concat(expected).concat(delimeter, " but got ").concat(received));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var stringifyReceivedType = function stringifyReceivedType(value) {
  var _value$constructor;

  var receivedType;
  var types = ["undefined", "boolean", "number", "bigint", "string"];

  if (types.includes(_typeof__default['default'](value))) {
    receivedType = typeof value === "string" ? "\"".concat(value, "\"") : "".concat(value);
  }

  if (_typeof__default['default'](value) === "object" && (value === null || value === void 0 ? void 0 : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) !== "Object") {
    var _value$constructor2;

    receivedType = value === null ? "null" : "instance of ".concat(value === null || value === void 0 ? void 0 : (_value$constructor2 = value.constructor) === null || _value$constructor2 === void 0 ? void 0 : _value$constructor2.name);
  }

  if (!receivedType) {
    receivedType = _typeof__default['default'](value);
  }

  return receivedType;
};
/* eslint-disable @typescript-eslint/no-explicit-any */

var validateConstructorTypes = function validateConstructorTypes() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (ctor) {
    return /*#__PURE__*/function (_ctor) {
      _inherits__default['default'](_class, _ctor);

      var _super = _createSuper(_class);

      function _class() {
        _classCallCheck__default['default'](this, _class);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        runtimeTypeValidation(finalRuleSet, args);
        return _super.call.apply(_super, [this].concat(args));
      }

      return _class;
    }(ctor);
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any */

var validateTypes = function validateTypes() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypes decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      runtimeTypeValidation(finalRuleSet, args);
      return originalMethod.apply(this, args);
    };
  };
};
var validateTypesAsync = function validateTypesAsync() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      try {
        runtimeTypeValidation(finalRuleSet, args);
      } catch (e) {
        return Promise.reject(e);
      }

      return originalMethod.apply(this, args);
    };
  };
};
var convertRuleArguments = function convertRuleArguments(args) {
  var finalRuleDefinitionSet = [];

  var _iterator2 = _createForOfIteratorHelper$1(args),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var arg = _step2.value;
      finalRuleDefinitionSet.push(convertRuleArgument(arg));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return finalRuleDefinitionSet;
};
var convertRuleArgument = function convertRuleArgument(arg) {
  var finalArgumentRuleDefinitions = [];
  var declaredRules = Array.isArray(arg) ? arg : [arg];

  var _iterator3 = _createForOfIteratorHelper$1(declaredRules),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var rule = _step3.value;

      if (typeof rule === "string" || typeof rule === "function") {
        finalArgumentRuleDefinitions.push(type(rule));
        continue;
      }

      finalArgumentRuleDefinitions.push(rule);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return finalArgumentRuleDefinitions;
};
var validateValue = function validateValue(ruleDefinitions, value) {
  var expectedTypes = [];
  var customReceivedType;
  var isValid = false;

  var _iterator4 = _createForOfIteratorHelper$1(ruleDefinitions),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var definition = _step4.value;

      var _iterator5 = _createForOfIteratorHelper$1(definition.checks),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var check = _step5.value;

          var _check = check(value),
              _check2 = _slicedToArray__default['default'](_check, 3),
              checkPassed = _check2[0],
              typeDescription = _check2[1],
              _receivedType = _check2[2];

          isValid = isValid || checkPassed;

          if (!customReceivedType && _receivedType) {
            customReceivedType = _receivedType;
          }

          if (typeDescription) {
            expectedTypes = typeof typeDescription === "string" ? [].concat(_toConsumableArray__default['default'](expectedTypes), [typeDescription]) : [].concat(_toConsumableArray__default['default'](expectedTypes), _toConsumableArray__default['default'](typeDescription));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (isValid) {
    return [true];
  }

  var receivedType = customReceivedType || stringifyReceivedType(value);
  var lastIndex = expectedTypes.length - 1;
  var expectedTypesString = lastIndex > 0 ? "".concat(expectedTypes.slice(0, lastIndex).join(", "), " or ").concat(expectedTypes[lastIndex]) : expectedTypes.join(", ");
  return [false, receivedType, expectedTypesString, lastIndex > 1 ? ";" : ","];
};

var objectSchema = function objectSchema(name, schema) {
  return custom(function (object) {
    if (_typeof__default['default'](object) !== "object" || object === null || Array.isArray(object)) {
      return [false, "valid ".concat(name, " (should be a pure object)")];
    }

    for (var _i = 0, _Object$entries = Object.entries(schema); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default['default'](_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          rules = _Object$entries$_i[1];

      var _validateValue = validateValue(convertRuleArgument(rules), object[key]),
          _validateValue2 = _slicedToArray__default['default'](_validateValue, 3),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2];

      if (!isValid) {
        return [false, "valid ".concat(name, " (key \"").concat(key, "\" should be ").concat(expected, ")"), "malformed ".concat(name, " (key \"").concat(key, "\" is ").concat(received, ")")];
      }
    }

    return [true];
  });
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var array = function array(name, rules) {
  return custom(function (value) {
    if (!Array.isArray(value)) {
      return [false, "an array of ".concat(name)];
    }

    var _iterator = _createForOfIteratorHelper(value.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray__default['default'](_step.value, 2),
            key = _step$value[0],
            valueOfKey = _step$value[1];

        var _validateValue = validateValue(convertRuleArgument(rules), valueOfKey),
            _validateValue2 = _slicedToArray__default['default'](_validateValue, 3),
            isValid = _validateValue2[0],
            received = _validateValue2[1],
            expected = _validateValue2[2];

        if (!isValid) {
          return [false, "a valid array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [true];
  });
};

exports.array = array;
exports.custom = custom;
exports.literal = literal;
exports.nonEmptyString = nonEmptyString;
exports.nonNegativeInteger = nonNegativeInteger;
exports.objectSchema = objectSchema;
exports.pureObject = pureObject;
exports.runtimeTypeValidation = runtimeTypeValidation;
exports.stringifyReceivedType = stringifyReceivedType;
exports.type = type;
exports.validateConstructorTypes = validateConstructorTypes;
exports.validateTypes = validateTypes;
exports.validateTypesAsync = validateTypesAsync;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 64411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2022 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(93786);
var log = __webpack_require__(70047);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var log__default = /*#__PURE__*/_interopDefaultLegacy(log);

var deprecated = function deprecated(oldName, newName, link) {
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function" && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get) === undefined) {
      throw new Error("The deprecated decorator can only be applied to methods or getters");
    }

    if (typeof descriptor.value === "function") {
      var originalMethod = descriptor.value;

      descriptor.value = function () {
        deprecationWarning("The method ".concat(oldName, " is deprecated").concat(newName ? ", use " + newName + " instead" : "").concat(link ? ", " + link : "."));

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return originalMethod.apply(this, args);
      };

      return;
    }

    var originalGet = descriptor.get;

    descriptor.get = function () {
      deprecationWarning("The getter ".concat(oldName, " is deprecated").concat(newName ? ", use " + newName + " instead" : "").concat(link ? ", " + link : "."));
      return originalGet === null || originalGet === void 0 ? void 0 : originalGet.apply(this);
    };
  };
};
var deprecationWarning = function deprecationWarning(warning) {
  var currentLevel = log__default["default"].getLevel();
  log__default["default"].setLevel("warn");
  log__default["default"].warn(warning);
  log__default["default"].setLevel(currentLevel);
};

exports.deprecated = deprecated;
exports.deprecationWarning = deprecationWarning;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 70047:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
        /Trident\/|MSIE /.test(window.navigator.userAgent)
    );

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) {
                console.log.apply(console, arguments);
            } else {
                // In old IE, native console methods themselves don't have apply().
                Function.prototype.apply.apply(console.log, [console, arguments]);
            }
        }
        if (console.trace) console.trace();
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (methodName === 'trace' && isIE) {
            return traceForIE;
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;

      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = undefined;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType || !storageKey) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType || !storageKey) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      function clearPersistedLevel() {
          if (typeof window === undefinedType || !storageKey) return;

          // Use localStorage if available
          try {
              window.localStorage.removeItem(storageKey);
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch (ignore) {}
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          defaultLevel = level;
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.resetLevel = function () {
          self.setLevel(defaultLevel, false);
          clearPersistedLevel();
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    // ES6 default export, for compatibility
    defaultLogger['default'] = defaultLogger;

    return defaultLogger;
}));


/***/ }),

/***/ 67720:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2018, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/


var global =
  typeof global !== "undefined"
    ? global
    : typeof self !== "undefined"
    ? self
    : typeof window !== "undefined"
    ? window
    : {};

Object.defineProperty(exports, "__esModule", ({ value: true }));

var _asyncToGenerator = __webpack_require__(20164);
var _defineProperty = __webpack_require__(93213);
__webpack_require__(94184);
var _regeneratorRuntime = __webpack_require__(72975);
__webpack_require__(38110);
var log$2 = __webpack_require__(33108);
__webpack_require__(63466);
__webpack_require__(86881);
__webpack_require__(47995);
__webpack_require__(74643);
__webpack_require__(24491);
__webpack_require__(84874);
__webpack_require__(31415);
__webpack_require__(14306);
var operationRetrier = __webpack_require__(65803);
var declarativeTypeValidator = __webpack_require__(79627);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var log__namespace = /*#__PURE__*/_interopNamespace(log$2);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function prepareLine(prefix, args) {
  return ["".concat(new Date().toISOString(), " MCS Client ").concat(prefix, ":")].concat(Array.from(args));
}

class Logger {
  constructor(prefix) {
    _defineProperty__default['default'](this, "prefix", "");

    this.prefix = prefix !== null && prefix !== undefined && prefix.length > 0 ? prefix + " " : "";
  }

  static scope(prefix) {
    return new Logger(prefix);
  }

  setLevel(level) {
    log__namespace.setLevel(level);
  }

  static setLevel(level) {
    log__namespace.setLevel(level);
  }
  /* eslint-disable @typescript-eslint/explicit-module-boundary-types */


  trace() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    log__namespace.trace.apply(null, prepareLine(this.prefix + "T", args));
  }

  debug() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    log__namespace.debug.apply(null, prepareLine(this.prefix + "D", args));
  }

  info() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    log__namespace.info.apply(null, prepareLine(this.prefix + "I", args));
  }

  warn() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    log__namespace.warn.apply(null, prepareLine(this.prefix + "W", args));
  }

  error() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    log__namespace.error.apply(null, prepareLine(this.prefix + "E", args));
  }

  static trace() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    log__namespace.trace.apply(null, prepareLine("T", args));
  }

  static debug() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    log__namespace.debug.apply(null, prepareLine("D", args));
  }

  static info() {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    log__namespace.info.apply(null, prepareLine("I", args));
  }

  static warn() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    log__namespace.warn.apply(null, prepareLine("W", args));
  }

  static error() {
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    log__namespace.error.apply(null, prepareLine("E", args));
  }

}

var MINIMUM_RETRY_DELAY = 1000;
var MAXIMUM_RETRY_DELAY = 4000;
var MAXIMUM_ATTEMPTS_COUNT = 3;
var RETRY_WHEN_THROTTLED = true;

var regionalMcsHost = region => "https://mcs.".concat(region !== null && region !== void 0 ? region : "us1", ".twilio.com");

var isFullUrl = url => url.startsWith("http");

var fullUrl = (partUrl, region) => "".concat(!isFullUrl(partUrl) ? regionalMcsHost(region) : "").concat(partUrl);

class Configuration {
  constructor(token, baseUrl, baseSetUrl, options) {
    var _ref, _options$MCS, _ref2, _constructorOptions$r, _constructorOptions$r2, _constructorOptions$b;

    var constructorOptions = (_ref = (_options$MCS = options.MCS) !== null && _options$MCS !== void 0 ? _options$MCS : options) !== null && _ref !== void 0 ? _ref : {};
    this.region = (_ref2 = (_constructorOptions$r = constructorOptions.region) !== null && _constructorOptions$r !== void 0 ? _constructorOptions$r : options.region) !== null && _ref2 !== void 0 ? _ref2 : 'us1';
    this.mediaUrl = fullUrl(baseUrl, this.region);
    this.mediaSetUrl = baseSetUrl ? fullUrl(baseSetUrl) : "".concat(this.mediaUrl, "Set");
    this.token = token;
    this.retryWhenThrottledOverride = (_constructorOptions$r2 = constructorOptions.retryWhenThrottledOverride) !== null && _constructorOptions$r2 !== void 0 ? _constructorOptions$r2 : RETRY_WHEN_THROTTLED;
    this.backoffConfigOverride = (_constructorOptions$b = constructorOptions.backoffConfigOverride) !== null && _constructorOptions$b !== void 0 ? _constructorOptions$b : Configuration.backoffConfigDefault;
  }

  static get backoffConfigDefault() {
    return {
      min: MINIMUM_RETRY_DELAY,
      max: MAXIMUM_RETRY_DELAY,
      maxAttemptsCount: MAXIMUM_ATTEMPTS_COUNT
    };
  }

  static get retryWhenThrottledDefault() {
    return RETRY_WHEN_THROTTLED;
  }

  updateToken(token) {
    this.token = token;
  }

}

/**
 * @classdesc A Media represents a metadata information for the media upload
 * @property {String} sid - The server-assigned unique identifier for Media
 * @property {String} serviceSid - Service instance id which Media belongs/uploaded to
 * @property {Date} dateCreated - When the Media was created
 * @property {Date} dateUpdated - When the Media was updated
 * @property {Number} size - Size of media, bytes
 * @property {String} contentType - content type of media
 * @property {String} fileName - file name, if present, null otherwise
 * @property {MediaCategory} category - attachment category
 */
class Media {
  constructor(config, network, data) {
    this.config = config;
    this.network = network;

    this._update(data);
  }

  get sid() {
    return this.state.sid;
  }

  get serviceSid() {
    return this.state.serviceSid;
  }

  get dateCreated() {
    return this.state.dateCreated;
  }

  get dateUpdated() {
    return this.state.dateUpdated;
  }

  get contentType() {
    return this.state.contentType;
  }

  get size() {
    return this.state.size;
  }
  /** @deprecated Use filename instead */


  get fileName() {
    return this.state.filename;
  }

  get filename() {
    return this.state.filename;
  }

  get category() {
    return this.state.category;
  }
  /**
   * Returns direct content URL to uploaded binary. This URL will expire after some time.
   * This function gets a new URL every time, preventing it from expiring but putting additional load on backend.
   * See getCachedContentUrl() for a function that reduces the amount of network requests.
   *
   * It is reasonable to build your own refresh logic upon these two functions: as soon as URL returned
   * by getCachedContentUrl() returns 40x status you should call getContentUrl() to refresh it.
   *
   * @returns {Promise<string>}
   */


  getContentUrl() {
    var _this = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
      var response;
      return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.network.get("".concat(_this.config.mediaUrl, "/").concat(_this.sid));

            case 2:
              response = _context.sent;

              _this._update(response.body);

              return _context.abrupt("return", Promise.resolve(_this.state.contentDirectUrl));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
  /**
   * Returns direct content URL to uploaded binary. This URL will expire after some time.
   * This function does not support getting a new URL however. Once set it will remain the same.
   * Use getContentUrl() to query a new one.
   *
   * It is reasonable to build your own refresh logic upon these two functions: as soon as URL returned
   * by getCachedContentUrl() returns 40x status you should call getContentUrl() to refresh it.
   *
   * @returns {Promise<string>}
   */


  getCachedContentUrl() {
    var _this2 = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
      return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.state.contentDirectUrl) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", Promise.resolve(_this2.state.contentDirectUrl));

            case 2:
              _context2.next = 4;
              return _this2.getContentUrl();

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }

  _update(data) {
    var _data$links$content_d, _data$filename, _data$category, _data$is_multipart_up;

    this.state = {
      sid: data.sid,
      serviceSid: data.service_sid,
      channelSid: data.channel_sid,
      messageSid: data.message_sid,
      dateCreated: data.date_created ? new Date(data.date_created) : null,
      dateUploadUpdated: data.date_upload_updated ? new Date(data.date_upload_updated) : null,
      dateUpdated: data.date_updated ? new Date(data.date_updated) : null,
      size: data.size,
      contentType: data.content_type,
      author: data.author,
      url: data.url,
      contentUrl: data.links.content,
      contentDirectUrl: (_data$links$content_d = data.links.content_direct_temporary) !== null && _data$links$content_d !== void 0 ? _data$links$content_d : null,
      filename: (_data$filename = data.filename) !== null && _data$filename !== void 0 ? _data$filename : null,
      category: (_data$category = data.category) !== null && _data$category !== void 0 ? _data$category : "media",
      isMultipartUpstream: (_data$is_multipart_up = data.is_multipart_upstream) !== null && _data$is_multipart_up !== void 0 ? _data$is_multipart_up : false
    };
  }

}

class TransportError extends Error {
  constructor(message, code, body, status, headers) {
    super(message);
    this.code = code;
    this.body = body;
    this.status = status;
    this.headers = headers;
  }

}

var XHR = global["XMLHttpRequest"] || {};

function parseResponseHeaders(headerString) {
  if (!headerString) {
    return {};
  }

  return headerString.split("\r\n").map(el => el.split(": ")).filter(el => el.length === 2 && el[1].length > 0).reduce((prev, curr) => {
    prev[curr[0]] = curr[1];
    return prev;
  }, {});
}

function extractBody(xhr) {
  var contentType = xhr.getResponseHeader("Content-Type");

  if (!contentType || contentType.indexOf("application/json") !== 0 || xhr.responseText.length === 0) {
    return xhr.responseText;
  }

  try {
    return JSON.parse(xhr.responseText);
  } catch (e) {
    return xhr.responseText;
  }
}
/**
 * Provides generic network interface
 */


class Transport {
  static request(method, url, headers, body) {
    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
      return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise((resolve, reject) => {
                var xhr = new XHR();
                xhr.open(method, url, true);

                xhr.onreadystatechange = function onreadystatechange() {
                  if (xhr.readyState !== 4) {
                    return;
                  }

                  var headers = parseResponseHeaders(xhr.getAllResponseHeaders());
                  var body = extractBody(xhr);

                  if (200 <= xhr.status && xhr.status < 300) {
                    resolve({
                      status: xhr.status,
                      headers,
                      body
                    });
                  } else {
                    var _xhr$statusText;

                    var status = (_xhr$statusText = xhr.statusText) !== null && _xhr$statusText !== void 0 ? _xhr$statusText : "NONE";
                    var bodyRepresentation;

                    if (typeof body === "string") {
                      bodyRepresentation = body && body.split("\n", 2).length === 1 ? body : "";
                    } else {
                      bodyRepresentation = JSON.stringify(body);
                    }

                    var message = "".concat(xhr.status, ": [").concat(status, "] ").concat(bodyRepresentation);
                    reject(new TransportError(message, xhr.status, body, status, headers));
                  }
                };

                for (var headerName in headers) {
                  xhr.setRequestHeader(headerName, headers[headerName]);

                  if (headerName === "Content-Type" && headers[headerName] === "application/json") {
                    body = JSON.stringify(body);
                  }
                }

                xhr.send(body);
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
  /**
   * Make a GET request by given URL
   */


  get(url, headers) {
    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
      return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Transport.request("GET", url, headers));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
  /**
   * Make a POST request by given URL
   */


  post(url, headers, body) {
    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3() {
      return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", Transport.request("POST", url, headers, body));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }

}

var log$1 = Logger.scope("Network");

class Network {
  constructor(config, transport) {
    this.config = config;
    this.transport = transport;
  }

  backoffConfig() {
    return Object.assign(Configuration.backoffConfigDefault, this.config.backoffConfigOverride);
  }

  retryWhenThrottled() {
    var _ref, _this$config$retryWhe;

    return (_ref = (_this$config$retryWhe = this.config.retryWhenThrottledOverride) !== null && _this$config$retryWhe !== void 0 ? _this$config$retryWhe : Configuration.retryWhenThrottledDefault) !== null && _ref !== void 0 ? _ref : false;
  }

  executeWithRetry(request, retryWhenThrottled) {
    var _this = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
      return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise((resolve, reject) => {
                var codesToRetryOn = [502, 503, 504];

                if (retryWhenThrottled) {
                  codesToRetryOn.push(429);
                }

                var retrier = new operationRetrier.Retrier(_this.backoffConfig());
                retrier.on("attempt", /*#__PURE__*/_asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
                  var result;
                  return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return request();

                        case 3:
                          result = _context.sent;
                          retrier.succeeded(result);
                          _context.next = 10;
                          break;

                        case 7:
                          _context.prev = 7;
                          _context.t0 = _context["catch"](0);

                          if (codesToRetryOn.indexOf(_context.t0.status) > -1) {
                            retrier.failed(_context.t0);
                          } else if (_context.t0.message === "Twilsock disconnected") {
                            // Ugly hack. We must make a proper exceptions for twilsock
                            retrier.failed(_context.t0);
                          } else {
                            // Fatal error
                            retrier.removeAllListeners();
                            retrier.cancel();
                            reject(_context.t0);
                          }

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 7]]);
                })));
                retrier.on("succeeded", result => {
                  resolve(result);
                });
                retrier.on("cancelled", err => reject(err));
                retrier.on("failed", err => reject(err));
                retrier.start();
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }

  get(url) {
    var _this2 = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3() {
      var headers, response;
      return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              headers = {
                "X-Twilio-Token": _this2.config.token
              };
              log$1.trace("sending GET request to ", url, " headers ", headers);
              _context3.prev = 2;
              _context3.next = 5;
              return _this2.executeWithRetry(() => _this2.transport.get(url, headers), _this2.retryWhenThrottled());

            case 5:
              response = _context3.sent;
              log$1.trace("response", response);
              return _context3.abrupt("return", response);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](2);
              log$1.debug("get() error ".concat(_context3.t0));
              throw _context3.t0;

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 10]]);
    }))();
  }

  post(url, category, media, contentType, filename) {
    var _this3 = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee4() {
      var headers, fullUrl, response;
      return _regeneratorRuntime__default['default'].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              headers = {
                "X-Twilio-Token": _this3.config.token
              };

              if ((typeof FormData === "undefined" || !(media instanceof FormData)) && contentType) {
                Object.assign(headers, {
                  "Content-Type": contentType
                });
              }

              fullUrl = new URL(url);

              if (category) {
                fullUrl.searchParams.append("Category", category);
              }

              if (filename) {
                fullUrl.searchParams.append("Filename", filename);
              }

              log$1.trace("sending POST request to ".concat(url, " with headers ").concat(headers));
              _context4.prev = 6;
              _context4.next = 9;
              return _this3.transport.post(fullUrl.href, headers, media);

            case 9:
              response = _context4.sent;
              _context4.next = 18;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](6);

              if (!(global["XMLHttpRequest"] === undefined && media instanceof FormData)) {
                _context4.next = 16;
                break;
              }

              throw new TypeError("Posting FormData supported only with browser engine's FormData");

            case 16:
              log$1.debug("post() error ".concat(_context4.t0));
              throw _context4.t0;

            case 18:
              log$1.trace("response", response);
              return _context4.abrupt("return", response);

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[6, 12]]);
    }))();
  }

}

var version = "0.5.3";

var _class, _temp;
var log = Logger.scope("");
/**
 * @classdesc A Client provides an interface for Media Content Service
 */

exports["default"] = (_temp = _class = class Client {
  // eslint-disable-next-line

  /**
   * Base URLs must be full URLs with host. If host is not provided it will be generated from a default configuration
   * template using options.region.
   *
   * @param {String} token - Access token
   * @param {String} baseUrl - Base URL for Media Content Service Media resource, i.e. /v1/Services/{serviceSid}/Media
   * @param {String} baseSetUrl - Base URL for Media Content Service MediaSet resource, i.e. /v1/Services/{serviceSid}/MediaSet
   * @param {Client#ClientOptions} [options] - Options to customize the Client
   */
  constructor(token, baseUrl, baseSetUrl) {
    var _this$options$logLeve, _this$options$transpo;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    this.options = options;
    this.options.logLevel = (_this$options$logLeve = this.options.logLevel) !== null && _this$options$logLeve !== void 0 ? _this$options$logLeve : "silent";
    this.config = new Configuration(token, baseUrl, baseSetUrl, this.options);
    log.setLevel(this.options.logLevel);
    this.options.transport = (_this$options$transpo = this.options.transport) !== null && _this$options$transpo !== void 0 ? _this$options$transpo : new Transport();
    this.transport = this.options.transport;
    this.network = new Network(this.config, this.transport);
  }
  /**
   * These options can be passed to Client constructor
   * @typedef {Object} Client#ClientOptions
   * @property {String} [logLevel='silent'] - The level of logging to enable. Valid options
   *   (from strictest to broadest): ['silent', 'error', 'warn', 'info', 'debug', 'trace']
   */

  /**
   * Update the token used for Client operations
   * @param {String} token - The JWT string of the new token
   * @returns {void}
   */


  updateToken(token) {
    log.info("updateToken");
    this.config.updateToken(token);
  }
  /**
   * Gets media from media service
   * @param {String} sid - Media's SID
   * @returns {Promise<Media>}
   */


  get(sid) {
    var _this = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
      var response;
      return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.network.get("".concat(_this.config.mediaUrl, "/").concat(sid));

            case 2:
              response = _context.sent;
              return _context.abrupt("return", new Media(_this.config, _this.network, response.body));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
  /**
   * Posts raw content to media service
   * @param {String} contentType - content type of media
   * @param {String|Buffer|Blob} media - content to post
   * @param {MediaCategory|null} category - category for the media
   * @returns {Promise<Media>}
   */


  post(contentType, media, category, filename) {
    var _this2 = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
      var response;
      return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.network.post(_this2.config.mediaUrl, category !== null && category !== void 0 ? category : "media", media, contentType, filename);

            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", new Media(_this2.config, _this2.network, response.body));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
  /**
   * Posts FormData to media service. Can be used only with browser engine's FormData.
   * In non-browser FormData case the method will do promise reject with
   * new TypeError("Posting FormData supported only with browser engine's FormData")
   * @param {FormData} formData - form data to post
   * @param {MediaCategory|null} category - category for the media
   * @returns {Promise<Media>}
   */


  postFormData(formData, category) {
    var _this3 = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3() {
      var response;
      return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.network.post(_this3.config.mediaUrl, category !== null && category !== void 0 ? category : "media", formData);

            case 2:
              response = _context3.sent;
              return _context3.abrupt("return", new Media(_this3.config, _this3.network, response.body));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
  /**
   * Retrieve information about multiple media SIDs at the same time.
   * @param mediaSids Array of Media SIDs to get information from.
   */


  mediaSetGet(mediaSids) {
    var _this4 = this;

    return _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee4() {
      var query, response;
      return _regeneratorRuntime__default['default'].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              query = {
                command: "get",
                list: mediaSids.map(sid => ({
                  media_sid: sid
                }))
              };
              _context4.next = 3;
              return _this4.network.post("".concat(_this4.config.mediaSetUrl), null, query, "application/json");

            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.body.map(item => {
                if (item.code !== 200) {
                  throw new Error("Failed to obtain detailed information about Media items (failed SID ".concat(item.media_record.sid, ")"));
                }

                return new Media(_this4.config, _this4.network, item.media_record);
              }));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }

}, _defineProperty__default['default'](_class, "version", version), _temp);

__decorate([declarativeTypeValidator.validateTypes(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], exports['default'].prototype, "updateToken", null);

__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], exports['default'].prototype, "get", null);

exports["default"] = __decorate([declarativeTypeValidator.validateConstructorTypes(declarativeTypeValidator.nonEmptyString, declarativeTypeValidator.nonEmptyString, [declarativeTypeValidator.nonEmptyString, declarativeTypeValidator.literal(null)], [declarativeTypeValidator.pureObject, "undefined"]), __metadata("design:paramtypes", [String, String, Object, Object])], exports['default']); // Proper renames should happen in index.ts,

exports.Client = exports['default'];
exports.McsClient = exports['default'];
exports.McsMedia = Media;
exports.Media = Media;
exports["default"] = exports['default'];
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 34078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
The MIT License (MIT)

Copyright (c) 2016 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(80437);
var _asyncToGenerator = __webpack_require__(20164);
var _classCallCheck = __webpack_require__(62638);
var _createClass = __webpack_require__(1023);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
var _regeneratorRuntime = __webpack_require__(72975);
__webpack_require__(84874);
__webpack_require__(12702);
__webpack_require__(29978);
__webpack_require__(71227);
__webpack_require__(31415);
__webpack_require__(93786);
__webpack_require__(98484);
__webpack_require__(94184);
var _typeof = __webpack_require__(8114);
var twilsock = __webpack_require__(99469);
var _assertThisInitialized = __webpack_require__(56121);
var _defineProperty = __webpack_require__(93213);
__webpack_require__(34365);
__webpack_require__(38110);
__webpack_require__(24491);
var operationRetrier = __webpack_require__(65803);
var _slicedToArray = __webpack_require__(98371);
var _toConsumableArray = __webpack_require__(40299);
__webpack_require__(86800);
__webpack_require__(24477);
var logger = __webpack_require__(33108);
var uuid = __webpack_require__(24819);
var declarativeTypeValidator = __webpack_require__(79627);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var logger__namespace = /*#__PURE__*/_interopNamespace(logger);
var uuid__namespace = /*#__PURE__*/_interopNamespace(uuid);

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default['default'](Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default['default'](Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };
    
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener){
    return this.removeListener(type, listener);
};

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

var log = logger__namespace.getLogger("twilio-notificatiions");

function prepareLine(prefix, args) {
  return ["".concat(new Date().toISOString(), " Twilio.Notifications ").concat(prefix, ":")].concat(Array.from(args));
}

var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck__default['default'](this, Logger);
  }

  _createClass__default['default'](Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      log.setLevel(level);
    }
  }, {
    key: "trace",
    value: function trace() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      log.trace.apply(null, prepareLine("T", args));
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      log.debug.apply(null, prepareLine("D", args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      log.info.apply(null, prepareLine("I", args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      log.warn.apply(null, prepareLine("W", args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      log.error.apply(null, prepareLine("E", args));
    }
  }]);

  return Logger;
}();

var logInstance = new Logger();

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RegistrationState = function RegistrationState() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var notificationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var messageTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();

  _classCallCheck__default['default'](this, RegistrationState);

  this.token = token;
  this.notificationId = notificationId;
  this.messageTypes = messageTypes;
};

function setDifference(a, b) {
  return [].concat(_toConsumableArray__default['default'](_toConsumableArray__default['default'](a).filter(function (x) {
    return !b.has(x);
  })), _toConsumableArray__default['default'](_toConsumableArray__default['default'](b).filter(function (x) {
    return !a.has(x);
  })));
}

function hasDifference(a, b) {
  var reasons = new Set();

  if (a.notificationId !== b.notificationId) {
    reasons.add("notificationId");
  }

  if (a.token !== b.token) {
    reasons.add("token");
  }

  if (setDifference(a.messageTypes, b.messageTypes).length > 0) {
    reasons.add("messageType");
  }

  return [reasons.size > 0, reasons];
}

var Connector = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](Connector, _EventEmitter);

  var _super = _createSuper$3(Connector);

  // @todo replace with FSM
  function Connector(channelType) {
    var _this;

    _classCallCheck__default['default'](this, Connector);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "desiredState", new RegistrationState());

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "currentState", new RegistrationState());

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "_hasActiveAttempt", false);

    _this.channelType = channelType;
    return _this;
  }
  /**
   * Set desired notification ID for the registration.
   * Call commitChanges() afterwards to commit this change.
   * @param notificationId Notification context ID to register.
   */


  _createClass__default['default'](Connector, [{
    key: "setNotificationId",
    value: function setNotificationId(notificationId) {
      this.desiredState.notificationId = notificationId;
    }
    /**
     * Return true is this connector is in usable state and should be able to commit changes.
     */

  }, {
    key: "isActive",
    value: function isActive() {
      return this.desiredState.notificationId !== "";
    }
  }, {
    key: "subscribe",
    value: function subscribe(messageType) {
      if (this.desiredState.messageTypes.has(messageType)) {
        logInstance.debug("message type '".concat(messageType, "' for channel ").concat(this.channelType, " is already registered"));
        return;
      }

      this.desiredState.messageTypes.add(messageType);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(messageType) {
      if (!this.desiredState.messageTypes.has(messageType)) {
        return;
      }

      this.desiredState.messageTypes.delete(messageType);
    }
  }, {
    key: "updateToken",
    value: function updateToken(token) {
      // @todo not entirely correct?
      this.desiredState.token = token;
    }
    /**
     * Perform actual registration after all required changes are settled.
     */

  }, {
    key: "commitChanges",
    value: function () {
      var _commitChanges = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
        var _hasDifference, _hasDifference2, needToUpdate, reasons, stateToPersist, persistedState;

        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._hasActiveAttempt) {
                  _context.next = 3;
                  break;
                }

                // Concurrent access violation
                logInstance.error("One registration attempt is already in progress");
                throw new Error("One registration attempt is already in progress");

              case 3:
                _hasDifference = hasDifference(this.desiredState, this.currentState), _hasDifference2 = _slicedToArray__default['default'](_hasDifference, 2), needToUpdate = _hasDifference2[0], reasons = _hasDifference2[1];

                if (needToUpdate) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                if (!this.currentState.notificationId) {
                  reasons.delete("notificationId");
                }

                logInstance.trace("Persisting ".concat(this.channelType, " registration"), reasons, this.desiredState);
                _context.prev = 8;
                this._hasActiveAttempt = true;
                stateToPersist = new RegistrationState();
                stateToPersist.token = this.desiredState.token;
                stateToPersist.notificationId = this.desiredState.notificationId;
                stateToPersist.messageTypes = new Set(this.desiredState.messageTypes);

                if (!(stateToPersist.messageTypes.size > 0)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 17;
                return this.updateRegistration(stateToPersist, reasons);

              case 17:
                persistedState = _context.sent;
                this.currentState.token = persistedState.token;
                this.currentState.notificationId = persistedState.notificationId;
                this.currentState.messageTypes = new Set(persistedState.messageTypes); // @todo twilsock emits registered(notificationContextId) when this context is reg'd

                this.emit("stateChanged", this.channelType, "registered", this.currentState);
                _context.next = 30;
                break;

              case 24:
                _context.next = 26;
                return this.removeRegistration();

              case 26:
                this.currentState.token = stateToPersist.token;
                this.currentState.notificationId = stateToPersist.notificationId;
                this.currentState.messageTypes.clear();
                this.emit("stateChanged", this.channelType, "unregistered", this.currentState);

              case 30:
                _context.next = 35;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](8);
                throw _context.t0;

              case 35:
                _context.prev = 35;
                this._hasActiveAttempt = false;
                return _context.finish(35);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 32, 35, 38]]);
      }));

      function commitChanges() {
        return _commitChanges.apply(this, arguments);
      }

      return commitChanges;
    }()
  }]);

  return Connector;
}(EventEmitter);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var retrierConfig = {
  min: 2000,
  max: 120000,
  randomness: 0.2
};
/**
 * Manages the registrations on ERS service.
 * Deduplicates registrations and manages them automatically.
 */

var RegistrarConnector = /*#__PURE__*/function (_Connector) {
  _inherits__default['default'](RegistrarConnector, _Connector);

  var _super = _createSuper$2(RegistrarConnector);

  /**
   * Creates new instance of the ERS registrar
   *
   * @param channelType {string} Channel this connector will be servicing.
   * @param context {any} productId, platform, and protocolVersion.
   * @param twilsock {TwilsockClient} connection transport.
   * @param registrarUrl {string}
   */
  function RegistrarConnector(channelType, context, // context is separate from config because it's not shared with other connectors
  twilsock, registrarUrl) {
    var _this;

    _classCallCheck__default['default'](this, RegistrarConnector);

    _this = _super.call(this, channelType);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "registrationId", null);

    _this.context = context;
    _this.twilsock = twilsock;
    _this.registrarUrl = registrarUrl;
    return _this;
  }

  _createClass__default['default'](RegistrarConnector, [{
    key: "updateRegistration",
    value: function () {
      var _updateRegistration = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee(registration, reasons) {
        var _this2 = this;

        var registrarRequest, productId, url, headers, response;
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!reasons.has("notificationId")) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.removeRegistration();

              case 3:
                if (!(!registration.notificationId || !registration.notificationId.length)) {
                  _context.next = 6;
                  break;
                }

                logInstance.error("No push notification ID for registration");
                throw new Error("No push notification ID for registration");

              case 6:
                logInstance.trace("Registering", this.channelType, registration);
                registrarRequest = {
                  endpoint_platform: this.context.platform,
                  channel_type: this.channelType,
                  version: this.context.protocolVersion.toString(),
                  message_types: Array.from(registration.messageTypes),
                  data: {
                    registration_id: registration.notificationId
                  } //ttl: 'PT24H' - This is totally ignored by notify, all bindings use PT1Y ttl.

                };
                productId = this.context.productId;
                url = "".concat(this.registrarUrl, "?productId=").concat(productId);
                headers = {
                  "Content-Type": "application/json" // 'X-Twilio-Token': registration.token

                };
                logInstance.trace("Creating registration for channel ".concat(this.channelType));
                _context.prev = 12;
                _context.next = 15;
                return new operationRetrier.AsyncRetrier(retrierConfig).run(function () {
                  return _this2.twilsock.post(url, headers, registrarRequest, productId);
                });

              case 15:
                response = _context.sent;
                this.registrationId = response.body.id;
                logInstance.debug("Registration created: ", response);
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](12);
                logInstance.error("Registration failed: ", _context.t0);
                throw _context.t0;

              case 24:
                return _context.abrupt("return", registration);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 20]]);
      }));

      function updateRegistration(_x, _x2) {
        return _updateRegistration.apply(this, arguments);
      }

      return updateRegistration;
    }()
  }, {
    key: "removeRegistration",
    value: function () {
      var _removeRegistration = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
        var _this3 = this;

        var productId, url, headers;
        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.registrationId) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                productId = this.context.productId;
                url = "".concat(this.registrarUrl, "/").concat(this.registrationId, "?productId=").concat(productId);
                headers = {
                  "Content-Type": "application/json" // 'X-Twilio-Token': this.config.token

                };
                logInstance.trace("Removing registration for ".concat(this.channelType));
                _context2.prev = 6;
                _context2.next = 9;
                return new operationRetrier.AsyncRetrier(Object.assign(retrierConfig, {
                  maxAttemptsCount: 3
                })).run(function () {
                  return _this3.twilsock.delete(url, headers, {}, productId);
                });

              case 9:
                this.registrationId = null;
                this.currentState.notificationId = "";
                logInstance.debug("Registration removed for ".concat(this.channelType));
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](6);
                logInstance.error("Failed to remove registration ", this.channelType, _context2.t0);
                throw _context2.t0;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 14]]);
      }));

      function removeRegistration() {
        return _removeRegistration.apply(this, arguments);
      }

      return removeRegistration;
    }()
  }, {
    key: "sendDeviceRemoveRequest",
    value: function () {
      var _sendDeviceRemoveRequest = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3(registrationId) {
        var _this4 = this;

        var productId, url, headers, payload;
        return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(registrationId === "")) {
                  _context3.next = 2;
                  break;
                }

                throw new Error("Empty registration ID");

              case 2:
                productId = this.context.productId;
                url = "".concat(this.registrarUrl, "?productId=").concat(productId);
                headers = {
                  "Content-Type": "application/json" // @todo Content-Length??

                };
                payload = {
                  binding_type: this.channelType,
                  address: registrationId
                };
                _context3.prev = 6;
                logInstance.trace("Removing old registrations for ".concat(this.channelType));
                _context3.next = 10;
                return new operationRetrier.AsyncRetrier(Object.assign(retrierConfig, {
                  maxAttemptsCount: 3
                })).run(function () {
                  return _this4.twilsock.delete(url, headers, payload, productId);
                });

              case 10:
                this.registrationId = null;
                this.currentState.notificationId = "";
                logInstance.debug("Registration removed for ".concat(this.channelType));
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](6);
                logInstance.error("Failed to remove registration ", this.channelType, _context3.t0);
                throw _context3.t0;

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 15]]);
      }));

      function sendDeviceRemoveRequest(_x3) {
        return _sendDeviceRemoveRequest.apply(this, arguments);
      }

      return sendDeviceRemoveRequest;
    }()
  }]);

  return RegistrarConnector;
}(Connector);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Registrar connector implementation for twilsock -- @todo Drop twilsock.connector COMPLETELY?!
 */

var TwilsockConnector = /*#__PURE__*/function (_Connector) {
  _inherits__default['default'](TwilsockConnector, _Connector);

  var _super = _createSuper$1(TwilsockConnector);

  /**
   * Create twilsock registration connector.
   * @param productId product ID
   * @param platform platform ID string
   * @param twilsock {TwilsockClient} connection transport.
   */
  function TwilsockConnector(productId, platform, twilsock) {
    var _this;

    _classCallCheck__default['default'](this, TwilsockConnector);

    _this = _super.call(this, "twilsock");

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "contextId", uuid__namespace.v4());

    _this.productId = productId;
    _this.platform = platform;
    _this.twilsock = twilsock;
    return _this;
  }

  _createClass__default['default'](TwilsockConnector, [{
    key: "updateRegistration",
    value: function () {
      var _updateRegistration = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee(registration, reasons) {
        var messageTypes, context;
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (reasons.has("messageType")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", registration);

              case 2:
                messageTypes = Array.from(registration.messageTypes);
                context = {
                  product_id: this.productId,
                  notification_protocol_version: 4,
                  endpoint_platform: this.platform,
                  message_types: messageTypes
                };
                _context.prev = 4;
                _context.next = 7;
                return this.twilsock.setNotificationsContext(this.contextId, context);

              case 7:
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);
                logInstance.error("Failed to update twilsock notification context: ".concat(_context.t0));
                throw _context.t0;

              case 13:
                return _context.abrupt("return", registration);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 9]]);
      }));

      function updateRegistration(_x, _x2) {
        return _updateRegistration.apply(this, arguments);
      }

      return updateRegistration;
    }()
  }, {
    key: "removeRegistration",
    value: function () {
      var _removeRegistration = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.twilsock.removeNotificationsContext(this.contextId);

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                logInstance.error("Failed to remove twilsock notification context: ".concat(_context2.t0));
                throw _context2.t0;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function removeRegistration() {
        return _removeRegistration.apply(this, arguments);
      }

      return removeRegistration;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "sendDeviceRemoveRequest",
    value: function () {
      var _sendDeviceRemoveRequest = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3(registrationId) {
        return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function sendDeviceRemoveRequest(_x3) {
        return _sendDeviceRemoveRequest.apply(this, arguments);
      }

      return sendDeviceRemoveRequest;
    }()
  }]);

  return TwilsockConnector;
}(Connector);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Client_1;

var channelTypeRule = declarativeTypeValidator.literal("apn", "fcm", "twilsock");
/**
 * @class
 * @alias Notifications
 * @classdesc The helper library for the notification service.
 * Provides high level api for creating and managing notification subscriptions and receiving messages
 * Creates the instance of Notification helper library
 *
 * @constructor
 * @param {string} token - Twilio access token
 * @param {Notifications#ClientOptions} options - Options to customize client behavior
 *
 * @event stateChanged channelType (registered|unregistered) -- coming from connector, i.e. it's per-connector type!
 * @event transportState Forwarded from Twilsock's stateChanged event.
 * @event message Routed from twilsock as a notification event.
 */

exports.Notifications = Client_1 = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](Client, _EventEmitter);

  var _super = _createSuper(Client);

  function Client(token) {
    var _options$logLevel, _options$productId, _options$twilsockClie, _options$notification, _ref, _config$region;

    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck__default['default'](this, Client);

    _this = _super.call(this);
    options.logLevel = (_options$logLevel = options.logLevel) !== null && _options$logLevel !== void 0 ? _options$logLevel : "error";
    logInstance.setLevel(options.logLevel);
    var productId = (_options$productId = options.productId) !== null && _options$productId !== void 0 ? _options$productId : "notifications";
    var startTwilsock = !options.twilsockClient;
    var twilsock$1 = options.twilsockClient = (_options$twilsockClie = options.twilsockClient) !== null && _options$twilsockClie !== void 0 ? _options$twilsockClie : new twilsock.TwilsockClient(token, productId, options);
    var config = (_options$notification = options.notifications) !== null && _options$notification !== void 0 ? _options$notification : {};
    var region = (_ref = (_config$region = config.region) !== null && _config$region !== void 0 ? _config$region : options.region) !== null && _ref !== void 0 ? _ref : "us1";
    var defaultUrl = "https://ers.".concat(region, ".twilio.com/v1/registrations");
    var registrarUrl = config.ersUrl || defaultUrl;
    _this.connectors = new Map();

    var platform = Client_1._detectPlatform();

    _this.connectors.set("apn", new RegistrarConnector("apn", {
      protocolVersion: 4,
      productId: productId,
      platform: platform
    }, twilsock$1, registrarUrl));

    _this.connectors.set("fcm", new RegistrarConnector("fcm", {
      protocolVersion: 3,
      productId: productId,
      platform: platform
    }, twilsock$1, registrarUrl));

    _this.connectors.set("twilsock", new TwilsockConnector(productId, platform, twilsock$1));

    twilsock$1.on("stateChanged", function (state) {
      return _this.emit("transportState", state);
    });

    _this._connector("twilsock").on("stateChanged", function (type, value, state) {
      return _this.emit("stateChanged", type, value, state);
    });

    _this._connector("apn").on("stateChanged", function (type, value, state) {
      return _this.emit("stateChanged", type, value, state);
    });

    _this._connector("fcm").on("stateChanged", function (type, value, state) {
      return _this.emit("stateChanged", type, value, state);
    }); // Router


    twilsock$1.on("message", function (type, message) {
      return _this._routeMessage(type, message);
    });

    _this.updateToken(token); // Start only if we created twilsock locally,
    // otherwise it's the responsibility of whoever created the Twilsock client.


    if (startTwilsock) {
      twilsock$1.connect();
      _this.twilsock = twilsock$1;
    }

    return _this;
  }

  _createClass__default['default'](Client, [{
    key: "shutdown",
    value: function () {
      var _shutdown = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.connectors.clear();

                if (!this.twilsock) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.twilsock.disconnect();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function shutdown() {
        return _shutdown.apply(this, arguments);
      }

      return shutdown;
    }()
    /**
     * Set OS-provided APNS/FCM registration binding for the given channel type. Not used for 'twilsock'.
     *
     * You must call this function once you've received the ID of your device from the underlying OS.
     *
     * @param {ChannelType} channelType Channel type ('apn'/'fcm').
     * @param {string} pushRegistrationId Token received from FCM/APNS system on device.
     */

  }, {
    key: "setPushRegistrationId",
    value: function setPushRegistrationId(channelType, pushRegistrationId) {
      logInstance.debug("Set ".concat(channelType, " push registration id '").concat(pushRegistrationId, "'"));

      this._connector(channelType).setNotificationId(pushRegistrationId);
    }
    /**
     * Subscribe to a given message type for a given channel type.
     *
     * Creates a subscriptions to receive incoming messages according to message type.
     * Subscription establishes a binding and you will receive a signal when a notification
     * of this type has been received by the library.
     *
     * Subscribed binding is preserved for 1 year, after which time it needs to be re-subscribed.
     * This is the responsibility of the client SDK.
     *
     * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
     * @param {string} messageType The type of message that you want to receive
     */

  }, {
    key: "subscribe",
    value: function subscribe(channelType, messageType) {
      logInstance.debug("Add ".concat(channelType, " subscriptions for message type ").concat(messageType));

      this._connector(channelType).subscribe(messageType);
    }
    /**
     * Unsubscribe from a given message type.
     *
     * Unsubscribing breaks a binding and you will not receive more notifications for this message type.
     * Please note that you have to call commitChanges() and receive a successful result before
     * the subscription is actually removed.
     *
     * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
     * @param {string} messageType The type of message that you don't want to receive anymore
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(channelType, messageType) {
      logInstance.debug("Remove ".concat(channelType, " subscriptions for message type ").concat(messageType));

      this._connector(channelType).unsubscribe(messageType);
    }
    /**
     * Update subscription token. You must update the token when the old one expires.
     *
     * When you receive onTokenWillExpire event from twilsock, call this function with the new refreshed
     * token _after_ you have updated twilsock and other associated objects with the new token.
     *
     * @param {string} token Authentication token for registrations
     */

  }, {
    key: "updateToken",
    value: function updateToken(token) {
      this.connectors.forEach(function (connector) {
        return connector.updateToken(token);
      });
    }
    /**
     * Commit all collected subscription changes as a batched update. This function tries to reduce
     * number of network calls necessary to update bindings status.
     */

  }, {
    key: "commitChanges",
    value: function () {
      var _commitChanges = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
        var promises;
        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                promises = [];
                this.connectors.forEach(function (connector) {
                  if (connector.isActive()) {
                    promises.push(connector.commitChanges());
                  }
                });
                _context2.next = 4;
                return Promise.all(promises);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function commitChanges() {
        return _commitChanges.apply(this, arguments);
      }

      return commitChanges;
    }()
    /**
     * Clear existing registrations directly using provided device token.
     * This is useful to ensure stopped subscriptions without resubscribing.
     *
     * This function goes completely beside the state machine and removes all registrations.
     * Use with caution: if it races with current state machine operations, madness will ensue.
     *
     * @param {ChannelType} channelType Channel type ('apn'/'fcm').
     * @param {string} registrationId Token received from FCM/APNS system on device.
     */

  }, {
    key: "removeRegistrations",
    value: function () {
      var _removeRegistrations = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3(channelType, registrationId) {
        return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._connector(channelType).sendDeviceRemoveRequest(registrationId);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeRegistrations(_x, _x2) {
        return _removeRegistrations.apply(this, arguments);
      }

      return removeRegistrations;
    }()
    /**
     * Handle incoming push notification.
     * Client application should call this method when it receives push notifications and pass the received data.
     * @param {Object} message push message
     * @return {PushNotification} A reformatted payload with extracted message type.
     */

  }, {
    key: "handlePushNotification",
    value: function handlePushNotification(message) {
      return {
        messageType: message.twi_message_type,
        payload: message.payload
      };
    }
    /**
     * Routes messages to the external subscribers
     */

  }, {
    key: "_routeMessage",
    value: function _routeMessage(type, message) {
      logInstance.debug("Notification message arrived: ", type, message);
      this.emit("message", type, message);
    }
    /**
     * @param {String} type Channel type
     * @throws {Error} Error with description
     */

  }, {
    key: "_connector",
    value: function _connector(type) {
      var connector = this.connectors.get(type);

      if (!connector) {
        throw new Error("Unknown channel type: ".concat(type));
      }

      return connector;
    }
    /**
     * Returns platform string limited to max 128 chars
     */

  }], [{
    key: "_detectPlatform",
    value: function _detectPlatform() {
      var platform = "";

      if (typeof navigator !== "undefined") {
        platform = "unknown";

        if (typeof navigator.product !== "undefined") {
          platform = navigator.product;
        }

        if (typeof navigator.userAgent !== "undefined") {
          platform = navigator.userAgent;
        }
      } else {
        platform = "web";
      }

      return platform.substring(0, 128);
    }
  }]);

  return Client;
}(EventEmitter);

__decorate([declarativeTypeValidator.validateTypes(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "setPushRegistrationId", null);

__decorate([declarativeTypeValidator.validateTypes(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "subscribe", null);

__decorate([declarativeTypeValidator.validateTypes(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "unsubscribe", null);

__decorate([declarativeTypeValidator.validateTypes(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], exports.Notifications.prototype, "updateToken", null);

__decorate([declarativeTypeValidator.validateTypesAsync(channelTypeRule, declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", Promise)], exports.Notifications.prototype, "removeRegistrations", null);

exports.Notifications = Client_1 = __decorate([declarativeTypeValidator.validateConstructorTypes(declarativeTypeValidator.nonEmptyString, [declarativeTypeValidator.pureObject, "undefined", declarativeTypeValidator.literal(null)]), __metadata("design:paramtypes", [String, Object])], exports.Notifications);
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 65803:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2016, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(14334);
__webpack_require__(80437);
var _classCallCheck = __webpack_require__(62638);
var _createClass = __webpack_require__(1023);
var _assertThisInitialized = __webpack_require__(56121);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
var _defineProperty = __webpack_require__(93213);
__webpack_require__(29978);
__webpack_require__(94184);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };
    
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener){
    return this.removeListener(type, listener);
};

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Provides retrier service
 */

var Retrier = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default["default"](Retrier, _EventEmitter);

  var _super = _createSuper$1(Retrier);

  // fibonacci strategy

  /**
   * Creates a new Retrier instance
   */
  function Retrier(options) {
    var _this;

    _classCallCheck__default["default"](this, Retrier);

    _this = _super.call(this);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "timeout", null);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "startTimestamp", -1);

    _this.minDelay = options.min;
    _this.maxDelay = options.max;
    _this.initialDelay = options.initial || 0;
    _this.maxAttemptsCount = options.maxAttemptsCount || 0;
    _this.maxAttemptsTime = options.maxAttemptsTime || 0;
    _this.randomness = options.randomness || 0;
    _this.inProgress = false;
    _this.attemptNum = 0;
    _this.prevDelay = 0;
    _this.currDelay = 0;
    return _this;
  }

  _createClass__default["default"](Retrier, [{
    key: "attempt",
    value: function attempt() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.attemptNum++;
      this.emit("attempt", this);
    }
  }, {
    key: "nextDelay",
    value: function nextDelay(delayOverride) {
      if (typeof delayOverride === "number") {
        this.prevDelay = 0;
        this.currDelay = delayOverride;
        return delayOverride;
      }

      if (this.attemptNum == 0) {
        return this.initialDelay;
      }

      if (this.attemptNum == 1) {
        this.currDelay = this.minDelay;
        return this.currDelay;
      }

      this.prevDelay = this.currDelay;
      var delay = this.currDelay + this.prevDelay;

      if (this.maxDelay && delay > this.maxDelay) {
        this.currDelay = this.maxDelay;
        delay = this.maxDelay;
      }

      this.currDelay = delay;
      return delay;
    }
  }, {
    key: "randomize",
    value: function randomize(delay) {
      var area = delay * this.randomness;
      var corr = Math.round(Math.random() * area * 2 - area);
      return Math.max(0, delay + corr);
    }
  }, {
    key: "scheduleAttempt",
    value: function scheduleAttempt(delayOverride) {
      var _this2 = this;

      if (this.maxAttemptsCount && this.attemptNum >= this.maxAttemptsCount) {
        this.cleanup();
        this.emit("failed", new Error("Maximum attempt count limit reached"));
        return;
      }

      var delay = this.nextDelay(delayOverride);
      delay = this.randomize(delay);

      if (this.maxAttemptsTime && this.startTimestamp + this.maxAttemptsTime < Date.now() + delay) {
        this.cleanup();
        this.emit("failed", new Error("Maximum attempt time limit reached"));
        return;
      }

      this.timeout = setTimeout(function () {
        return _this2.attempt();
      }, delay);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.inProgress = false;
      this.attemptNum = 0;
      this.prevDelay = 0;
      this.currDelay = 0;
    }
  }, {
    key: "start",
    value: function start() {
      if (this.inProgress) {
        throw new Error("Retrier is already in progress");
      }

      this.inProgress = true;
      this.startTimestamp = Date.now();
      this.scheduleAttempt(this.initialDelay);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.inProgress = false;
        this.emit("cancelled");
      }
    } // @todo Must be a T here, so the entire Retrier must be typed on this value type.
    // eslint-disable-next-line

  }, {
    key: "succeeded",
    value: function succeeded(arg) {
      this.emit("succeeded", arg);
    }
  }, {
    key: "failed",
    value: function failed(err, nextAttemptDelayOverride) {
      if (this.timeout) {
        throw new Error("Retrier attempt is already in progress");
      }

      this.scheduleAttempt(nextAttemptDelayOverride);
    }
  }]);

  return Retrier;
}(EventEmitter);
/**
 * Run retrier as an async function with possibility to await for it.
 * Example:
 * ```
 * const result = AsyncRetrier.run(async () => somePromise);
 * ```
 */


var AsyncRetrier = /*#__PURE__*/function (_EventEmitter2) {
  _inherits__default["default"](AsyncRetrier, _EventEmitter2);

  var _super2 = _createSuper$1(AsyncRetrier);

  // This any must be T typed directly on the AsyncRetrier
  // eslint-disable-next-line
  function AsyncRetrier(options) {
    var _this3;

    _classCallCheck__default["default"](this, AsyncRetrier);

    _this3 = _super2.call(this);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this3), "resolve", function () {
      return void 0;
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this3), "reject", function () {
      return void 0;
    });

    _this3.retrier = new Retrier(options);
    return _this3;
  }

  _createClass__default["default"](AsyncRetrier, [{
    key: "run",
    value: function run(handler) {
      var _this4 = this;

      this.retrier.on("attempt", function () {
        handler().then(function (v) {
          return _this4.retrier.succeeded(v);
        }).catch(function (e) {
          return _this4.retrier.failed(e);
        });
      });
      this.retrier.on("succeeded", function (arg) {
        return _this4.resolve(arg);
      });
      this.retrier.on("cancelled", function () {
        return _this4.reject(new Error("Cancelled"));
      });
      this.retrier.on("failed", function (err) {
        return _this4.reject(err);
      });
      return new Promise(function (resolve, reject) {
        _this4.resolve = resolve;
        _this4.reject = reject;

        _this4.retrier.start();
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.retrier.cancel();
    }
  }]);

  return AsyncRetrier;
}(EventEmitter);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function isDef(value) {
  return value !== undefined && value !== null;
}

var Backoff = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default["default"](Backoff, _EventEmitter);

  var _super = _createSuper(Backoff);

  function Backoff(options) {
    var _this;

    _classCallCheck__default["default"](this, Backoff);

    _this = _super.call(this);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "backoffDelay", 0);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "nextBackoffDelay", 0);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "backoffNumber", 0);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "timeoutID", null);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "maxNumberOfRetry", -1);

    options = options || {};
    var _options = options,
        initialDelay = _options.initialDelay,
        maxDelay = _options.maxDelay,
        randomisationFactor = _options.randomisationFactor,
        factor = _options.factor;

    if (isDef(initialDelay) && initialDelay < 1) {
      throw new Error("The initial timeout must be equal to or greater than 1.");
    }

    if (isDef(maxDelay) && maxDelay <= 1) {
      throw new Error("The maximal timeout must be greater than 1.");
    }

    if (isDef(randomisationFactor) && (randomisationFactor < 0 || randomisationFactor > 1)) {
      throw new Error("The randomisation factor must be between 0 and 1.");
    }

    if (isDef(factor) && factor <= 1) {
      throw new Error("Exponential factor should be greater than 1.");
    }

    _this.initialDelay = initialDelay || 100;
    _this.maxDelay = maxDelay || 10000;

    if (_this.maxDelay <= _this.initialDelay) {
      throw new Error("The maximal backoff delay must be greater than the initial backoff delay.");
    }

    _this.randomisationFactor = randomisationFactor || 0;
    _this.factor = factor || 2;

    _this.reset();

    return _this;
  }

  _createClass__default["default"](Backoff, [{
    key: "backoff",
    value: function backoff(err) {
      if (this.timeoutID == null) {
        if (this.backoffNumber === this.maxNumberOfRetry) {
          this.emit("fail", err);
          this.reset();
        } else {
          this.backoffDelay = this.next();
          this.timeoutID = setTimeout(this.onBackoff.bind(this), this.backoffDelay);
          this.emit("backoff", this.backoffNumber, this.backoffDelay, err);
        }
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.backoffDelay = 0;
      this.nextBackoffDelay = this.initialDelay;
      this.backoffNumber = 0;

      if (this.timeoutID) {
        clearTimeout(this.timeoutID);
      }

      this.timeoutID = null;
    }
  }, {
    key: "failAfter",
    value: function failAfter(maxNumberOfRetry) {
      if (maxNumberOfRetry <= 0) {
        throw new Error("Expected a maximum number of retry greater than 0 but got ".concat(maxNumberOfRetry));
      }

      this.maxNumberOfRetry = maxNumberOfRetry;
    }
  }, {
    key: "next",
    value: function next() {
      this.backoffDelay = Math.min(this.nextBackoffDelay, this.maxDelay);
      this.nextBackoffDelay = this.backoffDelay * this.factor;
      var randomisationMultiple = 1 + Math.random() * this.randomisationFactor;
      return Math.min(this.maxDelay, Math.round(this.backoffDelay * randomisationMultiple));
    }
  }, {
    key: "onBackoff",
    value: function onBackoff() {
      this.timeoutID = null;
      this.emit("ready", this.backoffNumber, this.backoffDelay);
      this.backoffNumber++;
    }
  }], [{
    key: "exponential",
    value: function exponential(options) {
      return new Backoff(options);
    }
  }]);

  return Backoff;
}(EventEmitter);

exports.AsyncRetrier = AsyncRetrier;
exports.Backoff = Backoff;
exports.Retrier = Retrier;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 4999:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

var _toConsumableArray = __webpack_require__(40299);
var _classCallCheck = __webpack_require__(62638);
var _createClass = __webpack_require__(1023);
var _assertThisInitialized = __webpack_require__(56121);
var _get = __webpack_require__(26480);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
var _defineProperty = __webpack_require__(93213);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };
    
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener){
    return this.removeListener(type, listener);
};

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ReplayEventEmitter = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default["default"](ReplayEventEmitter, _EventEmitter);

  var _super = _createSuper(ReplayEventEmitter);

  function ReplayEventEmitter() {
    var _this;

    _classCallCheck__default["default"](this, ReplayEventEmitter);

    _this = _super.call(this);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "eventHistory", new Map());

    return _this;
  }

  _createClass__default["default"](ReplayEventEmitter, [{
    key: "on",
    value: function on(event, listener) {
      return _get__default["default"](_getPrototypeOf__default["default"](ReplayEventEmitter.prototype), "on", this).call(this, event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      return _get__default["default"](_getPrototypeOf__default["default"](ReplayEventEmitter.prototype), "once", this).call(this, event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      return _get__default["default"](_getPrototypeOf__default["default"](ReplayEventEmitter.prototype), "off", this).call(this, event, listener);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this.eventHistory.set(event, args);
      return (_get2 = _get__default["default"](_getPrototypeOf__default["default"](ReplayEventEmitter.prototype), "emit", this)).call.apply(_get2, [this, event].concat(args));
    }
  }, {
    key: "addListener",
    value: function addListener(event, listener) {
      return _get__default["default"](_getPrototypeOf__default["default"](ReplayEventEmitter.prototype), "addListener", this).call(this, event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      return _get__default["default"](_getPrototypeOf__default["default"](ReplayEventEmitter.prototype), "removeListener", this).call(this, event, listener);
    }
  }, {
    key: "addListenerWithReplay",
    value: function addListenerWithReplay(event, listener) {
      var historyEntry = this.eventHistory.get(event);

      if (historyEntry !== undefined) {
        listener.apply(void 0, _toConsumableArray__default["default"](historyEntry));
      }

      return this.addListener(event, listener);
    }
  }, {
    key: "onWithReplay",
    value: function onWithReplay(event, listener) {
      return this.addListenerWithReplay(event, listener);
    }
  }, {
    key: "onceWithReplay",
    value: function onceWithReplay(event, listener) {
      var historyEntry = this.eventHistory.get(event);

      if (historyEntry !== undefined) {
        listener.apply(void 0, _toConsumableArray__default["default"](historyEntry));
        return this;
      }

      return _get__default["default"](_getPrototypeOf__default["default"](ReplayEventEmitter.prototype), "once", this).call(this, event, listener);
    }
  }]);

  return ReplayEventEmitter;
}(EventEmitter);

exports.ReplayEventEmitter = ReplayEventEmitter;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 72256:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var properties = [['aria-activedescendant', {
  'type': 'id'
}], ['aria-atomic', {
  'type': 'boolean'
}], ['aria-autocomplete', {
  'type': 'token',
  'values': ['inline', 'list', 'both', 'none']
}], ['aria-busy', {
  'type': 'boolean'
}], ['aria-checked', {
  'type': 'tristate'
}], ['aria-colcount', {
  type: 'integer'
}], ['aria-colindex', {
  type: 'integer'
}], ['aria-colspan', {
  type: 'integer'
}], ['aria-controls', {
  'type': 'idlist'
}], ['aria-current', {
  type: 'token',
  values: ['page', 'step', 'location', 'date', 'time', true, false]
}], ['aria-describedby', {
  'type': 'idlist'
}], ['aria-details', {
  'type': 'id'
}], ['aria-disabled', {
  'type': 'boolean'
}], ['aria-dropeffect', {
  'type': 'tokenlist',
  'values': ['copy', 'execute', 'link', 'move', 'none', 'popup']
}], ['aria-errormessage', {
  'type': 'id'
}], ['aria-expanded', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-flowto', {
  'type': 'idlist'
}], ['aria-grabbed', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-haspopup', {
  'type': 'token',
  'values': [false, true, 'menu', 'listbox', 'tree', 'grid', 'dialog']
}], ['aria-hidden', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-invalid', {
  'type': 'token',
  'values': ['grammar', false, 'spelling', true]
}], ['aria-keyshortcuts', {
  type: 'string'
}], ['aria-label', {
  'type': 'string'
}], ['aria-labelledby', {
  'type': 'idlist'
}], ['aria-level', {
  'type': 'integer'
}], ['aria-live', {
  'type': 'token',
  'values': ['assertive', 'off', 'polite']
}], ['aria-modal', {
  type: 'boolean'
}], ['aria-multiline', {
  'type': 'boolean'
}], ['aria-multiselectable', {
  'type': 'boolean'
}], ['aria-orientation', {
  'type': 'token',
  'values': ['vertical', 'undefined', 'horizontal']
}], ['aria-owns', {
  'type': 'idlist'
}], ['aria-placeholder', {
  type: 'string'
}], ['aria-posinset', {
  'type': 'integer'
}], ['aria-pressed', {
  'type': 'tristate'
}], ['aria-readonly', {
  'type': 'boolean'
}], ['aria-relevant', {
  'type': 'tokenlist',
  'values': ['additions', 'all', 'removals', 'text']
}], ['aria-required', {
  'type': 'boolean'
}], ['aria-roledescription', {
  type: 'string'
}], ['aria-rowcount', {
  type: 'integer'
}], ['aria-rowindex', {
  type: 'integer'
}], ['aria-rowspan', {
  type: 'integer'
}], ['aria-selected', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-setsize', {
  'type': 'integer'
}], ['aria-sort', {
  'type': 'token',
  'values': ['ascending', 'descending', 'none', 'other']
}], ['aria-valuemax', {
  'type': 'number'
}], ['aria-valuemin', {
  'type': 'number'
}], ['aria-valuenow', {
  'type': 'number'
}], ['aria-valuetext', {
  'type': 'string'
}]];
var ariaPropsMap = {
  entries: function entries() {
    return properties;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(properties),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, key, properties);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = properties.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!ariaPropsMap.get(key);
  },
  keys: function keys() {
    return properties.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return properties.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(ariaPropsMap, ariaPropsMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 92607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var dom = [['a', {
  reserved: false
}], ['abbr', {
  reserved: false
}], ['acronym', {
  reserved: false
}], ['address', {
  reserved: false
}], ['applet', {
  reserved: false
}], ['area', {
  reserved: false
}], ['article', {
  reserved: false
}], ['aside', {
  reserved: false
}], ['audio', {
  reserved: false
}], ['b', {
  reserved: false
}], ['base', {
  reserved: true
}], ['bdi', {
  reserved: false
}], ['bdo', {
  reserved: false
}], ['big', {
  reserved: false
}], ['blink', {
  reserved: false
}], ['blockquote', {
  reserved: false
}], ['body', {
  reserved: false
}], ['br', {
  reserved: false
}], ['button', {
  reserved: false
}], ['canvas', {
  reserved: false
}], ['caption', {
  reserved: false
}], ['center', {
  reserved: false
}], ['cite', {
  reserved: false
}], ['code', {
  reserved: false
}], ['col', {
  reserved: true
}], ['colgroup', {
  reserved: true
}], ['content', {
  reserved: false
}], ['data', {
  reserved: false
}], ['datalist', {
  reserved: false
}], ['dd', {
  reserved: false
}], ['del', {
  reserved: false
}], ['details', {
  reserved: false
}], ['dfn', {
  reserved: false
}], ['dialog', {
  reserved: false
}], ['dir', {
  reserved: false
}], ['div', {
  reserved: false
}], ['dl', {
  reserved: false
}], ['dt', {
  reserved: false
}], ['em', {
  reserved: false
}], ['embed', {
  reserved: false
}], ['fieldset', {
  reserved: false
}], ['figcaption', {
  reserved: false
}], ['figure', {
  reserved: false
}], ['font', {
  reserved: false
}], ['footer', {
  reserved: false
}], ['form', {
  reserved: false
}], ['frame', {
  reserved: false
}], ['frameset', {
  reserved: false
}], ['h1', {
  reserved: false
}], ['h2', {
  reserved: false
}], ['h3', {
  reserved: false
}], ['h4', {
  reserved: false
}], ['h5', {
  reserved: false
}], ['h6', {
  reserved: false
}], ['head', {
  reserved: true
}], ['header', {
  reserved: false
}], ['hgroup', {
  reserved: false
}], ['hr', {
  reserved: false
}], ['html', {
  reserved: true
}], ['i', {
  reserved: false
}], ['iframe', {
  reserved: false
}], ['img', {
  reserved: false
}], ['input', {
  reserved: false
}], ['ins', {
  reserved: false
}], ['kbd', {
  reserved: false
}], ['keygen', {
  reserved: false
}], ['label', {
  reserved: false
}], ['legend', {
  reserved: false
}], ['li', {
  reserved: false
}], ['link', {
  reserved: true
}], ['main', {
  reserved: false
}], ['map', {
  reserved: false
}], ['mark', {
  reserved: false
}], ['marquee', {
  reserved: false
}], ['menu', {
  reserved: false
}], ['menuitem', {
  reserved: false
}], ['meta', {
  reserved: true
}], ['meter', {
  reserved: false
}], ['nav', {
  reserved: false
}], ['noembed', {
  reserved: true
}], ['noscript', {
  reserved: true
}], ['object', {
  reserved: false
}], ['ol', {
  reserved: false
}], ['optgroup', {
  reserved: false
}], ['option', {
  reserved: false
}], ['output', {
  reserved: false
}], ['p', {
  reserved: false
}], ['param', {
  reserved: true
}], ['picture', {
  reserved: true
}], ['pre', {
  reserved: false
}], ['progress', {
  reserved: false
}], ['q', {
  reserved: false
}], ['rp', {
  reserved: false
}], ['rt', {
  reserved: false
}], ['rtc', {
  reserved: false
}], ['ruby', {
  reserved: false
}], ['s', {
  reserved: false
}], ['samp', {
  reserved: false
}], ['script', {
  reserved: true
}], ['section', {
  reserved: false
}], ['select', {
  reserved: false
}], ['small', {
  reserved: false
}], ['source', {
  reserved: true
}], ['spacer', {
  reserved: false
}], ['span', {
  reserved: false
}], ['strike', {
  reserved: false
}], ['strong', {
  reserved: false
}], ['style', {
  reserved: true
}], ['sub', {
  reserved: false
}], ['summary', {
  reserved: false
}], ['sup', {
  reserved: false
}], ['table', {
  reserved: false
}], ['tbody', {
  reserved: false
}], ['td', {
  reserved: false
}], ['textarea', {
  reserved: false
}], ['tfoot', {
  reserved: false
}], ['th', {
  reserved: false
}], ['thead', {
  reserved: false
}], ['time', {
  reserved: false
}], ['title', {
  reserved: true
}], ['tr', {
  reserved: false
}], ['track', {
  reserved: true
}], ['tt', {
  reserved: false
}], ['u', {
  reserved: false
}], ['ul', {
  reserved: false
}], ['var', {
  reserved: false
}], ['video', {
  reserved: false
}], ['wbr', {
  reserved: false
}], ['xmp', {
  reserved: false
}]];
var domMap = {
  entries: function entries() {
    return dom;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(dom),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, key, dom);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = dom.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!domMap.get(key);
  },
  keys: function keys() {
    return dom.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return dom.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(domMap, domMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 74490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _deepEqual = _interopRequireDefault(__webpack_require__(4562));
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
var _rolesMap = _interopRequireDefault(__webpack_require__(29312));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var elementRoles = [];
var keys = _rolesMap.default.keys();
for (var i = 0; i < keys.length; i++) {
  var key = keys[i];
  var role = _rolesMap.default.get(key);
  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
    for (var k = 0; k < concepts.length; k++) {
      var relation = concepts[k];
      if (relation.module === 'HTML') {
        var concept = relation.concept;
        if (concept) {
          (function () {
            var conceptStr = JSON.stringify(concept);
            var elementRoleRelation = elementRoles.find(function (relation) {
              return JSON.stringify(relation[0]) === conceptStr;
            });
            var roles = void 0;
            if (elementRoleRelation) {
              roles = elementRoleRelation[1];
            } else {
              roles = [];
            }
            var isUnique = true;
            for (var _i = 0; _i < roles.length; _i++) {
              if (roles[_i] === key) {
                isUnique = false;
                break;
              }
            }
            if (isUnique) {
              roles.push(key);
            }
            elementRoles.push([concept, roles]);
          })();
        }
      }
    }
  }
}
var elementRoleMap = {
  entries: function entries() {
    return elementRoles;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(elementRoles),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          _key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, _key, elementRoles);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = elementRoles.find(function (tuple) {
      return (0, _deepEqual.default)(key, tuple[0]);
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!elementRoleMap.get(key);
  },
  keys: function keys() {
    return elementRoles.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return elementRoles.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(elementRoleMap, elementRoleMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 69742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var commandRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = commandRole;
exports["default"] = _default;

/***/ }),

/***/ 7938:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var compositeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = compositeRole;
exports["default"] = _default;

/***/ }),

/***/ 46214:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var inputRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null
  },
  relatedConcepts: [{
    concept: {
      name: 'input'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = inputRole;
exports["default"] = _default;

/***/ }),

/***/ 10134:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var landmarkRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = landmarkRole;
exports["default"] = _default;

/***/ }),

/***/ 18950:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rangeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuemax': null,
    'aria-valuemin': null,
    'aria-valuenow': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = rangeRole;
exports["default"] = _default;

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var roletypeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {
    'aria-atomic': null,
    'aria-busy': null,
    'aria-controls': null,
    'aria-current': null,
    'aria-describedby': null,
    'aria-details': null,
    'aria-dropeffect': null,
    'aria-flowto': null,
    'aria-grabbed': null,
    'aria-hidden': null,
    'aria-keyshortcuts': null,
    'aria-label': null,
    'aria-labelledby': null,
    'aria-live': null,
    'aria-owns': null,
    'aria-relevant': null,
    'aria-roledescription': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rel'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'role'
    },
    module: 'XHTML'
  }, {
    concept: {
      name: 'type'
    },
    module: 'Dublin Core'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default = roletypeRole;
exports["default"] = _default;

/***/ }),

/***/ 65067:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sectionRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'frontmatter'
    },
    module: 'DTB'
  }, {
    concept: {
      name: 'level'
    },
    module: 'DTB'
  }, {
    concept: {
      name: 'level'
    },
    module: 'SMIL'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = sectionRole;
exports["default"] = _default;

/***/ }),

/***/ 50233:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sectionheadRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = sectionheadRole;
exports["default"] = _default;

/***/ }),

/***/ 27426:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var selectRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'group']]
};
var _default = selectRole;
exports["default"] = _default;

/***/ }),

/***/ 12781:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var structureRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = structureRole;
exports["default"] = _default;

/***/ }),

/***/ 20182:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var widgetRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = widgetRole;
exports["default"] = _default;

/***/ }),

/***/ 59943:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var windowRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-modal': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = windowRole;
exports["default"] = _default;

/***/ }),

/***/ 14690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _commandRole = _interopRequireDefault(__webpack_require__(69742));
var _compositeRole = _interopRequireDefault(__webpack_require__(7938));
var _inputRole = _interopRequireDefault(__webpack_require__(46214));
var _landmarkRole = _interopRequireDefault(__webpack_require__(10134));
var _rangeRole = _interopRequireDefault(__webpack_require__(18950));
var _roletypeRole = _interopRequireDefault(__webpack_require__(65966));
var _sectionRole = _interopRequireDefault(__webpack_require__(65067));
var _sectionheadRole = _interopRequireDefault(__webpack_require__(50233));
var _selectRole = _interopRequireDefault(__webpack_require__(27426));
var _structureRole = _interopRequireDefault(__webpack_require__(12781));
var _widgetRole = _interopRequireDefault(__webpack_require__(20182));
var _windowRole = _interopRequireDefault(__webpack_require__(59943));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaAbstractRoles = [['command', _commandRole.default], ['composite', _compositeRole.default], ['input', _inputRole.default], ['landmark', _landmarkRole.default], ['range', _rangeRole.default], ['roletype', _roletypeRole.default], ['section', _sectionRole.default], ['sectionhead', _sectionheadRole.default], ['select', _selectRole.default], ['structure', _structureRole.default], ['widget', _widgetRole.default], ['window', _windowRole.default]];
var _default = ariaAbstractRoles;
exports["default"] = _default;

/***/ }),

/***/ 61413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _docAbstractRole = _interopRequireDefault(__webpack_require__(18868));
var _docAcknowledgmentsRole = _interopRequireDefault(__webpack_require__(79710));
var _docAfterwordRole = _interopRequireDefault(__webpack_require__(77958));
var _docAppendixRole = _interopRequireDefault(__webpack_require__(99074));
var _docBacklinkRole = _interopRequireDefault(__webpack_require__(23961));
var _docBiblioentryRole = _interopRequireDefault(__webpack_require__(68917));
var _docBibliographyRole = _interopRequireDefault(__webpack_require__(20555));
var _docBibliorefRole = _interopRequireDefault(__webpack_require__(85081));
var _docChapterRole = _interopRequireDefault(__webpack_require__(38935));
var _docColophonRole = _interopRequireDefault(__webpack_require__(53076));
var _docConclusionRole = _interopRequireDefault(__webpack_require__(46406));
var _docCoverRole = _interopRequireDefault(__webpack_require__(44613));
var _docCreditRole = _interopRequireDefault(__webpack_require__(2060));
var _docCreditsRole = _interopRequireDefault(__webpack_require__(79176));
var _docDedicationRole = _interopRequireDefault(__webpack_require__(97684));
var _docEndnoteRole = _interopRequireDefault(__webpack_require__(75835));
var _docEndnotesRole = _interopRequireDefault(__webpack_require__(4656));
var _docEpigraphRole = _interopRequireDefault(__webpack_require__(34767));
var _docEpilogueRole = _interopRequireDefault(__webpack_require__(34726));
var _docErrataRole = _interopRequireDefault(__webpack_require__(363));
var _docExampleRole = _interopRequireDefault(__webpack_require__(25742));
var _docFootnoteRole = _interopRequireDefault(__webpack_require__(37863));
var _docForewordRole = _interopRequireDefault(__webpack_require__(89953));
var _docGlossaryRole = _interopRequireDefault(__webpack_require__(29209));
var _docGlossrefRole = _interopRequireDefault(__webpack_require__(43145));
var _docIndexRole = _interopRequireDefault(__webpack_require__(7945));
var _docIntroductionRole = _interopRequireDefault(__webpack_require__(60022));
var _docNoterefRole = _interopRequireDefault(__webpack_require__(21913));
var _docNoticeRole = _interopRequireDefault(__webpack_require__(76648));
var _docPagebreakRole = _interopRequireDefault(__webpack_require__(13551));
var _docPagelistRole = _interopRequireDefault(__webpack_require__(87789));
var _docPartRole = _interopRequireDefault(__webpack_require__(85367));
var _docPrefaceRole = _interopRequireDefault(__webpack_require__(90938));
var _docPrologueRole = _interopRequireDefault(__webpack_require__(59955));
var _docPullquoteRole = _interopRequireDefault(__webpack_require__(99992));
var _docQnaRole = _interopRequireDefault(__webpack_require__(64565));
var _docSubtitleRole = _interopRequireDefault(__webpack_require__(23465));
var _docTipRole = _interopRequireDefault(__webpack_require__(37207));
var _docTocRole = _interopRequireDefault(__webpack_require__(33719));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaDpubRoles = [['doc-abstract', _docAbstractRole.default], ['doc-acknowledgments', _docAcknowledgmentsRole.default], ['doc-afterword', _docAfterwordRole.default], ['doc-appendix', _docAppendixRole.default], ['doc-backlink', _docBacklinkRole.default], ['doc-biblioentry', _docBiblioentryRole.default], ['doc-bibliography', _docBibliographyRole.default], ['doc-biblioref', _docBibliorefRole.default], ['doc-chapter', _docChapterRole.default], ['doc-colophon', _docColophonRole.default], ['doc-conclusion', _docConclusionRole.default], ['doc-cover', _docCoverRole.default], ['doc-credit', _docCreditRole.default], ['doc-credits', _docCreditsRole.default], ['doc-dedication', _docDedicationRole.default], ['doc-endnote', _docEndnoteRole.default], ['doc-endnotes', _docEndnotesRole.default], ['doc-epigraph', _docEpigraphRole.default], ['doc-epilogue', _docEpilogueRole.default], ['doc-errata', _docErrataRole.default], ['doc-example', _docExampleRole.default], ['doc-footnote', _docFootnoteRole.default], ['doc-foreword', _docForewordRole.default], ['doc-glossary', _docGlossaryRole.default], ['doc-glossref', _docGlossrefRole.default], ['doc-index', _docIndexRole.default], ['doc-introduction', _docIntroductionRole.default], ['doc-noteref', _docNoterefRole.default], ['doc-notice', _docNoticeRole.default], ['doc-pagebreak', _docPagebreakRole.default], ['doc-pagelist', _docPagelistRole.default], ['doc-part', _docPartRole.default], ['doc-preface', _docPrefaceRole.default], ['doc-prologue', _docPrologueRole.default], ['doc-pullquote', _docPullquoteRole.default], ['doc-qna', _docQnaRole.default], ['doc-subtitle', _docSubtitleRole.default], ['doc-tip', _docTipRole.default], ['doc-toc', _docTocRole.default]];
var _default = ariaDpubRoles;
exports["default"] = _default;

/***/ }),

/***/ 20915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _graphicsDocumentRole = _interopRequireDefault(__webpack_require__(75805));
var _graphicsObjectRole = _interopRequireDefault(__webpack_require__(46205));
var _graphicsSymbolRole = _interopRequireDefault(__webpack_require__(8855));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaGraphicsRoles = [['graphics-document', _graphicsDocumentRole.default], ['graphics-object', _graphicsObjectRole.default], ['graphics-symbol', _graphicsSymbolRole.default]];
var _default = ariaGraphicsRoles;
exports["default"] = _default;

/***/ }),

/***/ 58514:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _alertRole = _interopRequireDefault(__webpack_require__(66472));
var _alertdialogRole = _interopRequireDefault(__webpack_require__(84976));
var _applicationRole = _interopRequireDefault(__webpack_require__(35902));
var _articleRole = _interopRequireDefault(__webpack_require__(36883));
var _bannerRole = _interopRequireDefault(__webpack_require__(25599));
var _blockquoteRole = _interopRequireDefault(__webpack_require__(91621));
var _buttonRole = _interopRequireDefault(__webpack_require__(50855));
var _captionRole = _interopRequireDefault(__webpack_require__(31760));
var _cellRole = _interopRequireDefault(__webpack_require__(73350));
var _checkboxRole = _interopRequireDefault(__webpack_require__(58651));
var _codeRole = _interopRequireDefault(__webpack_require__(87305));
var _columnheaderRole = _interopRequireDefault(__webpack_require__(53486));
var _comboboxRole = _interopRequireDefault(__webpack_require__(81663));
var _complementaryRole = _interopRequireDefault(__webpack_require__(98889));
var _contentinfoRole = _interopRequireDefault(__webpack_require__(94961));
var _definitionRole = _interopRequireDefault(__webpack_require__(4676));
var _deletionRole = _interopRequireDefault(__webpack_require__(48978));
var _dialogRole = _interopRequireDefault(__webpack_require__(94154));
var _directoryRole = _interopRequireDefault(__webpack_require__(95707));
var _documentRole = _interopRequireDefault(__webpack_require__(53212));
var _emphasisRole = _interopRequireDefault(__webpack_require__(55530));
var _feedRole = _interopRequireDefault(__webpack_require__(43478));
var _figureRole = _interopRequireDefault(__webpack_require__(12728));
var _formRole = _interopRequireDefault(__webpack_require__(77841));
var _genericRole = _interopRequireDefault(__webpack_require__(56322));
var _gridRole = _interopRequireDefault(__webpack_require__(10417));
var _gridcellRole = _interopRequireDefault(__webpack_require__(49947));
var _groupRole = _interopRequireDefault(__webpack_require__(48498));
var _headingRole = _interopRequireDefault(__webpack_require__(67830));
var _imgRole = _interopRequireDefault(__webpack_require__(25096));
var _insertionRole = _interopRequireDefault(__webpack_require__(45799));
var _linkRole = _interopRequireDefault(__webpack_require__(78987));
var _listRole = _interopRequireDefault(__webpack_require__(20353));
var _listboxRole = _interopRequireDefault(__webpack_require__(21300));
var _listitemRole = _interopRequireDefault(__webpack_require__(8288));
var _logRole = _interopRequireDefault(__webpack_require__(10503));
var _mainRole = _interopRequireDefault(__webpack_require__(14211));
var _marqueeRole = _interopRequireDefault(__webpack_require__(67165));
var _mathRole = _interopRequireDefault(__webpack_require__(63400));
var _menuRole = _interopRequireDefault(__webpack_require__(65357));
var _menubarRole = _interopRequireDefault(__webpack_require__(78926));
var _menuitemRole = _interopRequireDefault(__webpack_require__(96077));
var _menuitemcheckboxRole = _interopRequireDefault(__webpack_require__(4332));
var _menuitemradioRole = _interopRequireDefault(__webpack_require__(5462));
var _meterRole = _interopRequireDefault(__webpack_require__(10740));
var _navigationRole = _interopRequireDefault(__webpack_require__(24772));
var _noneRole = _interopRequireDefault(__webpack_require__(12109));
var _noteRole = _interopRequireDefault(__webpack_require__(15953));
var _optionRole = _interopRequireDefault(__webpack_require__(72476));
var _paragraphRole = _interopRequireDefault(__webpack_require__(16302));
var _presentationRole = _interopRequireDefault(__webpack_require__(88757));
var _progressbarRole = _interopRequireDefault(__webpack_require__(91548));
var _radioRole = _interopRequireDefault(__webpack_require__(59538));
var _radiogroupRole = _interopRequireDefault(__webpack_require__(2964));
var _regionRole = _interopRequireDefault(__webpack_require__(36542));
var _rowRole = _interopRequireDefault(__webpack_require__(86410));
var _rowgroupRole = _interopRequireDefault(__webpack_require__(22386));
var _rowheaderRole = _interopRequireDefault(__webpack_require__(34773));
var _scrollbarRole = _interopRequireDefault(__webpack_require__(87693));
var _searchRole = _interopRequireDefault(__webpack_require__(26560));
var _searchboxRole = _interopRequireDefault(__webpack_require__(4573));
var _separatorRole = _interopRequireDefault(__webpack_require__(15026));
var _sliderRole = _interopRequireDefault(__webpack_require__(99644));
var _spinbuttonRole = _interopRequireDefault(__webpack_require__(5954));
var _statusRole = _interopRequireDefault(__webpack_require__(23977));
var _strongRole = _interopRequireDefault(__webpack_require__(86484));
var _subscriptRole = _interopRequireDefault(__webpack_require__(79727));
var _superscriptRole = _interopRequireDefault(__webpack_require__(26566));
var _switchRole = _interopRequireDefault(__webpack_require__(6248));
var _tabRole = _interopRequireDefault(__webpack_require__(56767));
var _tableRole = _interopRequireDefault(__webpack_require__(5420));
var _tablistRole = _interopRequireDefault(__webpack_require__(80523));
var _tabpanelRole = _interopRequireDefault(__webpack_require__(33043));
var _termRole = _interopRequireDefault(__webpack_require__(96567));
var _textboxRole = _interopRequireDefault(__webpack_require__(40046));
var _timeRole = _interopRequireDefault(__webpack_require__(20292));
var _timerRole = _interopRequireDefault(__webpack_require__(69895));
var _toolbarRole = _interopRequireDefault(__webpack_require__(79182));
var _tooltipRole = _interopRequireDefault(__webpack_require__(42516));
var _treeRole = _interopRequireDefault(__webpack_require__(27976));
var _treegridRole = _interopRequireDefault(__webpack_require__(39379));
var _treeitemRole = _interopRequireDefault(__webpack_require__(58532));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaLiteralRoles = [['alert', _alertRole.default], ['alertdialog', _alertdialogRole.default], ['application', _applicationRole.default], ['article', _articleRole.default], ['banner', _bannerRole.default], ['blockquote', _blockquoteRole.default], ['button', _buttonRole.default], ['caption', _captionRole.default], ['cell', _cellRole.default], ['checkbox', _checkboxRole.default], ['code', _codeRole.default], ['columnheader', _columnheaderRole.default], ['combobox', _comboboxRole.default], ['complementary', _complementaryRole.default], ['contentinfo', _contentinfoRole.default], ['definition', _definitionRole.default], ['deletion', _deletionRole.default], ['dialog', _dialogRole.default], ['directory', _directoryRole.default], ['document', _documentRole.default], ['emphasis', _emphasisRole.default], ['feed', _feedRole.default], ['figure', _figureRole.default], ['form', _formRole.default], ['generic', _genericRole.default], ['grid', _gridRole.default], ['gridcell', _gridcellRole.default], ['group', _groupRole.default], ['heading', _headingRole.default], ['img', _imgRole.default], ['insertion', _insertionRole.default], ['link', _linkRole.default], ['list', _listRole.default], ['listbox', _listboxRole.default], ['listitem', _listitemRole.default], ['log', _logRole.default], ['main', _mainRole.default], ['marquee', _marqueeRole.default], ['math', _mathRole.default], ['menu', _menuRole.default], ['menubar', _menubarRole.default], ['menuitem', _menuitemRole.default], ['menuitemcheckbox', _menuitemcheckboxRole.default], ['menuitemradio', _menuitemradioRole.default], ['meter', _meterRole.default], ['navigation', _navigationRole.default], ['none', _noneRole.default], ['note', _noteRole.default], ['option', _optionRole.default], ['paragraph', _paragraphRole.default], ['presentation', _presentationRole.default], ['progressbar', _progressbarRole.default], ['radio', _radioRole.default], ['radiogroup', _radiogroupRole.default], ['region', _regionRole.default], ['row', _rowRole.default], ['rowgroup', _rowgroupRole.default], ['rowheader', _rowheaderRole.default], ['scrollbar', _scrollbarRole.default], ['search', _searchRole.default], ['searchbox', _searchboxRole.default], ['separator', _separatorRole.default], ['slider', _sliderRole.default], ['spinbutton', _spinbuttonRole.default], ['status', _statusRole.default], ['strong', _strongRole.default], ['subscript', _subscriptRole.default], ['superscript', _superscriptRole.default], ['switch', _switchRole.default], ['tab', _tabRole.default], ['table', _tableRole.default], ['tablist', _tablistRole.default], ['tabpanel', _tabpanelRole.default], ['term', _termRole.default], ['textbox', _textboxRole.default], ['time', _timeRole.default], ['timer', _timerRole.default], ['toolbar', _toolbarRole.default], ['tooltip', _tooltipRole.default], ['tree', _treeRole.default], ['treegrid', _treegridRole.default], ['treeitem', _treeitemRole.default]];
var _default = ariaLiteralRoles;
exports["default"] = _default;

/***/ }),

/***/ 18868:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAbstractRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'abstract [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docAbstractRole;
exports["default"] = _default;

/***/ }),

/***/ 79710:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAcknowledgmentsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'acknowledgments [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAcknowledgmentsRole;
exports["default"] = _default;

/***/ }),

/***/ 77958:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAfterwordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'afterword [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAfterwordRole;
exports["default"] = _default;

/***/ }),

/***/ 99074:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAppendixRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'appendix [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAppendixRole;
exports["default"] = _default;

/***/ }),

/***/ 23961:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBacklinkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'content'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'referrer [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docBacklinkRole;
exports["default"] = _default;

/***/ }),

/***/ 68917:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBiblioentryRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'EPUB biblioentry [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: ['doc-bibliography'],
  requiredContextRole: ['doc-bibliography'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'listitem']]
};
var _default = docBiblioentryRole;
exports["default"] = _default;

/***/ }),

/***/ 20555:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBibliographyRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'bibliography [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['doc-biblioentry']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docBibliographyRole;
exports["default"] = _default;

/***/ }),

/***/ 85081:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBibliorefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'biblioref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docBibliorefRole;
exports["default"] = _default;

/***/ }),

/***/ 38935:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docChapterRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'chapter [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docChapterRole;
exports["default"] = _default;

/***/ }),

/***/ 53076:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docColophonRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'colophon [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docColophonRole;
exports["default"] = _default;

/***/ }),

/***/ 46406:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docConclusionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'conclusion [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docConclusionRole;
exports["default"] = _default;

/***/ }),

/***/ 44613:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCoverRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'cover [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'img']]
};
var _default = docCoverRole;
exports["default"] = _default;

/***/ }),

/***/ 2060:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCreditRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'credit [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docCreditRole;
exports["default"] = _default;

/***/ }),

/***/ 79176:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCreditsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'credits [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docCreditsRole;
exports["default"] = _default;

/***/ }),

/***/ 97684:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docDedicationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'dedication [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docDedicationRole;
exports["default"] = _default;

/***/ }),

/***/ 75835:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEndnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rearnote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: ['doc-endnotes'],
  requiredContextRole: ['doc-endnotes'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'listitem']]
};
var _default = docEndnoteRole;
exports["default"] = _default;

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEndnotesRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rearnotes [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['doc-endnote']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docEndnotesRole;
exports["default"] = _default;

/***/ }),

/***/ 34767:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEpigraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'epigraph [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docEpigraphRole;
exports["default"] = _default;

/***/ }),

/***/ 34726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEpilogueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'epilogue [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docEpilogueRole;
exports["default"] = _default;

/***/ }),

/***/ 363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docErrataRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'errata [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docErrataRole;
exports["default"] = _default;

/***/ }),

/***/ 25742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docExampleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docExampleRole;
exports["default"] = _default;

/***/ }),

/***/ 37863:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docFootnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'footnote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docFootnoteRole;
exports["default"] = _default;

/***/ }),

/***/ 89953:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docForewordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'foreword [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docForewordRole;
exports["default"] = _default;

/***/ }),

/***/ 29209:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docGlossaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'glossary [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['definition'], ['term']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docGlossaryRole;
exports["default"] = _default;

/***/ }),

/***/ 43145:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docGlossrefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'glossref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docGlossrefRole;
exports["default"] = _default;

/***/ }),

/***/ 7945:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docIndexRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'index [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docIndexRole;
exports["default"] = _default;

/***/ }),

/***/ 60022:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docIntroductionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'introduction [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docIntroductionRole;
exports["default"] = _default;

/***/ }),

/***/ 21913:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docNoterefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'noteref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docNoterefRole;
exports["default"] = _default;

/***/ }),

/***/ 76648:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docNoticeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'notice [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'note']]
};
var _default = docNoticeRole;
exports["default"] = _default;

/***/ }),

/***/ 13551:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPagebreakRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'pagebreak [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'separator']]
};
var _default = docPagebreakRole;
exports["default"] = _default;

/***/ }),

/***/ 87789:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPagelistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'page-list [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docPagelistRole;
exports["default"] = _default;

/***/ }),

/***/ 85367:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPartRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'part [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPartRole;
exports["default"] = _default;

/***/ }),

/***/ 90938:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPrefaceRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'preface [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPrefaceRole;
exports["default"] = _default;

/***/ }),

/***/ 59955:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPrologueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'prologue [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPrologueRole;
exports["default"] = _default;

/***/ }),

/***/ 99992:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPullquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'pullquote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['none']]
};
var _default = docPullquoteRole;
exports["default"] = _default;

/***/ }),

/***/ 64565:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docQnaRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'qna [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docQnaRole;
exports["default"] = _default;

/***/ }),

/***/ 23465:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docSubtitleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'subtitle [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'sectionhead']]
};
var _default = docSubtitleRole;
exports["default"] = _default;

/***/ }),

/***/ 37207:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docTipRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'help [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'note']]
};
var _default = docTipRole;
exports["default"] = _default;

/***/ }),

/***/ 33719:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docTocRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'toc [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docTocRole;
exports["default"] = _default;

/***/ }),

/***/ 75805:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var graphicsDocumentRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    module: 'GRAPHICS',
    concept: {
      name: 'graphics-object'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'img'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'article'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'document']]
};
var _default = graphicsDocumentRole;
exports["default"] = _default;

/***/ }),

/***/ 46205:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var graphicsObjectRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    module: 'GRAPHICS',
    concept: {
      name: 'graphics-document'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'group'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'img'
    }
  }, {
    module: 'GRAPHICS',
    concept: {
      name: 'graphics-symbol'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group']]
};
var _default = graphicsObjectRole;
exports["default"] = _default;

/***/ }),

/***/ 8855:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var graphicsSymbolRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'img']]
};
var _default = graphicsSymbolRole;
exports["default"] = _default;

/***/ }),

/***/ 66472:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var alertRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-atomic': 'true',
    'aria-live': 'assertive'
  },
  relatedConcepts: [{
    concept: {
      name: 'alert'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = alertRole;
exports["default"] = _default;

/***/ }),

/***/ 84976:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var alertdialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'alert'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'alert'], ['roletype', 'window', 'dialog']]
};
var _default = alertdialogRole;
exports["default"] = _default;

/***/ }),

/***/ 35902:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var applicationRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'Device Independence Delivery Unit'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = applicationRole;
exports["default"] = _default;

/***/ }),

/***/ 36883:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var articleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'article'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'document']]
};
var _default = articleRole;
exports["default"] = _default;

/***/ }),

/***/ 25599:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var bannerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of document'],
      name: 'header'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = bannerRole;
exports["default"] = _default;

/***/ }),

/***/ 91621:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var blockquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = blockquoteRole;
exports["default"] = _default;

/***/ }),

/***/ 50855:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var buttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-pressed': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-pressed'
      }, {
        name: 'type',
        value: 'checkbox'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'aria-expanded',
        value: 'false'
      }],
      name: 'summary'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'aria-expanded',
        value: 'true'
      }],
      constraints: ['direct descendant of details element with the open attribute defined'],
      name: 'summary'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'button'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'image'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'reset'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'submit'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'button'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'trigger'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = buttonRole;
exports["default"] = _default;

/***/ }),

/***/ 31760:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var captionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: ['figure', 'grid', 'table'],
  requiredContextRole: ['figure', 'grid', 'table'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = captionRole;
exports["default"] = _default;

/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var cellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-colindex': null,
    'aria-colspan': null,
    'aria-rowindex': null,
    'aria-rowspan': null
  },
  relatedConcepts: [{
    concept: {
      constraints: ['descendant of table'],
      name: 'td'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = cellRole;
exports["default"] = _default;

/***/ }),

/***/ 58651:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var checkboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'checkbox'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'option'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = checkboxRole;
exports["default"] = _default;

/***/ }),

/***/ 87305:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var codeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = codeRole;
exports["default"] = _default;

/***/ }),

/***/ 53486:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var columnheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-sort': null
  },
  relatedConcepts: [{
    attributes: [{
      name: 'scope',
      value: 'col'
    }],
    concept: {
      name: 'th'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
};
var _default = columnheaderRole;
exports["default"] = _default;

/***/ }),

/***/ 81663:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var comboboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-autocomplete': null,
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-expanded': 'false',
    'aria-haspopup': 'listbox'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'email'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'search'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'tel'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'text'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'multiple'
      }, {
        constraints: ['undefined'],
        name: 'size'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'multiple'
      }, {
        name: 'size',
        value: 1
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-controls': null,
    'aria-expanded': 'false'
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = comboboxRole;
exports["default"] = _default;

/***/ }),

/***/ 98889:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var complementaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'aside'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = complementaryRole;
exports["default"] = _default;

/***/ }),

/***/ 94961:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var contentinfoRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of document'],
      name: 'footer'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = contentinfoRole;
exports["default"] = _default;

/***/ }),

/***/ 4676:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var definitionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dd'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = definitionRole;
exports["default"] = _default;

/***/ }),

/***/ 48978:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var deletionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = deletionRole;
exports["default"] = _default;

/***/ }),

/***/ 94154:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var dialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dialog'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'window']]
};
var _default = dialogRole;
exports["default"] = _default;

/***/ }),

/***/ 95707:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var directoryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    module: 'DAISY Guide'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'list']]
};
var _default = directoryRole;
exports["default"] = _default;

/***/ }),

/***/ 53212:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var documentRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'Device Independence Delivery Unit'
    }
  }, {
    concept: {
      name: 'body'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = documentRole;
exports["default"] = _default;

/***/ }),

/***/ 55530:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var emphasisRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = emphasisRole;
exports["default"] = _default;

/***/ }),

/***/ 43478:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var feedRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['article']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'list']]
};
var _default = feedRole;
exports["default"] = _default;

/***/ }),

/***/ 12728:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var figureRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'figure'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = figureRole;
exports["default"] = _default;

/***/ }),

/***/ 77841:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-label'
      }],
      name: 'form'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-labelledby'
      }],
      name: 'form'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'name'
      }],
      name: 'form'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = formRole;
exports["default"] = _default;

/***/ }),

/***/ 56322:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var genericRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'span'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'div'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = genericRole;
exports["default"] = _default;

/***/ }),

/***/ 10417:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-multiselectable': null,
    'aria-readonly': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'role',
        value: 'grid'
      }],
      name: 'table'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'table']]
};
var _default = gridRole;
exports["default"] = _default;

/***/ }),

/***/ 49947:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gridcellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-selected': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'role',
        value: 'gridcell'
      }],
      name: 'td'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'widget']]
};
var _default = gridcellRole;
exports["default"] = _default;

/***/ }),

/***/ 48498:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var groupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null
  },
  relatedConcepts: [{
    concept: {
      name: 'details'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'fieldset'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'optgroup'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = groupRole;
exports["default"] = _default;

/***/ }),

/***/ 67830:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var headingRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-level': '2'
  },
  relatedConcepts: [{
    concept: {
      name: 'h1'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h2'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h3'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h4'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h5'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h6'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-level': '2'
  },
  superClass: [['roletype', 'structure', 'sectionhead']]
};
var _default = headingRole;
exports["default"] = _default;

/***/ }),

/***/ 25096:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var imgRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'alt'
      }],
      name: 'img'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'alt'
      }],
      name: 'img'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'imggroup'
    },
    module: 'DTB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = imgRole;
exports["default"] = _default;

/***/ }),

/***/ 45799:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var insertionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = insertionRole;
exports["default"] = _default;

/***/ }),

/***/ 78987:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var linkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'a'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'area'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'link'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = linkRole;
exports["default"] = _default;

/***/ }),

/***/ 20353:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menu'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'ol'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'ul'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['listitem']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = listRole;
exports["default"] = _default;

/***/ }),

/***/ 21300:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-invalid': null,
    'aria-multiselectable': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['>1'],
        name: 'size'
      }, {
        name: 'multiple'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['>1'],
        name: 'size'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'multiple'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'datalist'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['option', 'group'], ['option']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = listboxRole;
exports["default"] = _default;

/***/ }),

/***/ 8288:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listitemRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-level': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of ol, ul or menu'],
      name: 'li'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'item'
    },
    module: 'XForms'
  }],
  requireContextRole: ['directory', 'list'],
  requiredContextRole: ['directory', 'list'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = listitemRole;
exports["default"] = _default;

/***/ }),

/***/ 10503:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var logRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-live': 'polite'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = logRole;
exports["default"] = _default;

/***/ }),

/***/ 14211:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mainRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'main'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = mainRole;
exports["default"] = _default;

/***/ }),

/***/ 67165:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var marqueeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = marqueeRole;
exports["default"] = _default;

/***/ }),

/***/ 63400:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mathRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'math'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = mathRole;
exports["default"] = _default;

/***/ }),

/***/ 65357:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [{
    concept: {
      name: 'MENU'
    },
    module: 'JAPI'
  }, {
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'sidebar'
    },
    module: 'DTB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = menuRole;
exports["default"] = _default;

/***/ }),

/***/ 78926:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menubarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    concept: {
      name: 'toolbar'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select', 'menu'], ['roletype', 'structure', 'section', 'group', 'select', 'menu']]
};
var _default = menubarRole;
exports["default"] = _default;

/***/ }),

/***/ 96077:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'MENU_ITEM'
    },
    module: 'JAPI'
  }, {
    concept: {
      name: 'listitem'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'menuitem'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'option'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = menuitemRole;
exports["default"] = _default;

/***/ }),

/***/ 4332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemcheckboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox'], ['roletype', 'widget', 'command', 'menuitem']]
};
var _default = menuitemcheckboxRole;
exports["default"] = _default;

/***/ }),

/***/ 5462:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemradioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox', 'menuitemcheckbox'], ['roletype', 'widget', 'command', 'menuitem', 'menuitemcheckbox'], ['roletype', 'widget', 'input', 'radio']]
};
var _default = menuitemradioRole;
exports["default"] = _default;

/***/ }),

/***/ 10740:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var meterRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuetext': null,
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-valuenow': null
  },
  superClass: [['roletype', 'structure', 'range']]
};
var _default = meterRole;
exports["default"] = _default;

/***/ }),

/***/ 24772:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var navigationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'nav'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = navigationRole;
exports["default"] = _default;

/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var noneRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default = noneRole;
exports["default"] = _default;

/***/ }),

/***/ 15953:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var noteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = noteRole;
exports["default"] = _default;

/***/ }),

/***/ 72476:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var optionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-posinset': null,
    'aria-setsize': null,
    'aria-selected': 'false'
  },
  relatedConcepts: [{
    concept: {
      name: 'item'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'listitem'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'option'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-selected': 'false'
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = optionRole;
exports["default"] = _default;

/***/ }),

/***/ 16302:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var paragraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = paragraphRole;
exports["default"] = _default;

/***/ }),

/***/ 88757:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var presentationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = presentationRole;
exports["default"] = _default;

/***/ }),

/***/ 91548:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var progressbarRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuetext': null
  },
  relatedConcepts: [{
    concept: {
      name: 'progress'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'status'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
};
var _default = progressbarRole;
exports["default"] = _default;

/***/ }),

/***/ 59538:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var radioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'radio'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = radioRole;
exports["default"] = _default;

/***/ }),

/***/ 2964:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var radiogroupRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['radio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = radiogroupRole;
exports["default"] = _default;

/***/ }),

/***/ 36542:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var regionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-label'
      }],
      name: 'section'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-labelledby'
      }],
      name: 'section'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'Device Independence Glossart perceivable unit'
    }
  }, {
    concept: {
      name: 'frame'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = regionRole;
exports["default"] = _default;

/***/ }),

/***/ 86410:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-colindex': null,
    'aria-expanded': null,
    'aria-level': null,
    'aria-posinset': null,
    'aria-rowindex': null,
    'aria-selected': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'tr'
    },
    module: 'HTML'
  }],
  requireContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
  requiredContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
  requiredOwnedElements: [['cell'], ['columnheader'], ['gridcell'], ['rowheader']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group'], ['roletype', 'widget']]
};
var _default = rowRole;
exports["default"] = _default;

/***/ }),

/***/ 22386:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowgroupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'tbody'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'tfoot'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'thead'
    },
    module: 'HTML'
  }],
  requireContextRole: ['grid', 'table', 'treegrid'],
  requiredContextRole: ['grid', 'table', 'treegrid'],
  requiredOwnedElements: [['row']],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = rowgroupRole;
exports["default"] = _default;

/***/ }),

/***/ 34773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-sort': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'scope',
        value: 'row'
      }],
      name: 'th'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'scope',
        value: 'rowgroup'
      }],
      name: 'th'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row', 'rowgroup'],
  requiredContextRole: ['row', 'rowgroup'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
};
var _default = rowheaderRole;
exports["default"] = _default;

/***/ }),

/***/ 87693:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var scrollbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-valuetext': null,
    'aria-orientation': 'vertical',
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-controls': null,
    'aria-valuenow': null
  },
  superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
};
var _default = scrollbarRole;
exports["default"] = _default;

/***/ }),

/***/ 26560:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = searchRole;
exports["default"] = _default;

/***/ }),

/***/ 4573:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'search'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'input', 'textbox']]
};
var _default = searchboxRole;
exports["default"] = _default;

/***/ }),

/***/ 15026:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var separatorRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-orientation': 'horizontal',
    'aria-valuemax': '100',
    'aria-valuemin': '0',
    'aria-valuenow': null,
    'aria-valuetext': null
  },
  relatedConcepts: [{
    concept: {
      name: 'hr'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = separatorRole;
exports["default"] = _default;

/***/ }),

/***/ 99644:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sliderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-valuetext': null,
    'aria-orientation': 'horizontal',
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'range'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-valuenow': null
  },
  superClass: [['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
};
var _default = sliderRole;
exports["default"] = _default;

/***/ }),

/***/ 5954:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var spinbuttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-valuetext': null,
    'aria-valuenow': '0'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'number'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
};
var _default = spinbuttonRole;
exports["default"] = _default;

/***/ }),

/***/ 23977:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var statusRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-atomic': 'true',
    'aria-live': 'polite'
  },
  relatedConcepts: [{
    concept: {
      name: 'output'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = statusRole;
exports["default"] = _default;

/***/ }),

/***/ 86484:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var strongRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = strongRole;
exports["default"] = _default;

/***/ }),

/***/ 79727:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var subscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = subscriptRole;
exports["default"] = _default;

/***/ }),

/***/ 26566:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var superscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = superscriptRole;
exports["default"] = _default;

/***/ }),

/***/ 6248:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var switchRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'button'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox']]
};
var _default = switchRole;
exports["default"] = _default;

/***/ }),

/***/ 56767:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tabRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-posinset': null,
    'aria-setsize': null,
    'aria-selected': 'false'
  },
  relatedConcepts: [],
  requireContextRole: ['tablist'],
  requiredContextRole: ['tablist'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'sectionhead'], ['roletype', 'widget']]
};
var _default = tabRole;
exports["default"] = _default;

/***/ }),

/***/ 5420:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tableRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-colcount': null,
    'aria-rowcount': null
  },
  relatedConcepts: [{
    concept: {
      name: 'table'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tableRole;
exports["default"] = _default;

/***/ }),

/***/ 80523:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tablistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-level': null,
    'aria-multiselectable': null,
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    module: 'DAISY',
    concept: {
      name: 'guide'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['tab']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite']]
};
var _default = tablistRole;
exports["default"] = _default;

/***/ }),

/***/ 33043:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tabpanelRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tabpanelRole;
exports["default"] = _default;

/***/ }),

/***/ 96567:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var termRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dfn'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'dt'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = termRole;
exports["default"] = _default;

/***/ }),

/***/ 40046:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var textboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-autocomplete': null,
    'aria-errormessage': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-multiline': null,
    'aria-placeholder': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'type'
      }, {
        constraints: ['undefined'],
        name: 'list'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'email'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'tel'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'text'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'input'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'textarea'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'input']]
};
var _default = textboxRole;
exports["default"] = _default;

/***/ }),

/***/ 20292:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var timeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = timeRole;
exports["default"] = _default;

/***/ }),

/***/ 69895:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var timerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'status']]
};
var _default = timerRole;
exports["default"] = _default;

/***/ }),

/***/ 79182:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var toolbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    concept: {
      name: 'menubar'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group']]
};
var _default = toolbarRole;
exports["default"] = _default;

/***/ }),

/***/ 42516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tooltipRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tooltipRole;
exports["default"] = _default;

/***/ }),

/***/ 27976:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-multiselectable': null,
    'aria-required': null,
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['treeitem', 'group'], ['treeitem']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = treeRole;
exports["default"] = _default;

/***/ }),

/***/ 39379:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treegridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'grid'], ['roletype', 'structure', 'section', 'table', 'grid'], ['roletype', 'widget', 'composite', 'select', 'tree'], ['roletype', 'structure', 'section', 'group', 'select', 'tree']]
};
var _default = treegridRole;
exports["default"] = _default;

/***/ }),

/***/ 58532:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treeitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-expanded': null,
    'aria-haspopup': null
  },
  relatedConcepts: [],
  requireContextRole: ['group', 'tree'],
  requiredContextRole: ['group', 'tree'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-selected': null
  },
  superClass: [['roletype', 'structure', 'section', 'listitem'], ['roletype', 'widget', 'input', 'option']]
};
var _default = treeitemRole;
exports["default"] = _default;

/***/ }),

/***/ 41516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.uJ = exports.UN = exports.Qv = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var _ariaPropsMap = _interopRequireDefault(__webpack_require__(72256));
var _domMap = _interopRequireDefault(__webpack_require__(92607));
var _rolesMap = _interopRequireDefault(__webpack_require__(29312));
var _elementRoleMap = _interopRequireDefault(__webpack_require__(74490));
var _roleElementMap = _interopRequireDefault(__webpack_require__(52438));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var aria = _ariaPropsMap.default;
__webpack_unused_export__ = aria;
var dom = _domMap.default;
__webpack_unused_export__ = dom;
var roles = _rolesMap.default;
exports.uJ = roles;
var elementRoles = _elementRoleMap.default;
exports.Qv = elementRoles;
var roleElements = _roleElementMap.default;
exports.UN = roleElements;

/***/ }),

/***/ 52438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
var _rolesMap = _interopRequireDefault(__webpack_require__(29312));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var roleElement = [];
var keys = _rolesMap.default.keys();
var _loop = function _loop(i) {
  var key = keys[i];
  var role = _rolesMap.default.get(key);
  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
    for (var k = 0; k < concepts.length; k++) {
      var relation = concepts[k];
      if (relation.module === 'HTML') {
        var concept = relation.concept;
        if (concept) {
          var roleElementRelation = roleElement.find(function (item) {
            return item[0] === key;
          });
          var relationConcepts = void 0;
          if (roleElementRelation) {
            relationConcepts = roleElementRelation[1];
          } else {
            relationConcepts = [];
          }
          relationConcepts.push(concept);
          roleElement.push([key, relationConcepts]);
        }
      }
    }
  }
};
for (var i = 0; i < keys.length; i++) {
  _loop(i);
}
var roleElementMap = {
  entries: function entries() {
    return roleElement;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(roleElement),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, key, roleElement);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = roleElement.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!roleElementMap.get(key);
  },
  keys: function keys() {
    return roleElement.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return roleElement.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(roleElementMap, roleElementMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 29312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _ariaAbstractRoles = _interopRequireDefault(__webpack_require__(14690));
var _ariaLiteralRoles = _interopRequireDefault(__webpack_require__(58514));
var _ariaDpubRoles = _interopRequireDefault(__webpack_require__(61413));
var _ariaGraphicsRoles = _interopRequireDefault(__webpack_require__(20915));
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var roles = [].concat(_ariaAbstractRoles.default, _ariaLiteralRoles.default, _ariaDpubRoles.default, _ariaGraphicsRoles.default);
roles.forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    roleDefinition = _ref2[1];
  // Conglomerate the properties
  var _iterator = _createForOfIteratorHelper(roleDefinition.superClass),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var superClassIter = _step.value;
      var _iterator2 = _createForOfIteratorHelper(superClassIter),
        _step2;
      try {
        var _loop = function _loop() {
          var superClassName = _step2.value;
          var superClassRoleTuple = roles.find(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
              name = _ref4[0];
            return name === superClassName;
          });
          if (superClassRoleTuple) {
            var superClassDefinition = superClassRoleTuple[1];
            for (var _i2 = 0, _Object$keys = Object.keys(superClassDefinition.props); _i2 < _Object$keys.length; _i2++) {
              var prop = _Object$keys[_i2];
              if (
              // $FlowIssue Accessing the hasOwnProperty on the Object prototype is fine.
              !Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)) {
                Object.assign(roleDefinition.props, _defineProperty({}, prop, superClassDefinition.props[prop]));
              }
            }
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});
var rolesMap = {
  entries: function entries() {
    return roles;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator3 = _createForOfIteratorHelper(roles),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
          key = _step3$value[0],
          values = _step3$value[1];
        fn.call(thisArg, values, key, roles);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  },
  get: function get(key) {
    var item = roles.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!rolesMap.get(key);
  },
  keys: function keys() {
    return roles.map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        key = _ref6[0];
      return key;
    });
  },
  values: function values() {
    return roles.map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        values = _ref8[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(rolesMap, rolesMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 34818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = iterationDecorator;
var _iteratorProxy = _interopRequireDefault(__webpack_require__(91101));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function iterationDecorator(collection, entries) {
  if (typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol') {
    Object.defineProperty(collection, Symbol.iterator, {
      value: _iteratorProxy.default.bind(entries)
    });
  }
  return collection;
}

/***/ }),

/***/ 91101:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// eslint-disable-next-line no-unused-vars
function iteratorProxy() {
  var values = this;
  var index = 0;
  var iter = {
    '@@iterator': function iterator() {
      return iter;
    },
    next: function next() {
      if (index < values.length) {
        var value = values[index];
        index = index + 1;
        return {
          done: false,
          value: value
        };
      } else {
        return {
          done: true
        };
      }
    }
  };
  return iter;
}
var _default = iteratorProxy;
exports["default"] = _default;

/***/ }),

/***/ 4562:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(42898);
var callBound = __webpack_require__(47737);
var flags = __webpack_require__(81861);
var GetIntrinsic = __webpack_require__(91528);
var getIterator = __webpack_require__(73607);
var getSideChannel = __webpack_require__(62538);
var is = __webpack_require__(10884);
var isArguments = __webpack_require__(14043);
var isArray = __webpack_require__(79830);
var isArrayBuffer = __webpack_require__(12026);
var isDate = __webpack_require__(464);
var isRegex = __webpack_require__(67584);
var isSharedArrayBuffer = __webpack_require__(25178);
var objectKeys = __webpack_require__(13438);
var whichBoxedPrimitive = __webpack_require__(14062);
var whichCollection = __webpack_require__(8121);
var whichTypedArray = __webpack_require__(49154);
var byteLength = __webpack_require__(83366);

var sabByteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);

var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');

var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
  var i = getIterator(set);
  var result;
  while ((result = i.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel)) { // eslint-disable-line no-use-before-define
      // Remove the matching element to make sure we do not check that again.
      $setDelete(set, result.value);
      return true;
    }
  }

  return false;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === 'undefined') {
    return null;
  }
  if (typeof prim === 'object') { // Only pass in null as object!
    return void 0;
  }
  if (typeof prim === 'symbol') {
    return false;
  }
  if (typeof prim === 'string' || typeof prim === 'number') {
    // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
  }
  return true;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b, altValue);
  var looseOpts = assign({}, opts, { strict: false });
  if (
    (typeof curB === 'undefined' && !$mapHas(b, altValue))
    // eslint-disable-next-line no-use-before-define
    || !internalDeepEqual(item, curB, looseOpts, channel)
  ) {
    return false;
  }
  // eslint-disable-next-line no-use-before-define
  return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }

  return $setHas(b, altValue) && !$setHas(a, altValue);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
  var i = getIterator(set);
  var result;
  var key2;
  while ((result = i.next()) && !result.done) {
    key2 = result.value;
    if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel)
      // eslint-disable-next-line no-use-before-define
      && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)
    ) {
      $setDelete(set, key2);
      return true;
    }
  }

  return false;
}

function internalDeepEqual(actual, expected, options, channel) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  var actualBoxed = whichBoxedPrimitive(actual);
  var expectedBoxed = whichBoxedPrimitive(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

  var hasActual = channel.has(actual);
  var hasExpected = channel.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel.get(actual) === channel.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) { channel.set(actual, sentinel); }
  if (!hasExpected) { channel.set(expected, sentinel); }

  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts, channel);
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }

  return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}

function setEquiv(a, b, opts, channel) {
  if ($setSize(a) !== $setSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && typeof resultA.value === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b, resultA.value)) {
      if (opts.strict) { return false; }
      if (!setMightHaveLoosePrim(a, b, resultA.value)) {
        return false;
      }
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
      if (resultB.value && typeof resultB.value === 'object') {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && !$setHas(a, resultB.value)
        && !setHasEqualElement(set, resultB.value, opts.strict, channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function mapEquiv(a, b, opts, channel) {
  if ($mapSize(a) !== $mapSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && typeof key === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b, key);
      if ((typeof item2 === 'undefined' && !$mapHas(b, key)) || !internalDeepEqual(item1, item2, opts, channel)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
          return false;
        }
        if (!set) { set = new $Set(); }
        $setAdd(set, key);
      }
    }
  }

  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && typeof key === 'object') {
        if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel))
        && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, { strict: false }), channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function objEquiv(a, b, opts, channel) {
  /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */
  var i, key;

  if (typeof a !== typeof b) { return false; }
  if (a == null || b == null) { return false; }

  if ($objToString(a) !== $objToString(b)) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsArray = isArray(a);
  var bIsArray = isArray(b);
  if (aIsArray !== bIsArray) { return false; }

  // TODO: replace when a cross-realm brand check is available
  var aIsError = a instanceof Error;
  var bIsError = b instanceof Error;
  if (aIsError !== bIsError) { return false; }
  if (aIsError || bIsError) {
    if (a.name !== b.name || a.message !== b.message) { return false; }
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
    return false;
  }

  var aIsDate = isDate(a);
  var bIsDate = isDate(b);
  if (aIsDate !== bIsDate) { return false; }
  if (aIsDate || bIsDate) { // && would work too, because both are true or both false here
    if ($getTime(a) !== $getTime(b)) { return false; }
  }
  if (opts.strict && gPO && gPO(a) !== gPO(b)) { return false; }

  var aWhich = whichTypedArray(a);
  var bWhich = whichTypedArray(b);
  if (aWhich !== bWhich) {
    return false;
  }
  if (aWhich || bWhich) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  var aIsArrayBuffer = isArrayBuffer(a);
  var bIsArrayBuffer = isArrayBuffer(b);
  if (aIsArrayBuffer !== bIsArrayBuffer) { return false; }
  if (aIsArrayBuffer || bIsArrayBuffer) { // && would work too, because both are true or both false here
    if (byteLength(a) !== byteLength(b)) { return false; }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }

  var aIsSAB = isSharedArrayBuffer(a);
  var bIsSAB = isSharedArrayBuffer(b);
  if (aIsSAB !== bIsSAB) { return false; }
  if (aIsSAB || bIsSAB) { // && would work too, because both are true or both false here
    if (sabByteLength(a) !== sabByteLength(b)) { return false; }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }

  if (typeof a !== typeof b) { return false; }

  var ka = objectKeys(a);
  var kb = objectKeys(b);
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; } // eslint-disable-line eqeqeq
  }

  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!internalDeepEqual(a[key], b[key], opts, channel)) { return false; }
  }

  var aCollection = whichCollection(a);
  var bCollection = whichCollection(b);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === 'Set' || bCollection === 'Set') { // aCollection === bCollection
    return setEquiv(a, b, opts, channel);
  }
  if (aCollection === 'Map') { // aCollection === bCollection
    return mapEquiv(a, b, opts, channel);
  }

  return true;
}

module.exports = function deepEqual(a, b, opts) {
  return internalDeepEqual(a, b, opts, getSideChannel());
};


/***/ }),

/***/ 79830:
/***/ (function(module) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 83366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);

var isArrayBuffer = __webpack_require__(12026);

module.exports = function byteLength(ab) {
	if (!isArrayBuffer(ab)) {
		return NaN;
	}
	return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property


/***/ }),

/***/ 47737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);

var callBind = __webpack_require__(73235);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 73235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(37156);
var GetIntrinsic = __webpack_require__(91528);
var setFunctionLength = __webpack_require__(1744);

var $TypeError = GetIntrinsic('%TypeError%');
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 40841:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 56219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */

var fingerprint = __webpack_require__(32858);
var pad = __webpack_require__(87404);
var getRandomValue = __webpack_require__(26066);

var c = 0,
  blockSize = 4,
  base = 36,
  discreteValues = Math.pow(base, blockSize);

function randomBlock () {
  return pad((getRandomValue() *
    discreteValues << 0)
    .toString(base), blockSize);
}

function safeCounter () {
  c = c < discreteValues ? c : 0;
  c++; // this is not subliminal
  return c - 1;
}

function cuid () {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c', // hard-coded allows for sequential access

    // timestamp
    // warning: this exposes the exact date and time
    // that the uid was created.
    timestamp = (new Date().getTime()).toString(base),

    // Prevent same-machine collisions.
    counter = pad(safeCounter().toString(base), blockSize),

    // A few chars to generate distinct ids for different
    // clients (so different computers are far less
    // likely to generate the same id)
    print = fingerprint(),

    // Grab some more chars from Math.random()
    random = randomBlock() + randomBlock();

  return letter + timestamp + counter + print + random;
}

cuid.slug = function slug () {
  var date = new Date().getTime().toString(36),
    counter = safeCounter().toString(36).slice(-4),
    print = fingerprint().slice(0, 1) +
      fingerprint().slice(-1),
    random = randomBlock().slice(-2);

  return date.slice(-2) +
    counter + print + random;
};

cuid.isCuid = function isCuid (stringToCheck) {
  if (typeof stringToCheck !== 'string') return false;
  if (stringToCheck.startsWith('c')) return true;
  return false;
};

cuid.isSlug = function isSlug (stringToCheck) {
  if (typeof stringToCheck !== 'string') return false;
  var stringLength = stringToCheck.length;
  if (stringLength >= 7 && stringLength <= 10) return true;
  return false;
};

cuid.fingerprint = fingerprint;

module.exports = cuid;


/***/ }),

/***/ 32858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var pad = __webpack_require__(87404);

var env = typeof window === 'object' ? window : self;
var globalCount = Object.keys(env).length;
var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var clientId = pad((mimeTypesLength +
  navigator.userAgent.length).toString(36) +
  globalCount.toString(36), 4);

module.exports = function fingerprint () {
  return clientId;
};


/***/ }),

/***/ 26066:
/***/ (function(module) {


var getRandomValue;

var crypto = typeof window !== 'undefined' &&
  (window.crypto || window.msCrypto) ||
  typeof self !== 'undefined' &&
  self.crypto;

if (crypto) {
    var lim = Math.pow(2, 32) - 1;
    getRandomValue = function () {
        return Math.abs(crypto.getRandomValues(new Uint32Array(1))[0] / lim);
    };
} else {
    getRandomValue = Math.random;
}

module.exports = getRandomValue;


/***/ }),

/***/ 87404:
/***/ (function(module) {

module.exports = function pad (num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};


/***/ }),

/***/ 27892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasPropertyDescriptors = __webpack_require__(42320)();

var GetIntrinsic = __webpack_require__(91528);

var $defineProperty = hasPropertyDescriptors && GetIntrinsic('%Object.defineProperty%', true);
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var gopd = __webpack_require__(41455);

/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ 26506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(13438);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(27892);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(42320)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 31861:
/***/ (function(module) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 77025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(43765);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 34019:
/***/ (function(module) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),

/***/ 91528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(10465)();
var hasProto = __webpack_require__(91209)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(37156);
var hasOwn = __webpack_require__(22268);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 22268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(37156);

/** @type {(o: {}, p: PropertyKey) => p is keyof o} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 41455:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 11539:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}

})(window, document, 'Hammer');


/***/ }),

/***/ 17155:
/***/ (function(module) {

"use strict";


var $BigInt = typeof BigInt !== 'undefined' && BigInt;

module.exports = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};


/***/ }),

/***/ 42320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 91209:
/***/ (function(module) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),

/***/ 10465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(16073);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 16073:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 76686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(16073);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 86154:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var hasOwn = __webpack_require__(62078);
var channel = __webpack_require__(62538)();

var $TypeError = GetIntrinsic('%TypeError%');

var SLOT = {
	assert: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		channel.assert(O);
		if (!SLOT.has(O, slot)) {
			throw new $TypeError('`' + slot + '` is not present on `O`');
		}
	},
	get: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return slots && slots['$' + slot];
	},
	has: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return !!slots && hasOwn(slots, '$' + slot);
	},
	set: function (O, slot, V) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		if (!slots) {
			slots = {};
			channel.set(O, slots);
		}
		slots['$' + slot] = V;
	}
};

if (Object.freeze) {
	Object.freeze(SLOT);
}

module.exports = SLOT;


/***/ }),

/***/ 62078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(37156);

/** @type {(o: {}, p: PropertyKey) => p is keyof o} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 14043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(76686)();
var callBound = __webpack_require__(47737);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 12026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(73235);
var callBound = __webpack_require__(47737);
var GetIntrinsic = __webpack_require__(91528);
var isTypedArray = __webpack_require__(36421);

var $ArrayBuffer = GetIntrinsic('ArrayBuffer', true);
var $Float32Array = GetIntrinsic('Float32Array', true);
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);

// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var abSlice = $ArrayBuffer && !$byteLength && new $ArrayBuffer().slice;
var $abSlice = abSlice && callBind(abSlice);

module.exports = $byteLength || $abSlice
	? function isArrayBuffer(obj) {
		if (!obj || typeof obj !== 'object') {
			return false;
		}
		try {
			if ($byteLength) {
				$byteLength(obj);
			} else {
				$abSlice(obj, 0);
			}
			return true;
		} catch (e) {
			return false;
		}
	}
	: $Float32Array
		// in node 0.8, ArrayBuffers have no prototype or own methods
		? function IsArrayBuffer(obj) {
			try {
				return (new $Float32Array(obj)).buffer === obj && !isTypedArray(obj);
			} catch (e) {
				return typeof obj === 'object' && e.name === 'RangeError';
			}
		}
		: function isArrayBuffer(obj) { // eslint-disable-line no-unused-vars
			return false;
		};


/***/ }),

/***/ 84155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasBigInts = __webpack_require__(17155)();

if (hasBigInts) {
	var bigIntValueOf = BigInt.prototype.valueOf;
	var tryBigInt = function tryBigIntObject(value) {
		try {
			bigIntValueOf.call(value);
			return true;
		} catch (e) {
		}
		return false;
	};

	module.exports = function isBigInt(value) {
		if (
			value === null
			|| typeof value === 'undefined'
			|| typeof value === 'boolean'
			|| typeof value === 'string'
			|| typeof value === 'number'
			|| typeof value === 'symbol'
			|| typeof value === 'function'
		) {
			return false;
		}
		if (typeof value === 'bigint') {
			return true;
		}

		return tryBigInt(value);
	};
} else {
	module.exports = function isBigInt(value) {
		return  false && 0;
	};
}


/***/ }),

/***/ 4836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');

var tryBooleanObject = function booleanBrandCheck(value) {
	try {
		$boolToStr(value);
		return true;
	} catch (e) {
		return false;
	}
};
var boolClass = '[object Boolean]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isBoolean(value) {
	if (typeof value === 'boolean') {
		return true;
	}
	if (value === null || typeof value !== 'object') {
		return false;
	}
	return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};


/***/ }),

/***/ 43765:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ 464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),

/***/ 81859:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Map) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x);
		if ($setHas) {
			try {
				$setHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Map; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 28038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
	try {
		numToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isNumberObject(value) {
	if (typeof value === 'number') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
};


/***/ }),

/***/ 67584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);
var hasToStringTag = __webpack_require__(76686)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),

/***/ 96109:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Set) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas.call(x);
		if ($mapHas) {
			try {
				$mapHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Set; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 25178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);

var $byteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);

module.exports = $byteLength
	? function isSharedArrayBuffer(obj) {
		if (!obj || typeof obj !== 'object') {
			return false;
		}
		try {
			$byteLength(obj);
			return true;
		} catch (e) {
			return false;
		}
	}
	: function isSharedArrayBuffer(obj) { // eslint-disable-line no-unused-vars
		return false;
	};


/***/ }),

/***/ 91770:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),

/***/ 44582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(10465)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return  false && 0;
	};
}


/***/ }),

/***/ 36421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var whichTypedArray = __webpack_require__(49154);

module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};


/***/ }),

/***/ 36959:
/***/ (function(module) {

"use strict";


var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;

var exported;

if (!$WeakMap) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` is not present in this environment.
		return false;
	};
}

var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isWeakMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x, $mapHas);
		if ($setHas) {
			try {
				$setHas.call(x, $setHas);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $WeakMap; // core-js workaround, pre-v3
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 92683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var callBound = __webpack_require__(47737);

var $WeakSet = GetIntrinsic('%WeakSet%', true);

var $setHas = callBound('WeakSet.prototype.has', true);

if ($setHas) {
	var $mapHas = callBound('WeakMap.prototype.has', true);

	module.exports = function isWeakSet(x) {
		if (!x || typeof x !== 'object') {
			return false;
		}
		try {
			$setHas(x, $setHas);
			if ($mapHas) {
				try {
					$mapHas(x, $mapHas);
				} catch (e) {
					return true;
				}
			}
			return x instanceof $WeakSet; // core-js workaround, pre-v3
		} catch (e) {}
		return false;
	};
} else {
	// eslint-disable-next-line no-unused-vars
	module.exports = function isWeakSet(x) {
		// `WeakSet` does not exist, or does not have a `has` method
		return false;
	};
}


/***/ }),

/***/ 17971:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/**
 * @description A module for parsing ISO8601 durations
 */

/**
 * The pattern used for parsing ISO8601 duration (PnYnMnDTnHnMnS).
 * This does not cover the week format PnW.
 */

// PnYnMnDTnHnMnS
var numbers = '\\d+(?:[\\.,]\\d+)?';
var weekPattern = '(' + numbers + 'W)';
var datePattern = '(' + numbers + 'Y)?(' + numbers + 'M)?(' + numbers + 'D)?';
var timePattern = 'T(' + numbers + 'H)?(' + numbers + 'M)?(' + numbers + 'S)?';

var iso8601 = 'P(?:' + weekPattern + '|' + datePattern + '(?:' + timePattern + ')?)';
var objMap = ['weeks', 'years', 'months', 'days', 'hours', 'minutes', 'seconds'];

/**
 * The ISO8601 regex for matching / testing durations
 */
var pattern = exports.pattern = new RegExp(iso8601);

/** Parse PnYnMnDTnHnMnS format to object
 * @param {string} durationString - PnYnMnDTnHnMnS formatted string
 * @return {Object} - With a property for each part of the pattern
 */
var parse = exports.parse = function parse(durationString) {
  // Slice away first entry in match-array
  return durationString.match(pattern).slice(1).reduce(function (prev, next, idx) {
    prev[objMap[idx]] = parseFloat(next) || 0;
    return prev;
  }, {});
};

/**
 * Convert ISO8601 duration object to an end Date.
 *
 * @param {Object} duration - The duration object
 * @param {Date} startDate - The starting Date for calculating the duration
 * @return {Date} - The resulting end Date
 */
var end = exports.end = function end(duration, startDate) {
  // Create two equal timestamps, add duration to 'then' and return time difference
  var timestamp = startDate ? startDate.getTime() : Date.now();
  var then = new Date(timestamp);

  then.setFullYear(then.getFullYear() + duration.years);
  then.setMonth(then.getMonth() + duration.months);
  then.setDate(then.getDate() + duration.days);
  then.setHours(then.getHours() + duration.hours);
  then.setMinutes(then.getMinutes() + duration.minutes);
  // Then.setSeconds(then.getSeconds() + duration.seconds);
  then.setMilliseconds(then.getMilliseconds() + duration.seconds * 1000);
  // Special case weeks
  then.setDate(then.getDate() + duration.weeks * 7);

  return then;
};

/**
 * Convert ISO8601 duration object to seconds
 *
 * @param {Object} duration - The duration object
 * @param {Date} startDate - The starting point for calculating the duration
 * @return {Number}
 */
var toSeconds = exports.toSeconds = function toSeconds(duration, startDate) {
  var timestamp = startDate ? startDate.getTime() : Date.now();
  var now = new Date(timestamp);
  var then = end(duration, now);

  var seconds = (then.getTime() - now.getTime()) / 1000;
  return seconds;
};

exports["default"] = {
  end: end,
  toSeconds: toSeconds,
  pattern: pattern,
  parse: parse
};

/***/ }),

/***/ 34805:
/***/ (function(module) {

module.exports = window.FormData


/***/ }),

/***/ 47683:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_563__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_563__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_563__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_563__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__nested_webpack_require_563__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_563__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_563__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_563__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_563__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_563__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_563__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_563__(__nested_webpack_require_563__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(target, sources) {
  var n, source, key;
  for(n = 1 ; n < arguments.length ; n++) {
    source = arguments[n];
    for(key in source) {
      if (source.hasOwnProperty(key))
        target[key] = source[key];
    }
  }
  return target;
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __nested_webpack_require_3360__) {

"use strict";


//-------------------------------------------------------------------------------------------------

var mixin = __nested_webpack_require_3360__(0);

//-------------------------------------------------------------------------------------------------

module.exports = {

  build: function(target, config) {
    var n, max, plugin, plugins = config.plugins;
    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n];
      if (plugin.methods)
        mixin(target, plugin.methods);
      if (plugin.properties)
        Object.defineProperties(target, plugin.properties);
    }
  },

  hook: function(fsm, name, additional) {
    var n, max, method, plugin,
        plugins = fsm.config.plugins,
        args    = [fsm.context];

    if (additional)
      args = args.concat(additional)

    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n]
      method = plugins[n][name]
      if (method)
        method.apply(plugin, args);
    }
  }

}

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------------------------------

function camelize(label) {

  if (label.length === 0)
    return label;

  var n, result, word, words = label.split(/[_-]/);

  // single word with first character already lowercase, return untouched
  if ((words.length === 1) && (words[0][0].toLowerCase() === words[0][0]))
    return label;

  result = words[0].toLowerCase();
  for(n = 1 ; n < words.length ; n++) {
    result = result + words[n].charAt(0).toUpperCase() + words[n].substring(1).toLowerCase();
  }

  return result;
}

//-------------------------------------------------------------------------------------------------

camelize.prepended = function(prepend, label) {
  label = camelize(label);
  return prepend + label[0].toUpperCase() + label.substring(1);
}

//-------------------------------------------------------------------------------------------------

module.exports = camelize;


/***/ }),
/* 3 */
/***/ (function(module, exports, __nested_webpack_require_5584__) {

"use strict";


//-------------------------------------------------------------------------------------------------

var mixin    = __nested_webpack_require_5584__(0),
    camelize = __nested_webpack_require_5584__(2);

//-------------------------------------------------------------------------------------------------

function Config(options, StateMachine) {

  options = options || {};

  this.options     = options; // preserving original options can be useful (e.g visualize plugin)
  this.defaults    = StateMachine.defaults;
  this.states      = [];
  this.transitions = [];
  this.map         = {};
  this.lifecycle   = this.configureLifecycle();
  this.init        = this.configureInitTransition(options.init);
  this.data        = this.configureData(options.data);
  this.methods     = this.configureMethods(options.methods);

  this.map[this.defaults.wildcard] = {};

  this.configureTransitions(options.transitions || []);

  this.plugins = this.configurePlugins(options.plugins, StateMachine.plugin);

}

//-------------------------------------------------------------------------------------------------

mixin(Config.prototype, {

  addState: function(name) {
    if (!this.map[name]) {
      this.states.push(name);
      this.addStateLifecycleNames(name);
      this.map[name] = {};
    }
  },

  addStateLifecycleNames: function(name) {
    this.lifecycle.onEnter[name] = camelize.prepended('onEnter', name);
    this.lifecycle.onLeave[name] = camelize.prepended('onLeave', name);
    this.lifecycle.on[name]      = camelize.prepended('on',      name);
  },

  addTransition: function(name) {
    if (this.transitions.indexOf(name) < 0) {
      this.transitions.push(name);
      this.addTransitionLifecycleNames(name);
    }
  },

  addTransitionLifecycleNames: function(name) {
    this.lifecycle.onBefore[name] = camelize.prepended('onBefore', name);
    this.lifecycle.onAfter[name]  = camelize.prepended('onAfter',  name);
    this.lifecycle.on[name]       = camelize.prepended('on',       name);
  },

  mapTransition: function(transition) {
    var name = transition.name,
        from = transition.from,
        to   = transition.to;
    this.addState(from);
    if (typeof to !== 'function')
      this.addState(to);
    this.addTransition(name);
    this.map[from][name] = transition;
    return transition;
  },

  configureLifecycle: function() {
    return {
      onBefore: { transition: 'onBeforeTransition' },
      onAfter:  { transition: 'onAfterTransition'  },
      onEnter:  { state:      'onEnterState'       },
      onLeave:  { state:      'onLeaveState'       },
      on:       { transition: 'onTransition'       }
    };
  },

  configureInitTransition: function(init) {
    if (typeof init === 'string') {
      return this.mapTransition(mixin({}, this.defaults.init, { to: init, active: true }));
    }
    else if (typeof init === 'object') {
      return this.mapTransition(mixin({}, this.defaults.init, init, { active: true }));
    }
    else {
      this.addState(this.defaults.init.from);
      return this.defaults.init;
    }
  },

  configureData: function(data) {
    if (typeof data === 'function')
      return data;
    else if (typeof data === 'object')
      return function() { return data; }
    else
      return function() { return {};  }
  },

  configureMethods: function(methods) {
    return methods || {};
  },

  configurePlugins: function(plugins, builtin) {
    plugins = plugins || [];
    var n, max, plugin;
    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n];
      if (typeof plugin === 'function')
        plugins[n] = plugin = plugin()
      if (plugin.configure)
        plugin.configure(this);
    }
    return plugins
  },

  configureTransitions: function(transitions) {
    var i, n, transition, from, to, wildcard = this.defaults.wildcard;
    for(n = 0 ; n < transitions.length ; n++) {
      transition = transitions[n];
      from  = Array.isArray(transition.from) ? transition.from : [transition.from || wildcard]
      to    = transition.to || wildcard;
      for(i = 0 ; i < from.length ; i++) {
        this.mapTransition({ name: transition.name, from: from[i], to: to });
      }
    }
  },

  transitionFor: function(state, transition) {
    var wildcard = this.defaults.wildcard;
    return this.map[state][transition] ||
           this.map[wildcard][transition];
  },

  transitionsFor: function(state) {
    var wildcard = this.defaults.wildcard;
    return Object.keys(this.map[state]).concat(Object.keys(this.map[wildcard]));
  },

  allStates: function() {
    return this.states;
  },

  allTransitions: function() {
    return this.transitions;
  }

});

//-------------------------------------------------------------------------------------------------

module.exports = Config;

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 4 */
/***/ (function(module, exports, __nested_webpack_require_10554__) {


var mixin      = __nested_webpack_require_10554__(0),
    Exception  = __nested_webpack_require_10554__(6),
    plugin     = __nested_webpack_require_10554__(1),
    UNOBSERVED = [ null, [] ];

//-------------------------------------------------------------------------------------------------

function JSM(context, config) {
  this.context   = context;
  this.config    = config;
  this.state     = config.init.from;
  this.observers = [context];
}

//-------------------------------------------------------------------------------------------------

mixin(JSM.prototype, {

  init: function(args) {
    mixin(this.context, this.config.data.apply(this.context, args));
    plugin.hook(this, 'init');
    if (this.config.init.active)
      return this.fire(this.config.init.name, []);
  },

  is: function(state) {
    return Array.isArray(state) ? (state.indexOf(this.state) >= 0) : (this.state === state);
  },

  isPending: function() {
    return this.pending;
  },

  can: function(transition) {
    return !this.isPending() && !!this.seek(transition);
  },

  cannot: function(transition) {
    return !this.can(transition);
  },

  allStates: function() {
    return this.config.allStates();
  },

  allTransitions: function() {
    return this.config.allTransitions();
  },

  transitions: function() {
    return this.config.transitionsFor(this.state);
  },

  seek: function(transition, args) {
    var wildcard = this.config.defaults.wildcard,
        entry    = this.config.transitionFor(this.state, transition),
        to       = entry && entry.to;
    if (typeof to === 'function')
      return to.apply(this.context, args);
    else if (to === wildcard)
      return this.state
    else
      return to
  },

  fire: function(transition, args) {
    return this.transit(transition, this.state, this.seek(transition, args), args);
  },

  transit: function(transition, from, to, args) {

    var lifecycle = this.config.lifecycle,
        changed   = this.config.options.observeUnchangedState || (from !== to);

    if (!to)
      return this.context.onInvalidTransition(transition, from, to);

    if (this.isPending())
      return this.context.onPendingTransition(transition, from, to);

    this.config.addState(to);  // might need to add this state if it's unknown (e.g. conditional transition or goto)

    this.beginTransit();

    args.unshift({             // this context will be passed to each lifecycle event observer
      transition: transition,
      from:       from,
      to:         to,
      fsm:        this.context
    });

    return this.observeEvents([
                this.observersForEvent(lifecycle.onBefore.transition),
                this.observersForEvent(lifecycle.onBefore[transition]),
      changed ? this.observersForEvent(lifecycle.onLeave.state) : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onLeave[from]) : UNOBSERVED,
                this.observersForEvent(lifecycle.on.transition),
      changed ? [ 'doTransit', [ this ] ]                       : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onEnter.state) : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onEnter[to])   : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.on[to])        : UNOBSERVED,
                this.observersForEvent(lifecycle.onAfter.transition),
                this.observersForEvent(lifecycle.onAfter[transition]),
                this.observersForEvent(lifecycle.on[transition])
    ], args);
  },

  beginTransit: function()          { this.pending = true;                 },
  endTransit:   function(result)    { this.pending = false; return result; },
  failTransit:  function(result)    { this.pending = false; throw result;  },
  doTransit:    function(lifecycle) { this.state = lifecycle.to;           },

  observe: function(args) {
    if (args.length === 2) {
      var observer = {};
      observer[args[0]] = args[1];
      this.observers.push(observer);
    }
    else {
      this.observers.push(args[0]);
    }
  },

  observersForEvent: function(event) { // TODO: this could be cached
    var n = 0, max = this.observers.length, observer, result = [];
    for( ; n < max ; n++) {
      observer = this.observers[n];
      if (observer[event])
        result.push(observer);
    }
    return [ event, result, true ]
  },

  observeEvents: function(events, args, previousEvent, previousResult) {
    if (events.length === 0) {
      return this.endTransit(previousResult === undefined ? true : previousResult);
    }

    var event     = events[0][0],
        observers = events[0][1],
        pluggable = events[0][2];

    args[0].event = event;
    if (event && pluggable && event !== previousEvent)
      plugin.hook(this, 'lifecycle', args);

    if (observers.length === 0) {
      events.shift();
      return this.observeEvents(events, args, event, previousResult);
    }
    else {
      var observer = observers.shift(),
          result = observer[event].apply(observer, args);
      if (result && typeof result.then === 'function') {
        return result.then(this.observeEvents.bind(this, events, args, event))
                     .catch(this.failTransit.bind(this))
      }
      else if (result === false) {
        return this.endTransit(false);
      }
      else {
        return this.observeEvents(events, args, event, result);
      }
    }
  },

  onInvalidTransition: function(transition, from, to) {
    throw new Exception("transition is invalid in current state", transition, from, to, this.state);
  },

  onPendingTransition: function(transition, from, to) {
    throw new Exception("transition is invalid while previous transition is still in progress", transition, from, to, this.state);
  }

});

//-------------------------------------------------------------------------------------------------

module.exports = JSM;

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 5 */
/***/ (function(module, exports, __nested_webpack_require_16556__) {

"use strict";


//-----------------------------------------------------------------------------------------------

var mixin    = __nested_webpack_require_16556__(0),
    camelize = __nested_webpack_require_16556__(2),
    plugin   = __nested_webpack_require_16556__(1),
    Config   = __nested_webpack_require_16556__(3),
    JSM      = __nested_webpack_require_16556__(4);

//-----------------------------------------------------------------------------------------------

var PublicMethods = {
  is:                  function(state)       { return this._fsm.is(state)                                     },
  can:                 function(transition)  { return this._fsm.can(transition)                               },
  cannot:              function(transition)  { return this._fsm.cannot(transition)                            },
  observe:             function()            { return this._fsm.observe(arguments)                            },
  transitions:         function()            { return this._fsm.transitions()                                 },
  allTransitions:      function()            { return this._fsm.allTransitions()                              },
  allStates:           function()            { return this._fsm.allStates()                                   },
  onInvalidTransition: function(t, from, to) { return this._fsm.onInvalidTransition(t, from, to)              },
  onPendingTransition: function(t, from, to) { return this._fsm.onPendingTransition(t, from, to)              },
}

var PublicProperties = {
  state: {
    configurable: false,
    enumerable:   true,
    get: function() {
      return this._fsm.state;
    },
    set: function(state) {
      throw Error('use transitions to change state')
    }
  }
}

//-----------------------------------------------------------------------------------------------

function StateMachine(options) {
  return apply(this || {}, options);
}

function factory() {
  var cstor, options;
  if (typeof arguments[0] === 'function') {
    cstor   = arguments[0];
    options = arguments[1] || {};
  }
  else {
    cstor   = function() { this._fsm.apply(this, arguments) };
    options = arguments[0] || {};
  }
  var config = new Config(options, StateMachine);
  build(cstor.prototype, config);
  cstor.prototype._fsm.config = config; // convenience access to shared config without needing an instance
  return cstor;
}

//-------------------------------------------------------------------------------------------------

function apply(instance, options) {
  var config = new Config(options, StateMachine);
  build(instance, config);
  instance._fsm();
  return instance;
}

function build(target, config) {
  if ((typeof target !== 'object') || Array.isArray(target))
    throw Error('StateMachine can only be applied to objects');
  plugin.build(target, config);
  Object.defineProperties(target, PublicProperties);
  mixin(target, PublicMethods);
  mixin(target, config.methods);
  config.allTransitions().forEach(function(transition) {
    target[camelize(transition)] = function() {
      return this._fsm.fire(transition, [].slice.call(arguments))
    }
  });
  target._fsm = function() {
    this._fsm = new JSM(this, config);
    this._fsm.init(arguments);
  }
}

//-----------------------------------------------------------------------------------------------

StateMachine.version  = '3.0.1';
StateMachine.factory  = factory;
StateMachine.apply    = apply;
StateMachine.defaults = {
  wildcard: '*',
  init: {
    name: 'init',
    from: 'none'
  }
}

//===============================================================================================

module.exports = StateMachine;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(message, transition, from, to, current) {
  this.message    = message;
  this.transition = transition;
  this.from       = from;
  this.to         = to;
  this.current    = current;
}


/***/ })
/******/ ]);
});

/***/ }),

/***/ 41699:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
/**
 * Adds zeroes to the left of a number until its final length is `targetLength`.
 *
 * If `targetLength` is 0, returns an empty string. If `targetLength` is smaller
 * than `num`'s existing length, returns `num` unchanged.
 *
 * @param num The number to pad
 * @param targetLength The final desired number of digits
 */
const padWithLeadingZeroes = (num, targetLength) => {
    if (targetLength < 0) {
        throw new RangeError(`Error: cannot pad "${num}" with ${targetLength} zeroes. argument size must be non-negative.`);
    }
    if (targetLength === 0) {
        return '';
    }
    let s = String(num);
    if (s.length >= targetLength) {
        return s;
    }
    return padWithLeadingZeroes(`0${s}`, targetLength); // TCO-compatible
};
__webpack_unused_export__ = padWithLeadingZeroes;


/***/ }),

/***/ 68652:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;


/***/ }),

/***/ 65549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 54613:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(38145),
    hashDelete = __webpack_require__(69096),
    hashGet = __webpack_require__(65239),
    hashHas = __webpack_require__(78228),
    hashSet = __webpack_require__(95920);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 70131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(17168),
    listCacheDelete = __webpack_require__(66582),
    listCacheGet = __webpack_require__(13867),
    listCacheHas = __webpack_require__(59557),
    listCacheSet = __webpack_require__(22726);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 64438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 90278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(67076),
    mapCacheDelete = __webpack_require__(2530),
    mapCacheGet = __webpack_require__(44858),
    mapCacheHas = __webpack_require__(96265),
    mapCacheSet = __webpack_require__(59909);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 87076:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 69902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 4281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(70131),
    stackClear = __webpack_require__(30560),
    stackDelete = __webpack_require__(58282),
    stackGet = __webpack_require__(46638),
    stackHas = __webpack_require__(57930),
    stackSet = __webpack_require__(3229);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 54690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(70441);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 5982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(70441);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 18965:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 85198:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 26758:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 69037:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 16222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(55092),
    isArguments = __webpack_require__(86981),
    isArray = __webpack_require__(77236),
    isBuffer = __webpack_require__(98752),
    isIndex = __webpack_require__(74363),
    isTypedArray = __webpack_require__(14812);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 63848:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 47596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(40999),
    eq = __webpack_require__(26530);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 3833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(26530);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 5615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(96051),
    keys = __webpack_require__(52635);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 3238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(96051),
    keysIn = __webpack_require__(5850);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 40999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(9346);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 42327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(4281),
    arrayEach = __webpack_require__(26758),
    assignValue = __webpack_require__(47596),
    baseAssign = __webpack_require__(5615),
    baseAssignIn = __webpack_require__(3238),
    cloneBuffer = __webpack_require__(78172),
    copyArray = __webpack_require__(66438),
    copySymbols = __webpack_require__(23746),
    copySymbolsIn = __webpack_require__(93989),
    getAllKeys = __webpack_require__(36094),
    getAllKeysIn = __webpack_require__(15559),
    getTag = __webpack_require__(26686),
    initCloneArray = __webpack_require__(26019),
    initCloneByTag = __webpack_require__(27621),
    initCloneObject = __webpack_require__(73905),
    isArray = __webpack_require__(77236),
    isBuffer = __webpack_require__(98752),
    isMap = __webpack_require__(69656),
    isObject = __webpack_require__(85973),
    isSet = __webpack_require__(66925),
    keys = __webpack_require__(52635),
    keysIn = __webpack_require__(5850);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 67372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(85973);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 39329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(63848),
    isArray = __webpack_require__(77236);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 94318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690),
    getRawTag = __webpack_require__(47077),
    objectToString = __webpack_require__(61954);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 58520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 4368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(26686),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 62987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(93839),
    isMasked = __webpack_require__(47275),
    isObject = __webpack_require__(85973),
    toSource = __webpack_require__(76822);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 4642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(26686),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 73749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isLength = __webpack_require__(99216),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 78803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(65003),
    nativeKeys = __webpack_require__(41466);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 32578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(85973),
    isPrototype = __webpack_require__(65003),
    nativeKeysIn = __webpack_require__(14904);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 94569:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(15362),
    overRest = __webpack_require__(94468),
    setToString = __webpack_require__(98756);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 81676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(88211),
    defineProperty = __webpack_require__(9346),
    identity = __webpack_require__(15362);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 55092:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 63349:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(5720);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 76535:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 13632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(5982);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 78172:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(70441);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 39841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(13632);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 62769:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 49130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 22215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(13632);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 66438:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 96051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(47596),
    baseAssignValue = __webpack_require__(40999);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 23746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(96051),
    getSymbols = __webpack_require__(75904);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 93989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(96051),
    getSymbolsIn = __webpack_require__(12511);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 38507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(70441);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 32544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(94569),
    isIterateeCall = __webpack_require__(63108);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 9346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 34414:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 36094:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(39329),
    getSymbols = __webpack_require__(75904),
    keys = __webpack_require__(52635);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 15559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(39329),
    getSymbolsIn = __webpack_require__(12511),
    keysIn = __webpack_require__(5850);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 72907:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(87620);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 84457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(62987),
    getValue = __webpack_require__(79741);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 71407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(53717);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 47077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 75904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(69037),
    stubArray = __webpack_require__(27471);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 12511:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(63848),
    getPrototype = __webpack_require__(71407),
    getSymbols = __webpack_require__(75904),
    stubArray = __webpack_require__(27471);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 26686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(65549),
    Map = __webpack_require__(64438),
    Promise = __webpack_require__(87076),
    Set = __webpack_require__(69902),
    WeakMap = __webpack_require__(18965),
    baseGetTag = __webpack_require__(94318),
    toSource = __webpack_require__(76822);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 79741:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 38145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 69096:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 65239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 78228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 95920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 26019:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 27621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(13632),
    cloneDataView = __webpack_require__(39841),
    cloneRegExp = __webpack_require__(62769),
    cloneSymbol = __webpack_require__(49130),
    cloneTypedArray = __webpack_require__(22215);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 73905:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(67372),
    getPrototype = __webpack_require__(71407),
    isPrototype = __webpack_require__(65003);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 74363:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 63108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(26530),
    isArrayLike = __webpack_require__(81580),
    isIndex = __webpack_require__(74363),
    isObject = __webpack_require__(85973);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 87620:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 47275:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(38507);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 65003:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 17168:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 66582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 13867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 59557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 22726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 67076:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(54613),
    ListCache = __webpack_require__(70131),
    Map = __webpack_require__(64438);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 2530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 44858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 96265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 59909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 75148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 41466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(53717);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 14904:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 91782:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(34414);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 61954:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 53717:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 94468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(85198);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 70441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(34414);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 98756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(81676),
    shortOut = __webpack_require__(79116);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 79116:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 30560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(70131);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 58282:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 46638:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 57930:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 3229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(70131),
    Map = __webpack_require__(64438),
    MapCache = __webpack_require__(90278);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 76822:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 5720:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 36782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(47596),
    copyObject = __webpack_require__(96051),
    createAssigner = __webpack_require__(32544),
    isArrayLike = __webpack_require__(81580),
    isPrototype = __webpack_require__(65003),
    keys = __webpack_require__(52635);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ 37032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(42327);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ 88211:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 45750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(85973),
    now = __webpack_require__(28148),
    toNumber = __webpack_require__(78746);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 26530:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 15362:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 86981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(58520),
    isObjectLike = __webpack_require__(3387);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 77236:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 81580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(93839),
    isLength = __webpack_require__(99216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 98752:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(70441),
    stubFalse = __webpack_require__(7149);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 93839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isObject = __webpack_require__(85973);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 99216:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 69656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(4368),
    baseUnary = __webpack_require__(76535),
    nodeUtil = __webpack_require__(91782);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 85973:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 3387:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 66925:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(4642),
    baseUnary = __webpack_require__(76535),
    nodeUtil = __webpack_require__(91782);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 22945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 14812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(73749),
    baseUnary = __webpack_require__(76535),
    nodeUtil = __webpack_require__(91782);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 52635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(16222),
    baseKeys = __webpack_require__(78803),
    isArrayLike = __webpack_require__(81580);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 5850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(16222),
    baseKeysIn = __webpack_require__(32578),
    isArrayLike = __webpack_require__(81580);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 13581:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 28148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(70441);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 27471:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 7149:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 33259:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(45750),
    isObject = __webpack_require__(85973);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 78746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(63349),
    isObject = __webpack_require__(85973),
    isSymbol = __webpack_require__(22945);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 33108:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
        /Trident\/|MSIE /.test(window.navigator.userAgent)
    );

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) {
                console.log.apply(console, arguments);
            } else {
                // In old IE, native console methods themselves don't have apply().
                Function.prototype.apply.apply(console.log, [console, arguments]);
            }
        }
        if (console.trace) console.trace();
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (methodName === 'trace' && isIE) {
            return traceForIE;
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;

      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = undefined;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType || !storageKey) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType || !storageKey) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      function clearPersistedLevel() {
          if (typeof window === undefinedType || !storageKey) return;

          // Use localStorage if available
          try {
              window.localStorage.removeItem(storageKey);
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch (ignore) {}
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          defaultLevel = level;
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.resetLevel = function () {
          self.setLevel(defaultLevel, false);
          clearPersistedLevel();
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    // ES6 default export, for compatibility
    defaultLogger['default'] = defaultLogger;

    return defaultLogger;
}));


/***/ }),

/***/ 26499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = (function() {

// private property
var f = String.fromCharCode;
var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
var baseReverseDic = {};

function getBaseValue(alphabet, character) {
  if (!baseReverseDic[alphabet]) {
    baseReverseDic[alphabet] = {};
    for (var i=0 ; i<alphabet.length ; i++) {
      baseReverseDic[alphabet][alphabet.charAt(i)] = i;
    }
  }
  return baseReverseDic[alphabet][character];
}

var LZString = {
  compressToBase64 : function (input) {
    if (input == null) return "";
    var res = LZString._compress(input, 6, function(a){return keyStrBase64.charAt(a);});
    switch (res.length % 4) { // To produce valid Base64
    default: // When could this happen ?
    case 0 : return res;
    case 1 : return res+"===";
    case 2 : return res+"==";
    case 3 : return res+"=";
    }
  },

  decompressFromBase64 : function (input) {
    if (input == null) return "";
    if (input == "") return null;
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrBase64, input.charAt(index)); });
  },

  compressToUTF16 : function (input) {
    if (input == null) return "";
    return LZString._compress(input, 15, function(a){return f(a+32);}) + " ";
  },

  decompressFromUTF16: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 16384, function(index) { return compressed.charCodeAt(index) - 32; });
  },

  //compress into uint8array (UCS-2 big endian format)
  compressToUint8Array: function (uncompressed) {
    var compressed = LZString.compress(uncompressed);
    var buf=new Uint8Array(compressed.length*2); // 2 bytes per character

    for (var i=0, TotalLen=compressed.length; i<TotalLen; i++) {
      var current_value = compressed.charCodeAt(i);
      buf[i*2] = current_value >>> 8;
      buf[i*2+1] = current_value % 256;
    }
    return buf;
  },

  //decompress from uint8array (UCS-2 big endian format)
  decompressFromUint8Array:function (compressed) {
    if (compressed===null || compressed===undefined){
        return LZString.decompress(compressed);
    } else {
        var buf=new Array(compressed.length/2); // 2 bytes per character
        for (var i=0, TotalLen=buf.length; i<TotalLen; i++) {
          buf[i]=compressed[i*2]*256+compressed[i*2+1];
        }

        var result = [];
        buf.forEach(function (c) {
          result.push(f(c));
        });
        return LZString.decompress(result.join(''));

    }

  },


  //compress into a string that is already URI encoded
  compressToEncodedURIComponent: function (input) {
    if (input == null) return "";
    return LZString._compress(input, 6, function(a){return keyStrUriSafe.charAt(a);});
  },

  //decompress from an output of compressToEncodedURIComponent
  decompressFromEncodedURIComponent:function (input) {
    if (input == null) return "";
    if (input == "") return null;
    input = input.replace(/ /g, "+");
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrUriSafe, input.charAt(index)); });
  },

  compress: function (uncompressed) {
    return LZString._compress(uncompressed, 16, function(a){return f(a);});
  },
  _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) return "";
    var i, value,
        context_dictionary= {},
        context_dictionaryToCreate= {},
        context_c="",
        context_wc="",
        context_w="",
        context_enlargeIn= 2, // Compensate for the first entry which should not count
        context_dictSize= 3,
        context_numBits= 2,
        context_data=[],
        context_data_val=0,
        context_data_position=0,
        ii;

    for (ii = 0; ii < uncompressed.length; ii += 1) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary,context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }

      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary,context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
          if (context_w.charCodeAt(0)<256) {
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<8 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          } else {
            value = 1;
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1) | value;
              if (context_data_position ==bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = 0;
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<16 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }


        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        // Add wc to the dictionary.
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }

    // Output the code for w.
    if (context_w !== "") {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
        if (context_w.charCodeAt(0)<256) {
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<8 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        } else {
          value = 1;
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | value;
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = 0;
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<16 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i=0 ; i<context_numBits ; i++) {
          context_data_val = (context_data_val << 1) | (value&1);
          if (context_data_position == bitsPerChar-1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }


      }
      context_enlargeIn--;
      if (context_enlargeIn == 0) {
        context_enlargeIn = Math.pow(2, context_numBits);
        context_numBits++;
      }
    }

    // Mark the end of the stream
    value = 2;
    for (i=0 ; i<context_numBits ; i++) {
      context_data_val = (context_data_val << 1) | (value&1);
      if (context_data_position == bitsPerChar-1) {
        context_data_position = 0;
        context_data.push(getCharFromInt(context_data_val));
        context_data_val = 0;
      } else {
        context_data_position++;
      }
      value = value >> 1;
    }

    // Flush the last char
    while (true) {
      context_data_val = (context_data_val << 1);
      if (context_data_position == bitsPerChar-1) {
        context_data.push(getCharFromInt(context_data_val));
        break;
      }
      else context_data_position++;
    }
    return context_data.join('');
  },

  decompress: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 32768, function(index) { return compressed.charCodeAt(index); });
  },

  _decompress: function (length, resetValue, getNextValue) {
    var dictionary = [],
        next,
        enlargeIn = 4,
        dictSize = 4,
        numBits = 3,
        entry = "",
        result = [],
        i,
        w,
        bits, resb, maxpower, power,
        c,
        data = {val:getNextValue(0), position:resetValue, index:1};

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxpower = Math.pow(2,2);
    power=1;
    while (power!=maxpower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position == 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb>0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 2:
        return "";
    }
    dictionary[3] = c;
    w = c;
    result.push(c);
    while (true) {
      if (data.index > length) {
        return "";
      }

      bits = 0;
      maxpower = Math.pow(2,numBits);
      power=1;
      while (power!=maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position == 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb>0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }

          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 2:
          return result.join('');
      }

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else {
        if (c === dictSize) {
          entry = w + w.charAt(0);
        } else {
          return null;
        }
      }
      result.push(entry);

      // Add w+entry[0] to the dictionary.
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;

      w = entry;

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

    }
  }
};
  return LZString;
})();

if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return LZString; }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}


/***/ }),

/***/ 42898:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
function g() {
    return assign;
}
Object.defineProperties(g(), {
    implementation: {
        get: g
    },
    shim: {
        value: g
    },
    getPolyfill: {
        value: g
    }
});
module.exports = g();

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29470:
/***/ (function(module) {

"use strict";

module.exports = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _onlyFirst = ref.onlyFirst, onlyFirst = _onlyFirst === void 0 ? false : _onlyFirst;
    var pattern = [
        "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
        "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
    ].join("|");
    return new RegExp(pattern, onlyFirst ? undefined : "g");
};


/***/ }),

/***/ 46582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73083)


/***/ }),

/***/ 38502:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 10884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(26506);
var callBind = __webpack_require__(73235);

var implementation = __webpack_require__(38502);
var getPolyfill = __webpack_require__(35453);
var shim = __webpack_require__(59789);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 35453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(38502);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 59789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(35453);
var define = __webpack_require__(26506);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 69113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(38441); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 13438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(38441);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(69113);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 38441:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 62930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(13158);
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map


/***/ }),

/***/ 89916:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes["object"] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof __webpack_require__.g == 'object' && __webpack_require__.g;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Electron',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': '(?:Edge|Edg|EdgA|EdgiOS)' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'Vivaldi',
      'Waterfox',
      'WebPositive',
      { 'label': 'Yandex Browser', 'pattern': 'YaBrowser' },
      { 'label': 'UC Browser', 'pattern': 'UCBrowser' },
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chromium',
      'Chrome',
      { 'label': 'Chrome', 'pattern': '(?:HeadlessChrome)' },
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation Vita',
      'PlayStation',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Alcatel': {},
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'Huawei': {},
      'Lenovo': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Oppo': {},
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 },
      'Xiaomi': { 'Mi': 1, 'Redmi': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'KaiOS',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      { 'label': 'DragonFly BSD', 'pattern': 'DragonFly' },
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Tizen',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect Android products.
    // Browsers on Android devices typically provide their product IDS after "Android;"
    // up to "Build" or ") AppleWebKit".
    // Example:
    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
    if (/\bAndroid\b/.test(os) && !product &&
        (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
      product = trim(data[1])
        // Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '')
        || null;
    }
    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    } else if (manufacturer && product) {
      product = product
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ')
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect UC Browser speed mode.
    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
      description.push('speed mode');
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Add Chrome version to description for Electron.
    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
      description.push('Chromium ' + data);
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11 identifying as other browsers.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (rhino) {
          try {
            version = context.require('ringo/engine').version.join('.');
            name = 'RingoJS';
          } catch(e) {
            if ((data = context.system) && data.global.system == context.system) {
              name = 'Narwhal';
              os || (os = data[0].os || null);
            }
          }
          if (!name) {
            name = 'Rhino';
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          if (typeof data.versions == 'object') {
            if (typeof data.versions.electron == 'string') {
              description.push('Node ' + data.versions.node);
              name = 'Electron';
              version = data.versions.electron;
            } else if (typeof data.versions.nw == 'string') {
              description.push('Chromium ' + version, 'Node ' + data.versions.node);
              name = 'NW.js';
              version = data.versions.nw;
            }
          }
          if (!name) {
            name = 'Node.js';
            arch = data.arch;
            os = data.platform;
            version = /[\d.]+/.exec(data.version);
            version = version ? version[0] : null;
          }
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      // Detect IE 11 masking as other browsers.
      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
        description.push('masking as ' + name + ' ' + version);
        name = 'IE';
        version = '11.0';
        layout = ['Trident'];
        os = 'Windows';
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      if (product == 'Xbox 360') {
        os = null;
      }
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures) {
      try {
        if (context.external === null) {
          description.unshift('platform preview');
        }
      } catch(e) {
        description.unshift('embedded');
      }
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
        description.unshift('headless');
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
    else if (/\bSRWare Iron\b/.test(name) && !version) {
      version = getVersion('Chrome');
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Ensure OS does not include the browser name.
    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (true) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return platform;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else {}
}.call(this));


/***/ }),

/***/ 48729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var now = __webpack_require__(62930)
  , root = typeof window === 'undefined' ? __webpack_require__.g : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ 43064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);
/** @license React v16.14.0
 * react-dom-test-utils.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var g=__webpack_require__(81412),k=__webpack_require__(32735),m=__webpack_require__(88872),n=__webpack_require__(89489);function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var q=k.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
q.hasOwnProperty("ReactCurrentDispatcher")||(q.ReactCurrentDispatcher={current:null});q.hasOwnProperty("ReactCurrentBatchConfig")||(q.ReactCurrentBatchConfig={suspense:null});function r(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function t(a){if(r(a)!==a)throw Error(p(188));}
function u(a){var b=a.alternate;if(!b){b=r(a);if(null===b)throw Error(p(188));return b!==a?null:a}for(var c=a,e=b;;){var d=c.return;if(null===d)break;var f=d.alternate;if(null===f){e=d.return;if(null!==e){c=e;continue}break}if(d.child===f.child){for(f=d.child;f;){if(f===c)return t(d),a;if(f===e)return t(d),b;f=f.sibling}throw Error(p(188));}if(c.return!==e.return)c=d,e=f;else{for(var h=!1,l=d.child;l;){if(l===c){h=!0;c=d;e=f;break}if(l===e){h=!0;e=d;c=f;break}l=l.sibling}if(!h){for(l=f.child;l;){if(l===
c){h=!0;c=f;e=d;break}if(l===e){h=!0;e=f;c=d;break}l=l.sibling}if(!h)throw Error(p(189));}}if(c.alternate!==e)throw Error(p(190));}if(3!==c.tag)throw Error(p(188));return c.stateNode.current===c?a:b}function v(){return!0}function w(){return!1}
function x(a,b,c,e){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var d in a)a.hasOwnProperty(d)&&((b=a[d])?this[d]=b(c):"target"===d?this.target=e:this[d]=c[d]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v:w;this.isPropagationStopped=w;return this}
g(x.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v)},persist:function(){this.isPersistent=v},isPersistent:w,destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=
null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=w;this._dispatchInstances=this._dispatchListeners=null}});x.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
x.extend=function(a){function b(){}function c(){return e.apply(this,arguments)}var e=this;b.prototype=e.prototype;var d=new b;g(d,c.prototype);c.prototype=d;c.prototype.constructor=c;c.Interface=g({},e.Interface,a);c.extend=e.extend;y(c);return c};y(x);function z(a,b,c,e){if(this.eventPool.length){var d=this.eventPool.pop();this.call(d,a,b,c,e);return d}return new this(a,b,c,e)}
function A(a){if(!(a instanceof this))throw Error(p(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function y(a){a.eventPool=[];a.getPooled=z;a.release=A}var B=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);function C(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}
var D={animationend:C("Animation","AnimationEnd"),animationiteration:C("Animation","AnimationIteration"),animationstart:C("Animation","AnimationStart"),transitionend:C("Transition","TransitionEnd")},E={},F={};B&&(F=document.createElement("div").style,"AnimationEvent"in window||(delete D.animationend.animation,delete D.animationiteration.animation,delete D.animationstart.animation),"TransitionEvent"in window||delete D.transitionend.transition);
function G(a){if(E[a])return E[a];if(!D[a])return a;var b=D[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in F)return E[a]=b[c];return a}var H=G("animationend"),I=G("animationiteration"),J=G("animationstart"),aa=G("transitionend"),K=null;function ba(a){if(null===K)try{var b=("require"+Math.random()).slice(0,7);K=(module&&module[b])("timers").setImmediate}catch(c){K=function(a){var b=new MessageChannel;b.port1.onmessage=a;b.port2.postMessage(void 0)}}return K(a)}
var L=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events,ca=L[11],M=L[12],da=m.unstable_batchedUpdates,N=q.IsSomeRendererActing,O="function"===typeof n.unstable_flushAllWithoutAsserting,P=n.unstable_flushAllWithoutAsserting||function(){for(var a=!1;ca();)a=!0;return a};function Q(a){try{P(),ba(function(){P()?Q(a):a()})}catch(b){a(b)}}var R=0,S=!1,ea=m.findDOMNode,T=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events,fa=T[0],U=T[4],ha=T[5],ia=T[6],ja=T[7],ka=T[8],V=T[9],la=T[10];
function W(){}function ma(a,b){if(!a)return[];a=u(a);if(!a)return[];for(var c=a,e=[];;){if(5===c.tag||6===c.tag||1===c.tag||0===c.tag){var d=c.stateNode;b(d)&&e.push(d)}if(c.child)c.child.return=c,c=c.child;else{if(c===a)return e;for(;!c.sibling;){if(!c.return||c.return===a)return e;c=c.return}c.sibling.return=c.return;c=c.sibling}}}
function X(a,b){if(a&&!a._reactInternalFiber){var c=""+a;a=Array.isArray(a)?"an array":a&&1===a.nodeType&&a.tagName?"a DOM node":"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c;throw Error(p(286,b,a));}}
var Y={renderIntoDocument:function(a){var b=document.createElement("div");return m.render(a,b)},isElement:function(a){return k.isValidElement(a)},isElementOfType:function(a,b){return k.isValidElement(a)&&a.type===b},isDOMComponent:function(a){return!(!a||1!==a.nodeType||!a.tagName)},isDOMComponentElement:function(a){return!!(a&&k.isValidElement(a)&&a.tagName)},isCompositeComponent:function(a){return Y.isDOMComponent(a)?!1:null!=a&&"function"===typeof a.render&&"function"===typeof a.setState},isCompositeComponentWithType:function(a,
b){return Y.isCompositeComponent(a)?a._reactInternalFiber.type===b:!1},findAllInRenderedTree:function(a,b){X(a,"findAllInRenderedTree");return a?ma(a._reactInternalFiber,b):[]},scryRenderedDOMComponentsWithClass:function(a,b){X(a,"scryRenderedDOMComponentsWithClass");return Y.findAllInRenderedTree(a,function(a){if(Y.isDOMComponent(a)){var c=a.className;"string"!==typeof c&&(c=a.getAttribute("class")||"");var d=c.split(/\s+/);if(!Array.isArray(b)){if(void 0===b)throw Error(p(11));b=b.split(/\s+/)}return b.every(function(a){return-1!==
d.indexOf(a)})}return!1})},findRenderedDOMComponentWithClass:function(a,b){X(a,"findRenderedDOMComponentWithClass");a=Y.scryRenderedDOMComponentsWithClass(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+a.length+") for class:"+b);return a[0]},scryRenderedDOMComponentsWithTag:function(a,b){X(a,"scryRenderedDOMComponentsWithTag");return Y.findAllInRenderedTree(a,function(a){return Y.isDOMComponent(a)&&a.tagName.toUpperCase()===b.toUpperCase()})},findRenderedDOMComponentWithTag:function(a,
b){X(a,"findRenderedDOMComponentWithTag");a=Y.scryRenderedDOMComponentsWithTag(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+a.length+") for tag:"+b);return a[0]},scryRenderedComponentsWithType:function(a,b){X(a,"scryRenderedComponentsWithType");return Y.findAllInRenderedTree(a,function(a){return Y.isCompositeComponentWithType(a,b)})},findRenderedComponentWithType:function(a,b){X(a,"findRenderedComponentWithType");a=Y.scryRenderedComponentsWithType(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+
a.length+") for componentType:"+b);return a[0]},mockComponent:function(a,b){b=b||a.mockTagName||"div";a.prototype.render.mockImplementation(function(){return k.createElement(b,null,this.props.children)});return this},nativeTouchData:function(a,b){return{touches:[{pageX:a,pageY:b}]}},Simulate:null,SimulateNative:{},act:function(a){function b(){R--;N.current=c;M.current=e}!1===S&&(S=!0,console.error("act(...) is not supported in production builds of React, and might not behave as expected."));R++;var c=
N.current;var e=M.current;N.current=!0;M.current=!0;try{var d=da(a)}catch(f){throw b(),f;}if(null!==d&&"object"===typeof d&&"function"===typeof d.then)return{then:function(a,e){d.then(function(){1<R||!0===O&&!0===c?(b(),a()):Q(function(c){b();c?e(c):a()})},function(a){b();e(a)})}};try{1!==R||!1!==O&&!1!==c||P(),b()}catch(f){throw b(),f;}return{then:function(a){a()}}}};
function na(a){return function(b,c){if(k.isValidElement(b))throw Error(p(228));if(Y.isCompositeComponent(b))throw Error(p(229));var e=U[a],d=new W;d.target=b;d.type=a.toLowerCase();var f=fa(b),h=new x(e,f,d,b);h.persist();g(h,c);e.phasedRegistrationNames?ha(h):ia(h);m.unstable_batchedUpdates(function(){ja(b);la(h)});ka()}}Y.Simulate={};for(var Z in U)Y.Simulate[Z]=na(Z);
function oa(a,b){return function(c,e){var d=new W(a);g(d,e);Y.isDOMComponent(c)?(c=ea(c),d.target=c,V(b,1,document,d)):c.tagName&&(d.target=c,V(b,1,document,d))}}
[["abort","abort"],[H,"animationEnd"],[I,"animationIteration"],[J,"animationStart"],["blur","blur"],["canplaythrough","canPlayThrough"],["canplay","canPlay"],["cancel","cancel"],["change","change"],["click","click"],["close","close"],["compositionend","compositionEnd"],["compositionstart","compositionStart"],["compositionupdate","compositionUpdate"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragenter","dragEnter"],["dragexit","dragExit"],
["dragleave","dragLeave"],["dragover","dragOver"],["dragstart","dragStart"],["drag","drag"],["drop","drop"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],["ended","ended"],["error","error"],["focus","focus"],["input","input"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["loadstart","loadStart"],["loadstart","loadStart"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["mousedown","mouseDown"],["mousemove","mouseMove"],
["mouseout","mouseOut"],["mouseover","mouseOver"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["playing","playing"],["progress","progress"],["ratechange","rateChange"],["scroll","scroll"],["seeked","seeked"],["seeking","seeking"],["selectionchange","selectionChange"],["stalled","stalled"],["suspend","suspend"],["textInput","textInput"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchmove","touchMove"],["touchstart",
"touchStart"],[aa,"transitionEnd"],["volumechange","volumeChange"],["waiting","waiting"],["wheel","wheel"]].forEach(function(a){var b=a[1];Y.SimulateNative[b]=oa(b,a[0])});module.exports=Y.default||Y;


/***/ }),

/***/ 73717:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),

/***/ 89489:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(73717);
} else {}


/***/ }),

/***/ 30740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43064);
} else {}


/***/ }),

/***/ 75514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gN": function() { return /* binding */ Field; },
  "l0": function() { return /* binding */ ReactFinalForm; }
});

// UNUSED EXPORTS: FormSpy, useField, useForm, useFormState, version, withTypes

// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(20011);
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(66017);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../node_modules/final-form/dist/final-form.es.js



//      

var charCodeOfDot = ".".charCodeAt(0);
var reEscapeChar = /\\(\\)?/g;
var rePropName = RegExp(
// Match anything that isn't a dot or bracket.
"[^.[\\]]+" + "|" +
// Or match property names within brackets.
"\\[(?:" +
// Match a non-string expression.
"([^\"'][^[]*)" + "|" +
// Or match strings (supports escaping characters).
"([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2" + ")\\]" + "|" +
// Or match "" as the space between consecutive dots or empty brackets.
"(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = function stringToPath(string) {
  var result = [];
  if (string.charCodeAt(0) === charCodeOfDot) {
    result.push("");
  }
  string.replace(rePropName, function (match, expression, quote, subString) {
    var key = match;
    if (quote) {
      key = subString.replace(reEscapeChar, "$1");
    } else if (expression) {
      key = expression.trim();
    }
    result.push(key);
  });
  return result;
};
var keysCache = {};
var keysRegex = /[.[\]]+/;
var toPath = function toPath(key) {
  if (key === null || key === undefined || !key.length) {
    return [];
  }
  if (typeof key !== "string") {
    throw new Error("toPath() expects a string");
  }
  if (keysCache[key] == null) {
    /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */
    if (key.endsWith("[]")) {
      // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
      keysCache[key] = key.split(keysRegex).filter(Boolean);
    } else {
      // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
      keysCache[key] = stringToPath(key);
    }
  }
  return keysCache[key];
};

//      
var getIn = function getIn(state, complexKey) {
  // Intentionally using iteration rather than recursion
  var path = toPath(complexKey);
  var current = state;
  for (var i = 0; i < path.length; i++) {
    var key = path[i];
    if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) {
      return undefined;
    }
    current = current[key];
  }
  return current;
};

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var setInRecursor = function setInRecursor(current, index, path, value, destroyArrays) {
  if (index >= path.length) {
    // end of recursion
    return value;
  }
  var key = path[index];

  // determine type of key
  if (isNaN(key)) {
    var _extends2;
    // object set
    if (current === undefined || current === null) {
      var _ref;
      // recurse
      var _result = setInRecursor(undefined, index + 1, path, value, destroyArrays);

      // delete or create an object
      return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
    }
    if (Array.isArray(current)) {
      throw new Error("Cannot set a non-numeric property on an array");
    }
    // current exists, so make a copy of all its values, and add/update the new one
    var _result2 = setInRecursor(current[key], index + 1, path, value, destroyArrays);
    if (_result2 === undefined) {
      var numKeys = Object.keys(current).length;
      if (current[key] === undefined && numKeys === 0) {
        // object was already empty
        return undefined;
      }
      if (current[key] !== undefined && numKeys <= 1) {
        // only key we had was the one we are deleting
        if (!isNaN(path[index - 1]) && !destroyArrays) {
          // we are in an array, so return an empty object
          return {};
        } else {
          return undefined;
        }
      }
      current[key];
        var _final = (0,objectWithoutPropertiesLoose/* default */.Z)(current, [key].map(_toPropertyKey));
      return _final;
    }
    // set result in key
    return (0,esm_extends/* default */.Z)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
  }
  // array set
  var numericKey = Number(key);
  if (current === undefined || current === null) {
    // recurse
    var _result3 = setInRecursor(undefined, index + 1, path, value, destroyArrays);

    // if nothing returned, delete it
    if (_result3 === undefined) {
      return undefined;
    }

    // create an array
    var _array = [];
    _array[numericKey] = _result3;
    return _array;
  }
  if (!Array.isArray(current)) {
    throw new Error("Cannot set a numeric property on an object");
  }
  // recurse
  var existingValue = current[numericKey];
  var result = setInRecursor(existingValue, index + 1, path, value, destroyArrays);

  // current exists, so make a copy of all its values, and add/update the new one
  var array = [].concat(current);
  if (destroyArrays && result === undefined) {
    array.splice(numericKey, 1);
    if (array.length === 0) {
      return undefined;
    }
  } else {
    array[numericKey] = result;
  }
  return array;
};
var setIn = function setIn(state, key, value, destroyArrays) {
  if (destroyArrays === void 0) {
    destroyArrays = false;
  }
  if (state === undefined || state === null) {
    throw new Error("Cannot call setIn() with " + String(state) + " state");
  }
  if (key === undefined || key === null) {
    throw new Error("Cannot call setIn() with " + String(key) + " key");
  }
  // Recursive function needs to accept and return State, but public API should
  // only deal with Objects
  return setInRecursor(state, 0, toPath(key), value, destroyArrays);
};

var FORM_ERROR = "FINAL_FORM/form-error";
var ARRAY_ERROR = "FINAL_FORM/array-error";

//      


/**
 * Converts internal field state to published field state
 */
function publishFieldState(formState, field) {
  var errors = formState.errors,
    initialValues = formState.initialValues,
    lastSubmittedValues = formState.lastSubmittedValues,
    submitErrors = formState.submitErrors,
    submitFailed = formState.submitFailed,
    submitSucceeded = formState.submitSucceeded,
    submitting = formState.submitting,
    values = formState.values;
  var active = field.active,
    blur = field.blur,
    change = field.change,
    data = field.data,
    focus = field.focus,
    modified = field.modified,
    modifiedSinceLastSubmit = field.modifiedSinceLastSubmit,
    name = field.name,
    touched = field.touched,
    validating = field.validating,
    visited = field.visited;
  var value = getIn(values, name);
  var error = getIn(errors, name);
  if (error && error[ARRAY_ERROR]) {
    error = error[ARRAY_ERROR];
  }
  var submitError = submitErrors && getIn(submitErrors, name);
  var initial = initialValues && getIn(initialValues, name);
  var pristine = field.isEqual(initial, value);
  var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value));
  var valid = !error && !submitError;
  return {
    active: active,
    blur: blur,
    change: change,
    data: data,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    error: error,
    focus: focus,
    initial: initial,
    invalid: !valid,
    length: Array.isArray(value) ? value.length : undefined,
    modified: modified,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    name: name,
    pristine: pristine,
    submitError: submitError,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitting: submitting,
    touched: touched,
    valid: valid,
    value: value,
    visited: visited,
    validating: validating
  };
}

//      
var fieldSubscriptionItems = ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "value", "visited", "validating"];

//      

var shallowEqual = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
    return false;
  }
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];
    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
      return false;
    }
  }
  return true;
};

//      
function subscriptionFilter (dest, src, previous, subscription, keys, shallowEqualKeys) {
  var different = false;
  keys.forEach(function (key) {
    if (subscription[key]) {
      dest[key] = src[key];
      if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) {
        different = true;
      }
    }
  });
  return different;
}

//      
var shallowEqualKeys$1 = ["data"];

/**
 * Filters items in a FieldState based on a FieldSubscription
 */
var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
  var result = {
    blur: state.blur,
    change: state.change,
    focus: state.focus,
    name: state.name
  };
  var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
  return different || force ? result : undefined;
};

//      
var formSubscriptionItems = ["active", "dirty", "dirtyFields", "dirtyFieldsSinceLastSubmit", "dirtySinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitting", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "touched", "valid", "validating", "values", "visited"];

//      
var shallowEqualKeys = ["touched", "visited"];

/**
 * Filters items in a FormState based on a FormSubscription
 */
function filterFormState(state, previousState, subscription, force) {
  var result = {};
  var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
  return different || force ? result : undefined;
}

//      
var memoize = function memoize(fn) {
  var lastArgs;
  var lastResult;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!lastArgs || args.length !== lastArgs.length || args.some(function (arg, index) {
      return !shallowEqual(lastArgs[index], arg);
    })) {
      lastArgs = args;
      lastResult = fn.apply(void 0, args);
    }
    return lastResult;
  };
};

var isPromise = (function (obj) {
  return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
});

var version = "4.20.10";

var configOptions = (/* unused pure expression or super */ null && (["debug", "initialValues", "keepDirtyOnReinitialize", "mutators", "onSubmit", "validate", "validateOnBlur"]));
var tripleEquals = function tripleEquals(a, b) {
  return a === b;
};
var hasAnyError = function hasAnyError(errors) {
  return Object.keys(errors).some(function (key) {
    var value = errors[key];
    if (value && typeof value === "object" && !(value instanceof Error)) {
      return hasAnyError(value);
    }
    return typeof value !== "undefined";
  });
};
function convertToExternalFormState(_ref) {
  var active = _ref.active,
    dirtySinceLastSubmit = _ref.dirtySinceLastSubmit,
    modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit,
    error = _ref.error,
    errors = _ref.errors,
    initialValues = _ref.initialValues,
    pristine = _ref.pristine,
    submitting = _ref.submitting,
    submitFailed = _ref.submitFailed,
    submitSucceeded = _ref.submitSucceeded,
    submitError = _ref.submitError,
    submitErrors = _ref.submitErrors,
    valid = _ref.valid,
    validating = _ref.validating,
    values = _ref.values;
  return {
    active: active,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    error: error,
    errors: errors,
    hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
    hasValidationErrors: !!(error || hasAnyError(errors)),
    invalid: !valid,
    initialValues: initialValues,
    pristine: pristine,
    submitting: submitting,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitError: submitError,
    submitErrors: submitErrors,
    valid: valid,
    validating: validating > 0,
    values: values
  };
}
function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
  var notification = filter(state, lastState, subscription, force);
  if (notification) {
    subscriber(notification);
    return true;
  }
  return false;
}
function notify(_ref2, state, lastState, filter, force) {
  var entries = _ref2.entries;
  Object.keys(entries).forEach(function (key) {
    var entry = entries[Number(key)];
    // istanbul ignore next
    if (entry) {
      var subscription = entry.subscription,
        subscriber = entry.subscriber,
        notified = entry.notified;
      if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) {
        entry.notified = true;
      }
    }
  });
}
function createForm(config) {
  if (!config) {
    throw new Error("No config specified");
  }
  var debug = config.debug,
    destroyOnUnregister = config.destroyOnUnregister,
    keepDirtyOnReinitialize = config.keepDirtyOnReinitialize,
    initialValues = config.initialValues,
    mutators = config.mutators,
    onSubmit = config.onSubmit,
    validate = config.validate,
    validateOnBlur = config.validateOnBlur;
  if (!onSubmit) {
    throw new Error("No onSubmit function specified");
  }
  var state = {
    subscribers: {
      index: 0,
      entries: {}
    },
    fieldSubscribers: {},
    fields: {},
    formState: {
      asyncErrors: {},
      dirtySinceLastSubmit: false,
      modifiedSinceLastSubmit: false,
      errors: {},
      initialValues: initialValues && (0,esm_extends/* default */.Z)({}, initialValues),
      invalid: false,
      pristine: true,
      submitting: false,
      submitFailed: false,
      submitSucceeded: false,
      resetWhileSubmitting: false,
      valid: true,
      validating: 0,
      values: initialValues ? (0,esm_extends/* default */.Z)({}, initialValues) : {}
    },
    lastFormState: undefined
  };
  var inBatch = 0;
  var validationPaused = false;
  var validationBlocked = false;
  var preventNotificationWhileValidationPaused = false;
  var nextAsyncValidationKey = 0;
  var asyncValidationPromises = {};
  var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
    return function (result) {
      delete asyncValidationPromises[key];
      return result;
    };
  };
  var changeValue = function changeValue(state, name, mutate) {
    var before = getIn(state.formState.values, name);
    var after = mutate(before);
    state.formState.values = setIn(state.formState.values, name, after) || {};
  };
  var renameField = function renameField(state, from, to) {
    if (state.fields[from]) {
      var _extends2, _extends3;
      state.fields = (0,esm_extends/* default */.Z)({}, state.fields, (_extends2 = {}, _extends2[to] = (0,esm_extends/* default */.Z)({}, state.fields[from], {
        name: to,
        // rebind event handlers
        blur: function blur() {
          return api.blur(to);
        },
        change: function change(value) {
          return api.change(to, value);
        },
        focus: function focus() {
          return api.focus(to);
        },
        lastFieldState: undefined
      }), _extends2));
      delete state.fields[from];
      state.fieldSubscribers = (0,esm_extends/* default */.Z)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
      delete state.fieldSubscribers[from];
      var value = getIn(state.formState.values, from);
      state.formState.values = setIn(state.formState.values, from, undefined) || {};
      state.formState.values = setIn(state.formState.values, to, value);
      delete state.lastFormState;
    }
  };

  // bind state to mutators
  var getMutatorApi = function getMutatorApi(key) {
    return function () {
      // istanbul ignore next
      if (mutators) {
        // ^^ causes branch coverage warning, but needed to appease the Flow gods
        var mutatableState = {
          formState: state.formState,
          fields: state.fields,
          fieldSubscribers: state.fieldSubscribers,
          lastFormState: state.lastFormState
        };
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var returnValue = mutators[key](args, mutatableState, {
          changeValue: changeValue,
          getIn: getIn,
          renameField: renameField,
          resetFieldState: api.resetFieldState,
          setIn: setIn,
          shallowEqual: shallowEqual
        });
        state.formState = mutatableState.formState;
        state.fields = mutatableState.fields;
        state.fieldSubscribers = mutatableState.fieldSubscribers;
        state.lastFormState = mutatableState.lastFormState;
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
        return returnValue;
      }
    };
  };
  var mutatorsApi = mutators ? Object.keys(mutators).reduce(function (result, key) {
    result[key] = getMutatorApi(key);
    return result;
  }, {}) : {};
  var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
    var promises = [];
    if (validate) {
      var errorsOrPromise = validate((0,esm_extends/* default */.Z)({}, state.formState.values)); // clone to avoid writing
      if (isPromise(errorsOrPromise)) {
        promises.push(errorsOrPromise.then(function (errors) {
          return setErrors(errors, true);
        }));
      } else {
        setErrors(errorsOrPromise, false);
      }
    }
    return promises;
  };
  var getValidators = function getValidators(field) {
    return Object.keys(field.validators).reduce(function (result, index) {
      var validator = field.validators[Number(index)]();
      if (validator) {
        result.push(validator);
      }
      return result;
    }, []);
  };
  var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
    var promises = [];
    var validators = getValidators(field);
    if (validators.length) {
      var error;
      validators.forEach(function (validator) {
        var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);
        if (errorOrPromise && isPromise(errorOrPromise)) {
          field.validating = true;
          var promise = errorOrPromise.then(function (error) {
            if (state.fields[field.name]) {
              state.fields[field.name].validating = false;
              setError(error);
            }
          }); // errors must be resolved, not rejected
          promises.push(promise);
        } else if (!error) {
          // first registered validator wins
          error = errorOrPromise;
        }
      });
      setError(error);
    }
    return promises;
  };
  var runValidation = function runValidation(fieldChanged, callback) {
    if (validationPaused) {
      validationBlocked = true;
      callback();
      return;
    }
    var fields = state.fields,
      formState = state.formState;
    var safeFields = (0,esm_extends/* default */.Z)({}, fields);
    var fieldKeys = Object.keys(safeFields);
    if (!validate && !fieldKeys.some(function (key) {
      return getValidators(safeFields[key]).length;
    })) {
      callback();
      return; // no validation rules
    }

    // pare down field keys to actually validate
    var limitedFieldLevelValidation = false;
    if (fieldChanged) {
      var changedField = safeFields[fieldChanged];
      if (changedField) {
        var validateFields = changedField.validateFields;
        if (validateFields) {
          limitedFieldLevelValidation = true;
          fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [fieldChanged];
        }
      }
    }
    var recordLevelErrors = {};
    var asyncRecordLevelErrors = {};
    var fieldLevelErrors = {};
    var promises = [].concat(runRecordLevelValidation(function (errors, wasAsync) {
      if (wasAsync) {
        asyncRecordLevelErrors = errors || {};
      } else {
        recordLevelErrors = errors || {};
      }
    }), fieldKeys.reduce(function (result, name) {
      return result.concat(runFieldLevelValidation(fields[name], function (error) {
        fieldLevelErrors[name] = error;
      }));
    }, []));
    var hasAsyncValidations = promises.length > 0;
    var asyncValidationPromiseKey = ++nextAsyncValidationKey;
    var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));

    // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
    if (hasAsyncValidations) {
      asyncValidationPromises[asyncValidationPromiseKey] = promise;
    }
    var processErrors = function processErrors(afterAsync) {
      var merged = (0,esm_extends/* default */.Z)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
      : formState.asyncErrors);
      var forEachError = function forEachError(fn) {
        fieldKeys.forEach(function (name) {
          if (fields[name]) {
            // make sure field is still registered
            // field-level errors take precedent over record-level errors
            var recordLevelError = getIn(recordLevelErrors, name);
            var errorFromParent = getIn(merged, name);
            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
            var fieldLevelError = fieldLevelErrors[name];
            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
          }
        });
      };
      forEachError(function (name, error) {
        merged = setIn(merged, name, error) || {};
      });
      forEachError(function (name, error) {
        if (error && error[ARRAY_ERROR]) {
          var existing = getIn(merged, name);
          var copy = [].concat(existing);
          copy[ARRAY_ERROR] = error[ARRAY_ERROR];
          merged = setIn(merged, name, copy);
        }
      });
      if (!shallowEqual(formState.errors, merged)) {
        formState.errors = merged;
      }
      if (afterAsync) {
        formState.asyncErrors = asyncRecordLevelErrors;
      }
      formState.error = recordLevelErrors[FORM_ERROR];
    };
    if (hasAsyncValidations) {
      // async validations are running, ensure validating is true before notifying
      state.formState.validating++;
      callback();
    }

    // process sync errors
    processErrors(false);
    // sync errors have been set. notify listeners while we wait for others
    callback();
    if (hasAsyncValidations) {
      var afterPromise = function afterPromise() {
        state.formState.validating--;
        callback();
        // field async validation may affect formState validating
        // so force notifyFormListeners if validating is still 0 after callback finished
        // and lastFormState validating is true
        if (state.formState.validating === 0 && state.lastFormState.validating) {
          notifyFormListeners();
        }
      };
      promise.then(function () {
        if (nextAsyncValidationKey > asyncValidationPromiseKey) {
          // if this async validator has been superseded by another, ignore its results
          return;
        }
        processErrors(true);
      }).then(afterPromise, afterPromise);
    }
  };
  var notifyFieldListeners = function notifyFieldListeners(name) {
    if (inBatch) {
      return;
    }
    var fields = state.fields,
      fieldSubscribers = state.fieldSubscribers,
      formState = state.formState;
    var safeFields = (0,esm_extends/* default */.Z)({}, fields);
    var notifyField = function notifyField(name) {
      var field = safeFields[name];
      var fieldState = publishFieldState(formState, field);
      var lastFieldState = field.lastFieldState;
      field.lastFieldState = fieldState;
      var fieldSubscriber = fieldSubscribers[name];
      if (fieldSubscriber) {
        notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
      }
    };
    if (name) {
      notifyField(name);
    } else {
      Object.keys(safeFields).forEach(notifyField);
    }
  };
  var markAllFieldsTouched = function markAllFieldsTouched() {
    Object.keys(state.fields).forEach(function (key) {
      state.fields[key].touched = true;
    });
  };
  var hasSyncErrors = function hasSyncErrors() {
    return !!(state.formState.error || hasAnyError(state.formState.errors));
  };
  var calculateNextFormState = function calculateNextFormState() {
    var fields = state.fields,
      formState = state.formState,
      lastFormState = state.lastFormState;
    var safeFields = (0,esm_extends/* default */.Z)({}, fields);
    var safeFieldKeys = Object.keys(safeFields);

    // calculate dirty/pristine
    var foundDirty = false;
    var dirtyFields = safeFieldKeys.reduce(function (result, key) {
      var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
      if (dirty) {
        foundDirty = true;
        result[key] = true;
      }
      return result;
    }, {});
    var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function (result, key) {
      // istanbul ignore next
      var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
      if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) {
        result[key] = true;
      }
      return result;
    }, {});
    formState.pristine = !foundDirty;
    formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function (value) {
      return value;
    }));
    formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues &&
    // Object.values would treat values as mixed (facebook/flow#2221)
    Object.keys(safeFields).some(function (value) {
      return safeFields[value].modifiedSinceLastSubmit;
    }));
    formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
    var nextFormState = convertToExternalFormState(formState);
    var _safeFieldKeys$reduce = safeFieldKeys.reduce(function (result, key) {
        result.modified[key] = safeFields[key].modified;
        result.touched[key] = safeFields[key].touched;
        result.visited[key] = safeFields[key].visited;
        return result;
      }, {
        modified: {},
        touched: {},
        visited: {}
      }),
      modified = _safeFieldKeys$reduce.modified,
      touched = _safeFieldKeys$reduce.touched,
      visited = _safeFieldKeys$reduce.visited;
    nextFormState.dirtyFields = lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
    nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
    nextFormState.modified = lastFormState && shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
    nextFormState.touched = lastFormState && shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
    nextFormState.visited = lastFormState && shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
    return lastFormState && shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
  };
  var callDebug = function callDebug() {
    return debug && "development" !== "production" && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function (result, key) {
      result[key] = state.fields[key];
      return result;
    }, {}));
  };
  var notifying = false;
  var scheduleNotification = false;
  var notifyFormListeners = function notifyFormListeners() {
    if (notifying) {
      scheduleNotification = true;
    } else {
      notifying = true;
      callDebug();
      if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
        var lastFormState = state.lastFormState;
        var nextFormState = calculateNextFormState();
        if (nextFormState !== lastFormState) {
          state.lastFormState = nextFormState;
          notify(state.subscribers, nextFormState, lastFormState, filterFormState);
        }
      }
      notifying = false;
      if (scheduleNotification) {
        scheduleNotification = false;
        notifyFormListeners();
      }
    }
  };
  var beforeSubmit = function beforeSubmit() {
    return Object.keys(state.fields).some(function (name) {
      return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
    });
  };
  var afterSubmit = function afterSubmit() {
    return Object.keys(state.fields).forEach(function (name) {
      return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
    });
  };
  var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
    return Object.keys(state.fields).forEach(function (key) {
      return state.fields[key].modifiedSinceLastSubmit = false;
    });
  };

  // generate initial errors
  runValidation(undefined, function () {
    notifyFormListeners();
  });
  var api = {
    batch: function batch(fn) {
      inBatch++;
      fn();
      inBatch--;
      notifyFieldListeners();
      notifyFormListeners();
    },
    blur: function blur(name) {
      var fields = state.fields,
        formState = state.formState;
      var previous = fields[name];
      if (previous) {
        // can only blur registered fields
        delete formState.active;
        fields[name] = (0,esm_extends/* default */.Z)({}, previous, {
          active: false,
          touched: true
        });
        if (validateOnBlur) {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        } else {
          notifyFieldListeners();
          notifyFormListeners();
        }
      }
    },
    change: function change(name, value) {
      var fields = state.fields,
        formState = state.formState;
      if (getIn(formState.values, name) !== value) {
        changeValue(state, name, function () {
          return value;
        });
        var previous = fields[name];
        if (previous) {
          // only track modified for registered fields
          fields[name] = (0,esm_extends/* default */.Z)({}, previous, {
            modified: true,
            modifiedSinceLastSubmit: !!formState.lastSubmittedValues
          });
        }
        if (validateOnBlur) {
          notifyFieldListeners();
          notifyFormListeners();
        } else {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        }
      }
    },
    get destroyOnUnregister() {
      return !!destroyOnUnregister;
    },
    set destroyOnUnregister(value) {
      destroyOnUnregister = value;
    },
    focus: function focus(name) {
      var field = state.fields[name];
      if (field && !field.active) {
        state.formState.active = name;
        field.active = true;
        field.visited = true;
        notifyFieldListeners();
        notifyFormListeners();
      }
    },
    mutators: mutatorsApi,
    getFieldState: function getFieldState(name) {
      var field = state.fields[name];
      return field && field.lastFieldState;
    },
    getRegisteredFields: function getRegisteredFields() {
      return Object.keys(state.fields);
    },
    getState: function getState() {
      return calculateNextFormState();
    },
    initialize: function initialize(data) {
      var fields = state.fields,
        formState = state.formState;
      var safeFields = (0,esm_extends/* default */.Z)({}, fields);
      var values = typeof data === "function" ? data(formState.values) : data;
      if (!keepDirtyOnReinitialize) {
        formState.values = values;
      }
      /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */

      // save dirty values
      var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function (result, key) {
        var field = safeFields[key];
        var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
        if (!pristine) {
          result[key] = getIn(formState.values, key);
        }
        return result;
      }, {}) : {};
      // update initalValues and values
      formState.initialValues = values;
      formState.values = values;
      // restore the dirty values
      Object.keys(savedDirtyValues).forEach(function (key) {
        formState.values = setIn(formState.values, key, savedDirtyValues[key]) || {};
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },
    isValidationPaused: function isValidationPaused() {
      return validationPaused;
    },
    pauseValidation: function pauseValidation(preventNotification) {
      if (preventNotification === void 0) {
        preventNotification = true;
      }
      validationPaused = true;
      preventNotificationWhileValidationPaused = preventNotification;
    },
    registerField: function registerField(name, subscriber, subscription, fieldConfig) {
      if (subscription === void 0) {
        subscription = {};
      }
      if (!state.fieldSubscribers[name]) {
        state.fieldSubscribers[name] = {
          index: 0,
          entries: {}
        };
      }
      var index = state.fieldSubscribers[name].index++;

      // save field subscriber callback
      state.fieldSubscribers[name].entries[index] = {
        subscriber: memoize(subscriber),
        subscription: subscription,
        notified: false
      };

      // create initial field state if not exists
      var field = state.fields[name] || {
        active: false,
        afterSubmit: fieldConfig && fieldConfig.afterSubmit,
        beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
        data: fieldConfig && fieldConfig.data || {},
        isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
        lastFieldState: undefined,
        modified: false,
        modifiedSinceLastSubmit: false,
        name: name,
        touched: false,
        valid: true,
        validateFields: fieldConfig && fieldConfig.validateFields,
        validators: {},
        validating: false,
        visited: false
      };
      // Mutators can create a field in order to keep the field states
      // We must update this field when registerField is called afterwards
      field.blur = field.blur || function () {
        return api.blur(name);
      };
      field.change = field.change || function (value) {
        return api.change(name, value);
      };
      field.focus = field.focus || function () {
        return api.focus(name);
      };
      state.fields[name] = field;
      var haveValidator = false;
      var silent = fieldConfig && fieldConfig.silent;
      var notify = function notify() {
        if (silent && state.fields[name]) {
          notifyFieldListeners(name);
        } else {
          notifyFormListeners();
          notifyFieldListeners();
        }
      };
      if (fieldConfig) {
        haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
        if (fieldConfig.getValidator) {
          state.fields[name].validators[index] = fieldConfig.getValidator;
        }
        var noValueInFormState = getIn(state.formState.values, name) === undefined;
        if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name))
        // only initialize if we don't yet have any value for this field
        ) {
          state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
          state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
          runValidation(undefined, notify);
        }

        // only use defaultValue if we don't yet have any value for this field
        if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) {
          state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
        }
      }
      if (haveValidator) {
        runValidation(undefined, notify);
      } else {
        notify();
      }
      return function () {
        var validatorRemoved = false;
        // istanbul ignore next
        if (state.fields[name]) {
          // state.fields[name] may have been removed by a mutator
          validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
          delete state.fields[name].validators[index];
        }
        var hasFieldSubscribers = !!state.fieldSubscribers[name];
        if (hasFieldSubscribers) {
          // state.fieldSubscribers[name] may have been removed by a mutator
          delete state.fieldSubscribers[name].entries[index];
        }
        var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
        if (lastOne) {
          delete state.fieldSubscribers[name];
          delete state.fields[name];
          if (validatorRemoved) {
            state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
          }
          if (destroyOnUnregister) {
            state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
          }
        }
        if (!silent) {
          if (validatorRemoved) {
            runValidation(undefined, function () {
              notifyFormListeners();
              notifyFieldListeners();
            });
          } else if (lastOne) {
            // values or errors may have changed
            notifyFormListeners();
          }
        }
      };
    },
    reset: function reset(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }
      if (state.formState.submitting) {
        state.formState.resetWhileSubmitting = true;
      }
      state.formState.submitFailed = false;
      state.formState.submitSucceeded = false;
      delete state.formState.submitError;
      delete state.formState.submitErrors;
      delete state.formState.lastSubmittedValues;
      api.initialize(initialValues || {});
    },
    /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */
    resetFieldState: function resetFieldState(name) {
      state.fields[name] = (0,esm_extends/* default */.Z)({}, state.fields[name], {
        active: false,
        lastFieldState: undefined,
        modified: false,
        touched: false,
        valid: true,
        validating: false,
        visited: false
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },
    /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */
    restart: function restart(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }
      api.batch(function () {
        for (var name in state.fields) {
          api.resetFieldState(name);
          state.fields[name] = (0,esm_extends/* default */.Z)({}, state.fields[name], {
            active: false,
            lastFieldState: undefined,
            modified: false,
            modifiedSinceLastSubmit: false,
            touched: false,
            valid: true,
            validating: false,
            visited: false
          });
        }
        api.reset(initialValues);
      });
    },
    resumeValidation: function resumeValidation() {
      validationPaused = false;
      preventNotificationWhileValidationPaused = false;
      if (validationBlocked) {
        // validation was attempted while it was paused, so run it now
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
      }
      validationBlocked = false;
    },
    setConfig: function setConfig(name, value) {
      switch (name) {
        case "debug":
          debug = value;
          break;
        case "destroyOnUnregister":
          destroyOnUnregister = value;
          break;
        case "initialValues":
          api.initialize(value);
          break;
        case "keepDirtyOnReinitialize":
          keepDirtyOnReinitialize = value;
          break;
        case "mutators":
          mutators = value;
          if (value) {
            Object.keys(mutatorsApi).forEach(function (key) {
              if (!(key in value)) {
                delete mutatorsApi[key];
              }
            });
            Object.keys(value).forEach(function (key) {
              mutatorsApi[key] = getMutatorApi(key);
            });
          } else {
            Object.keys(mutatorsApi).forEach(function (key) {
              delete mutatorsApi[key];
            });
          }
          break;
        case "onSubmit":
          onSubmit = value;
          break;
        case "validate":
          validate = value;
          runValidation(undefined, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
          break;
        case "validateOnBlur":
          validateOnBlur = value;
          break;
        default:
          throw new Error("Unrecognised option " + name);
      }
    },
    submit: function submit() {
      var formState = state.formState;
      if (formState.submitting) {
        return;
      }
      delete formState.submitErrors;
      delete formState.submitError;
      formState.lastSubmittedValues = (0,esm_extends/* default */.Z)({}, formState.values);
      if (hasSyncErrors()) {
        markAllFieldsTouched();
        resetModifiedAfterSubmit();
        state.formState.submitFailed = true;
        notifyFormListeners();
        notifyFieldListeners();
        return; // no submit for you!!
      }

      var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
      if (asyncValidationPromisesKeys.length) {
        // still waiting on async validation to complete...
        Promise.all(asyncValidationPromisesKeys.map(function (key) {
          return asyncValidationPromises[Number(key)];
        })).then(api.submit, console.error);
        return;
      }
      var submitIsBlocked = beforeSubmit();
      if (submitIsBlocked) {
        return;
      }
      var resolvePromise;
      var completeCalled = false;
      var complete = function complete(errors) {
        formState.submitting = false;
        var resetWhileSubmitting = formState.resetWhileSubmitting;
        if (resetWhileSubmitting) {
          formState.resetWhileSubmitting = false;
        }
        if (errors && hasAnyError(errors)) {
          formState.submitFailed = true;
          formState.submitSucceeded = false;
          formState.submitErrors = errors;
          formState.submitError = errors[FORM_ERROR];
          markAllFieldsTouched();
        } else {
          if (!resetWhileSubmitting) {
            formState.submitFailed = false;
            formState.submitSucceeded = true;
          }
          afterSubmit();
        }
        notifyFormListeners();
        notifyFieldListeners();
        completeCalled = true;
        if (resolvePromise) {
          resolvePromise(errors);
        }
        return errors;
      };
      formState.submitting = true;
      formState.submitFailed = false;
      formState.submitSucceeded = false;
      formState.lastSubmittedValues = (0,esm_extends/* default */.Z)({}, formState.values);
      resetModifiedAfterSubmit();

      // onSubmit is either sync, callback or async with a Promise
      var result = onSubmit(formState.values, api, complete);
      if (!completeCalled) {
        if (result && isPromise(result)) {
          // onSubmit is async with a Promise
          notifyFormListeners(); // let everyone know we are submitting
          notifyFieldListeners(); // notify fields also
          return result.then(complete, function (error) {
            complete();
            throw error;
          });
        } else if (onSubmit.length >= 3) {
          // must be async, so we should return a Promise
          notifyFormListeners(); // let everyone know we are submitting
          notifyFieldListeners(); // notify fields also
          return new Promise(function (resolve) {
            resolvePromise = resolve;
          });
        } else {
          // onSubmit is sync
          complete(result);
        }
      }
    },
    subscribe: function subscribe(subscriber, subscription) {
      if (!subscriber) {
        throw new Error("No callback given.");
      }
      if (!subscription) {
        throw new Error("No subscription provided. What values do you want to listen to?");
      }
      var memoized = memoize(subscriber);
      var subscribers = state.subscribers;
      var index = subscribers.index++;
      subscribers.entries[index] = {
        subscriber: memoized,
        subscription: subscription,
        notified: false
      };
      var nextFormState = calculateNextFormState();
      notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
      return function () {
        delete subscribers.entries[index];
      };
    }
  };
  return api;
}



;// CONCATENATED MODULE: ../../../node_modules/react-final-form/dist/react-final-form.es.js






var _excluded$3 = ["render", "children", "component"];
// shared logic between components that use either render prop,
// children render function, or component prop
function renderComponent(props, lazyProps, name) {
  var render = props.render,
      children = props.children,
      component = props.component,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded$3);

  if (component) {
    return /*#__PURE__*/react.createElement(component, Object.assign(lazyProps, rest, {
      children: children,
      render: render
    }));
  }

  if (render) {
    return render(children === undefined ? Object.assign(lazyProps, rest) : // inject children back in
    Object.assign(lazyProps, rest, {
      children: children
    }));
  }

  if (typeof children !== "function") {
    throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
  }

  return children(Object.assign(lazyProps, rest));
}

function useWhenValueChanges(value, callback, isEqual) {
  if (isEqual === void 0) {
    isEqual = function isEqual(a, b) {
      return a === b;
    };
  }

  var previous = react.useRef(value);
  react.useEffect(function () {
    if (!isEqual(value, previous.current)) {
      callback();
      previous.current = value;
    }
  });
}

/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */

function useConstant(init) {
  var ref = react.useRef();

  if (!ref.current) {
    ref.current = init();
  }

  return ref.current;
}

var react_final_form_es_shallowEqual = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
    return false;
  }

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
      return false;
    }
  }

  return true;
};

var isSyntheticEvent = function isSyntheticEvent(candidate) {
  return !!(candidate && typeof candidate.stopPropagation === "function");
};

var ReactFinalFormContext = /*#__PURE__*/react.createContext();

function useLatest(value) {
  var ref = react.useRef(value);
  react.useEffect(function () {
    ref.current = value;
  });
  return ref;
}

var react_final_form_es_version = "6.5.8";

var addLazyState = function addLazyState(dest, state, keys) {
  keys.forEach(function (key) {
    Object.defineProperty(dest, key, {
      get: function get() {
        return state[key];
      },
      enumerable: true
    });
  });
};

var addLazyFormState = function addLazyFormState(dest, state) {
  return addLazyState(dest, state, ["active", "dirty", "dirtyFields", "dirtySinceLastSubmit", "dirtyFieldsSinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "validating", "values", "visited"]);
};
var addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
  return addLazyState(dest, state, ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "validating", "visited"]);
};

var _excluded$2 = ["debug", "decorators", "destroyOnUnregister", "form", "initialValues", "initialValuesEqual", "keepDirtyOnReinitialize", "mutators", "onSubmit", "subscription", "validate", "validateOnBlur"];
var versions = {
  "final-form": version,
  "react-final-form": react_final_form_es_version
};
var all$1 = formSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

function ReactFinalForm(_ref) {
  var debug = _ref.debug,
      _ref$decorators = _ref.decorators,
      decorators = _ref$decorators === void 0 ? [] : _ref$decorators,
      destroyOnUnregister = _ref.destroyOnUnregister,
      alternateFormApi = _ref.form,
      initialValues = _ref.initialValues,
      initialValuesEqual = _ref.initialValuesEqual,
      keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize,
      mutators = _ref.mutators,
      onSubmit = _ref.onSubmit,
      _ref$subscription = _ref.subscription,
      subscription = _ref$subscription === void 0 ? all$1 : _ref$subscription,
      validate = _ref.validate,
      validateOnBlur = _ref.validateOnBlur,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded$2);

  var config = {
    debug: debug,
    destroyOnUnregister: destroyOnUnregister,
    initialValues: initialValues,
    keepDirtyOnReinitialize: keepDirtyOnReinitialize,
    mutators: mutators,
    onSubmit: onSubmit,
    validate: validate,
    validateOnBlur: validateOnBlur
  };
  var form = useConstant(function () {
    var f = alternateFormApi || createForm(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)

    f.pauseValidation();
    return f;
  }); // synchronously register and unregister to query form state for our subscription on first render

  var _React$useState = react.useState(function () {
    var initialState = {};
    form.subscribe(function (state) {
      initialState = state;
    }, subscription)();
    return initialState;
  }),
      state = _React$useState[0],
      setState = _React$useState[1]; // save a copy of state that can break through the closure
  // on the shallowEqual() line below.


  var stateRef = useLatest(state);
  react.useEffect(function () {
    // We have rendered, so all fields are now registered, so we can unpause validation
    form.isValidationPaused() && form.resumeValidation();
    var unsubscriptions = [form.subscribe(function (s) {
      if (!react_final_form_es_shallowEqual(s, stateRef.current)) {
        setState(s);
      }
    }, subscription)].concat(decorators ? decorators.map(function (decorator) {
      return (// this noop ternary is to appease the flow gods
        // istanbul ignore next
        decorator(form)
      );
    }) : []);
    return function () {
      form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration

      unsubscriptions.reverse().forEach(function (unsubscribe) {
        return unsubscribe();
      }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, decorators); // warn about decorator changes
  // istanbul ignore next

  if (false) {} // allow updatable config


  useWhenValueChanges(debug, function () {
    form.setConfig("debug", debug);
  });
  useWhenValueChanges(destroyOnUnregister, function () {
    form.destroyOnUnregister = !!destroyOnUnregister;
  });
  useWhenValueChanges(keepDirtyOnReinitialize, function () {
    form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
  });
  useWhenValueChanges(initialValues, function () {
    form.setConfig("initialValues", initialValues);
  }, initialValuesEqual || react_final_form_es_shallowEqual);
  useWhenValueChanges(mutators, function () {
    form.setConfig("mutators", mutators);
  });
  useWhenValueChanges(onSubmit, function () {
    form.setConfig("onSubmit", onSubmit);
  });
  useWhenValueChanges(validate, function () {
    form.setConfig("validate", validate);
  });
  useWhenValueChanges(validateOnBlur, function () {
    form.setConfig("validateOnBlur", validateOnBlur);
  });

  var handleSubmit = function handleSubmit(event) {
    if (event) {
      // sometimes not true, e.g. React Native
      if (typeof event.preventDefault === "function") {
        event.preventDefault();
      }

      if (typeof event.stopPropagation === "function") {
        // prevent any outer forms from receiving the event too
        event.stopPropagation();
      }
    }

    return form.submit();
  };

  var renderProps = {
    form: (0,esm_extends/* default */.Z)({}, form, {
      reset: function reset(eventOrValues) {
        if (isSyntheticEvent(eventOrValues)) {
          // it's a React SyntheticEvent, call reset with no arguments
          form.reset();
        } else {
          form.reset(eventOrValues);
        }
      }
    }),
    handleSubmit: handleSubmit
  };
  addLazyFormState(renderProps, state);
  return /*#__PURE__*/react.createElement(ReactFinalFormContext.Provider, {
    value: form
  }, renderComponent((0,esm_extends/* default */.Z)({}, rest, {
    __versions: versions
  }), renderProps, "ReactFinalForm"));
}

function useForm(componentName) {
  var form = react.useContext(ReactFinalFormContext);

  if (!form) {
    throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
  }

  return form;
}

function useFormState(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      onChange = _ref.onChange,
      _ref$subscription = _ref.subscription,
      subscription = _ref$subscription === void 0 ? all$1 : _ref$subscription;

  var form = useForm("useFormState");
  var firstRender = React.useRef(true);
  var onChangeRef = React.useRef(onChange);
  onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render

  var _React$useState = React.useState(function () {
    var initialState = {};
    form.subscribe(function (state) {
      initialState = state;
    }, subscription)();

    if (onChange) {
      onChange(initialState);
    }

    return initialState;
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  React.useEffect(function () {
    return form.subscribe(function (newState) {
      if (firstRender.current) {
        firstRender.current = false;
      } else {
        setState(newState);

        if (onChangeRef.current) {
          onChangeRef.current(newState);
        }
      }
    }, subscription);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var lazyState = {};
  addLazyFormState(lazyState, state);
  return lazyState;
}

var _excluded$1 = (/* unused pure expression or super */ null && (["onChange", "subscription"]));

function FormSpy(_ref) {
  var onChange = _ref.onChange,
      subscription = _ref.subscription,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var reactFinalForm = useForm("FormSpy");
  var state = useFormState({
    onChange: onChange,
    subscription: subscription
  });

  if (onChange) {
    return null;
  }

  var renderProps = {
    form: _extends({}, reactFinalForm, {
      reset: function reset(eventOrValues) {
        if (isSyntheticEvent(eventOrValues)) {
          // it's a React SyntheticEvent, call reset with no arguments
          reactFinalForm.reset();
        } else {
          reactFinalForm.reset(eventOrValues);
        }
      }
    })
  };
  return renderComponent(_extends({}, rest, renderProps), state, "FormSpy");
}

var isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";

var getSelectedValues = function getSelectedValues(options) {
  var result = [];

  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];

      if (option.selected) {
        result.push(option.value);
      }
    }
  }

  return result;
};

var getValue = function getValue(event, currentValue, valueProp, isReactNative) {
  if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
    return event.nativeEvent.text;
  }

  if (isReactNative && event.nativeEvent) {
    return event.nativeEvent.text;
  }

  var detypedEvent = event;
  var _detypedEvent$target = detypedEvent.target,
      type = _detypedEvent$target.type,
      value = _detypedEvent$target.value,
      checked = _detypedEvent$target.checked;

  switch (type) {
    case "checkbox":
      if (valueProp !== undefined) {
        // we are maintaining an array, not just a boolean
        if (checked) {
          // add value to current array value
          return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [valueProp];
        } else {
          // remove value from current array value
          if (!Array.isArray(currentValue)) {
            return currentValue;
          }

          var index = currentValue.indexOf(valueProp);

          if (index < 0) {
            return currentValue;
          } else {
            return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
          }
        }
      } else {
        // it's just a boolean
        return !!checked;
      }

    case "select-multiple":
      return getSelectedValues(event.target.options);

    default:
      return value;
  }
};

/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */

function useConstantCallback(callback) {
  var ref = react.useRef(callback);
  react.useEffect(function () {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(null, args);
  }, []);
}

var react_final_form_es_all = fieldSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

var defaultFormat = function defaultFormat(value, name) {
  return value === undefined ? "" : value;
};

var defaultParse = function defaultParse(value, name) {
  return value === "" ? undefined : value;
};

var defaultIsEqual = function defaultIsEqual(a, b) {
  return a === b;
};

function useField(name, config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      afterSubmit = _config.afterSubmit,
      allowNull = _config.allowNull,
      component = _config.component,
      data = _config.data,
      defaultValue = _config.defaultValue,
      _config$format = _config.format,
      format = _config$format === void 0 ? defaultFormat : _config$format,
      formatOnBlur = _config.formatOnBlur,
      initialValue = _config.initialValue,
      multiple = _config.multiple,
      _config$parse = _config.parse,
      parse = _config$parse === void 0 ? defaultParse : _config$parse,
      _config$subscription = _config.subscription,
      subscription = _config$subscription === void 0 ? react_final_form_es_all : _config$subscription,
      type = _config.type,
      validateFields = _config.validateFields,
      _value = _config.value;
  var form = useForm("useField");
  var configRef = useLatest(config);

  var register = function register(callback, silent) {
    return (// avoid using `state` const in any closures created inside `register`
      // because they would refer `state` from current execution context
      // whereas actual `state` would defined in the subsequent `useField` hook
      // execution
      // (that would be caused by `setState` call performed in `register` callback)
      form.registerField(name, callback, subscription, {
        afterSubmit: afterSubmit,
        beforeSubmit: function beforeSubmit() {
          var _configRef$current = configRef.current,
              beforeSubmit = _configRef$current.beforeSubmit,
              formatOnBlur = _configRef$current.formatOnBlur,
              _configRef$current$fo = _configRef$current.format,
              format = _configRef$current$fo === void 0 ? defaultFormat : _configRef$current$fo;

          if (formatOnBlur) {
            var _ref = form.getFieldState(name),
                value = _ref.value;

            var formatted = format(value, name);

            if (formatted !== value) {
              form.change(name, formatted);
            }
          }

          return beforeSubmit && beforeSubmit();
        },
        data: data,
        defaultValue: defaultValue,
        getValidator: function getValidator() {
          return configRef.current.validate;
        },
        initialValue: initialValue,
        isEqual: function isEqual(a, b) {
          return (configRef.current.isEqual || defaultIsEqual)(a, b);
        },
        silent: silent,
        validateFields: validateFields
      })
    );
  };

  var firstRender = react.useRef(true); // synchronously register and unregister to query field state for our subscription on first render

  var _React$useState = react.useState(function () {
    var initialState = {}; // temporarily disable destroyOnUnregister

    // temporarily disable destroyOnUnregister
    var destroyOnUnregister = form.destroyOnUnregister;
    form.destroyOnUnregister = false;
    register(function (state) {
      initialState = state;
    }, true)(); // return destroyOnUnregister to its original value

    // return destroyOnUnregister to its original value
    form.destroyOnUnregister = destroyOnUnregister;
    return initialState;
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  react.useEffect(function () {
    return register(function (state) {
      if (firstRender.current) {
        firstRender.current = false;
      } else {
        setState(state);
      }
    }, false);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [name, data, defaultValue, // If we want to allow inline fat-arrow field-level validation functions, we
  // cannot reregister field every time validate function !==.
  // validate,
  initialValue // The validateFields array is often passed as validateFields={[]}, creating
  // a !== new array every time. If it needs to be changed, a rerender/reregister
  // can be forced by changing the key prop
  // validateFields
  ]);
  var meta = {};
  addLazyFieldMetaState(meta, state);
  var input = {
    name: name,

    get value() {
      var value = state.value;

      if (formatOnBlur) {
        if (component === "input") {
          value = defaultFormat(value);
        }
      } else {
        value = format(value, name);
      }

      if (value === null && !allowNull) {
        value = "";
      }

      if (type === "checkbox" || type === "radio") {
        return _value;
      } else if (component === "select" && multiple) {
        return value || [];
      }

      return value;
    },

    get checked() {
      var value = state.value;

      if (type === "checkbox") {
        value = format(value, name);

        if (_value === undefined) {
          return !!value;
        } else {
          return !!(Array.isArray(value) && ~value.indexOf(_value));
        }
      } else if (type === "radio") {
        return format(value, name) === _value;
      }

      return undefined;
    },

    onBlur: useConstantCallback(function (event) {
      state.blur();

      if (formatOnBlur) {
        /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */
        var fieldState = form.getFieldState(state.name);
        state.change(format(fieldState.value, state.name));
      }
    }),
    onChange: useConstantCallback(function (event) {
      // istanbul ignore next
      if (false) { var _value2, unknown, targetType; }

      var value = event && event.target ? getValue(event, state.value, _value, isReactNative) : event;
      state.change(parse(value, name));
    }),
    onFocus: useConstantCallback(function (event) {
      return state.focus();
    })
  };

  if (multiple) {
    input.multiple = multiple;
  }

  if (type !== undefined) {
    input.type = type;
  }

  var renderProps = {
    input: input,
    meta: meta
  }; // assign to force Flow check

  return renderProps;
}

var _excluded = ["afterSubmit", "allowNull", "beforeSubmit", "children", "component", "data", "defaultValue", "format", "formatOnBlur", "initialValue", "isEqual", "multiple", "name", "parse", "subscription", "type", "validate", "validateFields", "value"];
var Field = /*#__PURE__*/react.forwardRef(function Field(_ref, ref) {
  var afterSubmit = _ref.afterSubmit,
      allowNull = _ref.allowNull,
      beforeSubmit = _ref.beforeSubmit,
      children = _ref.children,
      component = _ref.component,
      data = _ref.data,
      defaultValue = _ref.defaultValue,
      format = _ref.format,
      formatOnBlur = _ref.formatOnBlur,
      initialValue = _ref.initialValue,
      isEqual = _ref.isEqual,
      multiple = _ref.multiple,
      name = _ref.name,
      parse = _ref.parse,
      subscription = _ref.subscription,
      type = _ref.type,
      validate = _ref.validate,
      validateFields = _ref.validateFields,
      value = _ref.value,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);

  var field = useField(name, {
    afterSubmit: afterSubmit,
    allowNull: allowNull,
    beforeSubmit: beforeSubmit,
    children: children,
    component: component,
    data: data,
    defaultValue: defaultValue,
    format: format,
    formatOnBlur: formatOnBlur,
    initialValue: initialValue,
    isEqual: isEqual,
    multiple: multiple,
    parse: parse,
    subscription: subscription,
    type: type,
    validate: validate,
    validateFields: validateFields,
    value: value
  });

  if (typeof children === "function") {
    return children((0,esm_extends/* default */.Z)({}, field, rest));
  }

  if (typeof component === "string") {
    // ignore meta, combine input with any other props
    return /*#__PURE__*/react.createElement(component, (0,esm_extends/* default */.Z)({}, field.input, {
      children: children,
      ref: ref
    }, rest));
  }

  if (!name) {
    throw new Error("prop name cannot be undefined in <Field> component");
  }

  return renderComponent((0,esm_extends/* default */.Z)({
    children: children,
    component: component,
    ref: ref
  }, rest), field, "Field(" + name + ")");
});

function withTypes() {
  return {
    Form: ReactFinalForm,
    FormSpy: FormSpy
  };
}




/***/ }),

/***/ 57971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ es2015; }
});

// UNUSED EXPORTS: AutoFocusInside, FocusLockUI, FreeFocusInside, InFocusGuard, MoveFocusInside, useFocusInside

// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(66017);
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(20011);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/constants.js
/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

;// CONCATENATED MODULE: ../../../node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ../../../node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue || null, function (newValue) { return refs.forEach(function (ref) { return assignRef(ref, newValue); }); });
}

;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/FocusGuard.js


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /*#__PURE__*/react.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

InFocusGuard.propTypes =  false ? 0 : {};
InFocusGuard.defaultProps = {
  children: null
};
/* harmony default export */ var FocusGuard = ((/* unused pure expression or super */ null && (InFocusGuard)));
;// CONCATENATED MODULE: ../../../node_modules/use-sidecar/node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});

;// CONCATENATED MODULE: ../../../node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/medium.js

var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true // focus-lock sidecar is not required on the server
  // however, it might be required for JSDOM tests
  // ssr: true,

});
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/Lock.js








var emptyArray = [];
var FocusLock = /*#__PURE__*/react.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;

  var _React$useState = react.useState(),
      realObserved = _React$useState[0],
      setObserved = _React$useState[1];

  var observed = react.useRef();
  var isActive = react.useRef(false);
  var originalFocusedElement = react.useRef(null);
  var children = props.children,
      disabled = props.disabled,
      noFocusGuards = props.noFocusGuards,
      persistentFocus = props.persistentFocus,
      crossFrame = props.crossFrame,
      autoFocus = props.autoFocus,
      allowTextSelection = props.allowTextSelection,
      group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      hasPositiveIndices = props.hasPositiveIndices,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      shouldReturnFocus = props.returnFocus,
      focusOptions = props.focusOptions,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;

  var _React$useState2 = react.useState({}),
      id = _React$useState2[0]; // SIDE EFFECT CALLBACKS


  var onActivation = react.useCallback(function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;

    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }

    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = react.useCallback(function () {
    isActive.current = false;

    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  (0,react.useEffect)(function () {
    if (!disabled) {
      // cleanup return focus on trap deactivation
      // sideEffect/returnFocus should happen by this time
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = react.useCallback(function (allowDefer) {
    var returnFocusTo = originalFocusedElement.current;

    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;

      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;

        if (allowDefer) {
          // React might return focus after update
          // it's safer to defer the action
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = react.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = react.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);

  if (false) {}

  var lockProps = (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);

  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  // nearest focus guard
  react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), // first tabbed element guard
  hasPositiveIndices ? /*#__PURE__*/react.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/react.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions
  }), /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && /*#__PURE__*/react.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes =  false ? 0 : {};
FocusLock.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  focusOptions: undefined,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  hasPositiveIndices: undefined,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
/* harmony default export */ var Lock = (FocusLock);
;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(36655);
;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ../../../node_modules/react-clientside-effect/lib/index.es.js




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {}

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {}

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/react.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(react.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ var index_es = (withSideEffect);

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/array.js
/*
IE11 support
 */
var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/is.js

var isElementHidden = function (node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var getParentNode = function (node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node.parentNode.host
        : node.parentNode;
};
var isTopNode = function (node) {
    // @ts-ignore
    return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
};
var isVisibleUncached = function (node, checkParent) {
    return !node || isTopNode(node) || (!isElementHidden(node) && checkParent(getParentNode(node)));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function (node, checkParent) {
    return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false) : true;
};
var isAutoFocusAllowedCached = function (cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function (node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function (node) {
    var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
    return ![true, 'true', ''].includes(attribute);
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/tabOrder.js

var tabSort = function (a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) {
            return 1;
        }
        if (!b.tabIndex) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) { return ({
        node: node,
        index: index,
        tabIndex: keepGuards && node.tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : node.tabIndex,
    }); })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/tabbables.js
/**
 * list of the object to be considered as focusable
 */
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/tabUtils.js



var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function (parent, withGuards) {
    return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function (parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        return getFocusables([parent.contentDocument.body], withGuards);
    }
    return [parent];
};
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
        return acc.concat(
        // add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, 
        // add if node is tabbable itself
        parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/DOMutils.js




/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var filterAutoFocusable = function (nodes, cache) {
    if (cache === void 0) { cache = new Map(); }
    return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
};
/**
 * !__WARNING__! Low level API.
 * @returns all tabbable nodes
 *
 * @see {@link getFocusableNodes} to get any focusable element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * !__WARNING__! Low level API.
 *
 * @returns anything "focusable", not only tabbable. The difference is in `tabIndex=-1`
 * (without guards, as long as they are not expected to be ever focused)
 *
 * @see {@link getTabbableNodes} to get only tabble nodes element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getFocusableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var contains = function (scope, element) {
    if (scope.shadowRoot) {
        return contains(scope.shadowRoot, element);
    }
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined &&
            Object.getPrototypeOf(scope).contains.call(scope, element)) {
            return true;
        }
        return toArray(scope.children).some(function (child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) {
                    return contains(iframeBody, element);
                }
                return false;
            }
            return contains(child, element);
        });
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
/**
 * returns active element from document or from nested shadowdoms
 */

/**
 * returns current active element. If the active element is a "container" itself(shadowRoot or iframe) returns active element inside it
 * @param [inDocument]
 */
var getActiveElement = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    if (!inDocument || !inDocument.activeElement) {
        return undefined;
    }
    var activeElement = inDocument.activeElement;
    return (activeElement.shadowRoot
        ? getActiveElement(activeElement.shadowRoot)
        : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
            ? getActiveElement(activeElement.contentWindow.document)
            : activeElement);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusIsHidden.js




/**
 * checks if focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 *
 * This is a utility function coupled with {@link FOCUS_ALLOW} constant
 *
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    var activeElement = getActiveElement(inDocument);
    if (!activeElement) {
        return false;
    }
    // this does not support setting FOCUS_ALLOW within shadow dom
    return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains(node, activeElement); });
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/all-affected.js


/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            /* eslint-disable no-bitwise */
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
            /* eslint-enable */
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node - node or nodes to look inside
 * @returns Element[]
 */
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusInside.js




var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
var focusInsideIframe = function (topNode, activeElement) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes.
 * Supports nodes hidden inside shadowDom
 */
var focusInside = function (topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) { activeElement = getActiveElement(getFirst(topNode).ownerDocument); }
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).some(function (node) {
        return contains(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/commands.js
var focusOn = function (target, focusOptions) {
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/correctFocus.js

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function (nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    // using filter to support IE11
    return nodes.filter(function (node) { return resultSet.has(node); });
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/firstFocus.js

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, index) {
    if (nodes.length > 1) {
        return nodes.indexOf(correctNode(nodes[index], nodes));
    }
    return index;
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/solver.js



var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function (innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = pickFocusable(innerNodes, 0);
    var returnLastNode = pickFocusable(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    // old focus
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
        return lastNodeInside;
    }
    // focus above lock
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    // focus below lock
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/auto-focus.js



var findAutoFocused = function (autoFocusables) {
    return function (node) {
        var _a;
        var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return (
        // @ts-expect-error
        node.autofocus ||
            //
            (autofocus !== undefined && autofocus !== 'false') ||
            //
            autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) {
        return pickFirstFocus(autoFocusable);
    }
    return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/parenting.js



var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode.host || node.parentNode, parents);
    }
    return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || contains(common, topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusSolver.js








var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    // remap to dstNodes
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
/**
 * contains the main logic of the `focus-lock` package.
 *
 * ! you probably dont need this function !
 *
 * given top node(s) and the last active element returns the element to be focused next
 * @returns element which should be focused to move focus inside
 * @param topNode
 * @param lastNode
 */
var focusSolver = function (topNode, lastNode) {
    var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getFocusableNodes(entries, visibilityCache);
    var innerElements = getTabbableNodes(entries, visibilityCache).filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) {
            return undefined;
        }
    }
    var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var focusNode = pickAutofocus(anyFocusable, innerNodes, allParentAutofocusables(entries, visibilityCache));
        if (focusNode) {
            return { node: focusNode };
        }
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/moveFocusInside.js


var guardCount = 0;
var lockDisabled = false;
/**
 * The main functionality of the focus-lock package
 *
 * Contains focus at a given node.
 * The last focused element will help to determine which element(first or last) should be focused.
 * The found element will be focused.
 *
 * This is one time action (move), not a persistent focus-lock
 *
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @see {@link focusSolver} for the same functionality without autofocus
 */
var moveFocusInside = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = focusSolver(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/
        if (guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusables.js




/**
 * @returns list of focusable elements inside a given top node
 * @see {@link getFocusableNodes} for lower level access
 */
var expandFocusableNodes = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = getTabbableNodes([commonParent], visibilityCache, true);
    var innerElements = getTabbableNodes(entries, visibilityCache)
        .filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    })
        .map(function (_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  setTimeout(action, 1);
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/Trap.js
/* eslint-disable no-mixed-operators */







var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    // with cross frame return true for any value
    return Boolean(focusWasOutsideWindow);
  } // in other case return only of focus went a while aho


  return focusWasOutsideWindow === 'meanwhile';
};

var checkInHost = function checkInHost(check, el, boundary) {
  return el && ( // find host equal to active element and check nested active element
  el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) // dive up
  || el.parentNode && checkInHost(check, el.parentNode, boundary));
};

var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards,
        crossFrame = _lastActiveTrap.crossFrame,
        focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !( // active element is "inside" working area
          focusInside(workingArea) || // check for shadow-dom contained elements
          activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              // Check if blur() exists, which is missing on certain elements on IE
              if (activeElement.blur) {
                activeElement.blur();
              }

              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);

        if (focusedIndex > -1) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return deferAction(activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/react.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};

FocusTrap.propTypes =  false ? 0 : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction

  deferAction(function () {
    focusWasOutsideWindow = 'meanwhile';
  });
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}

function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];

  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium


mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb({
    moveFocusInside: moveFocusInside,
    focusInside: focusInside
  });
});
/* harmony default export */ var Trap = (index_es(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/Combination.js





/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/

var FocusLockCombination = /*#__PURE__*/react.forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/react.createElement(Lock, (0,esm_extends/* default */.Z)({
    sideCar: Trap,
    ref: ref
  }, props));
});

var _ref = Lock.propTypes || {},
    sideCar = _ref.sideCar,
    propTypes = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["sideCar"]);

FocusLockCombination.propTypes =  false ? 0 : {};
/* harmony default export */ var Combination = (FocusLockCombination);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/index.js


/* harmony default export */ var es2015 = (Combination);

/***/ }),

/***/ 45115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(32735);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60216);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      } else {
        options = {
          passive: false
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports["default"] = InfiniteScroll;
module.exports = exports['default'];


/***/ }),

/***/ 23712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(45115)


/***/ }),

/***/ 77224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(32735);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60216);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscribeUiEvent = __webpack_require__(68131);

var _classnames = __webpack_require__(40841);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(55007);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform';

// global variable for all instances
var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = (function (_Component) {
    _inherits(Sticky, _Component);

    function Sticky(props, context) {
        _classCallCheck(this, Sticky);

        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollStart = this.handleScrollStart.bind(this);
        this.delta = 0;
        this.stickyTop = 0;
        this.stickyBottom = 0;
        this.frozen = false;
        this.skipNextScrollEvent = false;
        this.scrollTop = -1;

        this.bottomBoundaryTarget;
        this.topTarget;
        this.subscribers;

        this.state = {
            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
            width: 0, // Sticky width
            height: 0, // Sticky height
            x: 0, // The original x of Sticky
            y: 0, // The original y of Sticky
            topBoundary: 0, // The top boundary on document
            bottomBoundary: Infinity, // The bottom boundary on document
            status: STATUS_ORIGINAL, // The Sticky status
            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
        };
    }

    _createClass(Sticky, [{
        key: 'getTargetHeight',
        value: function getTargetHeight(target) {
            return target && target.offsetHeight || 0;
        }
    }, {
        key: 'getTopPosition',
        value: function getTopPosition(top) {
            // a top argument can be provided to override reading from the props
            top = top || this.props.top || 0;
            if (typeof top === 'string') {
                if (!this.topTarget) {
                    this.topTarget = doc.querySelector(top);
                }
                top = this.getTargetHeight(this.topTarget);
            }
            return top;
        }
    }, {
        key: 'getTargetBottom',
        value: function getTargetBottom(target) {
            if (!target) {
                return -1;
            }
            var rect = target.getBoundingClientRect();
            return this.scrollTop + rect.bottom;
        }
    }, {
        key: 'getBottomBoundary',
        value: function getBottomBoundary(bottomBoundary) {
            // a bottomBoundary can be provided to avoid reading from the props
            var boundary = bottomBoundary || this.props.bottomBoundary;

            // TODO, bottomBoundary was an object, depricate it later.
            if (typeof boundary === 'object') {
                boundary = boundary.value || boundary.target || 0;
            }

            if (typeof boundary === 'string') {
                if (!this.bottomBoundaryTarget) {
                    this.bottomBoundaryTarget = doc.querySelector(boundary);
                }
                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
            }
            return boundary && boundary > 0 ? boundary : Infinity;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.setState({
                status: STATUS_ORIGINAL,
                pos: 0
            });
        }
    }, {
        key: 'release',
        value: function release(pos) {
            this.setState({
                status: STATUS_RELEASED,
                pos: pos - this.state.y
            });
        }
    }, {
        key: 'fix',
        value: function fix(pos) {
            this.setState({
                status: STATUS_FIXED,
                pos: pos
            });
        }

        /**
         * Update the initial position, width, and height. It should update whenever children change.
         * @param {Object} options optional top and bottomBoundary new values
         */
    }, {
        key: 'updateInitialDimension',
        value: function updateInitialDimension(options) {
            options = options || {};

            var outerRect = this.outerElement.getBoundingClientRect();
            var innerRect = this.innerElement.getBoundingClientRect();

            var width = outerRect.width || outerRect.right - outerRect.left;
            var height = innerRect.height || innerRect.bottom - innerRect.top;;
            var outerY = outerRect.top + this.scrollTop;

            this.setState({
                top: this.getTopPosition(options.top),
                bottom: Math.min(this.state.top + height, winHeight),
                width: width,
                height: height,
                x: outerRect.left,
                y: outerY,
                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
                topBoundary: outerY
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize(e, ae) {
            if (this.props.shouldFreeze()) {
                return;
            }

            winHeight = ae.resize.height;
            this.updateInitialDimension();
            this.update();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart(e, ae) {
            this.frozen = this.props.shouldFreeze();

            if (this.frozen) {
                return;
            }

            if (this.scrollTop === ae.scroll.top) {
                // Scroll position hasn't changed,
                // do nothing
                this.skipNextScrollEvent = true;
            } else {
                this.scrollTop = ae.scroll.top;
                this.updateInitialDimension();
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e, ae) {
            // Scroll doesn't need to be handled
            if (this.skipNextScrollEvent) {
                this.skipNextScrollEvent = false;
                return;
            }

            scrollDelta = ae.scroll.delta;
            this.scrollTop = ae.scroll.top;
            this.update();
        }

        /**
         * Update Sticky position.
         */
    }, {
        key: 'update',
        value: function update() {
            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

            if (disabled) {
                if (this.state.status !== STATUS_ORIGINAL) {
                    this.reset();
                }
                return;
            }

            var delta = scrollDelta;
            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
            // on document from viewport.
            var top = this.scrollTop + this.state.top;
            var bottom = this.scrollTop + this.state.bottom;

            // There are 2 principles to make sure Sticky won't get wrong so much:
            // 1. Reset Sticky to the original postion when "top" <= topBoundary
            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
            if (top <= this.state.topBoundary) {
                // #1
                this.reset();
            } else if (bottom >= this.state.bottomBoundary) {
                // #2
                this.stickyBottom = this.state.bottomBoundary;
                this.stickyTop = this.stickyBottom - this.state.height;
                this.release(this.stickyTop);
            } else {
                if (this.state.height > winHeight - this.state.top) {
                    // In this case, Sticky is higher then viewport minus top offset
                    switch (this.state.status) {
                        case STATUS_ORIGINAL:
                            this.release(this.state.y);
                            this.stickyTop = this.state.y;
                            this.stickyBottom = this.stickyTop + this.state.height;
                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
                        // from ORIGINAL when calling window.scrollTo().
                        // break;
                        case STATUS_RELEASED:
                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
                            this.stickyBottom = this.stickyTop + this.state.height;
                            if (delta > 0 && bottom > this.stickyBottom) {
                                this.fix(this.state.bottom - this.state.height);
                            } else if (delta < 0 && top < this.stickyTop) {
                                this.fix(this.state.top);
                            }
                            break;
                        case STATUS_FIXED:
                            var toRelease = true;
                            var pos = this.state.pos;
                            var height = this.state.height;
                            // In regular cases, when Sticky is in FIXED status,
                            // 1. it's top will stick to the screen top,
                            // 2. it's bottom will stick to the screen bottom,
                            // 3. if not the cases above, then it's height gets changed
                            if (delta > 0 && pos === this.state.top) {
                                // case 1, and scrolling down
                                this.stickyTop = top - delta;
                                this.stickyBottom = this.stickyTop + height;
                            } else if (delta < 0 && pos === this.state.bottom - height) {
                                // case 2, and scrolling up
                                this.stickyBottom = bottom - delta;
                                this.stickyTop = this.stickyBottom - height;
                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                                // case 3
                                // This case only happens when Sticky's bottom sticks to the screen bottom and
                                // its height gets changed. Sticky should be in RELEASE status and update its
                                // sticky bottom by calculating how much height it changed.
                                var deltaHeight = pos + height - this.state.bottom;
                                this.stickyBottom = bottom - delta + deltaHeight;
                                this.stickyTop = this.stickyBottom - height;
                            } else {
                                toRelease = false;
                            }

                            if (toRelease) {
                                this.release(this.stickyTop);
                            }
                            break;
                    }
                } else {
                    // In this case, Sticky is shorter then viewport minus top offset
                    // and will always fix to the top offset of viewport
                    this.fix(this.state.top);
                }
            }
            this.delta = delta;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this = this;

            if (prevState.status !== this.state.status && this.props.onStateChange) {
                this.props.onStateChange({ status: this.state.status });
            }
            var arePropsChanged = !(0, _shallowequal2['default'])(this.props, prevProps);
            if (arePropsChanged) {
                // if the props for enabling are toggled, then trigger the update or reset depending on the current props
                if (prevProps.enabled !== this.props.enabled) {
                    if (this.props.enabled) {
                        this.setState({ activated: true }, function () {
                            _this.updateInitialDimension();
                            _this.update();
                        });
                    } else {
                        this.setState({ activated: false }, function () {
                            _this.reset();
                        });
                    }
                }
                // if the top or bottomBoundary props were changed, then trigger the update
                else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
                        this.updateInitialDimension();
                        this.update();
                    }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var subscribers = this.subscribers || [];
            for (var i = subscribers.length - 1; i >= 0; i--) {
                this.subscribers[i].unsubscribe();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Only initialize the globals if this is the first
            // time this component type has been mounted
            if (!win) {
                win = window;
                doc = document;
                docEl = doc.documentElement;
                docBody = doc.body;
                winHeight = win.innerHeight || docEl.clientHeight;
                M = window.Modernizr;
                // No Sticky on lower-end browser when no Modernizr
                if (M && M.prefixed) {
                    canEnableTransforms = M.csstransforms3d;
                    TRANSFORM_PROP = M.prefixed('transform');
                }
            }

            // when mount, the scrollTop is not necessary on the top
            this.scrollTop = docBody.scrollTop + docEl.scrollTop;

            if (this.props.enabled) {
                this.setState({ activated: true });
                this.updateInitialDimension();
                this.update();
            }
            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
        }
    }, {
        key: 'translate',
        value: function translate(style, pos) {
            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
            if (enableTransforms && this.state.activated) {
                style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
            } else {
                style.top = pos + 'px';
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !this.props.shouldFreeze() && !((0, _shallowequal2['default'])(this.props, nextProps) && (0, _shallowequal2['default'])(this.state, nextState));
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
            var innerStyle = {
                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
                top: this.state.status === STATUS_FIXED ? '0px' : '',
                zIndex: this.props.innerZ
            };
            var outerStyle = {};

            // always use translate3d to enhance the performance
            this.translate(innerStyle, this.state.pos);
            if (this.state.status !== STATUS_ORIGINAL) {
                innerStyle.width = this.state.width + 'px';
                outerStyle.height = this.state.height + 'px';
            }

            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));

            var children = this.props.children;

            return _react2['default'].createElement(
                'div',
                { ref: function (outer) {
                        _this2.outerElement = outer;
                    }, className: outerClasses, style: outerStyle },
                _react2['default'].createElement(
                    'div',
                    { ref: function (inner) {
                            _this2.innerElement = inner;
                        }, className: ['sticky-inner-wrapper', this.props.innerClass].join(' '), style: innerStyle },
                    typeof children === 'function' ? children({ status: this.state.status }) : children
                )
            );
        }
    }]);

    return Sticky;
})(_react.Component);

Sticky.displayName = 'Sticky';

Sticky.defaultProps = {
    shouldFreeze: function shouldFreeze() {
        return false;
    },
    enabled: true,
    top: 0,
    bottomBoundary: 0,
    enableTransforms: true,
    activeClass: 'active',
    releasedClass: 'released',
    onStateChange: null,
    innerClass: ''
};

/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */
Sticky.propTypes = {
    enabled: _propTypes2['default'].bool,
    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
    _propTypes2['default'].string, _propTypes2['default'].number]),
    enableTransforms: _propTypes2['default'].bool,
    activeClass: _propTypes2['default'].string,
    releasedClass: _propTypes2['default'].string,
    innerClass: _propTypes2['default'].string,
    onStateChange: _propTypes2['default'].func,
    shouldFreeze: _propTypes2['default'].func,
    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
};

Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;

module.exports = Sticky;


/***/ }),

/***/ 75690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77224);


/***/ }),

/***/ 29745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setFunctionName = __webpack_require__(41408);

var $Object = Object;
var $TypeError = TypeError;

module.exports = setFunctionName(function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.unicodeSets) {
		result += 'v';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
}, 'get flags', true);



/***/ }),

/***/ 81861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(26506);
var callBind = __webpack_require__(73235);

var implementation = __webpack_require__(29745);
var getPolyfill = __webpack_require__(33214);
var shim = __webpack_require__(15233);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),

/***/ 33214:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(29745);

var supportsDescriptors = (__webpack_require__(26506).supportsDescriptors);
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),

/***/ 15233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var supportsDescriptors = (__webpack_require__(26506).supportsDescriptors);
var getPolyfill = __webpack_require__(33214);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),

/***/ 1744:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var define = __webpack_require__(27892);
var hasDescriptors = __webpack_require__(42320)();
var gOPD = __webpack_require__(41455);

var $TypeError = GetIntrinsic('%TypeError%');
var $floor = GetIntrinsic('%Math.floor%');

module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(fn, 'length', length, true, true);
		} else {
			define(fn, 'length', length);
		}
	}
	return fn;
};


/***/ }),

/***/ 41408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(27892);
var hasDescriptors = __webpack_require__(42320)();
var functionsHaveConfigurableNames = (__webpack_require__(34019).functionsHaveConfigurableNames)();

var $TypeError = TypeError;

module.exports = function setFunctionName(fn, name) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	var loose = arguments.length > 2 && !!arguments[2];
	if (!loose || functionsHaveConfigurableNames) {
		if (hasDescriptors) {
			define(fn, 'name', name, true, true);
		} else {
			define(fn, 'name', name);
		}
	}
	return fn;
};


/***/ }),

/***/ 55007:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 62538:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var callBound = __webpack_require__(47737);
var inspect = __webpack_require__(48683);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 48683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(88758);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (obj === __webpack_require__.g) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 52719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var SLOT = __webpack_require__(86154);

var $SyntaxError = SyntaxError;
var $StopIteration = typeof StopIteration === 'object' ? StopIteration : null;

module.exports = function getStopIterationIterator(origIterator) {
	if (!$StopIteration) {
		throw new $SyntaxError('this environment lacks StopIteration');
	}

	SLOT.set(origIterator, '[[Done]]', false);

	var siIterator = {
		next: function next() {
			var iterator = SLOT.get(this, '[[Iterator]]');
			var done = SLOT.get(iterator, '[[Done]]');
			try {
				return {
					done: done,
					value: done ? void undefined : iterator.next()
				};
			} catch (e) {
				SLOT.set(iterator, '[[Done]]', true);
				if (e !== $StopIteration) {
					throw e;
				}
				return {
					done: true,
					value: void undefined
				};
			}
		}
	};

	SLOT.set(siIterator, '[[Iterator]]', origIterator);

	return siIterator;
};


/***/ }),

/***/ 68131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "listen": function() { return /* binding */ index_es_listen; },
  "subscribe": function() { return /* binding */ index_es_subscribe; },
  "unsubscribe": function() { return /* binding */ index_es_unsubscribe; }
});

// EXTERNAL MODULE: ../../../node_modules/lodash/assign.js
var lodash_assign = __webpack_require__(36782);
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);
// EXTERNAL MODULE: ../../../node_modules/subscribe-ui-event/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__(25758);
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);
;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, options);
    window.removeEventListener('test', null, options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new (eventemitter3_default())(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: ../../../node_modules/lodash/clone.js
var clone = __webpack_require__(37032);
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);
// EXTERNAL MODULE: ../../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(33259);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ../../../node_modules/lodash/noop.js
var noop = __webpack_require__(13581);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent);

// EXTERNAL MODULE: ../../../node_modules/raf/index.js
var raf = __webpack_require__(48729);
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);
;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || (noop_default()), ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

;// CONCATENATED MODULE: ../../../node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ 25758:
/***/ (function(module) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ 22027:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

var _toConsumableArray = __webpack_require__(40299);
var _classCallCheck = __webpack_require__(62638);
var _createClass = __webpack_require__(1023);
var _assertThisInitialized = __webpack_require__(56121);
var _get = __webpack_require__(26480);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
var _defineProperty = __webpack_require__(93213);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };
    
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener){
    return this.removeListener(type, listener);
};

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ReplayEventEmitter = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](ReplayEventEmitter, _EventEmitter);

  var _super = _createSuper(ReplayEventEmitter);

  function ReplayEventEmitter() {
    var _this;

    _classCallCheck__default['default'](this, ReplayEventEmitter);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "eventHistory", new Map());

    return _this;
  }

  _createClass__default['default'](ReplayEventEmitter, [{
    key: "on",
    value: function on(event, listener) {
      return _get__default['default'](_getPrototypeOf__default['default'](ReplayEventEmitter.prototype), "on", this).call(this, event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      return _get__default['default'](_getPrototypeOf__default['default'](ReplayEventEmitter.prototype), "once", this).call(this, event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      return _get__default['default'](_getPrototypeOf__default['default'](ReplayEventEmitter.prototype), "off", this).call(this, event, listener);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this.eventHistory.set(event, args);
      return (_get2 = _get__default['default'](_getPrototypeOf__default['default'](ReplayEventEmitter.prototype), "emit", this)).call.apply(_get2, [this, event].concat(args));
    }
  }, {
    key: "addListener",
    value: function addListener(event, listener) {
      return _get__default['default'](_getPrototypeOf__default['default'](ReplayEventEmitter.prototype), "addListener", this).call(this, event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      return _get__default['default'](_getPrototypeOf__default['default'](ReplayEventEmitter.prototype), "removeListener", this).call(this, event, listener);
    }
  }, {
    key: "addListenerWithReplay",
    value: function addListenerWithReplay(event, listener) {
      var historyEntry = this.eventHistory.get(event);

      if (historyEntry !== undefined) {
        listener.apply(void 0, _toConsumableArray__default['default'](historyEntry));
      }

      return this.addListener(event, listener);
    }
  }, {
    key: "onWithReplay",
    value: function onWithReplay(event, listener) {
      return this.addListenerWithReplay(event, listener);
    }
  }]);

  return ReplayEventEmitter;
}(EventEmitter);

exports.ReplayEventEmitter = ReplayEventEmitter;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 25321:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/


Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(90614);
__webpack_require__(29978);
__webpack_require__(38110);
__webpack_require__(71227);
__webpack_require__(47995);
__webpack_require__(29282);
__webpack_require__(86283);
__webpack_require__(89615);
__webpack_require__(26847);
__webpack_require__(84874);
__webpack_require__(31415);
var _typeof = __webpack_require__(8114);
__webpack_require__(92979);
var _slicedToArray = __webpack_require__(98371);
__webpack_require__(93786);
__webpack_require__(14334);
__webpack_require__(80437);
var _toConsumableArray = __webpack_require__(40299);
var _createClass = __webpack_require__(1023);
var _classCallCheck = __webpack_require__(62638);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
__webpack_require__(11478);
__webpack_require__(94184);
__webpack_require__(16669);
__webpack_require__(77428);
__webpack_require__(39837);
__webpack_require__(83793);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);

var custom = function custom() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return {
    checks: checks
  };
};

function _createForOfIteratorHelper$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var type = function type() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$4(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _type = _step.value;

        if (typeof _type === "string") {
          isValid = isValid || _typeof__default["default"](value) === _type;
          expectedTypes.push("of type ".concat(_type));
          continue;
        }

        isValid = isValid || value instanceof _type;
        expectedTypes.push("an instance of ".concat(_type.name));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var literal = function literal() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return custom(function (value) {
    var isValid = false;
    var expectedTypes = [];

    var _iterator = _createForOfIteratorHelper$3(checks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;
        isValid = isValid || value === type;
        expectedTypes.push(typeof type === "string" ? "\"".concat(type, "\"") : "".concat(type));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [isValid, expectedTypes];
  });
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var runtimeTypeValidation = function runtimeTypeValidation(rules, values) {
  if (values.length > rules.length) {
    throw new Error("Expected at most ".concat(rules.length, " argument(s), but got ").concat(values.length));
  }

  while (values.length < rules.length) {
    values.push(undefined);
  }

  var _iterator = _createForOfIteratorHelper$2(values.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray__default["default"](_step.value, 2),
          index = _step$value[0],
          value = _step$value[1];

      var _validateValue = validateValue(rules[index], value),
          _validateValue2 = _slicedToArray__default["default"](_validateValue, 4),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2],
          delimeter = _validateValue2[3];

      if (isValid) {
        continue;
      }

      var argumentIndex = index + 1;
      throw new Error("Argument ".concat(argumentIndex, " is expected to be ").concat(expected).concat(delimeter, " but got ").concat(received));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var stringifyReceivedType = function stringifyReceivedType(value) {
  var _value$constructor;

  var receivedType;
  var types = ["undefined", "boolean", "number", "bigint", "string"];

  if (types.includes(_typeof__default["default"](value))) {
    receivedType = typeof value === "string" ? "\"".concat(value, "\"") : "".concat(value);
  }

  if (_typeof__default["default"](value) === "object" && (value === null || value === void 0 ? void 0 : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) !== "Object") {
    var _value$constructor2;

    receivedType = value === null ? "null" : "instance of ".concat(value === null || value === void 0 ? void 0 : (_value$constructor2 = value.constructor) === null || _value$constructor2 === void 0 ? void 0 : _value$constructor2.name);
  }

  if (!receivedType) {
    receivedType = _typeof__default["default"](value);
  }

  return receivedType;
};
/* eslint-disable @typescript-eslint/no-explicit-any */

var validateConstructorTypes = function validateConstructorTypes() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (ctor) {
    return /*#__PURE__*/function (_ctor) {
      _inherits__default["default"](_class, _ctor);

      var _super = _createSuper(_class);

      function _class() {
        _classCallCheck__default["default"](this, _class);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        runtimeTypeValidation(finalRuleSet, args);
        return _super.call.apply(_super, [this].concat(args));
      }

      return _createClass__default["default"](_class);
    }(ctor);
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any */

var validateTypes = function validateTypes() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypes decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      runtimeTypeValidation(finalRuleSet, args);
      return originalMethod.apply(this, args);
    };
  };
};
var validateTypesAsync = function validateTypesAsync() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var finalRuleSet = convertRuleArguments(args);
  return function (target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    }

    var originalMethod = descriptor.value;

    descriptor.value = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      try {
        runtimeTypeValidation(finalRuleSet, args);
      } catch (e) {
        return Promise.reject(e);
      }

      return originalMethod.apply(this, args);
    };
  };
};
var convertRuleArguments = function convertRuleArguments(args) {
  var finalRuleDefinitionSet = [];

  var _iterator2 = _createForOfIteratorHelper$2(args),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var arg = _step2.value;
      finalRuleDefinitionSet.push(convertRuleArgument(arg));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return finalRuleDefinitionSet;
};
var convertRuleArgument = function convertRuleArgument(arg) {
  var finalArgumentRuleDefinitions = [];
  var declaredRules = Array.isArray(arg) ? arg : [arg];

  var _iterator3 = _createForOfIteratorHelper$2(declaredRules),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var rule = _step3.value;

      if (typeof rule === "string" || typeof rule === "function") {
        finalArgumentRuleDefinitions.push(type(rule));
        continue;
      }

      finalArgumentRuleDefinitions.push(rule);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return finalArgumentRuleDefinitions;
};
var validateValue = function validateValue(ruleDefinitions, value) {
  var expectedTypes = [];
  var customReceivedType;
  var isValid = false;

  var _iterator4 = _createForOfIteratorHelper$2(ruleDefinitions),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var definition = _step4.value;

      var _iterator5 = _createForOfIteratorHelper$2(definition.checks),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var check = _step5.value;

          var _check = check(value),
              _check2 = _slicedToArray__default["default"](_check, 3),
              checkPassed = _check2[0],
              typeDescription = _check2[1],
              _receivedType = _check2[2];

          isValid = isValid || checkPassed;

          if (!customReceivedType && _receivedType) {
            customReceivedType = _receivedType;
          }

          if (typeDescription) {
            expectedTypes = typeof typeDescription === "string" ? [].concat(_toConsumableArray__default["default"](expectedTypes), [typeDescription]) : [].concat(_toConsumableArray__default["default"](expectedTypes), _toConsumableArray__default["default"](typeDescription));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (isValid) {
    return [true];
  }

  var receivedType = customReceivedType || stringifyReceivedType(value);
  var lastIndex = expectedTypes.length - 1;
  var expectedTypesString = lastIndex > 0 ? "".concat(expectedTypes.slice(0, lastIndex).join(", "), " or ").concat(expectedTypes[lastIndex]) : expectedTypes.join(", ");
  return [false, receivedType, expectedTypesString, lastIndex > 1 ? ";" : ","];
};

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var nonEmptyArray = function nonEmptyArray(name, rules) {
  return custom(function (value) {
    if (!Array.isArray(value) || value.length < 1) {
      return [false, "a non-empty array of ".concat(name)];
    }

    var _iterator = _createForOfIteratorHelper$1(value.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray__default["default"](_step.value, 2),
            key = _step$value[0],
            valueOfKey = _step$value[1];

        var _validateValue = validateValue(convertRuleArgument(rules), valueOfKey),
            _validateValue2 = _slicedToArray__default["default"](_validateValue, 3),
            isValid = _validateValue2[0],
            received = _validateValue2[1],
            expected = _validateValue2[2];

        if (!isValid) {
          return [false, "a valid non-empty array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [true];
  });
};

var nonEmptyString = custom(function (value) {
  return [typeof value === "string" && value.length > 0, "a non-empty string"];
});

var nonNegativeInteger = custom(function (value) {
  return [typeof value === "number" && Number.isInteger(value) && value >= 0, "a non-negative integer"];
});

var pureObject = custom(function (value) {
  return [_typeof__default["default"](value) === "object" && value !== null && !Array.isArray(value), "a pure object (non-null and non-array)"];
});

var objectSchema = function objectSchema(name, schema) {
  return custom(function (object) {
    if (_typeof__default["default"](object) !== "object" || object === null || Array.isArray(object)) {
      return [false, "valid ".concat(name, " (should be a pure object)")];
    }

    for (var _i = 0, _Object$entries = Object.entries(schema); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default["default"](_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          rules = _Object$entries$_i[1];

      var _validateValue = validateValue(convertRuleArgument(rules), object[key]),
          _validateValue2 = _slicedToArray__default["default"](_validateValue, 3),
          isValid = _validateValue2[0],
          received = _validateValue2[1],
          expected = _validateValue2[2];

      if (!isValid) {
        return [false, "valid ".concat(name, " (key \"").concat(key, "\" should be ").concat(expected, ")"), "malformed ".concat(name, " (key \"").concat(key, "\" is ").concat(received, ")")];
      }
    }

    return [true];
  });
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var array = function array(name, rules) {
  return custom(function (value) {
    if (!Array.isArray(value)) {
      return [false, "an array of ".concat(name)];
    }

    var _iterator = _createForOfIteratorHelper(value.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray__default["default"](_step.value, 2),
            key = _step$value[0],
            valueOfKey = _step$value[1];

        var _validateValue = validateValue(convertRuleArgument(rules), valueOfKey),
            _validateValue2 = _slicedToArray__default["default"](_validateValue, 3),
            isValid = _validateValue2[0],
            received = _validateValue2[1],
            expected = _validateValue2[2];

        if (!isValid) {
          return [false, "a valid array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [true];
  });
};

exports.array = array;
exports.custom = custom;
exports.literal = literal;
exports.nonEmptyArray = nonEmptyArray;
exports.nonEmptyString = nonEmptyString;
exports.nonNegativeInteger = nonNegativeInteger;
exports.objectSchema = objectSchema;
exports.pureObject = pureObject;
exports.runtimeTypeValidation = runtimeTypeValidation;
exports.stringifyReceivedType = stringifyReceivedType;
exports.type = type;
exports.validateConstructorTypes = validateConstructorTypes;
exports.validateTypes = validateTypes;
exports.validateTypesAsync = validateTypesAsync;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 99469:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2016, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes javascript-state-machine under the following license.

    Copyright (c) 2012, 2013, 2014, 2015, Jake Gordon and contributors

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.


*/


var global =
  typeof global !== "undefined"
    ? global
    : typeof self !== "undefined"
    ? self
    : typeof window !== "undefined"
    ? window
    : {};

Object.defineProperty(exports, "__esModule", ({ value: true }));

__webpack_require__(80437);
var _asyncToGenerator = __webpack_require__(20164);
var _createClass = __webpack_require__(1023);
var _assertThisInitialized = __webpack_require__(56121);
var _get = __webpack_require__(26480);
var _inherits = __webpack_require__(40126);
var _possibleConstructorReturn = __webpack_require__(3310);
var _getPrototypeOf = __webpack_require__(94692);
var _classCallCheck = __webpack_require__(62638);
var _defineProperty = __webpack_require__(93213);
var _regeneratorRuntime = __webpack_require__(72975);
__webpack_require__(93786);
__webpack_require__(29978);
__webpack_require__(34365);
__webpack_require__(16669);
__webpack_require__(16822);
var _typeof = __webpack_require__(8114);
var declarativeTypeValidator = __webpack_require__(79627);
__webpack_require__(38110);
__webpack_require__(71227);
var loglevelLog = __webpack_require__(33108);
__webpack_require__(84874);
__webpack_require__(86800);
__webpack_require__(31415);
__webpack_require__(86283);
__webpack_require__(89615);
__webpack_require__(94184);
var StateMachine = __webpack_require__(47683);
var uuid = __webpack_require__(24819);
__webpack_require__(47995);
__webpack_require__(9280);
__webpack_require__(39837);
__webpack_require__(66786);
__webpack_require__(21262);
__webpack_require__(92453);
__webpack_require__(15087);
__webpack_require__(83061);
__webpack_require__(51146);
__webpack_require__(22752);
__webpack_require__(24222);
__webpack_require__(99260);
__webpack_require__(77644);
__webpack_require__(965);
__webpack_require__(84946);
__webpack_require__(19381);
__webpack_require__(4768);
__webpack_require__(8425);
__webpack_require__(95243);
__webpack_require__(9991);
__webpack_require__(86590);
__webpack_require__(8502);
__webpack_require__(95611);
__webpack_require__(34640);
__webpack_require__(60070);
__webpack_require__(29829);
__webpack_require__(86167);
__webpack_require__(74643);
var _wrapNativeSuper = __webpack_require__(17164);
__webpack_require__(90061);
__webpack_require__(24477);
__webpack_require__(61765);
__webpack_require__(98484);
__webpack_require__(96775);
var operationRetrier = __webpack_require__(65803);
__webpack_require__(12702);
var platform = __webpack_require__(89916);
__webpack_require__(92048);
__webpack_require__(80383);
__webpack_require__(1183);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var loglevelLog__namespace = /*#__PURE__*/_interopNamespace(loglevelLog);
var StateMachine__namespace = /*#__PURE__*/_interopNamespace(StateMachine);
var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultLegacy(_wrapNativeSuper);
var platform__namespace = /*#__PURE__*/_interopNamespace(platform);

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default['default'](Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default['default'](Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };
    
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener){
    return this.removeListener(type, listener);
};

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

var log = loglevelLog__namespace.getLogger("twilsock"); // twilsock is used by Flex SDK. Please DO NOT change

function prepareLine(prefix, args) {
  return ["".concat(new Date().toISOString(), " Twilsock ").concat(prefix, ":")].concat(Array.from(args));
}

var Logger = /*#__PURE__*/function () {
  function Logger(prefix) {
    _classCallCheck__default['default'](this, Logger);

    _defineProperty__default['default'](this, "prefix", "");

    this.prefix = prefix !== null && prefix !== undefined && prefix.length > 0 ? " " + prefix + ":" : "";
  }

  _createClass__default['default'](Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      log.setLevel(level);
    }
  }, {
    key: "trace",
    value: function trace() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      log.trace.apply(null, prepareLine("T", args));
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      log.debug.apply(null, prepareLine("D", args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      log.info.apply(null, prepareLine("I", args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      log.warn.apply(null, prepareLine("W", args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      log.error.apply(null, prepareLine("E", args));
    }
  }], [{
    key: "setLevel",
    value: function setLevel(level) {
      log.setLevel(level);
    }
  }, {
    key: "trace",
    value: function trace() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      log.trace.apply(null, prepareLine("T", args));
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      log.debug.apply(null, prepareLine("D", args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      log.info.apply(null, prepareLine("I", args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      log.warn.apply(null, prepareLine("W", args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      log.error.apply(null, prepareLine("E", args));
    }
  }]);

  return Logger;
}();

var logInstance = new Logger("");

var version = "0.12.2";

/**
 * Settings container for the Twilsock client library
 */

var Configuration = /*#__PURE__*/function () {
  /**
   * @param {String} token - authentication token
   * @param {Object} options - options to override defaults
   */
  function Configuration(token, activeGrant, options) {
    _classCallCheck__default['default'](this, Configuration);

    _defineProperty__default['default'](this, "confirmedCapabilities", new Set());

    this.activeGrant = activeGrant;
    this._token = token;
    var region = options.region || "us1";
    var defaultTwilsockUrl = "wss://tsock.".concat(region, ".twilio.com/v3/wsconnect");
    var twilsockOptions = options.twilsock || options.Twilsock || {};
    this.url = twilsockOptions.uri || defaultTwilsockUrl;
    this._continuationToken = options.continuationToken ? options.continuationToken : null;
    this.logLevel = options.logLevel ? options.logLevel : "error";
    this.retryPolicy = options.retryPolicy ? options.retryPolicy : {
      min: 1 * 1000,
      max: 2 * 60 * 1000,
      randomness: 0.2
    };
    this.clientMetadata = options.clientMetadata ? options.clientMetadata : {};
    this.clientMetadata.ver = version;
    this.initRegistrations = options.initRegistrations ? options.initRegistrations : null;
    this.tweaks = options.tweaks ? options.tweaks : null;
  }

  _createClass__default['default'](Configuration, [{
    key: "token",
    get: function get() {
      return this._token;
    }
  }, {
    key: "continuationToken",
    get: function get() {
      return this._continuationToken;
    }
  }, {
    key: "updateToken",
    value: function updateToken(token) {
      this._token = token;
    }
  }, {
    key: "updateContinuationToken",
    value: function updateContinuationToken(continuationToken) {
      this._continuationToken = continuationToken;
    }
  }]);

  return Configuration;
}();

var AbstractMessage = function AbstractMessage(id) {
  _classCallCheck__default['default'](this, AbstractMessage);

  this.id = id || "TM".concat(uuid.v4());
};

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Init = /*#__PURE__*/function (_AbstractMessage) {
  _inherits__default['default'](Init, _AbstractMessage);

  var _super = _createSuper$f(Init);

  function Init(token, continuationToken, metadata, registrations, tweaks) {
    var _this;

    _classCallCheck__default['default'](this, Init);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "method", "init");

    _this.token = token;
    _this.continuation_token = continuationToken;
    _this.metadata = metadata;
    _this.registrations = registrations;
    _this.tweaks = tweaks;
    _this.capabilities = ["client_update", "offline_storage", "telemetry.v1"];
    return _this;
  }

  return Init;
}(AbstractMessage);

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InitReply = /*#__PURE__*/function (_AbstractMessage) {
  _inherits__default['default'](InitReply, _AbstractMessage);

  var _super = _createSuper$e(InitReply);

  function InitReply(id, continuationToken, confirmedCapabilities, continuationTokenStatus, offlineStorage, initRegistrations, debugInfo) {
    var _this;

    _classCallCheck__default['default'](this, InitReply);

    _this = _super.call(this, id);
    _this.continuationToken = continuationToken;
    _this.continuationTokenStatus = continuationTokenStatus;
    _this.offlineStorage = offlineStorage;
    _this.initRegistrations = initRegistrations;
    _this.debugInfo = debugInfo;
    _this.confirmedCapabilities = confirmedCapabilities;
    return _this;
  }

  return InitReply;
}(AbstractMessage);

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Update = /*#__PURE__*/function (_AbstractMessage) {
  _inherits__default['default'](Update, _AbstractMessage);

  var _super = _createSuper$d(Update);

  function Update(token) {
    var _this;

    _classCallCheck__default['default'](this, Update);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "method", "update");

    _this.token = token;
    return _this;
  }

  return Update;
}(AbstractMessage);

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Message = /*#__PURE__*/function (_AbstractMessage) {
  _inherits__default['default'](Message, _AbstractMessage);

  var _super = _createSuper$c(Message);

  function Message(grant, contentType, request) {
    var _this;

    _classCallCheck__default['default'](this, Message);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "method", "message");

    _this.active_grant = grant;
    _this.payload_type = contentType;
    _this.http_request = request;
    return _this;
  }

  return Message;
}(AbstractMessage);

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Reply = /*#__PURE__*/function (_AbstractMessage) {
  _inherits__default['default'](Reply, _AbstractMessage);

  var _super = _createSuper$b(Reply);

  function Reply(id) {
    var _this;

    _classCallCheck__default['default'](this, Reply);

    _this = _super.call(this, id);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "method", "reply");

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "payload_type", "application/json");

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "status", {
      code: 200,
      status: "OK"
    });

    return _this;
  }

  return Reply;
}(AbstractMessage);

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Close = /*#__PURE__*/function (_AbstractMessage) {
  _inherits__default['default'](Close, _AbstractMessage);

  var _super = _createSuper$a(Close);

  function Close() {
    var _this;

    _classCallCheck__default['default'](this, Close);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "method", "close");

    return _this;
  }

  return Close;
}(AbstractMessage);

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TelemetryEvent = function TelemetryEvent(start, // relative to event send time
end, // relative to event send time
title, details, id, // optional, default will be random assigned by backend
type) {
  _classCallCheck__default['default'](this, TelemetryEvent);

  this.start = start;
  this.end = end;
  this.title = title;
  this.details = details;
  this.id = id;
  this.type = type;
} // optional, default will be "SDK" assigned by backend
;

var Telemetry = /*#__PURE__*/function (_AbstractMessage) {
  _inherits__default['default'](Telemetry, _AbstractMessage);

  var _super = _createSuper$9(Telemetry);

  function Telemetry(events) {
    var _this;

    _classCallCheck__default['default'](this, Telemetry);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "method", "telemetry.v1");

    _this.events = events;
    return _this;
  }

  return Telemetry;
}(AbstractMessage);

function byteLength(s) {
  var escstr = encodeURIComponent(s);
  var binstr = escstr.replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode(Number("0x" + p1));
  });
  return binstr.length;
}

function stringToUint8Array(s) {
  var escstr = encodeURIComponent(s);
  var binstr = escstr.replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode(Number("0x" + p1));
  });
  var ua = new Uint8Array(binstr.length);
  Array.prototype.forEach.call(binstr, function (ch, i) {
    ua[i] = ch.charCodeAt(0);
  });
  return ua;
}

function uint8ArrayToString(ua) {
  var binstr = Array.prototype.map.call(ua, function (ch) {
    return String.fromCharCode(ch);
  }).join("");
  var escstr = binstr.replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();

    if (code.length < 2) {
      code = "0" + code;
    }

    return "%" + code;
  });
  return decodeURIComponent(escstr);
}

function getJsonObject(array) {
  return JSON.parse(uint8ArrayToString(array));
}

function getMagic(buffer) {
  var strMagic = "";
  var idx = 0;

  for (; idx < buffer.length; ++idx) {
    var chr = String.fromCharCode(buffer[idx]);
    strMagic += chr;

    if (chr === "\r") {
      idx += 2;
      break;
    }
  }

  var magics = strMagic.split(" ");
  return {
    size: idx,
    protocol: magics[0],
    version: magics[1],
    headerSize: Number(magics[2])
  };
}

var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck__default['default'](this, Parser);
  }

  _createClass__default['default'](Parser, null, [{
    key: "parse",
    value: function parse(message) {
      var fieldMargin = 2;
      var dataView = new Uint8Array(message);
      var magic = getMagic(dataView);

      if (magic.protocol !== "TWILSOCK" || magic.version !== "V3.0") {
        logInstance.error("unsupported protocol: ".concat(magic.protocol, " ver ").concat(magic.version)); //throw new Error('Unsupported protocol');
        //this.fsm.unsupportedProtocol();

        return null;
      }

      var header;

      try {
        header = getJsonObject(dataView.subarray(magic.size, magic.size + magic.headerSize));
      } catch (e) {
        logInstance.error("failed to parse message header", e, message); //throw new Error('Failed to parse message');
        //this.fsm.protocolError();

        return null;
      }

      logInstance.debug("message received: ", header.method);
      logInstance.trace("message received: ", header);
      var payload;

      if (header.payload_size > 0) {
        var payloadOffset = fieldMargin + magic.size + magic.headerSize;
        var payloadSize = header.payload_size;

        if (!header.hasOwnProperty("payload_type") || header.payload_type.indexOf("application/json") === 0) {
          try {
            payload = getJsonObject(dataView.subarray(payloadOffset, payloadOffset + payloadSize));
          } catch (e) {
            logInstance.error("failed to parse message body", e, message); //this.fsm.protocolError();

            return null;
          }
        } else if (header.payload_type.indexOf("text/plain") === 0) {
          payload = uint8ArrayToString(dataView.subarray(payloadOffset, payloadOffset + payloadSize));
        }
      }

      return {
        method: header.method,
        header: header,
        payload: payload
      };
    }
  }, {
    key: "createPacket",
    value: function createPacket(header) {
      var payloadString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      header.payload_size = byteLength(payloadString); // eslint-disable-line camelcase

      var headerString = JSON.stringify(header);
      var magicString = "TWILSOCK V3.0 " + byteLength(headerString);
      logInstance.debug("send request:", magicString + headerString + payloadString);
      var message = stringToUint8Array(magicString + "\r\n" + headerString + "\r\n" + payloadString);
      return message.buffer;
    }
  }]);

  return Parser;
}();

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TwilsockError = /*#__PURE__*/function (_Error) {
  _inherits__default['default'](TwilsockError, _Error);

  var _super = _createSuper$8(TwilsockError);

  function TwilsockError(description) {
    _classCallCheck__default['default'](this, TwilsockError);

    return _super.call(this, description);
  }

  return TwilsockError;
}( /*#__PURE__*/_wrapNativeSuper__default['default'](Error));

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TwilsockReplyError = /*#__PURE__*/function (_TwilsockError) {
  _inherits__default['default'](TwilsockReplyError, _TwilsockError);

  var _super = _createSuper$7(TwilsockReplyError);

  function TwilsockReplyError(description, reply) {
    var _this;

    _classCallCheck__default['default'](this, TwilsockReplyError);

    _this = _super.call(this, description);
    _this.reply = reply;
    return _this;
  }

  return TwilsockReplyError;
}(TwilsockError);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty__default['default'](target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BackoffRetrier = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](BackoffRetrier, _EventEmitter);

  var _super = _createSuper$6(BackoffRetrier);

  function BackoffRetrier(options) {
    var _this;

    _classCallCheck__default['default'](this, BackoffRetrier);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "newBackoff", null);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "usedBackoff", null);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "retrier", null);

    _this.options = options ? _objectSpread({}, options) : {};
    return _this;
  }
  /**
   * Should be called once per attempt series to start retrier.
   */


  _createClass__default['default'](BackoffRetrier, [{
    key: "inProgress",
    get: function get() {
      return !!this.retrier;
    }
  }, {
    key: "start",
    value: function start() {
      if (this.inProgress) {
        throw new Error("Already waiting for next attempt, call finishAttempt(success : boolean) to finish it");
      }

      this.createRetrier();
    }
    /**
     * Should be called to stop retrier entirely.
     */

  }, {
    key: "stop",
    value: function stop() {
      this.cleanRetrier();
      this.newBackoff = null;
      this.usedBackoff = null;
    }
    /**
     * Modifies backoff for next attempt.
     * Expected behavior:
     * - If there was no backoff passed previously reschedulling next attempt to given backoff
     * - If previous backoff was longer then ignoring this one.
     * - If previous backoff was shorter then reschedulling with this one.
     * With or without backoff retrier will keep growing normally.
     * @param delay delay of next attempts in ms.
     */

  }, {
    key: "modifyBackoff",
    value: function modifyBackoff(delay) {
      this.newBackoff = delay;
    }
    /**
     * Mark last emmited attempt as failed, initiating either next of fail if limits were hit.
     */

  }, {
    key: "attemptFailed",
    value: function attemptFailed() {
      if (!this.inProgress) {
        throw new Error("No attempt is in progress");
      }

      if (this.newBackoff) {
        var shouldUseNewBackoff = !this.usedBackoff || this.usedBackoff < this.newBackoff;

        if (shouldUseNewBackoff) {
          this.createRetrier();
        } else {
          var _this$retrier;

          (_this$retrier = this.retrier) === null || _this$retrier === void 0 ? void 0 : _this$retrier.failed(new Error());
        }
      } else {
        var _this$retrier2;

        (_this$retrier2 = this.retrier) === null || _this$retrier2 === void 0 ? void 0 : _this$retrier2.failed(new Error());
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this$retrier3;

      (_this$retrier3 = this.retrier) === null || _this$retrier3 === void 0 ? void 0 : _this$retrier3.cancel();
    }
  }, {
    key: "cleanRetrier",
    value: function cleanRetrier() {
      var _this$retrier4, _this$retrier5;

      (_this$retrier4 = this.retrier) === null || _this$retrier4 === void 0 ? void 0 : _this$retrier4.removeAllListeners();
      (_this$retrier5 = this.retrier) === null || _this$retrier5 === void 0 ? void 0 : _this$retrier5.cancel();
      this.retrier = null;
    }
  }, {
    key: "getRetryPolicy",
    value: function getRetryPolicy() {
      var clone = _objectSpread({}, this.options);

      if (this.newBackoff) {
        clone.min = this.newBackoff;
        clone.max = this.options.max && this.options.max > this.newBackoff ? this.options.max : this.newBackoff;
      } // As we're always skipping first attempt we should add one extra if limit is present


      clone.maxAttemptsCount = this.options.maxAttemptsCount ? this.options.maxAttemptsCount + 1 : undefined;
      return clone;
    }
  }, {
    key: "createRetrier",
    value: function createRetrier() {
      var _this2 = this;

      this.cleanRetrier();
      var retryPolicy = this.getRetryPolicy();
      this.retrier = new operationRetrier.Retrier(retryPolicy);
      this.retrier.once("attempt", function () {
        var _this2$retrier, _this2$retrier2;

        (_this2$retrier = _this2.retrier) === null || _this2$retrier === void 0 ? void 0 : _this2$retrier.on("attempt", function () {
          return _this2.emit("attempt");
        });
        (_this2$retrier2 = _this2.retrier) === null || _this2$retrier2 === void 0 ? void 0 : _this2$retrier2.failed(new Error("Skipping first attempt"));
      });
      this.retrier.on("failed", function (err) {
        return _this2.emit("failed", err);
      });
      this.usedBackoff = this.newBackoff;
      this.newBackoff = null;
      this.retrier.start(); // .catch(err => {});
    }
  }]);

  return BackoffRetrier;
}(EventEmitter);

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DISCONNECTING_TIMEOUT = 3000; // Wraps asynchronous rescheduling
// Just makes it simpler to find these hacks over the code
// Currently there's exactly one instance of this in closeSocket()

function trampoline(f) {
  setTimeout(f, 0);
}
/**
 * Twilsock channel level protocol implementation
 */


var TwilsockChannel = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](TwilsockChannel, _EventEmitter);

  var _super = _createSuper$5(TwilsockChannel);

  function TwilsockChannel(websocket, transport, config) {
    var _this;

    _classCallCheck__default['default'](this, TwilsockChannel);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "disconnectingTimer", null);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "disconnectedPromiseResolve", null);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "terminalStates", ["disconnected", "rejected"]);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "tokenExpiredSasCode", 20104);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "terminationReason", "Connection is not initialized");

    _this.websocket = websocket;

    _this.websocket.on("connected", function () {
      return _this.fsm.socketConnected();
    });

    _this.websocket.on("disconnected", function () {
      return _this.fsm.socketClosed();
    });

    _this.websocket.on("message", function (message) {
      return _this.onIncomingMessage(message);
    });

    _this.websocket.on("socketError", function (e) {
      return _this.emit("connectionError", {
        terminal: false,
        message: "Socket error: ".concat(e.message),
        httpStatusCode: null,
        errorCode: null
      });
    });

    _this.transport = transport;
    _this.config = config;
    _this.retrier = new BackoffRetrier(config.retryPolicy);

    _this.retrier.on("attempt", function () {
      return _this.retry();
    });

    _this.retrier.on("failed", function (err) {
      logInstance.warn("Retrying failed: ".concat(err.message));

      _this.disconnect();
    });

    if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") {
      window.addEventListener("online", function () {
        logInstance.debug("Browser reported connectivity state: online");

        _this.resetBackoff();

        _this.fsm.systemOnline();
      });
      window.addEventListener("offline", function () {
        logInstance.debug("Browser reported connectivity state: offline");

        _this.websocket.close();

        _this.fsm.socketClosed();
      });
    } // We have to use a factory function in here because using the default
    // StateMachine constructor would cause an error for the consumers of the
    // rollup bundles. This is a quirk unique to the javascript-state-machine
    // library.


    var TwilsockStateMachine = StateMachine__namespace.factory({
      init: "disconnected",
      transitions: [{
        name: "userConnect",
        from: ["disconnected", "rejected"],
        to: "connecting"
      }, {
        name: "userConnect",
        from: ["connecting", "connected"]
      }, {
        name: "userDisconnect",
        from: ["connecting", "initialising", "connected", "updating", "retrying", "rejected", "waitSocketClosed", "waitOffloadSocketClosed"],
        to: "disconnecting"
      }, {
        name: "userRetry",
        from: ["retrying"],
        to: "connecting"
      }, {
        name: "socketConnected",
        from: ["connecting"],
        to: "initialising"
      }, {
        name: "socketClosed",
        from: ["connecting", "initialising", "connected", "updating", "error", "waitOffloadSocketClosed"],
        to: "retrying"
      }, {
        name: "socketClosed",
        from: ["disconnecting"],
        to: "disconnected"
      }, {
        name: "socketClosed",
        from: ["waitSocketClosed"],
        to: "disconnected"
      }, {
        name: "socketClosed",
        from: ["rejected"],
        to: "rejected"
      }, {
        name: "initSuccess",
        from: ["initialising"],
        to: "connected"
      }, {
        name: "initError",
        from: ["initialising"],
        to: "error"
      }, {
        name: "tokenRejected",
        from: ["initialising", "updating"],
        to: "rejected"
      }, {
        name: "protocolError",
        from: ["initialising", "connected", "updating"],
        to: "error"
      }, {
        name: "receiveClose",
        from: ["initialising", "connected", "updating"],
        to: "waitSocketClosed"
      }, {
        name: "receiveOffload",
        from: ["initialising", "connected", "updating"],
        to: "waitOffloadSocketClosed"
      }, {
        name: "unsupportedProtocol",
        from: ["initialising", "connected", "updating"],
        to: "unsupported"
      }, {
        name: "receiveFatalClose",
        from: ["initialising", "connected", "updating"],
        to: "unsupported"
      }, {
        name: "userUpdateToken",
        from: ["disconnected", "rejected", "connecting", "retrying"],
        to: "connecting"
      }, {
        name: "userUpdateToken",
        from: ["connected"],
        to: "updating"
      }, {
        name: "updateSuccess",
        from: ["updating"],
        to: "connected"
      }, {
        name: "updateError",
        from: ["updating"],
        to: "error"
      }, {
        name: "userSend",
        from: ["connected"],
        to: "connected"
      }, {
        name: "systemOnline",
        from: ["retrying"],
        to: "connecting"
      }],
      methods: {
        onConnecting: function onConnecting() {
          _this.setupSocket();

          _this.emit("connecting");
        },
        onEnterInitialising: function onEnterInitialising() {
          _this.sendInit();
        },
        onLeaveInitialising: function onLeaveInitialising() {
          _this.cancelInit();
        },
        onEnterUpdating: function onEnterUpdating() {
          _this.sendUpdate();
        },
        onLeaveUpdating: function onLeaveUpdating() {
          _this.cancelUpdate();
        },
        onEnterRetrying: function onEnterRetrying() {
          _this.initRetry();

          _this.emit("connecting");
        },
        onEnterConnected: function onEnterConnected() {
          _this.resetBackoff();

          _this.onConnected();
        },
        onUserUpdateToken: function onUserUpdateToken() {
          _this.resetBackoff();
        },
        onTokenRejected: function onTokenRejected() {
          _this.resetBackoff();

          _this.closeSocket(true);

          _this.finalizeSocket();
        },
        onUserDisconnect: function onUserDisconnect() {
          _this.closeSocket(true);
        },
        onEnterDisconnecting: function onEnterDisconnecting() {
          _this.startDisconnectTimer();
        },
        onLeaveDisconnecting: function onLeaveDisconnecting() {
          _this.cancelDisconnectTimer();
        },
        onEnterWaitSocketClosed: function onEnterWaitSocketClosed() {
          _this.startDisconnectTimer();
        },
        onLeaveWaitSocketClosed: function onLeaveWaitSocketClosed() {
          _this.cancelDisconnectTimer();
        },
        onEnterWaitOffloadSocketClosed: function onEnterWaitOffloadSocketClosed() {
          _this.startDisconnectTimer();
        },
        onLeaveWaitOffloadSocketClosed: function onLeaveWaitOffloadSocketClosed() {
          _this.cancelDisconnectTimer();
        },
        onDisconnected: function onDisconnected() {
          _this.resetBackoff();

          _this.finalizeSocket();
        },
        onReceiveClose: function onReceiveClose() {
          _this.onCloseReceived();
        },
        onReceiveOffload: function onReceiveOffload(event, args) {
          logInstance.debug("onreceiveoffload: ", args);

          _this.modifyBackoff(args.body);

          _this.onCloseReceived();
        },
        onUnsupported: function onUnsupported() {
          _this.closeSocket(true);

          _this.finalizeSocket();
        },
        onError: function onError(lifecycle, graceful) {
          _this.closeSocket(graceful);

          _this.finalizeSocket();
        },
        onEnterState: function onEnterState(event) {
          if (event.from !== "none") {
            _this.changeState(event);
          }
        },
        onInvalidTransition: function onInvalidTransition(transition, from, to) {
          logInstance.warn("FSM: unexpected transition", from, to);
        }
      }
    });
    _this.fsm = new TwilsockStateMachine();
    return _this;
  }

  _createClass__default['default'](TwilsockChannel, [{
    key: "changeState",
    value: function changeState(event) {
      logInstance.debug("FSM: ".concat(event.transition, ": ").concat(event.from, " --> ").concat(event.to));

      if (this.lastEmittedState !== this.state) {
        this.lastEmittedState = this.state;
        this.emit("stateChanged", this.state);
      }
    }
  }, {
    key: "resetBackoff",
    value: function resetBackoff() {
      logInstance.trace("resetBackoff");
      this.retrier.stop();
    }
  }, {
    key: "modifyBackoff",
    value: function modifyBackoff(body) {
      logInstance.trace("modifyBackoff", body);
      var backoffPolicy = body ? body.backoff_policy : null;

      if (backoffPolicy && typeof backoffPolicy.reconnect_min_ms === "number") {
        this.retrier.modifyBackoff(backoffPolicy.reconnect_min_ms);
      }
    }
  }, {
    key: "startDisconnectTimer",
    value: function startDisconnectTimer() {
      var _this2 = this;

      logInstance.trace("startDisconnectTimer");

      if (this.disconnectingTimer) {
        clearTimeout(this.disconnectingTimer);
        this.disconnectingTimer = null;
      }

      this.disconnectingTimer = setTimeout(function () {
        logInstance.debug("disconnecting is timed out");

        _this2.closeSocket(true);
      }, DISCONNECTING_TIMEOUT);
    }
  }, {
    key: "cancelDisconnectTimer",
    value: function cancelDisconnectTimer() {
      logInstance.trace("cancelDisconnectTimer");

      if (this.disconnectingTimer) {
        clearTimeout(this.disconnectingTimer);
        this.disconnectingTimer = null;
      }
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this.state === "connected" && this.websocket.isConnected;
    }
  }, {
    key: "state",
    get: function get() {
      switch (this.fsm.state) {
        case "connecting":
        case "initialising":
        case "retrying":
        case "error":
          return "connecting";

        case "updating":
        case "connected":
          return "connected";

        case "rejected":
          return "denied";

        case "disconnecting":
        case "waitSocketClosed":
        case "waitOffloadSocketClosed":
          return "disconnecting";

        case "disconnected":
        default:
          return "disconnected";
      }
    }
  }, {
    key: "initRetry",
    value: function initRetry() {
      logInstance.debug("initRetry");

      if (this.retrier.inProgress) {
        this.retrier.attemptFailed();
      } else {
        this.retrier.start();
      }
    }
  }, {
    key: "retry",
    value: function retry() {
      if (this.fsm.state != "connecting") {
        logInstance.trace("retry");
        this.websocket.close();
        this.fsm.userRetry();
      } else {
        logInstance.trace("can\t retry as already connecting");
      }
    }
  }, {
    key: "onConnected",
    value: function onConnected() {
      this.emit("connected");
    }
  }, {
    key: "finalizeSocket",
    value: function finalizeSocket() {
      logInstance.trace("finalizeSocket");
      this.websocket.close();
      this.emit("disconnected");

      if (this.disconnectedPromiseResolve) {
        this.disconnectedPromiseResolve();
        this.disconnectedPromiseResolve = null;
      }
    }
  }, {
    key: "setupSocket",
    value: function setupSocket() {
      logInstance.trace("setupSocket:", this.config.token);
      this.emit("beforeConnect"); // This is used by client to record startup telemetry event

      this.websocket.connect();
    }
  }, {
    key: "onIncomingMessage",
    value: function onIncomingMessage(message) {
      var parsedMessage = Parser.parse(message);

      if (!parsedMessage) {
        return;
      }

      var method = parsedMessage.method,
          header = parsedMessage.header,
          payload = parsedMessage.payload;

      if (method !== "reply") {
        this.confirmReceiving(header);
      }

      if (method === "notification") {
        this.emit("message", header.message_type, payload);
      } else if (header.method === "reply") {
        this.transport.processReply({
          id: header.id,
          status: header.status,
          header: header,
          body: payload
        });
      } else if (header.method === "client_update") {
        if (header.client_update_type === "token_about_to_expire") {
          this.emit("tokenAboutToExpire");
        }
      } else if (header.method === "close") {
        if (header.status.code === 308) {
          logInstance.debug("Connection has been offloaded");
          this.fsm.receiveOffload({
            status: header.status.status,
            body: payload
          });
        } else if (header.status.code === 406) {
          // Not acceptable message
          var _message = "Server closed connection because can't parse protocol: ".concat(JSON.stringify(header.status));

          this.emitReplyConnectionError(_message, header, true);
          logInstance.error(_message);
          this.fsm.receiveFatalClose();
        } else if (header.status.code === 417) {
          // Protocol error
          logInstance.error("Server closed connection because can't parse client reply: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveFatalClose(header.status.status);
        } else if (header.status.code === 410) {
          // Expired token
          logInstance.warn("Server closed connection: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveClose(header.status.status);
          this.emit("tokenExpired");
        } else if (header.status.code === 401) {
          // Authentication fail
          logInstance.error("Server closed connection: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveClose(header.status.status);
        } else {
          logInstance.warn("unexpected message: ", header.status); // Try to reconnect

          this.fsm.receiveOffload({
            status: header.status.status,
            body: null
          });
        }
      }
    }
  }, {
    key: "sendInit",
    value: function () {
      var _sendInit = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
        var reply, isTerminalError;
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logInstance.trace("sendInit");
                _context.prev = 1;
                this.emit("beforeSendInit"); // This is used by client to record startup telemetry event

                _context.next = 5;
                return this.transport.sendInit();

              case 5:
                reply = _context.sent;
                this.config.updateContinuationToken(reply.continuationToken);
                this.config.confirmedCapabilities = reply.confirmedCapabilities;
                this.fsm.initSuccess(reply);
                this.emit("initialized", reply);
                this.emit("tokenUpdated");
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);

                if (_context.t0 instanceof TwilsockReplyError) {
                  isTerminalError = false;
                  logInstance.warn("Init rejected by server: ".concat(JSON.stringify(_context.t0.reply.status)));
                  this.emit("sendInitFailed"); // This is used by client to record startup telemetry event
                  // @todo emit telemetry from inside "if" below for more granularity...

                  if (_context.t0.reply.status.code === 401 || _context.t0.reply.status.code === 403) {
                    isTerminalError = true;
                    this.fsm.tokenRejected(_context.t0.reply.status);

                    if (_context.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                      this.emit("tokenExpired");
                    }
                  } else if (_context.t0.reply.status.code === 429) {
                    this.modifyBackoff(_context.t0.reply.body);
                    this.fsm.initError(true);
                  } else if (_context.t0.reply.status.code === 500) {
                    this.fsm.initError(false);
                  } else {
                    this.fsm.initError(true);
                  }

                  this.emitReplyConnectionError(_context.t0.message, _context.t0.reply, isTerminalError);
                } else {
                  this.terminationReason = _context.t0.message;
                  this.emit("connectionError", {
                    terminal: true,
                    message: "Unknown error during connection initialisation: ".concat(_context.t0.message, "\n").concat(JSON.stringify(_context.t0, null, 2)),
                    httpStatusCode: null,
                    errorCode: null
                  });
                  this.fsm.initError(true);
                }

                this.emit("tokenUpdated", _context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 13]]);
      }));

      function sendInit() {
        return _sendInit.apply(this, arguments);
      }

      return sendInit;
    }()
  }, {
    key: "sendUpdate",
    value: function () {
      var _sendUpdate = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
        var message, reply, isTerminalError;
        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logInstance.trace("sendUpdate");
                message = new Update(this.config.token);
                _context2.prev = 2;
                _context2.next = 5;
                return this.transport.sendWithReply(message);

              case 5:
                reply = _context2.sent;
                this.fsm.updateSuccess(reply.body);
                this.emit("tokenUpdated");
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);

                if (_context2.t0 instanceof TwilsockReplyError) {
                  isTerminalError = false;
                  logInstance.warn("Token update rejected by server: ".concat(JSON.stringify(_context2.t0.reply.status)));

                  if (_context2.t0.reply.status.code === 401 || _context2.t0.reply.status.code === 403) {
                    isTerminalError = true;
                    this.fsm.tokenRejected(_context2.t0.reply.status);

                    if (_context2.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                      this.emit("tokenExpired");
                    }
                  } else if (_context2.t0.reply.status.code === 429) {
                    this.modifyBackoff(_context2.t0.reply.body);
                    this.fsm.updateError(_context2.t0.reply.status);
                  } else {
                    this.fsm.updateError(_context2.t0.reply.status);
                  }

                  this.emitReplyConnectionError(_context2.t0.message, _context2.t0.reply, isTerminalError);
                } else {
                  this.emit("error", false, _context2.t0.message, null, null);
                  this.fsm.updateError(_context2.t0);
                }

                this.emit("tokenUpdated", _context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 10]]);
      }));

      function sendUpdate() {
        return _sendUpdate.apply(this, arguments);
      }

      return sendUpdate;
    }()
  }, {
    key: "emitReplyConnectionError",
    value: function emitReplyConnectionError(message, header, terminal) {
      var description = header.status && header.status.description ? header.status.description : message;
      var httpStatusCode = header.status.code;
      var errorCode = header.status && header.status.errorCode ? header.status.errorCode : null;

      if (terminal) {
        this.terminationReason = description;
      }

      this.emit("connectionError", {
        terminal: terminal,
        message: "Connection error: ".concat(description),
        httpStatusCode: httpStatusCode,
        errorCode: errorCode
      });
    }
  }, {
    key: "cancelInit",
    value: function cancelInit() {
      logInstance.trace("cancelInit"); // TODO: implement
    }
  }, {
    key: "cancelUpdate",
    value: function cancelUpdate() {
      logInstance.trace("cancelUpdate"); // TODO: implement
    }
    /**
     * Should be called for each message to confirm it received
     */

  }, {
    key: "confirmReceiving",
    value: function confirmReceiving(messageHeader) {
      logInstance.trace("confirmReceiving");

      try {
        //@todo send telemetry events AnyEvents
        this.transport.send(new Reply(messageHeader.id));
      } catch (e) {
        logInstance.debug("failed to confirm packet receiving", e);
      }
    }
    /**
     * Shutdown connection
     */

  }, {
    key: "closeSocket",
    value: function closeSocket(graceful) {
      var _this3 = this;

      logInstance.trace("closeSocket (graceful: ".concat(graceful, ")"));

      if (graceful && this.transport.isConnected) {
        this.transport.sendClose();
      }

      this.websocket.close();
      trampoline(function () {
        return _this3.fsm.socketClosed();
      });
    }
    /**
     * Initiate the twilsock connection
     * If already connected, it does nothing
     */

  }, {
    key: "connect",
    value: function connect() {
      logInstance.trace("connect");
      this.fsm.userConnect();
    }
    /**
     * Close twilsock connection
     * If already disconnected, it does nothing
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this4 = this;

      logInstance.trace("disconnect");

      if (this.fsm.is("disconnected")) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        _this4.disconnectedPromiseResolve = resolve;

        _this4.fsm.userDisconnect();
      });
    }
    /**
     * Update fpa token for twilsock connection
     */

  }, {
    key: "updateToken",
    value: function updateToken(token) {
      var _this5 = this;

      logInstance.trace("updateToken:", token);
      return new Promise(function (resolve, reject) {
        _this5.once("tokenUpdated", function (e) {
          if (e) {
            reject(e);
          } else {
            resolve();
          }
        });

        _this5.fsm.userUpdateToken();
      });
    }
  }, {
    key: "isTerminalState",
    get: function get() {
      return this.terminalStates.indexOf(this.fsm.state) !== -1;
    }
  }, {
    key: "getTerminationReason",
    get: function get() {
      return this.terminationReason;
    }
  }, {
    key: "onCloseReceived",
    value: function onCloseReceived() {
      this.websocket.close();
    }
  }]);

  return TwilsockChannel;
}(EventEmitter);

var Metadata = /*#__PURE__*/function () {
  function Metadata() {
    _classCallCheck__default['default'](this, Metadata);
  }

  _createClass__default['default'](Metadata, null, [{
    key: "getMetadata",
    value: function getMetadata(options) {
      var _platform$name, _platform$version, _platform$os$family, _platform$os, _platform$os$version, _platform$os2, _platform$os$architec, _platform$os3;

      var overrides = options && options.clientMetadata ? options.clientMetadata : {};
      var fieldNames = ["ver", "env", "envv", "os", "osv", "osa", "type", "sdk", "sdkv", "dev", "devv", "devt", "app", "appv"];
      var defaults = {
        env: (_platform$name = platform__namespace.name) !== null && _platform$name !== void 0 ? _platform$name : "unknown",
        envv: (_platform$version = platform__namespace.version) !== null && _platform$version !== void 0 ? _platform$version : "unknown",
        os: (_platform$os$family = (_platform$os = platform__namespace.os) === null || _platform$os === void 0 ? void 0 : _platform$os.family) !== null && _platform$os$family !== void 0 ? _platform$os$family : "unknown",
        osv: (_platform$os$version = (_platform$os2 = platform__namespace.os) === null || _platform$os2 === void 0 ? void 0 : _platform$os2.version) !== null && _platform$os$version !== void 0 ? _platform$os$version : "unknown",
        osa: (_platform$os$architec = (_platform$os3 = platform__namespace.os) === null || _platform$os3 === void 0 ? void 0 : _platform$os3.architecture) !== null && _platform$os$architec !== void 0 ? _platform$os$architec : "unknown",
        sdk: "js-default"
      };
      var finalClientMetadata = {};
      fieldNames.filter(function (key) {
        return key in overrides || key in defaults;
      }).forEach(function (key) {
        return finalClientMetadata[key] = key in overrides ? overrides[key] : defaults[key];
      });
      return finalClientMetadata;
    }
  }]);

  return Metadata;
}();

var REQUEST_TIMEOUT$1 = 30000;

function isHttpSuccess$1(code) {
  return code >= 200 && code < 300;
}
/**
 * Makes sure that body is properly stringified
 */


function preparePayload(payload) {
  switch (_typeof__default['default'](payload)) {
    case "undefined":
      return "";

    case "object":
      return JSON.stringify(payload);

    default:
      return payload;
  }
}

var PacketInterface = /*#__PURE__*/function () {
  function PacketInterface(channel, config) {
    var _this = this;

    _classCallCheck__default['default'](this, PacketInterface);

    this.config = config;
    this.activeRequests = new Map();
    this.channel = channel;
    this.channel.on("reply", function (reply) {
      return _this.processReply(reply);
    });
    this.channel.on("disconnected", function () {
      _this.activeRequests.forEach(function (descriptor) {
        clearTimeout(descriptor.timeout);
        descriptor.reject(new TwilsockError("disconnected"));
      });

      _this.activeRequests.clear();
    });
  }

  _createClass__default['default'](PacketInterface, [{
    key: "isConnected",
    get: function get() {
      return this.channel.isConnected;
    }
  }, {
    key: "processReply",
    value: function processReply(reply) {
      var request = this.activeRequests.get(reply.id);

      if (request) {
        clearTimeout(request.timeout);
        this.activeRequests.delete(reply.id);

        if (!isHttpSuccess$1(reply.status.code)) {
          request.reject(new TwilsockReplyError("Transport failure: " + reply.status.status, reply));
          logInstance.trace("message rejected");
        } else {
          request.resolve(reply);
        }
      }
    }
  }, {
    key: "storeRequest",
    value: function storeRequest(id, resolve, reject) {
      var requestDescriptor = {
        resolve: resolve,
        reject: reject,
        timeout: setTimeout(function () {
          logInstance.trace("request", id, "is timed out");
          reject(new TwilsockError("Twilsock: request timeout: " + id));
        }, REQUEST_TIMEOUT$1)
      };
      this.activeRequests.set(id, requestDescriptor);
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.activeRequests.forEach(function (descriptor) {
        clearTimeout(descriptor.timeout);
        descriptor.reject(new TwilsockError("Twilsock: request cancelled by user"));
      });
      this.activeRequests.clear();
    }
  }, {
    key: "sendInit",
    value: function () {
      var _sendInit = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
        var metadata, message, response;
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logInstance.trace("sendInit");
                metadata = Metadata.getMetadata(this.config);
                message = new Init(this.config.token, this.config.continuationToken, metadata, this.config.initRegistrations, this.config.tweaks);
                _context.next = 5;
                return this.sendWithReply(message);

              case 5:
                response = _context.sent;
                return _context.abrupt("return", new InitReply(response.id, response.header.continuation_token, new Set(response.header.capabilities), response.header.continuation_token_status, response.header.offline_storage, response.header.init_registrations, response.header.debug_info));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendInit() {
        return _sendInit.apply(this, arguments);
      }

      return sendInit;
    }()
  }, {
    key: "sendClose",
    value: function sendClose() {
      var message = new Close(); //@todo send telemetry AnyEventsIncludingUnfinished

      this.send(message);
    }
  }, {
    key: "sendWithReply",
    value: function sendWithReply(header, payload) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var id = _this2.send(header, payload);

        _this2.storeRequest(id, resolve, reject);
      });
    }
  }, {
    key: "send",
    value: function send(header, payload) {
      header.id = header.id || "TM".concat(uuid.v4());
      var message = Parser.createPacket(header, preparePayload(payload));

      try {
        this.channel.send(message);
        return header.id;
      } catch (e) {
        logInstance.debug("failed to send ", header, e);
        logInstance.trace(e.stack);
        throw e;
      }
    }
  }]);

  return PacketInterface;
}();

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WebSocketChannel = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](WebSocketChannel, _EventEmitter);

  var _super = _createSuper$4(WebSocketChannel);

  function WebSocketChannel(url) {
    var _this;

    _classCallCheck__default['default'](this, WebSocketChannel);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "socket", null);

    _this.url = url;
    _this.url = url;
    _this.WebSocket = global["WebSocket"] || global["MozWebSocket"] || {};
    return _this;
  }

  _createClass__default['default'](WebSocketChannel, [{
    key: "isConnected",
    get: function get() {
      return !!this.socket && this.socket.readyState === 1;
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this2 = this;

      logInstance.trace("connecting to socket");
      var socket;

      try {
        socket = new this.WebSocket(this.url);
      } catch (e) {
        logInstance.debug("Socket error: ".concat(this.url));
        this.emit("socketError", e);
        return;
      }

      socket.binaryType = "arraybuffer";

      socket.onopen = function () {
        logInstance.debug("socket opened ".concat(_this2.url));

        _this2.emit("connected");
      };

      socket.onclose = function (e) {
        logInstance.debug("socket closed", e);

        _this2.emit("disconnected", e);
      };

      socket.onerror = function (e) {
        logInstance.debug("Socket error:", e);

        _this2.emit("socketError", e);
      };

      socket.onmessage = function (message) {
        _this2.emit("message", message.data);
      };

      this.socket = socket;
    }
  }, {
    key: "send",
    value: function send(message) {
      return this.socket && this.socket.send(message);
    }
  }, {
    key: "close",
    value: function close() {
      logInstance.trace("closing socket");

      if (this.socket) {
        this.socket.onopen = null;
        this.socket.onclose = null;
        this.socket.onerror = null;
        this.socket.onmessage = null;

        try {
          this.socket.close();
        } finally {}
      }
    }
  }]);

  return WebSocketChannel;
}(EventEmitter);

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Registrations module handles all operations with registration contexts through twilsock.
 * Main role: it automatically refreshes all registrations after reconnect.
 */

var Registrations = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](Registrations, _EventEmitter);

  var _super = _createSuper$3(Registrations);

  function Registrations(transport) {
    var _this;

    _classCallCheck__default['default'](this, Registrations);

    _this = _super.call(this);
    _this.transport = transport;
    _this.registrations = new Map();
    _this.registrationsInProgress = new Map();
    return _this;
  }

  _createClass__default['default'](Registrations, [{
    key: "putNotificationContext",
    value: function () {
      var _putNotificationContext = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee(contextId, context) {
        var header;
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                header = {
                  method: "put_notification_ctx",
                  notification_ctx_id: contextId
                };
                _context.next = 3;
                return this.transport.sendWithReply(header, context);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function putNotificationContext(_x, _x2) {
        return _putNotificationContext.apply(this, arguments);
      }

      return putNotificationContext;
    }()
  }, {
    key: "deleteNotificationContext",
    value: function () {
      var _deleteNotificationContext = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2(contextId) {
        var message;
        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                message = {
                  method: "delete_notification_ctx",
                  notification_ctx_id: contextId
                };
                _context2.next = 3;
                return this.transport.sendWithReply(message);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteNotificationContext(_x3) {
        return _deleteNotificationContext.apply(this, arguments);
      }

      return deleteNotificationContext;
    }()
  }, {
    key: "updateRegistration",
    value: function () {
      var _updateRegistration = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3(contextId, context) {
        var registrationAttempts, attemptId;
        return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                logInstance.debug("update registration for context", contextId);
                registrationAttempts = this.registrationsInProgress.get(contextId);

                if (!registrationAttempts) {
                  registrationAttempts = new Set();
                  this.registrationsInProgress.set(contextId, registrationAttempts);
                }

                attemptId = uuid.v4();
                registrationAttempts.add(attemptId);
                _context3.prev = 5;
                _context3.next = 8;
                return this.putNotificationContext(contextId, context);

              case 8:
                logInstance.debug("registration attempt succeeded for context", context);
                registrationAttempts.delete(attemptId);

                if (registrationAttempts.size === 0) {
                  this.registrationsInProgress.delete(contextId);
                  this.emit("registered", contextId);
                }

                _context3.next = 19;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](5);
                logInstance.warn("registration attempt failed for context", context);
                logInstance.debug(_context3.t0);
                registrationAttempts.delete(attemptId);

                if (registrationAttempts.size === 0) {
                  this.registrationsInProgress.delete(contextId);
                  this.emit("registrationFailed", contextId, _context3.t0);
                }

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 13]]);
      }));

      function updateRegistration(_x4, _x5) {
        return _updateRegistration.apply(this, arguments);
      }

      return updateRegistration;
    }()
  }, {
    key: "updateRegistrations",
    value: function () {
      var _updateRegistrations = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee4() {
        var _this2 = this;

        var promises;
        return _regeneratorRuntime__default['default'].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                logInstance.trace("refreshing ".concat(this.registrations.size, " registrations"));
                promises = [];
                this.registrations.forEach(function (context, id) {
                  promises.push(_this2.updateRegistration(id, context));
                });
                _context4.next = 5;
                return Promise.all(promises);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateRegistrations() {
        return _updateRegistrations.apply(this, arguments);
      }

      return updateRegistrations;
    }()
  }, {
    key: "setNotificationsContext",
    value: function () {
      var _setNotificationsContext = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee5(contextId, context) {
        return _regeneratorRuntime__default['default'].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!contextId || !context)) {
                  _context5.next = 2;
                  break;
                }

                throw new TwilsockError("Invalid arguments provided");

              case 2:
                this.registrations.set(contextId, context);
                _context5.next = 5;
                return this.updateRegistration(contextId, context);

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setNotificationsContext(_x6, _x7) {
        return _setNotificationsContext.apply(this, arguments);
      }

      return setNotificationsContext;
    }()
  }, {
    key: "removeNotificationsContext",
    value: function () {
      var _removeNotificationsContext = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee6(contextId) {
        return _regeneratorRuntime__default['default'].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.registrations.has(contextId)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                _context6.next = 4;
                return this.deleteNotificationContext(contextId);

              case 4:
                if (this.transport.isConnected) {
                  this.registrations.delete(contextId);
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function removeNotificationsContext(_x8) {
        return _removeNotificationsContext.apply(this, arguments);
      }

      return removeNotificationsContext;
    }()
  }]);

  return Registrations;
}(EventEmitter);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TwilsockUpstreamError = /*#__PURE__*/function (_TwilsockError) {
  _inherits__default['default'](TwilsockUpstreamError, _TwilsockError);

  var _super = _createSuper$2(TwilsockUpstreamError);

  function TwilsockUpstreamError(status, description, body) {
    var _this;

    _classCallCheck__default['default'](this, TwilsockUpstreamError);

    _this = _super.call(this, description);
    _this.status = status;
    _this.description = description;
    _this.body = body;
    return _this;
  }

  return TwilsockUpstreamError;
}(TwilsockError);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TransportUnavailableError = /*#__PURE__*/function (_TwilsockError) {
  _inherits__default['default'](TransportUnavailableError, _TwilsockError);

  var _super = _createSuper$1(TransportUnavailableError);

  function TransportUnavailableError(description) {
    _classCallCheck__default['default'](this, TransportUnavailableError);

    return _super.call(this, description);
  }

  return TransportUnavailableError;
}(TwilsockError);

var REQUEST_TIMEOUT = 20000;

function isHttpSuccess(code) {
  return code >= 200 && code < 300;
}

function isHttpReply(packet) {
  return packet && packet.header && packet.header.http_status;
}

function parseUri(uri) {
  var match = uri.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);

  if (match) {
    var uriStruct = {
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7],
      params: {}
    };

    if (uriStruct.search.length > 0) {
      var paramsString = uriStruct.search.substring(1);
      uriStruct.params = paramsString.split("&").map(function (el) {
        return el.split("=");
      }).reduce(function (prev, curr) {
        if (!prev.hasOwnProperty(curr[0])) {
          prev[curr[0]] = curr[1];
        } else if (Array.isArray(prev[curr[0]])) {
          prev[curr[0]].push(curr[1]);
        } else {
          prev[curr[0]] = [prev[curr[0]], curr[1]];
        }

        return prev;
      }, {});
    }

    return uriStruct;
  }

  throw new TwilsockError("Incorrect URI: " + uri);
}

function twilsockAddress(method, uri) {
  var parsedUri = parseUri(uri);
  var to = {
    method: method,
    host: parsedUri.host,
    path: parsedUri.pathname
  };

  if (parsedUri.params) {
    to.params = parsedUri.params;
  }

  return to;
}

function twilsockParams(method, uri, headers, body, grant) {
  return {
    to: twilsockAddress(method, uri),
    headers: headers,
    body: body,
    grant: grant
  };
}

var Upstream = /*#__PURE__*/function () {
  function Upstream(transport, twilsock, config) {
    _classCallCheck__default['default'](this, Upstream);

    this.config = config;
    this.transport = transport;
    this.pendingMessages = [];
    this.twilsock = twilsock;
  }

  _createClass__default['default'](Upstream, [{
    key: "saveMessage",
    value: function saveMessage(message) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var requestDescriptor = {
          message: message,
          resolve: resolve,
          reject: reject,
          alreadyRejected: false,
          timeout: setTimeout(function () {
            logInstance.debug("request is timed out");
            reject(new TwilsockError("request '".concat(message.to.method, "' to '").concat(message.to.host, "' timed out")));
            requestDescriptor.alreadyRejected = true;
          }, REQUEST_TIMEOUT)
        };

        _this.pendingMessages.push(requestDescriptor);
      });
    }
  }, {
    key: "sendPendingMessages",
    value: function sendPendingMessages() {
      var _this2 = this;

      var _loop = function _loop() {
        var request = _this2.pendingMessages[0]; // Do not send message if we've rejected its promise already

        if (!request.alreadyRejected) {
          try {
            var message = request.message;

            _this2.actualSend(message).then(function (response) {
              return request.resolve(response);
            }).catch(function (e) {
              return request.reject(e);
            });

            clearTimeout(request.timeout);
          } catch (e) {
            logInstance.debug("Failed to send pending message", e);
            return "break";
          }
        }

        _this2.pendingMessages.splice(0, 1);
      };

      while (this.pendingMessages.length > 0) {
        var _ret = _loop();

        if (_ret === "break") break;
      }
    }
  }, {
    key: "rejectPendingMessages",
    value: function rejectPendingMessages() {
      var _this3 = this;

      this.pendingMessages.forEach(function (message) {
        message.reject(new TransportUnavailableError( // @todo Error Unhandled promise rejection!
        "Unable to connect: " + _this3.twilsock.getTerminationReason));
        message.alreadyRejected = true;
        clearTimeout(message.timeout);
      });
      this.pendingMessages.splice(0, this.pendingMessages.length);
    }
  }, {
    key: "actualSend",
    value: function () {
      var _actualSend = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee(message) {
        var _message$grant;

        var address, headers, body, grant, httpRequest, upstreamMessage, reply;
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                address = message.to;
                headers = message.headers;
                body = message.body;
                grant = (_message$grant = message.grant) !== null && _message$grant !== void 0 ? _message$grant : this.config.activeGrant;
                httpRequest = {
                  host: address.host,
                  path: address.path,
                  method: address.method,
                  params: address.params,
                  headers: headers
                };
                upstreamMessage = new Message(grant, headers["Content-Type"] || "application/json", httpRequest);
                logInstance.trace("Sending upstream message", upstreamMessage);
                _context.next = 9;
                return this.transport.sendWithReply(upstreamMessage, body);

              case 9:
                reply = _context.sent;
                logInstance.trace("Received upstream message response", reply);

                if (!(isHttpReply(reply) && !isHttpSuccess(reply.header.http_status.code))) {
                  _context.next = 13;
                  break;
                }

                throw new TwilsockUpstreamError(reply.header.http_status.code, reply.header.http_status.status, reply.body);

              case 13:
                return _context.abrupt("return", {
                  status: reply.header.http_status,
                  headers: reply.header.http_headers,
                  body: reply.body
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function actualSend(_x) {
        return _actualSend.apply(this, arguments);
      }

      return actualSend;
    }()
    /**
     * Send an upstream message
     * @param {string} method The upstream method
     * @param {string} url URL to send the message to
     * @param {object} [headers] The message headers
     * @param {any} [body] The message body
     * @param {string} [grant] The product grant
     * @returns {Promise<Result>} Result from remote side
     */

  }, {
    key: "send",
    value: function send(method, url) {
      var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var body = arguments.length > 3 ? arguments[3] : undefined;
      var grant = arguments.length > 4 ? arguments[4] : undefined;

      if (this.twilsock.isTerminalState) {
        return Promise.reject(new TransportUnavailableError("Unable to connect: " + this.twilsock.getTerminationReason));
      }

      var twilsockMessage = twilsockParams(method, url, headers, body, grant);

      if (!this.twilsock.isConnected) {
        return this.saveMessage(twilsockMessage);
      }

      return this.actualSend(twilsockMessage);
    }
  }]);

  return Upstream;
}();

var Deferred = /*#__PURE__*/function () {
  function Deferred() {
    var _this = this;

    _classCallCheck__default['default'](this, Deferred);

    this._promise = new Promise(function (resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
  }

  _createClass__default['default'](Deferred, [{
    key: "promise",
    get: function get() {
      return this._promise;
    }
  }, {
    key: "update",
    value: function update(value) {
      this._resolve(value);
    }
  }, {
    key: "set",
    value: function set(value) {
      this._resolve(value);
    }
  }, {
    key: "fail",
    value: function fail(e) {
      this._reject(e);
    }
  }]);

  return Deferred;
}();

var OfflineProductStorage = /*#__PURE__*/function () {
  function OfflineProductStorage(id) {
    _classCallCheck__default['default'](this, OfflineProductStorage);

    this.id = id;
  }

  _createClass__default['default'](OfflineProductStorage, null, [{
    key: "create",
    value: function create(productPayload) {
      if (productPayload instanceof Object && "storage_id" in productPayload) {
        return new OfflineProductStorage(productPayload.storage_id);
      } else {
        throw new TwilsockError('Field "storage_id" is missing');
      }
    }
  }]);

  return OfflineProductStorage;
}();

var TokenStorage = /*#__PURE__*/function () {
  function TokenStorage() {
    _classCallCheck__default['default'](this, TokenStorage);

    _defineProperty__default['default'](this, "initializedFlag", "twilio_twilsock_token_storage");

    _defineProperty__default['default'](this, "tokenStoragePrefix", "twilio_continuation_token_");

    if (!TokenStorage._instance) {
      this.initialize();
      TokenStorage._instance = this;
    }

    return TokenStorage._instance;
  }

  _createClass__default['default'](TokenStorage, [{
    key: "sessionStorage",
    value: function sessionStorage() {
      try {
        return global["sessionStorage"];
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "window",
    value: function window() {
      try {
        return global["window"];
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "storeToken",
    value: function storeToken(continuationToken, productId) {
      if (this.canStore()) {
        this.sessionStorage.setItem(this.getKeyName(productId), continuationToken);
      }
    }
  }, {
    key: "getStoredToken",
    value: function getStoredToken(productId) {
      if (!this.canStore()) {
        return null;
      }

      return this.sessionStorage.getItem(this.getKeyName(productId));
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this = this;

      if (this.canStore()) {
        var flag = this.sessionStorage.getItem(this.initializedFlag); // Duplicated tab, cleaning up all stored keys

        if (flag) {
          this.clear();
        }

        this.sessionStorage.setItem(this.initializedFlag, "true"); // When leaving page or refreshing

        var removeStorageItem = this.sessionStorage.removeItem;
        this.window.addEventListener("unload", function () {
          removeStorageItem(_this.initializedFlag);
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.canStore()) {
        var keyToDelete = [];

        for (var i = 0; i < this.sessionStorage.length; i++) {
          var key = this.sessionStorage.key(i); // We manually removed startsWith here due to some problems with babel polyfill setup.
          // Restore it when we figure out what's wrong.
          //if (key.startsWith(TokenStorage.tokenStoragePrefix)) {

          if (key && key.indexOf(this.tokenStoragePrefix) === 0) {
            keyToDelete.push(key);
          }
        }

        var removeStorageItem = this.sessionStorage.removeItem;
        keyToDelete.forEach(function (key) {
          return removeStorageItem(key);
        });
        removeStorageItem(this.initializedFlag);
      }
    }
  }, {
    key: "getKeyName",
    value: function getKeyName(productId) {
      return "".concat(this.tokenStoragePrefix).concat(productId);
    }
  }, {
    key: "canStore",
    value: function canStore() {
      return !!(this.sessionStorage && this.sessionStorage.length && this.window);
    }
  }]);

  return TokenStorage;
}();

_defineProperty__default['default'](TokenStorage, "_instance", null);

var TokenStorage$1 = new TokenStorage();

var TelemetryEventDescription = /*#__PURE__*/function () {
  function TelemetryEventDescription(title, details, start, end, type, id) {
    _classCallCheck__default['default'](this, TelemetryEventDescription);

    this.title = title;
    this.details = details;
    this.start = start;
    this.type = type;
    this.id = id;
    this.end = end;
  } // Prepare telemetry event right before sending it.
  // Convert times to relative.


  _createClass__default['default'](TelemetryEventDescription, [{
    key: "toTelemetryEvent",
    value: function toTelemetryEvent() {
      // Fix dates
      var now = new Date();
      var actualStart = this.start;
      var actualEnd = this.end ? this.end : now;

      if (actualEnd < actualStart) {
        var tmp = actualEnd;
        actualEnd = actualStart;
        actualStart = tmp;
      } // Converting dates to relative offset from current moment in ms


      var startOffset = actualStart.getTime() - now.getTime();
      var endOffset = actualEnd.getTime() - now.getTime();
      var result = new TelemetryEvent(startOffset, endOffset, this.title, this.details, this.id, this.type);
      return result;
    }
  }]);

  return TelemetryEventDescription;
}();

exports.TelemetryPoint = void 0;

(function (TelemetryPoint) {
  TelemetryPoint[TelemetryPoint["Start"] = 0] = "Start";
  TelemetryPoint[TelemetryPoint["End"] = 1] = "End";
})(exports.TelemetryPoint || (exports.TelemetryPoint = {}));

exports.EventSendingLimitation = void 0;

(function (EventSendingLimitation) {
  EventSendingLimitation[EventSendingLimitation["MinEventsPortion"] = 0] = "MinEventsPortion";
  EventSendingLimitation[EventSendingLimitation["AnyEvents"] = 1] = "AnyEvents";
  EventSendingLimitation[EventSendingLimitation["AnyEventsIncludingUnfinished"] = 2] = "AnyEventsIncludingUnfinished";
})(exports.EventSendingLimitation || (exports.EventSendingLimitation = {}));

var TelemetryTracker = /*#__PURE__*/function () {
  // accumulated events count that is big enough to be sent out of schedule (not on timer but on new event registration)
  // max events batch size to be sent in a single Telemetry message
  // started events: have TelemetryEvent::startTime only
  // events ready to send
  function TelemetryTracker(config, packetInterface) {
    _classCallCheck__default['default'](this, TelemetryTracker);

    _defineProperty__default['default'](this, "minEventsPortionToSend", 50);

    _defineProperty__default['default'](this, "maxEventsPortionToSend", 100);

    _defineProperty__default['default'](this, "pendingEvents", new Map());

    _defineProperty__default['default'](this, "readyEvents", []);

    _defineProperty__default['default'](this, "hasInitializationFinished", false);

    _defineProperty__default['default'](this, "_canSendTelemetry", false);

    this.config = config;
    this.packetInterface = packetInterface;
  } // Keeping this private prevents the type declaration from being generated properly.
  // Ideally, this should be private.


  _createClass__default['default'](TelemetryTracker, [{
    key: "isTelemetryEnabled",
    get: function get() {
      return this.config.confirmedCapabilities.has("telemetry.v1");
    }
  }, {
    key: "canSendTelemetry",
    get: function get() {
      return this._canSendTelemetry && this.isTelemetryEnabled;
    },
    set: function set(enable) {
      logInstance.debug("TelemetryTracker.canSendTelemetry: ".concat(enable, " TelemetryTracker.isTelemetryEnabled: ").concat(this.isTelemetryEnabled)); // We want to keep telemetry events added in advance but
      // we need to purge events from previous connection when being disconnected

      if (this._canSendTelemetry && !enable) {
        this.pendingEvents.clear();
        this.readyEvents = [];
      }

      this._canSendTelemetry = enable;

      if (enable) {
        this.sendTelemetry(exports.EventSendingLimitation.AnyEvents);
      }

      if (enable && !this.hasInitializationFinished) {
        this.hasInitializationFinished = true;
      }
    } // Add complete event

  }, {
    key: "addTelemetryEvent",
    value: function addTelemetryEvent(event) {
      // Allow adding events before initialization.
      if (!this.canSendTelemetry && this.hasInitializationFinished) {
        return;
      }

      this.readyEvents.push(event);
    } // Add incomplete event (with either starting or ending time point)

  }, {
    key: "addPartialEvent",
    value: function addPartialEvent(incompleteEvent, eventKey, point) {
      logInstance.debug("Adding ".concat(point === exports.TelemetryPoint.Start ? "starting" : "ending", " timepoint for '").concat(eventKey, "' event"));
      var exists = this.pendingEvents.has(eventKey);

      if (point === exports.TelemetryPoint.Start) {
        if (exists) {
          logInstance.debug("Overwriting starting point for '".concat(eventKey, "' event"));
        }

        this.pendingEvents.set(eventKey, incompleteEvent);
      } else {
        if (!exists) {
          logInstance.info("Could not find started event for '".concat(eventKey, "' event"));
          return;
        }

        this.addTelemetryEvent(this.merge(this.pendingEvents.get(eventKey), incompleteEvent));
        this.pendingEvents.delete(eventKey);
      }
    }
  }, {
    key: "getTelemetryToSend",
    value: function getTelemetryToSend(sendingLimit) {
      if (!this.canSendTelemetry || this.readyEvents.length == 0) {
        return []; // Events are collected but not sent until telemetry is enabled
      }

      if (sendingLimit == exports.EventSendingLimitation.MinEventsPortion && this.readyEvents.length < this.minEventsPortionToSend) {
        return [];
      }

      return this.getTelemetryPortion(sendingLimit == exports.EventSendingLimitation.AnyEventsIncludingUnfinished);
    }
  }, {
    key: "getTelemetryPortion",
    value: function getTelemetryPortion(includeUnfinished) {
      var _this = this;

      var eventsPortionToSend = Math.min(this.readyEvents.length, this.maxEventsPortionToSend);
      var res = this.readyEvents.splice(0, eventsPortionToSend);

      if (includeUnfinished && res.length < this.maxEventsPortionToSend) {
        this.pendingEvents.forEach(function (value, key) {
          if (res.length >= _this.maxEventsPortionToSend) {
            return; // @fixme does not end the loop early
          }

          var event = _this.pendingEvents.get(key);

          _this.pendingEvents.delete(key);

          res.push(new TelemetryEventDescription("[UNFINISHED] ".concat(event.title), // add prefix title to mark unfinished events for CleanSock
          event.details, event.start, null, // Not ended, on sending will be replaced with now
          event.type, event.id));
        });
      }

      return res;
    } // Merging 2 partial events:
    //   use start.startTime & end.endTime.
    // For other fields,
    //   if there are values in end, use them,
    //   else use values from start.

  }, {
    key: "merge",
    value: function merge(start, end) {
      return new TelemetryEventDescription(end.title ? end.title : start.title, end.details ? end.details : start.details, start.start, end.end, end.type ? end.type : start.type, end.id ? end.id : start.id);
    }
  }, {
    key: "sendTelemetryIfMinimalPortionCollected",
    value: function sendTelemetryIfMinimalPortionCollected() {
      this.sendTelemetry(exports.EventSendingLimitation.MinEventsPortion);
    } // NB: getTelemetryToSend will return non-empty array only if we have already received initReply
    // and telemetry.v1 capability is enabled there.

  }, {
    key: "sendTelemetry",
    value: function sendTelemetry(limit) {
      var events = this.getTelemetryToSend(limit);

      if (events.length === 0) {
        return; // not enough telemetry data collected
      }

      try {
        this.packetInterface.send(new Telemetry(events.map(function (e) {
          return e.toTelemetryEvent();
        })));
      } catch (err) {
        logInstance.debug("Error while sending ".concat(events.length, " telemetry events due to ").concat(err, "; they will be resubmitted"));
        this.readyEvents = this.readyEvents.concat(events);
      }
    }
  }]);

  return TelemetryTracker;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default['default'](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default['default'](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default['default'](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TelemetryEvents = function TelemetryEvents() {
  _classCallCheck__default['default'](this, TelemetryEvents);
};
/**
 * @alias Twilsock
 * @classdesc Client library for the Twilsock service
 * It allows to recevie service-generated updates as well as bi-directional transport
 * @fires Twilsock#message
 * @fires Twilsock#connected
 * @fires Twilsock#disconnected
 * @fires Twilsock#tokenAboutToExpire
 * @fires Twilsock#tokenExpired
 * @fires Twilsock#stateChanged
 * @fires Twilsock#connectionError
 */

_defineProperty__default['default'](TelemetryEvents, "TWILSOCK_CONNECT", "twilsock.sdk.connect");

_defineProperty__default['default'](TelemetryEvents, "TWILSOCK_INIT", "twilsock.sdk.init");

exports.TwilsockClient = /*#__PURE__*/function (_EventEmitter) {
  _inherits__default['default'](TwilsockClient, _EventEmitter);

  var _super = _createSuper(TwilsockClient);

  /**
   * @param {string} token Twilio access token
   * @param {string} productId Product identifier. Should be the same as a grant name in token
   * @param {object} options Twilsock configuration options
   */
  function TwilsockClient(token, productId, options) {
    var _this;

    _classCallCheck__default['default'](this, TwilsockClient);

    _this = _super.call(this);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "version", version);

    _defineProperty__default['default'](_assertThisInitialized__default['default'](_this), "offlineStorageDeferred", new Deferred());

    options.continuationToken = options.continuationToken ? options.continuationToken : TokenStorage$1.getStoredToken(productId);
    var config = _this.config = new Configuration(token, productId, options);
    logInstance.setLevel(config.logLevel);
    var websocket = new WebSocketChannel(config.url);
    var transport = new PacketInterface(websocket, config);
    _this.channel = new TwilsockChannel(websocket, transport, config);
    _this.registrations = new Registrations(transport);
    _this.upstream = new Upstream(transport, _this.channel, config); // Send telemetry only when connected and initialised

    _this.telemetryTracker = new TelemetryTracker(config, transport);

    _this.channel.on("initialized", function () {
      return _this.telemetryTracker.canSendTelemetry = true;
    });

    websocket.on("disconnected", function () {
      return _this.telemetryTracker.canSendTelemetry = false;
    });

    _this.registrations.on("registered", function (id) {
      return _this.emit("registered", id);
    });

    _this.channel.on("message", function (type, message) {
      return setTimeout(function () {
        return _this.emit("message", type, message);
      }, 0);
    });

    _this.channel.on("stateChanged", function (state) {
      return setTimeout(function () {
        return _this.emit("stateChanged", state);
      }, 0);
    });

    _this.channel.on("connectionError", function (connectionError) {
      return setTimeout(function () {
        return _this.emit("connectionError", connectionError);
      }, 0);
    });

    _this.channel.on("tokenAboutToExpire", function () {
      return setTimeout(function () {
        return _this.emit("tokenAboutToExpire");
      }, 0);
    });

    _this.channel.on("tokenExpired", function () {
      return setTimeout(function () {
        return _this.emit("tokenExpired");
      }, 0);
    });

    _this.channel.on("connected", function () {
      return _this.registrations.updateRegistrations();
    });

    _this.channel.on("connected", function () {
      return _this.upstream.sendPendingMessages();
    });

    _this.channel.on("connected", function () {
      return setTimeout(function () {
        return _this.emit("connected");
      }, 0);
    }); // Twilsock telemetry events


    _this.channel.on("beforeConnect", function () {
      return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Establish WebSocket connection", "", new Date()), TelemetryEvents.TWILSOCK_CONNECT, exports.TelemetryPoint.Start);
    });

    _this.channel.on("connected", function () {
      return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Establish WebSocket connection", "", new Date(), new Date()), TelemetryEvents.TWILSOCK_CONNECT, exports.TelemetryPoint.End);
    });

    _this.channel.on("beforeSendInit", function () {
      return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Send Twilsock init", "", new Date()), TelemetryEvents.TWILSOCK_INIT, exports.TelemetryPoint.Start);
    });

    _this.channel.on("initialized", function () {
      return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Send Twilsock init", "Succeeded", new Date(), new Date()), TelemetryEvents.TWILSOCK_INIT, exports.TelemetryPoint.End);
    });

    _this.channel.on("sendInitFailed", function () {
      return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Send Twilsock init", "Failed", new Date(), new Date()), TelemetryEvents.TWILSOCK_INIT, exports.TelemetryPoint.End);
    });

    _this.channel.on("initialized", function (initReply) {
      _this.handleStorageId(productId, initReply);

      TokenStorage$1.storeToken(initReply.continuationToken, productId);
      setTimeout(function () {
        return _this.emit("initialized", initReply);
      }, 0);
    });

    _this.channel.on("disconnected", function () {
      return setTimeout(function () {
        return _this.emit("disconnected");
      }, 0);
    });

    _this.channel.on("disconnected", function () {
      return _this.upstream.rejectPendingMessages();
    });

    _this.channel.on("disconnected", function () {
      return _this.offlineStorageDeferred.fail(new TwilsockError("Client disconnected"));
    });

    _this.offlineStorageDeferred.promise.catch(function () {
      return void 0;
    });

    return _this;
  }

  _createClass__default['default'](TwilsockClient, [{
    key: "emit",
    value: function emit(event) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      logInstance.debug("Emitting ".concat(event.toString(), "(").concat(args.map(function (a) {
        return JSON.stringify(a);
      }).join(", "), ")"));
      return (_get2 = _get__default['default'](_getPrototypeOf__default['default'](TwilsockClient.prototype), "emit", this)).call.apply(_get2, [this, event].concat(args));
    }
  }, {
    key: "handleStorageId",
    value: function handleStorageId(productId, initReply) {
      if (!initReply.offlineStorage) {
        this.offlineStorageDeferred.fail(new TwilsockError("No offline storage id"));
      } else if (initReply.offlineStorage.hasOwnProperty(productId)) {
        try {
          this.offlineStorageDeferred.set(OfflineProductStorage.create(initReply.offlineStorage[productId]));
          logInstance.debug("Offline storage for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage[productId]), "."));
        } catch (e) {
          this.offlineStorageDeferred.fail(new TwilsockError("Failed to parse offline storage for ".concat(productId, " ").concat(JSON.stringify(initReply.offlineStorage[productId]), ". ").concat(e, ".")));
        }
      } else {
        this.offlineStorageDeferred.fail(new TwilsockError("No offline storage id for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage))));
      }
    }
    /**
     * Get offline storage ID
     * @returns {Promise}
     */

  }, {
    key: "storageId",
    value: function storageId() {
      return this.offlineStorageDeferred.promise;
    }
    /**
     * Indicates if twilsock is connected now
     * @returns {Boolean}
     */

  }, {
    key: "isConnected",
    get: function get() {
      return this.channel.isConnected;
    }
    /**
     * Current state
     * @returns {ConnectionState}
     */

  }, {
    key: "state",
    get: function get() {
      return this.channel.state;
    }
    /**
     * Update token
     * @param {String} token
     * @returns {Promise}
     */

  }, {
    key: "updateToken",
    value: function () {
      var _updateToken = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee(token) {
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logInstance.trace("updating token '".concat(token, "'"));

                if (!(this.config.token === token)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this.config.updateToken(token);
                _context.next = 6;
                return this.channel.updateToken(token);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateToken(_x) {
        return _updateToken.apply(this, arguments);
      }

      return updateToken;
    }()
    /**
     * Updates notification context.
     * This method shouldn't be used anyone except twilio notifications library
     * @param contextId id of notification context
     * @param context value of notification context
     * @private
     */

  }, {
    key: "setNotificationsContext",
    value: function () {
      var _setNotificationsContext = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2(contextId, context) {
        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.registrations.setNotificationsContext(contextId, context);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setNotificationsContext(_x2, _x3) {
        return _setNotificationsContext.apply(this, arguments);
      }

      return setNotificationsContext;
    }()
    /**
     * Remove notification context.
     * This method shouldn't be used anyone except twilio notifications library
     * @param contextId id of notification context
     * @private
     */

  }, {
    key: "removeNotificationsContext",
    value: function () {
      var _removeNotificationsContext = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee3(contextId) {
        return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.registrations.removeNotificationsContext(contextId);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeNotificationsContext(_x4) {
        return _removeNotificationsContext.apply(this, arguments);
      }

      return removeNotificationsContext;
    }()
    /**
     * Connect to the server
     * @fires Twilsock#connected
     * @public
     * @returns {void}
     */

  }, {
    key: "connect",
    value: function connect() {
      return this.channel.connect();
    }
    /**
     * Disconnect from the server
     * @fires Twilsock#disconnected
     * @public
     * @returns {Promise}
     */

  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee4() {
        return _regeneratorRuntime__default['default'].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEventsIncludingUnfinished);
                _context4.next = 3;
                return this.channel.disconnect();

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
    /**
     * Get HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "get",
    value: function () {
      var _get3 = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee5(url, headers, grant) {
        return _regeneratorRuntime__default['default'].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

                _context5.next = 3;
                return this.upstream.send("GET", url, headers, undefined, grant);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function get(_x5, _x6, _x7) {
        return _get3.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Post HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {body} body Body to send
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee6(url, headers, body, grant) {
        return _regeneratorRuntime__default['default'].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

                _context6.next = 3;
                return this.upstream.send("POST", url, headers, body, grant);

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function post(_x8, _x9, _x10, _x11) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
    /**
     * Put HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {body} body Body to send
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee7(url, headers, body, grant) {
        return _regeneratorRuntime__default['default'].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

                _context7.next = 3;
                return this.upstream.send("PUT", url, headers, body, grant);

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function put(_x12, _x13, _x14, _x15) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Delete HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {body} body Body to send
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee8(url, headers, body, grant) {
        return _regeneratorRuntime__default['default'].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

                _context8.next = 3;
                return this.upstream.send("DELETE", url, headers, body, grant);

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function _delete(_x16, _x17, _x18, _x19) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
    /**
     * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
     * @param {TelemetryEventDescription} event Event details.
     * @returns {void}
     */

  }, {
    key: "addTelemetryEvent",
    value: function addTelemetryEvent(event) {
      this.telemetryTracker.addTelemetryEvent(event);
      this.telemetryTracker.sendTelemetryIfMinimalPortionCollected(); // send telemetry if need
    }
    /**
     * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
     * @param {TelemetryEventDescription} event Event details.
     * @param {string} eventKey Unique event key.
     * @param {TelemetryPoint} point Is this partial event for start or end of measurement.
     * @returns {void}
     */

  }, {
    key: "addPartialTelemetryEvent",
    value: function addPartialTelemetryEvent(event, eventKey, point) {
      this.telemetryTracker.addPartialEvent(event, eventKey, point);

      if (point === exports.TelemetryPoint.End) {
        // this telemetry event is complete, so minimal portion could become ready to send
        this.telemetryTracker.sendTelemetryIfMinimalPortionCollected(); // send telemetry if need
      }
    }
  }]);

  return TwilsockClient;
}(EventEmitter);

exports.TwilsockClient = __decorate([declarativeTypeValidator.validateConstructorTypes(declarativeTypeValidator.nonEmptyString, declarativeTypeValidator.nonEmptyString, [declarativeTypeValidator.pureObject, "undefined", declarativeTypeValidator.literal(null)]), __metadata("design:paramtypes", [String, String, Object])], exports.TwilsockClient);
/**
 * Twilsock destination address descriptor
 * @typedef {Object} Twilsock#Address
 * @property {String} method - HTTP method. (POST, PUT, etc)
 * @property {String} host - host name without path. (e.g. my.company.com)
 * @property {String} path - path on the host (e.g. /my/app/to/call.php)
 */

/**
 * Twilsock upstream message
 * @typedef {Object} Twilsock#Message
 * @property {Twilsock#Address} to - destination address
 * @property {Object} headers - HTTP headers
 * @property {Object} body - Body
 */

/**
 * Fired when new message received
 * @param {Twilsock#Message} message
 * @event Twilsock#message
 */

/**
 * Fired when socket connected
 * @param {String} URI of endpoint
 * @event Twilsock#connected
 */

/**
 * Fired when socket disconnected
 * @event Twilsock#disconnected
 */

/**
 * Fired when token is about to expire and should be updated
 * @event Twilsock#tokenAboutToExpire
 */

/**
 * Fired when token has expired and connection is aborted
 * @event Twilsock#tokenExpired
 */

/**
 * Fired when socket connected
 * @param ConnectionState state - general twilsock state
 * @event Twilsock#stateChanged
 */

/**
 * Fired when connection is interrupted by unexpected reason
 * @type {Object}
 * @property {Boolean} terminal - twilsock will stop connection attempts
 * @property {String} message - root cause
 * @property {Number} [httpStatusCode] - http status code if available
 * @property {Number} [errorCode] - Twilio public error code if available
 * @event Twilsock#connectionError
 */

var InitRegistration = /*#__PURE__*/function () {
  // It's a Set<string> but TS cannot serialize Sets properly.
  function InitRegistration(product) {
    _classCallCheck__default['default'](this, InitRegistration);

    this.product = product;
    this.type = "ers";
    this.notification_protocol_version = 0;
    this.message_types = [];
  }
  /*
   * @internal
   *
   * Populate init registrations section in the Twilsock configuration generically with
   * passed-in list of types to register.
   *
   * Used only by the SDK, ignore.
   *
   * @param {string[]} types List of types to add to init registrations in options.
   * @param {object} options Twilsock options object to update. Omit to create a new one.
   */


  _createClass__default['default'](InitRegistration, [{
    key: "populateInitRegistrations",
    value: function populateInitRegistrations(types) {
      var s = new Set(this.message_types); // Update options reference in place

      for (var idx in types) {
        s.add(types[idx]);
      }

      this.message_types = Array.from(s);
    }
  }]);

  return InitRegistration;
}();

exports.InitRegistration = InitRegistration;
exports.TelemetryEventDescription = TelemetryEventDescription;
exports.TelemetryTracker = TelemetryTracker;
exports.TransportUnavailableError = TransportUnavailableError;
exports.Twilsock = exports.TwilsockClient;
exports.TwilsockError = TwilsockError;
//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 14062:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(91770);
var isNumber = __webpack_require__(28038);
var isBoolean = __webpack_require__(4836);
var isSymbol = __webpack_require__(44582);
var isBigInt = __webpack_require__(84155);

// eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString(value)) {
		return 'String';
	}
	if (isNumber(value)) {
		return 'Number';
	}
	if (isBoolean(value)) {
		return 'Boolean';
	}
	if (isSymbol(value)) {
		return 'Symbol';
	}
	if (isBigInt(value)) {
		return 'BigInt';
	}
};


/***/ }),

/***/ 49154:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(77025);
var availableTypedArrays = __webpack_require__(23206);
var callBind = __webpack_require__(73235);
var callBound = __webpack_require__(47737);
var gOPD = __webpack_require__(41455);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(76686)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			cache['$' + typedArray] = callBind(descriptor.get);
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			cache['$' + typedArray] = callBind(fn);
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var found = false;
	forEach(cache, function (getter, typedArray) {
		if (!found) {
			try {
				if ('$' + getter(value) === typedArray) {
					found = $slice(typedArray, 1);
				}
			} catch (e) { /**/ }
		}
	});
	return found;
};

var trySlices = function tryAllSlices(value) {
	var found = false;
	forEach(cache, function (getter, name) {
		if (!found) {
			try {
				getter(value);
				found = $slice(name, 1);
			} catch (e) { /**/ }
		}
	});
	return found;
};

module.exports = function whichTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag) {
		var tag = $slice($toString(value), 8, -1);
		if ($indexOf(typedArrays, tag) > -1) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
};


/***/ }),

/***/ 29714:
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6900:
/***/ (function(module) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(29714);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 56121:
/***/ (function(module) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20164:
/***/ (function(module) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 62638:
/***/ (function(module) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 73994:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(93494);
var isNativeReflectConstruct = __webpack_require__(71543);
function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }
  return _construct.apply(null, arguments);
}
module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(96174);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(96174);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 26480:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var superPropBase = __webpack_require__(57843);
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }
  return _get.apply(this, arguments);
}
module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 94692:
/***/ (function(module) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 40126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(93494);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 2298:
/***/ (function(module) {

function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 71543:
/***/ (function(module) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 84159:
/***/ (function(module) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 96313:
/***/ (function(module) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 45171:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 53784:
/***/ (function(module) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(8114)["default"]);
var assertThisInitialized = __webpack_require__(56121);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 39649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(8114)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93494:
/***/ (function(module) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 98371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(6900);
var iterableToArrayLimit = __webpack_require__(96313);
var unsupportedIterableToArray = __webpack_require__(69563);
var nonIterableRest = __webpack_require__(45171);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 57843:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(94692);
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 40299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(17684);
var iterableToArray = __webpack_require__(84159);
var unsupportedIterableToArray = __webpack_require__(69563);
var nonIterableSpread = __webpack_require__(53784);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 27662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(8114)["default"]);
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 96174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(8114)["default"]);
var toPrimitive = __webpack_require__(27662);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8114:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69563:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(29714);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(94692);
var setPrototypeOf = __webpack_require__(93494);
var isNativeFunction = __webpack_require__(2298);
var construct = __webpack_require__(73994);
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _wrapNativeSuper(Class);
}
module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 72975:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(39649)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 23206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 78465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(44697);
var tryToString = __webpack_require__(90581);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 34193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__(49283);
var tryToString = __webpack_require__(90581);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 76024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(44697);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 88764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(62745);
var create = __webpack_require__(66990);
var defineProperty = (__webpack_require__(92382).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 99319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(45415).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 37397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(78767);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 2726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(87255);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 40993:
/***/ (function(module) {

"use strict";

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ 83231:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__(90898);

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ 48745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(40993);
var DESCRIPTORS = __webpack_require__(37215);
var global = __webpack_require__(29327);
var isCallable = __webpack_require__(44697);
var isObject = __webpack_require__(87255);
var hasOwn = __webpack_require__(49803);
var classof = __webpack_require__(30105);
var tryToString = __webpack_require__(90581);
var createNonEnumerableProperty = __webpack_require__(9425);
var defineBuiltIn = __webpack_require__(79494);
var defineBuiltInAccessor = __webpack_require__(97439);
var isPrototypeOf = __webpack_require__(78767);
var getPrototypeOf = __webpack_require__(49549);
var setPrototypeOf = __webpack_require__(40719);
var wellKnownSymbol = __webpack_require__(62745);
var uid = __webpack_require__(76481);
var InternalStateModule = __webpack_require__(54617);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw new TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw new TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 8602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var uncurryThis = __webpack_require__(93963);
var DESCRIPTORS = __webpack_require__(37215);
var NATIVE_ARRAY_BUFFER = __webpack_require__(40993);
var FunctionName = __webpack_require__(31334);
var createNonEnumerableProperty = __webpack_require__(9425);
var defineBuiltInAccessor = __webpack_require__(97439);
var defineBuiltIns = __webpack_require__(71728);
var fails = __webpack_require__(90898);
var anInstance = __webpack_require__(37397);
var toIntegerOrInfinity = __webpack_require__(64388);
var toLength = __webpack_require__(35385);
var toIndex = __webpack_require__(61909);
var fround = __webpack_require__(39137);
var IEEE754 = __webpack_require__(50196);
var getPrototypeOf = __webpack_require__(49549);
var setPrototypeOf = __webpack_require__(40719);
var getOwnPropertyNames = (__webpack_require__(69761).f);
var arrayFill = __webpack_require__(80778);
var arraySlice = __webpack_require__(90202);
var setToStringTag = __webpack_require__(69817);
var InternalStateModule = __webpack_require__(54617);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
var setInternalState = InternalStateModule.set;
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = global.Array;
var RangeError = global.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(fround(number), 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return boolIsLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var pack = conversion(+value);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw new RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw new RangeError(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ 45907:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(5110);
var toAbsoluteIndex = __webpack_require__(73504);
var lengthOfArrayLike = __webpack_require__(93506);
var deletePropertyOrThrow = __webpack_require__(3851);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ 80778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(5110);
var toAbsoluteIndex = __webpack_require__(73504);
var lengthOfArrayLike = __webpack_require__(93506);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ 35526:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = (__webpack_require__(33131).forEach);
var arrayMethodIsStrict = __webpack_require__(7366);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 51861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(93506);

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 6480:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(61643);
var call = __webpack_require__(27981);
var toObject = __webpack_require__(5110);
var callWithSafeIterationClosing = __webpack_require__(14718);
var isArrayIteratorMethod = __webpack_require__(29773);
var isConstructor = __webpack_require__(49283);
var lengthOfArrayLike = __webpack_require__(93506);
var createProperty = __webpack_require__(87490);
var getIterator = __webpack_require__(24075);
var getIteratorMethod = __webpack_require__(94746);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 16236:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(44276);
var toAbsoluteIndex = __webpack_require__(73504);
var lengthOfArrayLike = __webpack_require__(93506);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 33131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(61643);
var uncurryThis = __webpack_require__(93963);
var IndexedObject = __webpack_require__(68395);
var toObject = __webpack_require__(5110);
var lengthOfArrayLike = __webpack_require__(93506);
var arraySpeciesCreate = __webpack_require__(93020);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 55088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = __webpack_require__(35680);
var toIndexedObject = __webpack_require__(44276);
var toIntegerOrInfinity = __webpack_require__(64388);
var lengthOfArrayLike = __webpack_require__(93506);
var arrayMethodIsStrict = __webpack_require__(7366);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ 13012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var wellKnownSymbol = __webpack_require__(62745);
var V8_VERSION = __webpack_require__(61544);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 7366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 89445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(78465);
var toObject = __webpack_require__(5110);
var IndexedObject = __webpack_require__(68395);
var lengthOfArrayLike = __webpack_require__(93506);

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ 11614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var isArray = __webpack_require__(38080);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 90202:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toAbsoluteIndex = __webpack_require__(73504);
var lengthOfArrayLike = __webpack_require__(93506);
var createProperty = __webpack_require__(87490);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ 37282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 15871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySlice = __webpack_require__(90202);

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ 36497:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(38080);
var isConstructor = __webpack_require__(49283);
var isObject = __webpack_require__(87255);
var wellKnownSymbol = __webpack_require__(62745);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 93020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__(36497);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 14718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2726);
var iteratorClose = __webpack_require__(60027);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 69188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(62745);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 47684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 30105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(50934);
var isCallable = __webpack_require__(44697);
var classofRaw = __webpack_require__(47684);
var wellKnownSymbol = __webpack_require__(62745);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 56556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(66990);
var defineBuiltInAccessor = __webpack_require__(97439);
var defineBuiltIns = __webpack_require__(71728);
var bind = __webpack_require__(61643);
var anInstance = __webpack_require__(37397);
var isNullOrUndefined = __webpack_require__(4852);
var iterate = __webpack_require__(51956);
var defineIterator = __webpack_require__(55641);
var createIterResultObject = __webpack_require__(70980);
var setSpecies = __webpack_require__(84746);
var DESCRIPTORS = __webpack_require__(37215);
var fastKey = (__webpack_require__(6142).fastKey);
var InternalStateModule = __webpack_require__(54617);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key === key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first === entry) state.first = next;
          if (state.last === entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind === 'keys') return createIterResultObject(entry.key, false);
      if (kind === 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ 65002:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var defineBuiltIns = __webpack_require__(71728);
var getWeakData = (__webpack_require__(6142).getWeakData);
var anInstance = __webpack_require__(37397);
var anObject = __webpack_require__(2726);
var isNullOrUndefined = __webpack_require__(4852);
var isObject = __webpack_require__(87255);
var iterate = __webpack_require__(51956);
var ArrayIterationModule = __webpack_require__(33131);
var hasOwn = __webpack_require__(49803);
var InternalStateModule = __webpack_require__(54617);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};


/***/ }),

/***/ 77768:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var global = __webpack_require__(29327);
var uncurryThis = __webpack_require__(93963);
var isForced = __webpack_require__(41086);
var defineBuiltIn = __webpack_require__(79494);
var InternalMetadataModule = __webpack_require__(6142);
var iterate = __webpack_require__(51956);
var anInstance = __webpack_require__(37397);
var isCallable = __webpack_require__(44697);
var isNullOrUndefined = __webpack_require__(4852);
var isObject = __webpack_require__(87255);
var fails = __webpack_require__(90898);
var checkCorrectnessOfIteration = __webpack_require__(69188);
var setToStringTag = __webpack_require__(69817);
var inheritIfRequired = __webpack_require__(10599);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY === 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 4812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(49803);
var ownKeys = __webpack_require__(6361);
var getOwnPropertyDescriptorModule = __webpack_require__(25497);
var definePropertyModule = __webpack_require__(92382);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 43892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(62745);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 67292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 70980:
/***/ (function(module) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 9425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var definePropertyModule = __webpack_require__(92382);
var createPropertyDescriptor = __webpack_require__(30603);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 30603:
/***/ (function(module) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 87490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(71122);
var definePropertyModule = __webpack_require__(92382);
var createPropertyDescriptor = __webpack_require__(30603);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 97439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(14565);
var defineProperty = __webpack_require__(92382);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 79494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(44697);
var definePropertyModule = __webpack_require__(92382);
var makeBuiltIn = __webpack_require__(14565);
var defineGlobalProperty = __webpack_require__(33511);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 71728:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(79494);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 33511:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 3851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(90581);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 37215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 77503:
/***/ (function(module) {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 14025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var isObject = __webpack_require__(87255);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 57264:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 1465:
/***/ (function(module) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 93295:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(14025);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 64186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(89991);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 65030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_DENO = __webpack_require__(92659);
var IS_NODE = __webpack_require__(16407);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ 92659:
/***/ (function(module) {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ 19826:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var UA = __webpack_require__(89991);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 62418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(89991);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ 47501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(89991);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 16407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var classof = __webpack_require__(47684);

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ 12322:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(89991);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 89991:
/***/ (function(module) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 61544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var userAgent = __webpack_require__(89991);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 45761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(89991);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 43132:
/***/ (function(module) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 36924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var getOwnPropertyDescriptor = (__webpack_require__(25497).f);
var createNonEnumerableProperty = __webpack_require__(9425);
var defineBuiltIn = __webpack_require__(79494);
var defineGlobalProperty = __webpack_require__(33511);
var copyConstructorProperties = __webpack_require__(4812);
var isForced = __webpack_require__(41086);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 90898:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 57530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(47995);
var uncurryThis = __webpack_require__(90893);
var defineBuiltIn = __webpack_require__(79494);
var regexpExec = __webpack_require__(62937);
var fails = __webpack_require__(90898);
var wellKnownSymbol = __webpack_require__(62745);
var createNonEnumerableProperty = __webpack_require__(9425);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 90697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 35680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(97370);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 61643:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(90893);
var aCallable = __webpack_require__(78465);
var NATIVE_BIND = __webpack_require__(97370);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 97370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 93336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var aCallable = __webpack_require__(78465);
var isObject = __webpack_require__(87255);
var hasOwn = __webpack_require__(49803);
var arraySlice = __webpack_require__(37282);
var NATIVE_BIND = __webpack_require__(97370);

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    var list = [];
    var i = 0;
    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ 27981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(97370);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 31334:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var hasOwn = __webpack_require__(49803);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 96345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var aCallable = __webpack_require__(78465);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 90893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(47684);
var uncurryThis = __webpack_require__(93963);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 93963:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(97370);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var isCallable = __webpack_require__(44697);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 94746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(30105);
var getMethod = __webpack_require__(36582);
var isNullOrUndefined = __webpack_require__(4852);
var Iterators = __webpack_require__(21857);
var wellKnownSymbol = __webpack_require__(62745);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 24075:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var aCallable = __webpack_require__(78465);
var anObject = __webpack_require__(2726);
var tryToString = __webpack_require__(90581);
var getIteratorMethod = __webpack_require__(94746);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 62689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var isArray = __webpack_require__(38080);
var isCallable = __webpack_require__(44697);
var classof = __webpack_require__(47684);
var toString = __webpack_require__(44514);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 36582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(78465);
var isNullOrUndefined = __webpack_require__(4852);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 25210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var toObject = __webpack_require__(5110);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 29327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 49803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var toObject = __webpack_require__(5110);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 50408:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 29322:
/***/ (function(module) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 51975:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5020);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 83163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var fails = __webpack_require__(90898);
var createElement = __webpack_require__(14025);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 50196:
/***/ (function(module) {

"use strict";

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number !== number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number !== number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent += eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa += pow(2, mantissaLength);
    exponent -= eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),

/***/ 68395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var fails = __webpack_require__(90898);
var classof = __webpack_require__(47684);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 10599:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(44697);
var isObject = __webpack_require__(87255);
var setPrototypeOf = __webpack_require__(40719);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 85869:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var isCallable = __webpack_require__(44697);
var store = __webpack_require__(99090);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 6142:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var uncurryThis = __webpack_require__(93963);
var hiddenKeys = __webpack_require__(50408);
var isObject = __webpack_require__(87255);
var hasOwn = __webpack_require__(49803);
var defineProperty = (__webpack_require__(92382).f);
var getOwnPropertyNamesModule = __webpack_require__(69761);
var getOwnPropertyNamesExternalModule = __webpack_require__(47816);
var isExtensible = __webpack_require__(59976);
var uid = __webpack_require__(76481);
var FREEZING = __webpack_require__(90697);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 54617:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(61028);
var global = __webpack_require__(29327);
var isObject = __webpack_require__(87255);
var createNonEnumerableProperty = __webpack_require__(9425);
var hasOwn = __webpack_require__(49803);
var shared = __webpack_require__(99090);
var sharedKey = __webpack_require__(22644);
var hiddenKeys = __webpack_require__(50408);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 29773:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(62745);
var Iterators = __webpack_require__(21857);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 38080:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(47684);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 22549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(30105);

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};


/***/ }),

/***/ 44697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $documentAll = __webpack_require__(77503);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 49283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var fails = __webpack_require__(90898);
var isCallable = __webpack_require__(44697);
var classof = __webpack_require__(30105);
var getBuiltIn = __webpack_require__(5020);
var inspectSource = __webpack_require__(85869);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 41086:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var isCallable = __webpack_require__(44697);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 47117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(87255);

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 4852:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 87255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(44697);
var $documentAll = __webpack_require__(77503);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 73628:
/***/ (function(module) {

"use strict";

module.exports = false;


/***/ }),

/***/ 74296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(87255);
var classof = __webpack_require__(47684);
var wellKnownSymbol = __webpack_require__(62745);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),

/***/ 12887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5020);
var isCallable = __webpack_require__(44697);
var isPrototypeOf = __webpack_require__(78767);
var USE_SYMBOL_AS_UID = __webpack_require__(94169);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 51956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(61643);
var call = __webpack_require__(27981);
var anObject = __webpack_require__(2726);
var tryToString = __webpack_require__(90581);
var isArrayIteratorMethod = __webpack_require__(29773);
var lengthOfArrayLike = __webpack_require__(93506);
var isPrototypeOf = __webpack_require__(78767);
var getIterator = __webpack_require__(24075);
var getIteratorMethod = __webpack_require__(94746);
var iteratorClose = __webpack_require__(60027);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 60027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var anObject = __webpack_require__(2726);
var getMethod = __webpack_require__(36582);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 66137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = (__webpack_require__(11901).IteratorPrototype);
var create = __webpack_require__(66990);
var createPropertyDescriptor = __webpack_require__(30603);
var setToStringTag = __webpack_require__(69817);
var Iterators = __webpack_require__(21857);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 55641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var call = __webpack_require__(27981);
var IS_PURE = __webpack_require__(73628);
var FunctionName = __webpack_require__(31334);
var isCallable = __webpack_require__(44697);
var createIteratorConstructor = __webpack_require__(66137);
var getPrototypeOf = __webpack_require__(49549);
var setPrototypeOf = __webpack_require__(40719);
var setToStringTag = __webpack_require__(69817);
var createNonEnumerableProperty = __webpack_require__(9425);
var defineBuiltIn = __webpack_require__(79494);
var wellKnownSymbol = __webpack_require__(62745);
var Iterators = __webpack_require__(21857);
var IteratorsCore = __webpack_require__(11901);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 11901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var isCallable = __webpack_require__(44697);
var isObject = __webpack_require__(87255);
var create = __webpack_require__(66990);
var getPrototypeOf = __webpack_require__(49549);
var defineBuiltIn = __webpack_require__(79494);
var wellKnownSymbol = __webpack_require__(62745);
var IS_PURE = __webpack_require__(73628);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 21857:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 93506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(35385);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 14565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var fails = __webpack_require__(90898);
var isCallable = __webpack_require__(44697);
var hasOwn = __webpack_require__(49803);
var DESCRIPTORS = __webpack_require__(37215);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(31334).CONFIGURABLE);
var inspectSource = __webpack_require__(85869);
var InternalStateModule = __webpack_require__(54617);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 45711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var sign = __webpack_require__(38555);

var abs = Math.abs;

var EPSILON = 2.220446049250313e-16; // Number.EPSILON
var INVERSE_EPSILON = 1 / EPSILON;

var roundTiesToEven = function (n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};

module.exports = function (x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
  var n = +x;
  var absolute = abs(n);
  var s = sign(n);
  if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
  var result = a - (a - absolute);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
  return s * result;
};


/***/ }),

/***/ 39137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var floatRound = __webpack_require__(45711);

var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
module.exports = Math.fround || function fround(x) {
  return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
};


/***/ }),

/***/ 38555:
/***/ (function(module) {

"use strict";

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
  var n = +x;
  // eslint-disable-next-line no-self-compare -- NaN check
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


/***/ }),

/***/ 41260:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 65558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var bind = __webpack_require__(61643);
var getOwnPropertyDescriptor = (__webpack_require__(25497).f);
var macrotask = (__webpack_require__(13816).set);
var Queue = __webpack_require__(62652);
var IS_IOS = __webpack_require__(47501);
var IS_IOS_PEBBLE = __webpack_require__(62418);
var IS_WEBOS_WEBKIT = __webpack_require__(12322);
var IS_NODE = __webpack_require__(16407);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ 19928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(78465);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 44282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isRegExp = __webpack_require__(74296);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 95902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var uncurryThis = __webpack_require__(93963);
var call = __webpack_require__(27981);
var fails = __webpack_require__(90898);
var objectKeys = __webpack_require__(29328);
var getOwnPropertySymbolsModule = __webpack_require__(80157);
var propertyIsEnumerableModule = __webpack_require__(13440);
var toObject = __webpack_require__(5110);
var IndexedObject = __webpack_require__(68395);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 66990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(2726);
var definePropertiesModule = __webpack_require__(86848);
var enumBugKeys = __webpack_require__(43132);
var hiddenKeys = __webpack_require__(50408);
var html = __webpack_require__(51975);
var documentCreateElement = __webpack_require__(14025);
var sharedKey = __webpack_require__(22644);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 86848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(67632);
var definePropertyModule = __webpack_require__(92382);
var anObject = __webpack_require__(2726);
var toIndexedObject = __webpack_require__(44276);
var objectKeys = __webpack_require__(29328);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 92382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var IE8_DOM_DEFINE = __webpack_require__(83163);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(67632);
var anObject = __webpack_require__(2726);
var toPropertyKey = __webpack_require__(71122);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 25497:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var call = __webpack_require__(27981);
var propertyIsEnumerableModule = __webpack_require__(13440);
var createPropertyDescriptor = __webpack_require__(30603);
var toIndexedObject = __webpack_require__(44276);
var toPropertyKey = __webpack_require__(71122);
var hasOwn = __webpack_require__(49803);
var IE8_DOM_DEFINE = __webpack_require__(83163);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(47684);
var toIndexedObject = __webpack_require__(44276);
var $getOwnPropertyNames = (__webpack_require__(69761).f);
var arraySlice = __webpack_require__(90202);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 69761:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(37512);
var enumBugKeys = __webpack_require__(43132);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 80157:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 49549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(49803);
var isCallable = __webpack_require__(44697);
var toObject = __webpack_require__(5110);
var sharedKey = __webpack_require__(22644);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(67292);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 59976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var isObject = __webpack_require__(87255);
var classof = __webpack_require__(47684);
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(83231);

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ 78767:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 37512:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var hasOwn = __webpack_require__(49803);
var toIndexedObject = __webpack_require__(44276);
var indexOf = (__webpack_require__(16236).indexOf);
var hiddenKeys = __webpack_require__(50408);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 29328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(37512);
var enumBugKeys = __webpack_require__(43132);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 13440:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 40719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(96345);
var anObject = __webpack_require__(2726);
var aPossiblePrototype = __webpack_require__(76024);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 96363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var fails = __webpack_require__(90898);
var uncurryThis = __webpack_require__(93963);
var objectGetPrototypeOf = __webpack_require__(49549);
var objectKeys = __webpack_require__(29328);
var toIndexedObject = __webpack_require__(44276);
var $propertyIsEnumerable = (__webpack_require__(13440).f);

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ 12717:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(50934);
var classof = __webpack_require__(30105);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 26956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var isCallable = __webpack_require__(44697);
var isObject = __webpack_require__(87255);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 6361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5020);
var uncurryThis = __webpack_require__(93963);
var getOwnPropertyNamesModule = __webpack_require__(69761);
var getOwnPropertySymbolsModule = __webpack_require__(80157);
var anObject = __webpack_require__(2726);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 84539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);

module.exports = global;


/***/ }),

/***/ 6299:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 75145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var NativePromiseConstructor = __webpack_require__(354);
var isCallable = __webpack_require__(44697);
var isForced = __webpack_require__(41086);
var inspectSource = __webpack_require__(85869);
var wellKnownSymbol = __webpack_require__(62745);
var IS_BROWSER = __webpack_require__(65030);
var IS_DENO = __webpack_require__(92659);
var IS_PURE = __webpack_require__(73628);
var V8_VERSION = __webpack_require__(61544);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 354:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);

module.exports = global.Promise;


/***/ }),

/***/ 75434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2726);
var isObject = __webpack_require__(87255);
var newPromiseCapability = __webpack_require__(19928);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 29081:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__(354);
var checkCorrectnessOfIteration = __webpack_require__(69188);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(75145).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 62652:
/***/ (function(module) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 54795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var anObject = __webpack_require__(2726);
var isCallable = __webpack_require__(44697);
var classof = __webpack_require__(47684);
var regexpExec = __webpack_require__(62937);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw new $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 62937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(27981);
var uncurryThis = __webpack_require__(93963);
var toString = __webpack_require__(44514);
var regexpFlags = __webpack_require__(61135);
var stickyHelpers = __webpack_require__(98848);
var shared = __webpack_require__(50082);
var create = __webpack_require__(66990);
var getInternalState = (__webpack_require__(54617).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(81506);
var UNSUPPORTED_NCG = __webpack_require__(69872);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 61135:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2726);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 42322:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var hasOwn = __webpack_require__(49803);
var isPrototypeOf = __webpack_require__(78767);
var regExpFlags = __webpack_require__(61135);

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ 98848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var global = __webpack_require__(29327);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ 81506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var global = __webpack_require__(29327);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});


/***/ }),

/***/ 69872:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var global = __webpack_require__(29327);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 33823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(4852);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 67206:
/***/ (function(module) {

"use strict";

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


/***/ }),

/***/ 84746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5020);
var defineBuiltInAccessor = __webpack_require__(97439);
var wellKnownSymbol = __webpack_require__(62745);
var DESCRIPTORS = __webpack_require__(37215);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 69817:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(92382).f);
var hasOwn = __webpack_require__(49803);
var wellKnownSymbol = __webpack_require__(62745);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 22644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(50082);
var uid = __webpack_require__(76481);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 99090:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var defineGlobalProperty = __webpack_require__(33511);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 50082:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(73628);
var store = __webpack_require__(99090);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 43439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2726);
var aConstructor = __webpack_require__(34193);
var isNullOrUndefined = __webpack_require__(4852);
var wellKnownSymbol = __webpack_require__(62745);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 45415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var toIntegerOrInfinity = __webpack_require__(64388);
var toString = __webpack_require__(44514);
var requireObjectCoercible = __webpack_require__(33823);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 88915:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = __webpack_require__(93963);

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};


/***/ }),

/***/ 75411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var requireObjectCoercible = __webpack_require__(33823);
var toString = __webpack_require__(44514);
var whitespaces = __webpack_require__(37852);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 24394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(61544);
var fails = __webpack_require__(90898);
var global = __webpack_require__(29327);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 78441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var getBuiltIn = __webpack_require__(5020);
var wellKnownSymbol = __webpack_require__(62745);
var defineBuiltIn = __webpack_require__(79494);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(24394);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 13816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var apply = __webpack_require__(35680);
var bind = __webpack_require__(61643);
var isCallable = __webpack_require__(44697);
var hasOwn = __webpack_require__(49803);
var fails = __webpack_require__(90898);
var html = __webpack_require__(51975);
var arraySlice = __webpack_require__(37282);
var createElement = __webpack_require__(14025);
var validateArgumentsLength = __webpack_require__(71373);
var IS_IOS = __webpack_require__(47501);
var IS_NODE = __webpack_require__(16407);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 50487:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ 73504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(64388);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 54843:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(76104);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),

/***/ 61909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(64388);
var toLength = __webpack_require__(35385);

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw new $RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ 44276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(68395);
var requireObjectCoercible = __webpack_require__(33823);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 64388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(41260);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 35385:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(64388);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 5110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(33823);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 89670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPositiveInteger = __webpack_require__(89390);

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ 89390:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(64388);

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw new $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ 76104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var isObject = __webpack_require__(87255);
var isSymbol = __webpack_require__(12887);
var getMethod = __webpack_require__(36582);
var ordinaryToPrimitive = __webpack_require__(26956);
var wellKnownSymbol = __webpack_require__(62745);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 71122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(76104);
var isSymbol = __webpack_require__(12887);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 50934:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(62745);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 44514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(30105);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 93078:
/***/ (function(module) {

"use strict";

var round = Math.round;

module.exports = function (it) {
  var value = round(it);
  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};


/***/ }),

/***/ 90581:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 11966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var global = __webpack_require__(29327);
var call = __webpack_require__(27981);
var DESCRIPTORS = __webpack_require__(37215);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(33939);
var ArrayBufferViewCore = __webpack_require__(48745);
var ArrayBufferModule = __webpack_require__(8602);
var anInstance = __webpack_require__(37397);
var createPropertyDescriptor = __webpack_require__(30603);
var createNonEnumerableProperty = __webpack_require__(9425);
var isIntegralNumber = __webpack_require__(47117);
var toLength = __webpack_require__(35385);
var toIndex = __webpack_require__(61909);
var toOffset = __webpack_require__(89670);
var toUint8Clamped = __webpack_require__(93078);
var toPropertyKey = __webpack_require__(71122);
var hasOwn = __webpack_require__(49803);
var classof = __webpack_require__(30105);
var isObject = __webpack_require__(87255);
var isSymbol = __webpack_require__(12887);
var create = __webpack_require__(66990);
var isPrototypeOf = __webpack_require__(78767);
var setPrototypeOf = __webpack_require__(40719);
var getOwnPropertyNames = (__webpack_require__(69761).f);
var typedArrayFrom = __webpack_require__(11409);
var forEach = (__webpack_require__(33131).forEach);
var setSpecies = __webpack_require__(84746);
var defineBuiltInAccessor = __webpack_require__(97439);
var definePropertyModule = __webpack_require__(92382);
var getOwnPropertyDescriptorModule = __webpack_require__(25497);
var InternalStateModule = __webpack_require__(54617);
var inheritIfRequired = __webpack_require__(10599);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw new RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw new RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw new RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ 33939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__(29327);
var fails = __webpack_require__(90898);
var checkCorrectnessOfIteration = __webpack_require__(69188);
var NATIVE_ARRAY_BUFFER_VIEWS = (__webpack_require__(48745).NATIVE_ARRAY_BUFFER_VIEWS);

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),

/***/ 55596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arrayFromConstructorAndList = __webpack_require__(51861);
var typedArraySpeciesConstructor = __webpack_require__(72229);

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};


/***/ }),

/***/ 11409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(61643);
var call = __webpack_require__(27981);
var aConstructor = __webpack_require__(34193);
var toObject = __webpack_require__(5110);
var lengthOfArrayLike = __webpack_require__(93506);
var getIterator = __webpack_require__(24075);
var getIteratorMethod = __webpack_require__(94746);
var isArrayIteratorMethod = __webpack_require__(29773);
var isBigIntArray = __webpack_require__(22549);
var aTypedArrayConstructor = (__webpack_require__(48745).aTypedArrayConstructor);
var toBigInt = __webpack_require__(54843);

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};


/***/ }),

/***/ 72229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var speciesConstructor = __webpack_require__(43439);

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
};


/***/ }),

/***/ 76481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 64546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(90898);
var wellKnownSymbol = __webpack_require__(62745);
var DESCRIPTORS = __webpack_require__(37215);
var IS_PURE = __webpack_require__(73628);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ 94169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(24394);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 67632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var fails = __webpack_require__(90898);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 71373:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 61028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var isCallable = __webpack_require__(44697);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 61165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(84539);
var hasOwn = __webpack_require__(49803);
var wrappedWellKnownSymbolModule = __webpack_require__(2706);
var defineProperty = (__webpack_require__(92382).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 2706:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(62745);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 62745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var shared = __webpack_require__(50082);
var hasOwn = __webpack_require__(49803);
var uid = __webpack_require__(76481);
var NATIVE_SYMBOL = __webpack_require__(24394);
var USE_SYMBOL_AS_UID = __webpack_require__(94169);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 37852:
/***/ (function(module) {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 97458:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var global = __webpack_require__(29327);
var arrayBufferModule = __webpack_require__(8602);
var setSpecies = __webpack_require__(84746);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),

/***/ 93786:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var fails = __webpack_require__(90898);
var isArray = __webpack_require__(38080);
var isObject = __webpack_require__(87255);
var toObject = __webpack_require__(5110);
var lengthOfArrayLike = __webpack_require__(93506);
var doesNotExceedSafeInteger = __webpack_require__(57264);
var createProperty = __webpack_require__(87490);
var arraySpeciesCreate = __webpack_require__(93020);
var arrayMethodHasSpeciesSupport = __webpack_require__(13012);
var wellKnownSymbol = __webpack_require__(62745);
var V8_VERSION = __webpack_require__(61544);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 24477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var $filter = (__webpack_require__(33131).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(13012);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 62619:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var $find = (__webpack_require__(33131).find);
var addToUnscopables = __webpack_require__(88764);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 38110:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var from = __webpack_require__(6480);
var checkCorrectnessOfIteration = __webpack_require__(69188);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 11478:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var $includes = (__webpack_require__(16236).includes);
var fails = __webpack_require__(90898);
var addToUnscopables = __webpack_require__(88764);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 84874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(44276);
var addToUnscopables = __webpack_require__(88764);
var Iterators = __webpack_require__(21857);
var InternalStateModule = __webpack_require__(54617);
var defineProperty = (__webpack_require__(92382).f);
var defineIterator = __webpack_require__(55641);
var createIterResultObject = __webpack_require__(70980);
var IS_PURE = __webpack_require__(73628);
var DESCRIPTORS = __webpack_require__(37215);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 16669:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var uncurryThis = __webpack_require__(93963);
var IndexedObject = __webpack_require__(68395);
var toIndexedObject = __webpack_require__(44276);
var arrayMethodIsStrict = __webpack_require__(7366);

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 16822:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var $map = (__webpack_require__(33131).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(13012);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 86881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var $reduce = (__webpack_require__(89445).left);
var arrayMethodIsStrict = __webpack_require__(7366);
var CHROME_VERSION = __webpack_require__(61544);
var IS_NODE = __webpack_require__(16407);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 90614:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var isArray = __webpack_require__(38080);
var isConstructor = __webpack_require__(49283);
var isObject = __webpack_require__(87255);
var toAbsoluteIndex = __webpack_require__(73504);
var lengthOfArrayLike = __webpack_require__(93506);
var toIndexedObject = __webpack_require__(44276);
var createProperty = __webpack_require__(87490);
var wellKnownSymbol = __webpack_require__(62745);
var arrayMethodHasSpeciesSupport = __webpack_require__(13012);
var nativeSlice = __webpack_require__(37282);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 73486:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var uncurryThis = __webpack_require__(93963);
var aCallable = __webpack_require__(78465);
var toObject = __webpack_require__(5110);
var lengthOfArrayLike = __webpack_require__(93506);
var deletePropertyOrThrow = __webpack_require__(3851);
var toString = __webpack_require__(44514);
var fails = __webpack_require__(90898);
var internalSort = __webpack_require__(15871);
var arrayMethodIsStrict = __webpack_require__(7366);
var FF = __webpack_require__(64186);
var IE_OR_EDGE = __webpack_require__(19826);
var V8 = __webpack_require__(61544);
var WEBKIT = __webpack_require__(45761);

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});


/***/ }),

/***/ 1183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var toObject = __webpack_require__(5110);
var toAbsoluteIndex = __webpack_require__(73504);
var toIntegerOrInfinity = __webpack_require__(64388);
var lengthOfArrayLike = __webpack_require__(93506);
var setArrayLength = __webpack_require__(11614);
var doesNotExceedSafeInteger = __webpack_require__(57264);
var arraySpeciesCreate = __webpack_require__(93020);
var createProperty = __webpack_require__(87490);
var deletePropertyOrThrow = __webpack_require__(3851);
var arrayMethodHasSpeciesSupport = __webpack_require__(13012);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});


/***/ }),

/***/ 92979:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(37215);
var FUNCTION_NAME_EXISTS = (__webpack_require__(31334).EXISTS);
var uncurryThis = __webpack_require__(93963);
var defineBuiltInAccessor = __webpack_require__(97439);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 73772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var getBuiltIn = __webpack_require__(5020);
var apply = __webpack_require__(35680);
var call = __webpack_require__(27981);
var uncurryThis = __webpack_require__(93963);
var fails = __webpack_require__(90898);
var isCallable = __webpack_require__(44697);
var isSymbol = __webpack_require__(12887);
var arraySlice = __webpack_require__(37282);
var getReplacerFunction = __webpack_require__(62689);
var NATIVE_SYMBOL = __webpack_require__(24394);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 55163:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(77768);
var collectionStrong = __webpack_require__(56556);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 12702:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(55163);


/***/ }),

/***/ 39837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var IS_PURE = __webpack_require__(73628);
var DESCRIPTORS = __webpack_require__(37215);
var global = __webpack_require__(29327);
var path = __webpack_require__(84539);
var uncurryThis = __webpack_require__(93963);
var isForced = __webpack_require__(41086);
var hasOwn = __webpack_require__(49803);
var inheritIfRequired = __webpack_require__(10599);
var isPrototypeOf = __webpack_require__(78767);
var isSymbol = __webpack_require__(12887);
var toPrimitive = __webpack_require__(76104);
var fails = __webpack_require__(90898);
var getOwnPropertyNames = (__webpack_require__(69761).f);
var getOwnPropertyDescriptor = (__webpack_require__(25497).f);
var defineProperty = (__webpack_require__(92382).f);
var thisNumberValue = __webpack_require__(50487);
var trim = (__webpack_require__(75411).trim);

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw new TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        // fast equal of /^0b[01]+$/i
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0o[0-7]+$/i
        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        default:
          return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),

/***/ 77428:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var isIntegralNumber = __webpack_require__(47117);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),

/***/ 24491:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var assign = __webpack_require__(95902);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 83793:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var $entries = (__webpack_require__(96363).entries);

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ 17464:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var FREEZING = __webpack_require__(90697);
var fails = __webpack_require__(90898);
var isObject = __webpack_require__(87255);
var onFreeze = (__webpack_require__(6142).onFreeze);

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ 61765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var fails = __webpack_require__(90898);
var toIndexedObject = __webpack_require__(44276);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(25497).f);
var DESCRIPTORS = __webpack_require__(37215);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 96775:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var DESCRIPTORS = __webpack_require__(37215);
var ownKeys = __webpack_require__(6361);
var toIndexedObject = __webpack_require__(44276);
var getOwnPropertyDescriptorModule = __webpack_require__(25497);
var createProperty = __webpack_require__(87490);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 2888:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var NATIVE_SYMBOL = __webpack_require__(24394);
var fails = __webpack_require__(90898);
var getOwnPropertySymbolsModule = __webpack_require__(80157);
var toObject = __webpack_require__(5110);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 90061:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var toObject = __webpack_require__(5110);
var nativeKeys = __webpack_require__(29328);
var fails = __webpack_require__(90898);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 29978:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(50934);
var defineBuiltIn = __webpack_require__(79494);
var toString = __webpack_require__(12717);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 95201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var call = __webpack_require__(27981);
var aCallable = __webpack_require__(78465);
var newPromiseCapabilityModule = __webpack_require__(19928);
var perform = __webpack_require__(6299);
var iterate = __webpack_require__(51956);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(29081);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 10426:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var IS_PURE = __webpack_require__(73628);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(75145).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(354);
var getBuiltIn = __webpack_require__(5020);
var isCallable = __webpack_require__(44697);
var defineBuiltIn = __webpack_require__(79494);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 74048:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var IS_PURE = __webpack_require__(73628);
var IS_NODE = __webpack_require__(16407);
var global = __webpack_require__(29327);
var call = __webpack_require__(27981);
var defineBuiltIn = __webpack_require__(79494);
var setPrototypeOf = __webpack_require__(40719);
var setToStringTag = __webpack_require__(69817);
var setSpecies = __webpack_require__(84746);
var aCallable = __webpack_require__(78465);
var isCallable = __webpack_require__(44697);
var isObject = __webpack_require__(87255);
var anInstance = __webpack_require__(37397);
var speciesConstructor = __webpack_require__(43439);
var task = (__webpack_require__(13816).set);
var microtask = __webpack_require__(65558);
var hostReportErrors = __webpack_require__(29322);
var perform = __webpack_require__(6299);
var Queue = __webpack_require__(62652);
var InternalStateModule = __webpack_require__(54617);
var NativePromiseConstructor = __webpack_require__(354);
var PromiseConstructorDetection = __webpack_require__(75145);
var newPromiseCapabilityModule = __webpack_require__(19928);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 94184:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(74048);
__webpack_require__(95201);
__webpack_require__(10426);
__webpack_require__(76069);
__webpack_require__(83632);
__webpack_require__(35905);


/***/ }),

/***/ 76069:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var call = __webpack_require__(27981);
var aCallable = __webpack_require__(78465);
var newPromiseCapabilityModule = __webpack_require__(19928);
var perform = __webpack_require__(6299);
var iterate = __webpack_require__(51956);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(29081);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 83632:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var call = __webpack_require__(27981);
var newPromiseCapabilityModule = __webpack_require__(19928);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(75145).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ 35905:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var getBuiltIn = __webpack_require__(5020);
var IS_PURE = __webpack_require__(73628);
var NativePromiseConstructor = __webpack_require__(354);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(75145).CONSTRUCTOR);
var promiseResolve = __webpack_require__(75434);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 80437:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var getBuiltIn = __webpack_require__(5020);
var apply = __webpack_require__(35680);
var bind = __webpack_require__(93336);
var aConstructor = __webpack_require__(34193);
var anObject = __webpack_require__(2726);
var isObject = __webpack_require__(87255);
var create = __webpack_require__(66990);
var fails = __webpack_require__(90898);

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target === newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 14334:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var global = __webpack_require__(29327);
var setToStringTag = __webpack_require__(69817);

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ 47995:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var exec = __webpack_require__(62937);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 29282:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(47995);
var $ = __webpack_require__(36924);
var call = __webpack_require__(27981);
var isCallable = __webpack_require__(44697);
var anObject = __webpack_require__(2726);
var toString = __webpack_require__(44514);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});


/***/ }),

/***/ 34365:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(31334).PROPER);
var defineBuiltIn = __webpack_require__(79494);
var anObject = __webpack_require__(2726);
var $toString = __webpack_require__(44514);
var fails = __webpack_require__(90898);
var getRegExpFlags = __webpack_require__(42322);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ 93257:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(77768);
var collectionStrong = __webpack_require__(56556);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 86800:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(93257);


/***/ }),

/***/ 34071:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var uncurryThis = __webpack_require__(93963);
var notARegExp = __webpack_require__(44282);
var requireObjectCoercible = __webpack_require__(33823);
var toString = __webpack_require__(44514);
var correctIsRegExpLogic = __webpack_require__(43892);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ 71227:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(45415).charAt);
var toString = __webpack_require__(44514);
var InternalStateModule = __webpack_require__(54617);
var defineIterator = __webpack_require__(55641);
var createIterResultObject = __webpack_require__(70980);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ 92048:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(57530);
var anObject = __webpack_require__(2726);
var isNullOrUndefined = __webpack_require__(4852);
var toLength = __webpack_require__(35385);
var toString = __webpack_require__(44514);
var requireObjectCoercible = __webpack_require__(33823);
var getMethod = __webpack_require__(36582);
var advanceStringIndex = __webpack_require__(99319);
var regExpExec = __webpack_require__(54795);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 9280:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(35680);
var call = __webpack_require__(27981);
var uncurryThis = __webpack_require__(93963);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(57530);
var fails = __webpack_require__(90898);
var anObject = __webpack_require__(2726);
var isCallable = __webpack_require__(44697);
var isNullOrUndefined = __webpack_require__(4852);
var toIntegerOrInfinity = __webpack_require__(64388);
var toLength = __webpack_require__(35385);
var toString = __webpack_require__(44514);
var requireObjectCoercible = __webpack_require__(33823);
var advanceStringIndex = __webpack_require__(99319);
var getMethod = __webpack_require__(36582);
var getSubstitution = __webpack_require__(25210);
var regExpExec = __webpack_require__(54795);
var wellKnownSymbol = __webpack_require__(62745);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 80383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(27981);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(57530);
var anObject = __webpack_require__(2726);
var isNullOrUndefined = __webpack_require__(4852);
var requireObjectCoercible = __webpack_require__(33823);
var sameValue = __webpack_require__(67206);
var toString = __webpack_require__(44514);
var getMethod = __webpack_require__(36582);
var regExpExec = __webpack_require__(54795);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ 74643:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(35680);
var call = __webpack_require__(27981);
var uncurryThis = __webpack_require__(93963);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(57530);
var anObject = __webpack_require__(2726);
var isNullOrUndefined = __webpack_require__(4852);
var isRegExp = __webpack_require__(74296);
var requireObjectCoercible = __webpack_require__(33823);
var speciesConstructor = __webpack_require__(43439);
var advanceStringIndex = __webpack_require__(99319);
var toLength = __webpack_require__(35385);
var toString = __webpack_require__(44514);
var getMethod = __webpack_require__(36582);
var arraySlice = __webpack_require__(90202);
var callRegExpExec = __webpack_require__(54795);
var regexpExec = __webpack_require__(62937);
var stickyHelpers = __webpack_require__(98848);
var fails = __webpack_require__(90898);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] === 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length !== 4 ||
    'ab'.split(/(?:ab)*/).length !== 2 ||
    '.'.split(/(.?)(.?)/).length !== 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 63466:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var uncurryThis = __webpack_require__(90893);
var getOwnPropertyDescriptor = (__webpack_require__(25497).f);
var toLength = __webpack_require__(35385);
var toString = __webpack_require__(44514);
var notARegExp = __webpack_require__(44282);
var requireObjectCoercible = __webpack_require__(33823);
var correctIsRegExpLogic = __webpack_require__(43892);
var IS_PURE = __webpack_require__(73628);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ 61002:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var global = __webpack_require__(29327);
var call = __webpack_require__(27981);
var uncurryThis = __webpack_require__(93963);
var IS_PURE = __webpack_require__(73628);
var DESCRIPTORS = __webpack_require__(37215);
var NATIVE_SYMBOL = __webpack_require__(24394);
var fails = __webpack_require__(90898);
var hasOwn = __webpack_require__(49803);
var isPrototypeOf = __webpack_require__(78767);
var anObject = __webpack_require__(2726);
var toIndexedObject = __webpack_require__(44276);
var toPropertyKey = __webpack_require__(71122);
var $toString = __webpack_require__(44514);
var createPropertyDescriptor = __webpack_require__(30603);
var nativeObjectCreate = __webpack_require__(66990);
var objectKeys = __webpack_require__(29328);
var getOwnPropertyNamesModule = __webpack_require__(69761);
var getOwnPropertyNamesExternal = __webpack_require__(47816);
var getOwnPropertySymbolsModule = __webpack_require__(80157);
var getOwnPropertyDescriptorModule = __webpack_require__(25497);
var definePropertyModule = __webpack_require__(92382);
var definePropertiesModule = __webpack_require__(86848);
var propertyIsEnumerableModule = __webpack_require__(13440);
var defineBuiltIn = __webpack_require__(79494);
var defineBuiltInAccessor = __webpack_require__(97439);
var shared = __webpack_require__(50082);
var sharedKey = __webpack_require__(22644);
var hiddenKeys = __webpack_require__(50408);
var uid = __webpack_require__(76481);
var wellKnownSymbol = __webpack_require__(62745);
var wrappedWellKnownSymbolModule = __webpack_require__(2706);
var defineWellKnownSymbol = __webpack_require__(61165);
var defineSymbolToPrimitive = __webpack_require__(78441);
var setToStringTag = __webpack_require__(69817);
var InternalStateModule = __webpack_require__(54617);
var $forEach = (__webpack_require__(33131).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = global.RangeError;
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      var $this = this === undefined ? global : this;
      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 89615:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(36924);
var DESCRIPTORS = __webpack_require__(37215);
var global = __webpack_require__(29327);
var uncurryThis = __webpack_require__(93963);
var hasOwn = __webpack_require__(49803);
var isCallable = __webpack_require__(44697);
var isPrototypeOf = __webpack_require__(78767);
var toString = __webpack_require__(44514);
var defineBuiltInAccessor = __webpack_require__(97439);
var copyConstructorProperties = __webpack_require__(4812);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 14057:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var getBuiltIn = __webpack_require__(5020);
var hasOwn = __webpack_require__(49803);
var toString = __webpack_require__(44514);
var shared = __webpack_require__(50082);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(318);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 26847:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(61165);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 86283:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(61002);
__webpack_require__(14057);
__webpack_require__(16224);
__webpack_require__(73772);
__webpack_require__(2888);


/***/ }),

/***/ 16224:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(36924);
var hasOwn = __webpack_require__(49803);
var isSymbol = __webpack_require__(12887);
var tryToString = __webpack_require__(90581);
var shared = __webpack_require__(50082);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(318);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 43897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var lengthOfArrayLike = __webpack_require__(93506);
var toIntegerOrInfinity = __webpack_require__(64388);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.at` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.at
exportTypedArrayMethod('at', function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return (k < 0 || k >= len) ? undefined : O[k];
});


/***/ }),

/***/ 21262:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(93963);
var ArrayBufferViewCore = __webpack_require__(48745);
var $ArrayCopyWithin = __webpack_require__(45907);

var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),

/***/ 92453:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $every = (__webpack_require__(33131).every);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 15087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $fill = __webpack_require__(80778);
var toBigInt = __webpack_require__(54843);
var classof = __webpack_require__(30105);
var call = __webpack_require__(27981);
var uncurryThis = __webpack_require__(93963);
var fails = __webpack_require__(90898);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);


/***/ }),

/***/ 83061:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $filter = (__webpack_require__(33131).filter);
var fromSpeciesAndList = __webpack_require__(55596);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),

/***/ 22752:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $findIndex = (__webpack_require__(33131).findIndex);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 51146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $find = (__webpack_require__(33131).find);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 24222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $forEach = (__webpack_require__(33131).forEach);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 99260:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $includes = (__webpack_require__(16236).includes);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 77644:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $indexOf = (__webpack_require__(16236).indexOf);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 965:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var fails = __webpack_require__(90898);
var uncurryThis = __webpack_require__(93963);
var ArrayBufferViewCore = __webpack_require__(48745);
var ArrayIterators = __webpack_require__(84874);
var wellKnownSymbol = __webpack_require__(62745);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });


/***/ }),

/***/ 84946:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var uncurryThis = __webpack_require__(93963);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});


/***/ }),

/***/ 19381:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var apply = __webpack_require__(35680);
var $lastIndexOf = __webpack_require__(55088);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});


/***/ }),

/***/ 4768:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $map = (__webpack_require__(33131).map);
var typedArraySpeciesConstructor = __webpack_require__(72229);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});


/***/ }),

/***/ 95243:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $reduceRight = (__webpack_require__(89445).right);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 8425:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $reduce = (__webpack_require__(89445).left);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 9991:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),

/***/ 86590:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var call = __webpack_require__(27981);
var ArrayBufferViewCore = __webpack_require__(48745);
var lengthOfArrayLike = __webpack_require__(93506);
var toOffset = __webpack_require__(89670);
var toIndexedObject = __webpack_require__(5110);
var fails = __webpack_require__(90898);

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw new RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),

/***/ 8502:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var typedArraySpeciesConstructor = __webpack_require__(72229);
var fails = __webpack_require__(90898);
var arraySlice = __webpack_require__(37282);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),

/***/ 95611:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var $some = (__webpack_require__(33131).some);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 34640:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var uncurryThis = __webpack_require__(90893);
var fails = __webpack_require__(90898);
var aCallable = __webpack_require__(78465);
var internalSort = __webpack_require__(15871);
var ArrayBufferViewCore = __webpack_require__(48745);
var FF = __webpack_require__(64186);
var IE_OR_EDGE = __webpack_require__(19826);
var V8 = __webpack_require__(61544);
var WEBKIT = __webpack_require__(45761);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),

/***/ 60070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(48745);
var toLength = __webpack_require__(35385);
var toAbsoluteIndex = __webpack_require__(73504);
var typedArraySpeciesConstructor = __webpack_require__(72229);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),

/***/ 29829:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var apply = __webpack_require__(35680);
var ArrayBufferViewCore = __webpack_require__(48745);
var fails = __webpack_require__(90898);
var arraySlice = __webpack_require__(37282);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() !== new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);


/***/ }),

/***/ 86167:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var exportTypedArrayMethod = (__webpack_require__(48745).exportTypedArrayMethod);
var fails = __webpack_require__(90898);
var global = __webpack_require__(29327);
var uncurryThis = __webpack_require__(93963);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),

/***/ 66786:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(11966);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 25193:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(77768);
var collectionWeak = __webpack_require__(65002);

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);


/***/ }),

/***/ 15991:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(25193);


/***/ }),

/***/ 98484:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var DOMIterables = __webpack_require__(1465);
var DOMTokenListPrototype = __webpack_require__(93295);
var forEach = __webpack_require__(35526);
var createNonEnumerableProperty = __webpack_require__(9425);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 31415:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29327);
var DOMIterables = __webpack_require__(1465);
var DOMTokenListPrototype = __webpack_require__(93295);
var ArrayIteratorMethods = __webpack_require__(84874);
var createNonEnumerableProperty = __webpack_require__(9425);
var wellKnownSymbol = __webpack_require__(62745);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 93845:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(84874);
var $ = __webpack_require__(36924);
var global = __webpack_require__(29327);
var call = __webpack_require__(27981);
var uncurryThis = __webpack_require__(93963);
var DESCRIPTORS = __webpack_require__(37215);
var USE_NATIVE_URL = __webpack_require__(64546);
var defineBuiltIn = __webpack_require__(79494);
var defineBuiltInAccessor = __webpack_require__(97439);
var defineBuiltIns = __webpack_require__(71728);
var setToStringTag = __webpack_require__(69817);
var createIteratorConstructor = __webpack_require__(66137);
var InternalStateModule = __webpack_require__(54617);
var anInstance = __webpack_require__(37397);
var isCallable = __webpack_require__(44697);
var hasOwn = __webpack_require__(49803);
var bind = __webpack_require__(61643);
var classof = __webpack_require__(30105);
var anObject = __webpack_require__(2726);
var isObject = __webpack_require__(87255);
var $toString = __webpack_require__(44514);
var create = __webpack_require__(66990);
var createPropertyDescriptor = __webpack_require__(30603);
var getIterator = __webpack_require__(24075);
var getIteratorMethod = __webpack_require__(94746);
var createIterResultObject = __webpack_require__(70980);
var validateArgumentsLength = __webpack_require__(71373);
var wellKnownSymbol = __webpack_require__(62745);
var arraySort = __webpack_require__(15871);

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw new TypeError('Expected sequence with length 2');
        push(entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ 95535:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(93845);


/***/ }),

/***/ 97471:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(71227);
var $ = __webpack_require__(36924);
var DESCRIPTORS = __webpack_require__(37215);
var USE_NATIVE_URL = __webpack_require__(64546);
var global = __webpack_require__(29327);
var bind = __webpack_require__(61643);
var uncurryThis = __webpack_require__(93963);
var defineBuiltIn = __webpack_require__(79494);
var defineBuiltInAccessor = __webpack_require__(97439);
var anInstance = __webpack_require__(37397);
var hasOwn = __webpack_require__(49803);
var assign = __webpack_require__(95902);
var arrayFrom = __webpack_require__(6480);
var arraySlice = __webpack_require__(90202);
var codeAt = (__webpack_require__(45415).codeAt);
var toASCII = __webpack_require__(88915);
var $toString = __webpack_require__(44514);
var setToStringTag = __webpack_require__(69817);
var validateArgumentsLength = __webpack_require__(71373);
var URLSearchParamsModule = __webpack_require__(93845);
var InternalStateModule = __webpack_require__(54617);

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) === '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() === ':') {
    if (charAt(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) === '[') {
      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt(search, 0) === '?') search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ 14306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(97471);


/***/ }),

/***/ 73607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(13158);


/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.

var isArguments = __webpack_require__(14043);
var getStopIterationIterator = __webpack_require__(52719);

if (__webpack_require__(10465)() || __webpack_require__(16073)()) {
	var $iterator = Symbol.iterator;
	// Symbol is available natively or shammed
	// natively:
	//  - Chrome >= 38
	//  - Edge 12-14?, Edge >= 15 for sure
	//  - FF >= 36
	//  - Safari >= 9
	//  - node >= 0.12
	module.exports = function getIterator(iterable) {
		// alternatively, `iterable[$iterator]?.()`
		if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
			return iterable[$iterator]();
		}
		if (isArguments(iterable)) {
			// arguments objects lack Symbol.iterator
			// - node 0.12
			return Array.prototype[$iterator].call(iterable);
		}
	};
} else {
	// Symbol is not available, native or shammed
	var isArray = __webpack_require__(31861);
	var isString = __webpack_require__(91770);
	var GetIntrinsic = __webpack_require__(91528);
	var $Map = GetIntrinsic('%Map%', true);
	var $Set = GetIntrinsic('%Set%', true);
	var callBound = __webpack_require__(47737);
	var $arrayPush = callBound('Array.prototype.push');
	var $charCodeAt = callBound('String.prototype.charCodeAt');
	var $stringSlice = callBound('String.prototype.slice');

	var advanceStringIndex = function advanceStringIndex(S, index) {
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	};

	var getArrayIterator = function getArrayIterator(arraylike) {
		var i = 0;
		return {
			next: function next() {
				var done = i >= arraylike.length;
				var value;
				if (!done) {
					value = arraylike[i];
					i += 1;
				}
				return {
					done: done,
					value: value
				};
			}
		};
	};

	var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
		if (isArray(iterable) || isArguments(iterable)) {
			return getArrayIterator(iterable);
		}
		if (isString(iterable)) {
			var i = 0;
			return {
				next: function next() {
					var nextIndex = advanceStringIndex(iterable, i);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		}

		// es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
		if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
			return iterable['_es6-shim iterator_']();
		}
	};

	if (!$Map && !$Set) {
		// the only language iterables are Array, String, arguments
		// - Safari <= 6.0
		// - Chrome < 38
		// - node < 0.12
		// - FF < 13
		// - IE < 11
		// - Edge < 11

		module.exports = function getIterator(iterable) {
			if (iterable != null) {
				return getNonCollectionIterator(iterable, true);
			}
		};
	} else {
		// either Map or Set are available, but Symbol is not
		// - es6-shim on an ES5 browser
		// - Safari 6.2 (maybe 6.1?)
		// - FF v[13, 36)
		// - IE 11
		// - Edge 11
		// - Safari v[6, 9)

		var isMap = __webpack_require__(81859);
		var isSet = __webpack_require__(96109);

		// Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
		var $mapForEach = callBound('Map.prototype.forEach', true);
		var $setForEach = callBound('Set.prototype.forEach', true);
		if (typeof process === 'undefined' || !process.versions || !process.versions.node) { // "if is not node"

			// Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
			// returns a value, or throws a StopIteration object. These browsers
			// do not have any other mechanism for iteration.
			var $mapIterator = callBound('Map.prototype.iterator', true);
			var $setIterator = callBound('Set.prototype.iterator', true);
		}
		// Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
		// this returns a proper iterator object, so we should use it instead of forEach.
		// newer es6-shim versions use a string "_es6-shim iterator_" property.
		var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
		var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);

		var getCollectionIterator = function getCollectionIterator(iterable) {
			if (isMap(iterable)) {
				if ($mapIterator) {
					return getStopIterationIterator($mapIterator(iterable));
				}
				if ($mapAtAtIterator) {
					return $mapAtAtIterator(iterable);
				}
				if ($mapForEach) {
					var entries = [];
					$mapForEach(iterable, function (v, k) {
						$arrayPush(entries, [k, v]);
					});
					return getArrayIterator(entries);
				}
			}
			if (isSet(iterable)) {
				if ($setIterator) {
					return getStopIterationIterator($setIterator(iterable));
				}
				if ($setAtAtIterator) {
					return $setAtAtIterator(iterable);
				}
				if ($setForEach) {
					var values = [];
					$setForEach(iterable, function (v) {
						$arrayPush(values, v);
					});
					return getArrayIterator(values);
				}
			}
		};

		module.exports = function getIterator(iterable) {
			return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
		};
	}
}


/***/ }),

/***/ 8121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isMap = __webpack_require__(81859);
var isSet = __webpack_require__(96109);
var isWeakMap = __webpack_require__(36959);
var isWeakSet = __webpack_require__(92683);

module.exports = function whichCollection(value) {
	if (value && typeof value === 'object') {
		if (isMap(value)) {
			return 'Map';
		}
		if (isSet(value)) {
			return 'Set';
		}
		if (isWeakMap(value)) {
			return 'WeakMap';
		}
		if (isWeakSet(value)) {
			return 'WeakSet';
		}
	}
	return false;
};


/***/ }),

/***/ 20011:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 66017:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 36655:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/***/ }),

/***/ 78645:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);